import * as i0 from '@angular/core';
import { Directive, Injectable, Component, Input, ViewChild, EventEmitter, Output, ViewEncapsulation, Pipe, ElementRef, forwardRef, HostBinding, Inject, HostListener, CUSTOM_ELEMENTS_SCHEMA, ViewContainerRef, NgModule } from '@angular/core';
import * as i5 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, FormGroup, NG_VALUE_ACCESSOR, FormControl, FormArray } from '@angular/forms';
import * as i1 from '@un-fao/lightforms-lib/lightforms-services';
import { DynamicFormObject, StandardSearchParameter, DynamicFormControlService, SimpleSearchParameter, DynamicForm, GeneralSearchParameter, ViewTypeEnum, SearchRequest, ConfigurationService, LightformsServicesModule } from '@un-fao/lightforms-lib/lightforms-services';
import * as i3 from '@angular/common';
import { CommonModule, NgIf, NgFor, NgClass, DatePipe, DOCUMENT, DecimalPipe } from '@angular/common';
import * as i2 from '@angular/router';
import { RouterLink, RouterModule } from '@angular/router';
import * as i1$1 from 'primeng/dynamicdialog';
import { DynamicDialogComponent as DynamicDialogComponent$1, DynamicDialogModule, DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import * as i1$3 from '@angular/common/http';
import * as i4$3 from 'ngx-markdown';
import { MarkdownModule } from 'ngx-markdown';
import * as jsonPath from 'jsonpath/jsonpath';
import jsonPath__default from 'jsonpath/jsonpath';
import * as i3$2 from 'primeng/api';
import { ConfirmationService, MessageService } from 'primeng/api';
import { startWith, pairwise, forkJoin } from 'rxjs';
import { register } from 'swiper/element/bundle';
import * as i5$1 from 'primeng/confirmdialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import * as i8 from 'primeng/table';
import { TableModule } from 'primeng/table';
import * as i7 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i7$1 from 'primeng/toast';
import { ToastModule } from 'primeng/toast';
import * as i11 from 'primeng/tag';
import { TagModule } from 'primeng/tag';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import HC_nodata from 'highcharts/modules/no-data-to-display';
import { forkJoin as forkJoin$1 } from 'rxjs/internal/observable/forkJoin';
import * as i4 from 'ngx-json-viewer';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import * as i3$1 from 'ngx-clipboard';
import { ClipboardModule } from 'ngx-clipboard';
import moment from 'moment';
import * as i3$3 from 'primeng/textarea';
import { TextareaModule } from 'primeng/textarea';
import * as i4$2 from 'primeng/tooltip';
import { TooltipModule } from 'primeng/tooltip';
import * as i6 from 'primeng/select';
import { SelectModule } from 'primeng/select';
import * as i7$3 from 'primeng/multiselect';
import { MultiSelectModule } from 'primeng/multiselect';
import * as i8$1 from 'primeng/autocomplete';
import { AutoCompleteModule } from 'primeng/autocomplete';
import * as i13 from 'primeng/panel';
import { PanelModule } from 'primeng/panel';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Map from 'ol/Map';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import View from 'ol/View';
import { defaults, ScaleLine, Control } from 'ol/control';
import FullScreen from 'ol/control/FullScreen';
import { register as register$1 } from 'ol/proj/proj4';
import proj4 from 'proj4';
import { get, getTransform } from 'ol/proj';
import { applyTransform } from 'ol/extent';
import * as $ from 'jquery';
import * as i4$1 from 'primeng/checkbox';
import { CheckboxModule } from 'primeng/checkbox';
import * as i5$2 from 'primeng/slider';
import { SliderModule } from 'primeng/slider';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Draw, { createBox } from 'ol/interaction/Draw.js';
import GeoJSON from 'ol/format/GeoJSON';
import { TileArcGISRest } from 'ol/source.js';
import Circle from 'ol/style/Circle';
import * as i6$1 from 'primeng/inputtext';
import { InputTextModule } from 'primeng/inputtext';
import * as i7$2 from 'primeng/inputgroup';
import { InputGroupModule } from 'primeng/inputgroup';
import * as i3$4 from 'ngx-monaco-editor-v2';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import * as i1$2 from '@angular/platform-browser';
import * as i1$4 from '@angular/youtube-player';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { AccordionModule } from 'primeng/accordion';
import { TimelineModule } from 'primeng/timeline';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { ListboxModule } from 'primeng/listbox';
import * as i14 from 'primeng/tabs';
import { TabsModule } from 'primeng/tabs';
import * as i12 from 'primeng/fieldset';
import { FieldsetModule } from 'primeng/fieldset';
import { TreeModule } from 'primeng/tree';
import { ChipModule } from 'primeng/chip';
import * as i16 from 'primeng/togglebutton';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { BadgeModule } from 'primeng/badge';
import { SidebarModule } from 'primeng/sidebar';
import * as i10 from 'primeng/divider';
import { DividerModule } from 'primeng/divider';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';

class DynamicHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    static { this.ɵfac = function DynamicHostDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicHostDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: DynamicHostDirective, selectors: [["", "dynamicHost", ""]], standalone: false }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicHostDirective, [{
        type: Directive,
        args: [{
                selector: '[dynamicHost]',
                standalone: false
            }]
    }], () => [{ type: i0.ViewContainerRef }], null); })();

class ModulesService {
    constructor(configService) {
        this.configService = configService;
        this.components = {
            "anchor": AnchorComponent,
            "bibliography": BibliographyComponent,
            "banana-button": ButtonComponent,
            "calendar": CalendarComponent,
            "fi-doc": DocComponent,
            "fi-card": CardComponent,
            "fi-cards": CardsComponent,
            "app-cart": CartComponent,
            "cart-handler": CartHandlerComponent,
            "cart-buttons": CartButtonsComponent,
            "chart": ChartComponent,
            "citation": CitationComponent,
            "collection-item": CollectionItemComponent,
            "collection-list": CollectionListComponent,
            "collection-navigator": CollectionNavigatorComponent,
            "data-list": DataListComponent,
            "search": DatatypeSearchComponent,
            "debug-info": DebugInfoComponent,
            "documents": DocumentsComponent,
            "documents-list": DocumentsListComponent,
            "dynamic-dialog": DynamicDialogComponent$1,
            "lightforms-error-log": ErrorLogComponent,
            "error-log-icon": ErrorLogIconComponent,
            "app-factsheet-intro": FactsheetIntroComponent,
            "fi-filter": FiFilterComponent,
            "fi-filter-terms": FiFilterTermsComponent,
            "fi-list": FiListComponent,
            "fi-search-pills": FiSearchPillsComponent,
            "flag": FlagComponent,
            "form-errors-manager": FormErrorsManagerComponent,
            "formula-editor": FormulaEditorComponent,
            "global-parameters": GlobalParametersComponent,
            "geometry-editor": GeometryEditorComponent,
            "geosearch": GeosearchComponent,
            "grouped-result": GroupedResultComponent,
            "hierarchy": HierarchyComponent,
            "level": LevelComponent,
            "html-editor": HtmlEditorComponent,
            "html-renderer": HtmlRendererComponent,
            "fi-image-modal": ImageModalComponent,
            "fi-image": ImageComponent,
            "fi-image-button": ImageButtonComponent,
            "image-gallery-modal": ImageGalleryModalComponent,
            "image-gallery": ImageGalleryComponent,
            "image-viewer-modal": ImageViewerModalComponent,
            "image-viewer": ImageViewerComponent,
            "json-viewer": JsonViewerComponent,
            "loading": LoadingComponent,
            "fi-login-button": LoginButtonComponent,
            "fi-logout-button": LogoutButtonComponent,
            "layers-list": LayersListComponent,
            "legends-list": LegendsListComponent,
            "fi-map": MapComponent,
            "map-tips": MapTipsComponent,
            "projections-list": ProjectionsListComponent,
            "modal-popup": ModalComponent,
            "app-not-found": NotFoundComponent,
            "object-list": ObjectListComponent,
            "pagination": PaginationComponent,
            "fi-qrcode": QrcodeComponent,
            "ref": ReferenceComponent,
            "fi-register-button": RegisterButtonComponent,
            "app-related-links": RelatedLinksComponent,
            "standard-result": StandardResultComponent,
            "search-list": SearchListComponent,
            "fi-share-modal": ShareModalComponent,
            "slider": SliderComponent,
            "sources": SourcesComponent,
            "app-status-note": StatusNoteComponent,
            "app-table": TableComponent,
            "tabs": TabsComponent,
            "fi-template-renderer": TemplateRendererComponent,
            "toc": TocComponent,
            "app-user-register": UserRegisterComponent,
            "youtube-video-player": VideoPlayerComponent
        };
        this.parsers = [];
        this.selectors = ["fi-doc", "space-manager-button", "space-selector", "anchor", "bibliography", "calendar", "fi-cards", "fi-card", "fi-cart", "cart-handler", "cart-buttons", "chart", "citation", "collection-item",
            "collection-list", "collection-navigator", "data-list", "search", "debug-info", "documents", "documents-list", "dynamic-dialog", "fi-error-log", "fi-error-log-icon",
            "fi-factsheet-intro", "fi-filter", "fi-filter-terms", "fi-list", "fi-search-pills", "flag", "fi-formula-editor", "fi-geometry-editor", "fi-geosearch", "fi-grouped-result",
            "hierarchy", "level", "html-editor", "html-renderer", "fi-image", "fi-image-modal", "fi-image-button", "image-gallery", "image-viewer", "image-viewer-modal", "json-viewer", "loading",
            "fi-login-button", "fi-logout-button", "layers-list", "legends-list", "fi-map", "map-tips", "projections-list", "modal-popup", "app-not-found", "object-list", "pagination", "fi-qrcode", "ref",
            "fi-register-button", "app-related-links", "fi-standard-result", "search-list", "fi-share-modal", "slider", "sources", "app-status-note", "app-table", "tabs", "template", "toc", "app-user-register",
            "youtube-video-player"];
    }
    getDynamicModules() {
        if (this.dynamicModules) {
            return this.dynamicModules;
        }
        this.dynamicModules = [
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            LightformsComponentsModule,
            NgIf,
            NgFor,
            NgClass,
            RouterLink
        ];
        if (this.configService.env.modules) {
            for (let i = 0; i < this.configService.env.modules.length; i++) {
                this.dynamicModules.push(this.configService.env.modules[i]);
            }
        }
        return this.dynamicModules;
    }
    getDynamicModulesComponents() {
        let components = {};
        for (let i = 0; i < this.configService.env.modules.length; i++) {
            if (this.configService.env.modules[i].components) {
                for (let key in this.configService.env.modules[i].components) {
                    components[key] = this.configService.env.modules[i].components[key];
                }
            }
        }
        return components;
    }
    getAngularRegex() {
        if (this.angularSearchExpression > "") {
            return new RegExp(this.angularSearchExpression);
        }
        let selectors = this.selectors;
        if (this.configService.env.space) {
            selectors = selectors.concat([this.configService.env.space + "-[\\w-]+"]);
        }
        this.angularSearchExpression = '<(' + selectors.join("|") + ')(\\s[^>]*)?>';
        return new RegExp(this.angularSearchExpression);
    }
    getAngularDirectivesRegexp() {
        let angularSearchExpression = '(\\*[a-zA-Z0-9\\-]+\\s*=\\s*".*?")|(\\[.*?\\]=|\\(.*?\\)=)|(\\{\\{(.*?)\\}\\})';
        return new RegExp(angularSearchExpression);
    }
    getTemplateId(space, collection, template, alias) {
        if (space) {
            if (alias) {
                return space + "_" + collection + "_" + alias.replaceAll("/", "_");
            }
            else {
                if (template.startsWith("<!--" + space)) {
                    return template.substring(4, template.indexOf("-->")).trim();
                }
                else {
                    return null;
                }
            }
        }
        else {
            return null;
        }
    }
    static { this.ɵfac = function ModulesService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ModulesService)(i0.ɵɵinject(i1.ConfigurationService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ModulesService, factory: ModulesService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModulesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.ConfigurationService }], null); })();

function HtmlRendererComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.template, i0.ɵɵsanitizeHtml);
} }
class HtmlRendererComponent {
    constructor(configService, cacheService, utilsService, modulesService, cdr) {
        this.configService = configService;
        this.cacheService = cacheService;
        this.utilsService = utilsService;
        this.modulesService = modulesService;
        this.cdr = cdr;
        this.data = {};
        this.template = '';
        this.styles = '';
        this.dynamic = false;
    }
    async ngAfterViewInit() {
        //console.log("------HTML RENDERER------");
        if (this.template > "") {
            this.template = this.template.replaceAll("@", "&#64;");
        }
        else {
            return;
        }
        //console.log(this.template);
        try {
            if (this.modulesService.getAngularRegex().test(this.template)) {
                this.dynamic = true;
                this.renderDynamicHtml(this.template, this.dynamicHost.viewContainerRef);
            }
            else {
                this.dynamic = false;
            }
            this.cdr.detectChanges();
        }
        catch (error) {
            console.log("-----ERROR-----");
            console.log(error);
            console.log(this.template);
        }
    }
    renderDynamicHtml(html, container) {
        if (!container)
            return;
        container.clear(); // Clear previous content
        // Parse the HTML into a DOM structure
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html.trim();
        this.recursivelyRender(tempDiv, container);
    }
    recursivelyRender(element, container) {
        if (element.childNodes.length > 0) {
            Array.from(element.childNodes).forEach((node) => {
                const el = node;
                if (node.nodeType === Node.ELEMENT_NODE) {
                    let componentRef;
                    if (this.modulesService.components[el.tagName.toLowerCase()]) {
                        componentRef = container.createComponent(this.modulesService.components[el.tagName.toLowerCase()]);
                    }
                    else if (this.modulesService.getDynamicModulesComponents()[el.tagName.toLowerCase()]) {
                        componentRef = container.createComponent(this.modulesService.getDynamicModulesComponents()[el.tagName.toLowerCase()]);
                    }
                    if (componentRef) {
                        const attributes = el.getAttributeNames();
                        attributes.forEach((attr) => {
                            const inputValue = el.getAttribute(attr);
                            if (inputValue) {
                                componentRef.instance[attr] = isNaN(+inputValue) ? inputValue : +inputValue;
                            }
                        });
                        this.recursivelyRender(el, componentRef.instance['viewContainerRef']);
                    }
                    else if (el.childNodes.length > 0) {
                        this.recursivelyRender(el, container);
                    }
                    else {
                        // Append plain HTML elements inside container
                        if (container) {
                            container.element.nativeElement.appendChild(el.cloneNode(true));
                        }
                    }
                }
                else {
                    if (container) {
                        container.element.nativeElement.appendChild(el.cloneNode(true));
                    }
                }
            });
        }
        else {
            if (container) {
                container.element.nativeElement.appendChild(element.cloneNode(true));
            }
        }
    }
    static { this.ɵfac = function HtmlRendererComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HtmlRendererComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.CacheService), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(ModulesService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HtmlRendererComponent, selectors: [["html-renderer"]], viewQuery: function HtmlRendererComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(DynamicHostDirective, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dynamicHost = _t.first);
        } }, inputs: { space: "space", collection: "collection", collectionForm: "collectionForm", data: "data", template: "template", styles: "styles" }, standalone: false, decls: 2, vars: 1, consts: [["dynamicHost", "", 1, "html-renderer"], ["class", "html-renderer", 3, "innerHTML", 4, "ngIf"], [1, "html-renderer", 3, "innerHTML"]], template: function HtmlRendererComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
            i0.ɵɵtemplate(1, HtmlRendererComponent_span_1_Template, 1, 1, "span", 1);
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.dynamic);
        } }, dependencies: [i3.NgIf, DynamicHostDirective], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HtmlRendererComponent, [{
        type: Component,
        args: [{ selector: 'html-renderer', template: `
    <div class="html-renderer" dynamicHost></div>
    <span *ngIf="!dynamic" class="html-renderer" [innerHTML]="template"></span>
  `, standalone: false }]
    }], () => [{ type: i1.ConfigurationService }, { type: i1.CacheService }, { type: i1.UtilsService }, { type: ModulesService }, { type: i0.ChangeDetectorRef }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], collectionForm: [{
            type: Input
        }], data: [{
            type: Input
        }], template: [{
            type: Input
        }], styles: [{
            type: Input
        }], dynamicHost: [{
            type: ViewChild,
            args: [DynamicHostDirective, { static: true }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(HtmlRendererComponent, { className: "HtmlRendererComponent", filePath: "src/components/html-renderer/html-renderer.component.ts", lineNumber: 16 }); })();

function ObjectListComponent_ng_container_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.out);
} }
function ObjectListComponent_ng_container_0_h6_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.out);
} }
function ObjectListComponent_ng_container_0_ul_3_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "i", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", value_r2, " ");
} }
function ObjectListComponent_ng_container_0_ul_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, ObjectListComponent_ng_container_0_ul_3_li_1_Template, 3, 1, "li", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.values);
} }
function ObjectListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ObjectListComponent_ng_container_0_span_1_Template, 2, 1, "span", 0)(2, ObjectListComponent_ng_container_0_h6_2_Template, 2, 1, "h6", 1)(3, ObjectListComponent_ng_container_0_ul_3_Template, 2, 1, "ul", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type === "flat");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type === "highlight");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type === "list");
} }
function ObjectListComponent_ng_container_1_ul_1_li_1_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("href", value_r3.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(value_r3.value);
} }
function ObjectListComponent_ng_container_1_ul_1_li_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 11);
} if (rf & 2) {
    const value_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("innerHTML", value_r3, i0.ɵɵsanitizeHtml);
} }
function ObjectListComponent_ng_container_1_ul_1_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "div", 8);
    i0.ɵɵelement(2, "i", 4);
    i0.ɵɵtemplate(3, ObjectListComponent_ng_container_1_ul_1_li_1_a_3_Template, 2, 2, "a", 9)(4, ObjectListComponent_ng_container_1_ul_1_li_1_span_4_Template, 1, 1, "span", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.linkproperty);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.linkproperty);
} }
function ObjectListComponent_ng_container_1_ul_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 7);
    i0.ɵɵtemplate(1, ObjectListComponent_ng_container_1_ul_1_li_1_Template, 5, 2, "li", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.values);
} }
function ObjectListComponent_ng_container_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 11);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r0.out, i0.ɵɵsanitizeHtml);
} }
function ObjectListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ObjectListComponent_ng_container_1_ul_1_Template, 2, 1, "ul", 5)(2, ObjectListComponent_ng_container_1_span_2_Template, 1, 1, "span", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type === "list");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type !== "list");
} }
class ObjectListComponent {
    constructor(utilsService, configService) {
        this.utilsService = utilsService;
        this.configService = configService;
        this.items = [];
        this.languages = false;
        this.dynamic = false;
        this.type = 'flat';
    }
    ngOnInit() {
        if (!(typeof (this.items) === 'object')) {
            this.items = [];
        }
        if (this.items) {
            if (!this.items.length) {
                this.elements = [this.items];
            }
            else {
                this.elements = this.items;
            }
        }
        if (!this.elements) {
            this.elements = [];
        }
        if (this.property) {
            if (this.property.includes('%lang%')) {
                this.currentLangProperty = this.property.replace('%lang%', this.configService.env.currentLang);
                this.defaultLangProperty = this.property.replace('%lang%', this.configService.env.defaultLang);
            }
            else {
                this.currentLangProperty = this.property;
                this.defaultLangProperty = this.property;
            }
        }
        this.extractValues();
        if (this.type !== 'list') {
            this.stringify();
        }
    }
    stringify() {
        this.out = '';
        for (let i = 0; i < this.values.length; i++) {
            if (i == 0) {
                this.out = this.values[i];
            }
            else {
                if (this.separator === 'none') {
                    this.out = this.out.concat(this.values[i]);
                }
                else {
                    this.out = this.out.concat((this.separator + ' ' || ', ') + this.values[i]);
                }
            }
        }
    }
    extractValues() {
        this.values = [];
        for (let i = 0; i < this.elements.length; i++) {
            if (typeof (this.elements[i]) === 'object') {
                let value = this.languages ? this.configService.getLanguageByCode(this.elements[i][this.currentLangProperty]) : this.elements[i][this.currentLangProperty];
                if (value) {
                    if (this.elements[i][this.currentLangProperty]) {
                        if (this.linkproperty) {
                            this.values.push({
                                value: value,
                                link: this.elements[i][this.linkproperty]
                            });
                        }
                        else {
                            this.values.push(value);
                        }
                    }
                }
                else {
                    value = this.languages ? this.configService.getLanguageByCode(this.elements[i][this.defaultLangProperty]) : this.elements[i][this.defaultLangProperty];
                    if (value) {
                        if (this.elements[i][this.defaultLangProperty]) {
                            if (this.linkproperty) {
                                this.values.push({
                                    value: value,
                                    link: this.elements[i][this.linkproperty]
                                });
                            }
                            else {
                                this.values.push(value);
                            }
                        }
                    }
                }
            }
            else {
                let value = this.elements[i];
                this.values.push(value);
            }
        }
    }
    static { this.ɵfac = function ObjectListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ObjectListComponent)(i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ObjectListComponent, selectors: [["object-list"]], inputs: { items: "items", languages: "languages", property: "property", linkproperty: "linkproperty", separator: "separator", dynamic: "dynamic", type: "type" }, standalone: false, decls: 2, vars: 2, consts: [[4, "ngIf"], ["class", "title-category", 4, "ngIf"], [1, "title-category"], [4, "ngFor", "ngForOf"], [1, "bi", "bi-chevron-right"], ["class", "object-list", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [1, "object-list"], [1, "li-item"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"], [3, "innerHTML"]], template: function ObjectListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ObjectListComponent_ng_container_0_Template, 4, 3, "ng-container", 0)(1, ObjectListComponent_ng_container_1_Template, 3, 2, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.dynamic);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamic);
        } }, dependencies: [i3.NgForOf, i3.NgIf], styles: [".object-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{line-height:2rem;list-style-type:none}.object-list[_ngcontent-%COMP%]   .li-item[_ngcontent-%COMP%]{display:flex}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ObjectListComponent, [{
        type: Component,
        args: [{ selector: 'object-list', standalone: false, template: "<ng-container *ngIf=\"!dynamic\">    \r\n    <span *ngIf=\"type === 'flat'\">{{ out }}</span>\r\n    <h6 class=\"title-category\" *ngIf=\"type === 'highlight'\">{{ out }}</h6>\r\n    <ul *ngIf=\"type === 'list'\">\r\n        <li *ngFor=\"let value of values\">\r\n            <i class=\"bi bi-chevron-right\"></i>\r\n            {{ value }}\r\n        </li>\r\n    </ul>\r\n</ng-container>\r\n<ng-container *ngIf=\"dynamic\">\r\n    <ul class=\"object-list\" *ngIf=\"type === 'list'\">\r\n        <li *ngFor=\"let value of values\">\r\n            <div class=\"li-item\">\r\n                <i class=\"bi bi-chevron-right\"></i>\r\n                <a *ngIf=\"linkproperty\" href=\"{{value.link}}\" target=\"_blank\">{{value.value}}</a>\r\n                <span *ngIf=\"!linkproperty\" innerHTML=\"{{ value }}\"></span>\r\n            </div>\r\n        </li>\r\n    </ul>\r\n    <span *ngIf=\"type !== 'list'\" innerHTML=\"{{ out }}\"></span>\r\n</ng-container>", styles: [".object-list li{line-height:2rem;list-style-type:none}.object-list .li-item{display:flex}\n"] }]
    }], () => [{ type: i1.UtilsService }, { type: i1.ConfigurationService }], { items: [{
            type: Input
        }], languages: [{
            type: Input
        }], property: [{
            type: Input
        }], linkproperty: [{
            type: Input
        }], separator: [{
            type: Input
        }], dynamic: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ObjectListComponent, { className: "ObjectListComponent", filePath: "src/components/object-list/object-list.component.ts", lineNumber: 10 }); })();

function DynamicFormSwitcherView_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "dynamic-form-control-view", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r0.group)("id", ctx_r0.dynamicFormObject.code)("dynamicForm", ctx_r0.dynamicForm)("parentDynamicForm", ctx_r0.parentDynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("parentDynamicFormObject", ctx_r0.parentDynamicFormObject)("form", ctx_r0.form)("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("readonly", ctx_r0.readonly)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("hideLabel", ctx_r0.hideLabel)("statuses", ctx_r0.statuses);
} }
function DynamicFormSwitcherView_ng_container_1_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "dynamic-form-checkboxlist-view", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r0.group)("id", ctx_r0.dynamicFormObject.code)("dynamicForm", ctx_r0.dynamicForm)("parentDynamicForm", ctx_r0.parentDynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("parentDynamicFormObject", ctx_r0.parentDynamicFormObject)("form", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code])("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("readonly", ctx_r0.readonly)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("hideLabel", ctx_r0.hideLabel);
} }
function DynamicFormSwitcherView_ng_container_1_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "dynamic-form-control-view", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r0.group)("id", ctx_r0.dynamicFormObject.code)("dynamicForm", ctx_r0.dynamicForm)("parentDynamicForm", ctx_r0.parentDynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("parentDynamicFormObject", ctx_r0.parentDynamicFormObject)("form", ctx_r0.form)("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("readonly", ctx_r0.readonly)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("hideLabel", ctx_r0.hideLabel)("statuses", ctx_r0.statuses);
} }
function DynamicFormSwitcherView_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormSwitcherView_ng_container_1_ng_container_2_ng_container_1_Template, 2, 13, "ng-container", 1)(2, DynamicFormSwitcherView_ng_container_1_ng_container_2_ng_container_2_Template, 2, 14, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "checkbox");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type !== "checkbox");
} }
function DynamicFormSwitcherView_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormSwitcherView_ng_container_1_ng_container_1_Template, 2, 14, "ng-container", 1)(2, DynamicFormSwitcherView_ng_container_1_ng_container_2_Template, 3, 2, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.dynamicFormObject.multipleValues);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.multipleValues);
} }
function DynamicFormSwitcherView_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "dynamic-form-geometry-view", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r0.group)("id", ctx_r0.dynamicFormObject.code)("dynamicForm", ctx_r0.dynamicForm)("parentDynamicForm", ctx_r0.parentDynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("parentDynamicFormObject", ctx_r0.parentDynamicFormObject)("form", ctx_r0.form)("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("readonly", ctx_r0.readonly)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("hideLabel", ctx_r0.hideLabel);
} }
function DynamicFormSwitcherView_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dynamic-form-group-view", 4);
    i0.ɵɵlistener("nextForm", function DynamicFormSwitcherView_ng_container_3_Template_dynamic_form_group_view_nextForm_1_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onNextForm($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r0.group)("id", ctx_r0.dynamicFormObject.code)("dynamicForm", ctx_r0.dynamicForm)("parentDynamicForm", ctx_r0.parentDynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("parentDynamicFormObject", ctx_r0.parentDynamicFormObject)("form", ctx_r0.form)("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("readonly", ctx_r0.readonly)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("hideLabel", ctx_r0.hideLabel)("statuses", ctx_r0.statuses)("status", ctx_r0.status);
} }
function DynamicFormSwitcherView_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dynamic-form-keyselect-view", 4);
    i0.ɵɵlistener("nextForm", function DynamicFormSwitcherView_ng_container_4_Template_dynamic_form_keyselect_view_nextForm_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onNextForm($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r0.group)("id", ctx_r0.dynamicFormObject.code)("dynamicForm", ctx_r0.dynamicForm)("parentDynamicForm", ctx_r0.parentDynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("parentDynamicFormObject", ctx_r0.parentDynamicFormObject)("form", ctx_r0.form)("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("readonly", ctx_r0.readonly)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("hideLabel", ctx_r0.hideLabel)("statuses", ctx_r0.statuses)("status", ctx_r0.status);
} }
function DynamicFormSwitcherView_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "dynamic-form-groupselect-view", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.dynamicFormObject.code)("dynamicForm", ctx_r0.dynamicForm)("parentDynamicForm", ctx_r0.parentDynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("parentDynamicFormObject", ctx_r0.parentDynamicFormObject)("form", ctx_r0.form)("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("readonly", ctx_r0.readonly)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("hideLabel", ctx_r0.hideLabel)("statuses", ctx_r0.statuses)("status", ctx_r0.status);
} }
function DynamicFormSwitcherView_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "dynamic-form-checkboxlist-view", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r0.group)("id", ctx_r0.dynamicFormObject.code)("dynamicForm", ctx_r0.dynamicForm)("parentDynamicForm", ctx_r0.parentDynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("parentDynamicFormObject", ctx_r0.parentDynamicFormObject)("form", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code])("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("readonly", ctx_r0.readonly)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("hideLabel", ctx_r0.hideLabel);
} }
function DynamicFormSwitcherView_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "dynamic-form-group-lat-long-view", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r0.group)("id", ctx_r0.dynamicFormObject.code)("dynamicForm", ctx_r0.dynamicForm)("parentDynamicForm", ctx_r0.parentDynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("parentDynamicFormObject", ctx_r0.parentDynamicFormObject)("form", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code])("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("readonly", ctx_r0.readonly)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("hideLabel", ctx_r0.hideLabel);
} }
function DynamicFormSwitcherView_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dynamic-form-array-view", 4);
    i0.ɵɵlistener("nextForm", function DynamicFormSwitcherView_ng_container_8_Template_dynamic_form_array_view_nextForm_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onNextForm($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r0.group)("id", ctx_r0.dynamicFormObject.code)("dynamicForm", ctx_r0.dynamicForm)("parentDynamicForm", ctx_r0.parentDynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("parentDynamicFormObject", ctx_r0.parentDynamicFormObject)("form", ctx_r0.form)("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("readonly", ctx_r0.readonly)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("hideLabel", ctx_r0.hideLabel)("statuses", ctx_r0.statuses)("status", ctx_r0.status);
} }
function DynamicFormSwitcherView_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dynamic-form-nested-form-view", 6);
    i0.ɵɵlistener("nextForm", function DynamicFormSwitcherView_ng_container_9_Template_dynamic_form_nested_form_view_nextForm_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onNextForm($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.dynamicFormObject.code)("dynamicForm", ctx_r0.dynamicForm)("parentDynamicForm", ctx_r0.parentDynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("parentDynamicFormObject", ctx_r0.parentDynamicFormObject)("form", ctx_r0.form)("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("readonly", ctx_r0.readonly)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("hideLabel", ctx_r0.hideLabel)("statuses", ctx_r0.statuses)("status", ctx_r0.status);
} }
class DynamicFormSwitcherView {
    constructor(dynamicFormService, dynamicFormControlService) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.debug = false;
        this.readonly = false;
        this.nextForm = new EventEmitter();
    }
    ngOnInit() { }
    isReadonly() {
        let readonly = false;
        if (this.dynamicFormObject.editableIf > '') {
            try {
                let value = this.dynamicFormControlService.executeFormula(this.dynamicFormObject.editableIf, this.form.getRawValue(), this.dynamicForm.acceptedParams, this.dynamicForm.params, this.xpath);
                readonly = !value;
            }
            catch (error) {
                console.log(error.code + ' - ' + error.message);
                readonly = true;
            }
        }
        else {
            readonly = false;
        }
        if (this.readonly === undefined) {
            return readonly;
        }
        else {
            if (this.readonly || readonly) {
                return true;
            }
            else {
                return false;
            }
        }
    }
    getClass() {
        return (this.hideLabel === false ? "mb-2 " : "") + "form-component " + (this.dynamicFormObject.containerCssClass || "");
    }
    isVisible(dfo) {
        if (!dfo.visible || dfo.visible === true) {
            return true;
        }
        else {
            return false;
        }
    }
    onNextForm(event) {
        this.nextForm.emit(event);
    }
    static { this.ɵfac = function DynamicFormSwitcherView_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormSwitcherView)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormSwitcherView, selectors: [["dynamic-form-switcher-view"]], inputs: { group: "group", statuses: "statuses", status: "status", dynamicForm: "dynamicForm", parentDynamicForm: "parentDynamicForm", debug: "debug", readonly: "readonly", operation: "operation", parentDynamicFormObject: "parentDynamicFormObject", dynamicFormObject: "dynamicFormObject", form: "form", parentForm: "parentForm", xpath: "xpath", hideLabel: "hideLabel" }, outputs: { nextForm: "nextForm" }, standalone: false, decls: 10, vars: 12, consts: [[3, "formGroup", "title", "ngClass"], [4, "ngIf"], [3, "group", "id", "dynamicForm", "parentDynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "readonly", "debug", "xpath", "hideLabel", "statuses"], [3, "group", "id", "dynamicForm", "parentDynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "readonly", "debug", "xpath", "hideLabel"], [3, "nextForm", "group", "id", "dynamicForm", "parentDynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "readonly", "debug", "xpath", "hideLabel", "statuses", "status"], [3, "id", "dynamicForm", "parentDynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "readonly", "debug", "xpath", "hideLabel", "statuses", "status"], [3, "nextForm", "id", "dynamicForm", "parentDynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "readonly", "debug", "xpath", "hideLabel", "statuses", "status"]], template: function DynamicFormSwitcherView_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, DynamicFormSwitcherView_ng_container_1_Template, 3, 2, "ng-container", 1)(2, DynamicFormSwitcherView_ng_container_2_Template, 2, 13, "ng-container", 1)(3, DynamicFormSwitcherView_ng_container_3_Template, 2, 15, "ng-container", 1)(4, DynamicFormSwitcherView_ng_container_4_Template, 2, 15, "ng-container", 1)(5, DynamicFormSwitcherView_ng_container_5_Template, 2, 14, "ng-container", 1)(6, DynamicFormSwitcherView_ng_container_6_Template, 2, 13, "ng-container", 1)(7, DynamicFormSwitcherView_ng_container_7_Template, 2, 13, "ng-container", 1)(8, DynamicFormSwitcherView_ng_container_8_Template, 2, 15, "ng-container", 1)(9, DynamicFormSwitcherView_ng_container_9_Template, 2, 14, "ng-container", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.form)("title", ctx.dynamicFormControlService.getProperty(ctx.parentForm.getRawValue(), ctx.dynamicForm, ctx.dynamicFormObject, "tooltip"))("ngClass", ctx.getClass() + " " + ctx.dynamicFormControlService.getComponentClass(ctx.parentForm || ctx.form, ctx.dynamicForm, ctx.dynamicFormObject, ctx.xpath, ctx.debug));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormService.controlTypes.includes(ctx.dynamicFormObject.type) && !ctx.dynamicFormObject.type.startsWith("geo"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.type.startsWith("geo"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.type === "group");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.type === "keyselect");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.type === "groupselect");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.type === "checkboxlist");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.type === "latlong");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.type === "array");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.type === "form");
        } }, styles: [".effect[_ngcontent-%COMP%]{opacity:1;animation:_ngcontent-%COMP%_fade 5s linear}@keyframes _ngcontent-%COMP%_fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator[_ngcontent-%COMP%]{width:100%}.form-check-label[_ngcontent-%COMP%]{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items[_ngcontent-%COMP%]{list-style:none;font-size:.9rem}.help-button[_ngcontent-%COMP%]{margin:5px}.help-button[_ngcontent-%COMP%]:hover{cursor:pointer}.component-header[_ngcontent-%COMP%]{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{margin-left:10px}.form-control-footer[_ngcontent-%COMP%]{font-size:.8em}.mandatory[_ngcontent-%COMP%]{font-size:50%;vertical-align:top;color:red}.app-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}.header-title[_ngcontent-%COMP%]:hover{cursor:pointer}.status-label[_ngcontent-%COMP%]{font-size:1em;font-weight:700}.component-label[_ngcontent-%COMP%]{font-size:1em}.component-label.horizontal[_ngcontent-%COMP%], label.title-category[_ngcontent-%COMP%]{font-size:.9em}.float[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.panel-body[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading[_ngcontent-%COMP%]{min-height:45px;display:flex}.panel-heading[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-height:40px}.multiple-values-item[_ngcontent-%COMP%]{display:flex;flex-grow:1}.multiple-values-item-content[_ngcontent-%COMP%]{width:95%}.multiple-values-item-body[_ngcontent-%COMP%]{width:95%;margin-bottom:5px}.array-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:.9em}.header-title[_ngcontent-%COMP%]{vertical-align:middle}.card[_ngcontent-%COMP%]{margin-bottom:.5em}.refresh-button[_ngcontent-%COMP%]{margin:.5em}.refresh-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ref-form[_ngcontent-%COMP%]{display:flex;align-items:baseline}img[_ngcontent-%COMP%]{max-width:100%;height:auto}.collapse[_ngcontent-%COMP%]{display:none!important}.collapse.in[_ngcontent-%COMP%]{display:block!important}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form[_ngcontent-%COMP%]   .p-fieldset[_ngcontent-%COMP%]   .p-fieldset-legend[_ngcontent-%COMP%]{font-size:.8em!important}.dynamic-form-summary-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%]{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{margin-left:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%], .dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-icon[_ngcontent-%COMP%]{font-size:20px!important}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.control-cell.content[_ngcontent-%COMP%]{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu[_ngcontent-%COMP%]{width:55px}.form-group[_ngcontent-%COMP%]{border:solid 1px rgba(0,0,0,.125);margin:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormSwitcherView, [{
        type: Component,
        args: [{ selector: 'dynamic-form-switcher-view', standalone: false, template: "<div\r\n  [formGroup]=\"form\" \r\n  [title]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'tooltip')\"\r\n  [ngClass]=\"getClass() + ' ' + dynamicFormControlService.getComponentClass(parentForm || form, dynamicForm, dynamicFormObject, xpath, debug)\">\r\n\r\n    <ng-container *ngIf=\"dynamicFormService.controlTypes.includes(dynamicFormObject.type) && !(dynamicFormObject.type.startsWith('geo'))\">\r\n\r\n      <ng-container *ngIf=\"!dynamicFormObject.multipleValues\">\r\n        <dynamic-form-control-view\r\n          [group]=\"group\"\r\n          [id]=\"dynamicFormObject.code\"\r\n          [dynamicForm]=\"dynamicForm\"\r\n          [parentDynamicForm]=\"parentDynamicForm\"\r\n          [dynamicFormObject]=\"dynamicFormObject\"\r\n          [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n          [form]=\"form\"\r\n          [parentForm]=\"parentForm\"\r\n          [operation]=\"operation\"\r\n          [readonly]=\"readonly\"\r\n          [debug]=\"debug\"\r\n          [xpath]=\"xpath\"\r\n          [hideLabel]=\"hideLabel\"\r\n          [statuses]=\"statuses\">\r\n        </dynamic-form-control-view>\r\n      </ng-container>\r\n\r\n      <ng-container *ngIf=\"dynamicFormObject.multipleValues\">\r\n\r\n        <ng-container *ngIf=\"dynamicFormObject.type === 'checkbox'\">\r\n          <dynamic-form-checkboxlist-view\r\n            [group]=\"group\"\r\n            [id]=\"dynamicFormObject.code\"\r\n            [dynamicForm]=\"dynamicForm\"\r\n            [parentDynamicForm]=\"parentDynamicForm\"\r\n            [dynamicFormObject]=\"dynamicFormObject\"\r\n            [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n            [form]=\"$any(form.controls[dynamicFormObject.code])\"\r\n            [parentForm]=\"parentForm\"\r\n            [operation]=\"operation\"\r\n            [readonly]=\"readonly\"\r\n            [debug]=\"debug\"\r\n            [xpath]=\"xpath\"\r\n            [hideLabel]=\"hideLabel\">\r\n          </dynamic-form-checkboxlist-view>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"dynamicFormObject.type !== 'checkbox'\">\r\n          <dynamic-form-control-view\r\n            [group]=\"group\"\r\n            [id]=\"dynamicFormObject.code\"\r\n            [dynamicForm]=\"dynamicForm\"\r\n            [parentDynamicForm]=\"parentDynamicForm\"\r\n            [dynamicFormObject]=\"dynamicFormObject\"\r\n            [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n            [form]=\"form\"\r\n            [parentForm]=\"parentForm\"\r\n            [operation]=\"operation\"\r\n            [readonly]=\"readonly\"\r\n            [debug]=\"debug\"\r\n            [xpath]=\"xpath\"\r\n            [hideLabel]=\"hideLabel\"\r\n            [statuses]=\"statuses\">\r\n          </dynamic-form-control-view>\r\n        </ng-container>\r\n\r\n      </ng-container>\r\n\r\n    \r\n    </ng-container>\r\n  \r\n    <ng-container *ngIf=\"dynamicFormObject.type.startsWith('geo')\">\r\n      <dynamic-form-geometry-view\r\n        [group]=\"group\"\r\n        [id]=\"dynamicFormObject.code\"\r\n        [dynamicForm]=\"dynamicForm\"\r\n        [parentDynamicForm]=\"parentDynamicForm\"\r\n        [dynamicFormObject]=\"dynamicFormObject\"\r\n        [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n        [form]=\"form\"\r\n        [parentForm]=\"parentForm\"\r\n        [operation]=\"operation\"\r\n        [readonly]=\"readonly\"\r\n        [debug]=\"debug\"\r\n        [xpath]=\"xpath\"\r\n        [hideLabel]=\"hideLabel\">\r\n      </dynamic-form-geometry-view>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"dynamicFormObject.type === 'group'\">\r\n      <dynamic-form-group-view\r\n        [group]=\"group\"\r\n        [id]=\"dynamicFormObject.code\"\r\n        [dynamicForm]=\"dynamicForm\"\r\n        [parentDynamicForm]=\"parentDynamicForm\"\r\n        [dynamicFormObject]=\"dynamicFormObject\"\r\n        [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n        [form]=\"form\"\r\n        [parentForm]=\"parentForm\"\r\n        [operation]=\"operation\"\r\n        [readonly]=\"readonly\"\r\n        [debug]=\"debug\"\r\n        [xpath]=\"xpath\"\r\n        [hideLabel]=\"hideLabel\"\r\n        [statuses]=\"statuses\"\r\n        [status]=\"status\"\r\n        (nextForm)=\"onNextForm($event)\">\r\n      </dynamic-form-group-view>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"dynamicFormObject.type === 'keyselect'\">\r\n      <dynamic-form-keyselect-view\r\n        [group]=\"group\"\r\n        [id]=\"dynamicFormObject.code\"\r\n        [dynamicForm]=\"dynamicForm\"\r\n        [parentDynamicForm]=\"parentDynamicForm\"\r\n        [dynamicFormObject]=\"dynamicFormObject\"\r\n        [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n        [form]=\"form\"\r\n        [parentForm]=\"parentForm\"\r\n        [operation]=\"operation\"\r\n        [readonly]=\"readonly\"\r\n        [debug]=\"debug\"\r\n        [xpath]=\"xpath\"\r\n        [hideLabel]=\"hideLabel\"\r\n        [statuses]=\"statuses\"\r\n        [status]=\"status\"\r\n        (nextForm)=\"onNextForm($event)\">\r\n      </dynamic-form-keyselect-view>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"dynamicFormObject.type === 'groupselect'\">\r\n      <dynamic-form-groupselect-view\r\n        [id]=\"dynamicFormObject.code\"\r\n        [dynamicForm]=\"dynamicForm\"\r\n        [parentDynamicForm]=\"parentDynamicForm\"\r\n        [dynamicFormObject]=\"dynamicFormObject\"\r\n        [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n        [form]=\"form\"\r\n        [parentForm]=\"parentForm\"\r\n        [operation]=\"operation\"\r\n        [readonly]=\"readonly\"\r\n        [debug]=\"debug\"\r\n        [xpath]=\"xpath\"\r\n        [hideLabel]=\"hideLabel\"\r\n        [statuses]=\"statuses\"\r\n        [status]=\"status\">\r\n      </dynamic-form-groupselect-view>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"dynamicFormObject.type === 'checkboxlist'\">\r\n      <dynamic-form-checkboxlist-view\r\n        [group]=\"group\"\r\n        [id]=\"dynamicFormObject.code\"\r\n        [dynamicForm]=\"dynamicForm\"\r\n        [parentDynamicForm]=\"parentDynamicForm\"\r\n        [dynamicFormObject]=\"dynamicFormObject\"\r\n        [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n        [form]=\"$any(form.controls[dynamicFormObject.code])\"\r\n        [parentForm]=\"parentForm\"\r\n        [operation]=\"operation\"\r\n        [readonly]=\"readonly\"\r\n        [debug]=\"debug\"\r\n        [xpath]=\"xpath\"\r\n        [hideLabel]=\"hideLabel\">\r\n      </dynamic-form-checkboxlist-view>\r\n    </ng-container>\r\n  \r\n    <ng-container *ngIf=\"dynamicFormObject.type === 'latlong'\">\r\n      <dynamic-form-group-lat-long-view\r\n        [group]=\"group\"\r\n        [id]=\"dynamicFormObject.code\"\r\n        [dynamicForm]=\"dynamicForm\"\r\n        [parentDynamicForm]=\"parentDynamicForm\"\r\n        [dynamicFormObject]=\"dynamicFormObject\"\r\n        [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n        [form]=\"$any(form.controls[dynamicFormObject.code])\"\r\n        [parentForm]=\"parentForm\"\r\n        [operation]=\"operation\"\r\n        [readonly]=\"readonly\"\r\n        [debug]=\"debug\"\r\n        [xpath]=\"xpath\"\r\n        [hideLabel]=\"hideLabel\">\r\n      </dynamic-form-group-lat-long-view>\r\n    </ng-container>\r\n  \r\n    <ng-container *ngIf=\"dynamicFormObject.type === 'array'\">\r\n      <dynamic-form-array-view\r\n        [group]=\"group\"\r\n        [id]=\"dynamicFormObject.code\"\r\n        [dynamicForm]=\"dynamicForm\"\r\n        [parentDynamicForm]=\"parentDynamicForm\"\r\n        [dynamicFormObject]=\"dynamicFormObject\"\r\n        [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n        [form]=\"form\"\r\n        [parentForm]=\"parentForm\"\r\n        [operation]=\"operation\"\r\n        [readonly]=\"readonly\"\r\n        [debug]=\"debug\"\r\n        [xpath]=\"xpath\"\r\n        [hideLabel]=\"hideLabel\" \r\n        [statuses]=\"statuses\"\r\n        [status]=\"status\"\r\n        (nextForm)=\"onNextForm($event)\">\r\n      </dynamic-form-array-view>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"dynamicFormObject.type === 'form'\">\r\n      <dynamic-form-nested-form-view\r\n        [id]=\"dynamicFormObject.code\"\r\n        [dynamicForm]=\"dynamicForm\"\r\n        [parentDynamicForm]=\"parentDynamicForm\"\r\n        [dynamicFormObject]=\"dynamicFormObject\"\r\n        [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n        [form]=\"form\"\r\n        [parentForm]=\"parentForm\"\r\n        [operation]=\"operation\"\r\n        [readonly]=\"readonly\"\r\n        [debug]=\"debug\"\r\n        [xpath]=\"xpath\"\r\n        [hideLabel]=\"hideLabel\"\r\n        [statuses]=\"statuses\"\r\n        [status]=\"status\"\r\n        (nextForm)=\"onNextForm($event)\">\r\n      </dynamic-form-nested-form-view>\r\n    </ng-container>    \r\n  </div>\r\n  ", styles: [".effect{opacity:1;animation:fade 5s linear}@keyframes fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator{width:100%}.form-check-label{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items{list-style:none;font-size:.9rem}.help-button{margin:5px}.help-button:hover{cursor:pointer}.component-header{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header .header-title{margin-left:10px}.form-control-footer{font-size:.8em}.mandatory{font-size:50%;vertical-align:top;color:red}.app-menu-disabled{pointer-events:none;opacity:.6}.header-title:hover{cursor:pointer}.status-label{font-size:1em;font-weight:700}.component-label{font-size:1em}.component-label.horizontal,label.title-category{font-size:.9em}.float{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float>*{margin-left:5px;margin-right:5px}.panel-body{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading{min-height:45px;display:flex}.panel-heading .header-title{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading button{max-height:40px}.multiple-values-item{display:flex;flex-grow:1}.multiple-values-item-content{width:95%}.multiple-values-item-body{width:95%;margin-bottom:5px}.array-items button{font-size:.9em}.header-title{vertical-align:middle}.card{margin-bottom:.5em}.refresh-button{margin:.5em}.refresh-button:hover{cursor:pointer}.ref-form{display:flex;align-items:baseline}img{max-width:100%;height:auto}.collapse{display:none!important}.collapse.in{display:block!important}.collapsing{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form .p-fieldset .p-fieldset-legend{font-size:.8em!important}.dynamic-form-summary-view{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view .form-tree{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view .form-questions{margin-left:5px}.dynamic-form-summary-view .form-tree,.dynamic-form-summary-view .form-questions{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form{width:100%}form .item-icon{font-size:20px!important}form .item-switcher{width:100%}form .item-switcher>div{width:100%}.control-cell.content{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu{width:55px}.form-group{border:solid 1px rgba(0,0,0,.125);margin:1em}\n"] }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }], { group: [{
            type: Input
        }], statuses: [{
            type: Input
        }], status: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], parentDynamicForm: [{
            type: Input
        }], debug: [{
            type: Input
        }], readonly: [{
            type: Input
        }], operation: [{
            type: Input
        }], parentDynamicFormObject: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], form: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], xpath: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], nextForm: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormSwitcherView, { className: "DynamicFormSwitcherView", filePath: "src/dynamic-form/dynamic-form-switcher/dynamic-form-switcher.ts", lineNumber: 15 }); })();

function DynamicFormPage_div_2_div_1_div_1_div_6_p_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 15);
    i0.ɵɵlistener("click", function DynamicFormPage_div_2_div_1_div_1_div_6_p_button_3_Template_p_button_click_0_listener() { const item_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r2.changeStatus(item_r2)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("label", item_r2.charAt(0).toUpperCase() + item_r2.substring(1));
    i0.ɵɵproperty("rounded", true);
} }
function DynamicFormPage_div_2_div_1_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 1);
    i0.ɵɵtext(2, " Set status to: ");
    i0.ɵɵtemplate(3, DynamicFormPage_div_2_div_1_div_1_div_6_p_button_3_Template, 1, 2, "p-button", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.getNextStatuses(ctx_r2.status));
} }
function DynamicFormPage_div_2_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "label", 11);
    i0.ɵɵtext(3, "Status: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "p-button", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 13);
    i0.ɵɵtemplate(6, DynamicFormPage_div_2_div_1_div_1_div_6_Template, 4, 1, "div", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("label", ctx_r2.status.charAt(0).toUpperCase() + ctx_r2.status.substring(1));
    i0.ɵɵproperty("text", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.operation === "edit" && ctx_r2.getNextStatuses(ctx_r2.status));
} }
function DynamicFormPage_div_2_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dynamic-form-switcher-view", 16);
    i0.ɵɵlistener("nextForm", function DynamicFormPage_div_2_div_1_ng_container_3_Template_dynamic_form_switcher_view_nextForm_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onNextForm($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const dynamicFormObject_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", dynamicFormObject_r5.type === "system")("ngClass", dynamicFormObject_r5.type === "separator" ? "separator" : "")("xpath", ctx_r2.xpath)("dynamicForm", ctx_r2.dynamicForm)("parentDynamicForm", ctx_r2.parentDynamicForm)("dynamicFormObject", dynamicFormObject_r5)("parentDynamicFormObject", ctx_r2.parentDynamicFormObject)("parentForm", ctx_r2.parentForm ? ctx_r2.parentForm : ctx_r2.form)("form", ctx_r2.form)("operation", ctx_r2.operation)("debug", ctx_r2.debug)("readonly", ctx_r2.readonly)("hideLabel", ctx_r2.hideLabel)("statuses", ctx_r2.statuses)("status", ctx_r2.status);
} }
function DynamicFormPage_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, DynamicFormPage_div_2_div_1_div_1_Template, 7, 3, "div", 6);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵtemplate(3, DynamicFormPage_div_2_div_1_ng_container_3_Template, 2, 15, "ng-container", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.statuses);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r2.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.dynamicFormService.getRootForm(ctx_r2.dynamicForm));
} }
function DynamicFormPage_div_2_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dynamic-form-switcher-view", 16);
    i0.ɵɵlistener("nextForm", function DynamicFormPage_div_2_div_2_ng_container_2_Template_dynamic_form_switcher_view_nextForm_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onNextForm($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const dynamicFormObject_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", dynamicFormObject_r7.type === "system")("ngClass", dynamicFormObject_r7.type === "separator" ? "separator" : "")("xpath", ctx_r2.xpath)("dynamicForm", ctx_r2.dynamicForm)("parentDynamicForm", ctx_r2.parentDynamicForm)("dynamicFormObject", dynamicFormObject_r7)("parentDynamicFormObject", ctx_r2.parentDynamicFormObject)("parentForm", ctx_r2.parentForm ? ctx_r2.parentForm : ctx_r2.form)("form", ctx_r2.form)("operation", ctx_r2.operation)("debug", ctx_r2.debug)("readonly", ctx_r2.readonly)("hideLabel", ctx_r2.hideLabel)("statuses", ctx_r2.statuses)("status", ctx_r2.status);
} }
function DynamicFormPage_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 17);
    i0.ɵɵtemplate(2, DynamicFormPage_div_2_div_2_ng_container_2_Template, 2, 15, "ng-container", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.dynamicFormService.getRootForm(ctx_r2.dynamicForm));
} }
function DynamicFormPage_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, DynamicFormPage_div_2_div_1_Template, 4, 3, "div", 5)(2, DynamicFormPage_div_2_div_2_Template, 3, 1, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.role !== "child");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.role === "child");
} }
function DynamicFormPage_p_confirmDialog_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-confirmDialog", 18);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("header", ctx_r2.configService.getTranslation("builder.confirm-dialog-header"));
} }
class DynamicFormPage {
    constructor(dynamicFormService, dynamicFormControlService, route, configService) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.route = route;
        this.configService = configService;
        this.debug = false;
        this.readonly = false;
        this.xpath = "";
        this.hideLabel = false;
        this.formLoaded = new EventEmitter();
        this.formUpdate = new EventEmitter();
        this.nextForm = new EventEmitter();
        this.statusChange = new EventEmitter();
        this.dataAvailable = false;
        this.loading = true;
    }
    ngOnInit() {
        this.dynamicForm.space = this.space;
        if (this.stylesheet) {
            /* Create style document */
            let css = document.createElement('style');
            css.type = 'text/css';
            if (css.styleSheet) {
                css.styleSheet.cssText = this.stylesheet;
            }
            else {
                css.appendChild(document.createTextNode(this.stylesheet));
            }
            /* Append style to the tag name */
            document.getElementsByTagName("head")[0].appendChild(css);
        }
        else {
            if (this.dynamicForm.stylesheet) {
                /* Create style document */
                let css = document.createElement('style');
                css.type = 'text/css';
                if (css.styleSheet) {
                    css.styleSheet.cssText = this.dynamicForm.stylesheet;
                }
                else {
                    css.appendChild(document.createTextNode(this.dynamicForm.stylesheet));
                }
                /* Append style to the tag name */
                document.getElementsByTagName("head")[0].appendChild(css);
            }
        }
        if (this.cssClass) {
            if (!this.dynamicForm.cssClass) {
                this.dynamicForm.cssClass = this.cssClass;
            }
            else {
                for (let key in this.cssClass) {
                    this.dynamicForm.cssClass[key] = this.dynamicForm.cssClass[key] ? this.dynamicForm.cssClass[key] : this.cssClass[key];
                }
            }
        }
        if (this.params) {
            this.dynamicForm.params = this.params;
        }
        this.route.params.subscribe(params => {
            this.id = params.id;
            this.createForm();
            this.formLoaded.emit({
                formId: this.dynamicForm.id,
                data: this.dynamicForm
            });
        });
    }
    createForm() {
        this.loading = true;
        this.parentDynamicFormObject = new DynamicFormObject({
            components: this.dynamicFormService.getRootForm(this.dynamicForm)
        });
        this.dynamicForm = this.dynamicFormService.checkForm(this.dynamicForm);
        //The form is created only if it's not yet provided
        //A form object is already provided when the form is nested
        if (!this.form) {
            this.form = this.dynamicFormControlService.createRootForm(this.dynamicForm, this.operation, this.formData);
        }
        if (this.readonly) {
            this.form.disable();
        }
        this.loading = false;
    }
    getFormValue() {
        let data = this.form.getRawValue();
        if (this.statuses) {
            data.status = this.status;
        }
        return data;
    }
    getForm() {
        return this.form;
    }
    onNextForm(event) {
        event.status = this.status;
        this.nextForm.emit(event);
    }
    onFormLoaded(event) {
        event.status = this.status;
        this.formLoaded.emit(event);
    }
    onFormUpdate(event) {
        event.status = this.status;
        this.formUpdate.emit(event);
    }
    getNextStatuses(status) {
        let index = this.statuses.status.findIndex(item => item.name === status);
        if (index >= 0) {
            return this.statuses.status[index].computedNextStatuses;
        }
        else {
            return null;
        }
    }
    changeStatus(status) {
        this.statusChange.emit({
            old: this.status,
            new: status
        });
    }
    static { this.ɵfac = function DynamicFormPage_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormPage)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormPage, selectors: [["dynamic-form"]], inputs: { space: "space", formData: "formData", debug: "debug", readonly: "readonly", operation: "operation", xpath: "xpath", dynamicForm: "dynamicForm", parentDynamicForm: "parentDynamicForm", cssClass: "cssClass", stylesheet: "stylesheet", params: "params", form: "form", parentForm: "parentForm", role: "role", statuses: "statuses", status: "status", hideLabel: "hideLabel", id: "id" }, outputs: { formLoaded: "formLoaded", formUpdate: "formUpdate", nextForm: "nextForm", statusChange: "statusChange" }, standalone: false, decls: 5, vars: 2, consts: [[1, "row", "mt-2", "dynamic-form"], [1, "col-md-12"], ["class", "row", 4, "ngIf"], ["icon", "pi pi-exclamation-triangle", "key", "dynamic-form", 3, "header", 4, "ngIf"], [1, "row"], ["class", "col-md-12", 4, "ngIf"], ["class", "row mb-2", 4, "ngIf"], [1, "dynamic-form-view", 3, "formGroup"], [4, "ngFor", "ngForOf"], [1, "row", "mb-2"], [1, "col-md-6"], [1, "status-label", "text-color-gray-dark"], ["severity", "warn", 3, "label", "text"], [1, "col-md-6", "align-right"], ["class", "status-button", "severity", "warn", 3, "label", "rounded", "click", 4, "ngFor", "ngForOf"], ["severity", "warn", 1, "status-button", 3, "click", "label", "rounded"], [3, "nextForm", "hidden", "ngClass", "xpath", "dynamicForm", "parentDynamicForm", "dynamicFormObject", "parentDynamicFormObject", "parentForm", "form", "operation", "debug", "readonly", "hideLabel", "statuses", "status"], [1, "dynamic-form-view"], ["icon", "pi pi-exclamation-triangle", "key", "dynamic-form", 3, "header"]], template: function DynamicFormPage_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, DynamicFormPage_div_2_Template, 3, 2, "div", 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(3, "p-toast");
            i0.ɵɵtemplate(4, DynamicFormPage_p_confirmDialog_4_Template, 1, 1, "p-confirmDialog", 3);
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.loading);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.role);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i5.NgControlStatusGroup, i5.FormGroupDirective, i5$1.ConfirmDialog, i7.Button, i7$1.Toast, DynamicFormSwitcherView], styles: [".effect[_ngcontent-%COMP%]{opacity:1;animation:_ngcontent-%COMP%_fade 5s linear}@keyframes _ngcontent-%COMP%_fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator[_ngcontent-%COMP%]{width:100%}.form-check-label[_ngcontent-%COMP%]{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items[_ngcontent-%COMP%]{list-style:none;font-size:.9rem}.help-button[_ngcontent-%COMP%]{margin:5px}.help-button[_ngcontent-%COMP%]:hover{cursor:pointer}.component-header[_ngcontent-%COMP%]{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{margin-left:10px}.form-control-footer[_ngcontent-%COMP%]{font-size:.8em}.mandatory[_ngcontent-%COMP%]{font-size:50%;vertical-align:top;color:red}.app-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}.header-title[_ngcontent-%COMP%]:hover{cursor:pointer}.status-label[_ngcontent-%COMP%]{font-size:1em;font-weight:700}.component-label[_ngcontent-%COMP%]{font-size:1em}.component-label.horizontal[_ngcontent-%COMP%], label.title-category[_ngcontent-%COMP%]{font-size:.9em}.float[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.panel-body[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading[_ngcontent-%COMP%]{min-height:45px;display:flex}.panel-heading[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-height:40px}.multiple-values-item[_ngcontent-%COMP%]{display:flex;flex-grow:1}.multiple-values-item-content[_ngcontent-%COMP%]{width:95%}.multiple-values-item-body[_ngcontent-%COMP%]{width:95%;margin-bottom:5px}.array-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:.9em}.header-title[_ngcontent-%COMP%]{vertical-align:middle}.card[_ngcontent-%COMP%]{margin-bottom:.5em}.refresh-button[_ngcontent-%COMP%]{margin:.5em}.refresh-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ref-form[_ngcontent-%COMP%]{display:flex;align-items:baseline}img[_ngcontent-%COMP%]{max-width:100%;height:auto}.collapse[_ngcontent-%COMP%]{display:none!important}.collapse.in[_ngcontent-%COMP%]{display:block!important}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form[_ngcontent-%COMP%]   .p-fieldset[_ngcontent-%COMP%]   .p-fieldset-legend[_ngcontent-%COMP%]{font-size:.8em!important}.dynamic-form-summary-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%]{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{margin-left:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%], .dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-icon[_ngcontent-%COMP%]{font-size:20px!important}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.control-cell.content[_ngcontent-%COMP%]{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu[_ngcontent-%COMP%]{width:55px}.form-group[_ngcontent-%COMP%]{border:solid 1px rgba(0,0,0,.125);margin:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormPage, [{
        type: Component,
        args: [{ selector: 'dynamic-form', standalone: false, template: "<div class=\"row mt-2 dynamic-form\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"row\" *ngIf=\"!loading\">\r\n      <div class=\"col-md-12\" *ngIf=\"role !== 'child'\">\r\n\r\n        <!-- Statuses -->\r\n        <div class=\"row mb-2\" *ngIf=\"statuses\">\r\n          <div class=\"col-md-6\">\r\n            <label class=\"status-label text-color-gray-dark\">Status: </label>\r\n            <p-button label=\"{{ status.charAt(0).toUpperCase() + status.substring(1) }}\"\r\n            [text]=\"true\" severity=\"warn\"></p-button>\r\n          </div>\r\n          <div class=\"col-md-6 align-right\">\r\n            <div class=\"row\" *ngIf=\"operation === 'edit' && getNextStatuses(status)\">\r\n              <div class=\"col-md-12\">\r\n                Set status to:\r\n                <p-button *ngFor=\"let item of getNextStatuses(status)\"\r\n                  label=\"{{item.charAt(0).toUpperCase() + item.substring(1)}}\" class=\"status-button\"\r\n                  [rounded]=\"true\" severity=\"warn\" (click)=\"changeStatus(item)\"></p-button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- Form structure -->\r\n        <div [formGroup]=\"form\" class=\"dynamic-form-view\">\r\n            <ng-container *ngFor=\"let dynamicFormObject of (dynamicFormService.getRootForm(dynamicForm))\">\r\n                <dynamic-form-switcher-view [hidden]=\"dynamicFormObject.type==='system'\" [ngClass]=\"dynamicFormObject.type==='separator' ? 'separator' : ''\"\r\n                  [xpath]=\"xpath\" [dynamicForm]=\"dynamicForm\" [parentDynamicForm]=\"parentDynamicForm\"\r\n                  [dynamicFormObject]=\"dynamicFormObject\" [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n                  [parentForm]=\"parentForm ? parentForm : form\" [form]=\"form\" [operation]=\"operation\" [debug]=\"debug\"\r\n                  [readonly]=\"readonly\" [hideLabel]=\"hideLabel\" [statuses]=\"statuses\" [status]=\"status\"\r\n                  (nextForm)=\"onNextForm($event)\">\r\n                </dynamic-form-switcher-view>\r\n            </ng-container>\r\n        </div>\r\n\r\n      </div>\r\n\r\n      <div class=\"col-md-12\" *ngIf=\"role === 'child'\">\r\n\r\n        <!-- Form structure -->\r\n        <div class=\"dynamic-form-view\">\r\n            <ng-container *ngFor=\"let dynamicFormObject of (dynamicFormService.getRootForm(dynamicForm))\">\r\n                <dynamic-form-switcher-view [hidden]=\"dynamicFormObject.type==='system'\" [ngClass]=\"dynamicFormObject.type==='separator' ? 'separator' : ''\"\r\n                  [xpath]=\"xpath\" [dynamicForm]=\"dynamicForm\" [parentDynamicForm]=\"parentDynamicForm\"\r\n                  [dynamicFormObject]=\"dynamicFormObject\" [parentDynamicFormObject]=\"parentDynamicFormObject\"\r\n                  [parentForm]=\"parentForm ? parentForm : form\" [form]=\"form\" [operation]=\"operation\" [debug]=\"debug\"\r\n                  [readonly]=\"readonly\" [hideLabel]=\"hideLabel\" [statuses]=\"statuses\" [status]=\"status\"\r\n                  (nextForm)=\"onNextForm($event)\">\r\n                </dynamic-form-switcher-view>\r\n            </ng-container>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<p-toast></p-toast>\r\n<p-confirmDialog *ngIf=\"!role\" header=\"{{ configService.getTranslation('builder.confirm-dialog-header')}}\"\r\n  icon=\"pi pi-exclamation-triangle\" key=\"dynamic-form\"></p-confirmDialog>", styles: [".effect{opacity:1;animation:fade 5s linear}@keyframes fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator{width:100%}.form-check-label{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items{list-style:none;font-size:.9rem}.help-button{margin:5px}.help-button:hover{cursor:pointer}.component-header{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header .header-title{margin-left:10px}.form-control-footer{font-size:.8em}.mandatory{font-size:50%;vertical-align:top;color:red}.app-menu-disabled{pointer-events:none;opacity:.6}.header-title:hover{cursor:pointer}.status-label{font-size:1em;font-weight:700}.component-label{font-size:1em}.component-label.horizontal,label.title-category{font-size:.9em}.float{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float>*{margin-left:5px;margin-right:5px}.panel-body{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading{min-height:45px;display:flex}.panel-heading .header-title{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading button{max-height:40px}.multiple-values-item{display:flex;flex-grow:1}.multiple-values-item-content{width:95%}.multiple-values-item-body{width:95%;margin-bottom:5px}.array-items button{font-size:.9em}.header-title{vertical-align:middle}.card{margin-bottom:.5em}.refresh-button{margin:.5em}.refresh-button:hover{cursor:pointer}.ref-form{display:flex;align-items:baseline}img{max-width:100%;height:auto}.collapse{display:none!important}.collapse.in{display:block!important}.collapsing{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form .p-fieldset .p-fieldset-legend{font-size:.8em!important}.dynamic-form-summary-view{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view .form-tree{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view .form-questions{margin-left:5px}.dynamic-form-summary-view .form-tree,.dynamic-form-summary-view .form-questions{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form{width:100%}form .item-icon{font-size:20px!important}form .item-switcher{width:100%}form .item-switcher>div{width:100%}.control-cell.content{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu{width:55px}.form-group{border:solid 1px rgba(0,0,0,.125);margin:1em}\n"] }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i2.ActivatedRoute }, { type: i1.ConfigurationService }], { space: [{
            type: Input
        }], formData: [{
            type: Input
        }], debug: [{
            type: Input
        }], readonly: [{
            type: Input
        }], operation: [{
            type: Input
        }], xpath: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], parentDynamicForm: [{
            type: Input
        }], cssClass: [{
            type: Input
        }], stylesheet: [{
            type: Input
        }], params: [{
            type: Input
        }], form: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], role: [{
            type: Input
        }], statuses: [{
            type: Input
        }], status: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], id: [{
            type: Input
        }], formLoaded: [{
            type: Output
        }], formUpdate: [{
            type: Output
        }], nextForm: [{
            type: Output
        }], statusChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormPage, { className: "DynamicFormPage", filePath: "src/dynamic-form/dynamic-form/dynamic-form.ts", lineNumber: 17 }); })();

function DebugDetailsComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 9)(2, "div", 2)(3, "label", 4);
    i0.ɵɵtext(4, "Display template:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "label", 10);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormObject.displayTemplate);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("[", ctx_r0.executeFormula(ctx_r0.dynamicFormObject.displayTemplate), "]");
} }
function DebugDetailsComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 9)(2, "div", 2)(3, "label", 4);
    i0.ɵɵtext(4, "Show if:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "label", 10);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormObject.showIf);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("[", ctx_r0.executeFormula(ctx_r0.dynamicFormObject.showIf), "]");
} }
function DebugDetailsComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 9)(2, "div", 2)(3, "label", 4);
    i0.ɵɵtext(4, "Hide if:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "label", 10);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormObject.hideIf);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("[", ctx_r0.executeFormula(ctx_r0.dynamicFormObject.hideIf), "]");
} }
function DebugDetailsComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 9)(2, "div", 2)(3, "label", 4);
    i0.ɵɵtext(4, "Formula:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "label", 10);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormObject.formulaValue);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("[", ctx_r0.executeFormula(ctx_r0.dynamicFormObject.formulaValue), "]");
} }
function DebugDetailsComponent_div_15_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 2)(2, "label", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "label", 10);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const v_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Validator [", i_r3, "]:");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(v_r2.formula);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("[", ctx_r0.executeFormula(v_r2.formula), "]");
} }
function DebugDetailsComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, DebugDetailsComponent_div_15_div_1_Template, 8, 3, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.dynamicFormObject.validation);
} }
class DebugDetailsComponent {
    constructor(dynamicFormControlService) {
        this.dynamicFormControlService = dynamicFormControlService;
        this.mode = 'edit';
    }
    ngOnInit() { }
    executeFormula(formula) {
        try {
            let value = this.dynamicFormControlService.executeFormula(formula, this.data, this.dynamicForm.acceptedParams, this.dynamicForm.params, this.xpath);
            return value;
        }
        catch (error) {
            return error.code + ' - ' + error.message;
        }
    }
    static { this.ɵfac = function DebugDetailsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DebugDetailsComponent)(i0.ɵɵdirectiveInject(i1.DynamicFormControlService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DebugDetailsComponent, selectors: [["debug-details"]], inputs: { data: "data", dynamicForm: "dynamicForm", dynamicFormObject: "dynamicFormObject", xpath: "xpath", mode: "mode" }, standalone: false, decls: 16, vars: 8, consts: [["container", ""], [1, "row", "debug-details"], [1, "col-md-12"], [1, "clipboard-button"], [1, "debug-property"], ["type", "button", "ngxClipboard", "", 1, "btn", "btn-link", 3, "cbContent", "container"], [1, "debug-formula"], [1, "bi", "bi-clipboard"], ["class", "col-md-12", 4, "ngIf"], [1, "row"], [1, "debug-result"], ["class", "row", 4, "ngFor", "ngForOf"]], template: function DebugDetailsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "label", 4);
            i0.ɵɵtext(4, "Path:");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 3, 0)(7, "button", 5)(8, "label", 6);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(10, "i", 7);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(11, DebugDetailsComponent_div_11_Template, 9, 2, "div", 8)(12, DebugDetailsComponent_div_12_Template, 9, 2, "div", 8)(13, DebugDetailsComponent_div_13_Template, 9, 2, "div", 8)(14, DebugDetailsComponent_div_14_Template, 9, 2, "div", 8)(15, DebugDetailsComponent_div_15_Template, 2, 1, "div", 8);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            const container_r4 = i0.ɵɵreference(6);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("cbContent", ctx.xpath)("container", container_r4);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.xpath);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.mode !== "create" && ctx.dynamicFormObject.displayTemplate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.mode !== "create" && ctx.dynamicFormObject.showIf);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.mode !== "create" && ctx.dynamicFormObject.hideIf);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.mode !== "create" && ctx.dynamicFormObject.formulaValue);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.mode !== "create" && ctx.dynamicFormObject.validation && ctx.dynamicFormObject.validation.length > 0);
        } }, dependencies: [i3.NgForOf, i3.NgIf, i3$1.ClipboardDirective], styles: [".debug-details[_ngcontent-%COMP%]{font-size:.9em;background-color:var(--secondary-background-color);margin:0}.debug-property[_ngcontent-%COMP%]{font-variant:all-small-caps;margin-right:.5em}.debug-formula[_ngcontent-%COMP%]{color:var(--default-font-color);margin-right:.5em}.debug-result[_ngcontent-%COMP%]{font-variant:small-caps;font-weight:600;color:var(--default-font-color)}.clipboard-button[_ngcontent-%COMP%]{float:left}.clipboard-button[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:0!important;padding:0!important}.clipboard-button[_ngcontent-%COMP%]   .debug-property[_ngcontent-%COMP%]{vertical-align:sub}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DebugDetailsComponent, [{
        type: Component,
        args: [{ selector: 'debug-details', standalone: false, template: "<div class=\"row debug-details\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"clipboard-button\">\r\n        <label class=\"debug-property\">Path:</label>\r\n      </div>\r\n      <div #container class=\"clipboard-button\">\r\n        <button type=\"button\" class=\"btn btn-link\" ngxClipboard [cbContent]=\"xpath\" [container]=\"container\"><label class=\"debug-formula\">{{ xpath }}</label><i class=\"bi bi-clipboard\"></i></button>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"mode !== 'create' && dynamicFormObject.displayTemplate\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <label class=\"debug-property\">Display template:</label>\r\n          <label class=\"debug-formula\">{{ dynamicFormObject.displayTemplate }}</label>\r\n          <label class=\"debug-result\">[{{ executeFormula(dynamicFormObject.displayTemplate) }}]</label>\r\n        </div>        \r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"mode !== 'create' && dynamicFormObject.showIf\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <label class=\"debug-property\">Show if:</label>\r\n          <label class=\"debug-formula\">{{ dynamicFormObject.showIf }}</label>\r\n          <label class=\"debug-result\">[{{ executeFormula(dynamicFormObject.showIf) }}]</label>\r\n        </div>        \r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"mode !== 'create' && dynamicFormObject.hideIf\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <label class=\"debug-property\">Hide if:</label>\r\n          <label class=\"debug-formula\">{{ dynamicFormObject.hideIf }}</label>\r\n          <label class=\"debug-result\">[{{ executeFormula(dynamicFormObject.hideIf) }}]</label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"mode !== 'create' && dynamicFormObject.formulaValue\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <label class=\"debug-property\">Formula:</label>\r\n          <label class=\"debug-formula\">{{ dynamicFormObject.formulaValue }}</label>\r\n          <label class=\"debug-result\">[{{ executeFormula(dynamicFormObject.formulaValue) }}]</label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"mode !== 'create' && dynamicFormObject.validation && dynamicFormObject.validation.length > 0\">\r\n      <div class=\"row\" *ngFor=\"let v of dynamicFormObject.validation; let i = index\">\r\n        <div class=\"col-md-12\">\r\n          <label class=\"debug-property\">Validator [{{ i }}]:</label>\r\n          <label class=\"debug-formula\">{{ v.formula }}</label>\r\n          <label class=\"debug-result\">[{{ executeFormula(v.formula) }}]</label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n</div>", styles: [".debug-details{font-size:.9em;background-color:var(--secondary-background-color);margin:0}.debug-property{font-variant:all-small-caps;margin-right:.5em}.debug-formula{color:var(--default-font-color);margin-right:.5em}.debug-result{font-variant:small-caps;font-weight:600;color:var(--default-font-color)}.clipboard-button{float:left}.clipboard-button button{margin:0!important;padding:0!important}.clipboard-button .debug-property{vertical-align:sub}\n"] }]
    }], () => [{ type: i1.DynamicFormControlService }], { data: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], xpath: [{
            type: Input
        }], mode: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DebugDetailsComponent, { className: "DebugDetailsComponent", filePath: "src/dynamic-form/debug-details/debug-details.component.ts", lineNumber: 12 }); })();

class HelpComponent {
    constructor(ref, config) {
        this.ref = ref;
        this.config = config;
    }
    ngOnInit() {
        this.description = this.config.data.description;
    }
    static { this.ɵfac = function HelpComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HelpComponent)(i0.ɵɵdirectiveInject(i1$1.DynamicDialogRef), i0.ɵɵdirectiveInject(i1$1.DynamicDialogConfig)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpComponent, selectors: [["app-help"]], standalone: false, decls: 1, vars: 1, consts: [[3, "template"]], template: function HelpComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "fi-template-renderer", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("template", ctx.description || "");
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpComponent, [{
        type: Component,
        args: [{ selector: 'app-help', standalone: false, template: "<fi-template-renderer [template]=\"description || ''\"></fi-template-renderer>\r\n" }]
    }], () => [{ type: i1$1.DynamicDialogRef }, { type: i1$1.DynamicDialogConfig }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(HelpComponent, { className: "HelpComponent", filePath: "src/dynamic-form/help/help.component.ts", lineNumber: 10 }); })();

class FormDataService {
    constructor(searchService, router, dynamicFormControlService, messageService, configService, route) {
        this.searchService = searchService;
        this.router = router;
        this.dynamicFormControlService = dynamicFormControlService;
        this.messageService = messageService;
        this.configService = configService;
        this.route = route;
        this.loading = false;
    }
    storeFormData(routeParams, queryParams, subpath, dynamicFormPage, dynamicForm, collectionItem, operation, alias, parentId, parentSpace, parentCollection, leave, root, status, statuses) {
        this.loading = true;
        collectionItem.parentId = parentId;
        collectionItem.parentSpace = parentSpace;
        collectionItem.parentCollection = parentCollection;
        /* NEW COLLECTION ITEM */
        if (operation === 'new') {
            this.saveFormData(dynamicForm.space, dynamicForm.collection, collectionItem).subscribe(res => {
                this.loading = false;
                collectionItem.id = res.id;
                this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Collection item saved correctly' });
                this.leaveForm(routeParams, queryParams, subpath, collectionItem, dynamicForm, root);
            }, err => {
                this.loading = false;
                this.searchService.manageError(err, 'Error saving collection item');
            });
        }
        /* UPDATE OF A COLLECTION ITEM */
        else {
            this.loading = true;
            this.updateFormData(dynamicForm.space, dynamicForm.collection, collectionItem, alias, status).subscribe(res => {
                dynamicFormPage.getForm().markAsPristine();
                this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Collection item saved correctly' });
                this.leaveForm(routeParams, queryParams, subpath, collectionItem, dynamicForm, root);
            }, err => {
                this.loading = false;
                this.searchService.manageError(err, 'Error saving collection item');
            });
        }
    }
    /*
      Management of the action following an operation on a collection item
    */
    leaveForm(routeParams, queryParams, subpath, collectionItem, collectionForm, root) {
        if (root) {
            let url;
            if (collectionForm.formConfig.route) {
                url = "/" + collectionForm.formConfig.route + "/" + this.configService.env.currentLang;
            }
            else {
                url = '/' + subpath + root.space + '/' + root.collection + '/search' + "/" + this.configService.env.currentLang;
            }
            this.router.navigate([url]);
        }
        else {
            if (collectionItem?.parentSpace && collectionItem?.parentCollection) {
                let parentStatus;
                if (queryParams._p > "") {
                    let parentInfo;
                    if (queryParams._p.includes(",")) {
                        parentInfo = queryParams._p.substring(queryParams._p.lastIndexOf(",") + 1).split("@");
                    }
                    else {
                        parentInfo = queryParams._p.split("@");
                    }
                    parentStatus = parentInfo[3];
                }
                let url;
                if (collectionForm.formConfig.route) {
                    url = "/" + collectionForm.formConfig.route + "/" + this.configService.env.currentLang;
                }
                else {
                    if (routeParams.space) {
                        url = '/' + subpath + routeParams.space + '/' + collectionItem.parentCollection + '/' + collectionItem.parentId + "/" + this.configService.env.currentLang;
                    }
                    else {
                        url = '/' + subpath + collectionItem.parentCollection + '/' + collectionItem.parentId + "/" + this.configService.env.currentLang;
                    }
                }
                if (parentStatus) {
                    this.router.navigate([url], {
                        queryParams: {
                            status: parentStatus,
                            _p: (queryParams._p > "" && queryParams._p.includes(",") ? queryParams._p.substring(0, queryParams._p.lastIndexOf(",")) : null)
                        }
                    });
                }
                else {
                    let url;
                    if (collectionForm.formConfig.route) {
                        url = "/" + collectionForm.formConfig.route + "/" + this.configService.env.currentLang;
                    }
                    else {
                        if (routeParams.space) {
                            url = '/' + subpath + routeParams.space + '/' + collectionForm.collection + '/search' + "/" + this.configService.env.currentLang;
                        }
                        else {
                            url = '/' + subpath + collectionForm.collection + '/search' + "/" + this.configService.env.currentLang;
                        }
                    }
                    this.router.navigate([url]);
                }
            }
            else {
                let url;
                if (collectionForm.formConfig.route) {
                    url = "/" + collectionForm.formConfig.route + "/" + this.configService.env.currentLang;
                }
                else {
                    if (routeParams.space) {
                        url = '/' + subpath + routeParams.space + '/' + collectionForm.collection + '/search' + "/" + this.configService.env.currentLang;
                    }
                    else {
                        url = '/' + subpath + collectionForm.collection + '/search' + "/" + this.configService.env.currentLang;
                    }
                }
                this.router.navigate([url]);
            }
        }
    }
    /*
        Management of the next step of a chain of forms with external forms
    */
    goToNextForm(routeParams, queryParams, subpath, dynamicForm, entry, status, subform, parent) {
        let params = {};
        if (subform && subform.params) {
            for (let i = 0; i < subform.params.length; i++) {
                params[subform.params[i].name] = this.dynamicFormControlService.executeFormula(subform.params[i].value, entry, null, null, parent.code);
            }
        }
        params.status = status;
        params._pid = entry.id;
        params._ps = dynamicForm.space;
        params._pc = (dynamicForm.collection || dynamicForm.id);
        params._p = this.composeP(queryParams._p, dynamicForm.space, params._pc, entry.id, status);
        let url;
        if (routeParams.space) {
            url = '../' + subpath + dynamicForm.space + '/' + subform.refFormId + "/" + this.configService.env.currentLang;
        }
        else {
            url = './' + subpath + subform.refFormId + "/" + this.configService.env.currentLang;
        }
        this.router.navigate([url], {
            queryParams: params
        });
    }
    /* ------------------------------------- */
    /*
      Function to open, from form array or multiple nested form, a collection item of an external form
    */
    openSubformItem(parentId, item, id, status, parentStatus, queryParams, dynamicForm, refFormId, subpath) {
        let params = {
            status: status
        };
        params._p = this.composeP(queryParams._p, item.metadata.ps, item.metadata.pc, item.metadata.pid, parentStatus);
        params._pid = parentId;
        let url;
        if (subpath === '/') {
            url = '../../' + refFormId + '/' + id + "/" + this.configService.env.currentLang;
        }
        else {
            url = '/' + (subpath > '' ? '/' + subpath : '') + '/' + dynamicForm.space + '/' + refFormId + '/' + id + '/' + this.configService.env.currentLang;
        }
        this.router.navigate([url], {
            queryParams: params
        });
    }
    /* ------------------------------------- */
    getRedirectUrl(item, id, status, parentStatus, queryParams, dynamicForm, refFormId, subpath) {
        let params = {
            status: status
        };
        params._p = this.composeP(queryParams._p, item.metadata.ps, item.metadata.pc, item.metadata.pid, parentStatus);
        let url;
        url = subpath || '../../' + refFormId + '/' + id + "/" + this.configService.env.currentLang;
        return {
            url: url,
            queryParams: params
        };
    }
    composeP(_p, ps, pc, pid, status) {
        return (_p > "" ? _p + "," : "") + (ps + "@" + pc + "@" + pid + "@" + status);
    }
    /* ----------------------------------------------------------------------------------------------------------------------------------- */
    /* Single collection item operations                                                                                                   */
    /* ----------------------------------------------------------------------------------------------------------------------------------- */
    saveFormData(space, collection, payload) {
        payload.space = space;
        payload.collection = collection;
        return this.searchService.post(this.configService.env.servicesUrl + '/collection/' + space + '/' + collection + '/documents', payload);
    }
    updateFormData(space, collection, payload, alias, status) {
        payload.space = space;
        payload.collection = collection;
        return this.searchService.put(this.configService.env.servicesUrl + '/collection/' + space + '/' + collection + '/documents' + '/' + alias + '/status/' + status, payload);
    }
    deleteFormData(space, collection, alias, status) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/collection/' + space + '/' + collection + '/documents' + '/' + alias + '/status/' + status);
    }
    statusChange(space, collection, id, oldStatus, newStatus, note) {
        return this.searchService.post(this.configService.env.servicesUrl + '/collection/' + space + '/' + collection + '/documents/' + id + '/status/' + oldStatus + '/update/' + newStatus, note);
    }
    /* ----------------------------------------------------------------------------------------------------------------------------------- */
    /* ----------------------------------------------------------------------------------------------------------------------------------- */
    /* Bulk operations                                                                                                                     */
    /* ----------------------------------------------------------------------------------------------------------------------------------- */
    saveBulkFormData(space, collection, payload) {
        payload.space = space;
        payload.collection = collection;
        return this.searchService.post(this.configService.env.servicesUrl + '/collection/' + space + '/' + collection + '/documents/bulk', payload);
    }
    updateBulkFormData(space, collection, payload) {
        payload.space = space;
        payload.collection = collection;
        return this.searchService.put(this.configService.env.servicesUrl + '/collection/' + space + '/' + collection + '/documents/bulk', payload);
    }
    deleteBulkFormData(space, collection, payload) {
        return this.searchService.delete(this.configService.env.servicesUrl + '/collection/' + space + '/' + collection + '/documents/bulk');
    }
    static { this.ɵfac = function FormDataService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormDataService)(i0.ɵɵinject(i1.SearchService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i1.DynamicFormControlService), i0.ɵɵinject(i3$2.MessageService), i0.ɵɵinject(i1.ConfigurationService), i0.ɵɵinject(i2.ActivatedRoute)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FormDataService, factory: FormDataService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormDataService, [{
        type: Injectable
    }], () => [{ type: i1.SearchService }, { type: i2.Router }, { type: i1.DynamicFormControlService }, { type: i3$2.MessageService }, { type: i1.ConfigurationService }, { type: i2.ActivatedRoute }], null); })();

function DynamicFormArrayView_p_fieldset_0_ng_template_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementEnd();
} }
function DynamicFormArrayView_p_fieldset_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormArrayView_p_fieldset_0_ng_template_1_span_3_Template, 2, 0, "span", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.required);
} }
function DynamicFormArrayView_p_fieldset_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵelement(2, "html-renderer", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("template", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "quickhelp"));
} }
function DynamicFormArrayView_p_fieldset_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "debug-details", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", ctx_r1.dynamicFormObject)("data", ctx_r1.form.getRawValue())("xpath", ctx_r1.xpath);
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_5_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 21);
    i0.ɵɵlistener("click", function DynamicFormArrayView_p_fieldset_0_ng_container_5_li_2_Template_a_click_1_listener() { const item_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.openSubformItem(item_r4, item_r4.metadata.id, item_r4.status)); });
    i0.ɵɵelement(2, "i", 22);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.dynamicFormControlService.getHeader(ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, ctx_r1.getItemDataObject(ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject)[0].code, item_r4.document), ctx_r1.xpath, null, item_r4.status, ctx_r1.statuses));
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 19);
    i0.ɵɵtemplate(2, DynamicFormArrayView_p_fieldset_0_ng_container_5_li_2_Template, 5, 1, "li", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.items);
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "button", 30);
    i0.ɵɵlistener("click", function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_div_1_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r5); const arrayGroupElementIndex_r6 = i0.ɵɵnextContext().index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.removeFormArrayElement(arrayGroupElementIndex_r6)); });
    i0.ɵɵelement(2, "i", 31);
    i0.ɵɵelementEnd()();
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_div_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const arrayGroupElementIndex_r6 = i0.ɵɵnextContext().index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.dynamicFormControlService.getHeader(ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, ctx_r1.form.controls[ctx_r1.dynamicFormObject.code]["controls"][arrayGroupElementIndex_r6].value, null));
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r7 = ctx.$implicit;
    const arrayGroupElement_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", child_r7.type === "separator" ? "separator" : "")("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", child_r7)("parentDynamicFormObject", ctx_r1.dynamicFormObject)("form", arrayGroupElement_r8)("parentForm", ctx_r1.parentForm)("operation", ctx_r1.operation)("debug", ctx_r1.debug)("xpath", ctx_r1.xpath)("readonly", ctx_r1.readonly)("hideLabel", ctx_r1.hideLabel);
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "form-errors-manager", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const arrayGroupElement_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("errors", arrayGroupElement_r8.errors)("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", ctx_r1.dynamicFormObject);
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_div_1_div_1_Template, 3, 0, "div", 26);
    i0.ɵɵelementStart(2, "div", 27)(3, "p-panel", 28);
    i0.ɵɵtemplate(4, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_div_1_ng_template_4_Template, 3, 1, "ng-template", 2)(5, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_div_1_div_5_Template, 2, 11, "div", 20)(6, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_div_1_div_6_Template, 2, 3, "div", 5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const arrayGroupElement_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.readonly || ctx_r1.operation === "edit" && !ctx_r1.dynamicFormObject.editBlocked);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("toggleable", true)("collapsed", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", arrayGroupElement_r8.errors);
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_div_1_Template, 7, 5, "div", 24);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code]["controls"]);
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 41);
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41)(1, "div", 3)(2, "div", 42)(3, "div", 43)(4, "label", 44);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const child_r9 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", child_r9.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, child_r9, "label"), "");
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48)(1, "button", 30);
    i0.ɵɵlistener("click", function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_div_6_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r10); const arrayGroupElementIndex_r11 = i0.ɵɵnextContext().index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.removeFormArrayElement(arrayGroupElementIndex_r11)); });
    i0.ɵɵelement(2, "i", 31);
    i0.ɵɵelementEnd()();
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r12 = ctx.$implicit;
    const arrayGroupElement_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", child_r12.type === "separator" ? "separator" : "")("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", child_r12)("parentDynamicFormObject", ctx_r1.dynamicFormObject)("form", arrayGroupElement_r13)("parentForm", ctx_r1.parentForm)("operation", ctx_r1.operation)("debug", ctx_r1.debug)("xpath", ctx_r1.xpath)("readonly", ctx_r1.readonly)("hideLabel", true);
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtemplate(1, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_div_6_div_1_Template, 3, 0, "div", 46)(2, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_div_6_div_2_Template, 2, 11, "div", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.readonly || ctx_r1.operation === "edit" && !ctx_r1.dynamicFormObject.editBlocked);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 25);
    i0.ɵɵelementStart(1, "div", 35)(2, "div", 36);
    i0.ɵɵtemplate(3, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_div_3_Template, 1, 0, "div", 37)(4, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_div_4_Template, 6, 2, "div", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 39);
    i0.ɵɵtemplate(6, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_div_6_Template, 3, 2, "div", 40);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.readonly || ctx_r1.operation === "edit" && !ctx_r1.dynamicFormObject.editBlocked);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code]["controls"]);
} }
function DynamicFormArrayView_p_fieldset_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_1_Template, 2, 1, "ng-container", 5)(2, DynamicFormArrayView_p_fieldset_0_ng_container_6_ng_container_2_Template, 7, 3, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.dynamicFormObject.format || ctx_r1.dynamicFormObject.format === "vertical" || ctx_r1.dynamicFormObject.format === "float");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.format === "horizontal");
} }
function DynamicFormArrayView_p_fieldset_0_p_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 50);
    i0.ɵɵlistener("click", function DynamicFormArrayView_p_fieldset_0_p_button_9_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.showHelp(ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help"))); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function DynamicFormArrayView_p_fieldset_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-fieldset", 1);
    i0.ɵɵtemplate(1, DynamicFormArrayView_p_fieldset_0_ng_template_1_Template, 4, 2, "ng-template", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, DynamicFormArrayView_p_fieldset_0_div_3_Template, 3, 1, "div", 4)(4, DynamicFormArrayView_p_fieldset_0_div_4_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DynamicFormArrayView_p_fieldset_0_ng_container_5_Template, 3, 1, "ng-container", 5)(6, DynamicFormArrayView_p_fieldset_0_ng_container_6_Template, 3, 2, "ng-container", 5);
    i0.ɵɵelementStart(7, "div", 6)(8, "div", 7);
    i0.ɵɵtemplate(9, DynamicFormArrayView_p_fieldset_0_p_button_9_Template, 1, 2, "p-button", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 9)(11, "p-button", 10);
    i0.ɵɵlistener("click", function DynamicFormArrayView_p_fieldset_0_Template_p_button_click_11_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.addFormArrayElement()); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("collapsed", ctx_r1.dynamicFormObject.collapsed)("toggleable", true)("formGroup", ctx_r1.form)("ngClass", ctx_r1.dynamicForm.cssClass && ctx_r1.dynamicForm.cssClass.group || ctx_r1.dynamicFormObject.cssClass);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "quickhelp") > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.debug);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isExternalForm() && ctx_r1.items);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isExternalForm());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help") > "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("rounded", true);
} }
class DynamicFormArrayView {
    constructor(dynamicFormService, dynamicFormControlService, datePipe, dialogService, router, route, formDataService, confirmationService, searchService) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.datePipe = datePipe;
        this.dialogService = dialogService;
        this.router = router;
        this.route = route;
        this.formDataService = formDataService;
        this.confirmationService = confirmationService;
        this.searchService = searchService;
        this.debug = false;
        this.readonly = false;
        this.nextForm = new EventEmitter();
    }
    ngOnInit() {
        this.xpath = this.dynamicFormControlService.getXpath(this.dynamicFormObject, this.xpath);
        if (this.router.url.includes('reporting')) {
            this.subpath = '/reporting/';
        }
        else {
            this.subpath = '/';
        }
        if (this.isExternalForm()) {
            let children = this.dynamicFormService.getComponentChildren(this.dynamicFormObject);
            let status;
            if (this.statuses && this.statuses.status && this.statuses.status.length > 0) {
                status = this.statuses.status.map(e => {
                    return e.name;
                }).toString();
            }
            this.route.queryParams.subscribe(params => {
                this.queryParams = params;
                this.searchService.searchCollectionItems(this.dynamicForm.space, children[0].refFormId, [new StandardSearchParameter('metadata.pid', this.parentForm.getRawValue().id)], 10000, 0, null, null, ['document', 'metadata', 'status'], null, status).subscribe(res => {
                    this.items = res.results ? res.results.values : [];
                }, err => {
                    this.searchService.manageError(err, 'Error extracting children for ' + this.parentForm.getRawValue().id);
                });
            });
        }
    }
    getItemDataObject(code, item) {
        let data = {};
        data[code] = item;
        return data;
    }
    isExternalForm() {
        let children = this.dynamicFormService.getComponentChildren(this.dynamicFormObject);
        return (children.length === 1 && children[0].type === 'form' && children[0].refFormType === 'external');
    }
    addFormArrayElement() {
        let fa = this.form.controls[this.dynamicFormObject.code];
        let children = this.dynamicFormService.getComponentChildren(this.dynamicFormObject);
        if (children.length === 1 && children[0].type === 'form' && children[0].refFormType === 'external') {
            if (this.parentForm.dirty) {
                this.confirmationService.confirm({
                    message: 'Please save the form before adding a new subform item',
                    key: 'data-editor',
                    rejectVisible: false,
                    acceptLabel: 'Ok'
                });
                return;
            }
            else {
                this.nextForm.emit({
                    dynamicForm: this.dynamicForm,
                    entry: this.parentForm.getRawValue(),
                    subpath: this.subpath,
                    subform: children[0],
                    parent: this.parentDynamicFormObject,
                    _p: this.queryParams._p
                });
            }
        }
        else {
            let f = this.dynamicFormControlService.formObjectsToFormGroup(this.dynamicForm, this.operation, children, null, this.xpath);
            fa.push(f);
        }
    }
    removeFormArrayElement(i) {
        let fa = this.form.controls[this.dynamicFormObject.code];
        fa.removeAt(i);
    }
    openSubformItem(item, id, status) {
        let children = this.dynamicFormService.getComponentChildren(this.dynamicFormObject);
        if (children.length === 1 && children[0].type === 'form' && children[0].refFormType === 'external') {
            this.formDataService.openSubformItem(this.parentForm.getRawValue().id, item, id, status, this.status, this.queryParams, this.dynamicForm, children[0].refFormId, this.subpath);
        }
    }
    showHelp(description) {
        const ref = this.dialogService.open(HelpComponent, {
            data: {
                description: description
            },
            header: 'Help',
            width: '50%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    static { this.ɵfac = function DynamicFormArrayView_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormArrayView)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i3.DatePipe), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(i1.SearchService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormArrayView, selectors: [["dynamic-form-array-view"]], inputs: { group: "group", statuses: "statuses", status: "status", dynamicForm: "dynamicForm", parentDynamicForm: "parentDynamicForm", parentDynamicFormObject: "parentDynamicFormObject", dynamicFormObject: "dynamicFormObject", form: "form", parentForm: "parentForm", debug: "debug", readonly: "readonly", operation: "operation", xpath: "xpath", hideLabel: "hideLabel" }, outputs: { nextForm: "nextForm" }, standalone: false, features: [i0.ɵɵProvidersFeature([DynamicFormControlService])], decls: 1, vars: 1, consts: [[3, "collapsed", "toggleable", "formGroup", "ngClass", 4, "ngIf"], [3, "collapsed", "toggleable", "formGroup", "ngClass"], ["pTemplate", "header"], [1, "row"], ["class", "col-md-12 mt-2 mb-2", 4, "ngIf"], [4, "ngIf"], [1, "row", "mt-3"], [1, "col-md-6"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "rounded", "outlined", "click", 4, "ngIf"], [1, "col-md-6", "align-right"], ["icon", "pi pi-plus", 3, "click", "rounded"], [1, "flex", "align-items-center"], ["class", "mandatory", 4, "ngIf"], [1, "mandatory"], [1, "bi", "bi-asterisk"], [1, "col-md-12", "mt-2", "mb-2"], [1, "form-control-footer", "text-color-gray-medium"], [3, "template"], [3, "dynamicForm", "dynamicFormObject", "data", "xpath"], [1, "array-items"], [4, "ngFor", "ngForOf"], ["href", "javascript:", 1, "link-icon", 3, "click"], [1, "bi", "bi-file-earmark-text"], ["class", "form-array-item", 4, "ngIf"], ["class", "form-array-item", 4, "ngFor", "ngForOf"], [1, "form-array-item"], ["class", "form-array-item-actions", 4, "ngIf"], [1, "form-array-item-content"], [3, "toggleable", "collapsed"], [1, "form-array-item-actions"], ["title", "Remove item", "type", "button", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-trash"], [1, "form-array-item-header"], [3, "ngClass", "dynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "debug", "xpath", "readonly", "hideLabel"], [3, "errors", "dynamicForm", "dynamicFormObject"], [1, "layout-table"], [1, "layout-table-header"], ["class", "layout-table-header-item", 4, "ngIf"], ["class", "layout-table-header-item", 4, "ngFor", "ngForOf"], [1, "layout-table-body"], ["class", "layout-table-row", 4, "ngFor", "ngForOf"], [1, "layout-table-header-item"], [1, "col-md-12"], [1, "component-header"], [1, "component-label", "text-color-gray-medium", "horizontal", 3, "id"], [1, "layout-table-row"], ["class", "layout-table-cell buttons", 4, "ngIf"], ["class", "layout-table-cell", 4, "ngFor", "ngForOf"], [1, "layout-table-cell", "buttons"], [1, "layout-table-cell"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "click", "rounded", "outlined"]], template: function DynamicFormArrayView_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicFormArrayView_p_fieldset_0_Template, 12, 10, "p-fieldset", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.dynamicFormObject.multipleValues);
        } }, styles: [".effect[_ngcontent-%COMP%]{opacity:1;animation:_ngcontent-%COMP%_fade 5s linear}@keyframes _ngcontent-%COMP%_fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator[_ngcontent-%COMP%]{width:100%}.form-check-label[_ngcontent-%COMP%]{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items[_ngcontent-%COMP%]{list-style:none;font-size:.9rem}.help-button[_ngcontent-%COMP%]{margin:5px}.help-button[_ngcontent-%COMP%]:hover{cursor:pointer}.component-header[_ngcontent-%COMP%]{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{margin-left:10px}.form-control-footer[_ngcontent-%COMP%]{font-size:.8em}.mandatory[_ngcontent-%COMP%]{font-size:50%;vertical-align:top;color:red}.app-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}.header-title[_ngcontent-%COMP%]:hover{cursor:pointer}.status-label[_ngcontent-%COMP%]{font-size:1em;font-weight:700}.component-label[_ngcontent-%COMP%]{font-size:1em}.component-label.horizontal[_ngcontent-%COMP%], label.title-category[_ngcontent-%COMP%]{font-size:.9em}.float[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.panel-body[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading[_ngcontent-%COMP%]{min-height:45px;display:flex}.panel-heading[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-height:40px}.multiple-values-item[_ngcontent-%COMP%]{display:flex;flex-grow:1}.multiple-values-item-content[_ngcontent-%COMP%]{width:95%}.multiple-values-item-body[_ngcontent-%COMP%]{width:95%;margin-bottom:5px}.array-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:.9em}.header-title[_ngcontent-%COMP%]{vertical-align:middle}.card[_ngcontent-%COMP%]{margin-bottom:.5em}.refresh-button[_ngcontent-%COMP%]{margin:.5em}.refresh-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ref-form[_ngcontent-%COMP%]{display:flex;align-items:baseline}img[_ngcontent-%COMP%]{max-width:100%;height:auto}.collapse[_ngcontent-%COMP%]{display:none!important}.collapse.in[_ngcontent-%COMP%]{display:block!important}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form[_ngcontent-%COMP%]   .p-fieldset[_ngcontent-%COMP%]   .p-fieldset-legend[_ngcontent-%COMP%]{font-size:.8em!important}.dynamic-form-summary-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%]{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{margin-left:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%], .dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-icon[_ngcontent-%COMP%]{font-size:20px!important}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.control-cell.content[_ngcontent-%COMP%]{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu[_ngcontent-%COMP%]{width:55px}.form-group[_ngcontent-%COMP%]{border:solid 1px rgba(0,0,0,.125);margin:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormArrayView, [{
        type: Component,
        args: [{ selector: 'dynamic-form-array-view', providers: [DynamicFormControlService], standalone: false, template: "<p-fieldset [collapsed]=\"dynamicFormObject.collapsed\" [toggleable]=\"true\" *ngIf=\"!dynamicFormObject.multipleValues\" [formGroup]=\"form\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n\r\n  <ng-template pTemplate=\"header\">\r\n    <div class=\"flex align-items-center\">\r\n      <label>{{dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label')}}</label>\r\n      <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n      <div class=\"form-control-footer text-color-gray-medium\">\r\n        <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n      <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\" [xpath]=\"xpath\"></debug-details>\r\n    </div>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"isExternalForm() && items\">\r\n    <ul class=\"array-items\">\r\n      <li *ngFor=\"let item of items\">\r\n          <a href=\"javascript:\" (click)=\"openSubformItem(item,item.metadata.id,item.status)\" class=\"link-icon\">\r\n            <i class=\"bi bi-file-earmark-text\"></i><span>{{ dynamicFormControlService.getHeader(dynamicForm, dynamicFormObject,getItemDataObject(dynamicFormService.getComponentChildren(dynamicFormObject)[0].code, item.document), xpath, null, item.status, statuses) }}</span>\r\n          </a>\r\n      </li>\r\n    </ul>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"!isExternalForm()\">\r\n\r\n      <!-- Vertical layout -->\r\n      <ng-container *ngIf=\"(!dynamicFormObject.format) || dynamicFormObject.format === 'vertical' || dynamicFormObject.format === 'float'\">\r\n        <div class=\"form-array-item\"\r\n          *ngFor=\"let arrayGroupElement of form.controls[dynamicFormObject.code]['controls']; let arrayGroupElementIndex=index\">\r\n          <div class=\"form-array-item-actions\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n            <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n              (click)=\"removeFormArrayElement(arrayGroupElementIndex)\">\r\n              <i class=\"bi bi-trash\"></i>\r\n            </button>\r\n          </div>\r\n          <div class=\"form-array-item-content\">\r\n\r\n            <p-panel [toggleable]=\"true\" [collapsed]=\"true\">\r\n              <ng-template pTemplate=\"header\">\r\n                <!-- <span>[{{ arrayGroupElementIndex }}]&nbsp;</span> -->\r\n                <div class=\"form-array-item-header\"><label>{{ dynamicFormControlService.getHeader(dynamicForm, dynamicFormObject, form.controls[dynamicFormObject.code]['controls'][arrayGroupElementIndex].value,null) }}</label></div>\r\n              </ng-template>\r\n        \r\n              <div *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n                <dynamic-form-switcher-view \r\n                  [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n                  [dynamicForm]=\"dynamicForm\" \r\n                  [dynamicFormObject]=\"child\" \r\n                  [parentDynamicFormObject]=\"dynamicFormObject\" \r\n                  [form]=\"arrayGroupElement\" \r\n                  [parentForm]=\"parentForm\"\r\n                  [operation]=\"operation\"\r\n                  [debug]=\"debug\"\r\n                  [xpath]=\"xpath\"\r\n                  [readonly]=\"readonly\"\r\n                  [hideLabel]=\"hideLabel\">\r\n                </dynamic-form-switcher-view>                \r\n              </div>\r\n    \r\n              <div *ngIf=\"arrayGroupElement.errors\">\r\n                <form-errors-manager [errors]=\"arrayGroupElement.errors\" [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\"></form-errors-manager>\r\n              </div>\r\n    \r\n            </p-panel>\r\n\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <!-- Horizontal layout -->\r\n      <ng-container *ngIf=\"dynamicFormObject.format === 'horizontal'\" class=\"form-array-item\">\r\n        <div class=\"layout-table\">\r\n          <div class=\"layout-table-header\">\r\n            <div class=\"layout-table-header-item\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n\r\n            </div>\r\n            <div class=\"layout-table-header-item\"  *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"component-header\">\r\n                    <label class=\"component-label text-color-gray-medium horizontal\" [id]=\"child.pathId\"> {{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, child, 'label') }}</label>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"layout-table-body\">\r\n            <div class=\"layout-table-row\" *ngFor=\"let arrayGroupElement of form.controls[dynamicFormObject.code]['controls']; let arrayGroupElementIndex=index\">\r\n              <div class=\"layout-table-cell buttons\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n                <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n                  (click)=\"removeFormArrayElement(arrayGroupElementIndex)\">\r\n                  <i class=\"bi bi-trash\"></i>\r\n                </button>\r\n              </div>\r\n              <div class=\"layout-table-cell\" *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n                <dynamic-form-switcher-view \r\n                  [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n                  [dynamicForm]=\"dynamicForm\" \r\n                  [dynamicFormObject]=\"child\" \r\n                  [parentDynamicFormObject]=\"dynamicFormObject\" \r\n                  [form]=\"arrayGroupElement\" \r\n                  [parentForm]=\"parentForm\"\r\n                  [operation]=\"operation\"\r\n                  [debug]=\"debug\"\r\n                  [xpath]=\"xpath\"\r\n                  [readonly]=\"readonly\"\r\n                  [hideLabel]=\"true\">\r\n                </dynamic-form-switcher-view>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n      \r\n  </ng-container>\r\n\r\n  <div class=\"row mt-3\">\r\n    <div class=\"col-md-6\">\r\n      <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\" title=\"Help\"\r\n        (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\"></p-button>\r\n    </div>\r\n    <div class=\"col-md-6 align-right\">\r\n      <p-button icon=\"pi pi-plus\" [rounded]=\"true\" (click)=\"addFormArrayElement()\"></p-button>\r\n    </div>\r\n  </div>\r\n\r\n</p-fieldset>", styles: [".effect{opacity:1;animation:fade 5s linear}@keyframes fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator{width:100%}.form-check-label{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items{list-style:none;font-size:.9rem}.help-button{margin:5px}.help-button:hover{cursor:pointer}.component-header{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header .header-title{margin-left:10px}.form-control-footer{font-size:.8em}.mandatory{font-size:50%;vertical-align:top;color:red}.app-menu-disabled{pointer-events:none;opacity:.6}.header-title:hover{cursor:pointer}.status-label{font-size:1em;font-weight:700}.component-label{font-size:1em}.component-label.horizontal,label.title-category{font-size:.9em}.float{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float>*{margin-left:5px;margin-right:5px}.panel-body{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading{min-height:45px;display:flex}.panel-heading .header-title{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading button{max-height:40px}.multiple-values-item{display:flex;flex-grow:1}.multiple-values-item-content{width:95%}.multiple-values-item-body{width:95%;margin-bottom:5px}.array-items button{font-size:.9em}.header-title{vertical-align:middle}.card{margin-bottom:.5em}.refresh-button{margin:.5em}.refresh-button:hover{cursor:pointer}.ref-form{display:flex;align-items:baseline}img{max-width:100%;height:auto}.collapse{display:none!important}.collapse.in{display:block!important}.collapsing{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form .p-fieldset .p-fieldset-legend{font-size:.8em!important}.dynamic-form-summary-view{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view .form-tree{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view .form-questions{margin-left:5px}.dynamic-form-summary-view .form-tree,.dynamic-form-summary-view .form-questions{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form{width:100%}form .item-icon{font-size:20px!important}form .item-switcher{width:100%}form .item-switcher>div{width:100%}.control-cell.content{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu{width:55px}.form-group{border:solid 1px rgba(0,0,0,.125);margin:1em}\n"] }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i3.DatePipe }, { type: i1$1.DialogService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: FormDataService }, { type: i3$2.ConfirmationService }, { type: i1.SearchService }], { group: [{
            type: Input
        }], statuses: [{
            type: Input
        }], status: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], parentDynamicForm: [{
            type: Input
        }], parentDynamicFormObject: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], form: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], debug: [{
            type: Input
        }], readonly: [{
            type: Input
        }], operation: [{
            type: Input
        }], xpath: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], nextForm: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormArrayView, { className: "DynamicFormArrayView", filePath: "src/dynamic-form/dynamic-form-array/dynamic-form-array.ts", lineNumber: 27 }); })();

function DynamicFormCheckboxlistView_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵelement(1, "i", 10);
    i0.ɵɵelementEnd();
} }
function DynamicFormCheckboxlistView_div_0_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵlistener("click", function DynamicFormCheckboxlistView_div_0_a_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.showHelp(ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help"))); });
    i0.ɵɵelement(1, "i", 12);
    i0.ɵɵelementEnd();
} }
function DynamicFormCheckboxlistView_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "input", 14);
    i0.ɵɵlistener("change", function DynamicFormCheckboxlistView_div_0_div_6_Template_input_change_1_listener($event) { const opt_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onCheckboxChange($event, opt_r4)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const opt_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.dynamicForm.cssClass && ctx_r1.dynamicForm.cssClass.checkboxlist || ctx_r1.dynamicFormObject.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r1.dynamicFormObject.pathId + "_" + i_r5);
    i0.ɵɵproperty("readonly", ctx_r1.readonly)("name", ctx_r1.dynamicFormObject.code)("checked", ctx_r1.isChecked(opt_r4.value));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("for", ctx_r1.dynamicFormObject.pathId + "_" + i_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.optionsService.getOptionLabel(opt_r4), " ");
} }
function DynamicFormCheckboxlistView_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "html-renderer", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("template", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "quickhelp"));
} }
function DynamicFormCheckboxlistView_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "debug-details", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", ctx_r1.dynamicFormObject)("data", ctx_r1.form.getRawValue())("xpath", ctx_r1.xpath);
} }
function DynamicFormCheckboxlistView_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "label", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, DynamicFormCheckboxlistView_div_0_span_4_Template, 2, 0, "span", 4)(5, DynamicFormCheckboxlistView_div_0_a_5_Template, 2, 0, "a", 5)(6, DynamicFormCheckboxlistView_div_0_div_6_Template, 4, 7, "div", 6)(7, DynamicFormCheckboxlistView_div_0_div_7_Template, 2, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, DynamicFormCheckboxlistView_div_0_div_8_Template, 2, 4, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r1.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "label"), "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help") > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.items);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "quickhelp") > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.debug);
} }
class DynamicFormCheckboxlistView {
    constructor(dynamicFormService, dynamicFormControlService, dialogService, optionsService, confirmationService, searchService) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.dialogService = dialogService;
        this.optionsService = optionsService;
        this.confirmationService = confirmationService;
        this.searchService = searchService;
        this.debug = false;
        this.readonly = false;
        this.expanded = false;
    }
    async ngOnInit() {
        this.xpath = this.dynamicFormControlService.getXpath(this.dynamicFormObject, this.xpath);
        if (this.dynamicFormObject.refOptionsId) {
            this.getOptions();
        }
    }
    getOptions() {
        let index = this.dynamicForm.options.findIndex(item => item.id === this.dynamicFormObject.refOptionsId);
        if (index >= 0) {
            if (this.dynamicForm.options[index].type === 'reference' || this.dynamicForm.options[index].type === 'standard' || this.dynamicForm.options[index].type === 'external') {
                this.optionsService.getRemoteItems(this.statuses, this.dynamicFormControlService, this.dynamicForm, this.dynamicFormObject, this.parentForm, this.dynamicForm.options[index], this.dynamicFormObject.refOptionsFilters).subscribe(res => {
                    this.items = this.optionsService.mapRemoteItems(this.dynamicForm.options[index], res, this.dynamicFormObject.refOptionsMappings);
                }, err => {
                    this.searchService.manageError(err, 'Error reading ' + this.dynamicForm.options[index].type + ' items');
                });
            }
            else {
                this.items = [];
            }
        }
    }
    itemsLoaded() {
        let index = this.dynamicForm.options.findIndex(item => item.id === this.dynamicFormObject.refOptionsId);
        if (index >= 0) {
            if (this.dynamicForm.options[index].items) {
                return true;
            }
        }
        return false;
    }
    showHelp(description) {
        const ref = this.dialogService.open(HelpComponent, {
            data: {
                description: description
            },
            header: 'Help',
            width: '50%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    onCheckboxChange(event, opt) {
        if (event.target.checked) {
            this.addFormArrayElement(opt);
        }
        else {
            this.removeFormArrayElement(opt);
        }
    }
    addFormArrayElement(opt) {
        let fa = this.form;
        let group = {};
        for (let key in opt) {
            group[key] = new UntypedFormControl(opt[key]);
        }
        let f = new FormGroup(group);
        fa.push(f);
    }
    removeFormArrayElement(opt) {
        let fa = this.form;
        let index = fa.controls.findIndex((item) => item.controls['value'].value === opt.value);
        if (index >= 0) {
            fa.removeAt(index);
        }
    }
    isChecked(value) {
        let index = this.form.getRawValue().findIndex(item => item.value === value);
        return index >= 0;
    }
    static { this.ɵfac = function DynamicFormCheckboxlistView_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormCheckboxlistView)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.OptionsService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(i1.SearchService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormCheckboxlistView, selectors: [["dynamic-form-checkboxlist-view"]], inputs: { group: "group", dynamicForm: "dynamicForm", parentDynamicForm: "parentDynamicForm", dynamicFormObject: "dynamicFormObject", parentDynamicFormObject: "parentDynamicFormObject", form: "form", parentForm: "parentForm", debug: "debug", statuses: "statuses", readonly: "readonly", operation: "operation", xpath: "xpath", hideLabel: "hideLabel" }, standalone: false, decls: 1, vars: 1, consts: [["class", "row", 3, "formGroup", 4, "ngIf"], [1, "row", 3, "formGroup"], [1, "col-md-12"], [1, "component-label", "text-color-gray-dark", 3, "id"], ["class", "mandatory", 4, "ngIf"], ["class", "help-button", "title", "Help", 3, "click", 4, "ngIf"], ["class", "form-check", 3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "form-control-footer text-color-gray-medium", 4, "ngIf"], ["class", "col-md-12 mt-2 mb-2", 4, "ngIf"], [1, "mandatory"], [1, "bi", "bi-asterisk"], ["title", "Help", 1, "help-button", 3, "click"], [1, "bi", "bi-question-circle"], [1, "form-check", 3, "ngClass"], ["type", "checkbox", 1, "form-check-input", 3, "change", "readonly", "name", "id", "checked"], [3, "for"], [1, "form-control-footer", "text-color-gray-medium"], [3, "template"], [1, "col-md-12", "mt-2", "mb-2"], [3, "dynamicForm", "dynamicFormObject", "data", "xpath"]], template: function DynamicFormCheckboxlistView_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicFormCheckboxlistView_div_0_Template, 9, 8, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.itemsLoaded);
        } }, styles: [".effect[_ngcontent-%COMP%]{opacity:1;animation:_ngcontent-%COMP%_fade 5s linear}@keyframes _ngcontent-%COMP%_fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator[_ngcontent-%COMP%]{width:100%}.form-check-label[_ngcontent-%COMP%]{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items[_ngcontent-%COMP%]{list-style:none;font-size:.9rem}.help-button[_ngcontent-%COMP%]{margin:5px}.help-button[_ngcontent-%COMP%]:hover{cursor:pointer}.component-header[_ngcontent-%COMP%]{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{margin-left:10px}.form-control-footer[_ngcontent-%COMP%]{font-size:.8em}.mandatory[_ngcontent-%COMP%]{font-size:50%;vertical-align:top;color:red}.app-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}.header-title[_ngcontent-%COMP%]:hover{cursor:pointer}.status-label[_ngcontent-%COMP%]{font-size:1em;font-weight:700}.component-label[_ngcontent-%COMP%]{font-size:1em}.component-label.horizontal[_ngcontent-%COMP%], label.title-category[_ngcontent-%COMP%]{font-size:.9em}.float[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.panel-body[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading[_ngcontent-%COMP%]{min-height:45px;display:flex}.panel-heading[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-height:40px}.multiple-values-item[_ngcontent-%COMP%]{display:flex;flex-grow:1}.multiple-values-item-content[_ngcontent-%COMP%]{width:95%}.multiple-values-item-body[_ngcontent-%COMP%]{width:95%;margin-bottom:5px}.array-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:.9em}.header-title[_ngcontent-%COMP%]{vertical-align:middle}.card[_ngcontent-%COMP%]{margin-bottom:.5em}.refresh-button[_ngcontent-%COMP%]{margin:.5em}.refresh-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ref-form[_ngcontent-%COMP%]{display:flex;align-items:baseline}img[_ngcontent-%COMP%]{max-width:100%;height:auto}.collapse[_ngcontent-%COMP%]{display:none!important}.collapse.in[_ngcontent-%COMP%]{display:block!important}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form[_ngcontent-%COMP%]   .p-fieldset[_ngcontent-%COMP%]   .p-fieldset-legend[_ngcontent-%COMP%]{font-size:.8em!important}.dynamic-form-summary-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%]{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{margin-left:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%], .dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-icon[_ngcontent-%COMP%]{font-size:20px!important}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.control-cell.content[_ngcontent-%COMP%]{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu[_ngcontent-%COMP%]{width:55px}.form-group[_ngcontent-%COMP%]{border:solid 1px rgba(0,0,0,.125);margin:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormCheckboxlistView, [{
        type: Component,
        args: [{ selector: 'dynamic-form-checkboxlist-view', standalone: false, template: "<div [formGroup]=\"$any(form)\" class=\"row\" *ngIf=\"itemsLoaded\">  \r\n  <div class=\"col-md-12\">\r\n    <label class=\"component-label text-color-gray-dark\" [id]=\"dynamicFormObject.pathId\"> {{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label') }}</label>\r\n    <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n    <a *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\" class=\"help-button\" title=\"Help\" (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\" >\r\n      <i class=\"bi bi-question-circle\"></i>\r\n    </a>\r\n\r\n    <div class=\"form-check\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.checkboxlist) || dynamicFormObject.cssClass\" *ngFor=\"let opt of items; let i = index\">\r\n      <input [readonly]=\"readonly\" class=\"form-check-input\" type=\"checkbox\" [name]=\"dynamicFormObject.code\" id=\"{{dynamicFormObject.pathId + '_' + i}}\" (change)=\"onCheckboxChange($event,opt)\" [checked]=\"isChecked(opt.value)\">\r\n      <label for=\"{{dynamicFormObject.pathId + '_' + i}}\">\r\n        {{ optionsService.getOptionLabel(opt) }}\r\n      </label>\r\n    </div>\r\n    \r\n    <div class=\"form-control-footer text-color-gray-medium\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n      <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n    <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\" [xpath]=\"xpath\"></debug-details>\r\n  </div>\r\n</div>", styles: [".effect{opacity:1;animation:fade 5s linear}@keyframes fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator{width:100%}.form-check-label{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items{list-style:none;font-size:.9rem}.help-button{margin:5px}.help-button:hover{cursor:pointer}.component-header{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header .header-title{margin-left:10px}.form-control-footer{font-size:.8em}.mandatory{font-size:50%;vertical-align:top;color:red}.app-menu-disabled{pointer-events:none;opacity:.6}.header-title:hover{cursor:pointer}.status-label{font-size:1em;font-weight:700}.component-label{font-size:1em}.component-label.horizontal,label.title-category{font-size:.9em}.float{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float>*{margin-left:5px;margin-right:5px}.panel-body{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading{min-height:45px;display:flex}.panel-heading .header-title{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading button{max-height:40px}.multiple-values-item{display:flex;flex-grow:1}.multiple-values-item-content{width:95%}.multiple-values-item-body{width:95%;margin-bottom:5px}.array-items button{font-size:.9em}.header-title{vertical-align:middle}.card{margin-bottom:.5em}.refresh-button{margin:.5em}.refresh-button:hover{cursor:pointer}.ref-form{display:flex;align-items:baseline}img{max-width:100%;height:auto}.collapse{display:none!important}.collapse.in{display:block!important}.collapsing{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form .p-fieldset .p-fieldset-legend{font-size:.8em!important}.dynamic-form-summary-view{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view .form-tree{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view .form-questions{margin-left:5px}.dynamic-form-summary-view .form-tree,.dynamic-form-summary-view .form-questions{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form{width:100%}form .item-icon{font-size:20px!important}form .item-switcher{width:100%}form .item-switcher>div{width:100%}.control-cell.content{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu{width:55px}.form-group{border:solid 1px rgba(0,0,0,.125);margin:1em}\n"] }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i1$1.DialogService }, { type: i1.OptionsService }, { type: i3$2.ConfirmationService }, { type: i1.SearchService }], { group: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], parentDynamicForm: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], parentDynamicFormObject: [{
            type: Input
        }], form: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], debug: [{
            type: Input
        }], statuses: [{
            type: Input
        }], readonly: [{
            type: Input
        }], operation: [{
            type: Input
        }], xpath: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormCheckboxlistView, { className: "DynamicFormCheckboxlistView", filePath: "src/dynamic-form/dynamic-form-checkboxlist/dynamic-form-checkboxlist.ts", lineNumber: 20 }); })();

function DynamicFormControlView_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵelement(2, "input", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code);
} }
function DynamicFormControlView_div_1_div_1_h4_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.label || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
} }
function DynamicFormControlView_div_1_div_1_h5_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.label || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
} }
function DynamicFormControlView_div_1_div_1_label_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.label || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
} }
function DynamicFormControlView_div_1_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.label || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId);
} }
function DynamicFormControlView_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, DynamicFormControlView_div_1_div_1_h4_1_Template, 2, 3, "h4", 13)(2, DynamicFormControlView_div_1_div_1_h5_2_Template, 2, 3, "h5", 14)(3, DynamicFormControlView_div_1_div_1_label_3_Template, 2, 3, "label", 15)(4, DynamicFormControlView_div_1_div_1_div_4_Template, 1, 2, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "title");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "subtitle");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "label");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "separator");
} }
function DynamicFormControlView_div_1_div_2_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementEnd();
} }
function DynamicFormControlView_div_1_div_2_div_1_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵlistener("click", function DynamicFormControlView_div_1_div_2_div_1_a_4_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelement(1, "i", 30);
    i0.ɵɵelementEnd();
} }
function DynamicFormControlView_div_1_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "label", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormControlView_div_1_div_2_div_1_span_3_Template, 2, 0, "span", 25)(4, DynamicFormControlView_div_1_div_2_div_1_a_4_Template, 2, 0, "a", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"), "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
} }
function DynamicFormControlView_div_1_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormControlView_div_1_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormControlView_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, DynamicFormControlView_div_1_div_2_div_1_Template, 5, 4, "div", 21)(2, DynamicFormControlView_div_1_div_2_ng_container_2_Template, 1, 0, "ng-container", 22)(3, DynamicFormControlView_div_1_div_2_ng_container_3_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const quickhelp_r3 = i0.ɵɵreference(3);
    const single_r4 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.hideLabel === false && ctx_r0.dynamicFormObject.type !== "truefalse" && ctx_r0.dynamicFormObject.type !== "checkbox");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", single_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", quickhelp_r3);
} }
function DynamicFormControlView_div_1_div_3_ng_container_1_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementEnd();
} }
function DynamicFormControlView_div_1_div_3_ng_container_1_div_1_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵlistener("click", function DynamicFormControlView_div_1_div_3_ng_container_1_div_1_a_4_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelement(1, "i", 30);
    i0.ɵɵelementEnd();
} }
function DynamicFormControlView_div_1_div_3_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "label", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormControlView_div_1_div_3_ng_container_1_div_1_span_3_Template, 2, 0, "span", 25)(4, DynamicFormControlView_div_1_div_3_ng_container_1_div_1_a_4_Template, 2, 0, "a", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"), "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
} }
function DynamicFormControlView_div_1_div_3_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormControlView_div_1_div_3_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormControlView_div_1_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormControlView_div_1_div_3_ng_container_1_div_1_Template, 5, 4, "div", 21)(2, DynamicFormControlView_div_1_div_3_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 22)(3, DynamicFormControlView_div_1_div_3_ng_container_1_ng_container_3_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    const quickhelp_r3 = i0.ɵɵreference(3);
    const single_r4 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.hideLabel === false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", single_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", quickhelp_r3);
} }
function DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_ng_template_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementEnd();
} }
function DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_ng_template_1_span_3_Template, 2, 0, "span", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
} }
function DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_p_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 41);
    i0.ɵɵlistener("click", function DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_p_button_6_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r0 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_p_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 42);
    i0.ɵɵlistener("click", function DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_p_button_8_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r0 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r0.addFormArrayElement()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true);
} }
function DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-fieldset", 33);
    i0.ɵɵtemplate(1, DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_ng_template_1_Template, 4, 2, "ng-template", 34)(2, DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_ng_container_2_Template, 1, 0, "ng-container", 22)(3, DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_ng_container_3_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementStart(4, "div", 35)(5, "div", 36);
    i0.ɵɵtemplate(6, DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_p_button_6_Template, 1, 2, "p-button", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 38);
    i0.ɵɵtemplate(8, DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_p_button_8_Template, 1, 1, "p-button", 39);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    const quickhelp_r3 = i0.ɵɵreference(3);
    const multiple_r8 = i0.ɵɵreference(7);
    i0.ɵɵproperty("collapsed", ctx_r0.dynamicFormObject.collapsed)("toggleable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", quickhelp_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", multiple_r8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly || ctx_r0.operation === "edit" && !ctx_r0.dynamicFormObject.editBlocked);
} }
function DynamicFormControlView_div_1_div_3_ng_container_2_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormControlView_div_1_div_3_ng_container_2_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormControlView_div_1_div_3_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormControlView_div_1_div_3_ng_container_2_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 22)(2, DynamicFormControlView_div_1_div_3_ng_container_2_ng_container_2_ng_container_2_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(4);
    const quickhelp_r3 = i0.ɵɵreference(3);
    const multiple_r8 = i0.ɵɵreference(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", quickhelp_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", multiple_r8);
} }
function DynamicFormControlView_div_1_div_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormControlView_div_1_div_3_ng_container_2_p_fieldset_1_Template, 9, 6, "p-fieldset", 32)(2, DynamicFormControlView_div_1_div_3_ng_container_2_ng_container_2_Template, 3, 2, "ng-container", 31);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.hideLabel === false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.hideLabel === true);
} }
function DynamicFormControlView_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, DynamicFormControlView_div_1_div_3_ng_container_1_Template, 4, 3, "ng-container", 31)(2, DynamicFormControlView_div_1_div_3_ng_container_2_Template, 3, 2, "ng-container", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "select");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type !== "select");
} }
function DynamicFormControlView_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelement(1, "debug-details", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("data", ctx_r0.form.getRawValue())("xpath", ctx_r0.xpath);
} }
function DynamicFormControlView_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "form-errors-manager", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("errors", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code].errors)("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject);
} }
function DynamicFormControlView_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, DynamicFormControlView_div_1_div_1_Template, 5, 4, "div", 9)(2, DynamicFormControlView_div_1_div_2_Template, 4, 3, "div", 10)(3, DynamicFormControlView_div_1_div_3_Template, 3, 2, "div", 10)(4, DynamicFormControlView_div_1_div_4_Template, 2, 4, "div", 11)(5, DynamicFormControlView_div_1_div_5_Template, 2, 3, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "title" || ctx_r0.dynamicFormObject.type === "subtitle" || ctx_r0.dynamicFormObject.type === "label" || ctx_r0.dynamicFormObject.type === "separator");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.dynamicFormObject.type === "title" || ctx_r0.dynamicFormObject.type === "subtitle" || ctx_r0.dynamicFormObject.type === "label" || ctx_r0.dynamicFormObject.type === "separator") && !ctx_r0.dynamicFormObject.multipleValues);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.dynamicFormObject.type === "title" || ctx_r0.dynamicFormObject.type === "subtitle" || ctx_r0.dynamicFormObject.type === "label" || ctx_r0.dynamicFormObject.type === "separator") && ctx_r0.dynamicFormObject.multipleValues);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.debug);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.form && ctx_r0.form.controls && ctx_r0.form.controls[ctx_r0.dynamicFormObject.code] && !ctx_r0.form.controls[ctx_r0.dynamicFormObject.code].valid && ctx_r0.form.controls[ctx_r0.dynamicFormObject.code].touched);
} }
function DynamicFormControlView_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵelement(1, "html-renderer", 48);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("template", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp"));
} }
function DynamicFormControlView_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicFormControlView_ng_template_2_div_0_Template, 2, 1, "div", 46);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp") > "");
} }
function DynamicFormControlView_ng_template_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "input", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.number || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("placeholder", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "placeholder"))("step", ctx_r0.dynamicFormObject.step)("formControlName", ctx_r0.dynamicFormObject.code);
} }
function DynamicFormControlView_ng_template_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "input", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.text || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("placeholder", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "placeholder"))("formControlName", ctx_r0.dynamicFormObject.code);
} }
function DynamicFormControlView_ng_template_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "html-editor", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.textarea || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("placeholder", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "placeholder"))("formControlName", ctx_r0.dynamicFormObject.code);
} }
function DynamicFormControlView_ng_template_4_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "input", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.number || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("placeholder", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "placeholder"))("step", ctx_r0.dynamicFormObject.step)("formControlName", ctx_r0.dynamicFormObject.code);
} }
function DynamicFormControlView_ng_template_4_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "textarea", 52);
    i0.ɵɵtext(2, " ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.textarea || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("placeholder", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "placeholder"))("formControlName", ctx_r0.dynamicFormObject.code);
} }
function DynamicFormControlView_ng_template_4_div_6_p_tabs_1_fi_template_renderer_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 60);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("template", ctx_r0.form == null ? null : ctx_r0.form.controls[ctx_r0.dynamicFormObject.code] == null ? null : ctx_r0.form.controls[ctx_r0.dynamicFormObject.code].getRawValue())("data", ctx_r0.parentForm == null ? null : ctx_r0.parentForm.getRawValue());
} }
function DynamicFormControlView_ng_template_4_div_6_p_tabs_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-tabs", 54);
    i0.ɵɵtwoWayListener("valueChange", function DynamicFormControlView_ng_template_4_div_6_p_tabs_1_Template_p_tabs_valueChange_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r0 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r0.activeTab, $event) || (ctx_r0.activeTab = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementStart(1, "p-tablist")(2, "p-tab", 55);
    i0.ɵɵtext(3, "Definition");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-tab", 55);
    i0.ɵɵtext(5, "Preview");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "p-tabpanels")(7, "p-tabpanel", 55)(8, "div", 8)(9, "div", 6);
    i0.ɵɵelement(10, "html-editor", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 57)(12, "a", 58);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(14, "p-tabpanel", 55);
    i0.ɵɵtemplate(15, DynamicFormControlView_ng_template_4_div_6_p_tabs_1_fi_template_renderer_15_Template, 1, 2, "fi-template-renderer", 59);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtwoWayProperty("value", ctx_r0.activeTab);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", 1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.multiselect || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code)("mode", (ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.mode) || "html");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r0.configService.env.monacoEditorDocumentation, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("monacoInfoLabel"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.activeTab === 1);
} }
function DynamicFormControlView_ng_template_4_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 6);
    i0.ɵɵelement(2, "html-editor", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 57)(4, "a", 58);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.multiselect || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code)("mode", (ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.mode) || "html");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r0.configService.env.monacoEditorDocumentation, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("monacoInfoLabel"));
} }
function DynamicFormControlView_ng_template_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, DynamicFormControlView_ng_template_4_div_6_p_tabs_1_Template, 16, 12, "p-tabs", 53)(2, DynamicFormControlView_ng_template_4_div_6_div_2_Template, 6, 6, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.operation !== "view");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.operation === "view");
} }
function DynamicFormControlView_ng_template_4_div_7_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementEnd();
} }
function DynamicFormControlView_ng_template_4_div_7_div_1_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵlistener("click", function DynamicFormControlView_ng_template_4_div_7_div_1_a_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelement(1, "i", 30);
    i0.ɵɵelementEnd();
} }
function DynamicFormControlView_ng_template_4_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 62)(1, "label", 63);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-toggleButton", 64);
    i0.ɵɵtemplate(4, DynamicFormControlView_ng_template_4_div_7_div_1_span_4_Template, 2, 0, "span", 25)(5, DynamicFormControlView_ng_template_4_div_7_div_1_a_5_Template, 2, 0, "a", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.checkbox || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r0.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r0.dynamicFormObject.code)("id", ctx_r0.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
} }
function DynamicFormControlView_ng_template_4_div_7_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementEnd();
} }
function DynamicFormControlView_ng_template_4_div_7_div_2_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵlistener("click", function DynamicFormControlView_ng_template_4_div_7_div_2_a_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelement(1, "i", 30);
    i0.ɵɵelementEnd();
} }
function DynamicFormControlView_ng_template_4_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 62)(1, "label", 63);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 65);
    i0.ɵɵtemplate(4, DynamicFormControlView_ng_template_4_div_7_div_2_span_4_Template, 2, 0, "span", 25)(5, DynamicFormControlView_ng_template_4_div_7_div_2_a_5_Template, 2, 0, "a", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.checkbox || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r0.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
} }
function DynamicFormControlView_ng_template_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, DynamicFormControlView_ng_template_4_div_7_div_1_Template, 6, 7, "div", 61)(2, DynamicFormControlView_ng_template_4_div_7_div_2_Template, 6, 7, "div", 61);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.mode) || (ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.mode) === "toggle");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.mode) === "checkbox");
} }
function DynamicFormControlView_ng_template_4_div_8_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementEnd();
} }
function DynamicFormControlView_ng_template_4_div_8_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵlistener("click", function DynamicFormControlView_ng_template_4_div_8_a_6_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelement(1, "i", 30);
    i0.ɵɵelementEnd();
} }
function DynamicFormControlView_ng_template_4_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 66);
    i0.ɵɵelement(2, "input", 65);
    i0.ɵɵelementStart(3, "label", 63);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DynamicFormControlView_ng_template_4_div_8_span_5_Template, 2, 0, "span", 25)(6, DynamicFormControlView_ng_template_4_div_8_a_6_Template, 2, 0, "a", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.checkbox || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r0.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
} }
function DynamicFormControlView_ng_template_4_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "input", 67);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.datetime || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("placeholder", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "placeholder"))("formControlName", ctx_r0.dynamicFormObject.code);
} }
function DynamicFormControlView_ng_template_4_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "p-select", 68);
    i0.ɵɵlistener("onFilter", function DynamicFormControlView_ng_template_4_div_10_Template_p_select_onFilter_1_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.onFilterChange($event, ctx_r0.dynamicFormObject)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.select || ctx_r0.dynamicFormObject.cssClass)("options", ctx_r0.items)("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code)("showClear", true);
} }
function DynamicFormControlView_ng_template_4_div_11_ng_container_1_p_select_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-select", 71);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("filter", true)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.select || ctx_r0.dynamicFormObject.cssClass)("options", ctx_r0.paginatedItems)("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code)("showClear", true);
} }
function DynamicFormControlView_ng_template_4_div_11_ng_container_1_p_select_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-select", 72);
    i0.ɵɵlistener("onFilter", function DynamicFormControlView_ng_template_4_div_11_ng_container_1_p_select_2_Template_p_select_onFilter_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.onFilterChange($event, ctx_r0.dynamicFormObject)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("filter", true)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.select || ctx_r0.dynamicFormObject.cssClass)("options", ctx_r0.paginatedItems)("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code)("showClear", true)("virtualScroll", true)("virtualScrollItemSize", 20)("virtualScrollOptions", ctx_r0.options);
} }
function DynamicFormControlView_ng_template_4_div_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormControlView_ng_template_4_div_11_ng_container_1_p_select_1_Template, 1, 6, "p-select", 69)(2, DynamicFormControlView_ng_template_4_div_11_ng_container_1_p_select_2_Template, 1, 9, "p-select", 70);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.search));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.search);
} }
function DynamicFormControlView_ng_template_4_div_11_ng_container_2_p_multiSelect_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-multiSelect", 74);
    i0.ɵɵlistener("onFilter", function DynamicFormControlView_ng_template_4_div_11_ng_container_2_p_multiSelect_1_Template_p_multiSelect_onFilter_0_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.onFilterChange($event, ctx_r0.dynamicFormObject)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("filter", true)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.multiselect || ctx_r0.dynamicFormObject.cssClass)("options", ctx_r0.items)("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code)("showClear", true);
} }
function DynamicFormControlView_ng_template_4_div_11_ng_container_2_p_multiSelect_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-multiSelect", 71);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("filter", true)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.multiselect || ctx_r0.dynamicFormObject.cssClass)("options", ctx_r0.items)("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code)("showClear", true);
} }
function DynamicFormControlView_ng_template_4_div_11_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormControlView_ng_template_4_div_11_ng_container_2_p_multiSelect_1_Template, 1, 6, "p-multiSelect", 73)(2, DynamicFormControlView_ng_template_4_div_11_ng_container_2_p_multiSelect_2_Template, 1, 6, "p-multiSelect", 69);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.search);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.search));
} }
function DynamicFormControlView_ng_template_4_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, DynamicFormControlView_ng_template_4_div_11_ng_container_1_Template, 3, 2, "ng-container", 31)(2, DynamicFormControlView_ng_template_4_div_11_ng_container_2_Template, 3, 2, "ng-container", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.dynamicFormObject.multipleValues);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.multipleValues);
} }
function DynamicFormControlView_ng_template_4_div_12_p_multiSelect_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-multiSelect", 74);
    i0.ɵɵlistener("onFilter", function DynamicFormControlView_ng_template_4_div_12_p_multiSelect_1_Template_p_multiSelect_onFilter_0_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.onFilterChange($event, ctx_r0.dynamicFormObject)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("filter", true)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.multiselect || ctx_r0.dynamicFormObject.cssClass)("options", ctx_r0.items)("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code)("showClear", true);
} }
function DynamicFormControlView_ng_template_4_div_12_p_multiSelect_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-multiSelect", 71);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("filter", true)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.multiselect || ctx_r0.dynamicFormObject.cssClass)("options", ctx_r0.items)("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code)("showClear", true);
} }
function DynamicFormControlView_ng_template_4_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, DynamicFormControlView_ng_template_4_div_12_p_multiSelect_1_Template, 1, 6, "p-multiSelect", 73)(2, DynamicFormControlView_ng_template_4_div_12_p_multiSelect_2_Template, 1, 6, "p-multiSelect", 69);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.search);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.search));
} }
function DynamicFormControlView_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, DynamicFormControlView_ng_template_4_div_1_Template, 2, 5, "div", 10)(2, DynamicFormControlView_ng_template_4_div_2_Template, 2, 4, "div", 10)(3, DynamicFormControlView_ng_template_4_div_3_Template, 2, 4, "div", 10)(4, DynamicFormControlView_ng_template_4_div_4_Template, 2, 5, "div", 10)(5, DynamicFormControlView_ng_template_4_div_5_Template, 3, 4, "div", 10)(6, DynamicFormControlView_ng_template_4_div_6_Template, 3, 2, "div", 10)(7, DynamicFormControlView_ng_template_4_div_7_Template, 3, 2, "div", 10)(8, DynamicFormControlView_ng_template_4_div_8_Template, 7, 7, "div", 10)(9, DynamicFormControlView_ng_template_4_div_9_Template, 2, 4, "div", 10)(10, DynamicFormControlView_ng_template_4_div_10_Template, 2, 5, "div", 10)(11, DynamicFormControlView_ng_template_4_div_11_Template, 3, 2, "div", 10)(12, DynamicFormControlView_ng_template_4_div_12_Template, 3, 2, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "sequence");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "json");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "number");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "textarea");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "code");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "truefalse");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "checkbox");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "datetime");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "radiolist");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "select");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "multiselect");
} }
function DynamicFormControlView_ng_template_6_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 87)(1, "button", 88);
    i0.ɵɵlistener("click", function DynamicFormControlView_ng_template_6_div_3_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r17); const arrayGroupElementIndex_r18 = i0.ɵɵnextContext().index; const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.removeFormArrayElement(arrayGroupElementIndex_r18)); });
    i0.ɵɵelement(2, "i", 89);
    i0.ɵɵelementEnd()();
} }
function DynamicFormControlView_ng_template_6_div_3_input_4_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 90);
    i0.ɵɵlistener("keydown", function DynamicFormControlView_ng_template_6_div_3_input_4_Template_input_keydown_0_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.addFormArrayElement($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    const arrayGroupElement_r21 = ctx_r19.$implicit;
    const arrayGroupElementIndex_r18 = ctx_r19.index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.text || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId + "_" + arrayGroupElementIndex_r18)("formControl", arrayGroupElement_r21);
} }
function DynamicFormControlView_ng_template_6_div_3_input_5_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 91);
    i0.ɵɵlistener("keydown", function DynamicFormControlView_ng_template_6_div_3_input_5_Template_input_keydown_0_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.addFormArrayElement($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const arrayGroupElement_r21 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.number || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("placeholder", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "placeholder"))("step", ctx_r0.dynamicFormObject.step)("formControl", arrayGroupElement_r21);
} }
function DynamicFormControlView_ng_template_6_div_3_textarea_6_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "textarea", 92);
    i0.ɵɵlistener("keydown", function DynamicFormControlView_ng_template_6_div_3_textarea_6_Template_textarea_keydown_0_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.addFormArrayElement($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const arrayGroupElement_r21 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.textarea || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("placeholder", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "placeholder"))("formControl", arrayGroupElement_r21);
} }
function DynamicFormControlView_ng_template_6_div_3_p_tabs_7_fi_template_renderer_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 60);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("template", ctx_r0.form == null ? null : ctx_r0.form.controls[ctx_r0.dynamicFormObject.code] == null ? null : ctx_r0.form.controls[ctx_r0.dynamicFormObject.code].getRawValue())("data", ctx_r0.parentForm == null ? null : ctx_r0.parentForm.getRawValue());
} }
function DynamicFormControlView_ng_template_6_div_3_p_tabs_7_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-tabs", 54);
    i0.ɵɵtwoWayListener("valueChange", function DynamicFormControlView_ng_template_6_div_3_p_tabs_7_Template_p_tabs_valueChange_0_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r0 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r0.activeTab, $event) || (ctx_r0.activeTab = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementStart(1, "p-tablist")(2, "p-tab", 55);
    i0.ɵɵtext(3, "Definition");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-tab", 55);
    i0.ɵɵtext(5, "Preview");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "p-tabpanels")(7, "p-tabpanel", 55)(8, "div", 8)(9, "div", 6);
    i0.ɵɵelement(10, "html-editor", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 57)(12, "a", 58);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(14, "p-tabpanel", 55);
    i0.ɵɵtemplate(15, DynamicFormControlView_ng_template_6_div_3_p_tabs_7_fi_template_renderer_15_Template, 1, 2, "fi-template-renderer", 59);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtwoWayProperty("value", ctx_r0.activeTab);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", 1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.multiselect || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("formControlName", ctx_r0.dynamicFormObject.code)("mode", (ctx_r0.dynamicFormObject.componentConfig == null ? null : ctx_r0.dynamicFormObject.componentConfig.mode) || "html");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r0.configService.env.monacoEditorDocumentation, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("monacoInfoLabel"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.activeTab === 1);
} }
function DynamicFormControlView_ng_template_6_div_3_fi_template_renderer_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 60);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("template", ctx_r0.form == null ? null : ctx_r0.form.controls[ctx_r0.dynamicFormObject.code] == null ? null : ctx_r0.form.controls[ctx_r0.dynamicFormObject.code].getRawValue())("data", ctx_r0.parentForm == null ? null : ctx_r0.parentForm.getRawValue());
} }
function DynamicFormControlView_ng_template_6_div_3_input_9_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 93);
    i0.ɵɵlistener("keydown", function DynamicFormControlView_ng_template_6_div_3_input_9_Template_input_keydown_0_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.addFormArrayElement($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const arrayGroupElement_r21 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.datetime || ctx_r0.dynamicFormObject.cssClass)("id", ctx_r0.dynamicFormObject.pathId)("placeholder", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "placeholder"))("formControl", arrayGroupElement_r21);
} }
function DynamicFormControlView_ng_template_6_div_3_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "form-errors-manager", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const arrayGroupElement_r21 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("errors", arrayGroupElement_r21.errors)("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject);
} }
function DynamicFormControlView_ng_template_6_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵtemplate(1, DynamicFormControlView_ng_template_6_div_3_div_1_Template, 3, 0, "div", 80);
    i0.ɵɵelementStart(2, "div", 81)(3, "div", 82);
    i0.ɵɵtemplate(4, DynamicFormControlView_ng_template_6_div_3_input_4_Template, 1, 3, "input", 83)(5, DynamicFormControlView_ng_template_6_div_3_input_5_Template, 1, 5, "input", 84)(6, DynamicFormControlView_ng_template_6_div_3_textarea_6_Template, 1, 4, "textarea", 85)(7, DynamicFormControlView_ng_template_6_div_3_p_tabs_7_Template, 16, 12, "p-tabs", 53)(8, DynamicFormControlView_ng_template_6_div_3_fi_template_renderer_8_Template, 1, 2, "fi-template-renderer", 59)(9, DynamicFormControlView_ng_template_6_div_3_input_9_Template, 1, 4, "input", 86)(10, DynamicFormControlView_ng_template_6_div_3_div_10_Template, 2, 3, "div", 31);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const arrayGroupElement_r21 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly || ctx_r0.operation === "edit" && !ctx_r0.dynamicFormObject.editBlocked);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "number");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "textarea");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "code" && ctx_r0.operation !== "view");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "code" && ctx_r0.operation === "view");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "datetime");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", arrayGroupElement_r21.errors);
} }
function DynamicFormControlView_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 75);
    i0.ɵɵelementStart(1, "div", 76)(2, "div", 77);
    i0.ɵɵtemplate(3, DynamicFormControlView_ng_template_6_div_3_Template, 11, 8, "div", 78);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formArrayName", ctx_r0.dynamicFormObject.code);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code]["controls"]);
} }
class DynamicFormControlView {
    get isValid() {
        return this.form.controls[this.dynamicFormObject.code].valid;
    }
    constructor(dynamicFormService, dynamicFormControlService, configService, dialogService, optionsService, confirmationService, searchService, utilsService, cdr) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.configService = configService;
        this.dialogService = dialogService;
        this.optionsService = optionsService;
        this.confirmationService = confirmationService;
        this.searchService = searchService;
        this.utilsService = utilsService;
        this.cdr = cdr;
        this.debug = false;
        this.readonly = false;
        this.monacoInfo = this.configService.env.i18n.monacoInfoLabel;
        this.activeTab = 0;
        this.options = {
            delay: 250,
            showLoader: true,
            lazy: true,
            onLazyLoad: this.onLazyLoad.bind(this)
        };
        this.loadLazyTimeout = null;
    }
    async ngOnInit() {
        if (this.dynamicFormObject.refOptionsId) {
            this.dynamicFormObject.value = this.optionsService.getComponentSelectedOptions(this.dynamicForm, this.dynamicFormObject.refOptionsId);
            this.extractOptions(this.form.controls[this.dynamicFormObject.code].getRawValue());
        }
        //Initialization of the component with the default value or (in case of formula) with the computed value
        this.dynamicFormControlService.setFormComponentValue(this.operation, this.dynamicForm, this.dynamicFormObject, this.form, this.parentForm, this.xpath);
        this.xpath = this.dynamicFormControlService.getXpath(this.dynamicFormObject, this.xpath);
        this.form.controls[this.dynamicFormObject.code].valueChanges.subscribe(value => {
            if (this.dynamicFormObject.type === "json" && typeof (value) === "string") {
                value = JSON.parse(value);
                this.form.controls[this.dynamicFormObject.code].setValue(value);
            }
        });
        if (this.group) {
            this.group.onOptionsUpdated.subscribe(items => {
                let userFilters = {};
                //I create the user filter depending on the actual groupselect items filtered by the user selection
                for (let f in this.form.getRawValue()) {
                    let childDfo = this.group.dynamicFormObject.components[this.group.dynamicFormObject.components.findIndex(item => item.code === f)];
                    let childGroupColumn = childDfo.refOptionsMappings.groupColumn.startsWith("document.") ? childDfo.refOptionsMappings.groupColumn : "document." + childDfo.refOptionsMappings.groupColumn;
                    if (items) {
                        let childValues = items.map(e => {
                            let groupValues = jsonPath.query(e, '$.' + childGroupColumn);
                            if (groupValues.length > 0) {
                                return "'" + groupValues[0] + "'";
                            }
                        });
                        if (childValues.length > 0) {
                            userFilters[childDfo.code] = {
                                value: childValues.filter(this.utilsService.uniqueFilter)
                            };
                        }
                    }
                }
                this.extractOptions(userFilters);
            });
        }
        this.setChangeAlert();
        this.cdr.detectChanges();
    }
    onLazyLoad(event) {
        /*     if (this.loadLazyTimeout) {
                clearTimeout(this.loadLazyTimeout);
            }
        
            this.loadLazyTimeout = setTimeout(() => {
                const { first, last } = event;
        
                console.log(event);
        
                this.paginatedItems = [];
        
                for (let i = first; i < last; i++) {
                  this.paginatedItems.push(this.items[i]);
                }
        
                console.log(this.paginatedItems);
            }, Math.random() * 1000 + 250); */
    }
    extractOptions(userFilters, searchFilters) {
        let index = this.dynamicForm.options.findIndex(item => item.id === this.dynamicFormObject.refOptionsId);
        if (index >= 0) {
            if (this.dynamicForm.options[index].type === 'reference' || this.dynamicForm.options[index].type === 'standard' || this.dynamicForm.options[index].type === 'external') {
                this.optionsService.getRemoteItems(this.statuses, this.dynamicFormControlService, this.dynamicForm, this.dynamicFormObject, this.parentForm, this.dynamicForm.options[index], this.dynamicFormObject.refOptionsFilters, userFilters, searchFilters).subscribe(res => {
                    this.items = this.optionsService.mapRemoteItems(this.dynamicForm.options[index], res, this.dynamicFormObject.refOptionsMappings);
                    this.paginatedItems = this.items.slice(0, 20);
                }, err => {
                    this.searchService.manageError(err, 'Error reading ' + this.dynamicForm.options[index].type + ' items');
                });
            }
            else {
                this.items = [];
            }
        }
        else {
            this.items = [];
        }
    }
    getItemsFromInternalComponent() {
        let index = this.dynamicForm.options?.findIndex(item => item.id === this.dynamicFormObject.refOptionsId);
        if (index >= 0) {
            if (this.dynamicForm.options[index].type === 'internal') {
                let values = jsonPath.query(this.parentForm.getRawValue(), '$.' + this.dynamicForm.options[index].field);
                if (values.length > 0) {
                    return values[0];
                }
                else {
                    return [];
                }
            }
            else {
                return [];
            }
        }
        else {
            return [];
        }
    }
    setChangeAlert() {
        if (this.dynamicFormObject.resetData) {
            this.form.get(this.dynamicFormObject.code).valueChanges.pipe(startWith(1), pairwise()).subscribe((prevValue) => {
                this.confirmationService.confirm({
                    header: "Data reset",
                    key: "dynamic-form",
                    message: "A change to this value will reset the related data already inserted. Do you want to continue?",
                    accept: () => {
                    },
                    reject: () => {
                        this.form.get(this.dynamicFormObject.code).setValue(prevValue);
                    }
                });
            });
        }
    }
    isRadioChecked(opt) {
        if (this.form.get(this.dynamicFormObject.code).value) {
            return (this.form.get(this.dynamicFormObject.code).value.value === opt.value ? 'checked' : '');
        }
        else {
            return '';
        }
    }
    updateCheckedOptions(opt, event) {
        this.dynamicFormObject.value[opt["key"]] = event.checked;
    }
    updateSelectedOption(opt, event) {
        this.dynamicFormObject.value = event.checked;
    }
    addFormArrayElement(keyboard) {
        if (!keyboard || (keyboard && keyboard.keyCode === 9)) {
            let fa = this.form.controls[this.dynamicFormObject.code];
            if (!isNaN(fa.value.length)) {
                fa.push(this.dynamicFormControlService.createFormControl(this.dynamicForm, this.dynamicFormObject, null));
            }
        }
    }
    removeFormArrayElement(i) {
        let fa = this.form.controls[this.dynamicFormObject.code];
        fa.removeAt(i);
    }
    showHelp(description) {
        const ref = this.dialogService.open(HelpComponent, {
            data: {
                description: description
            },
            focusOnShow: false,
            modal: true,
            closable: true,
            header: 'Help',
            width: '50%'
        });
    }
    /*
      Function that fires when a search term is provided in the search field of the dropdown
    */
    onFilterChange(event, control) {
        if (event.filter && event.filter.length > 3 && control.componentConfig?.search && control.refOptionsId) {
            let index = this.dynamicForm.options.findIndex(item => item.id === this.dynamicFormObject.refOptionsId);
            if (index >= 0) {
                if (this.dynamicForm.options[index].type === 'reference' || this.dynamicForm.options[index].type === 'standard' || this.dynamicForm.options[index].type === 'external') {
                    this.optionsService.getRemoteItems(this.statuses, this.dynamicFormControlService, this.dynamicForm, this.dynamicFormObject, this.parentForm, this.dynamicForm.options[index], this.dynamicFormObject.refOptionsFilters, null, event.filter).subscribe(res => {
                        this.items = this.optionsService.mapRemoteItems(this.dynamicForm.options[index], res, this.dynamicFormObject.refOptionsMappings);
                    }, err => {
                        this.searchService.manageError(err, 'Error reading ' + this.dynamicForm.options[index].type + ' items');
                    });
                }
            }
        }
    }
    static { this.ɵfac = function DynamicFormControlView_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormControlView)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.OptionsService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormControlView, selectors: [["dynamic-form-control-view"]], inputs: { group: "group", dynamicForm: "dynamicForm", parentDynamicForm: "parentDynamicForm", dynamicFormObject: "dynamicFormObject", parentDynamicFormObject: "parentDynamicFormObject", form: "form", parentForm: "parentForm", statuses: "statuses", debug: "debug", readonly: "readonly", operation: "operation", xpath: "xpath", hideLabel: "hideLabel" }, standalone: false, decls: 8, vars: 2, consts: [["quickhelp", ""], ["single", ""], ["multiple", ""], ["class", "row", 3, "formGroup", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "row", 3, "formGroup"], [1, "col-md-12"], ["type", "hidden", 3, "id", "formControlName"], [1, "row"], ["class", "col-md-12 mt-3", 4, "ngIf"], ["class", "col-md-12", 4, "ngIf"], ["class", "col-md-12 mt-2 mb-2", 4, "ngIf"], [1, "col-md-12", "mt-3"], ["class", "title-highlight", 3, "ngClass", "id", 4, "ngIf"], ["class", "sub-title", 3, "ngClass", "id", 4, "ngIf"], ["class", "component-label text-color-gray-dark", 3, "ngClass", "id", 4, "ngIf"], ["class", "separator", 3, "ngClass", "id", 4, "ngIf"], [1, "title-highlight", 3, "ngClass", "id"], [1, "sub-title", 3, "ngClass", "id"], [1, "component-label", "text-color-gray-dark", 3, "ngClass", "id"], [1, "separator", 3, "ngClass", "id"], ["class", "component-header", 4, "ngIf"], [4, "ngTemplateOutlet"], [1, "component-header"], [1, "component-label", "text-color-gray-dark", 3, "id"], ["class", "mandatory", 4, "ngIf"], ["class", "help-button", "title", "Help", 3, "click", 4, "ngIf"], [1, "mandatory"], [1, "bi", "bi-asterisk"], ["title", "Help", 1, "help-button", 3, "click"], [1, "bi", "bi-question-circle"], [4, "ngIf"], [3, "collapsed", "toggleable", 4, "ngIf"], [3, "collapsed", "toggleable"], ["pTemplate", "header"], [1, "row", "mt-3"], [1, "col-md-6"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "rounded", "outlined", "click", 4, "ngIf"], [1, "col-md-6", "align-right"], ["icon", "pi pi-plus", 3, "rounded", "click", 4, "ngIf"], [1, "flex", "align-items-center"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "click", "rounded", "outlined"], ["icon", "pi pi-plus", 3, "click", "rounded"], [1, "col-md-12", "mt-2", "mb-2"], [3, "dynamicForm", "dynamicFormObject", "data", "xpath"], [3, "errors", "dynamicForm", "dynamicFormObject"], ["class", "form-control-footer text-color-gray-medium", 4, "ngIf"], [1, "form-control-footer", "text-color-gray-medium"], [3, "template"], ["type", "number", 1, "form-control", 3, "ngClass", "id", "placeholder", "step", "formControlName"], ["type", "text", 1, "form-control", 3, "ngClass", "id", "placeholder", "formControlName"], ["mode", "json", 1, "form-control", 3, "ngClass", "id", "placeholder", "formControlName"], [1, "form-control", 3, "ngClass", "id", "placeholder", "formControlName"], [3, "value", "valueChange", 4, "ngIf"], [3, "valueChange", "value"], [3, "value"], [3, "ngClass", "id", "formControlName", "mode"], [1, "col-md-12", "align-right"], ["target", "_blank", 3, "href"], [3, "template", "data", 4, "ngIf"], [3, "template", "data"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], [1, "form-check-label", 3, "for"], ["onLabel", "Yes", "offLabel", "No", 3, "formControlName", "id"], ["type", "checkbox", 1, "form-check-input", 3, "id", "formControlName"], [1, "form-group", "form-check", 3, "ngClass"], ["type", "date", 1, "form-control", 3, "ngClass", "id", "placeholder", "formControlName"], ["appendTo", "body", "optionLabel", "label", "placeholder", "(none)", "dataKey", "value", 3, "onFilter", "ngClass", "options", "id", "formControlName", "showClear"], ["appendTo", "body", "optionLabel", "label", "placeholder", "(none)", "dataKey", "value", 3, "filter", "ngClass", "options", "id", "formControlName", "showClear", 4, "ngIf"], ["appendTo", "body", "optionLabel", "label", "placeholder", "(none)", "dataKey", "value", 3, "filter", "ngClass", "options", "id", "formControlName", "showClear", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "onFilter", 4, "ngIf"], ["appendTo", "body", "optionLabel", "label", "placeholder", "(none)", "dataKey", "value", 3, "filter", "ngClass", "options", "id", "formControlName", "showClear"], ["appendTo", "body", "optionLabel", "label", "placeholder", "(none)", "dataKey", "value", 3, "onFilter", "filter", "ngClass", "options", "id", "formControlName", "showClear", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions"], ["appendTo", "body", "optionLabel", "label", "placeholder", "(none)", "dataKey", "value", 3, "filter", "ngClass", "options", "id", "formControlName", "showClear", "onFilter", 4, "ngIf"], ["appendTo", "body", "optionLabel", "label", "placeholder", "(none)", "dataKey", "value", 3, "onFilter", "filter", "ngClass", "options", "id", "formControlName", "showClear"], [3, "formGroup"], [1, "row", 3, "formArrayName"], [1, "col-md-12", "mt-2"], ["class", "multiple-values-item", 4, "ngFor", "ngForOf"], [1, "multiple-values-item"], ["class", "multiple-values-item-actions", 4, "ngIf"], [1, "multiple-values-item-content"], [1, "multiple-values-item-body"], ["class", "form-control", "type", "text", 3, "ngClass", "id", "formControl", "keydown", 4, "ngIf"], ["class", "form-control", "type", "number", 3, "ngClass", "id", "placeholder", "step", "formControl", "keydown", 4, "ngIf"], ["class", "form-control", "autore", "", 3, "ngClass", "id", "placeholder", "formControl", "keydown", 4, "ngIf"], ["class", "form-control", "type", "date", 3, "ngClass", "id", "placeholder", "formControl", "keydown", 4, "ngIf"], [1, "multiple-values-item-actions"], ["title", "Remove item", "type", "button", "tabindex", "-1", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-trash"], ["type", "text", 1, "form-control", 3, "keydown", "ngClass", "id", "formControl"], ["type", "number", 1, "form-control", 3, "keydown", "ngClass", "id", "placeholder", "step", "formControl"], ["autore", "", 1, "form-control", 3, "keydown", "ngClass", "id", "placeholder", "formControl"], ["type", "date", 1, "form-control", 3, "keydown", "ngClass", "id", "placeholder", "formControl"]], template: function DynamicFormControlView_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicFormControlView_div_0_Template, 3, 3, "div", 3)(1, DynamicFormControlView_div_1_Template, 6, 5, "div", 4)(2, DynamicFormControlView_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, DynamicFormControlView_ng_template_4_Template, 13, 13, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, DynamicFormControlView_ng_template_6_Template, 4, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.type === "system");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.form);
        } }, styles: [".effect[_ngcontent-%COMP%]{opacity:1;animation:_ngcontent-%COMP%_fade 5s linear}@keyframes _ngcontent-%COMP%_fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator[_ngcontent-%COMP%]{width:100%}.form-check-label[_ngcontent-%COMP%]{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items[_ngcontent-%COMP%]{list-style:none;font-size:.9rem}.help-button[_ngcontent-%COMP%]{margin:5px}.help-button[_ngcontent-%COMP%]:hover{cursor:pointer}.component-header[_ngcontent-%COMP%]{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{margin-left:10px}.form-control-footer[_ngcontent-%COMP%]{font-size:.8em}.mandatory[_ngcontent-%COMP%]{font-size:50%;vertical-align:top;color:red}.app-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}.header-title[_ngcontent-%COMP%]:hover{cursor:pointer}.status-label[_ngcontent-%COMP%]{font-size:1em;font-weight:700}.component-label[_ngcontent-%COMP%]{font-size:1em}.component-label.horizontal[_ngcontent-%COMP%], label.title-category[_ngcontent-%COMP%]{font-size:.9em}.float[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.panel-body[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading[_ngcontent-%COMP%]{min-height:45px;display:flex}.panel-heading[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-height:40px}.multiple-values-item[_ngcontent-%COMP%]{display:flex;flex-grow:1}.multiple-values-item-content[_ngcontent-%COMP%]{width:95%}.multiple-values-item-body[_ngcontent-%COMP%]{width:95%;margin-bottom:5px}.array-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:.9em}.header-title[_ngcontent-%COMP%]{vertical-align:middle}.card[_ngcontent-%COMP%]{margin-bottom:.5em}.refresh-button[_ngcontent-%COMP%]{margin:.5em}.refresh-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ref-form[_ngcontent-%COMP%]{display:flex;align-items:baseline}img[_ngcontent-%COMP%]{max-width:100%;height:auto}.collapse[_ngcontent-%COMP%]{display:none!important}.collapse.in[_ngcontent-%COMP%]{display:block!important}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form[_ngcontent-%COMP%]   .p-fieldset[_ngcontent-%COMP%]   .p-fieldset-legend[_ngcontent-%COMP%]{font-size:.8em!important}.dynamic-form-summary-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%]{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{margin-left:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%], .dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-icon[_ngcontent-%COMP%]{font-size:20px!important}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.control-cell.content[_ngcontent-%COMP%]{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu[_ngcontent-%COMP%]{width:55px}.form-group[_ngcontent-%COMP%]{border:solid 1px rgba(0,0,0,.125);margin:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormControlView, [{
        type: Component,
        args: [{ selector: 'dynamic-form-control-view', standalone: false, template: "<div class=\"row\" *ngIf=\"dynamicFormObject.type==='system'\" [formGroup]=\"form\">\r\n  <div class=\"col-md-12\">\r\n    <input type=\"hidden\" [id]=\"dynamicFormObject.pathId\" [formControlName]=\"dynamicFormObject.code\" />\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row\" *ngIf=\"form\">\r\n\r\n  <!-- STATIC COMPONENTS -->\r\n  <div class=\"col-md-12 mt-3\" *ngIf=\"dynamicFormObject.type === 'title' || dynamicFormObject.type === 'subtitle' || dynamicFormObject.type === 'label' || dynamicFormObject.type === 'separator'\">\r\n    <h4 *ngIf=\"dynamicFormObject.type === 'title'\" class=\"title-highlight\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.label) || dynamicFormObject.cssClass\" [id]=\"dynamicFormObject.pathId\">{{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label') }}</h4>\r\n    <h5 *ngIf=\"dynamicFormObject.type === 'subtitle'\" class=\"sub-title\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.label) || dynamicFormObject.cssClass\" [id]=\"dynamicFormObject.pathId\">{{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label') }}</h5>\r\n    <label *ngIf=\"dynamicFormObject.type === 'label'\" class=\"component-label text-color-gray-dark\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.label) || dynamicFormObject.cssClass\" [id]=\"dynamicFormObject.pathId\">{{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label') }}</label>\r\n    <div *ngIf=\"dynamicFormObject.type === 'separator'\" class=\"separator\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.label) || dynamicFormObject.cssClass\" [id]=\"dynamicFormObject.pathId\"></div>\r\n  </div>\r\n\r\n  <!-- DYNAMIC COMPONENTS -->\r\n  <!-- SINGLE VALUE -->\r\n  <div class=\"col-md-12\" *ngIf=\"!(dynamicFormObject.type === 'title' || dynamicFormObject.type === 'subtitle' || dynamicFormObject.type === 'label' || dynamicFormObject.type === 'separator') && (!dynamicFormObject.multipleValues)\">\r\n    \r\n    <!-- HEADER -->\r\n    <div class=\"component-header\" *ngIf=\"hideLabel === false && dynamicFormObject.type !== 'truefalse' && dynamicFormObject.type !== 'checkbox'\">\r\n      <label class=\"component-label text-color-gray-dark\" [id]=\"dynamicFormObject.pathId\"> {{\r\n        dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label') }}</label>\r\n      <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n      <a *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\"\r\n        class=\"help-button\" title=\"Help\"\r\n        (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\">\r\n        <i class=\"bi bi-question-circle\"></i>\r\n      </a>\r\n    </div>\r\n\r\n    <ng-container *ngTemplateOutlet=\"single\"></ng-container>\r\n    <ng-container *ngTemplateOutlet=\"quickhelp\"></ng-container>\r\n  </div>\r\n  <!-- --------------- -->\r\n\r\n  <!-- DYNAMIC COMPONENTS -->\r\n  <!-- MULTIPLE VALUES -->\r\n  <div class=\"col-md-12\" *ngIf=\"!(dynamicFormObject.type === 'title' || dynamicFormObject.type === 'subtitle' || dynamicFormObject.type === 'label' || dynamicFormObject.type === 'separator') && dynamicFormObject.multipleValues\">\r\n\r\n    <ng-container *ngIf=\"dynamicFormObject.type === 'select'\">\r\n\r\n      <!-- HEADER -->\r\n      <div class=\"component-header\" *ngIf=\"hideLabel === false\">\r\n        <label class=\"component-label text-color-gray-dark\" [id]=\"dynamicFormObject.pathId\"> {{\r\n          dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label') }}</label>\r\n        <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n        <a *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\"\r\n          class=\"help-button\" title=\"Help\"\r\n          (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\">\r\n          <i class=\"bi bi-question-circle\"></i>\r\n        </a>\r\n      </div>\r\n      \r\n      <ng-container *ngTemplateOutlet=\"single\"></ng-container>\r\n      <ng-container *ngTemplateOutlet=\"quickhelp\"></ng-container>\r\n\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"dynamicFormObject.type !== 'select'\">\r\n\r\n      <p-fieldset [collapsed]=\"dynamicFormObject.collapsed\" [toggleable]=\"true\" *ngIf=\"hideLabel === false\">\r\n        <ng-template pTemplate=\"header\">\r\n          <div class=\"flex align-items-center\">\r\n            <label>{{dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label')}}</label>\r\n            <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n          </div>\r\n        </ng-template>\r\n  \r\n        <ng-container *ngTemplateOutlet=\"quickhelp\"></ng-container>      \r\n        <ng-container *ngTemplateOutlet=\"multiple\"></ng-container>\r\n  \r\n        <div class=\"row mt-3\">\r\n          <div class=\"col-md-6\">\r\n            <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\" title=\"Help\"\r\n              (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\"></p-button>\r\n          </div>\r\n          <div class=\"col-md-6 align-right\">\r\n            <p-button *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\" icon=\"pi pi-plus\" [rounded]=\"true\" (click)=\"addFormArrayElement()\"></p-button>\r\n          </div>\r\n        </div>\r\n      </p-fieldset>\r\n  \r\n      <ng-container *ngIf=\"hideLabel === true\">\r\n        <ng-container *ngTemplateOutlet=\"quickhelp\"></ng-container>\r\n        <ng-container *ngTemplateOutlet=\"multiple\"></ng-container>\r\n      </ng-container>\r\n\r\n    </ng-container>\r\n\r\n  </div>\r\n  <!-- --------------- -->\r\n\r\n  <!-- FOOTER -->\r\n  <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n    <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\"\r\n      [xpath]=\"xpath\"></debug-details>\r\n  </div>\r\n\r\n  <div class=\"col-md-12\" *ngIf=\"form && form.controls && form.controls[dynamicFormObject.code] && !form.controls[dynamicFormObject.code].valid && form.controls[dynamicFormObject.code].touched\">\r\n    <form-errors-manager [errors]=\"form.controls[dynamicFormObject.code].errors\" [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\"></form-errors-manager>\r\n  </div>\r\n\r\n</div>\r\n\r\n\r\n<!-- --------- -->\r\n<!-- TEMPLATES -->\r\n<!-- --------- -->\r\n\r\n<!-- QUICK HELP -->\r\n<ng-template #quickhelp>\r\n  <div class=\"form-control-footer text-color-gray-medium\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n    <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- SINGLE CONTENT -->\r\n<ng-template #single>\r\n  <div class=\"row\" [formGroup]=\"form\">\r\n    <!-- SEQUENCE -->\r\n    <div class=\"col-md-12\" *ngIf=\"dynamicFormObject.type === 'sequence'\">\r\n      <input [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.number) || dynamicFormObject.cssClass\"\r\n        class=\"form-control\" [id]=\"dynamicFormObject.pathId\"\r\n        [placeholder]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'placeholder')\"\r\n        [step]=\"dynamicFormObject.step\" [formControlName]=\"dynamicFormObject.code\" type=\"number\">\r\n    </div>\r\n\r\n    <!-- TEXT -->\r\n    <div class=\"col-md-12\" *ngIf=\"dynamicFormObject.type === 'text'\">\r\n      <input [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.text) || dynamicFormObject.cssClass\"\r\n        class=\"form-control\" [id]=\"dynamicFormObject.pathId\"\r\n        [placeholder]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'placeholder')\"\r\n        type=\"text\" [formControlName]=\"dynamicFormObject.code\" />\r\n    </div>\r\n\r\n    <!-- JSON -->\r\n    <div class=\"col-md-12\" *ngIf=\"dynamicFormObject.type === 'json'\">\r\n      <html-editor [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.textarea) || dynamicFormObject.cssClass\"\r\n        class=\"form-control\" [id]=\"dynamicFormObject.pathId\" mode=\"json\"\r\n        [placeholder]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'placeholder')\"\r\n        [formControlName]=\"dynamicFormObject.code\"> </html-editor>\r\n    </div>\r\n\r\n    <!-- NUMBER -->\r\n    <div *ngIf=\"dynamicFormObject.type === 'number'\" class=\"col-md-12\">\r\n      <input [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.number) || dynamicFormObject.cssClass\"\r\n        class=\"form-control\" [id]=\"dynamicFormObject.pathId\"\r\n        [placeholder]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'placeholder')\"\r\n        [step]=\"dynamicFormObject.step\" [formControlName]=\"dynamicFormObject.code\" type=\"number\">\r\n    </div>\r\n\r\n    <!-- TEXTAREA -->\r\n    <div *ngIf=\"dynamicFormObject.type === 'textarea'\" class=\"col-md-12\">\r\n      <textarea [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.textarea) || dynamicFormObject.cssClass\"\r\n        class=\"form-control\" [id]=\"dynamicFormObject.pathId\"\r\n        [placeholder]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'placeholder')\"\r\n        [formControlName]=\"dynamicFormObject.code\"> </textarea>\r\n    </div>\r\n\r\n    <!-- CODE -->\r\n    <div *ngIf=\"dynamicFormObject.type === 'code'\" class=\"col-md-12\">\r\n      <p-tabs [(value)]=\"activeTab\" *ngIf=\"operation !== 'view'\">\r\n        <p-tablist>\r\n          <p-tab [value]=\"0\">Definition</p-tab>\r\n          <p-tab [value]=\"1\">Preview</p-tab>\r\n        </p-tablist>\r\n        <p-tabpanels>\r\n          <p-tabpanel [value]=\"0\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <html-editor [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.multiselect) || dynamicFormObject.cssClass\" [id]=\"dynamicFormObject.pathId\" [formControlName]=\"dynamicFormObject.code\" [mode]=\"dynamicFormObject.componentConfig?.mode || 'html'\"></html-editor>          \r\n              </div>\r\n              <div class=\"col-md-12 align-right\">\r\n                <a href=\"{{configService.env.monacoEditorDocumentation}}\" target=\"_blank\">{{ configService.getTranslation(\"monacoInfoLabel\") }}</a>\r\n              </div>\r\n            </div>\r\n          </p-tabpanel>\r\n          <p-tabpanel [value]=\"1\">\r\n            <fi-template-renderer *ngIf=\"activeTab === 1\" [template]=\"form?.controls[dynamicFormObject.code]?.getRawValue()\" [data]=\"parentForm?.getRawValue()\"></fi-template-renderer>\r\n          </p-tabpanel>\r\n        </p-tabpanels>\r\n      </p-tabs>\r\n\r\n      <div class=\"row\" *ngIf=\"operation === 'view'\">\r\n        <div class=\"col-md-12\">\r\n          <html-editor [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.multiselect) || dynamicFormObject.cssClass\" [id]=\"dynamicFormObject.pathId\" [formControlName]=\"dynamicFormObject.code\" [mode]=\"dynamicFormObject.componentConfig?.mode || 'html'\"></html-editor>\r\n        </div>\r\n        <div class=\"col-md-12 align-right\">\r\n          <a href=\"{{configService.env.monacoEditorDocumentation}}\" target=\"_blank\">{{ configService.getTranslation(\"monacoInfoLabel\") }}</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <!-- TRUEFALSE -->\r\n    <div *ngIf=\"dynamicFormObject.type === 'truefalse'\" class=\"col-md-12\">\r\n      <!-- Toggle view -->\r\n      <div *ngIf=\"!dynamicFormObject.componentConfig?.mode || dynamicFormObject.componentConfig?.mode === 'toggle'\"\r\n        [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.checkbox) || dynamicFormObject.cssClass\">\r\n\r\n        <label class=\"form-check-label\" [for]=\"dynamicFormObject.pathId\">{{\r\n          dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label') }}</label>\r\n        \r\n        <p-toggleButton [formControlName]=\"dynamicFormObject.code\" [id]=\"dynamicFormObject.pathId\" onLabel=\"Yes\" offLabel=\"No\"></p-toggleButton>\r\n        \r\n        <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n        <a *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\"\r\n          class=\"help-button\" title=\"Help\"\r\n          (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\">\r\n          <i class=\"bi bi-question-circle\"></i>\r\n        </a>\r\n      </div>\r\n\r\n      <!-- Checkbox view -->\r\n      <div *ngIf=\"dynamicFormObject.componentConfig?.mode === 'checkbox'\"\r\n        [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.checkbox) || dynamicFormObject.cssClass\">\r\n        <label class=\"form-check-label\" [for]=\"dynamicFormObject.pathId\">{{\r\n          dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label') }}</label>\r\n        <input class=\"form-check-input\" type=\"checkbox\" [id]=\"dynamicFormObject.pathId\"\r\n          [formControlName]=\"dynamicFormObject.code\" />\r\n        <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n        <a *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\"\r\n          class=\"help-button\" title=\"Help\"\r\n          (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\">\r\n          <i class=\"bi bi-question-circle\"></i>\r\n        </a>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- CHECKBOX -->\r\n    <div *ngIf=\"dynamicFormObject.type === 'checkbox'\" class=\"col-md-12\">\r\n      <div class=\"form-group form-check\"\r\n        [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.checkbox) || dynamicFormObject.cssClass\">\r\n        <input class=\"form-check-input\" type=\"checkbox\" [id]=\"dynamicFormObject.pathId\"\r\n          [formControlName]=\"dynamicFormObject.code\" />\r\n        <label class=\"form-check-label\" [for]=\"dynamicFormObject.pathId\">{{\r\n          dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label') }}</label>\r\n        <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n        <a *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\"\r\n          class=\"help-button\" title=\"Help\"\r\n          (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\">\r\n          <i class=\"bi bi-question-circle\"></i>\r\n        </a>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- DATETIME -->\r\n    <div *ngIf=\"dynamicFormObject.type === 'datetime'\" class=\"col-md-12\">\r\n      <input [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.datetime) || dynamicFormObject.cssClass\"\r\n        [id]=\"dynamicFormObject.pathId\" class=\"form-control\" type=\"date\"\r\n        [placeholder]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'placeholder')\"\r\n        [formControlName]=\"dynamicFormObject.code\" />\r\n    </div>\r\n\r\n    <!-- RADIOLIST -->\r\n    <div *ngIf=\"dynamicFormObject.type === 'radiolist'\" class=\"col-md-12\">      \r\n<!--       <div class=\"form-check radiolist\"\r\n        [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.radiolist) || dynamicFormObject.cssClass\"\r\n        *ngFor=\"let opt of items; let i = index\">        \r\n        <p-radioButton \r\n          class=\"form-check-input\" \r\n          [name]=\"dynamicFormObject.code\" \r\n          [value]=\"opt\" \r\n          [inputId]=\"opt.value\"\r\n          [formControlName]=\"dynamicFormObject.code\"\r\n        ></p-radioButton>\r\n        <label class=\"form-check-label\">\r\n          {{ optionsService.getOptionLabel(opt) }}\r\n        </label>\r\n      </div> -->\r\n\r\n      <p-select appendTo=\"body\"\r\n        (onFilter)=\"onFilterChange($event,dynamicFormObject)\"\r\n        [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.select) || dynamicFormObject.cssClass\"\r\n        [options]=\"items\" [id]=\"dynamicFormObject.pathId\" [formControlName]=\"dynamicFormObject.code\"\r\n        optionLabel=\"label\" [showClear]=\"true\" placeholder=\"(none)\" dataKey=\"value\"\r\n        >\r\n      </p-select>\r\n    </div>\r\n\r\n    <!-- SELECT -->\r\n    <div *ngIf=\"dynamicFormObject.type === 'select'\" class=\"col-md-12\">\r\n\r\n      <ng-container *ngIf=\"!dynamicFormObject.multipleValues\">\r\n\r\n        <p-select appendTo=\"body\" [filter]=\"true\"\r\n          *ngIf=\"!dynamicFormObject.componentConfig?.search\"\r\n          [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.select) || dynamicFormObject.cssClass\"\r\n          [options]=\"paginatedItems\" [id]=\"dynamicFormObject.pathId\" [formControlName]=\"dynamicFormObject.code\"\r\n          optionLabel=\"label\" [showClear]=\"true\" placeholder=\"(none)\" dataKey=\"value\">\r\n        </p-select>\r\n  \r\n        <p-select appendTo=\"body\" [filter]=\"true\"\r\n          *ngIf=\"dynamicFormObject.componentConfig?.search\"\r\n          (onFilter)=\"onFilterChange($event,dynamicFormObject)\"\r\n          [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.select) || dynamicFormObject.cssClass\"\r\n          [options]=\"paginatedItems\" [id]=\"dynamicFormObject.pathId\" [formControlName]=\"dynamicFormObject.code\"\r\n          optionLabel=\"label\" [showClear]=\"true\" placeholder=\"(none)\" dataKey=\"value\"\r\n          [virtualScroll]=\"true\"\r\n          [virtualScrollItemSize]=\"20\"\r\n          [virtualScrollOptions]=\"options\">\r\n        </p-select>\r\n        \r\n      </ng-container>\r\n\r\n      <ng-container *ngIf=\"dynamicFormObject.multipleValues\">\r\n\r\n        <p-multiSelect appendTo=\"body\" [filter]=\"true\"\r\n          *ngIf=\"dynamicFormObject.componentConfig?.search\"\r\n          (onFilter)=\"onFilterChange($event,dynamicFormObject)\"\r\n          [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.multiselect) || dynamicFormObject.cssClass\"\r\n          [options]=\"items\" [id]=\"dynamicFormObject.pathId\" [formControlName]=\"dynamicFormObject.code\"\r\n          optionLabel=\"label\" [showClear]=\"true\" placeholder=\"(none)\" dataKey=\"value\">\r\n        </p-multiSelect>\r\n\r\n        <p-multiSelect appendTo=\"body\" [filter]=\"true\"\r\n          *ngIf=\"!dynamicFormObject.componentConfig?.search\"\r\n          [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.multiselect) || dynamicFormObject.cssClass\"\r\n          [options]=\"items\" [id]=\"dynamicFormObject.pathId\" [formControlName]=\"dynamicFormObject.code\"\r\n          optionLabel=\"label\" [showClear]=\"true\" placeholder=\"(none)\" dataKey=\"value\">\r\n        </p-multiSelect>\r\n      \r\n      </ng-container>\r\n    </div>\r\n\r\n    <!-- MULTISELECT -->\r\n    <div *ngIf=\"dynamicFormObject.type === 'multiselect'\" class=\"col-md-12\">\r\n      <p-multiSelect appendTo=\"body\" [filter]=\"true\"\r\n        *ngIf=\"dynamicFormObject.componentConfig?.search\"\r\n        (onFilter)=\"onFilterChange($event,dynamicFormObject)\"\r\n        [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.multiselect) || dynamicFormObject.cssClass\"\r\n        [options]=\"items\" [id]=\"dynamicFormObject.pathId\" [formControlName]=\"dynamicFormObject.code\"\r\n        optionLabel=\"label\" [showClear]=\"true\" placeholder=\"(none)\" dataKey=\"value\">\r\n      </p-multiSelect>\r\n\r\n      <p-multiSelect appendTo=\"body\" [filter]=\"true\"\r\n        *ngIf=\"!dynamicFormObject.componentConfig?.search\"\r\n        [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.multiselect) || dynamicFormObject.cssClass\"\r\n        [options]=\"items\" [id]=\"dynamicFormObject.pathId\" [formControlName]=\"dynamicFormObject.code\"\r\n        optionLabel=\"label\" [showClear]=\"true\" placeholder=\"(none)\" dataKey=\"value\">\r\n      </p-multiSelect>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- MULTIPLE CONTENT -->\r\n<ng-template #multiple>\r\n  <ng-container [formGroup]=\"form\">\r\n    <div class=\"row\" [formArrayName]=\"dynamicFormObject.code\">\r\n      <div class=\"col-md-12 mt-2\">\r\n        <div class=\"multiple-values-item\" *ngFor=\"let arrayGroupElement of form.controls[dynamicFormObject.code]['controls']; let arrayGroupElementIndex=index\">\r\n          <div class=\"multiple-values-item-actions\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n            <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n              (click)=\"removeFormArrayElement(arrayGroupElementIndex)\" tabindex=\"-1\">\r\n              <i class=\"bi bi-trash\"></i>\r\n            </button>\r\n          </div>\r\n          \r\n          <div class=\"multiple-values-item-content\">\r\n            <div class=\"multiple-values-item-body\">\r\n  \r\n              <!-- TEXT -->\r\n              <input *ngIf=\"dynamicFormObject.type === 'text'\"\r\n                [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.text) || dynamicFormObject.cssClass\"\r\n                class=\"form-control\" [id]=\"dynamicFormObject.pathId + '_' + arrayGroupElementIndex\" type=\"text\"\r\n                [formControl]=\"arrayGroupElement\" (keydown)=\"addFormArrayElement($event)\" />\r\n  \r\n              <!-- NUMBER -->\r\n              <input *ngIf=\"dynamicFormObject.type === 'number'\"\r\n                [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.number) || dynamicFormObject.cssClass\"\r\n                class=\"form-control\" [id]=\"dynamicFormObject.pathId\"\r\n                [placeholder]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'placeholder')\"\r\n                [step]=\"dynamicFormObject.step\" [formControl]=\"arrayGroupElement\" type=\"number\"\r\n                (keydown)=\"addFormArrayElement($event)\">\r\n  \r\n              <!-- TEXTAREA -->\r\n              <textarea *ngIf=\"dynamicFormObject.type === 'textarea'\"\r\n                [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.textarea) || dynamicFormObject.cssClass\"\r\n                class=\"form-control\" [id]=\"dynamicFormObject.pathId\" autore\r\n                [placeholder]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'placeholder')\"\r\n                [formControl]=\"arrayGroupElement\" (keydown)=\"addFormArrayElement($event)\"></textarea>\r\n\r\n              <!-- CODE -->\r\n              <p-tabs [(value)]=\"activeTab\" *ngIf=\"dynamicFormObject.type === 'code' && operation !== 'view'\">\r\n                <p-tablist>\r\n                  <p-tab [value]=\"0\">Definition</p-tab>\r\n                  <p-tab [value]=\"1\">Preview</p-tab>\r\n                </p-tablist>\r\n                <p-tabpanels>\r\n                  <p-tabpanel [value]=\"0\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-12\">\r\n                        <html-editor [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.multiselect) || dynamicFormObject.cssClass\" [id]=\"dynamicFormObject.pathId\" [formControlName]=\"dynamicFormObject.code\" [mode]=\"dynamicFormObject.componentConfig?.mode || 'html'\"></html-editor>\r\n                      </div>\r\n                      <div class=\"col-md-12 align-right\">\r\n                        <a href=\"{{configService.env.monacoEditorDocumentation}}\" target=\"_blank\">{{ configService.getTranslation(\"monacoInfoLabel\") }}</a>\r\n                      </div>\r\n                    </div>\r\n                  </p-tabpanel>\r\n                  <p-tabpanel [value]=\"1\">\r\n                    <fi-template-renderer *ngIf=\"activeTab === 1\" [template]=\"form?.controls[dynamicFormObject.code]?.getRawValue()\" [data]=\"parentForm?.getRawValue()\"></fi-template-renderer>\r\n                  </p-tabpanel>\r\n                </p-tabpanels>\r\n              </p-tabs>\r\n\r\n              <fi-template-renderer *ngIf=\"dynamicFormObject.type === 'code' && operation === 'view'\" [template]=\"form?.controls[dynamicFormObject.code]?.getRawValue()\" [data]=\"parentForm?.getRawValue()\"></fi-template-renderer>\r\n  \r\n              <!-- DATETIME -->\r\n              <input *ngIf=\"dynamicFormObject.type === 'datetime'\"\r\n                [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.datetime) || dynamicFormObject.cssClass\"\r\n                [id]=\"dynamicFormObject.pathId\" class=\"form-control\" type=\"date\"\r\n                [placeholder]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'placeholder')\"\r\n                [formControl]=\"arrayGroupElement\" (keydown)=\"addFormArrayElement($event)\" />\r\n\r\n              <div *ngIf=\"arrayGroupElement.errors\">\r\n                <form-errors-manager [errors]=\"arrayGroupElement.errors\" [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\"></form-errors-manager>\r\n              </div>\r\n  \r\n            </div>\r\n          </div>\r\n        </div>\r\n  \r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</ng-template>", styles: [".effect{opacity:1;animation:fade 5s linear}@keyframes fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator{width:100%}.form-check-label{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items{list-style:none;font-size:.9rem}.help-button{margin:5px}.help-button:hover{cursor:pointer}.component-header{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header .header-title{margin-left:10px}.form-control-footer{font-size:.8em}.mandatory{font-size:50%;vertical-align:top;color:red}.app-menu-disabled{pointer-events:none;opacity:.6}.header-title:hover{cursor:pointer}.status-label{font-size:1em;font-weight:700}.component-label{font-size:1em}.component-label.horizontal,label.title-category{font-size:.9em}.float{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float>*{margin-left:5px;margin-right:5px}.panel-body{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading{min-height:45px;display:flex}.panel-heading .header-title{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading button{max-height:40px}.multiple-values-item{display:flex;flex-grow:1}.multiple-values-item-content{width:95%}.multiple-values-item-body{width:95%;margin-bottom:5px}.array-items button{font-size:.9em}.header-title{vertical-align:middle}.card{margin-bottom:.5em}.refresh-button{margin:.5em}.refresh-button:hover{cursor:pointer}.ref-form{display:flex;align-items:baseline}img{max-width:100%;height:auto}.collapse{display:none!important}.collapse.in{display:block!important}.collapsing{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form .p-fieldset .p-fieldset-legend{font-size:.8em!important}.dynamic-form-summary-view{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view .form-tree{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view .form-questions{margin-left:5px}.dynamic-form-summary-view .form-tree,.dynamic-form-summary-view .form-questions{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form{width:100%}form .item-icon{font-size:20px!important}form .item-switcher{width:100%}form .item-switcher>div{width:100%}.control-cell.content{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu{width:55px}.form-group{border:solid 1px rgba(0,0,0,.125);margin:1em}\n"] }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i1.ConfigurationService }, { type: i1$1.DialogService }, { type: i1.OptionsService }, { type: i3$2.ConfirmationService }, { type: i1.SearchService }, { type: i1.UtilsService }, { type: i0.ChangeDetectorRef }], { group: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], parentDynamicForm: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], parentDynamicFormObject: [{
            type: Input
        }], form: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], statuses: [{
            type: Input
        }], debug: [{
            type: Input
        }], readonly: [{
            type: Input
        }], operation: [{
            type: Input
        }], xpath: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormControlView, { className: "DynamicFormControlView", filePath: "src/dynamic-form/dynamic-form-control/dynamic-form-control.ts", lineNumber: 23 }); })();

function DynamicFormGroupView_p_fieldset_0_ng_template_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵelementEnd();
} }
function DynamicFormGroupView_p_fieldset_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormGroupView_p_fieldset_0_ng_template_1_span_3_Template, 2, 0, "span", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.required);
} }
function DynamicFormGroupView_p_fieldset_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17);
    i0.ɵɵelement(2, "html-renderer", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("template", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "quickhelp"));
} }
function DynamicFormGroupView_p_fieldset_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "debug-details", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", ctx_r1.dynamicFormObject)("data", ctx_r1.form.getRawValue())("xpath", ctx_r1.xpath);
} }
function DynamicFormGroupView_p_fieldset_0_div_5_dynamic_form_switcher_view_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "dynamic-form-switcher-view", 22);
} if (rf & 2) {
    const child_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", child_r3.type === "separator" ? "separator" : "")("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", child_r3)("parentDynamicFormObject", ctx_r1.dynamicFormObject)("form", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code])("parentForm", ctx_r1.parentForm)("operation", ctx_r1.operation)("debug", ctx_r1.debug)("xpath", ctx_r1.xpath)("readonly", ctx_r1.readonly)("hideLabel", ctx_r1.hideLabel)("statuses", ctx_r1.statuses)("status", ctx_r1.status);
} }
function DynamicFormGroupView_p_fieldset_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, DynamicFormGroupView_p_fieldset_0_div_5_dynamic_form_switcher_view_1_Template, 1, 13, "dynamic-form-switcher-view", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.dynamicForm.cssClass && ctx_r1.dynamicForm.cssClass.group || ctx_r1.dynamicFormObject.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
} }
function DynamicFormGroupView_p_fieldset_0_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", child_r4.type === "separator" ? "separator" : "")("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", child_r4)("parentDynamicFormObject", ctx_r1.dynamicFormObject)("form", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code])("parentForm", ctx_r1.parentForm)("operation", ctx_r1.operation)("debug", ctx_r1.debug)("xpath", ctx_r1.xpath)("readonly", ctx_r1.readonly)("hideLabel", ctx_r1.hideLabel)("statuses", ctx_r1.statuses)("status", ctx_r1.status);
} }
function DynamicFormGroupView_p_fieldset_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24);
    i0.ɵɵtemplate(2, DynamicFormGroupView_p_fieldset_0_div_6_div_2_Template, 2, 13, "div", 25);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.dynamicForm.cssClass && ctx_r1.dynamicForm.cssClass.group || ctx_r1.dynamicFormObject.cssClass);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
} }
function DynamicFormGroupView_p_fieldset_0_ng_container_7_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "div", 3)(2, "div", 24)(3, "div", 33)(4, "label", 34);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const child_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", child_r5.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, child_r5, "label"), "");
} }
function DynamicFormGroupView_p_fieldset_0_ng_container_7_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormGroupView_p_fieldset_0_ng_container_7_ng_container_3_div_1_Template, 6, 2, "div", 31);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getComponentClass(ctx_r1.parentForm || ctx_r1.form, ctx_r1.dynamicForm, child_r5, ctx_r1.xpath, ctx_r1.debug) !== "hidden");
} }
function DynamicFormGroupView_p_fieldset_0_ng_container_7_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", child_r6.type === "separator" ? "separator" : "")("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", child_r6)("parentDynamicFormObject", ctx_r1.dynamicFormObject)("form", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code])("parentForm", ctx_r1.parentForm)("operation", ctx_r1.operation)("debug", ctx_r1.debug)("xpath", ctx_r1.xpath)("readonly", ctx_r1.readonly)("hideLabel", true)("statuses", ctx_r1.statuses)("status", ctx_r1.status);
} }
function DynamicFormGroupView_p_fieldset_0_ng_container_7_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormGroupView_p_fieldset_0_ng_container_7_ng_container_6_div_1_Template, 2, 13, "div", 35);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getComponentClass(ctx_r1.parentForm || ctx_r1.form, ctx_r1.dynamicForm, child_r6, ctx_r1.xpath, ctx_r1.debug) !== "hidden");
} }
function DynamicFormGroupView_p_fieldset_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 26);
    i0.ɵɵelementStart(1, "div", 27)(2, "div", 28);
    i0.ɵɵtemplate(3, DynamicFormGroupView_p_fieldset_0_ng_container_7_ng_container_3_Template, 2, 1, "ng-container", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 29)(5, "div", 30);
    i0.ɵɵtemplate(6, DynamicFormGroupView_p_fieldset_0_ng_container_7_ng_container_6_Template, 2, 1, "ng-container", 25);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
} }
function DynamicFormGroupView_p_fieldset_0_p_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 37);
    i0.ɵɵlistener("click", function DynamicFormGroupView_p_fieldset_0_p_button_10_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.showHelp(ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help"))); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function DynamicFormGroupView_p_fieldset_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-fieldset", 1);
    i0.ɵɵlistener("onBeforeToggle", function DynamicFormGroupView_p_fieldset_0_Template_p_fieldset_onBeforeToggle_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onGroupHeaderClick()); });
    i0.ɵɵtemplate(1, DynamicFormGroupView_p_fieldset_0_ng_template_1_Template, 4, 2, "ng-template", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, DynamicFormGroupView_p_fieldset_0_div_3_Template, 3, 1, "div", 4)(4, DynamicFormGroupView_p_fieldset_0_div_4_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DynamicFormGroupView_p_fieldset_0_div_5_Template, 2, 2, "div", 5)(6, DynamicFormGroupView_p_fieldset_0_div_6_Template, 3, 2, "div", 6)(7, DynamicFormGroupView_p_fieldset_0_ng_container_7_Template, 7, 2, "ng-container", 7);
    i0.ɵɵelementStart(8, "div", 8)(9, "div", 9);
    i0.ɵɵtemplate(10, DynamicFormGroupView_p_fieldset_0_p_button_10_Template, 1, 2, "p-button", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "div", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("collapsed", ctx_r1.dynamicFormObject.collapsed)("toggleable", true)("formGroup", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code])("ngClass", ctx_r1.dynamicForm.cssClass && ctx_r1.dynamicForm.cssClass.group || ctx_r1.dynamicFormObject.cssClass);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "quickhelp") > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.debug);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.format === "float");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.dynamicFormObject.format || ctx_r1.dynamicFormObject.format === "vertical");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.format === "horizontal");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help") > "");
} }
function DynamicFormGroupView_p_fieldset_1_ng_template_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵelementEnd();
} }
function DynamicFormGroupView_p_fieldset_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormGroupView_p_fieldset_1_ng_template_1_span_3_Template, 2, 0, "span", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.required);
} }
function DynamicFormGroupView_p_fieldset_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17);
    i0.ɵɵelement(2, "html-renderer", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("template", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "quickhelp"));
} }
function DynamicFormGroupView_p_fieldset_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "debug-details", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", ctx_r1.dynamicFormObject)("data", ctx_r1.form.getRawValue())("xpath", ctx_r1.xpath);
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_5_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44)(1, "button", 45);
    i0.ɵɵlistener("click", function DynamicFormGroupView_p_fieldset_1_ng_container_5_div_1_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r9); const arrayGroupElementIndex_r10 = i0.ɵɵnextContext().index; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.removeFormArrayElement(arrayGroupElementIndex_r10)); });
    i0.ɵɵelement(2, "i", 46);
    i0.ɵɵelementEnd()();
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_5_div_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const arrayGroupElementIndex_r10 = i0.ɵɵnextContext().index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.dynamicFormControlService.getHeader(ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, ctx_r1.form.controls[ctx_r1.dynamicFormObject.code]["controls"][arrayGroupElementIndex_r10].value, null));
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_5_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r11 = ctx.$implicit;
    const arrayGroupElement_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", child_r11.type === "separator" ? "separator" : "")("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", child_r11)("parentDynamicFormObject", ctx_r1.dynamicFormObject)("form", arrayGroupElement_r12)("parentForm", ctx_r1.parentForm)("operation", ctx_r1.operation)("debug", ctx_r1.debug)("xpath", ctx_r1.xpath)("readonly", ctx_r1.readonly)("hideLabel", ctx_r1.hideLabel)("statuses", ctx_r1.statuses)("status", ctx_r1.status);
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_5_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "form-errors-manager", 48);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const arrayGroupElement_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("errors", arrayGroupElement_r12.errors)("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", ctx_r1.dynamicFormObject);
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, DynamicFormGroupView_p_fieldset_1_ng_container_5_div_1_div_1_Template, 3, 0, "div", 41);
    i0.ɵɵelementStart(2, "div", 42)(3, "p-panel", 43);
    i0.ɵɵtemplate(4, DynamicFormGroupView_p_fieldset_1_ng_container_5_div_1_ng_template_4_Template, 3, 1, "ng-template", 2)(5, DynamicFormGroupView_p_fieldset_1_ng_container_5_div_1_div_5_Template, 2, 13, "div", 25)(6, DynamicFormGroupView_p_fieldset_1_ng_container_5_div_1_div_6_Template, 2, 3, "div", 38);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const arrayGroupElement_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.readonly || ctx_r1.operation === "edit" && !ctx_r1.dynamicFormObject.editBlocked);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("toggleable", true)("collapsed", ctx_r1.dynamicFormObject.collapsed);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", arrayGroupElement_r12.errors);
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormGroupView_p_fieldset_1_ng_container_5_div_1_Template, 7, 5, "div", 40);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code]["controls"]);
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_6_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 32);
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_6_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "div", 3)(2, "div", 24)(3, "div", 33)(4, "label", 34);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const child_r13 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", child_r13.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, child_r13, "label"), "");
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_6_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54)(1, "button", 45);
    i0.ɵɵlistener("click", function DynamicFormGroupView_p_fieldset_1_ng_container_6_div_6_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r14); const arrayGroupElementIndex_r15 = i0.ɵɵnextContext().index; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.removeFormArrayElement(arrayGroupElementIndex_r15)); });
    i0.ɵɵelement(2, "i", 46);
    i0.ɵɵelementEnd()();
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_6_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r16 = ctx.$implicit;
    const arrayGroupElement_r17 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", child_r16.type === "separator" ? "separator" : "")("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", child_r16)("parentDynamicFormObject", ctx_r1.dynamicFormObject)("form", arrayGroupElement_r17)("parentForm", ctx_r1.parentForm)("operation", ctx_r1.operation)("debug", ctx_r1.debug)("xpath", ctx_r1.xpath)("readonly", ctx_r1.readonly)("hideLabel", true)("statuses", ctx_r1.statuses)("status", ctx_r1.status);
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_6_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, DynamicFormGroupView_p_fieldset_1_ng_container_6_div_6_div_1_Template, 3, 0, "div", 52)(2, DynamicFormGroupView_p_fieldset_1_ng_container_6_div_6_div_2_Template, 2, 13, "div", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.readonly || ctx_r1.operation === "edit" && !ctx_r1.dynamicFormObject.editBlocked);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_6_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵtext(1, " No data found ");
    i0.ɵɵelementEnd();
} }
function DynamicFormGroupView_p_fieldset_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 26);
    i0.ɵɵelementStart(1, "div", 27)(2, "div", 28);
    i0.ɵɵtemplate(3, DynamicFormGroupView_p_fieldset_1_ng_container_6_div_3_Template, 1, 0, "div", 31)(4, DynamicFormGroupView_p_fieldset_1_ng_container_6_div_4_Template, 6, 2, "div", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 29);
    i0.ɵɵtemplate(6, DynamicFormGroupView_p_fieldset_1_ng_container_6_div_6_Template, 3, 2, "div", 50);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, DynamicFormGroupView_p_fieldset_1_ng_container_6_div_7_Template, 2, 0, "div", 51);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.readonly || ctx_r1.operation === "edit" && !ctx_r1.dynamicFormObject.editBlocked);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code]["controls"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code]["controls"].length === 0);
} }
function DynamicFormGroupView_p_fieldset_1_p_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 37);
    i0.ɵɵlistener("click", function DynamicFormGroupView_p_fieldset_1_p_button_9_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.showHelp(ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help"))); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function DynamicFormGroupView_p_fieldset_1_p_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 56);
    i0.ɵɵlistener("click", function DynamicFormGroupView_p_fieldset_1_p_button_11_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.addFormArrayElement()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true);
} }
function DynamicFormGroupView_p_fieldset_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-fieldset", 1);
    i0.ɵɵlistener("onBeforeToggle", function DynamicFormGroupView_p_fieldset_1_Template_p_fieldset_onBeforeToggle_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onGroupHeaderClick()); });
    i0.ɵɵtemplate(1, DynamicFormGroupView_p_fieldset_1_ng_template_1_Template, 4, 2, "ng-template", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, DynamicFormGroupView_p_fieldset_1_div_3_Template, 3, 1, "div", 4)(4, DynamicFormGroupView_p_fieldset_1_div_4_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DynamicFormGroupView_p_fieldset_1_ng_container_5_Template, 2, 1, "ng-container", 38)(6, DynamicFormGroupView_p_fieldset_1_ng_container_6_Template, 8, 4, "ng-container", 7);
    i0.ɵɵelementStart(7, "div", 8)(8, "div", 9);
    i0.ɵɵtemplate(9, DynamicFormGroupView_p_fieldset_1_p_button_9_Template, 1, 2, "p-button", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 11);
    i0.ɵɵtemplate(11, DynamicFormGroupView_p_fieldset_1_p_button_11_Template, 1, 1, "p-button", 39);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("collapsed", ctx_r1.dynamicFormObject.collapsed)("toggleable", true)("formGroup", ctx_r1.form)("ngClass", ctx_r1.dynamicForm.cssClass && ctx_r1.dynamicForm.cssClass.group || ctx_r1.dynamicFormObject.cssClass);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "quickhelp") > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.debug);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.dynamicFormObject.format || ctx_r1.dynamicFormObject.format === "vertical" || ctx_r1.dynamicFormObject.format === "float");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.format === "horizontal");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help") > "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.readonly || ctx_r1.operation === "edit" && !ctx_r1.dynamicFormObject.editBlocked);
} }
class DynamicFormGroupView {
    constructor(dynamicFormService, dynamicFormControlService, dialogService, router, formDataService, confirmationService, route) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.dialogService = dialogService;
        this.router = router;
        this.formDataService = formDataService;
        this.confirmationService = confirmationService;
        this.route = route;
        this.debug = false;
        this.readonly = false;
        this.nextForm = new EventEmitter();
    }
    ngOnInit() {
        this.xpath = this.dynamicFormControlService.getXpath(this.dynamicFormObject, this.xpath);
        this.subpath = this.router.url.substring(this.router.url.indexOf('/admin') + 7);
        this.subpath = this.subpath.substring(0, this.subpath.indexOf('/'));
        this.route.queryParams.subscribe(params => {
            this.queryParams = params;
        });
    }
    ngAfterViewInit() {
        if (this.operation === 'new' && !this.dynamicFormObject.collapsed) {
            this.addFormArrayElement();
        }
    }
    showHelp(description) {
        const ref = this.dialogService.open(HelpComponent, {
            data: {
                description: description
            },
            header: 'Help',
            width: '50%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    onGroupHeaderClick() {
        let children = this.dynamicFormService.getComponentChildren(this.dynamicFormObject);
        if (children.length === 1 && children[0].type === 'form' && children[0].refFormType === 'external') {
            if (this.parentForm.dirty) {
                this.confirmationService.confirm({
                    message: 'Please save the form before moving to the next form',
                    key: 'data-editor',
                    rejectVisible: false,
                    acceptLabel: 'Ok'
                });
                return;
            }
            else {
                this.nextForm.emit({
                    dynamicForm: this.dynamicForm,
                    entry: this.parentForm.getRawValue(),
                    subpath: this.subpath,
                    subform: children[0],
                    parent: this.parentDynamicFormObject,
                    _p: this.queryParams._p
                });
            }
        }
    }
    addFormArrayElement(keyboard) {
        if (!keyboard || (keyboard && keyboard.keyCode === 9)) {
            let fa = this.form.controls[this.dynamicFormObject.code];
            if (!isNaN(fa.value.length)) {
                fa.push(this.dynamicFormControlService.formObjectsToFormGroup(this.dynamicForm, this.operation, this.dynamicFormService.getComponentChildren(this.dynamicFormObject), null, this.xpath));
            }
        }
    }
    removeFormArrayElement(i) {
        let fa = this.form.controls[this.dynamicFormObject.code];
        fa.removeAt(i);
    }
    static { this.ɵfac = function DynamicFormGroupView_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormGroupView)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(i2.ActivatedRoute)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormGroupView, selectors: [["dynamic-form-group-view"]], inputs: { group: "group", statuses: "statuses", status: "status", dynamicForm: "dynamicForm", parentDynamicForm: "parentDynamicForm", dynamicFormObject: "dynamicFormObject", parentDynamicFormObject: "parentDynamicFormObject", form: "form", parentForm: "parentForm", debug: "debug", readonly: "readonly", operation: "operation", xpath: "xpath", hideLabel: "hideLabel" }, outputs: { nextForm: "nextForm" }, standalone: false, decls: 2, vars: 2, consts: [[3, "collapsed", "toggleable", "formGroup", "ngClass", "onBeforeToggle", 4, "ngIf"], [3, "onBeforeToggle", "collapsed", "toggleable", "formGroup", "ngClass"], ["pTemplate", "header"], [1, "row"], ["class", "col-md-12 mt-2 mb-2", 4, "ngIf"], ["class", "float form-group-children", 3, "ngClass", 4, "ngIf"], ["class", "row form-group-children", 3, "ngClass", 4, "ngIf"], ["class", "form-array-item", 4, "ngIf"], [1, "row", "mt-3"], [1, "col-md-6"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "rounded", "outlined", "click", 4, "ngIf"], [1, "col-md-6", "align-right"], [1, "flex", "align-items-center"], ["class", "mandatory", 4, "ngIf"], [1, "mandatory"], [1, "bi", "bi-asterisk"], [1, "col-md-12", "mt-2", "mb-2"], [1, "form-control-footer", "text-color-gray-medium"], [3, "template"], [3, "dynamicForm", "dynamicFormObject", "data", "xpath"], [1, "float", "form-group-children", 3, "ngClass"], [3, "ngClass", "dynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "debug", "xpath", "readonly", "hideLabel", "statuses", "status", 4, "ngFor", "ngForOf"], [3, "ngClass", "dynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "debug", "xpath", "readonly", "hideLabel", "statuses", "status"], [1, "row", "form-group-children", 3, "ngClass"], [1, "col-md-12"], [4, "ngFor", "ngForOf"], [1, "form-array-item"], [1, "layout-table"], [1, "layout-table-header"], [1, "layout-table-body"], [1, "layout-table-row"], ["class", "layout-table-header-item", 4, "ngIf"], [1, "layout-table-header-item"], [1, "component-header"], [1, "component-label", "text-color-gray-medium", "horizontal", 3, "id"], ["class", "layout-table-cell", 4, "ngIf"], [1, "layout-table-cell"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "click", "rounded", "outlined"], [4, "ngIf"], ["icon", "pi pi-plus", 3, "rounded", "click", 4, "ngIf"], ["class", "form-array-item", 4, "ngFor", "ngForOf"], ["class", "form-array-item-actions", 4, "ngIf"], [1, "form-array-item-content"], [3, "toggleable", "collapsed"], [1, "form-array-item-actions"], ["title", "Remove item", "type", "button", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-trash"], [1, "form-array-item-header"], [3, "errors", "dynamicForm", "dynamicFormObject"], ["class", "layout-table-header-item", 4, "ngFor", "ngForOf"], ["class", "layout-table-row", 4, "ngFor", "ngForOf"], ["class", "no-data-found", 4, "ngIf"], ["class", "layout-table-cell buttons", 4, "ngIf"], ["class", "layout-table-cell", 4, "ngFor", "ngForOf"], [1, "layout-table-cell", "buttons"], [1, "no-data-found"], ["icon", "pi pi-plus", 3, "click", "rounded"]], template: function DynamicFormGroupView_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicFormGroupView_p_fieldset_0_Template, 12, 10, "p-fieldset", 0)(1, DynamicFormGroupView_p_fieldset_1_Template, 12, 10, "p-fieldset", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.dynamicFormObject.multipleValues);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.multipleValues);
        } }, styles: [".effect[_ngcontent-%COMP%]{opacity:1;animation:_ngcontent-%COMP%_fade 5s linear}@keyframes _ngcontent-%COMP%_fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator[_ngcontent-%COMP%]{width:100%}.form-check-label[_ngcontent-%COMP%]{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items[_ngcontent-%COMP%]{list-style:none;font-size:.9rem}.help-button[_ngcontent-%COMP%]{margin:5px}.help-button[_ngcontent-%COMP%]:hover{cursor:pointer}.component-header[_ngcontent-%COMP%]{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{margin-left:10px}.form-control-footer[_ngcontent-%COMP%]{font-size:.8em}.mandatory[_ngcontent-%COMP%]{font-size:50%;vertical-align:top;color:red}.app-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}.header-title[_ngcontent-%COMP%]:hover{cursor:pointer}.status-label[_ngcontent-%COMP%]{font-size:1em;font-weight:700}.component-label[_ngcontent-%COMP%]{font-size:1em}.component-label.horizontal[_ngcontent-%COMP%], label.title-category[_ngcontent-%COMP%]{font-size:.9em}.float[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.panel-body[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading[_ngcontent-%COMP%]{min-height:45px;display:flex}.panel-heading[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-height:40px}.multiple-values-item[_ngcontent-%COMP%]{display:flex;flex-grow:1}.multiple-values-item-content[_ngcontent-%COMP%]{width:95%}.multiple-values-item-body[_ngcontent-%COMP%]{width:95%;margin-bottom:5px}.array-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:.9em}.header-title[_ngcontent-%COMP%]{vertical-align:middle}.card[_ngcontent-%COMP%]{margin-bottom:.5em}.refresh-button[_ngcontent-%COMP%]{margin:.5em}.refresh-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ref-form[_ngcontent-%COMP%]{display:flex;align-items:baseline}img[_ngcontent-%COMP%]{max-width:100%;height:auto}.collapse[_ngcontent-%COMP%]{display:none!important}.collapse.in[_ngcontent-%COMP%]{display:block!important}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form[_ngcontent-%COMP%]   .p-fieldset[_ngcontent-%COMP%]   .p-fieldset-legend[_ngcontent-%COMP%]{font-size:.8em!important}.dynamic-form-summary-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%]{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{margin-left:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%], .dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-icon[_ngcontent-%COMP%]{font-size:20px!important}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.control-cell.content[_ngcontent-%COMP%]{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu[_ngcontent-%COMP%]{width:55px}.form-group[_ngcontent-%COMP%]{border:solid 1px rgba(0,0,0,.125);margin:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormGroupView, [{
        type: Component,
        args: [{ selector: 'dynamic-form-group-view', standalone: false, template: "<!-- Multiple values = false -->\r\n<p-fieldset [collapsed]=\"dynamicFormObject.collapsed\" (onBeforeToggle)=\"onGroupHeaderClick()\" [toggleable]=\"true\" *ngIf=\"!dynamicFormObject.multipleValues\" [formGroup]=\"$any(form.controls[dynamicFormObject.code])\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n\r\n  <ng-template pTemplate=\"header\">\r\n    <div class=\"flex align-items-center\">\r\n      <label>{{dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label')}}</label>\r\n      <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n      <div class=\"form-control-footer text-color-gray-medium\">\r\n        <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n      <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\" [xpath]=\"xpath\"></debug-details>\r\n    </div>\r\n  </div>\r\n\r\n    <!-- Float layout -->\r\n    <div *ngIf=\"dynamicFormObject.format === 'float'\" class=\"float form-group-children\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n      <dynamic-form-switcher-view \r\n        *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\"\r\n        [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n        [dynamicForm]=\"dynamicForm\" \r\n        [dynamicFormObject]=\"child\" \r\n        [parentDynamicFormObject]=\"dynamicFormObject\" \r\n        [form]=\"$any(form.controls[dynamicFormObject.code])\" \r\n        [parentForm]=\"parentForm\"\r\n        [operation]=\"operation\"\r\n        [debug]=\"debug\"\r\n        [xpath]=\"xpath\"\r\n        [readonly]=\"readonly\"\r\n        [hideLabel]=\"hideLabel\"\r\n        [statuses]=\"statuses\"\r\n        [status]=\"status\">\r\n      </dynamic-form-switcher-view>\r\n    </div>\r\n\r\n  <!-- Vertical layout -->\r\n  <div *ngIf=\"(!dynamicFormObject.format) || dynamicFormObject.format === 'vertical'\" class=\"row form-group-children\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n    <div class=\"col-md-12\">\r\n      <div *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n        <dynamic-form-switcher-view \r\n          [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n          [dynamicForm]=\"dynamicForm\" \r\n          [dynamicFormObject]=\"child\" \r\n          [parentDynamicFormObject]=\"dynamicFormObject\" \r\n          [form]=\"$any(form.controls[dynamicFormObject.code])\" \r\n          [parentForm]=\"parentForm\"\r\n          [operation]=\"operation\"\r\n          [debug]=\"debug\"\r\n          [xpath]=\"xpath\"\r\n          [readonly]=\"readonly\"\r\n          [hideLabel]=\"hideLabel\"\r\n          [statuses]=\"statuses\"\r\n          [status]=\"status\">\r\n        </dynamic-form-switcher-view>                \r\n      </div>     \r\n    </div>\r\n  </div>\r\n\r\n  <!-- Horizontal layout -->\r\n  <ng-container *ngIf=\"dynamicFormObject.format === 'horizontal'\" class=\"form-array-item\">\r\n    <div class=\"layout-table\">\r\n      <div class=\"layout-table-header\">\r\n        <ng-container *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n          <div class=\"layout-table-header-item\" *ngIf=\"dynamicFormControlService.getComponentClass(parentForm || form, dynamicForm, child, xpath, debug) !== 'hidden'\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"component-header\">\r\n                  <label class=\"component-label text-color-gray-medium horizontal\" [id]=\"child.pathId\"> {{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, child, 'label') }}</label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n      <div class=\"layout-table-body\">\r\n        <div class=\"layout-table-row\">\r\n          <ng-container *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n            <div class=\"layout-table-cell\" *ngIf=\"dynamicFormControlService.getComponentClass(parentForm || form, dynamicForm, child, xpath, debug) !== 'hidden'\">\r\n              <dynamic-form-switcher-view \r\n                [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n                [dynamicForm]=\"dynamicForm\" \r\n                [dynamicFormObject]=\"child\" \r\n                [parentDynamicFormObject]=\"dynamicFormObject\" \r\n                [form]=\"$any(form.controls[dynamicFormObject.code])\" \r\n                [parentForm]=\"parentForm\"\r\n                [operation]=\"operation\"\r\n                [debug]=\"debug\"\r\n                [xpath]=\"xpath\"\r\n                [readonly]=\"readonly\"\r\n                [hideLabel]=\"true\"\r\n                [statuses]=\"statuses\"\r\n                [status]=\"status\">\r\n              </dynamic-form-switcher-view>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <div class=\"row mt-3\">\r\n    <div class=\"col-md-6\">\r\n      <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\" title=\"Help\"\r\n        (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\"></p-button>\r\n    </div>\r\n    <div class=\"col-md-6 align-right\">\r\n\r\n    </div>\r\n  </div>\r\n</p-fieldset>\r\n\r\n<!-- Multiple values = true -->\r\n<p-fieldset [collapsed]=\"dynamicFormObject.collapsed\" (onBeforeToggle)=\"onGroupHeaderClick()\" [toggleable]=\"true\" *ngIf=\"dynamicFormObject.multipleValues\" [formGroup]=\"form\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n\r\n  <ng-template pTemplate=\"header\">\r\n    <div class=\"flex align-items-center\">\r\n      <label>{{dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label')}}</label>\r\n      <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n      <div class=\"form-control-footer text-color-gray-medium\">\r\n        <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n      <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\" [xpath]=\"xpath\"></debug-details>\r\n    </div>\r\n  </div>\r\n    \r\n  <!-- Vertical layout -->\r\n  <ng-container *ngIf=\"(!dynamicFormObject.format) || dynamicFormObject.format === 'vertical' || dynamicFormObject.format === 'float'\">\r\n\r\n    <div class=\"form-array-item\" *ngFor=\"let arrayGroupElement of form.controls[dynamicFormObject.code]['controls']; let arrayGroupElementIndex=index\">\r\n      <div class=\"form-array-item-actions\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n        <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n          (click)=\"removeFormArrayElement(arrayGroupElementIndex)\">\r\n          <i class=\"bi bi-trash\"></i>\r\n        </button>\r\n      </div>\r\n      <div class=\"form-array-item-content\">\r\n\r\n        <p-panel [toggleable]=\"true\" [collapsed]=\"dynamicFormObject.collapsed\">\r\n          <ng-template pTemplate=\"header\">\r\n            <!-- <span>[{{ arrayGroupElementIndex }}]&nbsp;</span> -->\r\n            <div class=\"form-array-item-header\"><label>{{ dynamicFormControlService.getHeader(dynamicForm, dynamicFormObject, form.controls[dynamicFormObject.code]['controls'][arrayGroupElementIndex].value,null) }}</label></div>\r\n          </ng-template>\r\n    \r\n          <div *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n            <dynamic-form-switcher-view \r\n              [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n              [dynamicForm]=\"dynamicForm\" \r\n              [dynamicFormObject]=\"child\" \r\n              [parentDynamicFormObject]=\"dynamicFormObject\" \r\n              [form]=\"arrayGroupElement\" \r\n              [parentForm]=\"parentForm\"\r\n              [operation]=\"operation\"\r\n              [debug]=\"debug\"\r\n              [xpath]=\"xpath\"\r\n              [readonly]=\"readonly\"\r\n              [hideLabel]=\"hideLabel\"\r\n              [statuses]=\"statuses\"\r\n              [status]=\"status\">\r\n            </dynamic-form-switcher-view>                \r\n          </div>\r\n\r\n          <div *ngIf=\"arrayGroupElement.errors\">\r\n            <form-errors-manager [errors]=\"arrayGroupElement.errors\" [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\"></form-errors-manager>\r\n          </div>\r\n\r\n        </p-panel>\r\n\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <!-- Horizontal layout -->\r\n  <ng-container *ngIf=\"dynamicFormObject.format === 'horizontal'\" class=\"form-array-item\">\r\n    <div class=\"layout-table\">\r\n      <div class=\"layout-table-header\">\r\n        <div class=\"layout-table-header-item\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n\r\n        </div>\r\n        <div class=\"layout-table-header-item\"  *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n              <div class=\"component-header\">\r\n                <label class=\"component-label text-color-gray-medium horizontal\" [id]=\"child.pathId\"> {{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, child, 'label') }}</label>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"layout-table-body\">        \r\n        <div class=\"layout-table-row\" *ngFor=\"let arrayGroupElement of form.controls[dynamicFormObject.code]['controls']; let arrayGroupElementIndex=index\">\r\n          <div class=\"layout-table-cell buttons\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n            <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n              (click)=\"removeFormArrayElement(arrayGroupElementIndex)\">\r\n              <i class=\"bi bi-trash\"></i>\r\n            </button>\r\n          </div>\r\n          <div class=\"layout-table-cell\" *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n            <dynamic-form-switcher-view \r\n              [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n              [dynamicForm]=\"dynamicForm\" \r\n              [dynamicFormObject]=\"child\" \r\n              [parentDynamicFormObject]=\"dynamicFormObject\" \r\n              [form]=\"arrayGroupElement\" \r\n              [parentForm]=\"parentForm\"\r\n              [operation]=\"operation\"\r\n              [debug]=\"debug\"\r\n              [xpath]=\"xpath\"\r\n              [readonly]=\"readonly\"\r\n              [hideLabel]=\"true\"\r\n              [statuses]=\"statuses\"\r\n              [status]=\"status\">\r\n            </dynamic-form-switcher-view>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"no-data-found\" *ngIf=\"form.controls[dynamicFormObject.code]['controls'].length === 0\">\r\n      No data found\r\n    </div>\r\n  </ng-container>\r\n\r\n  <div class=\"row mt-3\">\r\n    <div class=\"col-md-6\">\r\n      <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\" title=\"Help\"\r\n        (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\"></p-button>\r\n    </div>\r\n    <div class=\"col-md-6 align-right\">\r\n      <p-button *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\" icon=\"pi pi-plus\" [rounded]=\"true\" (click)=\"addFormArrayElement()\"></p-button>\r\n    </div>\r\n  </div>\r\n\r\n</p-fieldset>", styles: [".effect{opacity:1;animation:fade 5s linear}@keyframes fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator{width:100%}.form-check-label{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items{list-style:none;font-size:.9rem}.help-button{margin:5px}.help-button:hover{cursor:pointer}.component-header{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header .header-title{margin-left:10px}.form-control-footer{font-size:.8em}.mandatory{font-size:50%;vertical-align:top;color:red}.app-menu-disabled{pointer-events:none;opacity:.6}.header-title:hover{cursor:pointer}.status-label{font-size:1em;font-weight:700}.component-label{font-size:1em}.component-label.horizontal,label.title-category{font-size:.9em}.float{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float>*{margin-left:5px;margin-right:5px}.panel-body{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading{min-height:45px;display:flex}.panel-heading .header-title{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading button{max-height:40px}.multiple-values-item{display:flex;flex-grow:1}.multiple-values-item-content{width:95%}.multiple-values-item-body{width:95%;margin-bottom:5px}.array-items button{font-size:.9em}.header-title{vertical-align:middle}.card{margin-bottom:.5em}.refresh-button{margin:.5em}.refresh-button:hover{cursor:pointer}.ref-form{display:flex;align-items:baseline}img{max-width:100%;height:auto}.collapse{display:none!important}.collapse.in{display:block!important}.collapsing{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form .p-fieldset .p-fieldset-legend{font-size:.8em!important}.dynamic-form-summary-view{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view .form-tree{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view .form-questions{margin-left:5px}.dynamic-form-summary-view .form-tree,.dynamic-form-summary-view .form-questions{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form{width:100%}form .item-icon{font-size:20px!important}form .item-switcher{width:100%}form .item-switcher>div{width:100%}.control-cell.content{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu{width:55px}.form-group{border:solid 1px rgba(0,0,0,.125);margin:1em}\n"] }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i1$1.DialogService }, { type: i2.Router }, { type: FormDataService }, { type: i3$2.ConfirmationService }, { type: i2.ActivatedRoute }], { group: [{
            type: Input
        }], statuses: [{
            type: Input
        }], status: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], parentDynamicForm: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], parentDynamicFormObject: [{
            type: Input
        }], form: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], debug: [{
            type: Input
        }], readonly: [{
            type: Input
        }], operation: [{
            type: Input
        }], xpath: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], nextForm: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormGroupView, { className: "DynamicFormGroupView", filePath: "src/dynamic-form/dynamic-form-group/dynamic-form-group.ts", lineNumber: 21 }); })();

function DynamicFormGroupLatLongView_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵelementEnd();
} }
function DynamicFormGroupLatLongView_div_2_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵlistener("click", function DynamicFormGroupLatLongView_div_2_a_4_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.showHelp(ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help"))); });
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵelementEnd();
} }
function DynamicFormGroupLatLongView_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "label", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormGroupLatLongView_div_2_span_3_Template, 2, 0, "span", 10)(4, DynamicFormGroupLatLongView_div_2_a_4_Template, 2, 0, "a", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "label"), "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help") > "");
} }
function DynamicFormGroupLatLongView_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "input", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("readonly", ctx_r1.readonly)("placeholder", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, child_r3, "placeholder"))("step", 0.01)("formControl", ctx_r1.form.controls[child_r3.code]);
} }
function DynamicFormGroupLatLongView_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 22)(2, "input", 23);
    i0.ɵɵlistener("change", function DynamicFormGroupLatLongView_div_3_div_3_Template_input_change_2_listener() { i0.ɵɵrestoreView(_r4); const child_r3 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.useCurrentLocation(ctx_r1.form.controls[child_r3.code].value)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 24);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("readonly", ctx_r1.readonly)("formControl", ctx_r1.form.controls[child_r3.code]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, child_r3, "label"), " ");
} }
function DynamicFormGroupLatLongView_div_3_input_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "input", 25);
} if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", true)("formControl", ctx_r1.form.controls[child_r3.code])("placeholder", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, child_r3, "placeholder"));
} }
function DynamicFormGroupLatLongView_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 16);
    i0.ɵɵtemplate(2, DynamicFormGroupLatLongView_div_3_div_2_Template, 2, 4, "div", 17)(3, DynamicFormGroupLatLongView_div_3_div_3_Template, 5, 3, "div", 18)(4, DynamicFormGroupLatLongView_div_3_input_4_Template, 1, 3, "input", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const child_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", child_r3.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "number");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "checkbox");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "text");
} }
function DynamicFormGroupLatLongView_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "html-renderer", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("template", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "quickhelp"));
} }
function DynamicFormGroupLatLongView_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "debug-details", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", ctx_r1.dynamicFormObject)("data", ctx_r1.form.getRawValue())("xpath", ctx_r1.xpath);
} }
class DynamicFormGroupLatLongView {
    constructor(dynamicFormService, dynamicFormControlService, dialogService) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.dialogService = dialogService;
        this.debug = false;
        this.readonly = false;
        this.inBoundaries = true;
    }
    ngOnInit() {
        this.xpath = this.dynamicFormControlService.getXpath(this.dynamicFormObject, this.xpath);
        if (this.form.controls['useCurrentLocation'].value == "true" || this.form.controls['useCurrentLocation'].value == true) {
            this.getCurrentPosition();
        }
    }
    getCurrentPosition() {
        let _this = this;
        navigator.geolocation.getCurrentPosition(function (position) {
            _this.form.controls['latitude'].setValue(position.coords.latitude.toFixed(2));
            _this.form.controls['longitude'].setValue(position.coords.longitude.toFixed(2));
        });
    }
    useCurrentLocation(checked) {
        this.inBoundaries = true;
        if (checked) {
            this.getCoordinates();
        }
        else {
            this.form.controls['latitude'].setValue('');
            this.form.controls['longitude'].setValue('');
        }
    }
    getCoordinates() {
        this.getCurrentPosition();
    }
    showHelp(description) {
        const ref = this.dialogService.open(HelpComponent, {
            data: {
                description: description
            },
            header: 'Help',
            width: '50%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    static { this.ɵfac = function DynamicFormGroupLatLongView_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormGroupLatLongView)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1$1.DialogService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormGroupLatLongView, selectors: [["dynamic-form-group-lat-long-view"]], inputs: { dynamicForm: "dynamicForm", parentDynamicForm: "parentDynamicForm", dynamicFormObject: "dynamicFormObject", parentDynamicFormObject: "parentDynamicFormObject", form: "form", parentForm: "parentForm", debug: "debug", readonly: "readonly", operation: "operation", xpath: "xpath", hideLabel: "hideLabel" }, standalone: false, decls: 10, vars: 7, consts: [[1, "row", 3, "ngClass"], [1, "col-md-12"], ["class", "component-header", 4, "ngIf"], ["class", "col-md-12", 4, "ngFor", "ngForOf"], ["class", "form-control-footer text-color-gray-medium", 4, "ngIf"], ["class", "col-md-12 mt-2 mb-2", 4, "ngIf"], ["text-wrap", "", 1, "warning", 3, "hidden"], [1, "warning"], [1, "component-header"], [1, "component-label", "text-color-gray-dark", 3, "id"], ["class", "mandatory", 4, "ngIf"], ["class", "help-button", "title", "Help", 3, "click", 4, "ngIf"], [1, "mandatory"], [1, "bi", "bi-asterisk"], ["title", "Help", 1, "help-button", 3, "click"], [1, "bi", "bi-question-circle"], [1, "row", 3, "ngSwitch"], ["class", "col-md-12 mt-2", "layout", "row", "layout-wrap", "", 4, "ngSwitchCase"], ["class", "col-md-12", 4, "ngSwitchCase"], ["type", "text", 3, "hidden", "formControl", "placeholder", 4, "ngSwitchCase"], ["layout", "row", "layout-wrap", "", 1, "col-md-12", "mt-2"], ["type", "number", "ng-pattern", "/^[-+]?[0-9]+(\\.[0-9]{1,2})?$/", 1, "form-control", 3, "readonly", "placeholder", "step", "formControl"], [1, "form-check"], ["type", "checkbox", 1, "form-check-input", 3, "change", "readonly", "formControl"], [1, "form-check-label"], ["type", "text", 3, "hidden", "formControl", "placeholder"], [1, "form-control-footer", "text-color-gray-medium"], [3, "template"], [1, "col-md-12", "mt-2", "mb-2"], [3, "dynamicForm", "dynamicFormObject", "data", "xpath"]], template: function DynamicFormGroupLatLongView_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, DynamicFormGroupLatLongView_div_2_Template, 5, 4, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, DynamicFormGroupLatLongView_div_3_Template, 5, 4, "div", 3);
            i0.ɵɵelementStart(4, "div", 1);
            i0.ɵɵtemplate(5, DynamicFormGroupLatLongView_div_5_Template, 2, 1, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, DynamicFormGroupLatLongView_div_6_Template, 2, 4, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 6)(8, "span", 7);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.dynamicForm.cssClass && ctx.dynamicForm.cssClass.latlong || ctx.dynamicFormObject.cssClass);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.hideLabel === false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.dynamicFormService.getComponentChildren(ctx.dynamicFormObject));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.dynamicFormControlService.getProperty(ctx.parentForm.getRawValue(), ctx.dynamicForm, ctx.dynamicFormObject, "quickhelp") > "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.debug);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.inBoundaries);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", "warn.coords", " ");
        } }, styles: [".effect[_ngcontent-%COMP%]{opacity:1;animation:_ngcontent-%COMP%_fade 5s linear}@keyframes _ngcontent-%COMP%_fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator[_ngcontent-%COMP%]{width:100%}.form-check-label[_ngcontent-%COMP%]{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items[_ngcontent-%COMP%]{list-style:none;font-size:.9rem}.help-button[_ngcontent-%COMP%]{margin:5px}.help-button[_ngcontent-%COMP%]:hover{cursor:pointer}.component-header[_ngcontent-%COMP%]{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{margin-left:10px}.form-control-footer[_ngcontent-%COMP%]{font-size:.8em}.mandatory[_ngcontent-%COMP%]{font-size:50%;vertical-align:top;color:red}.app-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}.header-title[_ngcontent-%COMP%]:hover{cursor:pointer}.status-label[_ngcontent-%COMP%]{font-size:1em;font-weight:700}.component-label[_ngcontent-%COMP%]{font-size:1em}.component-label.horizontal[_ngcontent-%COMP%], label.title-category[_ngcontent-%COMP%]{font-size:.9em}.float[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.panel-body[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading[_ngcontent-%COMP%]{min-height:45px;display:flex}.panel-heading[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-height:40px}.multiple-values-item[_ngcontent-%COMP%]{display:flex;flex-grow:1}.multiple-values-item-content[_ngcontent-%COMP%]{width:95%}.multiple-values-item-body[_ngcontent-%COMP%]{width:95%;margin-bottom:5px}.array-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:.9em}.header-title[_ngcontent-%COMP%]{vertical-align:middle}.card[_ngcontent-%COMP%]{margin-bottom:.5em}.refresh-button[_ngcontent-%COMP%]{margin:.5em}.refresh-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ref-form[_ngcontent-%COMP%]{display:flex;align-items:baseline}img[_ngcontent-%COMP%]{max-width:100%;height:auto}.collapse[_ngcontent-%COMP%]{display:none!important}.collapse.in[_ngcontent-%COMP%]{display:block!important}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form[_ngcontent-%COMP%]   .p-fieldset[_ngcontent-%COMP%]   .p-fieldset-legend[_ngcontent-%COMP%]{font-size:.8em!important}.dynamic-form-summary-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%]{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{margin-left:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%], .dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-icon[_ngcontent-%COMP%]{font-size:20px!important}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.control-cell.content[_ngcontent-%COMP%]{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu[_ngcontent-%COMP%]{width:55px}.form-group[_ngcontent-%COMP%]{border:solid 1px rgba(0,0,0,.125);margin:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormGroupLatLongView, [{
        type: Component,
        args: [{ selector: 'dynamic-form-group-lat-long-view', standalone: false, template: "\r\n<div class=\"row\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.latlong) || dynamicFormObject.cssClass\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"component-header\" *ngIf=\"hideLabel === false\">\r\n      <label class=\"component-label text-color-gray-dark\" [id]=\"dynamicFormObject.pathId\"> {{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label') }}</label>\r\n      <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n      <a *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\" class=\"help-button\" title=\"Help\" (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\" >\r\n        <i class=\"bi bi-question-circle\"></i>\r\n      </a>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-12\" *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n    <div class=\"row\" [ngSwitch]=\"child.type\">\r\n        <div class=\"col-md-12 mt-2\" *ngSwitchCase=\"'number'\" layout=\"row\" layout-wrap>\r\n          <input\r\n            [readonly]=\"readonly\"\r\n            class=\"form-control\"\r\n            [placeholder]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, child, 'placeholder')\"\r\n            type=\"number\"\r\n            [step]=\"0.0100\"\r\n            ng-pattern=\"/^[-+]?[0-9]+(\\.[0-9]{1,2})?$/\"\r\n            [formControl]=\"$any(form.controls[child.code])\">\r\n        </div>\r\n  \r\n        <div class=\"col-md-12\" *ngSwitchCase=\"'checkbox'\">\r\n          <div class=\"form-check\">\r\n            <input [readonly]=\"readonly\" class=\"form-check-input\" type=\"checkbox\" [formControl]=\"$any(form.controls[child.code])\" (change)=\"useCurrentLocation(form.controls[child.code].value)\">\r\n            <label class=\"form-check-label\">\r\n              {{dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, child, 'label')}}\r\n            </label>\r\n          </div>\r\n        </div>\r\n  \r\n        <input [hidden]=\"true\" type=\"text\" *ngSwitchCase=\"'text'\" [formControl]=\"$any(form.controls[child.code])\" [placeholder]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, child, 'placeholder')\">\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-12\">\r\n    <div class=\"form-control-footer text-color-gray-medium\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n      <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n    <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\" [xpath]=\"xpath\"></debug-details>\r\n  </div>\r\n</div>\r\n<div [hidden]=\"inBoundaries\" text-wrap class=\"warning\">\r\n  <span class=\"warning\">\r\n    {{'warn.coords'}}\r\n  </span>\r\n</div>", styles: [".effect{opacity:1;animation:fade 5s linear}@keyframes fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator{width:100%}.form-check-label{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items{list-style:none;font-size:.9rem}.help-button{margin:5px}.help-button:hover{cursor:pointer}.component-header{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header .header-title{margin-left:10px}.form-control-footer{font-size:.8em}.mandatory{font-size:50%;vertical-align:top;color:red}.app-menu-disabled{pointer-events:none;opacity:.6}.header-title:hover{cursor:pointer}.status-label{font-size:1em;font-weight:700}.component-label{font-size:1em}.component-label.horizontal,label.title-category{font-size:.9em}.float{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float>*{margin-left:5px;margin-right:5px}.panel-body{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading{min-height:45px;display:flex}.panel-heading .header-title{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading button{max-height:40px}.multiple-values-item{display:flex;flex-grow:1}.multiple-values-item-content{width:95%}.multiple-values-item-body{width:95%;margin-bottom:5px}.array-items button{font-size:.9em}.header-title{vertical-align:middle}.card{margin-bottom:.5em}.refresh-button{margin:.5em}.refresh-button:hover{cursor:pointer}.ref-form{display:flex;align-items:baseline}img{max-width:100%;height:auto}.collapse{display:none!important}.collapse.in{display:block!important}.collapsing{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form .p-fieldset .p-fieldset-legend{font-size:.8em!important}.dynamic-form-summary-view{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view .form-tree{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view .form-questions{margin-left:5px}.dynamic-form-summary-view .form-tree,.dynamic-form-summary-view .form-questions{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form{width:100%}form .item-icon{font-size:20px!important}form .item-switcher{width:100%}form .item-switcher>div{width:100%}.control-cell.content{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu{width:55px}.form-group{border:solid 1px rgba(0,0,0,.125);margin:1em}\n"] }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i1$1.DialogService }], { dynamicForm: [{
            type: Input
        }], parentDynamicForm: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], parentDynamicFormObject: [{
            type: Input
        }], form: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], debug: [{
            type: Input
        }], readonly: [{
            type: Input
        }], operation: [{
            type: Input
        }], xpath: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormGroupLatLongView, { className: "DynamicFormGroupLatLongView", filePath: "src/dynamic-form/dynamic-form-group-lat-long/dynamic-form-group-lat-long.ts", lineNumber: 16 }); })();

function DynamicFormGroupselectView_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementEnd();
} }
function DynamicFormGroupselectView_div_2_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵlistener("click", function DynamicFormGroupselectView_div_2_a_4_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.showHelp(ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help"))); });
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵelementEnd();
} }
function DynamicFormGroupselectView_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "label", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormGroupselectView_div_2_span_3_Template, 2, 0, "span", 11)(4, DynamicFormGroupselectView_div_2_a_4_Template, 2, 0, "a", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.dynamicFormObject.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "label"), "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help") > "");
} }
function DynamicFormGroupselectView_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r1.component)("ngClass", child_r3.type === "separator" ? "separator" : "")("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", child_r3)("parentDynamicFormObject", ctx_r1.dynamicFormObject)("form", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code])("parentForm", ctx_r1.parentForm)("operation", ctx_r1.operation)("debug", ctx_r1.debug)("xpath", ctx_r1.xpath)("readonly", ctx_r1.readonly)("hideLabel", ctx_r1.hideLabel)("statuses", ctx_r1.statuses)("status", ctx_r1.status);
} }
function DynamicFormGroupselectView_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 1);
    i0.ɵɵtemplate(2, DynamicFormGroupselectView_div_3_div_2_Template, 2, 14, "div", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.dynamicForm.cssClass && ctx_r1.dynamicForm.cssClass.group || ctx_r1.dynamicFormObject.cssClass);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
} }
function DynamicFormGroupselectView_div_4_dynamic_form_switcher_view_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "dynamic-form-switcher-view", 19);
} if (rf & 2) {
    const child_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("group", ctx_r1.component)("ngClass", child_r4.type === "separator" ? "separator" : "")("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", child_r4)("parentDynamicFormObject", ctx_r1.dynamicFormObject)("form", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code])("parentForm", ctx_r1.parentForm)("operation", ctx_r1.operation)("debug", ctx_r1.debug)("xpath", ctx_r1.xpath)("readonly", ctx_r1.readonly)("hideLabel", ctx_r1.hideLabel)("statuses", ctx_r1.statuses)("status", ctx_r1.status);
} }
function DynamicFormGroupselectView_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, DynamicFormGroupselectView_div_4_dynamic_form_switcher_view_1_Template, 1, 14, "dynamic-form-switcher-view", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.dynamicForm.cssClass && ctx_r1.dynamicForm.cssClass.group || ctx_r1.dynamicFormObject.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
} }
function DynamicFormGroupselectView_ng_container_5_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "div", 29)(2, "div", 1)(3, "div", 9)(4, "label", 30);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const child_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", child_r5.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, child_r5, "label"), "");
} }
function DynamicFormGroupselectView_ng_container_5_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormGroupselectView_ng_container_5_ng_container_3_div_1_Template, 6, 2, "div", 27);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getComponentClass(ctx_r1.parentForm || ctx_r1.form, ctx_r1.dynamicForm, child_r5, ctx_r1.xpath, ctx_r1.debug) !== "hidden");
} }
function DynamicFormGroupselectView_ng_container_5_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("group", ctx_r1.component)("ngClass", child_r6.type === "separator" ? "separator" : "")("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", child_r6)("parentDynamicFormObject", ctx_r1.dynamicFormObject)("form", ctx_r1.form.controls[ctx_r1.dynamicFormObject.code])("parentForm", ctx_r1.parentForm)("operation", ctx_r1.operation)("debug", ctx_r1.debug)("xpath", ctx_r1.xpath)("readonly", ctx_r1.readonly)("hideLabel", true)("statuses", ctx_r1.statuses)("status", ctx_r1.status);
} }
function DynamicFormGroupselectView_ng_container_5_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormGroupselectView_ng_container_5_ng_container_6_div_1_Template, 2, 14, "div", 31);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormControlService.getComponentClass(ctx_r1.parentForm || ctx_r1.form, ctx_r1.dynamicForm, child_r6, ctx_r1.xpath, ctx_r1.debug) !== "hidden");
} }
function DynamicFormGroupselectView_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 22);
    i0.ɵɵelementStart(1, "div", 23)(2, "div", 24);
    i0.ɵɵtemplate(3, DynamicFormGroupselectView_ng_container_5_ng_container_3_Template, 2, 1, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 25)(5, "div", 26);
    i0.ɵɵtemplate(6, DynamicFormGroupselectView_ng_container_5_ng_container_6_Template, 2, 1, "ng-container", 18);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.dynamicFormService.getComponentChildren(ctx_r1.dynamicFormObject));
} }
function DynamicFormGroupselectView_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33)(1, "div", 34)(2, "p-button", 35);
    i0.ɵɵlistener("click", function DynamicFormGroupselectView_div_6_Template_p_button_click_2_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.showHelp(ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "help"))); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(3, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function DynamicFormGroupselectView_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelement(1, "html-renderer", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("template", ctx_r1.dynamicFormControlService.getProperty(ctx_r1.parentForm.getRawValue(), ctx_r1.dynamicForm, ctx_r1.dynamicFormObject, "quickhelp"));
} }
function DynamicFormGroupselectView_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelement(1, "debug-details", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r1.dynamicForm)("dynamicFormObject", ctx_r1.dynamicFormObject)("data", ctx_r1.form.getRawValue())("xpath", ctx_r1.xpath);
} }
class DynamicFormGroupselectView {
    constructor(dynamicFormService, dynamicFormControlService, dialogService, optionsService, searchService, utilsService) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.dialogService = dialogService;
        this.optionsService = optionsService;
        this.searchService = searchService;
        this.utilsService = utilsService;
        this.debug = false;
        this.readonly = false;
        this.onOptionsUpdated = new EventEmitter();
        this.expanded = false;
    }
    async ngOnInit() {
        this.xpath = this.dynamicFormControlService.getXpath(this.dynamicFormObject, this.xpath);
        this.component = this;
        this.updateComponent(this.form.controls[this.dynamicFormObject.code].getRawValue());
        //I subscribe to the change of my value
        this.form.controls[this.dynamicFormObject.code].valueChanges.subscribe(value => {
            this.updateComponent(value);
        });
    }
    updateComponent(value) {
        if (!this.isEmpty(value)) {
            this.extractOptions(this.form.controls[this.dynamicFormObject.code].getRawValue(), (items) => {
                this.onOptionsUpdated.emit(items);
            });
        }
        else {
            //This makes children reset their options
            this.onOptionsUpdated.emit([]);
        }
    }
    extractOptions(userFilters, callback) {
        let index = this.dynamicForm.options.findIndex(item => item.id === this.dynamicFormObject.refOptionsId);
        if (index >= 0) {
            if (this.dynamicForm.options[index].type === 'reference' || this.dynamicForm.options[index].type === 'standard' || this.dynamicForm.options[index].type === 'external') {
                this.optionsService.getRemoteItems(this.statuses, this.dynamicFormControlService, this.dynamicForm, this.dynamicFormObject, this.parentForm, this.dynamicForm.options[index], this.dynamicFormObject.refOptionsFilters, userFilters).subscribe(res => {
                    this.items = this.optionsService.mapRemoteItems(this.dynamicForm.options[index], res, this.dynamicFormObject.refOptionsMappings);
                    if (callback) {
                        callback(this.items);
                    }
                }, err => {
                    this.searchService.manageError(err, 'Error reading ' + this.dynamicForm.options[index].type + ' items');
                });
            }
            else {
                this.items = [];
                if (callback) {
                    callback(this.items);
                }
            }
        }
        else {
            this.items = [];
            if (callback) {
                callback(this.items);
            }
        }
    }
    isEmpty(filter) {
        let empty = true;
        if (filter) {
            for (let key in filter) {
                if (filter[key] !== null && filter[key] !== undefined) {
                    empty = false;
                }
            }
        }
        return empty;
    }
    showHelp(description) {
        const ref = this.dialogService.open(HelpComponent, {
            data: {
                description: description
            },
            header: 'Help',
            width: '50%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    static { this.ɵfac = function DynamicFormGroupselectView_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormGroupselectView)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.OptionsService), i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i1.UtilsService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormGroupselectView, selectors: [["dynamic-form-groupselect-view"]], inputs: { statuses: "statuses", status: "status", dynamicForm: "dynamicForm", parentDynamicForm: "parentDynamicForm", dynamicFormObject: "dynamicFormObject", parentDynamicFormObject: "parentDynamicFormObject", form: "form", parentForm: "parentForm", debug: "debug", readonly: "readonly", operation: "operation", xpath: "xpath", hideLabel: "hideLabel" }, outputs: { onOptionsUpdated: "onOptionsUpdated" }, standalone: false, decls: 9, vars: 9, consts: [[1, "row", 3, "formGroup", "ngClass"], [1, "col-md-12"], ["class", "component-header", 4, "ngIf"], ["class", "row form-group-children", 3, "ngClass", 4, "ngIf"], ["class", "float form-group-children", 3, "ngClass", 4, "ngIf"], ["class", "form-array-item", 4, "ngIf"], ["class", "row mt-3", 4, "ngIf"], ["class", "form-control-footer text-color-gray-medium", 4, "ngIf"], ["class", "col-md-12 mt-2 mb-2", 4, "ngIf"], [1, "component-header"], [1, "component-label", "text-color-gray-dark", 3, "id"], ["class", "mandatory", 4, "ngIf"], ["class", "help-button", "title", "Help", 3, "click", 4, "ngIf"], [1, "mandatory"], [1, "bi", "bi-asterisk"], ["title", "Help", 1, "help-button", 3, "click"], [1, "bi", "bi-question-circle"], [1, "row", "form-group-children", 3, "ngClass"], [4, "ngFor", "ngForOf"], [3, "group", "ngClass", "dynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "debug", "xpath", "readonly", "hideLabel", "statuses", "status"], [1, "float", "form-group-children", 3, "ngClass"], [3, "group", "ngClass", "dynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "debug", "xpath", "readonly", "hideLabel", "statuses", "status", 4, "ngFor", "ngForOf"], [1, "form-array-item"], [1, "layout-table"], [1, "layout-table-header"], [1, "layout-table-body"], [1, "layout-table-row"], ["class", "layout-table-header-item", 4, "ngIf"], [1, "layout-table-header-item"], [1, "row"], [1, "component-label", "text-color-gray-medium", "horizontal", 3, "id"], ["class", "layout-table-cell", 4, "ngIf"], [1, "layout-table-cell"], [1, "row", "mt-3"], [1, "col-md-6"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "click", "rounded", "outlined"], [1, "col-md-6", "align-right"], [1, "form-control-footer", "text-color-gray-medium"], [3, "template"], [1, "col-md-12", "mt-2", "mb-2"], [3, "dynamicForm", "dynamicFormObject", "data", "xpath"]], template: function DynamicFormGroupselectView_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, DynamicFormGroupselectView_div_2_Template, 5, 4, "div", 2)(3, DynamicFormGroupselectView_div_3_Template, 3, 2, "div", 3)(4, DynamicFormGroupselectView_div_4_Template, 2, 2, "div", 4)(5, DynamicFormGroupselectView_ng_container_5_Template, 7, 2, "ng-container", 5)(6, DynamicFormGroupselectView_div_6_Template, 4, 2, "div", 6)(7, DynamicFormGroupselectView_div_7_Template, 2, 1, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, DynamicFormGroupselectView_div_8_Template, 2, 4, "div", 8);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.form.controls[ctx.dynamicFormObject.code])("ngClass", ctx.dynamicForm.cssClass && ctx.dynamicForm.cssClass.groupselect || ctx.dynamicFormObject.cssClass);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.hideLabel === false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.dynamicFormObject.format || ctx.dynamicFormObject.format === "vertical");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.format === "float");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.format === "horizontal");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormControlService.getProperty(ctx.parentForm.getRawValue(), ctx.dynamicForm, ctx.dynamicFormObject, "help") > "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormControlService.getProperty(ctx.parentForm.getRawValue(), ctx.dynamicForm, ctx.dynamicFormObject, "quickhelp") > "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.debug);
        } }, styles: [".effect[_ngcontent-%COMP%]{opacity:1;animation:_ngcontent-%COMP%_fade 5s linear}@keyframes _ngcontent-%COMP%_fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator[_ngcontent-%COMP%]{width:100%}.form-check-label[_ngcontent-%COMP%]{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items[_ngcontent-%COMP%]{list-style:none;font-size:.9rem}.help-button[_ngcontent-%COMP%]{margin:5px}.help-button[_ngcontent-%COMP%]:hover{cursor:pointer}.component-header[_ngcontent-%COMP%]{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{margin-left:10px}.form-control-footer[_ngcontent-%COMP%]{font-size:.8em}.mandatory[_ngcontent-%COMP%]{font-size:50%;vertical-align:top;color:red}.app-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}.header-title[_ngcontent-%COMP%]:hover{cursor:pointer}.status-label[_ngcontent-%COMP%]{font-size:1em;font-weight:700}.component-label[_ngcontent-%COMP%]{font-size:1em}.component-label.horizontal[_ngcontent-%COMP%], label.title-category[_ngcontent-%COMP%]{font-size:.9em}.float[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.panel-body[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading[_ngcontent-%COMP%]{min-height:45px;display:flex}.panel-heading[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-height:40px}.multiple-values-item[_ngcontent-%COMP%]{display:flex;flex-grow:1}.multiple-values-item-content[_ngcontent-%COMP%]{width:95%}.multiple-values-item-body[_ngcontent-%COMP%]{width:95%;margin-bottom:5px}.array-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:.9em}.header-title[_ngcontent-%COMP%]{vertical-align:middle}.card[_ngcontent-%COMP%]{margin-bottom:.5em}.refresh-button[_ngcontent-%COMP%]{margin:.5em}.refresh-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ref-form[_ngcontent-%COMP%]{display:flex;align-items:baseline}img[_ngcontent-%COMP%]{max-width:100%;height:auto}.collapse[_ngcontent-%COMP%]{display:none!important}.collapse.in[_ngcontent-%COMP%]{display:block!important}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form[_ngcontent-%COMP%]   .p-fieldset[_ngcontent-%COMP%]   .p-fieldset-legend[_ngcontent-%COMP%]{font-size:.8em!important}.dynamic-form-summary-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%]{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{margin-left:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%], .dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-icon[_ngcontent-%COMP%]{font-size:20px!important}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.control-cell.content[_ngcontent-%COMP%]{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu[_ngcontent-%COMP%]{width:55px}.form-group[_ngcontent-%COMP%]{border:solid 1px rgba(0,0,0,.125);margin:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormGroupselectView, [{
        type: Component,
        args: [{ selector: 'dynamic-form-groupselect-view', standalone: false, template: "<div [formGroup]=\"$any(form.controls[dynamicFormObject.code])\" class=\"row\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.groupselect) || dynamicFormObject.cssClass\">  \r\n  <div class=\"col-md-12\">\r\n    <div class=\"component-header\" *ngIf=\"hideLabel === false\">\r\n      <label class=\"component-label text-color-gray-dark\" [id]=\"dynamicFormObject.pathId\"> {{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label') }}</label>\r\n      <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n      <a *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\" class=\"help-button\" title=\"Help\" (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\" >\r\n        <i class=\"bi bi-question-circle\"></i>\r\n      </a>\r\n    </div>\r\n\r\n    <!-- Vertical layout -->\r\n    <div *ngIf=\"(!dynamicFormObject.format) || dynamicFormObject.format === 'vertical'\" class=\"row form-group-children\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n      <div class=\"col-md-12\">\r\n        <div *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n          <dynamic-form-switcher-view \r\n            [group]=\"component\"\r\n            [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n            [dynamicForm]=\"dynamicForm\" \r\n            [dynamicFormObject]=\"child\" \r\n            [parentDynamicFormObject]=\"dynamicFormObject\" \r\n            [form]=\"$any(form.controls[dynamicFormObject.code])\" \r\n            [parentForm]=\"parentForm\"\r\n            [operation]=\"operation\"\r\n            [debug]=\"debug\"\r\n            [xpath]=\"xpath\"\r\n            [readonly]=\"readonly\"\r\n            [hideLabel]=\"hideLabel\"\r\n            [statuses]=\"statuses\"\r\n            [status]=\"status\">\r\n          </dynamic-form-switcher-view>\r\n        </div>     \r\n      </div>\r\n    </div>\r\n\r\n    <!-- Float layout -->\r\n    <div *ngIf=\"dynamicFormObject.format === 'float'\" class=\"float form-group-children\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n      <dynamic-form-switcher-view \r\n        *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\"\r\n        [group]=\"component\"\r\n        [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n        [dynamicForm]=\"dynamicForm\" \r\n        [dynamicFormObject]=\"child\" \r\n        [parentDynamicFormObject]=\"dynamicFormObject\" \r\n        [form]=\"$any(form.controls[dynamicFormObject.code])\" \r\n        [parentForm]=\"parentForm\"\r\n        [operation]=\"operation\"\r\n        [debug]=\"debug\"\r\n        [xpath]=\"xpath\"\r\n        [readonly]=\"readonly\"\r\n        [hideLabel]=\"hideLabel\"\r\n        [statuses]=\"statuses\"\r\n        [status]=\"status\">\r\n      </dynamic-form-switcher-view>\r\n    </div>\r\n\r\n    <!-- Horizontal layout -->\r\n  <ng-container *ngIf=\"dynamicFormObject.format === 'horizontal'\" class=\"form-array-item\">\r\n    <div class=\"layout-table\">\r\n      <div class=\"layout-table-header\">\r\n        <ng-container *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n          <div class=\"layout-table-header-item\" *ngIf=\"dynamicFormControlService.getComponentClass(parentForm || form, dynamicForm, child, xpath, debug) !== 'hidden'\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"component-header\">\r\n                  <label class=\"component-label text-color-gray-medium horizontal\" [id]=\"child.pathId\"> {{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, child, 'label') }}</label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n      <div class=\"layout-table-body\">\r\n        <div class=\"layout-table-row\">\r\n          <ng-container *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n            <div class=\"layout-table-cell\" *ngIf=\"dynamicFormControlService.getComponentClass(parentForm || form, dynamicForm, child, xpath, debug) !== 'hidden'\">\r\n              <dynamic-form-switcher-view \r\n                [group]=\"component\"\r\n                [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n                [dynamicForm]=\"dynamicForm\" \r\n                [dynamicFormObject]=\"child\" \r\n                [parentDynamicFormObject]=\"dynamicFormObject\" \r\n                [form]=\"$any(form.controls[dynamicFormObject.code])\" \r\n                [parentForm]=\"parentForm\"\r\n                [operation]=\"operation\"\r\n                [debug]=\"debug\"\r\n                [xpath]=\"xpath\"\r\n                [readonly]=\"readonly\"\r\n                [hideLabel]=\"true\"\r\n                [statuses]=\"statuses\"\r\n                [status]=\"status\">\r\n              </dynamic-form-switcher-view>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <div class=\"row mt-3\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\">\r\n    <div class=\"col-md-6\">\r\n      <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\" title=\"Help\"\r\n        (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\"></p-button>\r\n    </div>\r\n    <div class=\"col-md-6 align-right\">\r\n\r\n    </div>\r\n  </div>\r\n\r\n    <div class=\"form-control-footer text-color-gray-medium\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n      <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n    <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\" [xpath]=\"xpath\"></debug-details>\r\n  </div>\r\n</div>", styles: [".effect{opacity:1;animation:fade 5s linear}@keyframes fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator{width:100%}.form-check-label{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items{list-style:none;font-size:.9rem}.help-button{margin:5px}.help-button:hover{cursor:pointer}.component-header{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header .header-title{margin-left:10px}.form-control-footer{font-size:.8em}.mandatory{font-size:50%;vertical-align:top;color:red}.app-menu-disabled{pointer-events:none;opacity:.6}.header-title:hover{cursor:pointer}.status-label{font-size:1em;font-weight:700}.component-label{font-size:1em}.component-label.horizontal,label.title-category{font-size:.9em}.float{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float>*{margin-left:5px;margin-right:5px}.panel-body{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading{min-height:45px;display:flex}.panel-heading .header-title{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading button{max-height:40px}.multiple-values-item{display:flex;flex-grow:1}.multiple-values-item-content{width:95%}.multiple-values-item-body{width:95%;margin-bottom:5px}.array-items button{font-size:.9em}.header-title{vertical-align:middle}.card{margin-bottom:.5em}.refresh-button{margin:.5em}.refresh-button:hover{cursor:pointer}.ref-form{display:flex;align-items:baseline}img{max-width:100%;height:auto}.collapse{display:none!important}.collapse.in{display:block!important}.collapsing{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form .p-fieldset .p-fieldset-legend{font-size:.8em!important}.dynamic-form-summary-view{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view .form-tree{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view .form-questions{margin-left:5px}.dynamic-form-summary-view .form-tree,.dynamic-form-summary-view .form-questions{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form{width:100%}form .item-icon{font-size:20px!important}form .item-switcher{width:100%}form .item-switcher>div{width:100%}.control-cell.content{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu{width:55px}.form-group{border:solid 1px rgba(0,0,0,.125);margin:1em}\n"] }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i1$1.DialogService }, { type: i1.OptionsService }, { type: i1.SearchService }, { type: i1.UtilsService }], { statuses: [{
            type: Input
        }], status: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], parentDynamicForm: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], parentDynamicFormObject: [{
            type: Input
        }], form: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], debug: [{
            type: Input
        }], readonly: [{
            type: Input
        }], operation: [{
            type: Input
        }], xpath: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], onOptionsUpdated: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormGroupselectView, { className: "DynamicFormGroupselectView", filePath: "src/dynamic-form/dynamic-form-groupselect/dynamic-form-groupselect.ts", lineNumber: 22 }); })();

function DynamicFormNestedFormView_p_fieldset_0_ng_template_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵelementEnd();
} }
function DynamicFormNestedFormView_p_fieldset_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormNestedFormView_p_fieldset_0_ng_template_1_span_3_Template, 2, 0, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
} }
function DynamicFormNestedFormView_p_fieldset_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵelement(2, "html-renderer", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("template", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp"));
} }
function DynamicFormNestedFormView_p_fieldset_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "debug-details", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("data", ctx_r0.form.getRawValue())("xpath", ctx_r0.xpath);
} }
function DynamicFormNestedFormView_p_fieldset_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19);
    i0.ɵɵelement(2, "dynamic-form", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code])("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.form || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cssClass", ctx_r0.dynamicForm.cssClass)("parentForm", ctx_r0.parentForm)("form", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code])("formData", ctx_r0.parentForm.getRawValue())("params", ctx_r0.dynamicFormObject.params)("xpath", ctx_r0.xpath)("debug", ctx_r0.debug)("dynamicForm", ctx_r0.nestedForm)("parentDynamicForm", ctx_r0.parentDynamicForm);
} }
function DynamicFormNestedFormView_p_fieldset_0_div_6_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 23);
    i0.ɵɵlistener("click", function DynamicFormNestedFormView_p_fieldset_0_div_6_li_2_Template_a_click_1_listener() { const item_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.openSubformItem(item_r3, item_r3.metadata.id, item_r3.status)); });
    i0.ɵɵelement(2, "i", 24);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getHeader(ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, item_r3.document, null, ctx_r0.externalForm, item_r3.status, ctx_r0.statuses));
} }
function DynamicFormNestedFormView_p_fieldset_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "ul", 21);
    i0.ɵɵtemplate(2, DynamicFormNestedFormView_p_fieldset_0_div_6_li_2_Template, 5, 1, "li", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.form)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.form || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
function DynamicFormNestedFormView_p_fieldset_0_p_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 25);
    i0.ɵɵlistener("click", function DynamicFormNestedFormView_p_fieldset_0_p_button_9_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function DynamicFormNestedFormView_p_fieldset_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-fieldset", 1);
    i0.ɵɵtemplate(1, DynamicFormNestedFormView_p_fieldset_0_ng_template_1_Template, 4, 2, "ng-template", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, DynamicFormNestedFormView_p_fieldset_0_div_3_Template, 3, 1, "div", 4)(4, DynamicFormNestedFormView_p_fieldset_0_div_4_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DynamicFormNestedFormView_p_fieldset_0_div_5_Template, 3, 11, "div", 5)(6, DynamicFormNestedFormView_p_fieldset_0_div_6_Template, 3, 3, "div", 5);
    i0.ɵɵelementStart(7, "div", 6)(8, "div", 7);
    i0.ɵɵtemplate(9, DynamicFormNestedFormView_p_fieldset_0_p_button_9_Template, 1, 2, "p-button", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "div", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("collapsed", ctx_r0.dynamicFormObject.collapsed)("toggleable", true)("formGroup", ctx_r0.form)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.group || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp") > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.debug);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.refFormType !== "external" && ctx_r0.nestedForm);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.refFormType === "external" && ctx_r0.items);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
} }
function DynamicFormNestedFormView_p_fieldset_1_ng_template_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵelementEnd();
} }
function DynamicFormNestedFormView_p_fieldset_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormNestedFormView_p_fieldset_1_ng_template_1_span_3_Template, 2, 0, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
} }
function DynamicFormNestedFormView_p_fieldset_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵelement(2, "html-renderer", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("template", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp"));
} }
function DynamicFormNestedFormView_p_fieldset_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "debug-details", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("data", ctx_r0.form.getRawValue())("xpath", ctx_r0.xpath);
} }
function DynamicFormNestedFormView_p_fieldset_1_div_5_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33)(1, "button", 34);
    i0.ɵɵlistener("click", function DynamicFormNestedFormView_p_fieldset_1_div_5_div_1_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r5); const arrayGroupElementIndex_r6 = i0.ɵɵnextContext().index; const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.removeFormArrayElement(arrayGroupElementIndex_r6)); });
    i0.ɵɵelement(2, "i", 35);
    i0.ɵɵelementEnd()();
} }
function DynamicFormNestedFormView_p_fieldset_1_div_5_div_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const arrayGroupElementIndex_r6 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getHeader(ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, ctx_r0.form.controls[ctx_r0.dynamicFormObject.code]["controls"][arrayGroupElementIndex_r6].value, null));
} }
function DynamicFormNestedFormView_p_fieldset_1_div_5_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "form-errors-manager", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const arrayGroupElement_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("errors", arrayGroupElement_r7.errors)("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject);
} }
function DynamicFormNestedFormView_p_fieldset_1_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, DynamicFormNestedFormView_p_fieldset_1_div_5_div_1_div_1_Template, 3, 0, "div", 29);
    i0.ɵɵelementStart(2, "div", 30)(3, "p-panel", 31);
    i0.ɵɵtemplate(4, DynamicFormNestedFormView_p_fieldset_1_div_5_div_1_ng_template_4_Template, 3, 1, "ng-template", 2);
    i0.ɵɵelement(5, "dynamic-form", 20);
    i0.ɵɵtemplate(6, DynamicFormNestedFormView_p_fieldset_1_div_5_div_1_div_6_Template, 2, 3, "div", 32);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const arrayGroupElement_r7 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly || ctx_r0.operation === "edit" && !ctx_r0.dynamicFormObject.editBlocked);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("toggleable", true)("collapsed", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cssClass", ctx_r0.dynamicForm.cssClass)("parentForm", ctx_r0.parentForm)("form", arrayGroupElement_r7)("formData", ctx_r0.parentForm.getRawValue())("params", ctx_r0.dynamicFormObject.params)("xpath", ctx_r0.xpath)("debug", ctx_r0.debug)("dynamicForm", ctx_r0.nestedForm)("parentDynamicForm", ctx_r0.parentDynamicForm);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", arrayGroupElement_r7.errors);
} }
function DynamicFormNestedFormView_p_fieldset_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, DynamicFormNestedFormView_p_fieldset_1_div_5_div_1_Template, 7, 13, "div", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.form)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.form || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code]["controls"]);
} }
function DynamicFormNestedFormView_p_fieldset_1_div_6_li_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 23);
    i0.ɵɵlistener("click", function DynamicFormNestedFormView_p_fieldset_1_div_6_li_4_Template_a_click_1_listener() { const item_r9 = i0.ɵɵrestoreView(_r8).$implicit; const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.openSubformItem(item_r9, item_r9.metadata.id, item_r9.status)); });
    i0.ɵɵelement(2, "i", 24);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getHeader(ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, item_r9.document, null, ctx_r0.externalForm, item_r9.status, ctx_r0.statuses));
} }
function DynamicFormNestedFormView_p_fieldset_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "div", 3)(3, "ul", 21);
    i0.ɵɵtemplate(4, DynamicFormNestedFormView_p_fieldset_1_div_6_li_4_Template, 5, 1, "li", 22);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r0.form)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.form || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
function DynamicFormNestedFormView_p_fieldset_1_p_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 25);
    i0.ɵɵlistener("click", function DynamicFormNestedFormView_p_fieldset_1_p_button_9_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function DynamicFormNestedFormView_p_fieldset_1_p_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 38);
    i0.ɵɵlistener("click", function DynamicFormNestedFormView_p_fieldset_1_p_button_11_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.addFormArrayElement()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true);
} }
function DynamicFormNestedFormView_p_fieldset_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-fieldset", 1);
    i0.ɵɵtemplate(1, DynamicFormNestedFormView_p_fieldset_1_ng_template_1_Template, 4, 2, "ng-template", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, DynamicFormNestedFormView_p_fieldset_1_div_3_Template, 3, 1, "div", 4)(4, DynamicFormNestedFormView_p_fieldset_1_div_4_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DynamicFormNestedFormView_p_fieldset_1_div_5_Template, 2, 3, "div", 5)(6, DynamicFormNestedFormView_p_fieldset_1_div_6_Template, 5, 3, "div", 5);
    i0.ɵɵelementStart(7, "div", 6)(8, "div", 7);
    i0.ɵɵtemplate(9, DynamicFormNestedFormView_p_fieldset_1_p_button_9_Template, 1, 2, "p-button", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 9);
    i0.ɵɵtemplate(11, DynamicFormNestedFormView_p_fieldset_1_p_button_11_Template, 1, 1, "p-button", 26);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("collapsed", ctx_r0.dynamicFormObject.collapsed)("toggleable", true)("formGroup", ctx_r0.form)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.group || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp") > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.debug);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.refFormType !== "external" && ctx_r0.nestedForm);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.refFormType === "external" && ctx_r0.items);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly || ctx_r0.operation === "edit" && !ctx_r0.dynamicFormObject.editBlocked);
} }
class DynamicFormNestedFormView {
    constructor(dynamicFormService, dynamicFormControlService, formService, formDataService, dialogService, configService, router, route, confirmationService, searchService) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.formService = formService;
        this.formDataService = formDataService;
        this.dialogService = dialogService;
        this.configService = configService;
        this.router = router;
        this.route = route;
        this.confirmationService = confirmationService;
        this.searchService = searchService;
        this.debug = false;
        this.readonly = false;
        this.nextForm = new EventEmitter();
    }
    ngOnInit() {
        this.xpath = this.dynamicFormControlService.getXpath(this.dynamicFormObject, this.xpath);
        if (this.router.url.includes('reporting')) {
            this.subpath = '/reporting/';
        }
        else {
            this.subpath = '/';
        }
        if (this.dynamicFormObject.refFormId) {
            if (this.dynamicFormObject.refFormType === 'external') {
                this.route.queryParams.subscribe(params => {
                    this.queryParams = params;
                    this.formService.getForm(this.dynamicForm.space, this.dynamicFormObject.refFormId).subscribe(res => {
                        if (!res.space) {
                            res.space = this.dynamicForm.space;
                        }
                        this.externalForm = res;
                        if (this.parentForm.getRawValue().id) {
                            let status;
                            if (this.statuses && this.statuses.status && this.statuses.status.length > 0) {
                                status = this.statuses.status.map(e => {
                                    return e.name;
                                }).toString();
                            }
                            this.searchService.searchCollectionItems(this.dynamicForm.space, this.dynamicFormObject.refFormId, [new StandardSearchParameter('metadata.pid', this.parentForm.getRawValue().id)], 10000, 0, null, null, ['document', 'metadata', 'status'], null, status).subscribe(res => {
                                this.items = res.results && res.results.values ? res.results.values : [];
                            }, err => {
                                this.searchService.manageError(err, 'Error reading collection items for subform ' + this.dynamicFormObject.refFormId + ' (' + this.parentForm.getRawValue().id + ')');
                            });
                        }
                        else {
                            this.items = [];
                        }
                    }, err => {
                        this.searchService.manageError(err, 'Error reading form ' + this.dynamicFormObject.refFormId);
                    });
                });
            }
            else {
                this.nestedForm = this.dynamicFormService.getForm(this.dynamicForm, this.dynamicFormObject.refFormId);
                if (!this.nestedForm.properties) {
                    this.nestedForm.properties = this.dynamicForm.properties;
                }
            }
        }
    }
    canEdit() {
        return !(this.readonly || (this.operation === 'edit' && this.dynamicFormObject.editBlocked));
    }
    showHelp(description) {
        const ref = this.dialogService.open(HelpComponent, {
            data: {
                description: description
            },
            header: 'Help',
            width: '50%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    addFormArrayElement(keyboard) {
        if (!keyboard || (keyboard && keyboard.keyCode === 9)) {
            let fa = this.form.controls[this.dynamicFormObject.code];
            if (this.dynamicFormObject.refFormId) {
                if (this.dynamicFormObject.refFormType === 'external') {
                    if (this.parentForm.dirty) {
                        this.confirmationService.confirm({
                            message: 'Please save the form before adding a new subform item',
                            key: 'data-editor',
                            rejectVisible: false,
                            acceptLabel: 'Ok'
                        });
                        return;
                    }
                    else {
                        this.nextForm.emit({
                            dynamicForm: this.dynamicForm,
                            entry: this.parentForm.getRawValue(),
                            subpath: this.subpath,
                            subform: this.dynamicFormObject,
                            parent: this.parentDynamicFormObject,
                            _p: this.queryParams._p
                        });
                    }
                }
                else {
                    fa.push(this.dynamicFormControlService.formObjectsToFormGroup(this.dynamicForm, this.operation, this.dynamicFormService.getNestedFormChildren(this.dynamicForm, this.dynamicFormObject.refFormId), null, this.xpath));
                }
            }
        }
    }
    openSubformItem(item, id, status) {
        if (this.dynamicFormObject.refFormId) {
            if (this.dynamicFormObject.refFormType === 'external') {
                this.formDataService.openSubformItem(this.parentForm.getRawValue().id, item, id, status, this.status, this.queryParams, this.dynamicForm, this.dynamicFormObject.refFormId, this.subpath);
            }
        }
    }
    removeFormArrayElement(i) {
        let fa = this.form.controls[this.dynamicFormObject.code];
        fa.removeAt(i);
    }
    getItemDataObject(code, item) {
        let data = {};
        data[code] = item;
        return data;
    }
    async getHeader(dynamicForm, dynamicFormObject, data, xpath) {
        let header = await this.dynamicFormControlService.getHeader(dynamicForm, dynamicFormObject, data, xpath);
        return header;
    }
    static { this.ɵfac = function DynamicFormNestedFormView_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormNestedFormView)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1.FormService), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(i1.SearchService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormNestedFormView, selectors: [["dynamic-form-nested-form-view"]], inputs: { statuses: "statuses", status: "status", dynamicForm: "dynamicForm", parentDynamicForm: "parentDynamicForm", dynamicFormObject: "dynamicFormObject", parentDynamicFormObject: "parentDynamicFormObject", form: "form", parentForm: "parentForm", debug: "debug", readonly: "readonly", operation: "operation", xpath: "xpath", hideLabel: "hideLabel" }, outputs: { nextForm: "nextForm" }, standalone: false, decls: 2, vars: 2, consts: [[3, "collapsed", "toggleable", "formGroup", "ngClass", 4, "ngIf"], [3, "collapsed", "toggleable", "formGroup", "ngClass"], ["pTemplate", "header"], [1, "row"], ["class", "col-md-12 mt-2 mb-2", 4, "ngIf"], ["class", "row", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "row", "mt-3"], [1, "col-md-6"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "rounded", "outlined", "click", 4, "ngIf"], [1, "col-md-6", "align-right"], [1, "flex", "align-items-center"], ["class", "mandatory", 4, "ngIf"], [1, "mandatory"], [1, "bi", "bi-asterisk"], [1, "col-md-12", "mt-2", "mb-2"], [1, "form-control-footer", "text-color-gray-medium"], [3, "template"], [3, "dynamicForm", "dynamicFormObject", "data", "xpath"], [1, "row", 3, "formGroup", "ngClass"], [1, "col-md-12"], ["role", "child", "mode", "edit", 3, "cssClass", "parentForm", "form", "formData", "params", "xpath", "debug", "dynamicForm", "parentDynamicForm"], [1, "array-items"], [4, "ngFor", "ngForOf"], ["href", "javascript:", 1, "link-icon", 3, "click"], [1, "bi", "bi-file-earmark-text"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "click", "rounded", "outlined"], ["icon", "pi pi-plus", 3, "rounded", "click", 4, "ngIf"], ["class", "form-array-item", 4, "ngFor", "ngForOf"], [1, "form-array-item"], ["class", "form-array-item-actions", 4, "ngIf"], [1, "form-array-item-content"], [3, "toggleable", "collapsed"], [4, "ngIf"], [1, "form-array-item-actions"], ["title", "Remove item", "type", "button", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-trash"], [1, "form-array-item-header"], [3, "errors", "dynamicForm", "dynamicFormObject"], ["icon", "pi pi-plus", 3, "click", "rounded"]], template: function DynamicFormNestedFormView_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicFormNestedFormView_p_fieldset_0_Template, 11, 9, "p-fieldset", 0)(1, DynamicFormNestedFormView_p_fieldset_1_Template, 12, 10, "p-fieldset", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.dynamicFormObject.multipleValues);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.multipleValues);
        } }, styles: [".effect[_ngcontent-%COMP%]{opacity:1;animation:_ngcontent-%COMP%_fade 5s linear}@keyframes _ngcontent-%COMP%_fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator[_ngcontent-%COMP%]{width:100%}.form-check-label[_ngcontent-%COMP%]{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items[_ngcontent-%COMP%]{list-style:none;font-size:.9rem}.help-button[_ngcontent-%COMP%]{margin:5px}.help-button[_ngcontent-%COMP%]:hover{cursor:pointer}.component-header[_ngcontent-%COMP%]{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{margin-left:10px}.form-control-footer[_ngcontent-%COMP%]{font-size:.8em}.mandatory[_ngcontent-%COMP%]{font-size:50%;vertical-align:top;color:red}.app-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}.header-title[_ngcontent-%COMP%]:hover{cursor:pointer}.status-label[_ngcontent-%COMP%]{font-size:1em;font-weight:700}.component-label[_ngcontent-%COMP%]{font-size:1em}.component-label.horizontal[_ngcontent-%COMP%], label.title-category[_ngcontent-%COMP%]{font-size:.9em}.float[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.panel-body[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading[_ngcontent-%COMP%]{min-height:45px;display:flex}.panel-heading[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-height:40px}.multiple-values-item[_ngcontent-%COMP%]{display:flex;flex-grow:1}.multiple-values-item-content[_ngcontent-%COMP%]{width:95%}.multiple-values-item-body[_ngcontent-%COMP%]{width:95%;margin-bottom:5px}.array-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:.9em}.header-title[_ngcontent-%COMP%]{vertical-align:middle}.card[_ngcontent-%COMP%]{margin-bottom:.5em}.refresh-button[_ngcontent-%COMP%]{margin:.5em}.refresh-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ref-form[_ngcontent-%COMP%]{display:flex;align-items:baseline}img[_ngcontent-%COMP%]{max-width:100%;height:auto}.collapse[_ngcontent-%COMP%]{display:none!important}.collapse.in[_ngcontent-%COMP%]{display:block!important}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form[_ngcontent-%COMP%]   .p-fieldset[_ngcontent-%COMP%]   .p-fieldset-legend[_ngcontent-%COMP%]{font-size:.8em!important}.dynamic-form-summary-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%]{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{margin-left:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%], .dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-icon[_ngcontent-%COMP%]{font-size:20px!important}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.control-cell.content[_ngcontent-%COMP%]{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu[_ngcontent-%COMP%]{width:55px}.form-group[_ngcontent-%COMP%]{border:solid 1px rgba(0,0,0,.125);margin:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormNestedFormView, [{
        type: Component,
        args: [{ selector: 'dynamic-form-nested-form-view', standalone: false, template: "<!-- Multiple values = false -->\r\n<p-fieldset [collapsed]=\"dynamicFormObject.collapsed\" [toggleable]=\"true\" *ngIf=\"!dynamicFormObject.multipleValues\" [formGroup]=\"form\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n\r\n  <ng-template pTemplate=\"header\">\r\n    <div class=\"flex align-items-center\">\r\n      <label>{{dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label')}}</label>\r\n      <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n      <div class=\"form-control-footer text-color-gray-medium\">\r\n        <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n      <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\" [xpath]=\"xpath\"></debug-details>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"dynamicFormObject.refFormType !== 'external' && nestedForm\" [formGroup]=\"$any(form.controls[dynamicFormObject.code])\" class=\"row\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.form) || dynamicFormObject.cssClass\">\r\n    <div class=\"col-md-12\">\r\n      <dynamic-form role=\"child\" [cssClass]=\"dynamicForm.cssClass\" [parentForm]=\"parentForm\" [form]=\"$any(form.controls[dynamicFormObject.code])\" [formData]=\"parentForm.getRawValue()\" [params]=\"dynamicFormObject.params\" [xpath]=\"xpath\" [debug]=\"debug\" [dynamicForm]=\"nestedForm\" [parentDynamicForm]=\"parentDynamicForm\" mode=\"edit\"></dynamic-form>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"dynamicFormObject.refFormType === 'external' && items\" [formGroup]=\"form\" class=\"row\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.form) || dynamicFormObject.cssClass\">\r\n    <ul class=\"array-items\">\r\n      <li *ngFor=\"let item of items\">\r\n        <a href=\"javascript:\" (click)=\"openSubformItem(item,item.metadata.id,item.status)\" class=\"link-icon\">\r\n          <i class=\"bi bi-file-earmark-text\"></i><span>{{ dynamicFormControlService.getHeader(dynamicForm, dynamicFormObject,item.document,null, externalForm, item.status, statuses) }}</span>\r\n        </a>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n\r\n  <div class=\"row mt-3\">\r\n    <div class=\"col-md-6\">\r\n      <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\" title=\"Help\"\r\n        (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\"></p-button>\r\n    </div>\r\n    <div class=\"col-md-6 align-right\">\r\n\r\n    </div>\r\n  </div>\r\n\r\n</p-fieldset>\r\n\r\n<!-- Multiple values = true -->\r\n<p-fieldset [collapsed]=\"dynamicFormObject.collapsed\" [toggleable]=\"true\" *ngIf=\"dynamicFormObject.multipleValues\" [formGroup]=\"form\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n\r\n  <ng-template pTemplate=\"header\">\r\n    <div class=\"flex align-items-center\">\r\n      <label>{{dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label')}}</label>\r\n      <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n      <div class=\"form-control-footer text-color-gray-medium\">\r\n        <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n      <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\" [xpath]=\"xpath\"></debug-details>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"dynamicFormObject.refFormType !== 'external' && nestedForm\" [formGroup]=\"form\" class=\"row\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.form) || dynamicFormObject.cssClass\">\r\n\r\n    <div class=\"form-array-item\"\r\n      *ngFor=\"let arrayGroupElement of form.controls[dynamicFormObject.code]['controls']; let arrayGroupElementIndex=index\">\r\n      <div class=\"form-array-item-actions\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n        <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n          (click)=\"removeFormArrayElement(arrayGroupElementIndex)\">\r\n          <i class=\"bi bi-trash\"></i>\r\n        </button>\r\n      </div>\r\n      <div class=\"form-array-item-content\">\r\n\r\n        <p-panel [toggleable]=\"true\" [collapsed]=\"true\">\r\n          <ng-template pTemplate=\"header\">\r\n            <!-- <span>[{{ arrayGroupElementIndex }}]&nbsp;</span> -->\r\n            <div class=\"form-array-item-header\"><label>{{ dynamicFormControlService.getHeader(dynamicForm, dynamicFormObject, form.controls[dynamicFormObject.code]['controls'][arrayGroupElementIndex].value,null) }}</label></div>\r\n          </ng-template>\r\n    \r\n          <dynamic-form role=\"child\" [cssClass]=\"dynamicForm.cssClass\" [parentForm]=\"parentForm\" [form]=\"arrayGroupElement\" [formData]=\"parentForm.getRawValue()\" [params]=\"dynamicFormObject.params\" [xpath]=\"xpath\" [debug]=\"debug\" [dynamicForm]=\"nestedForm\" [parentDynamicForm]=\"parentDynamicForm\" mode=\"edit\"></dynamic-form>\r\n\r\n          <div *ngIf=\"arrayGroupElement.errors\">\r\n            <form-errors-manager [errors]=\"arrayGroupElement.errors\" [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\"></form-errors-manager>\r\n          </div>\r\n\r\n        </p-panel>\r\n\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n  <div *ngIf=\"dynamicFormObject.refFormType === 'external' && items\" [formGroup]=\"form\" class=\"row\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.form) || dynamicFormObject.cssClass\">\r\n    <div class=\"col-md-12\">\r\n\r\n      <div class=\"row\">\r\n        <ul class=\"array-items\">\r\n          <li *ngFor=\"let item of items\">\r\n              <a href=\"javascript:\" (click)=\"openSubformItem(item,item.metadata.id,item.status)\" class=\"link-icon\">\r\n                <i class=\"bi bi-file-earmark-text\"></i><span>{{ dynamicFormControlService.getHeader(dynamicForm, dynamicFormObject,item.document,null, externalForm, item.status, statuses) }}</span>\r\n              </a>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n\r\n    </div>  \r\n  </div>\r\n\r\n  <div class=\"row mt-3\">\r\n    <div class=\"col-md-6\">\r\n      <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\" title=\"Help\"\r\n        (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\"></p-button>\r\n    </div>\r\n    <div class=\"col-md-6 align-right\">\r\n      <p-button *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\" icon=\"pi pi-plus\" [rounded]=\"true\" (click)=\"addFormArrayElement()\"></p-button>\r\n    </div>\r\n  </div>\r\n\r\n</p-fieldset>\r\n", styles: [".effect{opacity:1;animation:fade 5s linear}@keyframes fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator{width:100%}.form-check-label{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items{list-style:none;font-size:.9rem}.help-button{margin:5px}.help-button:hover{cursor:pointer}.component-header{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header .header-title{margin-left:10px}.form-control-footer{font-size:.8em}.mandatory{font-size:50%;vertical-align:top;color:red}.app-menu-disabled{pointer-events:none;opacity:.6}.header-title:hover{cursor:pointer}.status-label{font-size:1em;font-weight:700}.component-label{font-size:1em}.component-label.horizontal,label.title-category{font-size:.9em}.float{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float>*{margin-left:5px;margin-right:5px}.panel-body{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading{min-height:45px;display:flex}.panel-heading .header-title{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading button{max-height:40px}.multiple-values-item{display:flex;flex-grow:1}.multiple-values-item-content{width:95%}.multiple-values-item-body{width:95%;margin-bottom:5px}.array-items button{font-size:.9em}.header-title{vertical-align:middle}.card{margin-bottom:.5em}.refresh-button{margin:.5em}.refresh-button:hover{cursor:pointer}.ref-form{display:flex;align-items:baseline}img{max-width:100%;height:auto}.collapse{display:none!important}.collapse.in{display:block!important}.collapsing{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form .p-fieldset .p-fieldset-legend{font-size:.8em!important}.dynamic-form-summary-view{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view .form-tree{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view .form-questions{margin-left:5px}.dynamic-form-summary-view .form-tree,.dynamic-form-summary-view .form-questions{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form{width:100%}form .item-icon{font-size:20px!important}form .item-switcher{width:100%}form .item-switcher>div{width:100%}.control-cell.content{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu{width:55px}.form-group{border:solid 1px rgba(0,0,0,.125);margin:1em}\n"] }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i1.FormService }, { type: FormDataService }, { type: i1$1.DialogService }, { type: i1.ConfigurationService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i3$2.ConfirmationService }, { type: i1.SearchService }], { statuses: [{
            type: Input
        }], status: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], parentDynamicForm: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], parentDynamicFormObject: [{
            type: Input
        }], form: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], debug: [{
            type: Input
        }], readonly: [{
            type: Input
        }], operation: [{
            type: Input
        }], xpath: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], nextForm: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormNestedFormView, { className: "DynamicFormNestedFormView", filePath: "src/dynamic-form/dynamic-form-nested-form/dynamic-form-nested-form.ts", lineNumber: 23 }); })();

class ButtonComponent {
    constructor() {
        this.label = 'Accept';
    }
    static { this.ɵfac = function ButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ButtonComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["banana-button"]], inputs: { label: "label" }, standalone: false, decls: 2, vars: 1, consts: [[1, "button"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
        } }, styles: [".button{box-sizing:border-box;display:inline-block;border:0;border-radius:10px;padding:15px;min-height:30px;min-width:120px;opacity:.8;background-color:var(--banana-btn-bg-color);color:var(--banana-btn-color);cursor:pointer;text-align:center;font-size:1rem;line-height:1.2;transition:opacity .3s ease}.button:hover{opacity:1}\n"], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{ selector: 'banana-button', encapsulation: ViewEncapsulation.None, standalone: false, template: "<button class=\"button\">{{label}}</button>\r\n", styles: [".button{box-sizing:border-box;display:inline-block;border:0;border-radius:10px;padding:15px;min-height:30px;min-width:120px;opacity:.8;background-color:var(--banana-btn-bg-color);color:var(--banana-btn-color);cursor:pointer;text-align:center;font-size:1rem;line-height:1.2;transition:opacity .3s ease}.button:hover{opacity:1}\n"] }]
    }], null, { label: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ButtonComponent, { className: "ButtonComponent", filePath: "src/components/button/button.component.ts", lineNumber: 10 }); })();

const _c0$i = a0 => [a0];
function TabsComponent_div_0_div_1_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 6);
    i0.ɵɵlistener("click", function TabsComponent_div_0_div_1_ng_container_2_ng_container_1_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r1); const tab_r2 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.showTab(tab_r2)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(tab_r2.label);
} }
function TabsComponent_div_0_div_1_ng_container_2_ng_container_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c0$i, tab_r2.link == null ? null : tab_r2.link.url))("target", (tab_r2.link == null ? null : tab_r2.link.target) || "_blank");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(tab_r2.label);
} }
function TabsComponent_div_0_div_1_ng_container_2_ng_container_2_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("href", i0.ɵɵpureFunction1(3, _c0$i, tab_r2.link == null ? null : tab_r2.link.url), i0.ɵɵsanitizeUrl)("target", (tab_r2.link == null ? null : tab_r2.link.target) || "_blank");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(tab_r2.label);
} }
function TabsComponent_div_0_div_1_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TabsComponent_div_0_div_1_ng_container_2_ng_container_2_a_1_Template, 2, 5, "a", 7)(2, TabsComponent_div_0_div_1_ng_container_2_ng_container_2_a_2_Template, 2, 5, "a", 8);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !tab_r2.link.external);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r2.link.external);
} }
function TabsComponent_div_0_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TabsComponent_div_0_div_1_ng_container_2_ng_container_1_Template, 3, 1, "ng-container", 5)(2, TabsComponent_div_0_div_1_ng_container_2_ng_container_2_Template, 3, 2, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !tab_r2.link);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r2.link);
} }
function TabsComponent_div_0_div_1_label_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(tab_r2.label);
} }
function TabsComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtemplate(2, TabsComponent_div_0_div_1_ng_container_2_Template, 3, 2, "ng-container", 5)(3, TabsComponent_div_0_div_1_label_3_Template, 2, 1, "label", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", tab_r2.active ? "active" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !tab_r2.active);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r2.active);
} }
function TabsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, TabsComponent_div_0_div_1_Template, 4, 3, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.tabs);
} }
class TabsComponent {
    constructor(configService) {
        this.configService = configService;
    }
    ngOnInit() {
        for (let item of this.tabs) {
            if (!item.link) {
                if (item.active) {
                    document.getElementById(item.id)?.setAttribute("class", "show");
                }
                else {
                    document.getElementById(item.id)?.setAttribute("class", "hide");
                }
            }
        }
    }
    showTab(tab) {
        for (let item of this.tabs) {
            if (!item.link) {
                document.getElementById(item.id)?.setAttribute("class", "hide");
                item.active = false;
            }
        }
        if (!tab.link) {
            document.getElementById(tab.id)?.setAttribute("class", "show");
        }
        tab.active = true;
    }
    static { this.ɵfac = function TabsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TabsComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TabsComponent, selectors: [["tabs"]], inputs: { tabs: "tabs" }, standalone: false, decls: 1, vars: 1, consts: [["class", "tabs", 4, "ngIf"], [1, "tabs"], ["class", "tab", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "tab", 3, "ngClass"], [1, "tab-header", "align-center"], [4, "ngIf"], ["href", "javascript:", 1, "tab-link", 3, "click"], [3, "routerLink", "target", 4, "ngIf"], [3, "href", "target", 4, "ngIf"], [3, "routerLink", "target"], [3, "href", "target"]], template: function TabsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, TabsComponent_div_0_Template, 2, 1, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.tabs);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i2.RouterLink], styles: [".tabs[_ngcontent-%COMP%]{display:flex;flex-grow:1}.tab[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-grow:1}.tab.active[_ngcontent-%COMP%]   .tab-header[_ngcontent-%COMP%]{border-left:solid 1px #ccc;border-top:solid 1px #ccc;border-right:solid 1px #ccc;border-top-left-radius:5px;border-top-right-radius:5px}.tab-header[_ngcontent-%COMP%]{padding:1em}.tab-header[_ngcontent-%COMP%]{border-bottom:solid 1px #ccc}.tab.active[_ngcontent-%COMP%]   .tab-header[_ngcontent-%COMP%]{border-bottom:none}.tab-link[_ngcontent-%COMP%]:hover{cursor:pointer}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsComponent, [{
        type: Component,
        args: [{ selector: 'tabs', standalone: false, template: "<div class=\"tabs\" *ngIf=\"tabs\">\r\n    <div *ngFor=\"let tab of tabs\" class=\"tab\" [ngClass]=\"tab.active ? 'active' : ''\">\r\n      <div class=\"tab-header align-center\">\r\n        <ng-container *ngIf=\"!tab.active\">\r\n            <ng-container *ngIf=\"!tab.link\">\r\n              <a class=\"tab-link\" href=\"javascript:\" (click)=\"showTab(tab)\">{{tab.label}}</a>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"tab.link\">\r\n              <a *ngIf=\"!tab.link.external\" [routerLink]=\"[tab.link?.url]\" [target]=\"tab.link?.target || '_blank'\">{{tab.label}}</a>\r\n              <a *ngIf=\"tab.link.external\" [href]=\"[tab.link?.url]\" [target]=\"tab.link?.target || '_blank'\">{{tab.label}}</a>\r\n          </ng-container>\r\n        </ng-container>\r\n        <label *ngIf=\"tab.active\">{{tab.label}}</label>\r\n      </div>\r\n    </div>\r\n</div>", styles: [".tabs{display:flex;flex-grow:1}.tab{display:flex;flex-direction:column;flex-grow:1}.tab.active .tab-header{border-left:solid 1px #ccc;border-top:solid 1px #ccc;border-right:solid 1px #ccc;border-top-left-radius:5px;border-top-right-radius:5px}.tab-header{padding:1em}.tab-header{border-bottom:solid 1px #ccc}.tab.active .tab-header{border-bottom:none}.tab-link:hover{cursor:pointer}\n"] }]
    }], () => [{ type: i1.ConfigurationService }], { tabs: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TabsComponent, { className: "TabsComponent", filePath: "src/components/tabs/tabs.component.ts", lineNumber: 10 }); })();

class KeysPipe {
    transform(value, args) {
        if (!value) {
            return value;
        }
        let keys = [];
        for (let key in value) {
            keys.push({ key: key, value: value[key] });
        }
        return keys;
    }
    static { this.ɵfac = function KeysPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || KeysPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "keys", type: KeysPipe, pure: true, standalone: false }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(KeysPipe, [{
        type: Pipe,
        args: [{
                name: 'keys',
                standalone: false
            }]
    }], null, null); })();

const _c0$h = a0 => ({ min: a0 });
const _c1$6 = a0 => ({ max: a0 });
function FormErrorsManagerComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.configService.getTranslation("form-errors.required"), " ");
} }
function FormErrorsManagerComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.configService.getTranslation("form-errors.min", i0.ɵɵpureFunction1(1, _c0$h, ctx_r0.dynamicFormObject.validation.min)), " ");
} }
function FormErrorsManagerComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.configService.getTranslation("form-errors.max", i0.ɵɵpureFunction1(1, _c1$6, ctx_r0.dynamicFormObject.validation.max)), " ");
} }
function FormErrorsManagerComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.configService.getTranslation("form-errors.validationRegex"), " ");
} }
function FormErrorsManagerComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.configService.getTranslation("form-errors.validationFormat"), " ");
} }
function FormErrorsManagerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FormErrorsManagerComponent_div_0_div_1_Template, 3, 1, "div", 1)(2, FormErrorsManagerComponent_div_0_div_2_Template, 3, 3, "div", 1)(3, FormErrorsManagerComponent_div_0_div_3_Template, 3, 3, "div", 1)(4, FormErrorsManagerComponent_div_0_div_4_Template, 3, 1, "div", 1)(5, FormErrorsManagerComponent_div_0_div_5_Template, 3, 1, "div", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", e_r2.key === "required" && e_r2.value === true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", e_r2.key === "min" && e_r2.value === true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", e_r2.key === "max" && e_r2.value === true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", e_r2.key === "validationRegex" && e_r2.value === true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", e_r2.key === "validationFormat" && e_r2.value === true);
} }
class FormErrorsManagerComponent {
    constructor(dynamicFormControlService, configService) {
        this.dynamicFormControlService = dynamicFormControlService;
        this.configService = configService;
    }
    ngOnInit() {
    }
    ngOnChanges() {
        console.log(this.errors);
    }
    static { this.ɵfac = function FormErrorsManagerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormErrorsManagerComponent)(i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormErrorsManagerComponent, selectors: [["form-errors-manager"]], inputs: { errors: "errors", dynamicForm: "dynamicForm", dynamicFormObject: "dynamicFormObject" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[4, "ngFor", "ngForOf"], ["class", "alert alert-danger", 4, "ngIf"], [1, "alert", "alert-danger"]], template: function FormErrorsManagerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FormErrorsManagerComponent_div_0_Template, 6, 5, "div", 0);
            i0.ɵɵpipe(1, "keys");
        } if (rf & 2) {
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(1, 1, ctx.errors));
        } }, dependencies: [i3.NgForOf, i3.NgIf, KeysPipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormErrorsManagerComponent, [{
        type: Component,
        args: [{ selector: 'form-errors-manager', standalone: false, template: "<div *ngFor=\"let e of errors | keys\">\r\n    <div class=\"alert alert-danger\" *ngIf=\"e.key === 'required' && e.value === true\">\r\n      <div>\r\n        {{ configService.getTranslation('form-errors.required') }}\r\n      </div>\r\n    </div>\r\n    <div class=\"alert alert-danger\" *ngIf=\"e.key === 'min' && e.value === true\">\r\n      <div>\r\n        {{ configService.getTranslation('form-errors.min',{ min: dynamicFormObject.validation.min }) }}\r\n      </div>\r\n    </div>\r\n    <div class=\"alert alert-danger\" *ngIf=\"e.key === 'max' && e.value === true\">\r\n      <div>\r\n        {{ configService.getTranslation('form-errors.max',{ max: dynamicFormObject.validation.max }) }}\r\n      </div>\r\n    </div>\r\n    <div class=\"alert alert-danger\" *ngIf=\"e.key === 'validationRegex' && e.value === true\">\r\n      <div>\r\n        {{ configService.getTranslation('form-errors.validationRegex') }}\r\n      </div>\r\n    </div>\r\n    <div class=\"alert alert-danger\" *ngIf=\"e.key === 'validationFormat' && e.value === true\">\r\n      <div>\r\n        {{ configService.getTranslation('form-errors.validationFormat') }}\r\n      </div>\r\n    </div>\r\n  </div>" }]
    }], () => [{ type: i1.DynamicFormControlService }, { type: i1.ConfigurationService }], { errors: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormErrorsManagerComponent, { className: "FormErrorsManagerComponent", filePath: "src/components/form-errors-manager/form-errors-manager.component.ts", lineNumber: 12 }); })();

function GlobalParametersComponent_li_3_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getValue(p_r1.name));
} }
function GlobalParametersComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 2);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "\u00A0");
    i0.ɵɵtemplate(5, GlobalParametersComponent_li_3_span_5_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("$", p_r1.name, "\u00A0");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("[", p_r1.type, "]");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.globalParams);
} }
class GlobalParametersComponent {
    constructor() { }
    ngOnInit() {
    }
    getValue(name) {
        let index = this.globalParams.findIndex(item => item.name === name);
        if (index >= 0) {
            return this.globalParams[index].value;
        }
    }
    static { this.ɵfac = function GlobalParametersComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GlobalParametersComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GlobalParametersComponent, selectors: [["global-parameters"]], inputs: { globalParams: "globalParams", dynamicForm: "dynamicForm" }, standalone: false, decls: 4, vars: 1, consts: [[1, "title-category"], [4, "ngFor", "ngForOf"], [1, "text-color-gray-medium"], ["class", "text-color-orange", 4, "ngIf"], [1, "text-color-orange"]], template: function GlobalParametersComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h6", 0);
            i0.ɵɵtext(1, "Global form parameters:");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "ul");
            i0.ɵɵtemplate(3, GlobalParametersComponent_li_3_Template, 6, 3, "li", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.dynamicForm.acceptedParams);
        } }, dependencies: [i3.NgForOf, i3.NgIf], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalParametersComponent, [{
        type: Component,
        args: [{ selector: 'global-parameters', standalone: false, template: "<h6 class=\"title-category\">Global form parameters:</h6>\r\n<ul>\r\n    <li *ngFor=\"let p of dynamicForm.acceptedParams\">${{ p.name }}&nbsp;<span class=\"text-color-gray-medium\">[{{p.type}}]</span>&nbsp;<span class=\"text-color-orange\" *ngIf=\"globalParams\">{{getValue(p.name)}}</span></li>\r\n</ul>" }]
    }], () => [], { globalParams: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(GlobalParametersComponent, { className: "GlobalParametersComponent", filePath: "src/components/formula-editor/global-parameters/global-parameters.component.ts", lineNumber: 10 }); })();

function FormulaEditorComponent_div_0_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "global-parameters", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r1.dynamicForm)("globalParams", ctx_r1.globalParams);
} }
function FormulaEditorComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 1);
    i0.ɵɵtemplate(2, FormulaEditorComponent_div_0_div_1_div_2_Template, 2, 2, "div", 2);
    i0.ɵɵelementStart(3, "div", 3)(4, "textarea", 4);
    i0.ɵɵtwoWayListener("ngModelChange", function FormulaEditorComponent_div_0_div_1_Template_textarea_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r1.child.formulaValue, $event) || (ctx_r1.child.formulaValue = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicForm.acceptedParams);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.child.formulaValue);
} }
function FormulaEditorComponent_div_0_div_2_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "global-parameters", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r1.dynamicForm)("globalParams", ctx_r1.globalParams);
} }
function FormulaEditorComponent_div_0_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 1);
    i0.ɵɵtemplate(2, FormulaEditorComponent_div_0_div_2_div_2_div_2_Template, 2, 2, "div", 2);
    i0.ɵɵelementStart(3, "div", 3)(4, "textarea", 4);
    i0.ɵɵtwoWayListener("ngModelChange", function FormulaEditorComponent_div_0_div_2_div_2_Template_textarea_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r1.child[ctx_r1.field || "formula"], $event) || (ctx_r1.child[ctx_r1.field || "formula"] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicForm.acceptedParams);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.child[ctx_r1.field || "formula"]);
} }
function FormulaEditorComponent_div_0_div_2_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "global-parameters", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r1.dynamicForm)("globalParams", ctx_r1.globalParams);
} }
function FormulaEditorComponent_div_0_div_2_div_3_div_3_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectedItem_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("[", selectedItem_r6.id, "]");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", selectedItem_r6.label, "");
} }
function FormulaEditorComponent_div_0_div_2_div_3_div_3_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("[", item_r7.id, "]");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r7.label, " ");
} }
function FormulaEditorComponent_div_0_div_2_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "div", 1)(3, "div", 9)(4, "label");
    i0.ɵɵtext(5, "Reference");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 10)(7, "p-select", 11);
    i0.ɵɵtwoWayListener("ngModelChange", function FormulaEditorComponent_div_0_div_2_div_3_div_3_Template_p_select_ngModelChange_7_listener($event) { const item_r5 = i0.ɵɵrestoreView(_r4).$implicit; i0.ɵɵtwoWayBindingSet(item_r5.refPropertiesId, $event) || (item_r5.refPropertiesId = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵtemplate(8, FormulaEditorComponent_div_0_div_2_div_3_div_3_ng_template_8_Template, 4, 2, "ng-template", 12)(9, FormulaEditorComponent_div_0_div_2_div_3_div_3_ng_template_9_Template, 3, 2, "ng-template", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 14)(11, "label");
    i0.ɵɵtext(12, "Formula");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 15)(14, "textarea", 16);
    i0.ɵɵtwoWayListener("ngModelChange", function FormulaEditorComponent_div_0_div_2_div_3_div_3_Template_textarea_ngModelChange_14_listener($event) { const item_r5 = i0.ɵɵrestoreView(_r4).$implicit; i0.ɵɵtwoWayBindingSet(item_r5.formula, $event) || (item_r5.formula = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(15, "button", 17);
    i0.ɵɵlistener("click", function FormulaEditorComponent_div_0_div_2_div_3_div_3_Template_button_click_15_listener() { const i_r8 = i0.ɵɵrestoreView(_r4).index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.deleteCondition(i_r8)); });
    i0.ɵɵelement(16, "i", 18);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const i_r8 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("filter", true)("options", ctx_r1.dynamicForm.properties);
    i0.ɵɵtwoWayProperty("ngModel", item_r5.refPropertiesId);
    i0.ɵɵproperty("showClear", true);
    i0.ɵɵadvance(7);
    i0.ɵɵpropertyInterpolate("name", ctx_r1.field + "_" + i_r8);
    i0.ɵɵtwoWayProperty("ngModel", item_r5.formula);
} }
function FormulaEditorComponent_div_0_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 1);
    i0.ɵɵtemplate(2, FormulaEditorComponent_div_0_div_2_div_3_div_2_Template, 2, 2, "div", 2)(3, FormulaEditorComponent_div_0_div_2_div_3_div_3_Template, 17, 6, "div", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicForm.acceptedParams);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.child[ctx_r1.field]);
} }
function FormulaEditorComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 1);
    i0.ɵɵtemplate(2, FormulaEditorComponent_div_0_div_2_div_2_Template, 5, 2, "div", 2)(3, FormulaEditorComponent_div_0_div_2_div_3_Template, 4, 2, "div", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isArray(ctx_r1.child[ctx_r1.field]));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isArray(ctx_r1.child[ctx_r1.field]));
} }
function FormulaEditorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FormulaEditorComponent_div_0_div_1_Template, 5, 2, "div", 2)(2, FormulaEditorComponent_div_0_div_2_Template, 4, 2, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.field);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.field);
} }
function FormulaEditorComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "global-parameters", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r1.dynamicForm)("globalParams", ctx_r1.globalParams);
} }
function FormulaEditorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, FormulaEditorComponent_div_1_div_1_Template, 2, 2, "div", 2);
    i0.ɵɵelementStart(2, "div", 3)(3, "h6", 20);
    i0.ɵɵtext(4, "Path");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 21);
    i0.ɵɵtwoWayListener("ngModelChange", function FormulaEditorComponent_div_1_Template_input_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.xpath, $event) || (ctx_r1.xpath = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 22)(7, "h6", 20);
    i0.ɵɵtext(8, "Formula");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "textarea", 4);
    i0.ɵɵtwoWayListener("ngModelChange", function FormulaEditorComponent_div_1_Template_textarea_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.formula, $event) || (ctx_r1.formula = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 3)(11, "label", 23);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 24)(14, "button", 25);
    i0.ɵɵlistener("click", function FormulaEditorComponent_div_1_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.test()); });
    i0.ɵɵelement(15, "i", 26);
    i0.ɵɵtext(16, "\u00A0");
    i0.ɵɵelementStart(17, "span");
    i0.ɵɵtext(18, "Test formula");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(19, "div", 22)(20, "h6", 20);
    i0.ɵɵtext(21, "Value");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "div", 3);
    i0.ɵɵelement(23, "ngx-json-viewer", 27);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicForm.acceptedParams);
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.xpath);
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.formula);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.error);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("json", ctx_r1.value);
} }
class FormulaEditorComponent {
    constructor(dynamicFormService, dynamicFormControlService, optionService) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.optionService = optionService;
        /**
         * Binary operators that apply (mostly) to numbers.
         */
        this.numberOperators = [
            {
                value: ">",
                label: "greater than"
            }, {
                value: "<",
                label: "less than"
            }, {
                value: "<=",
                label: "less than or equal"
            }, {
                value: ">=",
                label: "greater than or equal"
            }
        ];
        /**
         * Base operators that apply to all types (string, number, boolean, null)
         */
        this.baseOperators = [{
                value: "=",
                label: "equals"
            }, {
                value: "!=",
                label: "not equals"
            }];
        /**
         * Only applies to array functions
         */
        this.arrayOperators = [{
                value: "in",
                label: "array contains"
            }];
        /**
         * Combiner operators. These operators should return boolean values
         */
        this.combinerOperators = [{
                value: "and",
                label: "and"
            }, {
                value: "or",
                label: "or"
            }];
        /**
         * Math operators. These operators should return number values
         */
        this.mathOperators = [{
                value: "-",
                label: "minus"
            }, {
                value: "+",
                label: "plus"
            }, {
                value: "*",
                label: "times"
            }, {
                value: "/",
                label: "divided by"
            }, {
                value: "%",
                label: "modulo"
            }];
        this.stringOperators = [{
                value: "&",
                label: "concatenate"
            }];
        /**
         * Set of all comparion operators. These operators should all return boolean values.
         */
        this.comparionsOperators = [
            this.baseOperators,
            this.numberOperators,
            this.arrayOperators
        ];
        /**
         * Set of *all* binary operators
         */
        this.binaryOperators = [
            this.comparionsOperators,
            this.mathOperators,
            this.combinerOperators,
            this.stringOperators
        ];
    }
    ngOnInit() { }
    isArray(value) {
        return (typeof (value) === 'object');
    }
    deleteCondition(i) {
        this.child[this.field].splice(i, 1);
    }
    test() {
        try {
            this.value = this.dynamicFormControlService.executeFormula(this.formula, this.data, this.dynamicForm.acceptedParams, this.dynamicForm.params, this.xpath);
            this.error = '';
        }
        catch (error) {
            this.error = error.code + ' - ' + error.message;
        }
    }
    static { this.ɵfac = function FormulaEditorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FormulaEditorComponent)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1.OptionsService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormulaEditorComponent, selectors: [["formula-editor"]], inputs: { globalParams: "globalParams", dynamicForm: "dynamicForm", data: "data", brothers: "brothers", child: "child", field: "field" }, standalone: false, decls: 2, vars: 2, consts: [["class", "row", 4, "ngIf"], [1, "row"], ["class", "col-md-12", 4, "ngIf"], [1, "col-md-12"], ["rows", "6", 1, "form-control", 3, "ngModelChange", "ngModel"], [3, "dynamicForm", "globalParams"], ["class", "col-md-12 mb-2", 4, "ngFor", "ngForOf"], [1, "col-md-12", "mb-2"], [1, "validator"], [1, "col-md-2", "mb-2"], [1, "col-md-10", "mb-2"], ["appendTo", "body", "optionValue", "id", "placeholder", "(none)", 3, "ngModelChange", "filter", "options", "ngModel", "showClear"], ["pTemplate", "selectedItem"], ["pTemplate", "item"], [1, "col-md-2"], [1, "col-md-10"], ["rows", "1", 1, "form-control", 3, "ngModelChange", "name", "ngModel"], ["title", "Delete condition", "type", "button", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-trash"], [1, "text-color-orange"], [1, "title-category"], ["type", "text", 1, "form-control", 3, "ngModelChange", "ngModel"], [1, "col-md-12", "mt-3"], [1, "text-color-emergency"], [1, "col-md-12", "align-right"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], [1, "pi", "pi-save"], [3, "json"]], template: function FormulaEditorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FormulaEditorComponent_div_0_Template, 3, 2, "div", 0)(1, FormulaEditorComponent_div_1_Template, 24, 5, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.data);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data);
        } }, dependencies: [i3.NgForOf, i3.NgIf, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgModel, i4.NgxJsonViewerComponent, i3$2.PrimeTemplate, i6.Select, GlobalParametersComponent], styles: ["textarea[_ngcontent-%COMP%]{width:100%}.validator[_ngcontent-%COMP%]{display:flex;border-bottom:solid 1px var(--secondary-color);padding-bottom:.6em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormulaEditorComponent, [{
        type: Component,
        args: [{ selector: 'formula-editor', standalone: false, template: "<div class=\"row\" *ngIf=\"!data\">\r\n    <div class=\"col-md-12\" *ngIf=\"!field\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\" *ngIf=\"dynamicForm.acceptedParams\">\r\n                <global-parameters [dynamicForm]=\"dynamicForm\" [globalParams]=\"globalParams\"></global-parameters>\r\n            </div>\r\n            <div class=\"col-md-12\">\r\n                <textarea class=\"form-control\" [(ngModel)]=\"child.formulaValue\" rows=\"6\"></textarea>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"field\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\" *ngIf=\"!isArray(child[field])\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\" *ngIf=\"dynamicForm.acceptedParams\">\r\n                        <global-parameters [dynamicForm]=\"dynamicForm\" [globalParams]=\"globalParams\"></global-parameters>\r\n                    </div>\r\n                    <div class=\"col-md-12\">\r\n                        <textarea class=\"form-control\" [(ngModel)]=\"child[field || 'formula']\" rows=\"6\"></textarea>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-md-12\" *ngIf=\"isArray(child[field])\">                \r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\" *ngIf=\"dynamicForm.acceptedParams\">\r\n                        <global-parameters [dynamicForm]=\"dynamicForm\" [globalParams]=\"globalParams\"></global-parameters>\r\n                    </div>\r\n                    <div class=\"col-md-12 mb-2\" *ngFor=\"let item of child[field]; let i=index\">\r\n                        <div class=\"validator\">\r\n                            <div class=\"row\">\r\n                                <div class=\"col-md-2 mb-2\">\r\n                                  <label>Reference</label>\r\n                                </div>\r\n                                <div class=\"col-md-10 mb-2\">\r\n                                    <p-select appendTo=\"body\" [filter]=\"true\" [options]=\"dynamicForm.properties\" [(ngModel)]=\"item.refPropertiesId\" optionValue=\"id\" [showClear]=\"true\" placeholder=\"(none)\">\r\n                                        <ng-template let-selectedItem pTemplate=\"selectedItem\">\r\n                                          <div><span class=\"text-color-orange\">[{{ selectedItem.id }}]</span> {{ selectedItem.label }}</div>\r\n                                        </ng-template>\r\n                                        <ng-template let-item pTemplate=\"item\">\r\n                                          <span class=\"text-color-orange\">[{{ item.id }}]</span> {{ item.label }}\r\n                                        </ng-template>\r\n                                    </p-select>\r\n                                </div>\r\n                                <div class=\"col-md-2\">\r\n                                    <label>Formula</label>\r\n                                </div>\r\n                                <div class=\"col-md-10\">\r\n                                    <textarea class=\"form-control\" name=\"{{ field + '_' + i }}\" [(ngModel)]=\"item.formula\" rows=\"1\"></textarea>\r\n                                </div>\r\n                            </div>\r\n                            <button title=\"Delete condition\" type=\"button\" class=\"btn btn-link\" (click)=\"deleteCondition(i);\"><i class=\"bi bi-trash\"></i></button>\r\n                        </div>\r\n                    </div>                    \r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\" *ngIf=\"data\">\r\n    <div class=\"col-md-12\" *ngIf=\"dynamicForm.acceptedParams\">\r\n        <global-parameters [dynamicForm]=\"dynamicForm\" [globalParams]=\"globalParams\"></global-parameters>\r\n    </div>\r\n    <div class=\"col-md-12\">\r\n        <h6 class=\"title-category\">Path</h6>\r\n        <input class=\"form-control\" type=\"text\" [(ngModel)]=\"xpath\" />\r\n    </div>\r\n    <div class=\"col-md-12 mt-3\">\r\n        <h6 class=\"title-category\">Formula</h6>\r\n        <textarea class=\"form-control\" [(ngModel)]=\"formula\" rows=\"6\"></textarea>\r\n    </div>\r\n    <div class=\"col-md-12\">\r\n        <label class=\"text-color-emergency\">{{ error }}</label>\r\n    </div>\r\n    <div class=\"col-md-12 align-right\">\r\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"test()\"><i class=\"pi pi-save\"></i>&nbsp;<span>Test formula</span></button>\r\n    </div>\r\n    <div class=\"col-md-12 mt-3\">\r\n        <h6 class=\"title-category\">Value</h6>\r\n    </div>\r\n    <div class=\"col-md-12\">\r\n        <ngx-json-viewer [json]=\"value\"></ngx-json-viewer>\r\n    </div>\r\n</div>", styles: ["textarea{width:100%}.validator{display:flex;border-bottom:solid 1px var(--secondary-color);padding-bottom:.6em}\n"] }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i1.OptionsService }], { globalParams: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], data: [{
            type: Input
        }], brothers: [{
            type: Input
        }], child: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FormulaEditorComponent, { className: "FormulaEditorComponent", filePath: "src/components/formula-editor/formula-editor.component.ts", lineNumber: 14 }); })();

function LoadingComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("common.loading"));
} }
class LoadingComponent {
    constructor(configService) {
        this.configService = configService;
        this.loading = false;
    }
    start() {
        this.loading = true;
    }
    stop() {
        this.loading = false;
    }
    static { this.ɵfac = function LoadingComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoadingComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoadingComponent, selectors: [["loading"]], standalone: false, decls: 1, vars: 1, consts: [["class", "row spinner", 4, "ngIf"], [1, "row", "spinner"], [1, "col-md-12", "mb-3", "align-center"], ["role", "status", 1, "spinner-border"], [1, "sr-only"]], template: function LoadingComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LoadingComponent_div_0_Template, 5, 1, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.loading);
        } }, dependencies: [i3.NgIf], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingComponent, [{
        type: Component,
        args: [{ selector: 'loading', standalone: false, template: "<div class=\"row spinner\" *ngIf=\"loading\">\r\n    <div class=\"col-md-12 mb-3 align-center\">\r\n      <div class=\"spinner-border\" role=\"status\">\r\n        <span class=\"sr-only\">{{ configService.getTranslation('common.loading')}}</span>\r\n      </div>\r\n    </div>\r\n</div>" }]
    }], () => [{ type: i1.ConfigurationService }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LoadingComponent, { className: "LoadingComponent", filePath: "src/components/loading/loading.component.ts", lineNumber: 10 }); })();

class NotFoundComponent {
    constructor(meta) {
        this.meta = meta;
        meta.addTag({ name: "robots", content: "noindex" });
    }
    ngOnInit() {
    }
    static { this.ɵfac = function NotFoundComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotFoundComponent)(i0.ɵɵdirectiveInject(i1$2.Meta)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotFoundComponent, selectors: [["app-not-found"]], standalone: false, decls: 31, vars: 0, consts: [[1, "row"], ["id", "Contentplaceholder1_C004_Col00", "data-sf-element", "Column 1", "data-placeholder-label", "Column 1", 1, "sf_colsIn", "col-md-12"], ["id", "Contentplaceholder1_C002_Col00", "data-sf-element", "Container", "data-placeholder-label", "Container", 1, "sf_colsIn", "container"], [1, "sf-Long-text"], ["dir", "rtl", 2, "text-align", "right"]], template: function NotFoundComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div")(4, "div", 3)(5, "h1", 4);
            i0.ɵɵtext(6, "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "p", 4);
            i0.ɵɵtext(8, "\u0639\u0630\u0631\u0627\u064B \u0648 \u0644\u0643\u0646 \u064A\u0628\u062F\u0648 \u0623\u0646 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u064A \u0637\u0644\u0628\u062A\u0647\u0627 \u0642\u062F \u062A\u063A\u064A\u0631 \u0639\u0646\u0648\u0627\u0646\u0647\u0627 \u0623\u0648 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629. \u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0631\u0628\u0639 \u0627\u0644\u0628\u062D\u062B \u0644\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 .");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(9, "div")(10, "div", 3)(11, "h1");
            i0.ɵɵtext(12, "\u7F51\u9875\u672A\u627E\u5230");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "p");
            i0.ɵɵtext(14, "\u60A8\u6B63\u5728\u5BFB\u627E\u7684\u7F51\u9875\u6216\u8005\u88AB\u79FB\u9664\u6216\u8005\u4E0D\u518D\u5B58\u5728\u3002\u8BF7\u4F7F\u7528\u641C\u7D22\u6846\u83B7\u53D6\u60A8\u6B63\u5728\u5BFB\u627E\u7684\u4FE1\u606F\u3002");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(15, "h1");
            i0.ɵɵtext(16, "Page not found");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "p");
            i0.ɵɵtext(18, "The page you are looking for has either been moved or no longer exists. Please use the search box to find the information you are looking for.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "h1");
            i0.ɵɵtext(20, "Page non trouv\u00E9e");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "p");
            i0.ɵɵtext(22, "Nous sommes d\u00E9sol\u00E9s, la page que vous cherchez a \u00E9t\u00E9 d\u00E9plac\u00E9e ou peut-\u00EAtre effac\u00E9e. Vous pouvez acc\u00E9der \u00E0 l'information d\u00E9sir\u00E9e gr\u00E2ce \u00E0 notre moteur de recherche.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(23, "h1");
            i0.ɵɵtext(24, "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "p");
            i0.ɵɵtext(26, "\u0417\u0430\u043F\u0440\u043E\u0448\u0435\u043D\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0431\u044B\u043B\u0430 \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0430 \u0438\u043B\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u0430. \u0427\u0442\u043E\u0431\u044B \u043D\u0430\u0439\u0442\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E, \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435\u0441\u044C \u0441\u0442\u0440\u043E\u043A\u043E\u0439 \u043F\u043E\u0438\u0441\u043A\u0430.");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(27, "h1");
            i0.ɵɵtext(28, "P\u00E1gina no encontrada");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(29, "p");
            i0.ɵɵtext(30, "La p\u00E1gina a la que intenta acceder ha sido cambiada de lugar o no existe. Por favor, use la herramienta de b\u00FAsquedas para encontrar la informaci\u00F3n deseada.");
            i0.ɵɵelementEnd()()()()()();
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotFoundComponent, [{
        type: Component,
        args: [{ selector: 'app-not-found', standalone: false, template: "<div class=\"row\">\r\n    <div id=\"Contentplaceholder1_C004_Col00\" class=\"sf_colsIn col-md-12\" data-sf-element=\"Column 1\"\r\n        data-placeholder-label=\"Column 1\">\r\n        <div id=\"Contentplaceholder1_C002_Col00\" class=\"sf_colsIn container\" data-sf-element=\"Container\"\r\n            data-placeholder-label=\"Container\">\r\n            <div>\r\n                <div class=\"sf-Long-text\">\r\n                    <h1 dir=\"rtl\" style=\"text-align: right\">\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629</h1>\r\n                    <p dir=\"rtl\" style=\"text-align: right\">\u0639\u0630\u0631\u0627\u064B \u0648 \u0644\u0643\u0646 \u064A\u0628\u062F\u0648 \u0623\u0646 \u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u064A \u0637\u0644\u0628\u062A\u0647\u0627 \u0642\u062F \u062A\u063A\u064A\u0631 \u0639\u0646\u0648\u0627\u0646\u0647\u0627 \u0623\u0648\r\n                        \u063A\u064A\u0631 \u0645\u0648\u062C\u0648\u062F\u0629. \u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0631\u0628\u0639 \u0627\u0644\u0628\u062D\u062B \u0644\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0645\u0637\u0644\u0648\u0628\u0629 .</p>\r\n                </div>\r\n            </div>\r\n            <div>\r\n                <div class=\"sf-Long-text\">\r\n                    <h1>\u7F51\u9875\u672A\u627E\u5230</h1>\r\n                    <p>\u60A8\u6B63\u5728\u5BFB\u627E\u7684\u7F51\u9875\u6216\u8005\u88AB\u79FB\u9664\u6216\u8005\u4E0D\u518D\u5B58\u5728\u3002\u8BF7\u4F7F\u7528\u641C\u7D22\u6846\u83B7\u53D6\u60A8\u6B63\u5728\u5BFB\u627E\u7684\u4FE1\u606F\u3002</p>\r\n                    <h1>Page not found</h1>\r\n                    <p>The page you are looking for has either been moved or no longer exists. Please use the search\r\n                        box to find the information you are looking for.</p>\r\n                    <h1>Page non trouv\u00E9e</h1>\r\n                    <p>Nous sommes d\u00E9sol\u00E9s, la page que vous cherchez a \u00E9t\u00E9 d\u00E9plac\u00E9e ou peut-\u00EAtre effac\u00E9e. Vous\r\n                        pouvez acc\u00E9der \u00E0 l'information d\u00E9sir\u00E9e gr\u00E2ce \u00E0 notre moteur de recherche.</p>\r\n                    <h1>\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430</h1>\r\n                    <p>\u0417\u0430\u043F\u0440\u043E\u0448\u0435\u043D\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0431\u044B\u043B\u0430 \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0430 \u0438\u043B\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u0430. \u0427\u0442\u043E\u0431\u044B \u043D\u0430\u0439\u0442\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E,\r\n                        \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435\u0441\u044C \u0441\u0442\u0440\u043E\u043A\u043E\u0439 \u043F\u043E\u0438\u0441\u043A\u0430.</p>\r\n                    <h1>P\u00E1gina no encontrada</h1>\r\n                    <p>La p\u00E1gina a la que intenta acceder ha sido cambiada de lugar o no existe. Por favor, use la\r\n                        herramienta de b\u00FAsquedas para encontrar la informaci\u00F3n deseada.</p>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>" }]
    }], () => [{ type: i1$2.Meta }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(NotFoundComponent, { className: "NotFoundComponent", filePath: "src/components/not-found/not-found.component.ts", lineNumber: 10 }); })();

class UserRegisterComponent {
    constructor(ref, config, configService) {
        this.ref = ref;
        this.config = config;
        this.configService = configService;
        this.url = this.configService.env.registerRedirectUrl;
    }
    close() {
        this.ref.close();
    }
    static { this.ɵfac = function UserRegisterComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UserRegisterComponent)(i0.ɵɵdirectiveInject(i1$1.DynamicDialogRef), i0.ɵɵdirectiveInject(i1$1.DynamicDialogConfig), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UserRegisterComponent, selectors: [["app-user-register"]], standalone: false, decls: 6, vars: 1, consts: [[1, "row"], [1, "col-md-12"], [1, "col-md-12", "align-center", "mt-3"], ["target", "_blank", 3, "click", "href"]], template: function UserRegisterComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtext(2, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2)(4, "a", 3);
            i0.ɵɵlistener("click", function UserRegisterComponent_Template_a_click_4_listener() { return ctx.close(); });
            i0.ɵɵtext(5, "Register");
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("href", ctx.url, i0.ɵɵsanitizeUrl);
        } }, styles: ["button[_ngcontent-%COMP%]{font-size:.9em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserRegisterComponent, [{
        type: Component,
        args: [{ selector: 'app-user-register', standalone: false, template: "<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\r\n    </div>\r\n    <div class=\"col-md-12 align-center mt-3\">\r\n        <a href=\"{{url}}\" target=\"_blank\" (click)=\"close()\">Register</a>\r\n    </div>\r\n</div>", styles: ["button{font-size:.9em}\n"] }]
    }], () => [{ type: i1$1.DynamicDialogRef }, { type: i1$1.DynamicDialogConfig }, { type: i1.ConfigurationService }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(UserRegisterComponent, { className: "UserRegisterComponent", filePath: "src/components/user-register/user-register.component.ts", lineNumber: 11 }); })();

class StatusNoteComponent {
    constructor(ref, config) {
        this.ref = ref;
        this.config = config;
    }
    ngOnInit() { }
    save() {
        this.ref.close(this.note);
    }
    close() {
        this.ref.close();
    }
    static { this.ɵfac = function StatusNoteComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StatusNoteComponent)(i0.ɵɵdirectiveInject(i1$1.DynamicDialogRef), i0.ɵɵdirectiveInject(i1$1.DynamicDialogConfig)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StatusNoteComponent, selectors: [["app-status-note"]], standalone: false, decls: 14, vars: 2, consts: [[1, "row"], [1, "col-md-12", "mb-2"], [1, "col-md-12"], ["rows", "10", "pTextarea", "", 3, "ngModelChange", "ngModel"], [1, "col-md-12", "align-right", "buttons-toolbar", "dialog-buttons-toolbar"], ["type", "button", "title", "Save", 1, "btn", "btn-primary", 3, "click", "disabled"], [1, "pi", "pi-save"], ["type", "button", "title", "Close without saving", 1, "btn", "btn-secondary", 3, "click"], [1, "bi", "bi-box-arrow-left"]], template: function StatusNoteComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtext(2, " Please add a comment related to the change of the status: ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 2)(4, "textarea", 3);
            i0.ɵɵtwoWayListener("ngModelChange", function StatusNoteComponent_Template_textarea_ngModelChange_4_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.note, $event) || (ctx.note = $event); return $event; });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 4)(6, "button", 5);
            i0.ɵɵlistener("click", function StatusNoteComponent_Template_button_click_6_listener() { return ctx.save(); });
            i0.ɵɵelement(7, "i", 6);
            i0.ɵɵelementStart(8, "span");
            i0.ɵɵtext(9, "Save");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "button", 7);
            i0.ɵɵlistener("click", function StatusNoteComponent_Template_button_click_10_listener() { return ctx.close(); });
            i0.ɵɵelement(11, "i", 8);
            i0.ɵɵelementStart(12, "span");
            i0.ɵɵtext(13, "Close");
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtwoWayProperty("ngModel", ctx.note);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", !(ctx.note > ""));
        } }, dependencies: [i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgModel, i3$3.Textarea], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StatusNoteComponent, [{
        type: Component,
        args: [{ selector: 'app-status-note', standalone: false, template: "<div class=\"row\">\r\n    <div class=\"col-md-12 mb-2\">\r\n        Please add a comment related to the change of the status:\r\n    </div>\r\n    <div class=\"col-md-12\">\r\n        <textarea rows=\"10\" pTextarea [(ngModel)]=\"note\"></textarea>\r\n    </div>\r\n    <div class=\"col-md-12 align-right buttons-toolbar dialog-buttons-toolbar\">\r\n        <button type=\"button\" class=\"btn btn-primary\" [disabled]=\"!(note>'')\" title=\"Save\" (click)=\"save()\"><i class=\"pi pi-save\"></i><span>Save</span></button>\r\n        <button type=\"button\" class=\"btn btn-secondary\" title=\"Close without saving\" (click)=\"close()\"><i class=\"bi bi-box-arrow-left\"></i><span>Close</span></button>\r\n    </div>\r\n</div>" }]
    }], () => [{ type: i1$1.DynamicDialogRef }, { type: i1$1.DynamicDialogConfig }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(StatusNoteComponent, { className: "StatusNoteComponent", filePath: "src/components/status-note/status-note.component.ts", lineNumber: 10 }); })();

//https://scotch.io/tutorials/create-a-globally-available-custom-pipe-in-angular-2
class OrderByPipe {
    transform(items, args) {
        //console.debug("sorting")
        if (items) {
            // get the first element
            let orderByValue = args[0];
            let byVal = 1;
            // check if exclamation point
            if (orderByValue.charAt(0) === "!") {
                // reverse the array
                byVal = -1;
                orderByValue = orderByValue.substring(1);
            }
            //console.debug("byVal",byVal);
            //console.debug("orderByValue",orderByValue);
            items.sort((a, b) => {
                if (a[orderByValue] < b[orderByValue]) {
                    return -1 * byVal;
                }
                else if (a[orderByValue] > b[orderByValue]) {
                    return 1 * byVal;
                }
                else {
                    return 0;
                }
            });
            return items;
        }
    }
    static { this.ɵfac = function OrderByPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OrderByPipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "orderBy", type: OrderByPipe, pure: true, standalone: false }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderByPipe, [{
        type: Pipe,
        args: [{
                name: 'orderBy',
                standalone: false
            }]
    }], null, null); })();

class SafePipe {
    /**
     * Pipe Constructor
     *
     * @param _sanitizer: DomSanitezer
     */
    // tslint:disable-next-line
    constructor(_sanitizer) {
        this._sanitizer = _sanitizer;
    }
    /**
     * Transform
     *
     * @param value: string
     * @param type: string
     */
    transform(value, type) {
        switch (type) {
            case 'html':
                return this._sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this._sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this._sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this._sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this._sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                return this._sanitizer.bypassSecurityTrustHtml(value);
        }
    }
    static { this.ɵfac = function SafePipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SafePipe)(i0.ɵɵdirectiveInject(i1$2.DomSanitizer, 16)); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "safe", type: SafePipe, pure: true, standalone: false }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafePipe, [{
        type: Pipe,
        args: [{
                name: 'safe',
                standalone: false
            }]
    }], () => [{ type: i1$2.DomSanitizer }], null); })();

class TruncatePipe {
    transform(value, limit = 25, completeWords = false, stripHtml = false, ellipsis = '...') {
        if (typeof value === 'undefined') {
            return value;
        }
        if (stripHtml) {
            value = value.replace(/(<([^>]+)>)/ig, '').replace(/(&([^]+);)/ig, '');
        }
        if (value.length <= limit) {
            return value;
        }
        if (completeWords) {
            limit = value.substr(0, limit).lastIndexOf(' ');
        }
        return `${value.substr(0, limit)}${ellipsis}`;
    }
    static { this.ɵfac = function TruncatePipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TruncatePipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "truncate", type: TruncatePipe, pure: true, standalone: false }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TruncatePipe, [{
        type: Pipe,
        args: [{
                name: 'truncate',
                standalone: false
            }]
    }], null, null); })();

class AnchorComponent {
    constructor(route, router) {
        this.route = route;
        this.router = router;
        this.current = ".";
    }
    ngOnInit() {
        this.url = window.location.href;
    }
    static { this.ɵfac = function AnchorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AnchorComponent)(i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i2.Router)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AnchorComponent, selectors: [["anchor"]], inputs: { fragment: "fragment", title: "title" }, standalone: false, decls: 2, vars: 4, consts: [[3, "href"]], template: function AnchorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "a", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵpropertyInterpolate2("href", "", ctx.url, "#", ctx.fragment, "", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.title);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnchorComponent, [{
        type: Component,
        args: [{ selector: 'anchor', standalone: false, template: "<a href=\"{{url}}#{{fragment}}\">{{ title }}</a>" }]
    }], () => [{ type: i2.ActivatedRoute }, { type: i2.Router }], { fragment: [{
            type: Input
        }], title: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AnchorComponent, { className: "AnchorComponent", filePath: "src/components/anchor/anchor.component.ts", lineNumber: 10 }); })();

function BibliographyComponent_div_0_div_3_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.composeItem(item_r1), i0.ɵɵsanitizeHtml);
} }
function BibliographyComponent_div_0_div_3_ng_container_2_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 10);
} }
function BibliographyComponent_div_0_div_3_ng_container_2_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 11);
} }
function BibliographyComponent_div_0_div_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 7);
    i0.ɵɵtemplate(2, BibliographyComponent_div_0_div_3_ng_container_2_img_2_Template, 1, 0, "img", 8)(3, BibliographyComponent_div_0_div_3_ng_container_2_i_3_Template, 1, 0, "i", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", item_r1.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.url.toLowerCase().includes(".pdf"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r1.url.toLowerCase().includes(".pdf"));
} }
function BibliographyComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, BibliographyComponent_div_0_div_3_span_1_Template, 1, 1, "span", 5)(2, BibliographyComponent_div_0_div_3_ng_container_2_Template, 4, 3, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.composeItem(item_r1) > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.url);
} }
function BibliographyComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵelement(2, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, BibliographyComponent_div_0_div_3_Template, 3, 2, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.intro, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.getItems());
} }
class BibliographyComponent {
    constructor(utilsService, configService) {
        this.utilsService = utilsService;
        this.configService = configService;
    }
    ngOnInit() {
        this.faolexUrl = this.configService.env.faolexUrl;
    }
    getItems() {
        if (this.type) {
            return this.items.filter(item => item.type === this.type);
        }
        else {
            return this.items;
        }
    }
    composeItem(item) {
        let out = '';
        if (item.title && item.title.length) {
            out = out + ' "' + item.title + '"';
        }
        if (item.freeText) {
            out = out + " " + item.freeText;
        }
        if (item.text) {
            out = out + " " + item.text;
        }
        if (item.citation) {
            out = out + " " + item.citation;
        }
        if (item.publisher && !this.utilsService.isObjectHierarchyEmpty(item.publisher)) {
            out = out + " " + item.publisher;
        }
        if (item.identifier && item.identifier.value === 'ISBN') {
            out = out + " " + item.identifier.type;
        }
        if (item.identifier && !item.identifier.value) {
            out = out + " " + item.identifier.type;
        }
        if (item.series) {
            out = out + " " + item.series;
        }
        if (item.editor) {
            out = out + " " + item.editor;
        }
        if (item.creator && item.creator.corporateauthor) {
            out = out + " " + item.creator.corporateauthor;
        }
        if (item.creator && item.creator.personalAuthor) {
            out = out + " " + item.creator.personalAuthor;
        }
        if (item.creator && item.creator.personalauthor) {
            out = out + " " + item.creator.personalauthor;
        }
        if (item.creatorpersonal) {
            /*             for(let key of item.creatorpersonal) { */
            out = out + " " + item.creatorpersonal;
            /* } */
        }
        if (item.creatorPersonal) {
            /* for(let key of item.creatorPersonal) { */
            out = out + " " + item.creatorPersonal;
            /* } */
        }
        if (item.creatorcorporate) {
            out = out + " " + item.creatorcorporate;
        }
        if (item.creatorCorporate) {
            out = out + " " + item.creatorCorporate;
        }
        if (item.bibliographicCitation) {
            out = out + " " + item.bibliographicCitation;
        }
        if (item.created) {
            out = out + " " + item.created;
        }
        if (item.date) {
            if (item.date.created) {
                out = out + ', ' + item.date.created + " ";
            }
            else if (item.date.modified) {
                out = out + ', ' + item.date.modified + " ";
            }
        }
        return out.trim();
    }
    composeItemBefore(item) {
        let out = '';
        if (item.text) {
            out = out + " " + item.text;
        }
        if (item.citation) {
            out = out + " " + item.citation;
        }
        return out.trim();
    }
    composeItemAfter(item) {
        let out = '';
        if (!item.identifier || item.identifier.value !== 'URI' || !item.identifier.value) {
            if (item.title && item.title.length) {
                out = out + ' "' + item.title + '"';
            }
            if (item.freeText) {
                out = out + " " + item.freeText;
            }
        }
        if (item.publisher && !this.utilsService.isObjectHierarchyEmpty(item.publisher)) {
            out = out + " " + item.publisher;
        }
        if (item.identifier && item.identifier.value === 'ISBN') {
            out = out + " " + item.identifier.type;
        }
        if (item.identifier && !item.identifier.value) {
            out = out + " " + item.identifier.type;
        }
        if (item.series) {
            out = out + " " + item.series;
        }
        if (item.editor) {
            out = out + " " + item.editor;
        }
        if (item.creator && item.creator.corporateauthor) {
            out = out + " " + item.creator.corporateauthor;
        }
        if (item.creator && item.creator.personalAuthor) {
            out = out + " " + item.creator.personalAuthor;
        }
        if (item.creator && item.creator.personalauthor) {
            out = out + " " + item.creator.personalauthor;
        }
        if (item.creatorpersonal) {
            /*             for(let key of item.creatorpersonal) { */
            out = out + " " + item.creatorpersonal;
            /* } */
        }
        if (item.creatorPersonal) {
            /* for(let key of item.creatorPersonal) { */
            out = out + " " + item.creatorPersonal;
            /* } */
        }
        if (item.creatorcorporate) {
            out = out + " " + item.creatorcorporate;
        }
        if (item.creatorCorporate) {
            out = out + " " + item.creatorCorporate;
        }
        if (item.bibliographicCitation) {
            out = out + " " + item.bibliographicCitation;
        }
        if (item.created) {
            out = out + " " + item.created;
        }
        if (item.date) {
            if (item.date.created) {
                out = out + ', ' + item.date.created + " ";
            }
            else if (item.date.modified) {
                out = out + ', ' + item.date.modified + " ";
            }
        }
        return out.trim();
    }
    static { this.ɵfac = function BibliographyComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BibliographyComponent)(i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BibliographyComponent, selectors: [["bibliography"]], inputs: { items: "items", type: "type", intro: "intro" }, standalone: false, decls: 1, vars: 1, consts: [["class", "row bibliography", 4, "ngIf"], [1, "row", "bibliography"], [1, "col-md-12", "mb-3"], [3, "innerHTML"], ["class", "col-md-12 mb-3", 4, "ngFor", "ngForOf"], [3, "innerHTML", 4, "ngIf"], [4, "ngIf"], ["target", "_blank", 1, "bibliography-link", 3, "href"], ["class", "noprint", "alt", "Click to open", "src", "./assets/images/pdf.gif", 4, "ngIf"], ["class", "noprint bi bi-globe", 4, "ngIf"], ["alt", "Click to open", "src", "./assets/images/pdf.gif", 1, "noprint"], [1, "noprint", "bi", "bi-globe"]], template: function BibliographyComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, BibliographyComponent_div_0_Template, 4, 2, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.getItems());
        } }, dependencies: [i3.NgForOf, i3.NgIf], styles: [".bibliography[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:.4em}.bibliography-link[_ngcontent-%COMP%]{margin-left:5px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BibliographyComponent, [{
        type: Component,
        args: [{ selector: 'bibliography', standalone: false, template: "<div class=\"row bibliography\" *ngIf=\"getItems()\">\r\n    <div class=\"col-md-12 mb-3\">\r\n        <span [innerHTML]=\"intro\"></span>\r\n    </div>\r\n    <div class=\"col-md-12 mb-3\" *ngFor=\"let item of getItems()\">\r\n        <span *ngIf=\"composeItem(item) > ''\" [innerHTML]=\"composeItem(item)\"></span>\r\n        <ng-container *ngIf=\"item.url\">\r\n            <a href=\"{{item.url}}\" target=\"_blank\" class=\"bibliography-link\">\r\n                <img *ngIf=\"item.url.toLowerCase().includes('.pdf')\" class=\"noprint\" alt=\"Click to open\" src=\"./assets/images/pdf.gif\" />\r\n                <i *ngIf=\"!item.url.toLowerCase().includes('.pdf')\" class=\"noprint bi bi-globe\"></i>\r\n            </a>\r\n        </ng-container>\r\n    </div>\r\n</div>", styles: [".bibliography p{margin-bottom:.4em}.bibliography-link{margin-left:5px}\n"] }]
    }], () => [{ type: i1.UtilsService }, { type: i1.ConfigurationService }], { items: [{
            type: Input
        }], type: [{
            type: Input
        }], intro: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(BibliographyComponent, { className: "BibliographyComponent", filePath: "src/components/bibliography/bibliography.component.ts", lineNumber: 10 }); })();

class CalendarComponent {
    constructor() {
        this.format = 'dd/MM/yyyy';
    }
    ngOnInit() {
        try {
            if (this.value?.toString().length === 8) {
                this.date = this.value.toString().substring(6) + '/' + this.value.toString().substring(4, 6) + '/' + this.value.toString().substring(0, 4);
            }
            else {
                this.date = new DatePipe('en').transform(new Date(this.value), this.format);
            }
        }
        catch (error) {
            if (this.value?.toString().length === 8) {
                this.date = this.value.toString().substring(6) + '/' + this.value.toString().substring(4, 6) + '/' + this.value.toString().substring(0, 4);
            }
            else {
                this.date = this.value;
            }
        }
    }
    static { this.ɵfac = function CalendarComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CalendarComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CalendarComponent, selectors: [["calendar"]], inputs: { value: "value", format: "format" }, standalone: false, decls: 1, vars: 1, template: function CalendarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtext(0);
        } if (rf & 2) {
            i0.ɵɵtextInterpolate(ctx.date);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarComponent, [{
        type: Component,
        args: [{ selector: 'calendar', standalone: false, template: "{{ date }}" }]
    }], () => [], { value: [{
            type: Input
        }], format: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CalendarComponent, { className: "CalendarComponent", filePath: "src/components/calendar/calendar.component.ts", lineNumber: 10 }); })();

const _c0$g = ["video"];
const _c1$5 = a0 => [a0];
const _c2$1 = a0 => ({ "background-image": a0 });
function CardComponent_ng_container_0_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵelement(2, "img", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_1_fi_template_renderer_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_1_fi_template_renderer_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_1_a_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target)("title", ctx_r0.data.title || "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.callouttitle, " ");
} }
function CardComponent_ng_container_0_ng_container_1_a_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target)("title", ctx_r0.data.title || "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.callouttitle, " ");
} }
function CardComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 3);
    i0.ɵɵtemplate(3, CardComponent_ng_container_0_ng_container_1_div_3_Template, 3, 1, "div", 4);
    i0.ɵɵelementStart(4, "div", 5)(5, "div", 6)(6, "h5", 7);
    i0.ɵɵelement(7, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "p", 9);
    i0.ɵɵtemplate(9, CardComponent_ng_container_0_ng_container_1_fi_template_renderer_9_Template, 2, 4, "fi-template-renderer", 10)(10, CardComponent_ng_container_0_ng_container_1_fi_template_renderer_10_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, CardComponent_ng_container_0_ng_container_1_a_11_Template, 3, 4, "a", 11)(12, CardComponent_ng_container_0_ng_container_1_a_12_Template, 3, 6, "a", 12);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.data.image);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.data.image ? "col-md-6" : "col-md-12");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.callouttitle && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.callouttitle && ctx_r0.config.internal);
} }
function CardComponent_ng_container_0_ng_container_2_div_1_div_1_h6_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.category);
} }
function CardComponent_ng_container_0_ng_container_2_div_1_div_1_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 30);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_2_div_1_div_1_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_2_div_1_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_2_div_1_div_1_fi_template_renderer_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_2_div_1_div_1_fi_template_renderer_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_2_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_2_div_1_div_1_h6_1_Template, 2, 1, "h6", 25);
    i0.ɵɵelementStart(2, "h5", 26);
    i0.ɵɵtemplate(3, CardComponent_ng_container_0_ng_container_2_div_1_div_1_a_3_Template, 2, 3, "a", 27)(4, CardComponent_ng_container_0_ng_container_2_div_1_div_1_a_4_Template, 2, 5, "a", 28)(5, CardComponent_ng_container_0_ng_container_2_div_1_div_1_span_5_Template, 2, 1, "span", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p");
    i0.ɵɵtemplate(7, CardComponent_ng_container_0_ng_container_2_div_1_div_1_fi_template_renderer_7_Template, 2, 4, "fi-template-renderer", 10)(8, CardComponent_ng_container_0_ng_container_2_div_1_div_1_fi_template_renderer_8_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.category);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
} }
function CardComponent_ng_container_0_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_2_div_1_div_1_Template, 9, 6, "div", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.config.cssclass)("ngStyle", i0.ɵɵpureFunction1(4, _c2$1, "url(" + ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image) + ")"))("title", ctx_r0.data.copyright || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.title || ctx_r0.data.description);
} }
function CardComponent_ng_container_0_ng_container_2_div_2_youtube_video_player_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "youtube-video-player", 35);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("videoId", ctx_r0.data.video);
} }
function CardComponent_ng_container_0_ng_container_2_div_2_video_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "video", 36, 0);
    i0.ɵɵelement(2, "source", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r0.data.video, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("type", ctx_r0.data.videotype);
} }
function CardComponent_ng_container_0_ng_container_2_div_2_div_3_h6_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.category);
} }
function CardComponent_ng_container_0_ng_container_2_div_2_div_3_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 30);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_2_div_2_div_3_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_2_div_2_div_3_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_2_div_2_div_3_fi_template_renderer_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_2_div_2_div_3_fi_template_renderer_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_2_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_2_div_2_div_3_h6_1_Template, 2, 1, "h6", 25);
    i0.ɵɵelementStart(2, "h5", 26);
    i0.ɵɵtemplate(3, CardComponent_ng_container_0_ng_container_2_div_2_div_3_a_3_Template, 2, 3, "a", 27)(4, CardComponent_ng_container_0_ng_container_2_div_2_div_3_a_4_Template, 2, 5, "a", 28)(5, CardComponent_ng_container_0_ng_container_2_div_2_div_3_span_5_Template, 2, 1, "span", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p");
    i0.ɵɵtemplate(7, CardComponent_ng_container_0_ng_container_2_div_2_div_3_fi_template_renderer_7_Template, 2, 4, "fi-template-renderer", 10)(8, CardComponent_ng_container_0_ng_container_2_div_2_div_3_fi_template_renderer_8_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.category);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
} }
function CardComponent_ng_container_0_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_2_div_2_youtube_video_player_1_Template, 1, 1, "youtube-video-player", 33)(2, CardComponent_ng_container_0_ng_container_2_div_2_video_2_Template, 3, 2, "video", 34)(3, CardComponent_ng_container_0_ng_container_2_div_2_div_3_Template, 9, 6, "div", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.videotype === "video/youtube");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video && !(ctx_r0.data.videotype === "video/youtube"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.title || ctx_r0.data.description);
} }
function CardComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_2_div_1_Template, 2, 6, "div", 20)(2, CardComponent_ng_container_0_ng_container_2_div_2_Template, 4, 3, "div", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.image && !ctx_r0.data.video);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video);
} }
function CardComponent_ng_container_0_ng_container_3_div_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 46);
    i0.ɵɵelement(1, "img", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("title", ctx_r0.data.copyright || "")("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_3_div_2_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 48);
    i0.ɵɵelement(1, "img", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c1$5, ctx_r0.data.link))("title", ctx_r0.data.copyright || "")("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_3_div_2_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 49);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl)("alt", ctx_r0.data.copyright || "");
} }
function CardComponent_ng_container_0_ng_container_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_3_div_2_a_1_Template, 2, 4, "a", 43)(2, CardComponent_ng_container_0_ng_container_3_div_2_a_2_Template, 2, 6, "a", 44)(3, CardComponent_ng_container_0_ng_container_3_div_2_img_3_Template, 1, 2, "img", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.image && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.image && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link && ctx_r0.data.image);
} }
function CardComponent_ng_container_0_ng_container_3_div_3_youtube_video_player_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "youtube-video-player", 52);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("videoId", ctx_r0.data.video);
} }
function CardComponent_ng_container_0_ng_container_3_div_3_video_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "video", 53, 0);
    i0.ɵɵelement(2, "source", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r0.data.video, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("type", ctx_r0.data.videotype);
} }
function CardComponent_ng_container_0_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_3_div_3_youtube_video_player_1_Template, 1, 1, "youtube-video-player", 50)(2, CardComponent_ng_container_0_ng_container_3_div_3_video_2_Template, 3, 2, "video", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.videotype === "video/youtube");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video && !(ctx_r0.data.videotype === "video/youtube"));
} }
function CardComponent_ng_container_0_ng_container_3_div_4_h6_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.category);
} }
function CardComponent_ng_container_0_ng_container_3_div_4_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 59);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_3_div_4_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 60);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_3_div_4_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_3_div_4_fi_template_renderer_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_3_div_4_fi_template_renderer_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_3_div_4_a_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target)("title", ctx_r0.data.title || "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.callouttitle, " ");
} }
function CardComponent_ng_container_0_ng_container_3_div_4_a_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target)("title", ctx_r0.data.title || "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.callouttitle, " ");
} }
function CardComponent_ng_container_0_ng_container_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_3_div_4_h6_1_Template, 2, 1, "h6", 25);
    i0.ɵɵelementStart(2, "h5", 54);
    i0.ɵɵtemplate(3, CardComponent_ng_container_0_ng_container_3_div_4_a_3_Template, 2, 3, "a", 55)(4, CardComponent_ng_container_0_ng_container_3_div_4_a_4_Template, 2, 5, "a", 56)(5, CardComponent_ng_container_0_ng_container_3_div_4_span_5_Template, 2, 1, "span", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 58);
    i0.ɵɵtemplate(7, CardComponent_ng_container_0_ng_container_3_div_4_fi_template_renderer_7_Template, 2, 4, "fi-template-renderer", 10)(8, CardComponent_ng_container_0_ng_container_3_div_4_fi_template_renderer_8_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CardComponent_ng_container_0_ng_container_3_div_4_a_9_Template, 3, 4, "a", 11)(10, CardComponent_ng_container_0_ng_container_3_div_4_a_10_Template, 3, 6, "a", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.category);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.callouttitle && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.callouttitle && ctx_r0.config.internal);
} }
function CardComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 38);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_3_div_2_Template, 4, 3, "div", 39)(3, CardComponent_ng_container_0_ng_container_3_div_3_Template, 3, 2, "div", 40)(4, CardComponent_ng_container_0_ng_container_3_div_4_Template, 11, 8, "div", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.config.cssclass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.image && !ctx_r0.data.video);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.title || ctx_r0.data.description);
} }
function CardComponent_ng_container_0_ng_container_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42)(1, "div", 62);
    i0.ɵɵelement(2, "img", 47);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r0.data.copyright || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_4_div_3_h6_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.category);
} }
function CardComponent_ng_container_0_ng_container_4_div_3_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 59);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_4_div_3_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 60);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_4_div_3_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_4_div_3_fi_template_renderer_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_4_div_3_fi_template_renderer_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_4_div_3_a_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target)("title", ctx_r0.data.title || "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.callouttitle, " ");
} }
function CardComponent_ng_container_0_ng_container_4_div_3_a_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target)("title", ctx_r0.data.title || "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.callouttitle, " ");
} }
function CardComponent_ng_container_0_ng_container_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_4_div_3_h6_1_Template, 2, 1, "h6", 25);
    i0.ɵɵelementStart(2, "h5", 54);
    i0.ɵɵtemplate(3, CardComponent_ng_container_0_ng_container_4_div_3_a_3_Template, 2, 3, "a", 55)(4, CardComponent_ng_container_0_ng_container_4_div_3_a_4_Template, 2, 5, "a", 56)(5, CardComponent_ng_container_0_ng_container_4_div_3_span_5_Template, 2, 1, "span", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 58);
    i0.ɵɵtemplate(7, CardComponent_ng_container_0_ng_container_4_div_3_fi_template_renderer_7_Template, 2, 4, "fi-template-renderer", 10)(8, CardComponent_ng_container_0_ng_container_4_div_3_fi_template_renderer_8_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CardComponent_ng_container_0_ng_container_4_div_3_a_9_Template, 3, 4, "a", 11)(10, CardComponent_ng_container_0_ng_container_4_div_3_a_10_Template, 3, 6, "a", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.category);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.callouttitle && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.callouttitle && ctx_r0.config.internal);
} }
function CardComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 61);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_4_div_2_Template, 3, 2, "div", 39)(3, CardComponent_ng_container_0_ng_container_4_div_3_Template, 11, 8, "div", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.config.cssclass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.image);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.title || ctx_r0.data.description);
} }
function CardComponent_ng_container_0_ng_container_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 74);
    i0.ɵɵelement(1, "img", 75);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl)("alt", ctx_r0.data.title);
} }
function CardComponent_ng_container_0_ng_container_5_a_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 76)(1, "span", 77);
    i0.ɵɵelement(2, "i", 78);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵproperty("target", ctx_r0.data.target || ctx_r0.config.target);
} }
function CardComponent_ng_container_0_ng_container_5_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵelement(1, "i", 80)(2, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.location, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_5_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 81);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.date, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_5_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 81);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.date, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_5_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 81);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.year, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_5_p_14_fi_template_renderer_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_5_p_14_fi_template_renderer_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_5_p_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 82);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_5_p_14_fi_template_renderer_1_Template, 2, 4, "fi-template-renderer", 10)(2, CardComponent_ng_container_0_ng_container_5_p_14_fi_template_renderer_2_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
} }
function CardComponent_ng_container_0_ng_container_5_p_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 83)(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.dynamicFormControlService.getFormProperty(null, ctx_r0.collectionForm == null ? null : ctx_r0.collectionForm.form, "publication.result.type", "label"), ": ");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.type);
} }
function CardComponent_ng_container_0_ng_container_5_p_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 83)(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.dynamicFormControlService.getFormProperty(null, ctx_r0.collectionForm == null ? null : ctx_r0.collectionForm.form, "publication.result.language", "label"), ": ");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.lang);
} }
function CardComponent_ng_container_0_ng_container_5_div_17_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const keyword_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", keyword_r2, "");
} }
function CardComponent_ng_container_0_ng_container_5_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84)(1, "div", 85);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_5_div_17_span_2_Template, 2, 1, "span", 86);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.data.keywords);
} }
function CardComponent_ng_container_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 63);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_5_div_2_Template, 2, 2, "div", 64);
    i0.ɵɵelementStart(3, "div", 65)(4, "h5", 26)(5, "a", 66);
    i0.ɵɵelement(6, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, " \u00A0 ");
    i0.ɵɵtemplate(8, CardComponent_ng_container_0_ng_container_5_a_8_Template, 3, 2, "a", 67);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "h6", 68);
    i0.ɵɵtemplate(10, CardComponent_ng_container_0_ng_container_5_span_10_Template, 3, 1, "span", 69)(11, CardComponent_ng_container_0_ng_container_5_span_11_Template, 2, 1, "span", 70)(12, CardComponent_ng_container_0_ng_container_5_span_12_Template, 2, 1, "span", 70)(13, CardComponent_ng_container_0_ng_container_5_span_13_Template, 2, 1, "span", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, CardComponent_ng_container_0_ng_container_5_p_14_Template, 3, 2, "p", 71)(15, CardComponent_ng_container_0_ng_container_5_p_15_Template, 4, 2, "p", 72)(16, CardComponent_ng_container_0_ng_container_5_p_16_Template, 4, 2, "p", 72)(17, CardComponent_ng_container_0_ng_container_5_div_17_Template, 3, 1, "div", 73);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.image);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(12, _c1$5, "/publication/" + ctx_r0.data.id + "/" + ctx_r0.configService.env.currentLang));
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.location);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.date);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.date);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.year);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.lang);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.keywords);
} }
function CardComponent_ng_container_0_ng_container_6_span_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵelement(1, "i", 80);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.location["name_" + ctx_r0.configService.env.currentLang] ? ctx_r0.data.location["name_" + ctx_r0.configService.env.currentLang] : ctx_r0.data.location["name_" + ctx_r0.configService.env.defaultLang], ", ");
} }
function CardComponent_ng_container_0_ng_container_6_p_39_fi_template_renderer_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_6_p_39_fi_template_renderer_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_6_p_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 82);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_6_p_39_fi_template_renderer_1_Template, 2, 4, "fi-template-renderer", 10)(2, CardComponent_ng_container_0_ng_container_6_p_39_fi_template_renderer_2_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
} }
function CardComponent_ng_container_0_ng_container_6_p_40_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", ctx_r0.data.contactEmail, ")");
} }
function CardComponent_ng_container_0_ng_container_6_p_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 83)(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, CardComponent_ng_container_0_ng_container_6_p_40_span_4_Template, 2, 1, "span", 1);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.dynamicFormControlService.getFormProperty(null, ctx_r0.collectionForm == null ? null : ctx_r0.collectionForm.form, "meeting.furtherinfo", "label"), ": ");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.data.contactName, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.contactEmail);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.contactAddress, "");
} }
function CardComponent_ng_container_0_ng_container_6_div_41_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const keyword_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", keyword_r3, "");
} }
function CardComponent_ng_container_0_ng_container_6_div_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84)(1, "div", 85);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_6_div_41_span_2_Template, 2, 1, "span", 86);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.data.keywords);
} }
function CardComponent_ng_container_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 88)(2, "div", 74)(3, "div", 89)(4, "div", 90)(5, "p", 81)(6, "span", 91);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(9, "/ ");
    i0.ɵɵelementStart(10, "span", 92);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "date");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "p", 93);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "date");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(16, "div", 94);
    i0.ɵɵelementStart(17, "div", 90)(18, "p", 81)(19, "span", 91);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(22, "/ ");
    i0.ɵɵelementStart(23, "span", 92);
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "date");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "p", 93);
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "date");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(29, "div", 65)(30, "h5", 26)(31, "a", 31);
    i0.ɵɵtext(32);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(33, "h6", 68);
    i0.ɵɵtemplate(34, CardComponent_ng_container_0_ng_container_6_span_34_Template, 3, 1, "span", 69);
    i0.ɵɵelementStart(35, "span", 81);
    i0.ɵɵtext(36);
    i0.ɵɵpipe(37, "date");
    i0.ɵɵpipe(38, "date");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(39, CardComponent_ng_container_0_ng_container_6_p_39_Template, 3, 2, "p", 71)(40, CardComponent_ng_container_0_ng_container_6_p_40_Template, 6, 4, "p", 72)(41, CardComponent_ng_container_0_ng_container_6_div_41_Template, 3, 1, "div", 73);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.config.cssclass);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(8, 16, ctx_r0.data.eventStartDate, "dd"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(12, 19, ctx_r0.data.eventStartDate, "MM"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(15, 22, ctx_r0.data.eventStartDate, "yyyy"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(21, 25, ctx_r0.data.eventEndDate, "dd"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(25, 28, ctx_r0.data.eventEndDate, "MM"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(28, 31, ctx_r0.data.eventEndDate, "yyyy"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(40, _c1$5, "/meeting/" + ctx_r0.data.id + "/" + ctx_r0.configService.env.currentLang))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.location);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind2(37, 34, ctx_r0.data.eventStartDate, "d MMMM y"), " - ", i0.ɵɵpipeBind2(38, 37, ctx_r0.data.eventEndDate, "d MMMM y"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.data.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.contactName || ctx_r0.data.contactEmail || ctx_r0.data.contactAddress);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.keywords);
} }
function CardComponent_ng_container_0_ng_container_7_div_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 46);
    i0.ɵɵelement(1, "img", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("title", ctx_r0.data.copyright || "")("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl)("alt", ctx_r0.data.copyright || "");
} }
function CardComponent_ng_container_0_ng_container_7_div_2_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 49);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl)("alt", ctx_r0.data.copyright || "");
} }
function CardComponent_ng_container_0_ng_container_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_7_div_2_a_1_Template, 2, 5, "a", 43)(2, CardComponent_ng_container_0_ng_container_7_div_2_img_2_Template, 1, 2, "img", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.image);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link && ctx_r0.data.image);
} }
function CardComponent_ng_container_0_ng_container_7_div_3_youtube_video_player_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "youtube-video-player", 52);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("videoId", ctx_r0.data.video);
} }
function CardComponent_ng_container_0_ng_container_7_div_3_video_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "video", 53, 0);
    i0.ɵɵelement(2, "source", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r0.data.video, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("type", ctx_r0.data.videotype);
} }
function CardComponent_ng_container_0_ng_container_7_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 98);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_7_div_3_youtube_video_player_1_Template, 1, 1, "youtube-video-player", 50)(2, CardComponent_ng_container_0_ng_container_7_div_3_video_2_Template, 3, 2, "video", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.videotype === "video/youtube");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video && !(ctx_r0.data.videotype === "video/youtube"));
} }
function CardComponent_ng_container_0_ng_container_7_div_4_h6_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.category);
} }
function CardComponent_ng_container_0_ng_container_7_div_4_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 103);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_7_div_4_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 104);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_7_div_4_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 105);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_7_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 99);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_7_div_4_h6_1_Template, 2, 1, "h6", 25);
    i0.ɵɵelementStart(2, "h5", 54);
    i0.ɵɵtemplate(3, CardComponent_ng_container_0_ng_container_7_div_4_a_3_Template, 2, 3, "a", 100)(4, CardComponent_ng_container_0_ng_container_7_div_4_a_4_Template, 2, 5, "a", 101)(5, CardComponent_ng_container_0_ng_container_7_div_4_span_5_Template, 2, 1, "span", 102);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", ctx_r0.data.copyright || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.category);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link);
} }
function CardComponent_ng_container_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 95);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_7_div_2_Template, 3, 2, "div", 39)(3, CardComponent_ng_container_0_ng_container_7_div_3_Template, 3, 2, "div", 96)(4, CardComponent_ng_container_0_ng_container_7_div_4_Template, 6, 5, "div", 97);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.config.cssclass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.image && !ctx_r0.data.video);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.video && (ctx_r0.data.title || ctx_r0.data.description));
} }
function CardComponent_ng_container_0_ng_container_8_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 108);
    i0.ɵɵelement(2, "img", 109);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r0.config.leftcolclass ? ctx_r0.config.leftcolclass : "col-lg-2 col-md-3");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl)("alt", ctx_r0.data.title);
} }
function CardComponent_ng_container_0_ng_container_8_div_5_h6_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.category);
} }
function CardComponent_ng_container_0_ng_container_8_div_5_h5_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 54);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_8_div_5_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 115)(1, "h5", 54);
    i0.ɵɵelement(2, "span", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵproperty("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_8_div_5_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 116)(1, "h5", 54);
    i0.ɵɵelement(2, "span", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_8_div_5_fi_template_renderer_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_8_div_5_fi_template_renderer_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_8_div_5_a_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 117);
    i0.ɵɵelement(1, "i", 118);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c1$5, "/" + ctx_r0.config.detailurl + "/" + ctx_r0.data.id + "/" + ctx_r0.configService.env.currentLang));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.config.detaillabel);
} }
function CardComponent_ng_container_0_ng_container_8_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_8_div_5_h6_1_Template, 2, 1, "h6", 25)(2, CardComponent_ng_container_0_ng_container_8_div_5_h5_2_Template, 2, 1, "h5", 110)(3, CardComponent_ng_container_0_ng_container_8_div_5_a_3_Template, 3, 3, "a", 111)(4, CardComponent_ng_container_0_ng_container_8_div_5_a_4_Template, 3, 5, "a", 112);
    i0.ɵɵelementStart(5, "div", 113);
    i0.ɵɵtemplate(6, CardComponent_ng_container_0_ng_container_8_div_5_fi_template_renderer_6_Template, 2, 4, "fi-template-renderer", 10)(7, CardComponent_ng_container_0_ng_container_8_div_5_fi_template_renderer_7_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, CardComponent_ng_container_0_ng_container_8_div_5_a_8_Template, 4, 4, "a", 114);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.category);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.detailurl);
} }
function CardComponent_ng_container_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 106)(2, "div", 3);
    i0.ɵɵtemplate(3, CardComponent_ng_container_0_ng_container_8_div_3_Template, 3, 3, "div", 107);
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵtemplate(5, CardComponent_ng_container_0_ng_container_8_div_5_Template, 9, 7, "div", 41);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.config.cssclass);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.image && !ctx_r0.data.video);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.config.rightcolclass ? ctx_r0.config.rightcolclass : ctx_r0.data.image ? "col-lg-10 col-md-9" : "col-lg-12 col-md-12");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.title || ctx_r0.data.description);
} }
function CardComponent_ng_container_0_ng_container_9_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 125);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.category, " ");
} }
function CardComponent_ng_container_0_ng_container_9_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 126)(1, "div", 108);
    i0.ɵɵelement(2, "img", 109);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl)("alt", ctx_r0.data.title);
} }
function CardComponent_ng_container_0_ng_container_9_div_8_youtube_video_player_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "youtube-video-player", 52);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("videoId", ctx_r0.data.video);
} }
function CardComponent_ng_container_0_ng_container_9_div_8_video_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "video", 53, 0);
    i0.ɵɵelement(2, "source", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r0.data.video, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("type", ctx_r0.data.videotype);
} }
function CardComponent_ng_container_0_ng_container_9_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 126);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_9_div_8_youtube_video_player_1_Template, 1, 1, "youtube-video-player", 50)(2, CardComponent_ng_container_0_ng_container_9_div_8_video_2_Template, 3, 2, "video", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.videotype === "video/youtube");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video && !(ctx_r0.data.videotype === "video/youtube"));
} }
function CardComponent_ng_container_0_ng_container_9_div_9_a_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 131);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.link);
} }
function CardComponent_ng_container_0_ng_container_9_div_9_a_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 132);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c1$5, ctx_r0.data.link));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.link);
} }
function CardComponent_ng_container_0_ng_container_9_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 126)(1, "div", 127)(2, "p", 128);
    i0.ɵɵtext(3);
    i0.ɵɵelement(4, "br");
    i0.ɵɵtemplate(5, CardComponent_ng_container_0_ng_container_9_div_9_a_5_Template, 2, 2, "a", 129)(6, CardComponent_ng_container_0_ng_container_9_div_9_a_6_Template, 2, 4, "a", 130);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" SOURCE: ", ctx_r0.data.source, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
} }
function CardComponent_ng_container_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 119)(2, "div", 120)(3, "div", 121)(4, "h4", 122);
    i0.ɵɵelement(5, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CardComponent_ng_container_0_ng_container_9_p_6_Template, 2, 1, "p", 123);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CardComponent_ng_container_0_ng_container_9_div_7_Template, 3, 2, "div", 124)(8, CardComponent_ng_container_0_ng_container_9_div_8_Template, 3, 2, "div", 124)(9, CardComponent_ng_container_0_ng_container_9_div_9_Template, 7, 3, "div", 124);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.config.cssclass);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.category);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.image && !ctx_r0.data.video);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.source);
} }
function CardComponent_ng_container_0_ng_container_10_div_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 140);
    i0.ɵɵelement(1, "img", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("title", ctx_r0.data.copyright || "")("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_10_div_2_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 141);
    i0.ɵɵelement(1, "img", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c1$5, ctx_r0.data.link))("title", ctx_r0.data.copyright || "")("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_10_div_2_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 75);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl)("alt", ctx_r0.data.copyright || "");
} }
function CardComponent_ng_container_0_ng_container_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 136);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_10_div_2_a_1_Template, 2, 4, "a", 137)(2, CardComponent_ng_container_0_ng_container_10_div_2_a_2_Template, 2, 6, "a", 138)(3, CardComponent_ng_container_0_ng_container_10_div_2_img_3_Template, 1, 2, "img", 139);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.image && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.image && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link && ctx_r0.data.image);
} }
function CardComponent_ng_container_0_ng_container_10_a_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 30);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_10_a_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_10_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_10_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵelement(1, "i", 80)(2, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.location, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_10_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 81);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.date, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_10_p_11_fi_template_renderer_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_10_p_11_fi_template_renderer_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_10_p_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 82);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_10_p_11_fi_template_renderer_1_Template, 2, 4, "fi-template-renderer", 10)(2, CardComponent_ng_container_0_ng_container_10_p_11_fi_template_renderer_2_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
} }
function CardComponent_ng_container_0_ng_container_10_div_12_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const keyword_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", keyword_r4, "");
} }
function CardComponent_ng_container_0_ng_container_10_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84)(1, "div", 85);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_10_div_12_span_2_Template, 2, 1, "span", 86);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.data.keywords);
} }
function CardComponent_ng_container_0_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 133);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_10_div_2_Template, 4, 3, "div", 134);
    i0.ɵɵelementStart(3, "div", 65)(4, "h5", 26);
    i0.ɵɵtemplate(5, CardComponent_ng_container_0_ng_container_10_a_5_Template, 2, 3, "a", 27)(6, CardComponent_ng_container_0_ng_container_10_a_6_Template, 2, 5, "a", 28)(7, CardComponent_ng_container_0_ng_container_10_span_7_Template, 1, 1, "span", 135);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "h6", 68);
    i0.ɵɵtemplate(9, CardComponent_ng_container_0_ng_container_10_span_9_Template, 3, 1, "span", 69)(10, CardComponent_ng_container_0_ng_container_10_span_10_Template, 2, 1, "span", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, CardComponent_ng_container_0_ng_container_10_p_11_Template, 3, 2, "p", 71)(12, CardComponent_ng_container_0_ng_container_10_div_12_Template, 3, 1, "div", 73);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(13, "hr");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.image);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.location);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.date);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.keywords);
} }
function CardComponent_ng_container_0_ng_container_11_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "img", 75);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl)("alt", ctx_r0.data.copyright || "");
} }
function CardComponent_ng_container_0_ng_container_11_h6_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.category);
} }
function CardComponent_ng_container_0_ng_container_11_a_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 59);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_11_a_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 60);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_11_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_11_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵelement(1, "i", 80)(2, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.location, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_11_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 81);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.date, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_11_p_12_fi_template_renderer_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_11_p_12_fi_template_renderer_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_11_p_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 58);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_11_p_12_fi_template_renderer_1_Template, 2, 4, "fi-template-renderer", 10)(2, CardComponent_ng_container_0_ng_container_11_p_12_fi_template_renderer_2_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
} }
function CardComponent_ng_container_0_ng_container_11_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const keyword_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", keyword_r5, "");
} }
function CardComponent_ng_container_0_ng_container_11_a_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target)("title", ctx_r0.data.title || "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.callouttitle, " ");
} }
function CardComponent_ng_container_0_ng_container_11_a_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target)("title", ctx_r0.data.title || "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.callouttitle, " ");
} }
function CardComponent_ng_container_0_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 142);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_11_div_2_Template, 2, 2, "div", 40);
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵtemplate(4, CardComponent_ng_container_0_ng_container_11_h6_4_Template, 2, 1, "h6", 25);
    i0.ɵɵelementStart(5, "h5", 54);
    i0.ɵɵtemplate(6, CardComponent_ng_container_0_ng_container_11_a_6_Template, 2, 3, "a", 55)(7, CardComponent_ng_container_0_ng_container_11_a_7_Template, 2, 5, "a", 56)(8, CardComponent_ng_container_0_ng_container_11_span_8_Template, 2, 1, "span", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "h6", 143);
    i0.ɵɵtemplate(10, CardComponent_ng_container_0_ng_container_11_span_10_Template, 3, 1, "span", 69)(11, CardComponent_ng_container_0_ng_container_11_span_11_Template, 2, 1, "span", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, CardComponent_ng_container_0_ng_container_11_p_12_Template, 3, 2, "p", 144);
    i0.ɵɵelementStart(13, "div", 145)(14, "div", 85);
    i0.ɵɵtemplate(15, CardComponent_ng_container_0_ng_container_11_span_15_Template, 2, 1, "span", 86);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, CardComponent_ng_container_0_ng_container_11_a_16_Template, 3, 4, "a", 11)(17, CardComponent_ng_container_0_ng_container_11_a_17_Template, 3, 6, "a", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.image);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.category);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.location);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.date);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.data.keywords);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.callouttitle && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.callouttitle && ctx_r0.config.internal);
} }
function CardComponent_ng_container_0_ng_container_12_div_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 140);
    i0.ɵɵelement(1, "img", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("title", ctx_r0.data.copyright || "")("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_12_div_2_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 141);
    i0.ɵɵelement(1, "img", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c1$5, ctx_r0.data.link))("title", ctx_r0.data.copyright || "")("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_12_div_2_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 75);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl)("alt", ctx_r0.data.copyright || "");
} }
function CardComponent_ng_container_0_ng_container_12_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_12_div_2_a_1_Template, 2, 4, "a", 137)(2, CardComponent_ng_container_0_ng_container_12_div_2_a_2_Template, 2, 6, "a", 138)(3, CardComponent_ng_container_0_ng_container_12_div_2_img_3_Template, 1, 2, "img", 139);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.image && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.image && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link && ctx_r0.data.image);
} }
function CardComponent_ng_container_0_ng_container_12_div_3_youtube_video_player_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "youtube-video-player", 52);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("videoId", ctx_r0.data.video);
} }
function CardComponent_ng_container_0_ng_container_12_div_3_video_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "video", 53, 0);
    i0.ɵɵelement(2, "source", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r0.data.video, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("type", ctx_r0.data.videotype);
} }
function CardComponent_ng_container_0_ng_container_12_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_12_div_3_youtube_video_player_1_Template, 1, 1, "youtube-video-player", 50)(2, CardComponent_ng_container_0_ng_container_12_div_3_video_2_Template, 3, 2, "video", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.videotype === "video/youtube");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video && !(ctx_r0.data.videotype === "video/youtube"));
} }
function CardComponent_ng_container_0_ng_container_12_h6_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.category);
} }
function CardComponent_ng_container_0_ng_container_12_a_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 59);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_12_a_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 60);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_12_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_12_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵelement(1, "i", 80)(2, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.location, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_12_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 81);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.date, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_12_p_13_fi_template_renderer_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_12_p_13_fi_template_renderer_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_12_p_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 58);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_12_p_13_fi_template_renderer_1_Template, 2, 4, "fi-template-renderer", 10)(2, CardComponent_ng_container_0_ng_container_12_p_13_fi_template_renderer_2_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
} }
function CardComponent_ng_container_0_ng_container_12_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const keyword_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", keyword_r6, "");
} }
function CardComponent_ng_container_0_ng_container_12_a_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target)("title", ctx_r0.data.title || "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.callouttitle, " ");
} }
function CardComponent_ng_container_0_ng_container_12_a_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target)("title", ctx_r0.data.title || "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.callouttitle, " ");
} }
function CardComponent_ng_container_0_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 146);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_12_div_2_Template, 4, 3, "div", 40)(3, CardComponent_ng_container_0_ng_container_12_div_3_Template, 3, 2, "div", 40);
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵtemplate(5, CardComponent_ng_container_0_ng_container_12_h6_5_Template, 2, 1, "h6", 25);
    i0.ɵɵelementStart(6, "h5", 54);
    i0.ɵɵtemplate(7, CardComponent_ng_container_0_ng_container_12_a_7_Template, 2, 3, "a", 55)(8, CardComponent_ng_container_0_ng_container_12_a_8_Template, 2, 5, "a", 56)(9, CardComponent_ng_container_0_ng_container_12_span_9_Template, 2, 1, "span", 57);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "h6", 143);
    i0.ɵɵtemplate(11, CardComponent_ng_container_0_ng_container_12_span_11_Template, 3, 1, "span", 69)(12, CardComponent_ng_container_0_ng_container_12_span_12_Template, 2, 1, "span", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, CardComponent_ng_container_0_ng_container_12_p_13_Template, 3, 2, "p", 144);
    i0.ɵɵelementStart(14, "div", 145)(15, "div", 85);
    i0.ɵɵtemplate(16, CardComponent_ng_container_0_ng_container_12_span_16_Template, 2, 1, "span", 86);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(17, CardComponent_ng_container_0_ng_container_12_a_17_Template, 3, 4, "a", 11)(18, CardComponent_ng_container_0_ng_container_12_a_18_Template, 3, 6, "a", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.image && !ctx_r0.data.video);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.category);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.location);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.date);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.data.keywords);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.callouttitle && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.callouttitle && ctx_r0.config.internal);
} }
function CardComponent_ng_container_0_ng_container_13_div_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 140);
    i0.ɵɵelement(1, "img", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("title", ctx_r0.data.copyright || "")("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_13_div_2_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 141);
    i0.ɵɵelement(1, "img", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c1$5, ctx_r0.data.link))("title", ctx_r0.data.copyright || "")("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_13_div_2_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 75);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl)("alt", ctx_r0.data.copyright || "");
} }
function CardComponent_ng_container_0_ng_container_13_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 136);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_13_div_2_a_1_Template, 2, 4, "a", 137)(2, CardComponent_ng_container_0_ng_container_13_div_2_a_2_Template, 2, 6, "a", 138)(3, CardComponent_ng_container_0_ng_container_13_div_2_img_3_Template, 1, 2, "img", 139);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.image && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.image && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link && ctx_r0.data.image);
} }
function CardComponent_ng_container_0_ng_container_13_div_3_youtube_video_player_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "youtube-video-player", 52);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("videoId", ctx_r0.data.video);
} }
function CardComponent_ng_container_0_ng_container_13_div_3_video_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "video", 53, 0);
    i0.ɵɵelement(2, "source", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r0.data.video, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("type", ctx_r0.data.videotype);
} }
function CardComponent_ng_container_0_ng_container_13_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 136);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_13_div_3_youtube_video_player_1_Template, 1, 1, "youtube-video-player", 50)(2, CardComponent_ng_container_0_ng_container_13_div_3_video_2_Template, 3, 2, "video", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.videotype === "video/youtube");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video && !(ctx_r0.data.videotype === "video/youtube"));
} }
function CardComponent_ng_container_0_ng_container_13_a_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 30);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_13_a_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_13_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_13_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵelement(1, "i", 80)(2, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.location, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_13_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 81);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.date, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_13_p_12_fi_template_renderer_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_13_p_12_fi_template_renderer_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_13_p_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 82);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_13_p_12_fi_template_renderer_1_Template, 2, 4, "fi-template-renderer", 10)(2, CardComponent_ng_container_0_ng_container_13_p_12_fi_template_renderer_2_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
} }
function CardComponent_ng_container_0_ng_container_13_div_13_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const keyword_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", keyword_r7, "");
} }
function CardComponent_ng_container_0_ng_container_13_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84)(1, "div", 85);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_13_div_13_span_2_Template, 2, 1, "span", 86);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.data.keywords);
} }
function CardComponent_ng_container_0_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 147);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_13_div_2_Template, 4, 3, "div", 134)(3, CardComponent_ng_container_0_ng_container_13_div_3_Template, 3, 2, "div", 134);
    i0.ɵɵelementStart(4, "div", 65)(5, "h5", 26);
    i0.ɵɵtemplate(6, CardComponent_ng_container_0_ng_container_13_a_6_Template, 2, 3, "a", 27)(7, CardComponent_ng_container_0_ng_container_13_a_7_Template, 2, 5, "a", 28)(8, CardComponent_ng_container_0_ng_container_13_span_8_Template, 1, 1, "span", 135);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "h6", 68);
    i0.ɵɵtemplate(10, CardComponent_ng_container_0_ng_container_13_span_10_Template, 3, 1, "span", 69)(11, CardComponent_ng_container_0_ng_container_13_span_11_Template, 2, 1, "span", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, CardComponent_ng_container_0_ng_container_13_p_12_Template, 3, 2, "p", 71)(13, CardComponent_ng_container_0_ng_container_13_div_13_Template, 3, 1, "div", 73);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.image && !ctx_r0.data.video);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.location);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.date);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.keywords);
} }
function CardComponent_ng_container_0_ng_container_14_div_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 140);
    i0.ɵɵelement(1, "img", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("title", ctx_r0.data.copyright || "")("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_14_div_2_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 141);
    i0.ɵɵelement(1, "img", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c1$5, ctx_r0.data.link))("title", ctx_r0.data.copyright || "")("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl);
} }
function CardComponent_ng_container_0_ng_container_14_div_2_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 75);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("src", ctx_r0.utilsService.processUrl(ctx_r0.space, ctx_r0.data.image), i0.ɵɵsanitizeUrl)("alt", ctx_r0.data.copyright || "");
} }
function CardComponent_ng_container_0_ng_container_14_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 136);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_14_div_2_a_1_Template, 2, 4, "a", 137)(2, CardComponent_ng_container_0_ng_container_14_div_2_a_2_Template, 2, 6, "a", 138)(3, CardComponent_ng_container_0_ng_container_14_div_2_img_3_Template, 1, 2, "img", 139);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.image && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.data.image && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link && ctx_r0.data.image);
} }
function CardComponent_ng_container_0_ng_container_14_div_3_youtube_video_player_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "youtube-video-player", 52);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("videoId", ctx_r0.data.video);
} }
function CardComponent_ng_container_0_ng_container_14_div_3_video_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "video", 53, 0);
    i0.ɵɵelement(2, "source", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r0.data.video, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("type", ctx_r0.data.videotype);
} }
function CardComponent_ng_container_0_ng_container_14_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 136);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_14_div_3_youtube_video_player_1_Template, 1, 1, "youtube-video-player", 50)(2, CardComponent_ng_container_0_ng_container_14_div_3_video_2_Template, 3, 2, "video", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.videotype === "video/youtube");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video && !(ctx_r0.data.videotype === "video/youtube"));
} }
function CardComponent_ng_container_0_ng_container_14_a_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 30);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r0.data.link, i0.ɵɵsanitizeUrl)("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_14_a_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1$5, ctx_r0.data.link))("target", ctx_r0.data.target || ctx_r0.config.target);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_14_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.title, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_14_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 79);
    i0.ɵɵelement(1, "i", 80)(2, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.data.location, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_14_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 81);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.date, i0.ɵɵsanitizeHtml);
} }
function CardComponent_ng_container_0_ng_container_14_p_12_fi_template_renderer_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_14_p_12_fi_template_renderer_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
    i0.ɵɵpipe(1, "truncate");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("template", i0.ɵɵpipeBind2(1, 1, ctx_r0.data.description, 250));
} }
function CardComponent_ng_container_0_ng_container_14_p_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 82);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_14_p_12_fi_template_renderer_1_Template, 2, 4, "fi-template-renderer", 10)(2, CardComponent_ng_container_0_ng_container_14_p_12_fi_template_renderer_2_Template, 2, 4, "fi-template-renderer", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && ctx_r0.textlimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description && !ctx_r0.textlimit);
} }
function CardComponent_ng_container_0_ng_container_14_div_13_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 87);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const keyword_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", keyword_r8, "");
} }
function CardComponent_ng_container_0_ng_container_14_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84)(1, "div", 85);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_14_div_13_span_2_Template, 2, 1, "span", 86);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.data.keywords);
} }
function CardComponent_ng_container_0_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 148);
    i0.ɵɵtemplate(2, CardComponent_ng_container_0_ng_container_14_div_2_Template, 4, 3, "div", 134)(3, CardComponent_ng_container_0_ng_container_14_div_3_Template, 3, 2, "div", 134);
    i0.ɵɵelementStart(4, "div", 65)(5, "h5", 26);
    i0.ɵɵtemplate(6, CardComponent_ng_container_0_ng_container_14_a_6_Template, 2, 3, "a", 27)(7, CardComponent_ng_container_0_ng_container_14_a_7_Template, 2, 5, "a", 28)(8, CardComponent_ng_container_0_ng_container_14_span_8_Template, 1, 1, "span", 135);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "h6", 68);
    i0.ɵɵtemplate(10, CardComponent_ng_container_0_ng_container_14_span_10_Template, 3, 1, "span", 69)(11, CardComponent_ng_container_0_ng_container_14_span_11_Template, 2, 1, "span", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, CardComponent_ng_container_0_ng_container_14_p_12_Template, 3, 2, "p", 71)(13, CardComponent_ng_container_0_ng_container_14_div_13_Template, 3, 1, "div", 73);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.image && !ctx_r0.data.video);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.video);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && !ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.link && ctx_r0.config.internal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.data.link);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.data.location);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.date);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.keywords);
} }
function CardComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CardComponent_ng_container_0_ng_container_1_Template, 13, 7, "ng-container", 1)(2, CardComponent_ng_container_0_ng_container_2_Template, 3, 2, "ng-container", 1)(3, CardComponent_ng_container_0_ng_container_3_Template, 5, 4, "ng-container", 1)(4, CardComponent_ng_container_0_ng_container_4_Template, 4, 3, "ng-container", 1)(5, CardComponent_ng_container_0_ng_container_5_Template, 18, 14, "ng-container", 1)(6, CardComponent_ng_container_0_ng_container_6_Template, 42, 42, "ng-container", 1)(7, CardComponent_ng_container_0_ng_container_7_Template, 5, 4, "ng-container", 1)(8, CardComponent_ng_container_0_ng_container_8_Template, 6, 4, "ng-container", 1)(9, CardComponent_ng_container_0_ng_container_9_Template, 10, 6, "ng-container", 1)(10, CardComponent_ng_container_0_ng_container_10_Template, 14, 8, "ng-container", 1)(11, CardComponent_ng_container_0_ng_container_11_Template, 18, 11, "ng-container", 1)(12, CardComponent_ng_container_0_ng_container_12_Template, 19, 12, "ng-container", 1)(13, CardComponent_ng_container_0_ng_container_13_Template, 14, 9, "ng-container", 1)(14, CardComponent_ng_container_0_ng_container_14_Template, 14, 9, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDHORIZONTALCAPTION);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.HERO);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARD);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDPUBLICATION);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDPUBLICATIONHORIZONTAL);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDMEETING);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDOVERLAY);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDHORIZONTAL);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDFULL);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDNEWSHORIZONTAL);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDPHOTO);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDVIDEO);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDPHOTOHORIZONTAL);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data && ctx_r0.config.view === ctx_r0.configService.cardTypes.CARDVIDEOHORIZONTAL);
} }
class CardComponent {
    constructor(configService, utilsService, dynamicFormControlService) {
        this.configService = configService;
        this.utilsService = utilsService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.view = 'card';
        this.templateType = "detail";
        this.ready = false;
    }
    ngOnInit() {
        this.init();
    }
    ngAfterViewInit() {
        this.setVideo();
    }
    init() {
        this.config = this.config || {};
        if (this.data && typeof (this.data) === 'string') {
            try {
                this.data = JSON.parse(this.data);
                this.setAutoLink();
            }
            catch (err) {
                console.log(this.data);
                console.log(err);
            }
        }
        else {
            this.data = this.data || {};
            this.setAutoLink();
        }
        if (this.view === "hero" && !this.data.image) {
            this.data.image = "assets/images/noimage.jpg";
        }
        if (this.data.video && this.data.videotype === 'video/youtube') {
            this.data.video = this.transform(this.data.video);
        }
        this.config.cssclass = this.config.cssclass || this.cssclass || this.data?.cssclass;
        this.config.target = this.config.target || this.target || this.data?.target || "_self";
        this.config.detailurl = this.config.detailurl || this.detailurl;
        this.config.detaillabel = this.config.detaillabel || this.detaillabel;
        this.config.leftcolclass = this.config.leftcolclass || this.leftcolclass;
        this.config.rightcolclass = this.config.rightcolclass || this.rightcolclass;
        this.config.view = this.view;
        this.config.internal = this.isInternal(this.data.link);
        this.config.textlimit = this.textlimit;
        this.ready = true;
    }
    setAutoLink() {
        if (!this.data?.link && this.space && this.collection) {
            this.data.link = "/" + (this.configService.env.hosted && this.configService.env.space ? "" : this.space) + "/" + this.collection + "/" + this.data.id + "/" + this.configService.env.currentLang;
        }
    }
    /**
     * Function added to solve the problem of the video that didn't start
     *
     * @returns
     */
    setVideo() {
        if (!this.data?.video) {
            return;
        }
        setTimeout(() => {
            if (this.videoplayer) {
                this.videoplayer.nativeElement.muted = true;
                this.videoplayer.nativeElement.play();
            }
        }, 1000);
    }
    transform(url) {
        let videoId = url.substring(url.lastIndexOf('/') + 1);
        if (videoId.includes('?')) {
            videoId = videoId.substring(0, videoId.indexOf('?'));
        }
        return videoId;
    }
    isInternal(link) {
        return !link?.startsWith("http");
    }
    static { this.ɵfac = function CardComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CardComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CardComponent, selectors: [["fi-card"]], viewQuery: function CardComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$g, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.videoplayer = _t.first);
        } }, inputs: { space: "space", collection: "collection", collectionForm: "collectionForm", view: "view", data: "data", target: "target", cssclass: "cssclass", detailurl: "detailurl", detaillabel: "detaillabel", textlimit: "textlimit", leftcolclass: "leftcolclass", rightcolclass: "rightcolclass", templateUrl: "templateUrl", templateId: "templateId", templateType: "templateType", config: "config" }, standalone: false, decls: 1, vars: 1, consts: [["video", ""], [4, "ngIf"], [1, "card", "card-horizontal", "bg-caption"], [1, "row", "g-0", "align-items-center"], ["class", "col-md-6", 4, "ngIf"], [3, "ngClass"], [1, "card-body"], [1, "card-title", "text-white"], [3, "innerHTML"], [1, "card-text", "text-white"], [3, "template", 4, "ngIf"], ["class", "link-icon", 3, "href", "target", "title", 4, "ngIf"], ["class", "link-icon", 3, "routerLink", "target", "title", 4, "ngIf"], [1, "col-md-6"], [1, "card-image", "ratio", "ratio-3x2"], [3, "src"], [3, "template"], [1, "link-icon", 3, "href", "target", "title"], [1, "bi", "bi-chevron-right"], [1, "link-icon", 3, "routerLink", "target", "title"], ["class", "hero-banner", 3, "ngClass", "ngStyle", "title", 4, "ngIf"], ["class", "hero-banner", 4, "ngIf"], [1, "hero-banner", 3, "ngClass", "ngStyle", "title"], ["class", "hero-caption", 4, "ngIf"], [1, "hero-caption"], ["class", "title-category", 4, "ngIf"], [1, "title-link"], [3, "href", "target", 4, "ngIf"], [3, "routerLink", "target", 4, "ngIf"], [1, "title-category"], [3, "href", "target"], [3, "routerLink", "target"], [1, "hero-banner"], ["class", "hero-banner-video", 3, "videoId", 4, "ngIf"], ["class", "hero-banner-video", "autoplay", "autoplay", "muted", "true", "loop", "true", "height", "inherit", 4, "ngIf"], [1, "hero-banner-video", 3, "videoId"], ["autoplay", "autoplay", "muted", "true", "loop", "true", "height", "inherit", 1, "hero-banner-video"], [3, "src", "type"], [1, "card", 3, "ngClass"], ["class", "card-image ratio-3x2", 4, "ngIf"], ["class", "card-image ratio ratio-3x2", 4, "ngIf"], ["class", "card-body", 4, "ngIf"], [1, "card-image", "ratio-3x2"], ["class", "title-link", 3, "href", "title", "target", 4, "ngIf"], ["class", "title-link", 3, "routerLink", "title", "target", 4, "ngIf"], ["width", "100%", "height", "100%", 3, "src", "alt", 4, "ngIf"], [1, "title-link", 3, "href", "title", "target"], ["width", "100%", "height", "100%", 3, "src"], [1, "title-link", 3, "routerLink", "title", "target"], ["width", "100%", "height", "100%", 3, "src", "alt"], [3, "videoId", 4, "ngIf"], ["autoplay", "autoplay", "muted", "true", "loop", "true", "height", "inherit", 4, "ngIf"], [3, "videoId"], ["autoplay", "autoplay", "muted", "true", "loop", "true", "height", "inherit"], [1, "card-title"], ["class", "title-link", 3, "href", "target", 4, "ngIf"], ["class", "title-link", 3, "routerLink", "target", 4, "ngIf"], ["class", "title-link", 4, "ngIf"], [1, "card-text"], [1, "title-link", 3, "href", "target"], [1, "title-link", 3, "routerLink", "target"], [1, "card", "card-publication", 3, "ngClass"], [1, "card-pub-image", 3, "title"], [1, "d-list", "d-list-publication"], ["class", "d-list-visual", 4, "ngIf"], [1, "d-list-content"], [3, "routerLink"], ["target", "_blank", "title", "View PDF", "class", "float-right", 3, "href", "target", 4, "ngIf"], [1, "date-location", "d-list-date-location"], ["class", "location", 4, "ngIf"], ["class", "date", 4, "ngIf"], ["class", "d-list-description", 4, "ngIf"], ["class", "me-3 mb-2", 4, "ngIf"], ["class", "classifications d-list-classifications", 4, "ngIf"], [1, "d-list-visual"], [3, "src", "alt"], ["target", "_blank", "title", "View PDF", 1, "float-right", 3, "href", "target"], [1, "text-right"], [1, "bi", "bi-file-earmark"], [1, "location"], [1, "bi", "bi-geo-alt-fill"], [1, "date"], [1, "d-list-description"], [1, "me-3", "mb-2"], [1, "classifications", "d-list-classifications"], [1, "tags-list"], ["class", "badge text-bg-secondary", 4, "ngFor", "ngForOf"], [1, "badge", "text-bg-secondary"], [1, "d-list", "d-list-event", 3, "ngClass"], [1, "card-calendar"], [1, "row-calendar"], [1, "date__day"], [1, "date__month"], [1, "year"], [1, "from-to-divider"], [1, "card", "card-overlay", "undefined", "undefined", 3, "ngClass"], ["class", "ratio-3x2", 4, "ngIf"], ["class", "card-img-overlay d-flex flex-column justify-content-center", 3, "title", 4, "ngIf"], [1, "ratio-3x2"], [1, "card-img-overlay", "d-flex", "flex-column", "justify-content-center", 3, "title"], ["class", "title-link stretched-link", 3, "href", "target", 4, "ngIf"], ["class", "title-link stretched-link", 3, "routerLink", "target", 4, "ngIf"], ["class", "title-link stretched-link", 4, "ngIf"], [1, "title-link", "stretched-link", 3, "href", "target"], [1, "title-link", "stretched-link", 3, "routerLink", "target"], [1, "title-link", "stretched-link"], [1, "card", "card-horizontal", 3, "ngClass"], [3, "ngClass", 4, "ngIf"], [1, "card-image", "ratio-3x2", "p-4"], ["width", "100%", "height", "100%", 1, "img-fluid", 3, "src", "alt"], ["class", "card-title", 4, "ngIf"], ["class", "link-icon", 3, "href", "target", 4, "ngIf"], ["class", "link-icon", 3, "routerLink", "target", 4, "ngIf"], [1, "mb-2"], ["class", "link-icon", 3, "routerLink", 4, "ngIf"], [1, "link-icon", 3, "href", "target"], [1, "link-icon", 3, "routerLink", "target"], [1, "link-icon", 3, "routerLink"], [1, "bi", "bi-file-earmark-text"], [1, "container-fluid", "mb-3", 3, "ngClass"], [1, "row", "no-gutters"], [1, "col-md-12", "mt-4"], [1, "title-highlight", "mb-2", 2, "text-align", "center"], ["class", "text-center mb-5 d-flex justify-content-center", 4, "ngIf"], ["class", "col-md-12", 4, "ngIf"], [1, "text-center", "mb-5", "d-flex", "justify-content-center"], [1, "col-md-12"], [1, "sf-Long-text"], [1, "mt-4", "small", "text-center"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "routerLink", 4, "ngIf"], ["target", "_blank", 3, "href"], ["target", "_blank", 3, "routerLink"], [1, "d-list", "d-list-news"], ["class", "d-list-visual ratio ratio-3x2", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [1, "d-list-visual", "ratio", "ratio-3x2"], [3, "href", "title", "target", 4, "ngIf"], [3, "routerLink", "title", "target", 4, "ngIf"], [3, "src", "alt", 4, "ngIf"], [3, "href", "title", "target"], [3, "routerLink", "title", "target"], [1, "card", "card-photo-gallery", "bg-gray-dark"], [1, "date-location", "card-date-location"], ["class", "card-text", 4, "ngIf"], [1, "classifications", "card-classifications"], [1, "card", "card-video", "bg-gray-dark"], [1, "d-list", "d-list-photogallery"], [1, "d-list", "d-list-video"]], template: function CardComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, CardComponent_ng_container_0_Template, 15, 14, "ng-container", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.ready);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardComponent, [{
        type: Component,
        args: [{ selector: 'fi-card', standalone: false, template: "<!-- <fi-template-renderer \r\n  [space]=\"space\" \r\n  [collection]=\"collection\" \r\n  [collectionForm]=\"collectionForm\"\r\n  [config]=\"config\"\r\n  [data]=\"data\"\r\n  [templateSpace]=\"configService.env.templateSpace\" \r\n  [templateCollection]=\"configService.env.templateCollection\" \r\n  templateId=\"card\"\r\n  *ngIf=\"ready\"></fi-template-renderer> -->\r\n\r\n<ng-container *ngIf=\"ready\">\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDHORIZONTALCAPTION\">\r\n    <div class=\"card card-horizontal bg-caption\">\r\n      <div class=\"row g-0 align-items-center\">\r\n        <div class=\"col-md-6\" *ngIf=\"data.image\">\r\n          <div class=\"card-image ratio ratio-3x2\">\r\n            <img [src]=\"utilsService.processUrl(space,data.image)\">\r\n          </div>\r\n        </div>\r\n        <div [ngClass]=\"data.image ? 'col-md-6' : 'col-md-12'\">\r\n          <div class=\"card-body\">\r\n            <h5 class=\"card-title text-white\"><span [innerHTML]=\"data.title\"></span></h5>\r\n            <p class=\"card-text text-white\">\r\n              <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n              <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n            </p>\r\n            <a class=\"link-icon\" *ngIf=\"data.link && data.callouttitle && !config.internal\" [href]=\"data.link\"\r\n              [target]=\"data.target || config.target\" [title]=\"data.title || ''\">\r\n              {{ data.callouttitle }}\r\n              <i class=\"bi bi-chevron-right\"></i>\r\n            </a>\r\n            <a class=\"link-icon\" *ngIf=\"data.link && data.callouttitle && config.internal\" [routerLink]=\"[data.link]\"\r\n              [target]=\"data.target || config.target\" [title]=\"data.title || ''\">\r\n              {{ data.callouttitle }}\r\n              <i class=\"bi bi-chevron-right\"></i>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.HERO\">\r\n    <div *ngIf=\"data.image && !data.video\" [ngClass]=\"config.cssclass\" class=\"hero-banner\"\r\n      [ngStyle]=\"{'background-image': 'url(' + utilsService.processUrl(space,data.image) + ')'}\"\r\n      [title]=\"data.copyright || ''\">\r\n      <div class=\"hero-caption\" *ngIf=\"data.title || data.description\">\r\n        <h6 class=\"title-category\" *ngIf=\"data.category\">{{data.category}}</h6>\r\n        <h5 class=\"title-link\">\r\n          <a *ngIf=\"data.link && !config.internal\" [href]=\"data.link\" [target]=\"data.target || config.target\"><span\r\n              [innerHTML]=\"data.title\"></span></a>\r\n          <a *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <span *ngIf=\"!data.link\"><span [innerHTML]=\"data.title\"></span></span>\r\n        </h5>\r\n        <p>\r\n          <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n          <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n        </p>\r\n      </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"data.video\" class=\"hero-banner\">\r\n      <youtube-video-player class=\"hero-banner-video\" *ngIf=\"data.videotype === 'video/youtube'\"\r\n        [videoId]=\"data.video\"></youtube-video-player>\r\n\r\n      <video class=\"hero-banner-video\" #video *ngIf=\"data.video && !(data.videotype === 'video/youtube')\"\r\n        autoplay=\"autoplay\" muted=\"true\" loop=\"true\" height=\"inherit\">\r\n        <source src=\"{{data.video}}\" type=\"{{ data.videotype }}\">\r\n      </video>\r\n\r\n      <div class=\"hero-caption\" *ngIf=\"data.title || data.description\">\r\n        <h6 class=\"title-category\" *ngIf=\"data.category\">{{data.category}}</h6>\r\n        <h5 class=\"title-link\">\r\n          <a *ngIf=\"data.link && !config.internal\" [href]=\"data.link\" [target]=\"data.target || config.target\"><span\r\n              [innerHTML]=\"data.title\"></span></a>\r\n          <a *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <span *ngIf=\"!data.link\"><span [innerHTML]=\"data.title\"></span></span>\r\n        </h5>\r\n        <p>\r\n          <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n          <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n        </p>\r\n      </div>\r\n      <!-- <a *ngIf=\"data.link\" [href]=\"data.link\" class=\"video-header-wrapper-link\" [target]=\"data.target || config.target\"></a> -->\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARD\">\r\n    <div [ngClass]=\"config.cssclass\" class=\"card\">\r\n      <div class=\"card-image ratio-3x2\" *ngIf=\"data.image && !data.video\">\r\n        <a class=\"title-link\" *ngIf=\"data.link && data.image && !config.internal\" [href]=\"data.link\"\r\n          [title]=\"data.copyright || ''\" [target]=\"data.target || config.target\">\r\n          <img [src]=\"utilsService.processUrl(space,data.image)\" width=\"100%\" height=\"100%\" />\r\n        </a>\r\n        <a class=\"title-link\" *ngIf=\"data.link && data.image && config.internal\" [routerLink]=\"[data.link]\"\r\n          [title]=\"data.copyright || ''\" [target]=\"data.target || config.target\">\r\n          <img [src]=\"utilsService.processUrl(space,data.image)\" width=\"100%\" height=\"100%\" />\r\n        </a>\r\n        <img *ngIf=\"!data.link && data.image\" [src]=\"utilsService.processUrl(space,data.image)\"\r\n          [alt]=\"data.copyright || ''\" width=\"100%\" height=\"100%\" />\r\n      </div>\r\n\r\n      <div class=\"card-image ratio ratio-3x2\" *ngIf=\"data.video\">\r\n        <youtube-video-player *ngIf=\"data.videotype === 'video/youtube'\" [videoId]=\"data.video\"></youtube-video-player>\r\n\r\n        <video #video *ngIf=\"data.video && !(data.videotype === 'video/youtube')\" autoplay=\"autoplay\" muted=\"true\"\r\n          loop=\"true\" height=\"inherit\">\r\n          <source src=\"{{data.video}}\" type=\"{{ data.videotype }}\">\r\n        </video>\r\n      </div>\r\n\r\n      <div class=\"card-body\" *ngIf=\"data.title || data.description\">\r\n        <h6 class=\"title-category\" *ngIf=\"data.category\">{{data.category}}</h6>\r\n        <h5 class=\"card-title\">\r\n          <a class=\"title-link\" *ngIf=\"data.link && !config.internal\" [href]=\"data.link\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <a class=\"title-link\" *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <span class=\"title-link\" *ngIf=\"!data.link\"><span [innerHTML]=\"data.title\"></span></span>\r\n        </h5>\r\n        <div class=\"card-text\">\r\n          <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n          <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n        </div>\r\n        <a class=\"link-icon\" *ngIf=\"data.link && data.callouttitle && !config.internal\" [href]=\"data.link\"\r\n          [target]=\"data.target || config.target\" [title]=\"data.title || ''\">\r\n          {{ data.callouttitle }}\r\n          <i class=\"bi bi-chevron-right\"></i>\r\n        </a>\r\n        <a class=\"link-icon\" *ngIf=\"data.link && data.callouttitle && config.internal\" [routerLink]=\"[data.link]\"\r\n          [target]=\"data.target || config.target\" [title]=\"data.title || ''\">\r\n          {{ data.callouttitle }}\r\n          <i class=\"bi bi-chevron-right\"></i>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDPUBLICATION\">\r\n    <div [ngClass]=\"config.cssclass\" class=\"card card-publication\">\r\n      <div class=\"card-image ratio-3x2\" *ngIf=\"data.image\">\r\n        <div class=\"card-pub-image\" [title]=\"data.copyright || ''\"><img\r\n            [src]=\"utilsService.processUrl(space,data.image)\" width=\"100%\" height=\"100%\" /></div>\r\n      </div>\r\n      <div class=\"card-body\" *ngIf=\"data.title || data.description\">\r\n        <h6 class=\"title-category\" *ngIf=\"data.category\">{{data.category}}</h6>\r\n        <h5 class=\"card-title\">\r\n          <a class=\"title-link\" *ngIf=\"data.link && !config.internal\" [href]=\"data.link\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <a class=\"title-link\" *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <span class=\"title-link\" *ngIf=\"!data.link\"><span [innerHTML]=\"data.title\"></span></span>\r\n        </h5>\r\n        <div class=\"card-text\">\r\n          <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n          <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n\r\n        </div>\r\n        <a class=\"link-icon\" *ngIf=\"data.link && data.callouttitle && !config.internal\" [href]=\"data.link\"\r\n          [target]=\"data.target || config.target\" [title]=\"data.title || ''\">\r\n          {{ data.callouttitle }}\r\n          <i class=\"bi bi-chevron-right\"></i>\r\n        </a>\r\n        <a class=\"link-icon\" *ngIf=\"data.link && data.callouttitle && config.internal\" [routerLink]=\"[data.link]\"\r\n          [target]=\"data.target || config.target\" [title]=\"data.title || ''\">\r\n          {{ data.callouttitle }}\r\n          <i class=\"bi bi-chevron-right\"></i>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDPUBLICATIONHORIZONTAL\">\r\n    <div class=\"d-list d-list-publication\">\r\n      <div class=\"d-list-visual\" *ngIf=\"data.image\">\r\n        <img [src]=\"utilsService.processUrl(space,data.image)\" [alt]=\"data.title\">\r\n      </div>\r\n      <div class=\"d-list-content\">\r\n        <h5 class=\"title-link\">\r\n          <a [routerLink]=\"['/publication/' + data.id + '/' + configService.env.currentLang]\">\r\n            <span [innerHTML]=\"data.title\"></span>\r\n          </a>\r\n          &nbsp;\r\n          <a target=\"_blank\" *ngIf=\"data.link\" title=\"View PDF\" class=\"float-right\" href=\"{{data.link}}\"\r\n            [target]=\"data.target || config.target\">\r\n            <span class=\"text-right\"><i class=\"bi bi-file-earmark\"></i></span>\r\n          </a>\r\n        </h5>\r\n\r\n        <h6 class=\"date-location d-list-date-location\">\r\n          <span class=\"location\" *ngIf=\"data.location\">\r\n            <i class=\"bi bi-geo-alt-fill\"></i><span [innerHTML]=\"data.location\"></span>\r\n          </span>\r\n          <span class=\"date\" *ngIf=\"data.date\"><span [innerHTML]=\"data.date\"></span></span>\r\n          <span class=\"date\" *ngIf=\"data.date\"><span [innerHTML]=\"data.date\"></span></span>\r\n          <span class=\"date\" *ngIf=\"data.year\"><span [innerHTML]=\"data.year\"></span></span>\r\n        </h6>\r\n\r\n        <p class=\"d-list-description\" *ngIf=\"data.description\">\r\n          <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n          <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n        </p>\r\n        <p class=\"me-3 mb-2\" *ngIf=\"data.type\">\r\n          <b>{{dynamicFormControlService.getFormProperty(null,this.collectionForm?.form,\"publication.result.type\",\"label\")}}:\r\n          </b>{{data.type}}</p>\r\n        <p class=\"me-3 mb-2\" *ngIf=\"data.lang\">\r\n          <b>{{dynamicFormControlService.getFormProperty(null,this.collectionForm?.form,\"publication.result.language\",\"label\")}}:\r\n          </b>{{data.lang}}</p>\r\n\r\n        <div class=\"classifications d-list-classifications\" *ngIf=\"data.keywords\">\r\n          <div class=\"tags-list\">\r\n            <span class=\"badge text-bg-secondary\" *ngFor=\"let keyword of data.keywords\"> {{keyword}}</span>\r\n          </div>\r\n          <!--             <p class=\"category-list\">\r\n                  <span class=\"category-list-title\">Categories:</span>\r\n                  <a href=\"#\" class=\"me-1\"> Lorem, </a\r\n                  ><a href=\"#\" class=\"me-1\"> Ipsum, </a\r\n                  ><a href=\"#\" class=\"me-1\"> Lorem ipsum, </a\r\n                  ><a href=\"#\" class=\"me-1\"> Lorem, </a\r\n                  ><a href=\"#\" class=\"me-1\"> Ipsum, </a>\r\n                </p>\r\n                <div class=\"sdg-list\">\r\n                  <span class=\"sdg-list__title\">SDGs:</span>\r\n                  <span class=\"sdg-small sdg-1\"></span\r\n                  ><span class=\"sdg-small sdg-2\"></span\r\n                  ><span class=\"sdg-small sdg-3\"></span>\r\n                </div> -->\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDMEETING\">\r\n    <div [ngClass]=\"config.cssclass\" class=\"d-list d-list-event\">\r\n      <div class=\"d-list-visual\">\r\n        <div class=\"card-calendar\">\r\n          <div class=\"row-calendar\">\r\n            <p class=\"date\">\r\n              <span class=\"date__day\">{{ data.eventStartDate | date: 'dd' }}</span>/ <span class=\"date__month\">{{\r\n                data.eventStartDate | date: 'MM' }}</span>\r\n            </p>\r\n            <p class=\"year\">{{ data.eventStartDate | date:'yyyy' }}</p>\r\n          </div>\r\n          <div class=\"from-to-divider\"></div>\r\n          <div class=\"row-calendar\">\r\n            <p class=\"date\">\r\n              <span class=\"date__day\">{{ data.eventEndDate | date: 'dd' }}</span>/ <span class=\"date__month\">{{\r\n                data.eventEndDate | date: 'MM' }}</span>\r\n            </p>\r\n            <p class=\"year\">{{ data.eventEndDate | date:'yyyy' }}</p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"d-list-content\">\r\n        <h5 class=\"title-link\"><a [routerLink]=\"['/meeting/' + data.id + '/' + configService.env.currentLang]\"\r\n            [target]=\"data.target || config.target\">{{ data.title }}</a></h5>\r\n        <h6 class=\"date-location d-list-date-location\">\r\n          <span class=\"location\" *ngIf=\"data.location\">\r\n            <i class=\"bi bi-geo-alt-fill\"></i> {{data.location['name_' + configService.env.currentLang] ?\r\n            data.location['name_' + configService.env.currentLang] : data.location['name_' +\r\n            configService.env.defaultLang]}},\r\n          </span>\r\n          <span class=\"date\">{{ data.eventStartDate | date: 'd MMMM y' }} - {{ data.eventEndDate | date: 'd MMMM y'\r\n            }}</span>\r\n        </h6>\r\n        <p class=\"d-list-description\" *ngIf=\"data.description\">\r\n          <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n          <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n        </p>\r\n        <p class=\"me-3 mb-2\" *ngIf=\"data.contactName || data.contactEmail || data.contactAddress\">\r\n          <b>{{dynamicFormControlService.getFormProperty(null,this.collectionForm?.form,\"meeting.furtherinfo\",\"label\")}}:\r\n          </b>{{data.contactName}} <span *ngIf=\"data.contactEmail\">({{data.contactEmail}})</span>\r\n          {{data.contactAddress}}</p>\r\n        <div class=\"classifications d-list-classifications\" *ngIf=\"data.keywords\">\r\n          <div class=\"tags-list\">\r\n            <span class=\"badge text-bg-secondary\" *ngFor=\"let keyword of data.keywords\"> {{keyword}}</span>\r\n          </div>\r\n          <!--                 <p class=\"category-list\">\r\n                        <span class=\"category-list-title\">Categories:</span>\r\n                        <a href=\"#\" class=\"me-1\"> Lorem, </a\r\n                        ><a href=\"#\" class=\"me-1\"> Ipsum, </a\r\n                        ><a href=\"#\" class=\"me-1\"> Lorem ipsum, </a\r\n                        ><a href=\"#\" class=\"me-1\"> Lorem, </a\r\n                        ><a href=\"#\" class=\"me-1\"> Ipsum, </a>\r\n                </p> -->\r\n          <!--             \r\n                <div class=\"sdg-list\">\r\n                  <span class=\"sdg-list__title\">SDGs:</span>\r\n                  <span class=\"sdg-small sdg-1\"></span\r\n                  ><span class=\"sdg-small sdg-2\"></span\r\n                  ><span class=\"sdg-small sdg-3\"></span>\r\n                </div> -->\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDOVERLAY\">\r\n    <div [ngClass]=\"config.cssclass\" class=\"card card-overlay undefined undefined\">\r\n      <div class=\"card-image ratio-3x2\" *ngIf=\"data.image && !data.video\">\r\n        <a class=\"title-link\" *ngIf=\"data.link && data.image\" [href]=\"data.link\" [title]=\"data.copyright || ''\"\r\n          [target]=\"data.target || config.target\">\r\n          <img [src]=\"utilsService.processUrl(space,data.image)\" [alt]=\"data.copyright || ''\" width=\"100%\"\r\n            height=\"100%\" />\r\n        </a>\r\n        <img *ngIf=\"!data.link && data.image\" [src]=\"utilsService.processUrl(space,data.image)\"\r\n          [alt]=\"data.copyright || ''\" width=\"100%\" height=\"100%\" />\r\n      </div>\r\n      <div class=\"ratio-3x2\" *ngIf=\"data.video\">\r\n        <youtube-video-player *ngIf=\"data.videotype === 'video/youtube'\" [videoId]=\"data.video\"></youtube-video-player>\r\n\r\n        <video #video *ngIf=\"data.video && !(data.videotype === 'video/youtube')\" autoplay=\"autoplay\" muted=\"true\"\r\n          loop=\"true\" height=\"inherit\">\r\n          <source src=\"{{data.video}}\" type=\"{{ data.videotype }}\">\r\n        </video>\r\n      </div>\r\n      <div *ngIf=\"!data.video && (data.title || data.description)\"\r\n        class=\"card-img-overlay d-flex flex-column justify-content-center\" [title]=\"data.copyright || ''\">\r\n        <h6 class=\"title-category\" *ngIf=\"data.category\">{{data.category}}</h6>\r\n        <h5 class=\"card-title\">\r\n          <a class=\"title-link stretched-link\" *ngIf=\"data.link && !config.internal\" [href]=\"data.link\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <a class=\"title-link stretched-link\" *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <span class=\"title-link stretched-link\" *ngIf=\"!data.link\"><span [innerHTML]=\"data.title\"></span></span>\r\n        </h5>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDHORIZONTAL\">\r\n    <!-- accettare attributo per dividere le colonne in modo diverso -->\r\n    <div class=\"card card-horizontal\" [ngClass]=\"config.cssclass\">\r\n      <div class=\"row g-0 align-items-center\">\r\n        <div *ngIf=\"data.image && !data.video\"\r\n          [ngClass]=\"config.leftcolclass ? config.leftcolclass : 'col-lg-2 col-md-3'\">\r\n          <div class=\"card-image ratio-3x2 p-4\">\r\n            <img class=\"img-fluid\" [src]=\"utilsService.processUrl(space,data.image)\" [alt]=\"data.title\" width=\"100%\"\r\n              height=\"100%\">\r\n          </div>\r\n        </div>\r\n        <div\r\n          [ngClass]=\"config.rightcolclass ? config.rightcolclass : (data.image ? 'col-lg-10 col-md-9' : 'col-lg-12 col-md-12')\">\r\n          <div class=\"card-body\" *ngIf=\"data.title || data.description\">\r\n            <h6 class=\"title-category\" *ngIf=\"data.category\">{{data.category}}</h6>\r\n            <h5 *ngIf=\"!data.link\" class=\"card-title\"><span [innerHTML]=\"data.title\"></span></h5>\r\n            <a *ngIf=\"data.link && !config.internal\" href=\"{{data.link}}\" class=\"link-icon\"\r\n              [target]=\"data.target || config.target\">\r\n              <h5 class=\"card-title\"><span [innerHTML]=\"data.title\"></span></h5>\r\n            </a>\r\n            <a *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\" class=\"link-icon\"\r\n              [target]=\"data.target || config.target\">\r\n              <h5 class=\"card-title\"><span [innerHTML]=\"data.title\"></span></h5>\r\n            </a>\r\n            <div class=\"mb-2\">\r\n              <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n              <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n            </div>\r\n            <a *ngIf=\"config.detailurl\"\r\n              [routerLink]=\"['/' + config.detailurl + '/' + data.id + '/' + configService.env.currentLang]\"\r\n              class=\"link-icon\">\r\n              <i class=\"bi bi-file-earmark-text\"></i>\r\n              <span>{{config.detaillabel}}</span>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDFULL\">\r\n    <div class=\"container-fluid mb-3\" [ngClass]=\"config.cssclass\">\r\n      <div class=\"row no-gutters\">\r\n\r\n        <div class=\"col-md-12 mt-4\">\r\n          <h4 class=\"title-highlight mb-2\" style=\"text-align: center\">\r\n            <span [innerHTML]=\"data.title\"></span>\r\n          </h4>\r\n          <p class=\"text-center mb-5 d-flex justify-content-center\" *ngIf=\"data.category\">\r\n            {{data.category}}\r\n          </p>\r\n        </div>\r\n\r\n        <div class=\"col-md-12\" *ngIf=\"data.image && !data.video\">\r\n          <div class=\"card-image ratio-3x2 p-4\">\r\n            <img class=\"img-fluid\" [src]=\"utilsService.processUrl(space,data.image)\" [alt]=\"data.title\" width=\"100%\"\r\n              height=\"100%\">\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-md-12\" *ngIf=\"data.video\">\r\n          <youtube-video-player *ngIf=\"data.videotype === 'video/youtube'\"\r\n            [videoId]=\"data.video\"></youtube-video-player>\r\n\r\n          <video #video *ngIf=\"data.video && !(data.videotype === 'video/youtube')\" autoplay=\"autoplay\" muted=\"true\"\r\n            loop=\"true\" height=\"inherit\">\r\n            <source src=\"{{data.video}}\" type=\"{{ data.videotype }}\">\r\n          </video>\r\n        </div>\r\n\r\n        <div class=\"col-md-12\" *ngIf=\"data.source\">\r\n          <div class=\"sf-Long-text\">\r\n            <p class=\"mt-4 small text-center\">\r\n              SOURCE: {{data.source}}<br><a *ngIf=\"data.link && !config.internal\" href=\"{{data.link}}\"\r\n                target=\"_blank\">{{data.link}}</a><a *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\"\r\n                target=\"_blank\">{{data.link}}</a>\r\n            </p>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDNEWSHORIZONTAL\">\r\n    <div class=\"d-list d-list-news\">\r\n      <div class=\"d-list-visual ratio ratio-3x2\" *ngIf=\"data.image\">\r\n        <a *ngIf=\"data.link && data.image && !config.internal\" [href]=\"data.link\" [title]=\"data.copyright || ''\"\r\n          [target]=\"data.target || config.target\">\r\n          <img [src]=\"utilsService.processUrl(space,data.image)\" />\r\n        </a>\r\n        <a *ngIf=\"data.link && data.image && config.internal\" [routerLink]=\"[data.link]\" [title]=\"data.copyright || ''\"\r\n          [target]=\"data.target || config.target\">\r\n          <img [src]=\"utilsService.processUrl(space,data.image)\" />\r\n        </a>\r\n        <img *ngIf=\"!data.link && data.image\" [src]=\"utilsService.processUrl(space,data.image)\"\r\n          [alt]=\"data.copyright || ''\" />\r\n      </div>\r\n      <div class=\"d-list-content\">\r\n        <h5 class=\"title-link\">\r\n          <a *ngIf=\"data.link && !config.internal\" [href]=\"data.link\" [target]=\"data.target || config.target\"><span\r\n              [innerHTML]=\"data.title\"></span></a>\r\n          <a *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <span *ngIf=\"!data.link\" [innerHTML]=\"data.title\"></span>\r\n        </h5>\r\n        <h6 class=\"date-location d-list-date-location\">\r\n          <span class=\"location\" *ngIf=\"data.location\">\r\n            <i class=\"bi bi-geo-alt-fill\"></i><span [innerHTML]=\"data.location\"></span>\r\n          </span>\r\n          <span class=\"date\" *ngIf=\"data.date\"><span [innerHTML]=\"data.date\"></span></span>\r\n        </h6>\r\n        <p class=\"d-list-description\" *ngIf=\"data.description\">\r\n          <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n          <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n        </p>\r\n        <div class=\"classifications d-list-classifications\" *ngIf=\"data.keywords\">\r\n          <div class=\"tags-list\">\r\n            <span class=\"badge text-bg-secondary\" *ngFor=\"let keyword of data.keywords\"> {{keyword}}</span>\r\n          </div>\r\n          <!--             <p class=\"category-list\">\r\n            <span class=\"category-list-title\">Categories:</span>\r\n            <a href=\"#\" class=\"me-1\"> Lorem, </a\r\n            ><a href=\"#\" class=\"me-1\"> Ipsum, </a\r\n            ><a href=\"#\" class=\"me-1\"> Lorem ipsum, </a\r\n            ><a href=\"#\" class=\"me-1\"> Lorem, </a\r\n            ><a href=\"#\" class=\"me-1\"> Ipsum, </a>\r\n          </p>\r\n          <div class=\"sdg-list\">\r\n            <span class=\"sdg-list__title\">SDGs:</span>\r\n            <span class=\"sdg-small sdg-1\"></span\r\n            ><span class=\"sdg-small sdg-2\"></span\r\n            ><span class=\"sdg-small sdg-3\"></span>\r\n          </div> -->\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <hr />\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDPHOTO\">\r\n    <div class=\"card card-photo-gallery bg-gray-dark\">\r\n      <div class=\"card-image ratio ratio-3x2\" *ngIf=\"data.image\">\r\n        <img [src]=\"utilsService.processUrl(space,data.image)\" [alt]=\"data.copyright || ''\" />\r\n      </div>\r\n      <div class=\"card-body\">\r\n        <h6 class=\"title-category\" *ngIf=\"data.category\">{{data.category}}</h6>\r\n        <h5 class=\"card-title\">\r\n          <a class=\"title-link\" *ngIf=\"data.link && !config.internal\" [href]=\"data.link\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <a class=\"title-link\" *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <span class=\"title-link\" *ngIf=\"!data.link\"><span [innerHTML]=\"data.title\"></span></span>\r\n        </h5>\r\n        <h6 class=\"date-location card-date-location\">\r\n          <span class=\"location\" *ngIf=\"data.location\">\r\n            <i class=\"bi bi-geo-alt-fill\"></i><span [innerHTML]=\"data.location\"></span>\r\n          </span>\r\n          <span class=\"date\" *ngIf=\"data.date\"><span [innerHTML]=\"data.date\"></span></span>\r\n        </h6>\r\n        <p class=\"card-text\" *ngIf=\"data.description\">\r\n          <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n          <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n        </p>\r\n\r\n        <div class=\"classifications card-classifications\">\r\n          <div class=\"tags-list\">\r\n            <span class=\"badge text-bg-secondary\" *ngFor=\"let keyword of data.keywords\"> {{keyword}}</span>\r\n          </div>\r\n          <!-- <p class=\"category-list\">\r\n              <span class=\"category-list-title\">Categories:</span>\r\n              <a href=\"#\" class=\"me-1\"> Lorem, </a\r\n              ><a href=\"#\" class=\"me-1\"> Ipsum, </a\r\n              ><a href=\"#\" class=\"me-1\"> Lorem ipsum, </a\r\n              ><a href=\"#\" class=\"me-1\"> Lorem, </a\r\n              ><a href=\"#\" class=\"me-1\"> Ipsum, </a>\r\n            </p>\r\n            <div class=\"sdg-list\">\r\n              <span class=\"sdg-small sdg-1\"></span\r\n              ><span class=\"sdg-small sdg-2\"></span\r\n              ><span class=\"sdg-small sdg-3\"></span>\r\n            </div> -->\r\n        </div>\r\n        <a class=\"link-icon\" *ngIf=\"data.link && data.callouttitle && !config.internal\" [href]=\"data.link\"\r\n          [target]=\"data.target || config.target\" [title]=\"data.title || ''\">\r\n          {{ data.callouttitle }}\r\n          <i class=\"bi bi-chevron-right\"></i>\r\n        </a>\r\n        <a class=\"link-icon\" *ngIf=\"data.link && data.callouttitle && config.internal\" [routerLink]=\"[data.link]\"\r\n          [target]=\"data.target || config.target\" [title]=\"data.title || ''\">\r\n          {{ data.callouttitle }}\r\n          <i class=\"bi bi-chevron-right\"></i>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDVIDEO\">\r\n    <div class=\"card card-video bg-gray-dark\">\r\n      <div class=\"card-image ratio ratio-3x2\" *ngIf=\"data.image && !data.video\">\r\n        <a *ngIf=\"data.link && data.image && !config.internal\" [href]=\"data.link\" [title]=\"data.copyright || ''\"\r\n          [target]=\"data.target || config.target\">\r\n          <img [src]=\"utilsService.processUrl(space,data.image)\" />\r\n        </a>\r\n        <a *ngIf=\"data.link && data.image && config.internal\" [routerLink]=\"[data.link]\" [title]=\"data.copyright || ''\"\r\n          [target]=\"data.target || config.target\">\r\n          <img [src]=\"utilsService.processUrl(space,data.image)\" />\r\n        </a>\r\n        <img *ngIf=\"!data.link && data.image\" [src]=\"utilsService.processUrl(space,data.image)\"\r\n          [alt]=\"data.copyright || ''\" />\r\n      </div>\r\n      <div class=\"card-image ratio ratio-3x2\" *ngIf=\"data.video\">\r\n        <youtube-video-player *ngIf=\"data.videotype === 'video/youtube'\" [videoId]=\"data.video\"></youtube-video-player>\r\n\r\n        <video #video *ngIf=\"data.video && !(data.videotype === 'video/youtube')\" autoplay=\"autoplay\" muted=\"true\"\r\n          loop=\"true\" height=\"inherit\">\r\n          <source src=\"{{data.video}}\" type=\"{{ data.videotype }}\">\r\n        </video>\r\n      </div>\r\n      <div class=\"card-body\">\r\n        <h6 class=\"title-category\" *ngIf=\"data.category\">{{data.category}}</h6>\r\n        <h5 class=\"card-title\">\r\n          <a class=\"title-link\" *ngIf=\"data.link && !config.internal\" [href]=\"data.link\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <a class=\"title-link\" *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <span class=\"title-link\" *ngIf=\"!data.link\"><span [innerHTML]=\"data.title\"></span></span>\r\n        </h5>\r\n        <h6 class=\"date-location card-date-location\">\r\n          <span class=\"location\" *ngIf=\"data.location\">\r\n            <i class=\"bi bi-geo-alt-fill\"></i><span [innerHTML]=\"data.location\"></span>\r\n          </span>\r\n          <span class=\"date\" *ngIf=\"data.date\"><span [innerHTML]=\"data.date\"></span></span>\r\n        </h6>\r\n        <p class=\"card-text\" *ngIf=\"data.description\">\r\n          <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n          <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n        </p>\r\n        <div class=\"classifications card-classifications\">\r\n          <div class=\"tags-list\">\r\n            <span class=\"badge text-bg-secondary\" *ngFor=\"let keyword of data.keywords\"> {{keyword}}</span>\r\n          </div>\r\n          <!-- <p class=\"category-list\">\r\n              <span class=\"category-list-title\">Categories:</span>\r\n              <a href=\"#\" class=\"me-1\"> Lorem, </a\r\n              ><a href=\"#\" class=\"me-1\"> Ipsum, </a\r\n              ><a href=\"#\" class=\"me-1\"> Lorem ipsum, </a\r\n              ><a href=\"#\" class=\"me-1\"> Lorem, </a\r\n              ><a href=\"#\" class=\"me-1\"> Ipsum, </a>\r\n            </p>\r\n            <div class=\"sdg-list\">\r\n              <span class=\"sdg-small sdg-1\"></span\r\n              ><span class=\"sdg-small sdg-2\"></span\r\n              ><span class=\"sdg-small sdg-3\"></span>\r\n            </div> -->\r\n        </div>\r\n        <a class=\"link-icon\" *ngIf=\"data.link && data.callouttitle && !config.internal\" [href]=\"data.link\"\r\n          [target]=\"data.target || config.target\" [title]=\"data.title || ''\">\r\n          {{ data.callouttitle }}\r\n          <i class=\"bi bi-chevron-right\"></i>\r\n        </a>\r\n        <a class=\"link-icon\" *ngIf=\"data.link && data.callouttitle && config.internal\" [routerLink]=\"[data.link]\"\r\n          [target]=\"data.target || config.target\" [title]=\"data.title || ''\">\r\n          {{ data.callouttitle }}\r\n          <i class=\"bi bi-chevron-right\"></i>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDPHOTOHORIZONTAL\">\r\n    <div class=\"d-list d-list-photogallery\">\r\n      <div class=\"d-list-visual ratio ratio-3x2\" *ngIf=\"data.image && !data.video\">\r\n        <a *ngIf=\"data.link && data.image && !config.internal\" [href]=\"data.link\" [title]=\"data.copyright || ''\"\r\n          [target]=\"data.target || config.target\">\r\n          <img [src]=\"utilsService.processUrl(space,data.image)\" />\r\n        </a>\r\n        <a *ngIf=\"data.link && data.image && config.internal\" [routerLink]=\"[data.link]\" [title]=\"data.copyright || ''\"\r\n          [target]=\"data.target || config.target\">\r\n          <img [src]=\"utilsService.processUrl(space,data.image)\" />\r\n        </a>\r\n        <img *ngIf=\"!data.link && data.image\" [src]=\"utilsService.processUrl(space,data.image)\"\r\n          [alt]=\"data.copyright || ''\" />\r\n      </div>\r\n      <div class=\"d-list-visual ratio ratio-3x2\" *ngIf=\"data.video\">\r\n        <youtube-video-player *ngIf=\"data.videotype === 'video/youtube'\" [videoId]=\"data.video\"></youtube-video-player>\r\n\r\n        <video #video *ngIf=\"data.video && !(data.videotype === 'video/youtube')\" autoplay=\"autoplay\" muted=\"true\"\r\n          loop=\"true\" height=\"inherit\">\r\n          <source src=\"{{data.video}}\" type=\"{{ data.videotype }}\">\r\n        </video>\r\n      </div>\r\n      <div class=\"d-list-content\">\r\n        <h5 class=\"title-link\">\r\n          <a *ngIf=\"data.link && !config.internal\" [href]=\"data.link\" [target]=\"data.target || config.target\"><span\r\n              [innerHTML]=\"data.title\"></span></a>\r\n          <a *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <span *ngIf=\"!data.link\" [innerHTML]=\"data.title\"></span>\r\n        </h5>\r\n        <h6 class=\"date-location d-list-date-location\">\r\n          <span class=\"location\" *ngIf=\"data.location\">\r\n            <i class=\"bi bi-geo-alt-fill\"></i><span [innerHTML]=\"data.location\"></span>\r\n          </span>\r\n          <span class=\"date\" *ngIf=\"data.date\"><span [innerHTML]=\"data.date\"></span></span>\r\n        </h6>\r\n        <p class=\"d-list-description\" *ngIf=\"data.description\">\r\n          <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n          <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n        </p>\r\n        <div class=\"classifications d-list-classifications\" *ngIf=\"data.keywords\">\r\n          <div class=\"tags-list\">\r\n            <span class=\"badge text-bg-secondary\" *ngFor=\"let keyword of data.keywords\"> {{keyword}}</span>\r\n          </div>\r\n          <!--             <p class=\"category-list\">\r\n              <span class=\"category-list-title\">Categories:</span>\r\n              <a href=\"#\" class=\"me-1\"> Lorem, </a\r\n              ><a href=\"#\" class=\"me-1\"> Ipsum, </a\r\n              ><a href=\"#\" class=\"me-1\"> Lorem ipsum, </a\r\n              ><a href=\"#\" class=\"me-1\"> Lorem, </a\r\n              ><a href=\"#\" class=\"me-1\"> Ipsum, </a>\r\n            </p>\r\n            <div class=\"sdg-list\">\r\n              <span class=\"sdg-list__title\">SDGs:</span>\r\n              <span class=\"sdg-small sdg-1\"></span\r\n              ><span class=\"sdg-small sdg-2\"></span\r\n              ><span class=\"sdg-small sdg-3\"></span>\r\n            </div> -->\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"data && config.view === configService.cardTypes.CARDVIDEOHORIZONTAL\">\r\n    <div class=\"d-list d-list-video\">\r\n      <div class=\"d-list-visual ratio ratio-3x2\" *ngIf=\"data.image && !data.video\">\r\n        <a *ngIf=\"data.link && data.image && !config.internal\" [href]=\"data.link\" [title]=\"data.copyright || ''\"\r\n          [target]=\"data.target || config.target\">\r\n          <img [src]=\"utilsService.processUrl(space,data.image)\" />\r\n        </a>\r\n        <a *ngIf=\"data.link && data.image && config.internal\" [routerLink]=\"[data.link]\" [title]=\"data.copyright || ''\"\r\n          [target]=\"data.target || config.target\">\r\n          <img [src]=\"utilsService.processUrl(space,data.image)\" />\r\n        </a>\r\n        <img *ngIf=\"!data.link && data.image\" [src]=\"utilsService.processUrl(space,data.image)\"\r\n          [alt]=\"data.copyright || ''\" />\r\n      </div>\r\n      <div class=\"d-list-visual ratio ratio-3x2\" *ngIf=\"data.video\">\r\n        <youtube-video-player *ngIf=\"data.videotype === 'video/youtube'\" [videoId]=\"data.video\"></youtube-video-player>\r\n\r\n        <video #video *ngIf=\"data.video && !(data.videotype === 'video/youtube')\" autoplay=\"autoplay\" muted=\"true\"\r\n          loop=\"true\" height=\"inherit\">\r\n          <source src=\"{{data.video}}\" type=\"{{ data.videotype }}\">\r\n        </video>\r\n      </div>\r\n      <div class=\"d-list-content\">\r\n        <h5 class=\"title-link\">\r\n          <a *ngIf=\"data.link && !config.internal\" [href]=\"data.link\" [target]=\"data.target || config.target\"><span\r\n              [innerHTML]=\"data.title\"></span></a>\r\n          <a *ngIf=\"data.link && config.internal\" [routerLink]=\"[data.link]\"\r\n            [target]=\"data.target || config.target\"><span [innerHTML]=\"data.title\"></span></a>\r\n          <span *ngIf=\"!data.link\" [innerHTML]=\"data.title\"></span>\r\n        </h5>\r\n        <h6 class=\"date-location d-list-date-location\">\r\n          <span class=\"location\" *ngIf=\"data.location\">\r\n            <i class=\"bi bi-geo-alt-fill\"></i><span [innerHTML]=\"data.location\"></span>\r\n          </span>\r\n          <span class=\"date\" *ngIf=\"data.date\"><span [innerHTML]=\"data.date\"></span></span>\r\n        </h6>\r\n        <p class=\"d-list-description\" *ngIf=\"data.description\">\r\n          <fi-template-renderer *ngIf=\"data.description && textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n          <fi-template-renderer *ngIf=\"data.description && !textlimit\" template=\"{{data.description | truncate:250}}\"></fi-template-renderer>\r\n        </p>\r\n        <div class=\"classifications d-list-classifications\" *ngIf=\"data.keywords\">\r\n          <div class=\"tags-list\">\r\n            <span class=\"badge text-bg-secondary\" *ngFor=\"let keyword of data.keywords\"> {{keyword}}</span>\r\n          </div>\r\n          <!--             <p class=\"category-list\">\r\n              <span class=\"category-list-title\">Categories:</span>\r\n              <a href=\"#\" class=\"me-1\"> Lorem, </a\r\n              ><a href=\"#\" class=\"me-1\"> Ipsum, </a\r\n              ><a href=\"#\" class=\"me-1\"> Lorem ipsum, </a\r\n              ><a href=\"#\" class=\"me-1\"> Lorem, </a\r\n              ><a href=\"#\" class=\"me-1\"> Ipsum, </a>\r\n            </p>\r\n            <div class=\"sdg-list\">\r\n              <span class=\"sdg-list__title\">SDGs:</span>\r\n              <span class=\"sdg-small sdg-1\"></span\r\n              ><span class=\"sdg-small sdg-2\"></span\r\n              ><span class=\"sdg-small sdg-3\"></span>\r\n            </div> -->\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</ng-container>" }]
    }], () => [{ type: i1.ConfigurationService }, { type: i1.UtilsService }, { type: i1.DynamicFormControlService }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], collectionForm: [{
            type: Input
        }], view: [{
            type: Input
        }], data: [{
            type: Input
        }], target: [{
            type: Input
        }], cssclass: [{
            type: Input
        }], detailurl: [{
            type: Input
        }], detaillabel: [{
            type: Input
        }], textlimit: [{
            type: Input
        }], leftcolclass: [{
            type: Input
        }], rightcolclass: [{
            type: Input
        }], templateUrl: [{
            type: Input
        }], templateId: [{
            type: Input
        }], templateType: [{
            type: Input
        }], config: [{
            type: Input
        }], videoplayer: [{
            type: ViewChild,
            args: ["video", { static: false }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CardComponent, { className: "CardComponent", filePath: "src/components/card/card.component.ts", lineNumber: 10 }); })();

class UserselectionService {
    constructor(configService, searchService, formDataService) {
        this.configService = configService;
        this.searchService = searchService;
        this.formDataService = formDataService;
        this.isNew = true;
        this.collection = "userselections";
        this.storageToken = "_" + this.collection;
        this.status = "approved";
    }
    initCart(space, type, callback) {
        if (this.configService.isLoggedIn()) {
            this.searchService.searchCollectionItems(space, this.collection, [new SimpleSearchParameter("document.userId", this.configService.user?.id), new SimpleSearchParameter("document.type", type)], 1000, 0, null, null).subscribe(res => {
                if (res?.results?.values) {
                    this.storeUserselections(space, res.results.values || []);
                    this.isNew = false;
                }
                else {
                    this.storeUserselections(space, [this.createNewCart()]);
                }
                callback();
            }, err => {
                this.storeUserselections(space, [this.createNewCart()]);
                callback();
            });
        }
        else {
            this.storeUserselections(space, [this.createNewCart()]);
            callback();
        }
    }
    createNewCart() {
        return {
            "document": {
                "userId": this.configService.user?.id,
                "userEmail": this.configService.user?.email,
                "type": "cart",
                "searches": [],
                "selectionList": []
            },
            "status": this.configService.env.status
        };
    }
    countCart(space) {
        let list = this.getUserselections(space);
        let items = list?.filter(item => item.document?.type === 'cart');
        if (items.length > 0) {
            let count = 0;
            items[0].document.selectionList?.map(e => {
                count = count + e.documentIds?.length;
                return e;
            });
            count = count + items[0].document.searches?.length;
            return count;
        }
        else {
            return 0;
        }
    }
    storeSearch(space, collection, request) {
        if (request.q || Object.keys(request.f).length > 0 || Object.keys(request.o).length > 0 || request.geoFilter) {
            let name = space + '-' + collection + '-' + this.randomIntFromInterval(100, 999);
            request.collections = [collection];
            let newRequest = this.convertRequest(this.checkDuplicateSearch(space, collection, request));
            if (newRequest) {
                let list = this.getUserselections(space);
                let items = list?.filter(item => item.document?.type === 'cart');
                if (items.length > 0) {
                    if (!items[0].document.searches) {
                        items[0].document.searches = [];
                    }
                    items[0].document.searches.push({
                        name: name,
                        searchRequest: newRequest
                    });
                    this.storeUserselections(space, list);
                }
                if (this.configService.isLoggedIn()) {
                    this.saveCart(space);
                }
            }
        }
    }
    checkDuplicateSearch(space, collection, request) {
        let strRequest = JSON.stringify(request);
        let index = this.getUserselections(space).findIndex(item => item.document?.type === 'search' && item.document.searchRequest?.collections?.includes(collection) && JSON.stringify(item.document.searchRequest) === strRequest);
        if (index < 0) {
            let searchRequest = JSON.parse(strRequest);
            return searchRequest;
        }
    }
    getSearchUrl(space, searchRequest) {
        return "/" + space + "/" + searchRequest.collections[0] + "/search/" + this.configService.env.currentLang;
    }
    getSearchQueryParams(searchRequest) {
        let q = "";
        if (searchRequest.q) {
            q = searchRequest.q;
        }
        let f = "";
        if (searchRequest.f) {
            for (let key in searchRequest.f) {
                f = f + key + "=" + searchRequest.f[key] + ";";
            }
        }
        let o = "";
        if (searchRequest.o) {
            for (let key in searchRequest.o) {
                o = o + key + "=" + searchRequest.o[key] + ";";
            }
        }
        return {
            q: q,
            f: f,
            o: o
        };
    }
    getUserselections(space) {
        return JSON.parse(localStorage.getItem(space + this.storageToken)) || [];
    }
    storeUserselections(space, userselection) {
        localStorage.setItem(space + this.storageToken, JSON.stringify(userselection));
    }
    saveCart(space, callback) {
        let payload = {
            space: space,
            recreate: true,
            updateExistingDocument: true,
            documents: this.getUserselections(space)
        };
        this.formDataService.saveBulkFormData(space, this.collection, payload).subscribe(res => {
            this.isNew = false;
            if (callback) {
                callback();
            }
        });
    }
    saveCartItem(space, item, callback) {
        this.formDataService.saveFormData(space, this.collection, item).subscribe(res => {
            this.isNew = false;
            if (callback) {
                callback();
            }
        });
    }
    deleteCartItem(space, item, callback) {
        this.formDataService.deleteFormData(space, this.collection, item.id, item.status).subscribe(res => {
            this.isNew = false;
            if (callback) {
                callback();
            }
        });
    }
    cleanupCart(space) {
        let list = this.getUserselections(space);
        let index = list.findIndex(item => item.document?.type === "cart");
        if (index >= 0) {
            list[index].document.searches = [];
            list[index].document.selectionList = [];
            this.formDataService.updateFormData(space, this.collection, list[index], list[index].id, list[index].status).subscribe(res => {
                this.storeUserselections(space, list);
            });
        }
    }
    convertRequest(request) {
        if (request) {
            //TODO
            //conversion into the format needed for the back-end
        }
        return request;
    }
    addToCart(space, collection, id) {
        let list = this.getUserselections(space);
        let items = list?.filter(item => item.document?.type === 'cart');
        if (items.length > 0) {
            if (!items[0].document.selectionList) {
                items[0].document.selectionList = [{
                        collection: collection,
                        documentIds: [id]
                    }];
            }
            else {
                let index = items[0].document.selectionList.findIndex(item => item.collection === collection);
                if (index >= 0) {
                    if (!items[0].document.selectionList[index].documentIds) {
                        items[0].document.selectionList[index].documentIds = [];
                    }
                    items[0].document.selectionList[index].documentIds.push(id);
                }
                else {
                    items[0].document.selectionList.push({
                        collection: collection,
                        documentIds: [id]
                    });
                }
            }
        }
        this.storeUserselections(space, list);
        if (this.configService.isLoggedIn()) {
            this.saveCart(space);
        }
    }
    removeFromCart(space, collection, id) {
        let list = this.getUserselections(space);
        let items = list?.filter(item => item.document?.type === 'cart');
        if (items.length > 0) {
            let index = items[0].document.selectionList?.findIndex(item => item.collection === collection);
            if (index >= 0) {
                let subindex = items[0].document.selectionList[index].documentIds.findIndex(item => item === id);
                if (subindex >= 0) {
                    items[0].document.selectionList[index].documentIds.splice(subindex, 1);
                }
            }
        }
        this.storeUserselections(space, list);
        if (this.configService.isLoggedIn()) {
            this.saveCart(space);
        }
    }
    isInCart(space, collection, id) {
        let list = this.getUserselections(space);
        let items = list?.filter(item => item.document?.type === 'cart');
        if (items.length > 0) {
            let index = items[0].document.selectionList?.findIndex(item => item.collection === collection);
            if (index >= 0) {
                let subindex = items[0].document.selectionList[index].documentIds.findIndex(item => item === id);
                if (subindex >= 0) {
                    return items[0].document.selectionList[index].documentIds.includes(id);
                }
            }
        }
    }
    onSelectionChange(space, collection, id, event) {
        if (event.srcElement.checked) {
            this.addToCart(space, collection, id);
        }
        else {
            this.removeFromCart(space, collection, id);
        }
    }
    selectedAll(space, collection, data) {
        let isSelectedAll = true;
        if (data) {
            for (let i = 0; i < data.length; i++) {
                let element = data[i];
                if (!this.isInCart(space, collection, (element.id || element.metadata.id))) {
                    isSelectedAll = false;
                    break;
                }
            }
            ;
        }
        else {
            isSelectedAll = false;
        }
        return isSelectedAll;
    }
    showCart(space) {
        return this.countCart(space) > 0;
    }
    isChecked(space, collection, id) {
        return this.isInCart(space, collection, id);
    }
    removeSelectionFromList(space, type, collection, i) {
        let list = this.getUserselections(space);
        let index = list.findIndex(item => item.document?.type === type);
        if (index >= 0) {
            let subindex = list[index].document.selectionList.findIndex(item => item.collection === collection);
            if (subindex >= 0) {
                if (!isNaN(i)) {
                    list[index].document.selectionList[subindex].documentIds.splice(i, 1);
                }
                else {
                    list[index].document.selectionList.splice(subindex);
                }
            }
        }
        this.storeUserselections(space, list);
        if (this.configService.isLoggedIn()) {
            this.saveCart(space);
        }
    }
    removeRequestFromList(space, name) {
        let list = this.getUserselections(space);
        let index = list.findIndex(item => item.document?.type === "cart");
        if (index >= 0) {
            let subindex = list[index].document.searches.findIndex(item => item.name === name);
            if (subindex >= 0) {
                list[index].document.searches.splice(subindex, 1);
            }
        }
        this.storeUserselections(space, list);
        if (this.configService.isLoggedIn()) {
            this.saveCart(space);
        }
    }
    randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    static { this.ɵfac = function UserselectionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UserselectionService)(i0.ɵɵinject(i1.ConfigurationService), i0.ɵɵinject(i1.SearchService), i0.ɵɵinject(FormDataService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserselectionService, factory: UserselectionService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserselectionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.ConfigurationService }, { type: i1.SearchService }, { type: FormDataService }], null); })();

const _c0$f = a0 => ({ refPropertiesId: a0 });
const _c1$4 = a0 => [a0];
const _c2 = (a0, a1) => ({ status: a0, lang: a1 });
const _c3 = a0 => ({ status: a0 });
function GroupedResultComponent_table_0_th_3_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function GroupedResultComponent_table_0_th_3_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const column_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onSortChange(column_r2)); });
    i0.ɵɵelement(1, "i", 10);
    i0.ɵɵelementEnd();
} }
function GroupedResultComponent_table_0_th_3_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function GroupedResultComponent_table_0_th_3_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const column_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onSortChange(column_r2)); });
    i0.ɵɵelement(1, "i", 10);
    i0.ɵɵelementEnd();
} }
function GroupedResultComponent_table_0_th_3_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function GroupedResultComponent_table_0_th_3_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const column_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onSortChange(column_r2)); });
    i0.ɵɵelement(1, "i", 12);
    i0.ɵɵelementEnd();
} }
function GroupedResultComponent_table_0_th_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 5)(1, "div", 6)(2, "label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GroupedResultComponent_table_0_th_3_button_4_Template, 2, 0, "button", 7)(5, GroupedResultComponent_table_0_th_3_button_5_Template, 2, 0, "button", 8)(6, GroupedResultComponent_table_0_th_3_button_6_Template, 2, 0, "button", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const column_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.dynamicFormControlService.getProperty(null, ctx_r2.dynamicForm, i0.ɵɵpureFunction1(4, _c0$f, column_r2.refPropertiesId), "shortlabel") || column_r2.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r2.allowSorting && !ctx_r2.getSortCriteria(column_r2.name));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r2.allowSorting && !ctx_r2.getSortCriteria(column_r2.name) && ctx_r2.getSortCriteria(column_r2.name).order === "ASC");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r2.allowSorting && !ctx_r2.getSortCriteria(column_r2.name) && ctx_r2.getSortCriteria(column_r2.name).orders === "DESC");
} }
function GroupedResultComponent_table_0_th_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 13);
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementEnd();
} }
function GroupedResultComponent_table_0_tbody_5_td_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r6 = i0.ɵɵnextContext().$implicit;
    const resource_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r2.getColumnValue(ctx_r2.getValue(resource_r7, column_r6)), i0.ɵɵsanitizeHtml);
} }
function GroupedResultComponent_table_0_tbody_5_td_2_ng_container_2_li_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngClass", i_r8.results[0].values[0].status)("routerLink", i0.ɵɵpureFunction1(4, _c1$4, ctx_r2.getRedirectUrl(i_r8.results[0].values[0], i_r8.results[0].values[0].metadata.id, i_r8.results[0].values[0].status).url))("queryParams", i0.ɵɵpureFunction2(6, _c2, i_r8.results[0].values[0].status, i_r8.key));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i_r8.key);
} }
function GroupedResultComponent_table_0_tbody_5_td_2_ng_container_2_li_2_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngClass", i_r8.results[0].values[0].status)("routerLink", i0.ɵɵpureFunction1(4, _c1$4, ctx_r2.getRedirectUrl(i_r8.results[0].values[0], i_r8.results[0].values[0].metadata.id, i_r8.results[0].values[0].status).url))("queryParams", i0.ɵɵpureFunction1(6, _c3, i_r8.results[0].values[0].status));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i_r8.key);
} }
function GroupedResultComponent_table_0_tbody_5_td_2_ng_container_2_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 23);
    i0.ɵɵtemplate(1, GroupedResultComponent_table_0_tbody_5_td_2_ng_container_2_li_2_a_1_Template, 2, 9, "a", 24)(2, GroupedResultComponent_table_0_tbody_5_td_2_ng_container_2_li_2_a_2_Template, 2, 8, "a", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r8 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.configService.getLanguageByCode(i_r8.key) > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r2.configService.getLanguageByCode(i_r8.key) > ""));
} }
function GroupedResultComponent_table_0_tbody_5_td_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 21);
    i0.ɵɵtemplate(2, GroupedResultComponent_table_0_tbody_5_td_2_ng_container_2_li_2_Template, 3, 2, "li", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r6 = i0.ɵɵnextContext().$implicit;
    const resource_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.getData(resource_r7, column_r6.name));
} }
function GroupedResultComponent_table_0_tbody_5_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 18);
    i0.ɵɵtemplate(1, GroupedResultComponent_table_0_tbody_5_td_2_ng_container_1_Template, 2, 1, "ng-container", 19)(2, GroupedResultComponent_table_0_tbody_5_td_2_ng_container_2_Template, 3, 1, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r6 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", column_r6.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !column_r6.type || column_r6.type === "normal");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r6.type === "aggregation");
} }
function GroupedResultComponent_table_0_tbody_5_td_3_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function GroupedResultComponent_table_0_tbody_5_td_3_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const resource_r7 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onSelectionChange(resource_r7, { srcElement: { checked: false } })); });
    i0.ɵɵelement(1, "i", 27);
    i0.ɵɵelementEnd();
} }
function GroupedResultComponent_table_0_tbody_5_td_3_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function GroupedResultComponent_table_0_tbody_5_td_3_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const resource_r7 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onSelectionChange(resource_r7, { srcElement: { checked: false } })); });
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementEnd();
} }
function GroupedResultComponent_table_0_tbody_5_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 26);
    i0.ɵɵtemplate(1, GroupedResultComponent_table_0_tbody_5_td_3_button_1_Template, 2, 0, "button", 8)(2, GroupedResultComponent_table_0_tbody_5_td_3_button_2_Template, 2, 0, "button", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.userselectionService.isChecked(ctx_r2.space, ctx_r2.collection, resource_r7.id || resource_r7.metadata.id));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.userselectionService.isChecked(ctx_r2.space, ctx_r2.collection, resource_r7.id || resource_r7.metadata.id));
} }
function GroupedResultComponent_table_0_tbody_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody")(1, "tr", 15);
    i0.ɵɵtemplate(2, GroupedResultComponent_table_0_tbody_5_td_2_Template, 3, 3, "td", 16)(3, GroupedResultComponent_table_0_tbody_5_td_3_Template, 3, 2, "td", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.config.grouping.listResult);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.selectionEnabled);
} }
function GroupedResultComponent_table_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 1)(1, "thead")(2, "tr");
    i0.ɵɵtemplate(3, GroupedResultComponent_table_0_th_3_Template, 7, 6, "th", 2)(4, GroupedResultComponent_table_0_th_4_Template, 2, 0, "th", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, GroupedResultComponent_table_0_tbody_5_Template, 4, 2, "tbody", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.config.grouping.listResult);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.selectionEnabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.data);
} }
class GroupedResultComponent {
    constructor(utilsService, configService, activatedRoute, router, dynamicFormControlService, userselectionService, formDataService) {
        this.utilsService = utilsService;
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.dynamicFormControlService = dynamicFormControlService;
        this.userselectionService = userselectionService;
        this.formDataService = formDataService;
        this.selectionEnabled = false;
        this.sortCriteria = [];
    }
    ngOnInit() {
        if (this.router.url.includes('reporting')) {
            this.subpath = 'reporting/';
        }
        else {
            this.subpath = this.space + '/';
        }
        this.activatedRoute.queryParams.subscribe(params => {
            this.queryParams = JSON.parse(JSON.stringify(params));
            if (this.queryParams.sort) {
                this.createSortCriteria();
            }
        });
        this.activatedRoute.params.subscribe(params => {
            this.params = params;
        });
    }
    ngOnDestroy() {
    }
    createSortCriteria() {
        let s = this.queryParams.sort.split(";");
        for (let i = 0; i < s.length; i++) {
            if (s[i] > "") {
                this.sortCriteria.push({
                    name: s[i].split(":")[0],
                    order: s[i].split(":")[1]
                });
            }
        }
    }
    getSortCriteria(name) {
        let index = this.sortCriteria.findIndex(item => item.name === name);
        if (index >= 0) {
            return this.sortCriteria[index];
        }
        else {
            return null;
        }
    }
    onSortChange(column) {
        if (this.getSortCriteria(column.name) && this.getSortCriteria(column.name).order === 'ASC') {
            column.sort = 'DESC';
        }
        else {
            column.sort = 'ASC';
        }
        this.config.listResult.forEach(element => {
            element.sorted = false;
        });
        column.sorted = true;
        let url = this.router.url;
        if (url.includes('?')) {
            url = url.substring(0, url.indexOf('?'));
        }
        this.queryParams.sort = column.name + this.configService.env.sort.paramValueSeparator + column.sort;
        this.router.navigate([url], {
            fragment: 'search',
            queryParams: this.queryParams
        });
    }
    getRedirectUrl(item, id, status) {
        if (this.parent) {
            return this.formDataService.getRedirectUrl(item, id, status, this.status, this.queryParams, new DynamicForm({
                space: this.space,
                name: this.parent
            }), this.collection, this.subpath);
        }
        else {
            return {
                url: "../../" + ((this.params.param && this.params.value) ? "../" : "") + (this.route || this.collection) + "/" + (item.id || item.metadata.id),
                queryParams: {
                    status: item.status
                }
            };
        }
    }
    getData(resource, key) {
        let results = jsonPath.query(resource.results, '$..[?(@.name==\'' + key + '\')]');
        if (results?.length > 0) {
            return results[0].results;
        }
        else {
            return [];
        }
    }
    getValue(obj, column) {
        if (column.name) {
            let values;
            if (column.name.startsWith("document.")) {
                let prop = column.name.replaceAll("%lang%", this.configService.env.currentLang);
                values = jsonPath.query(obj.results, '$..' + prop);
                if (values.length > 0) {
                    if (column.formula) {
                        try {
                            let value = this.dynamicFormControlService.executeFormula(column.formula, {
                                key: values[0]
                            }, this.dynamicForm.acceptedParams, this.dynamicForm.params);
                            return value;
                        }
                        catch (error) {
                            return error.code + ' - ' + error.message;
                        }
                    }
                    else {
                        return values[0];
                    }
                }
                else {
                    return "";
                }
            }
            else {
                values = jsonPath.query(obj.results, '$..[?(@.name==\'' + column.name + '\')]');
                if (values.length > 0) {
                    if (column.formula) {
                        try {
                            let value = this.dynamicFormControlService.executeFormula(column.formula, values[0].results[0], this.dynamicForm.acceptedParams, this.dynamicForm.params);
                            return value;
                        }
                        catch (error) {
                            return error.code + ' - ' + error.message;
                        }
                    }
                    else {
                        return values[0].results[0].key;
                    }
                }
                else {
                    return "";
                }
            }
        }
        else {
            if (column.formula) {
                try {
                    let value = this.dynamicFormControlService.executeFormula(column.formula, obj, this.dynamicForm.acceptedParams, this.dynamicForm.params);
                    return value;
                }
                catch (error) {
                    return error.code + ' - ' + error.message;
                }
            }
            else {
                return obj.key;
            }
        }
    }
    getColumnValue(value) {
        return value?.replace(/\|/gi, " ");
    }
    getArrayString(items, separator) {
        let output = '';
        for (let i = 0; i < items.length; i++) {
            if (output > '') {
                output += separator + items[i];
            }
            else {
                output = items[i];
            }
        }
        return output;
    }
    goToFirst(resource) {
        let url = "/" + (this.route || this.collection) + "/" + this.configService.getAlias(resource.results[0].values[0], this.config) + '/' + this.configService.env.currentLang;
        if (this.configService.getLanguageByCode(resource.results[0].key) > '') {
            this.router.navigate([url]);
        }
        else {
            this.router.navigate([url], { queryParams: { lang: resource.results[0].key } });
        }
    }
    onSelectionChange(item, event) {
        this.userselectionService.onSelectionChange(this.space, this.collection, item, event);
    }
    selectedAll() {
        return this.userselectionService.selectedAll(this.space, this.collection, this.data);
    }
    static { this.ɵfac = function GroupedResultComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GroupedResultComponent)(i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(UserselectionService), i0.ɵɵdirectiveInject(FormDataService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GroupedResultComponent, selectors: [["grouped-result"]], inputs: { selectionEnabled: "selectionEnabled", route: "route", dynamicForm: "dynamicForm", data: "data", space: "space", collection: "collection", config: "config", subpath: "subpath", parent: "parent", status: "status", aliases: "aliases" }, standalone: false, decls: 1, vars: 1, consts: [["class", "table table-hover table-responsive-md table-sm", 4, "ngIf"], [1, "table", "table-hover", "table-responsive-md", "table-sm"], ["scope", "col", "class", "column-header-cell", 4, "ngFor", "ngForOf"], ["class", "userselection", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["scope", "col", 1, "column-header-cell"], [1, "column-header"], ["type", "button", "class", "btn btn-link dark-button", 3, "click", 4, "ngIf"], ["type", "button", "class", "btn btn-link", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-link", "dark-button", 3, "click"], [1, "bi", "bi-sort-alpha-down"], ["type", "button", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-sort-alpha-up"], [1, "userselection"], [1, "bi", "bi-cart"], [1, "table-link-aggregated"], [3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "userselection-buttons", 4, "ngIf"], [3, "ngClass"], [4, "ngIf"], [3, "innerHTML"], [1, "list-inline"], ["class", "list-inline-item", 4, "ngFor", "ngForOf"], [1, "list-inline-item"], ["routerLinkActive", "router-link-active", 3, "ngClass", "routerLink", "queryParams", 4, "ngIf"], ["routerLinkActive", "router-link-active", 3, "ngClass", "routerLink", "queryParams"], [1, "userselection-buttons"], [1, "bi", "bi-dash-lg"], [1, "bi", "bi-plus-lg"]], template: function GroupedResultComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, GroupedResultComponent_table_0_Template, 6, 3, "table", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.config);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i2.RouterLink, i2.RouterLinkActive], styles: [".table-link-standard[_ngcontent-%COMP%]{cursor:pointer}.table-link-standard[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--default-font-color);text-decoration:none}.column-header[_ngcontent-%COMP%]{display:flex;align-items:flex-start}.column-header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{text-wrap:nowrap}.column-header[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:0;margin-left:.5em}.btn.btn-link.dark-button[_ngcontent-%COMP%]{color:var(--default-font-color)}.column-header-cell[_ngcontent-%COMP%]{vertical-align:top}.list-inline[_ngcontent-%COMP%], .list-inline-item[_ngcontent-%COMP%]{margin-bottom:0!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GroupedResultComponent, [{
        type: Component,
        args: [{ selector: 'grouped-result', standalone: false, template: "<table class=\"table table-hover table-responsive-md table-sm\" *ngIf=\"config\">\r\n    <thead>\r\n        <tr>\r\n<!--             <th>\r\n                <div>\r\n                    <input [disabled]=\"!configService.isLoggedIn()\" (change)=\"onSelectionChange(null,$event)\" class=\"form-check-input\" type=\"checkbox\" [checked]=\"selectedAll()\">\r\n                </div>\r\n            </th> -->\r\n            <th *ngFor=\"let column of config.grouping.listResult\" scope=\"col\" class=\"column-header-cell\">\r\n                <div class=\"column-header\">\r\n                    <label>{{ dynamicFormControlService.getProperty(null, dynamicForm,{ refPropertiesId: column.refPropertiesId },\"shortlabel\") || column.name }}</label>\r\n                    <button *ngIf=\"column.allowSorting && !getSortCriteria(column.name)\" type=\"button\" class=\"btn btn-link dark-button\" (click)=\"onSortChange(column)\"><i class=\"bi bi-sort-alpha-down\"></i></button>\r\n                    <button *ngIf=\"column.allowSorting && !getSortCriteria(column.name) && getSortCriteria(column.name).order === 'ASC'\" type=\"button\" class=\"btn btn-link\" (click)=\"onSortChange(column)\"><i class=\"bi bi-sort-alpha-down\"></i></button>\r\n                    <button *ngIf=\"column.allowSorting && !getSortCriteria(column.name) && getSortCriteria(column.name).orders === 'DESC'\" type=\"button\" class=\"btn btn-link\" (click)=\"onSortChange(column)\"><i class=\"bi bi-sort-alpha-up\"></i></button>\r\n                </div>\r\n            </th>\r\n            <th *ngIf=\"selectionEnabled\" class=\"userselection\">\r\n                <i class=\"bi bi-cart\"></i>\r\n            </th>\r\n        </tr>\r\n    </thead>\r\n    <tbody *ngFor=\"let resource of data\">\r\n        <tr class=\"table-link-aggregated\"> <!-- (click)=\"goToFirst(resource)\" -->\r\n<!--             <td>\r\n                <div>\r\n                    <input [disabled]=\"!configService.isLoggedIn()\" (change)=\"onSelectionChange(resource.id || resource.metadata.id, $event)\" class=\"form-check-input\" type=\"checkbox\" [checked]=\"userselectionService.isChecked(space, collection, resource.id || resource.metadata.id)\" id=\"{{resource.id || resource.metadata.id}}\">\r\n                </div>\r\n            </td> -->\r\n            <td *ngFor=\"let column of config.grouping.listResult\" [ngClass]=\"column.cssClass\">\r\n                <ng-container *ngIf=\"(!column.type || column.type === 'normal')\">\r\n                    <span [innerHTML]=\"getColumnValue(getValue(resource,column))\"></span>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"column.type === 'aggregation'\">\r\n                    <ul class=\"list-inline\">\r\n                        <li class=\"list-inline-item\" *ngFor=\"let i of getData(resource,column.name)\">\r\n                            <a *ngIf=\"configService.getLanguageByCode(i.key) > ''\"\r\n                                [ngClass]=\"i.results[0].values[0].status\"\r\n                                [routerLink]=\"[getRedirectUrl(i.results[0].values[0],i.results[0].values[0].metadata.id,i.results[0].values[0].status).url]\"\r\n                                [queryParams]=\"{\r\n                                    status: i.results[0].values[0].status,\r\n                                    lang: i.key\r\n                                }\" routerLinkActive=\"router-link-active\"\r\n                            >{{i.key}}</a>\r\n                            <a *ngIf=\"!(configService.getLanguageByCode(i.key) > '')\"\r\n                                [ngClass]=\"i.results[0].values[0].status\"\r\n                                [routerLink]=\"[getRedirectUrl(i.results[0].values[0],i.results[0].values[0].metadata.id,i.results[0].values[0].status).url]\"\r\n                                [queryParams]=\"{\r\n                                    status: i.results[0].values[0].status\r\n                                }\" routerLinkActive=\"router-link-active\"\r\n                            >{{i.key}}</a>\r\n                        </li>\r\n                    </ul>\r\n                </ng-container>\r\n            </td>\r\n            <td class=\"userselection-buttons\" *ngIf=\"selectionEnabled\">\r\n                <button *ngIf=\"userselectionService.isChecked(space, collection, resource.id || resource.metadata.id)\" type=\"button\" class=\"btn btn-link\" (click)=\"onSelectionChange(resource,{ srcElement: { checked: false } })\"><i class=\"bi bi-dash-lg\"></i></button>\r\n                <button *ngIf=\"!userselectionService.isChecked(space, collection, resource.id || resource.metadata.id)\" type=\"button\" class=\"btn btn-link\" (click)=\"onSelectionChange(resource,{ srcElement: { checked: false } })\"><i class=\"bi bi-plus-lg\"></i></button>                \r\n            </td>\r\n        </tr>\r\n    </tbody>    \r\n</table>", styles: [".table-link-standard{cursor:pointer}.table-link-standard a{color:var(--default-font-color);text-decoration:none}.column-header{display:flex;align-items:flex-start}.column-header label{text-wrap:nowrap}.column-header button{padding:0;margin-left:.5em}.btn.btn-link.dark-button{color:var(--default-font-color)}.column-header-cell{vertical-align:top}.list-inline,.list-inline-item{margin-bottom:0!important}\n"] }]
    }], () => [{ type: i1.UtilsService }, { type: i1.ConfigurationService }, { type: i2.ActivatedRoute }, { type: i2.Router }, { type: i1.DynamicFormControlService }, { type: UserselectionService }, { type: FormDataService }], { selectionEnabled: [{
            type: Input
        }], route: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], data: [{
            type: Input
        }], space: [{
            type: Input
        }], collection: [{
            type: Input
        }], config: [{
            type: Input
        }], subpath: [{
            type: Input
        }], parent: [{
            type: Input
        }], status: [{
            type: Input
        }], aliases: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(GroupedResultComponent, { className: "GroupedResultComponent", filePath: "src/components/grouped-result/grouped-result.component.ts", lineNumber: 18 }); })();

const _c0$e = a0 => ({ refPropertiesId: a0 });
const _c1$3 = a0 => [a0];
function StandardResultComponent_ng_container_0_table_1_tr_2_th_1_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tr_2_th_1_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const column_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.onSortChange(column_r2)); });
    i0.ɵɵelement(1, "i", 12);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tr_2_th_1_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tr_2_th_1_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const column_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.onSortChange(column_r2)); });
    i0.ɵɵelement(1, "i", 12);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tr_2_th_1_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tr_2_th_1_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const column_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.onSortChange(column_r2)); });
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tr_2_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 6)(1, "div", 7)(2, "label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, StandardResultComponent_ng_container_0_table_1_tr_2_th_1_button_4_Template, 2, 0, "button", 8)(5, StandardResultComponent_ng_container_0_table_1_tr_2_th_1_button_5_Template, 2, 0, "button", 9)(6, StandardResultComponent_ng_container_0_table_1_tr_2_th_1_button_6_Template, 2, 0, "button", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const column_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.dynamicFormControlService.getProperty(null, ctx_r2.dynamicForm, i0.ɵɵpureFunction1(4, _c0$e, column_r2.refPropertiesId), "shortlabel") || ctx_r2.dynamicFormControlService.getProperty(null, ctx_r2.dynamicForm, i0.ɵɵpureFunction1(6, _c0$e, column_r2.refPropertiesId), "label") || column_r2.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r2.allowSorting && !ctx_r2.getSortCriteria(column_r2.name));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r2.allowSorting && ctx_r2.getSortCriteria(column_r2.name) && ctx_r2.getSortCriteria(column_r2.name).order === "ASC");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r2.allowSorting && ctx_r2.getSortCriteria(column_r2.name) && ctx_r2.getSortCriteria(column_r2.name).order === "DESC");
} }
function StandardResultComponent_ng_container_0_table_1_tr_2_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 16);
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tr_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, StandardResultComponent_ng_container_0_table_1_tr_2_th_1_Template, 7, 8, "th", 4)(2, StandardResultComponent_ng_container_0_table_1_tr_2_th_2_Template, 2, 0, "th", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.columns);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.collectionForm.formConfig.selectionEnabled);
} }
function StandardResultComponent_ng_container_0_table_1_tr_3_th_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "th", 19);
} }
function StandardResultComponent_ng_container_0_table_1_tr_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th")(2, "label");
    i0.ɵɵtext(3, "Id");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "th")(5, "label");
    i0.ɵɵtext(6, "Status");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, StandardResultComponent_ng_container_0_table_1_tr_3_th_7_Template, 1, 0, "th", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", ctx_r2.collectionForm.formConfig.selectionEnabled);
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 27);
} if (rf & 2) {
    const column_r6 = i0.ɵɵnextContext().$implicit;
    const resource_r7 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("innerHtml", ctx_r2.getValue(resource_r7, column_r6) || "(empty)", i0.ɵɵsanitizeHtml);
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r7 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("ngClass", resource_r7.status);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(resource_r7.status);
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 23)(1, "a", 24);
    i0.ɵɵtemplate(2, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_1_span_2_Template, 1, 1, "span", 25)(3, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_1_span_3_Template, 2, 2, "span", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const column_r6 = ctx.$implicit;
    const resource_r7 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", column_r6.cssClass)("routerLink", i0.ɵɵpureFunction1(6, _c1$3, ctx_r2.getRedirectUrl(resource_r7, resource_r7.metadata == null ? null : resource_r7.metadata.id, resource_r7.status).url))("queryParams", ctx_r2.getRedirectUrl(resource_r7, resource_r7.metadata == null ? null : resource_r7.metadata.id, resource_r7.status).queryParams);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", resource_r7.status);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r6.name !== "status");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r6.name === "status");
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_2_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const resource_r7 = i0.ɵɵnextContext(4).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onSelectionChange(resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id), { srcElement: { checked: false } })); });
    i0.ɵɵelement(1, "i", 31);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_2_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_2_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const resource_r7 = i0.ɵɵnextContext(4).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onSelectionChange(resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id), { srcElement: { checked: true } })); });
    i0.ɵɵelement(1, "i", 32);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtemplate(1, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_2_button_1_Template, 2, 0, "button", 29)(2, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_2_button_2_Template, 2, 0, "button", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r7 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.userselectionService.isChecked(ctx_r2.space, ctx_r2.collection, resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.userselectionService.isChecked(ctx_r2.space, ctx_r2.collection, resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id)));
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 21);
    i0.ɵɵtemplate(1, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_1_Template, 4, 8, "td", 22)(2, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_td_2_Template, 3, 2, "td", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.columns);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.collectionForm.formConfig.selectionEnabled);
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 27);
} if (rf & 2) {
    const column_r11 = i0.ɵɵnextContext().$implicit;
    const resource_r7 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("innerHtml", ctx_r2.getValue(resource_r7, column_r11) || "(empty)", i0.ɵɵsanitizeHtml);
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r7 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("ngClass", resource_r7.status);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(resource_r7.status);
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 34);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_1_Template_td_click_0_listener() { i0.ɵɵrestoreView(_r10); const resource_r7 = i0.ɵɵnextContext(3).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.resultClick(resource_r7)); });
    i0.ɵɵelementStart(1, "a", 24);
    i0.ɵɵtemplate(2, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_1_span_2_Template, 1, 1, "span", 25)(3, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_1_span_3_Template, 2, 2, "span", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const column_r11 = ctx.$implicit;
    const resource_r7 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("ngClass", column_r11.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", resource_r7.status);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r11.name !== "status");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r11.name === "status");
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_2_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const resource_r7 = i0.ɵɵnextContext(4).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onSelectionChange(resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id), { srcElement: { checked: false } })); });
    i0.ɵɵelement(1, "i", 31);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_2_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_2_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r13); const resource_r7 = i0.ɵɵnextContext(4).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onSelectionChange(resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id), { srcElement: { checked: true } })); });
    i0.ɵɵelement(1, "i", 32);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtemplate(1, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_2_button_1_Template, 2, 0, "button", 29)(2, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_2_button_2_Template, 2, 0, "button", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r7 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.userselectionService.isChecked(ctx_r2.space, ctx_r2.collection, resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.userselectionService.isChecked(ctx_r2.space, ctx_r2.collection, resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id)));
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 21);
    i0.ɵɵtemplate(1, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_1_Template, 4, 4, "td", 33)(2, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_td_2_Template, 3, 2, "td", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.columns);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.collectionForm.formConfig.selectionEnabled);
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_1_Template, 3, 2, "tr", 20)(2, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_tr_2_Template, 3, 2, "tr", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.enableClick);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.enableClick);
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_1_td_8_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_1_td_8_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const resource_r7 = i0.ɵɵnextContext(4).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onSelectionChange(resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id), { srcElement: { checked: false } })); });
    i0.ɵɵelement(1, "i", 31);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_1_td_8_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_1_td_8_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r15); const resource_r7 = i0.ɵɵnextContext(4).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onSelectionChange(resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id), { srcElement: { checked: true } })); });
    i0.ɵɵelement(1, "i", 32);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_1_td_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtemplate(1, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_1_td_8_button_1_Template, 2, 0, "button", 29)(2, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_1_td_8_button_2_Template, 2, 0, "button", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r7 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.userselectionService.isChecked(ctx_r2.space, ctx_r2.collection, resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.userselectionService.isChecked(ctx_r2.space, ctx_r2.collection, resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id)));
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 21)(1, "td", 35)(2, "a", 24);
    i0.ɵɵelement(3, "span", 36);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td", 35)(5, "a", 24)(6, "div", 28);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(8, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_1_td_8_Template, 3, 2, "td", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r7 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(10, _c1$3, ctx_r2.getRedirectUrl(resource_r7, resource_r7.metadata == null ? null : resource_r7.metadata.id, resource_r7.status).url))("queryParams", ctx_r2.getRedirectUrl(resource_r7, resource_r7.metadata == null ? null : resource_r7.metadata.id, resource_r7.status).queryParams);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", resource_r7.status);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("innerHTML", resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id) || "(empty)", i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(12, _c1$3, ctx_r2.getRedirectUrl(resource_r7, resource_r7.metadata == null ? null : resource_r7.metadata.id, resource_r7.status).url))("queryParams", ctx_r2.getRedirectUrl(resource_r7, resource_r7.metadata == null ? null : resource_r7.metadata.id, resource_r7.status).queryParams);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", resource_r7.status);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", resource_r7.status);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("[", resource_r7.status, "]");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.collectionForm.formConfig.selectionEnabled);
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_td_8_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_td_8_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r17); const resource_r7 = i0.ɵɵnextContext(4).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onSelectionChange(resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id), { srcElement: { checked: false } })); });
    i0.ɵɵelement(1, "i", 31);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_td_8_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_td_8_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r18); const resource_r7 = i0.ɵɵnextContext(4).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onSelectionChange(resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id), { srcElement: { checked: true } })); });
    i0.ɵɵelement(1, "i", 32);
    i0.ɵɵelementEnd();
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_td_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtemplate(1, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_td_8_button_1_Template, 2, 0, "button", 29)(2, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_td_8_button_2_Template, 2, 0, "button", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r7 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.userselectionService.isChecked(ctx_r2.space, ctx_r2.collection, resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.userselectionService.isChecked(ctx_r2.space, ctx_r2.collection, resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id)));
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 21)(1, "td", 37);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_Template_td_click_1_listener() { i0.ɵɵrestoreView(_r16); const resource_r7 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.resultClick(resource_r7)); });
    i0.ɵɵelementStart(2, "a", 24);
    i0.ɵɵelement(3, "span", 36);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td", 37);
    i0.ɵɵlistener("click", function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_Template_td_click_4_listener() { i0.ɵɵrestoreView(_r16); const resource_r7 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.resultClick(resource_r7)); });
    i0.ɵɵelementStart(5, "a", 24)(6, "div", 28);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(8, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_td_8_Template, 3, 2, "td", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r7 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", resource_r7.status);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("innerHTML", resource_r7.id || (resource_r7.metadata == null ? null : resource_r7.metadata.id) || "(empty)", i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", resource_r7.status);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", resource_r7.status);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("[", resource_r7.status, "]");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.collectionForm.formConfig.selectionEnabled);
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_1_Template, 9, 14, "tr", 20)(2, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_tr_2_Template, 9, 6, "tr", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.enableClick);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.enableClick);
} }
function StandardResultComponent_ng_container_0_table_1_tbody_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody");
    i0.ɵɵtemplate(1, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_1_Template, 3, 2, "ng-container", 0)(2, StandardResultComponent_ng_container_0_table_1_tbody_4_ng_container_2_Template, 3, 2, "ng-container", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.columns && ctx_r2.columns.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.columns || ctx_r2.columns.length === 0);
} }
function StandardResultComponent_ng_container_0_table_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 2)(1, "thead");
    i0.ɵɵtemplate(2, StandardResultComponent_ng_container_0_table_1_tr_2_Template, 3, 2, "tr", 0)(3, StandardResultComponent_ng_container_0_table_1_tr_3_Template, 8, 1, "tr", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, StandardResultComponent_ng_container_0_table_1_tbody_4_Template, 3, 2, "tbody", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.columns && ctx_r2.columns.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.columns || ctx_r2.columns.length === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.data);
} }
function StandardResultComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, StandardResultComponent_ng_container_0_table_1_Template, 5, 3, "table", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.config && ctx_r2.columns);
} }
function StandardResultComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function StandardResultComponent_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "fi-card", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r19 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r2.getCardClass(resource_r19));
    i0.ɵɵadvance();
    i0.ɵɵproperty("space", ctx_r2.space)("collection", ctx_r2.collection)("collectionForm", ctx_r2.collectionForm)("view", ctx_r2.cardType)("textlimit", true)("data", ctx_r2.mapItem(resource_r19));
} }
function StandardResultComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 38);
    i0.ɵɵtemplate(2, StandardResultComponent_ng_container_2_div_2_Template, 2, 7, "div", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.data);
} }
class StandardResultComponent {
    constructor(utilsService, configService, activatedRoute, router, dynamicFormControlService, userselectionService, formDataService) {
        this.utilsService = utilsService;
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.dynamicFormControlService = dynamicFormControlService;
        this.userselectionService = userselectionService;
        this.formDataService = formDataService;
        this.enableClick = false;
        this.onClick = new EventEmitter();
        this.sortCriteria = [];
    }
    ngOnInit() {
        this.url = "/" + this.utilsService.getParentUrl();
        if (this.router.url.includes('reporting')) {
            this.subpath = 'reporting/';
        }
        else {
            this.subpath = this.space + '/';
        }
        this.columns = this.config.listResult.filter(item => item.name.startsWith('document'));
        this.activatedRoute.queryParams.subscribe(params => {
            this.queryParams = JSON.parse(JSON.stringify(params));
            if (this.queryParams.sort) {
                this.createSortCriteria();
            }
        });
    }
    ngOnDestroy() {
    }
    mapItem(item) {
        let mappedItem = {};
        for (let key in this.collectionForm?.formConfig.aliases) {
            let prop = this.utilsService.getPropertyId(item, this.collectionForm?.formConfig.aliases[key]);
            if (!prop) {
                prop = item.document[key];
            }
            mappedItem[key] = prop;
        }
        for (let key in CardsComponent.itemParams) {
            if (!mappedItem[key]) {
                let prop = this.utilsService.getPropertyId(item, "document." + CardsComponent.itemParams[key]);
                if (!prop) {
                    prop = item.document[key];
                }
            }
        }
        mappedItem.id = item.id;
        return mappedItem;
    }
    createSortCriteria() {
        let s = this.queryParams.sort.split(";");
        for (let i = 0; i < s.length; i++) {
            if (s[i] > "") {
                this.sortCriteria.push({
                    name: s[i].split(":")[0],
                    order: s[i].split(":")[1]
                });
            }
        }
    }
    getSortCriteria(name) {
        let index = this.sortCriteria.findIndex(item => item.name === name);
        if (index >= 0) {
            return this.sortCriteria[index];
        }
        else {
            return null;
        }
    }
    getCardClass(resource) {
        if (this.cardType === this.configService.cardTypes.CARDHORIZONTAL
            || this.cardType === this.configService.cardTypes.CARDHORIZONTALCAPTION
            || this.cardType === this.configService.cardTypes.CARDMEETING
            || this.cardType === this.configService.cardTypes.CARDPUBLICATIONHORIZONTAL
            || this.cardType === this.configService.cardTypes.CARDNEWSHORIZONTAL
            || this.cardType === this.configService.cardTypes.CARDPHOTOHORIZONTAL
            || this.cardType === this.configService.cardTypes.CARDVIDEOHORIZONTAL
            || this.cardType === this.configService.cardTypes.HERO
            || this.cardType === this.configService.cardTypes.CARDFULL) {
            return 'col-md-12';
        }
        else if (this.cardType === this.configService.cardTypes.CARDOVERLAY) {
            return 'col-md-6';
        }
        else {
            return 'col-md-4';
        }
    }
    onSortChange(column) {
        if (this.getSortCriteria(column.name) && this.getSortCriteria(column.name).order === 'ASC') {
            column.sort = 'DESC';
        }
        else {
            column.sort = 'ASC';
        }
        this.columns.forEach(element => {
            element.sorted = false;
        });
        column.sorted = true;
        let url = this.router.url;
        if (url.includes('?')) {
            url = url.substring(0, url.indexOf('?'));
        }
        this.queryParams.sort = column.name + this.configService.env.sort.paramValueSeparator + column.sort;
        this.router.navigate([url], {
            fragment: 'search',
            queryParams: this.queryParams
        });
    }
    getValue(obj, column) {
        if (column.formula) {
            try {
                let value = this.dynamicFormControlService.executeFormula(column.formula, obj, this.dynamicForm.acceptedParams, this.dynamicForm.params);
                return value;
            }
            catch (error) {
                return error.code + ' - ' + error.message;
            }
        }
        else {
            let field = (this.aliases ? ListDirective.manageField(this.configService.env.advancedSearch.termConcatenator, (this.aliases[column.name] || column.name), this.configService.env.currentLang) : column.name);
            let data = jsonPath.query(obj, '$.' + field);
            if (data.length > 0) {
                //Multiple property means that the jsonpath result of the search of the material (short name) field could be an array of values, this implies to transform the array in a comma separated string
                if (column.multipleProperty) {
                    let items = data[0].map(item => item[column.multipleProperty]);
                    return this.getArrayString(items, ', ');
                }
                else {
                    /* TODO: If a field has a reference to a standard option, extract label */
                    return data[0];
                }
            }
            else {
                if (column.alternativeText) {
                    return column.alternativeText[this.configService.env.currentLang] || column.alternativeText[this.configService.env.defaultLang];
                }
                return '';
            }
        }
    }
    getArrayString(items, separator) {
        let output = '';
        for (let i = 0; i < items.length; i++) {
            if (output > '') {
                output += separator + items[i];
            }
            else {
                output = items[i];
            }
        }
        return output;
    }
    goToFirst(resource) {
        let url;
        url = '../../';
        if (this.configService.getLanguageByCode(resource.results[0].key) > '') {
            this.router.navigate([url + this.configService.getAlias(resource.results[0].values[0], this.config)]);
        }
        else {
            this.router.navigate([url + this.configService.getAlias(resource.results[0].values[0], this.config)], { queryParams: { lang: resource.results[0].key } });
        }
    }
    onSelectionChange(id, event) {
        this.userselectionService.onSelectionChange(this.space, this.collection, id, event);
    }
    selectedAll() {
        return this.userselectionService.selectedAll(this.space, this.collection, this.data);
    }
    getRedirectUrl(item, id, status) {
        if (this.parent) {
            return this.formDataService.getRedirectUrl(item, id, status, this.status, this.queryParams, new DynamicForm({
                space: this.space,
                name: this.parent
            }), this.collection, this.url);
        }
        else {
            let url;
            if (this.collectionForm?.formConfig.route) {
                url = "/" + this.collectionForm?.formConfig.route;
            }
            else {
                url = this.url;
            }
            if (url.endsWith('search')) {
                url = url.replace('/search', '');
            }
            url = url + "/" + (item.id || item.metadata?.id) + "/" + this.configService.env.currentLang;
            return {
                url: url,
                queryParams: {
                    status: item.status
                }
            };
        }
    }
    resultClick(event) {
        this.onClick.emit(event);
    }
    static { this.ɵfac = function StandardResultComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StandardResultComponent)(i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(UserselectionService), i0.ɵɵdirectiveInject(FormDataService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StandardResultComponent, selectors: [["standard-result"]], inputs: { space: "space", collection: "collection", collectionForm: "collectionForm", dynamicForm: "dynamicForm", data: "data", config: "config", subpath: "subpath", parent: "parent", status: "status", aliases: "aliases", view: "view", cardType: "cardType", enableClick: "enableClick" }, outputs: { onClick: "onClick" }, standalone: false, decls: 3, vars: 3, consts: [[4, "ngIf"], ["class", "table table-hover table-responsive-md table-sm", 4, "ngIf"], [1, "table", "table-hover", "table-responsive-md", "table-sm"], [4, "ngFor", "ngForOf"], ["scope", "col", "class", "column-header-cell", 4, "ngFor", "ngForOf"], ["class", "userselection", 4, "ngIf"], ["scope", "col", 1, "column-header-cell"], [1, "column-header"], ["id", "no-sort", "type", "button", "class", "btn btn-link dark-button", 3, "click", 4, "ngIf"], ["id", "sort-asc", "type", "button", "class", "btn btn-link", 3, "click", 4, "ngIf"], ["id", "sort-desc", "type", "button", "class", "btn btn-link", 3, "click", 4, "ngIf"], ["id", "no-sort", "type", "button", 1, "btn", "btn-link", "dark-button", 3, "click"], [1, "bi", "bi-sort-alpha-down"], ["id", "sort-asc", "type", "button", 1, "btn", "btn-link", 3, "click"], ["id", "sort-desc", "type", "button", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-sort-alpha-up"], [1, "userselection"], [1, "bi", "bi-cart"], ["class", "userselection-buttons", 4, "ngIf"], [1, "userselection-buttons"], ["class", "table-link-standard", 4, "ngIf"], [1, "table-link-standard"], [3, "ngClass", "routerLink", "queryParams", 4, "ngFor", "ngForOf"], [3, "ngClass", "routerLink", "queryParams"], [3, "ngClass"], [3, "innerHtml", 4, "ngIf"], ["class", "status", 3, "ngClass", 4, "ngIf"], [3, "innerHtml"], [1, "status", 3, "ngClass"], ["type", "button", "class", "btn btn-link", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-dash-lg"], [1, "bi", "bi-plus-lg"], [3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "click", "ngClass"], [3, "routerLink", "queryParams"], [3, "innerHTML"], [3, "click"], [1, "row", "cards-view"], [3, "ngClass", 4, "ngFor", "ngForOf"], [3, "space", "collection", "collectionForm", "view", "textlimit", "data"]], template: function StandardResultComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, StandardResultComponent_ng_container_0_Template, 2, 1, "ng-container", 0)(1, StandardResultComponent_ng_container_1_Template, 1, 0, "ng-container", 0)(2, StandardResultComponent_ng_container_2_Template, 3, 1, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.view === "table");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.view === "grid");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.view === "list");
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i2.RouterLink, CardComponent], styles: [".userselection[_ngcontent-%COMP%]{color:var(--primary-color);vertical-align:top;text-align:center;font-size:1.3em}.userselection-buttons[_ngcontent-%COMP%]{text-align:center}.userselection-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:0!important}.table-link-standard[_ngcontent-%COMP%]{cursor:pointer}.table-link-standard[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--default-font-color);text-decoration:none}.column-header[_ngcontent-%COMP%]{display:flex;align-items:flex-start}.column-header[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{text-wrap:nowrap}.column-header[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:0;margin-left:.5em}.btn.btn-link.dark-button[_ngcontent-%COMP%]{color:var(--default-font-color)}.column-header-cell[_ngcontent-%COMP%]{vertical-align:top}.list-inline[_ngcontent-%COMP%], .list-inline-item[_ngcontent-%COMP%]{margin-bottom:0!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StandardResultComponent, [{
        type: Component,
        args: [{ selector: 'standard-result', standalone: false, template: "<ng-container *ngIf=\"view === 'table'\">\r\n    <table class=\"table table-hover table-responsive-md table-sm\" *ngIf=\"config && columns\">\r\n        <thead>\r\n            <tr *ngIf=\"columns && columns.length > 0\">\r\n                <th *ngFor=\"let column of columns\" scope=\"col\" class=\"column-header-cell\">\r\n                    <div class=\"column-header\">\r\n                        <label>{{ dynamicFormControlService.getProperty(null, dynamicForm,{ refPropertiesId: column.refPropertiesId },\"shortlabel\") || dynamicFormControlService.getProperty(null, dynamicForm,{ refPropertiesId: column.refPropertiesId },\"label\") || column.name }}</label>\r\n                        <button id=\"no-sort\" *ngIf=\"column.allowSorting && !getSortCriteria(column.name)\" type=\"button\" class=\"btn btn-link dark-button\" (click)=\"onSortChange(column)\"><i class=\"bi bi-sort-alpha-down\"></i></button>\r\n                        <button id=\"sort-asc\" *ngIf=\"column.allowSorting && getSortCriteria(column.name) && getSortCriteria(column.name).order === 'ASC'\" type=\"button\" class=\"btn btn-link\" (click)=\"onSortChange(column)\"><i class=\"bi bi-sort-alpha-down\"></i></button>\r\n                        <button id=\"sort-desc\" *ngIf=\"column.allowSorting && getSortCriteria(column.name) && getSortCriteria(column.name).order === 'DESC'\" type=\"button\" class=\"btn btn-link\" (click)=\"onSortChange(column)\"><i class=\"bi bi-sort-alpha-up\"></i></button>\r\n                    </div>\r\n                </th>\r\n                <th *ngIf=\"collectionForm.formConfig.selectionEnabled\" class=\"userselection\">\r\n                    <i class=\"bi bi-cart\"></i>\r\n                </th>\r\n            </tr>   \r\n            <tr *ngIf=\"!columns || columns.length === 0\">\r\n                <th><label>Id</label></th>\r\n                <th><label>Status</label></th>\r\n                <th class=\"userselection-buttons\" *ngIf=\"collectionForm.formConfig.selectionEnabled\"></th>\r\n            </tr>     \r\n        </thead>\r\n        <tbody *ngFor=\"let resource of data\">\r\n    \r\n            <ng-container *ngIf=\"columns && columns.length > 0\">\r\n                <tr class=\"table-link-standard\" *ngIf=\"!enableClick\">\r\n                    <td *ngFor=\"let column of columns\" [ngClass]=\"column.cssClass\" [routerLink]=\"[getRedirectUrl(resource,resource.metadata?.id,resource.status).url]\" [queryParams]=\"getRedirectUrl(resource,resource.metadata?.id,resource.status).queryParams\">\r\n                        <a [ngClass]=\"resource.status\">                \r\n                            <span *ngIf=\"column.name !== 'status'\" innerHtml=\"{{ getValue(resource,column) || '(empty)' }}\"></span>\r\n                            <span *ngIf=\"column.name === 'status'\" class=\"status\" [ngClass]=\"resource.status\">{{resource.status}}</span>\r\n                        </a>\r\n                    </td>\r\n                    <td class=\"userselection-buttons\" *ngIf=\"collectionForm.formConfig.selectionEnabled\">\r\n                        <button *ngIf=\"userselectionService.isChecked(space, collection, resource.id || resource.metadata?.id)\" type=\"button\" class=\"btn btn-link\" (click)=\"onSelectionChange(resource.id || resource.metadata?.id,{ srcElement: { checked: false } })\"><i class=\"bi bi-dash-lg\"></i></button>\r\n                        <button *ngIf=\"!userselectionService.isChecked(space, collection, resource.id || resource.metadata?.id)\" type=\"button\" class=\"btn btn-link\" (click)=\"onSelectionChange(resource.id || resource.metadata?.id,{ srcElement: { checked: true } })\"><i class=\"bi bi-plus-lg\"></i></button>                \r\n                    </td>\r\n                </tr>\r\n\r\n                <tr class=\"table-link-standard\" *ngIf=\"enableClick\">\r\n                    <td *ngFor=\"let column of columns\" [ngClass]=\"column.cssClass\" (click)=\"resultClick(resource)\">\r\n                        <a [ngClass]=\"resource.status\">\r\n                            <span *ngIf=\"column.name !== 'status'\" innerHtml=\"{{ getValue(resource,column) || '(empty)' }}\"></span>\r\n                            <span *ngIf=\"column.name === 'status'\" class=\"status\" [ngClass]=\"resource.status\">{{resource.status}}</span>\r\n                        </a>\r\n                    </td>\r\n                    <td class=\"userselection-buttons\" *ngIf=\"collectionForm.formConfig.selectionEnabled\">\r\n                        <button *ngIf=\"userselectionService.isChecked(space, collection, resource.id || resource.metadata?.id)\" type=\"button\" class=\"btn btn-link\" (click)=\"onSelectionChange(resource.id || resource.metadata?.id,{ srcElement: { checked: false } })\"><i class=\"bi bi-dash-lg\"></i></button>\r\n                        <button *ngIf=\"!userselectionService.isChecked(space, collection, resource.id || resource.metadata?.id)\" type=\"button\" class=\"btn btn-link\" (click)=\"onSelectionChange(resource.id || resource.metadata?.id,{ srcElement: { checked: true } })\"><i class=\"bi bi-plus-lg\"></i></button>                \r\n                    </td>\r\n                </tr>\r\n            </ng-container>\r\n    \r\n            <!-- No list result columns config is provided -->\r\n            <ng-container *ngIf=\"!columns || columns.length === 0\">\r\n                <tr class=\"table-link-standard\" *ngIf=\"!enableClick\">\r\n                    <td [routerLink]=\"[getRedirectUrl(resource,resource.metadata?.id,resource.status).url]\" [queryParams]=\"getRedirectUrl(resource,resource.metadata?.id,resource.status).queryParams\">\r\n                        <a [ngClass]=\"resource.status\">\r\n                            <span innerHTML=\"{{ resource.id || resource.metadata?.id || '(empty)' }}\"></span>\r\n                        </a>\r\n                    </td>\r\n                    <td [routerLink]=\"[getRedirectUrl(resource,resource.metadata?.id,resource.status).url]\" [queryParams]=\"getRedirectUrl(resource,resource.metadata?.id,resource.status).queryParams\">\r\n                        <a [ngClass]=\"resource.status\">\r\n                            <div class=\"status\" [ngClass]=\"resource.status\">[{{resource.status}}]</div>\r\n                        </a>\r\n                    </td>\r\n                    <td class=\"userselection-buttons\" *ngIf=\"collectionForm.formConfig.selectionEnabled\">\r\n                        <button *ngIf=\"userselectionService.isChecked(space, collection, resource.id || resource.metadata?.id)\" type=\"button\" class=\"btn btn-link\" (click)=\"onSelectionChange(resource.id || resource.metadata?.id,{ srcElement: { checked: false } })\"><i class=\"bi bi-dash-lg\"></i></button>\r\n                        <button *ngIf=\"!userselectionService.isChecked(space, collection, resource.id || resource.metadata?.id)\" type=\"button\" class=\"btn btn-link\" (click)=\"onSelectionChange(resource.id || resource.metadata?.id,{ srcElement: { checked: true } })\"><i class=\"bi bi-plus-lg\"></i></button>                \r\n                    </td>\r\n                </tr>\r\n\r\n                <tr class=\"table-link-standard\" *ngIf=\"enableClick\">\r\n                    <td (click)=\"resultClick(resource)\">\r\n                        <a [ngClass]=\"resource.status\">\r\n                            <span innerHTML=\"{{ resource.id || resource.metadata?.id || '(empty)' }}\"></span>\r\n                        </a>\r\n                    </td>\r\n                    <td (click)=\"resultClick(resource)\">\r\n                        <a [ngClass]=\"resource.status\">\r\n                            <div class=\"status\" [ngClass]=\"resource.status\">[{{resource.status}}]</div>\r\n                        </a>\r\n                    </td>\r\n                    <td class=\"userselection-buttons\" *ngIf=\"collectionForm.formConfig.selectionEnabled\">\r\n                        <button *ngIf=\"userselectionService.isChecked(space, collection, resource.id || resource.metadata?.id)\" type=\"button\" class=\"btn btn-link\" (click)=\"onSelectionChange(resource.id || resource.metadata?.id,{ srcElement: { checked: false } })\"><i class=\"bi bi-dash-lg\"></i></button>\r\n                        <button *ngIf=\"!userselectionService.isChecked(space, collection, resource.id || resource.metadata?.id)\" type=\"button\" class=\"btn btn-link\" (click)=\"onSelectionChange(resource.id || resource.metadata?.id,{ srcElement: { checked: true } })\"><i class=\"bi bi-plus-lg\"></i></button>                \r\n                    </td>\r\n                </tr>\r\n            </ng-container>\r\n        </tbody>\r\n    </table>\r\n</ng-container>\r\n<ng-container *ngIf=\"view === 'grid'\">\r\n\r\n</ng-container>\r\n<ng-container *ngIf=\"view === 'list'\">\r\n    <div class=\"row cards-view\">\r\n        <div [ngClass]=\"getCardClass(resource)\" *ngFor=\"let resource of data\">\r\n            <fi-card [space]=\"space\" [collection]=\"collection\" [collectionForm]=\"collectionForm\" [view]=\"cardType\" [textlimit]=\"true\" [data]=\"mapItem(resource)\"></fi-card>\r\n        </div>\r\n    </div>\r\n</ng-container>", styles: [".userselection{color:var(--primary-color);vertical-align:top;text-align:center;font-size:1.3em}.userselection-buttons{text-align:center}.userselection-buttons button{padding:0!important}.table-link-standard{cursor:pointer}.table-link-standard a{color:var(--default-font-color);text-decoration:none}.column-header{display:flex;align-items:flex-start}.column-header label{text-wrap:nowrap}.column-header button{padding:0;margin-left:.5em}.btn.btn-link.dark-button{color:var(--default-font-color)}.column-header-cell{vertical-align:top}.list-inline,.list-inline-item{margin-bottom:0!important}\n"] }]
    }], () => [{ type: i1.UtilsService }, { type: i1.ConfigurationService }, { type: i2.ActivatedRoute }, { type: i2.Router }, { type: i1.DynamicFormControlService }, { type: UserselectionService }, { type: FormDataService }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], collectionForm: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], data: [{
            type: Input
        }], config: [{
            type: Input
        }], subpath: [{
            type: Input
        }], parent: [{
            type: Input
        }], status: [{
            type: Input
        }], aliases: [{
            type: Input
        }], view: [{
            type: Input
        }], cardType: [{
            type: Input
        }], enableClick: [{
            type: Input
        }], onClick: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(StandardResultComponent, { className: "StandardResultComponent", filePath: "src/components/result/result.component.ts", lineNumber: 21 }); })();

class ListDirective {
    constructor(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService) {
        this.searchService = searchService;
        this.router = router;
        this.route = route;
        this.utilsService = utilsService;
        this.configService = configService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.elementRef = elementRef;
        this.collectionService = collectionService;
        this.confirmationService = confirmationService;
        this.userselectionService = userselectionService;
        this.workspaceService = workspaceService;
        this.templateService = templateService;
        this.propertiesService = propertiesService;
        this.listConfigService = listConfigService;
        this.loading = false;
        this.pageReady = false;
        this.isEditMode = false;
        this.adminMode = false;
        this.subpath = '';
        this.maxSize = 12;
        this.pagination = true;
        this.itemsPerPage = 30;
        this.review = false;
        this.requestAccess = false;
        this.accessRequested = false;
    }
    ngOnDestroy() {
    }
    init(refresh = true, inputs) {
        if (this.router.url.includes('reporting')) {
            this.subpath = 'reporting/';
            this.isEditMode = true;
        }
        else {
            this.subpath = '';
            this.isEditMode = false;
        }
        this.route.params.subscribe(params => {
            this.params = params;
            if (this.params.space && !this.space) {
                this.space = this.params.space;
            }
            if (this.params.collection && !this.name) {
                this.name = this.params.collection;
            }
            this.route.queryParams.subscribe(params => {
                this.review = JSON.parse(params.review || "false");
                this.status = params.status;
                this.currentView = params.view;
                if (params.lang) {
                    this.lang = params.lang;
                }
                this.queryParams = JSON.parse(JSON.stringify(params));
                if (inputs) {
                    for (let key in inputs) {
                        if (!this.queryParams[key]) {
                            this.queryParams[key] = inputs[key];
                        }
                    }
                }
                this.searchRequest = ListDirective.parsePageRequest(this.configService.env.advancedSearch, this.queryParams, this.params);
                if (this.isEditMode) {
                    this.getReferences(() => {
                        this.extractCollectionInfo(inputs, refresh);
                    });
                }
                else {
                    this.extractCollectionInfo(inputs, refresh);
                }
            });
        });
    }
    getReferences(callback) {
        if (!this.configService.references[this.space]) {
            this.collectionService.getCollections(this.space, null, "reference").subscribe(res => {
                this.configService.references[this.space] = res;
                let requests = [];
                if (this.configService.references[this.space].length > 0) {
                    //--------------------------------------------------------------
                    // For each reference, extraction of the corresponding workflow
                    //--------------------------------------------------------------
                    for (let i = 0; i < this.configService.references[this.space].length; i++) {
                        requests.push(this.workspaceService.getWorkflow(this.space, this.configService.references[this.space][i].workflowId));
                    }
                    forkJoin([requests]).subscribe((results) => {
                        //Storage of the references
                        for (let i = 0; i < this.configService.references[this.space].length; i++) {
                            this.configService.references[this.space][i].workflow = results[i];
                        }
                        callback();
                    }, (err) => {
                        this.loading = false;
                        this.searchService.manageError(err, 'Error reading references workflows for ' + this.space);
                    });
                    //--------------------------------------------------------------
                }
                else {
                    callback();
                }
            }, (err) => {
                this.loading = false;
                this.searchService.manageError(err, 'Error reading references list for ' + this.space);
            });
        }
        else {
            callback();
        }
    }
    extractCollectionInfo(inputs, refresh) {
        if (!this.collectionForm) {
            this.loading = true;
            this.getCollectionInfo(() => {
                this.getStatuses(() => {
                    this.getProperties(() => {
                        this.getListPageConfig(() => {
                            this.getListPageTemplate(() => {
                                this.loadData(inputs, refresh);
                            });
                        });
                    });
                });
            });
        }
        else {
            this.getStatuses(() => {
                this.loadData(inputs, refresh);
            });
        }
    }
    getCollectionInfo(callback) {
        forkJoin([
            this.collectionService.getCollection(this.space, this.name),
            this.collectionService.getCollectionConfig(this.space, this.name)
        ]).subscribe((results) => {
            results[0].form = this.configService.enrichGlobalParams(this.space, results[0].roleType, results[0].form, 'edit');
            if (results[1].selectionEnabled && !this.configService.isLoggedIn()) {
                results[1].selectionEnabled = false;
            }
            this.collectionForm = results[0];
            this.collectionForm.formConfig = ListDirective.initFormConfig(results[1]);
            if (this.collectionForm.formConfig.defaultListPageSearchCondition) {
                this.defaultSearchParameters = [this.collectionForm.formConfig.defaultListPageSearchCondition];
            }
            if (this.setIndexingData === undefined || this.setIndexingData === true) {
                this.utilsService.setIndexingData(this.collectionForm?.formConfig?.name, this.collectionForm.collection, this.name);
            }
            callback();
        }, (err) => {
            this.loading = false;
            if ((err.status === 403 || err.status === 500) && err.error.toLowerCase().includes("user settings not found")) {
                this.loading = true;
                this.searchService.get(this.configService.env.servicesUrl + '/workspace/space/' + this.space + '/user-settings/request-access?userId=' + this.configService.getUser().id + '&collection=' + this.name).subscribe(res => {
                    this.requestAccess = true;
                    this.accessRequested = res;
                    this.loading = false;
                }, err => {
                    this.loading = false;
                    this.requestAccess = true;
                    this.searchService.manageError(err, 'Error extracting access detail to ' + this.name + ' for user ' + this.configService.getUser().email);
                });
            }
            else {
                this.searchService.manageError(err, 'Error reading collection for ' + this.name);
            }
        });
    }
    requestCollectionAccess() {
        this.searchService.post(this.configService.env.servicesUrl + '/workspace/space/' + this.space + '/user-settings/request-access', {
            "id": this.configService.getUser().id,
            "email": this.configService.getUser().email,
            "collections": [
                this.name
            ]
        }).subscribe(res => {
            this.accessRequested = true;
        }, err => {
            this.loading = false;
            this.searchService.manageError(err, 'Error requesting access to ' + this.name + ' for user ' + this.configService.getUser().email);
        });
    }
    getProperties(callback) {
        this.propertiesService.getGlobalProperties(this.space, this.configService.env.currentLang).subscribe(globalProps => {
            this.propertiesService.getCollectionProperties(this.space, this.name, this.configService.env.currentLang).subscribe(collectionProps => {
                if (this.collectionForm?.form) {
                    this.collectionForm.form.properties = this.propertiesService.merge(globalProps, collectionProps);
                    this.configService.enrichProperties(this.collectionForm?.form.properties);
                }
                callback();
            });
        }, error => {
            this.propertiesService.getCollectionProperties(this.space, this.name, this.configService.env.currentLang).subscribe(collectionProps => {
                if (this.collectionForm?.form) {
                    this.collectionForm.form.properties = collectionProps;
                    this.configService.enrichProperties(this.collectionForm?.form.properties);
                }
                callback();
            });
        });
    }
    getStatuses(callback) {
        if (this.configService.getUser()) {
            this.workspaceService.getWorkflow(this.space, this.collectionForm.workflowId || 'default').subscribe(res => {
                this.statuses = res.statuses;
                if (this.collectionForm?.formConfig.virtualCollection) {
                    this.collectionService.getCollection(this.collectionForm?.formConfig.dataSpace, this.collectionForm?.formConfig.dataCollections.toString()).subscribe(res => {
                        this.workspaceService.getWorkflow(this.collectionForm?.formConfig.dataSpace, res.workflowId || 'default').subscribe(res => {
                            this.virtualCollectionStatuses = res.statuses.defaultSearchStatus;
                            callback();
                        }, err => {
                            this.loading = false;
                            this.searchService.manageError(err, 'Error reading workflow');
                        });
                    });
                }
                else {
                    callback();
                }
            }, err => {
                this.loading = false;
                this.searchService.manageError(err, 'Error reading workflow');
            });
        }
        else {
            this.statuses = { status: [] };
            if (this.collectionForm?.formConfig.virtualCollection) {
                this.collectionService.getCollection(this.collectionForm?.formConfig.dataSpace, this.collectionForm?.formConfig.dataCollections.toString()).subscribe(res => {
                    this.workspaceService.getWorkflow(this.collectionForm?.formConfig.dataSpace, res.workflowId || 'default').subscribe(res => {
                        this.virtualCollectionStatuses = res.statuses.defaultSearchStatus;
                        callback();
                    }, err => {
                        this.loading = false;
                        this.searchService.manageError(err, 'Error reading workflow');
                    });
                });
            }
            else {
                callback();
            }
            callback();
        }
    }
    checkFormConfig() {
        if (!this.collectionForm?.formConfig) {
            this.collectionForm.formConfig = {};
        }
        if (!this.collectionForm?.formConfig.aliases) {
            this.collectionForm.formConfig.aliases = {};
        }
        if (!this.collectionForm?.formConfig.resultsPageConfig && this.collectionForm?.formConfig.resultPages?.length > 0) {
            this.collectionForm.formConfig.resultsPageConfig = this.collectionForm?.formConfig.resultPages[0];
        }
        if (!this.collectionForm?.formConfig.editResultsPageConfig && this.collectionForm?.formConfig.resultPages?.length > 0) {
            this.collectionForm.formConfig.editResultsPageConfig = this.collectionForm?.formConfig.resultPages[0];
        }
    }
    static enrichFilters(configService, viewConfig) {
        for (let j = 0; j < viewConfig.fields?.length; j++) {
            if (viewConfig.fields[j].includes("%lang%")) {
                viewConfig.fields[j] = viewConfig.fields[j].replace("%lang%", configService.env.currentLang);
            }
        }
        for (let j = 0; j < viewConfig.listResult?.length; j++) {
            if (viewConfig.listResult[j].name.includes("%lang%")) {
                viewConfig.listResult[j].name = viewConfig.listResult[j].name.replace("%lang%", configService.env.currentLang);
            }
        }
        for (let j = 0; j < viewConfig.sort?.length; j++) {
            if (viewConfig.sort[j].name.includes("%lang%")) {
                viewConfig.sort[j].name = viewConfig.sort[j].name.replace("%lang%", configService.env.currentLang);
            }
        }
        for (let i = 0; i < viewConfig.filters?.length; i++) {
            for (let j = 0; j < viewConfig.filters[i].paths?.length; j++) {
                if (viewConfig.filters[i].paths[j].includes("%lang%")) {
                    viewConfig.filters[i].paths[j] = viewConfig.filters[i].paths[j].replace("%lang%", configService.env.currentLang);
                }
            }
            let index;
            index = viewConfig.facets?.findIndex(item => item.name === viewConfig.filters[i].name);
            if (index >= 0) {
                //This means that this filter is used also as facet
                viewConfig.facets[index] = Object.assign({}, viewConfig.filters[i], viewConfig.facets[index]);
            }
            index = viewConfig.advancedSearch?.findIndex(item => item.name === viewConfig.filters[i].name);
            if (index >= 0) {
                //This means that this filter is used also as advanced search
                viewConfig.advancedSearch[index] = Object.assign({}, viewConfig.filters[i], viewConfig.advancedSearch[index]);
            }
            index = viewConfig.geoSearch?.findIndex(item => item.name === viewConfig.filters[i].name);
            if (index >= 0) {
                //This means that this filter is used also as geospatial search
                viewConfig.geoSearch[index] = Object.assign({}, viewConfig.filters[i], viewConfig.geoSearch[index]);
            }
        }
    }
    getListPageConfig(callback) {
        let config = this.isEditMode ? this.collectionForm?.formConfig.editResultsPageConfig : (this.listConfig || this.collectionForm?.formConfig.resultsPageConfig);
        if (!config && this.collectionForm?.formConfig.resultsPages?.length > 0) {
            config = this.collectionForm?.formConfig.resultsPages[0];
        }
        if (config) {
            this.listConfigService.getListconfigById(this.space, this.name, config).subscribe(res => {
                this.collectionForm.formConfig.viewConfig = res;
                ListDirective.enrichFilters(this.configService, this.collectionForm?.formConfig.viewConfig);
                callback();
            }, err => {
                this.searchService.manageError(err, 'Error extracting list page configuration ' + config);
            });
        }
        else {
            this.collectionForm.formConfig.viewConfig = {};
            callback();
        }
    }
    getListPageTemplate(callback) {
        if (!this.isEditMode && (this.listTemplate || this.collectionForm?.formConfig.listPageTemplate)) {
            this.templateService.getTemplateByIdCompressed(this.space, this.name, 'list', this.listTemplate || this.collectionForm?.formConfig.listPageTemplate).subscribe(res => {
                if (res) {
                    this.template = res;
                }
                callback();
            }, err => {
                this.searchService.manageError(err, 'Error extracting list template ' + this.collectionForm?.formConfig.listTemplate);
            });
        }
        else {
            callback();
        }
    }
    loadData(inputs, refresh) {
        this.initSettings();
        this.checkFormConfig();
        this.processAdditionalAttributes(inputs);
        this.initOptions();
        if (this.collectionForm?.formConfig.selectionEnabled) {
            this.userselectionService.initCart(this.space, "cart", () => {
                if (refresh) {
                    this.refresh();
                }
                else {
                    this.pageReady = true;
                }
            });
        }
        else {
            if (refresh) {
                this.refresh();
            }
            else {
                this.pageReady = true;
            }
        }
    }
    initSettings() {
        this.collectionForm.formConfig.viewConfig = ListDirective.initViewConfig(this.collectionForm?.formConfig.viewConfig, {
            showSearchbar: this.showSearchbar,
            showAdvancedSearch: this.showAdvancedSearch,
            showFilterTerms: this.showFilterTerms,
            showHeader: this.showHeader
        });
        if (!this.collectionForm.formConfig.viewConfig.itemsPerPage) {
            this.collectionForm.formConfig.viewConfig.itemsPerPage = this.itemsPerPage;
        }
        if (!this.size) {
            this.size = this.collectionForm.formConfig.viewConfig.itemsPerPage;
        }
        else {
            if (!isNaN(this.size)) {
                this.collectionForm.formConfig.viewConfig.itemsPerPage = Number(this.size);
            }
        }
    }
    openPanel(event) {
        this.showAdvancedSearch = event;
    }
    /**
     * This function inits the search request object with the default values for the options defined in the configuration object
     */
    initOptions() {
        if (!this.searchRequest.o) {
            this.searchRequest.o = {};
        }
        if (this.collectionForm?.formConfig.viewConfig.options) {
            for (let i = 0; i < this.collectionForm?.formConfig.viewConfig.options.length; i++) {
                if (this.collectionForm?.formConfig.viewConfig.options[i].type !== 'hidden' && this.searchRequest.o[this.collectionForm?.formConfig.viewConfig.options[i].name] === undefined) {
                    let index = this.collectionForm?.formConfig.viewConfig.options[i].values.findIndex(item => item.default === true);
                    if (index >= 0) {
                        this.searchRequest.o[this.collectionForm?.formConfig.viewConfig.options[i].name] = this.collectionForm?.formConfig.viewConfig.options[i].values[index].value;
                    }
                }
            }
        }
        if (this.collectionForm?.form?.stylesheet) {
            /* Create style document */
            let css = document.createElement('style');
            css.type = 'text/css';
            if (css.styleSheet) {
                css.styleSheet.cssText = this.collectionForm?.form.stylesheet;
            }
            else {
                css.appendChild(document.createTextNode(this.collectionForm?.form.stylesheet));
            }
            /* Append style to the tag name */
            document.getElementsByTagName("head")[0].appendChild(css);
        }
    }
    /**
     *
     * @param searchParameters
     *
     * This function transforms the options object in an array of parameters to be processed by the search function (an array of parameters, as for example GeneralSearchParameter or SimpleSearchParameter)
     */
    searchForOptions(aliases, searchParameters) {
        if (this.collectionForm?.formConfig.viewConfig.options) {
            for (let i = 0; i < this.collectionForm?.formConfig.viewConfig.options.length; i++) {
                if (this.collectionForm?.formConfig.viewConfig.options[i].type === 'hidden') {
                    searchParameters.push(new SimpleSearchParameter(ListDirective.manageField(this.configService.env.advancedSearch.termConcatenator, aliases[this.collectionForm?.formConfig.viewConfig.options[i].name], this.configService.env.currentLang), this.collectionForm?.formConfig.viewConfig.options[i].value));
                }
                else {
                    if (this.searchRequest.o[this.collectionForm?.formConfig.viewConfig.options[i].name]) {
                        let index = this.collectionForm?.formConfig.viewConfig.options[i].values.findIndex(item => item.value === this.searchRequest.o[this.collectionForm?.formConfig.viewConfig.options[i].name]);
                        if (index >= 0) {
                            if (this.collectionForm?.formConfig.viewConfig.options[i].values[index].condition) {
                                if (this.collectionForm?.formConfig.viewConfig.options[i].values[index].name) {
                                    searchParameters.push(new SimpleSearchParameter(ListDirective.manageField(this.configService.env.advancedSearch.termConcatenator, aliases[this.collectionForm?.formConfig.viewConfig.options[i].values[index].name], this.configService.env.currentLang), this.collectionForm?.formConfig.viewConfig.options[i].values[index].condition));
                                }
                                else {
                                    searchParameters.push(new GeneralSearchParameter(this.collectionForm?.formConfig.viewConfig.options[i].values[index].condition));
                                }
                            }
                        }
                    }
                    else {
                        let index = this.collectionForm?.formConfig.viewConfig.options[i].values.findIndex(item => item.value === null);
                        if (index >= 0) {
                            if (this.collectionForm?.formConfig.viewConfig.options[i].values[index].name) {
                                searchParameters.push(new SimpleSearchParameter(ListDirective.manageField(this.configService.env.advancedSearch.termConcatenator, aliases[this.collectionForm?.formConfig.viewConfig.options[i].values[index].name], this.configService.env), this.collectionForm?.formConfig.viewConfig.options[i].values[index].condition));
                            }
                            else {
                                searchParameters.push(new GeneralSearchParameter(this.collectionForm?.formConfig.viewConfig.options[i].values[index].condition));
                            }
                        }
                    }
                }
            }
        }
        return searchParameters;
    }
    setRenderer(resultNumber, res, list, aggregations, grouped = false) {
        this.setPagination(res);
        if (grouped) {
            this.resultList = { component: GroupedResultComponent, viewType: ViewTypeEnum.TABLE, searchRequest: this.searchRequest, paginationItems: this.paginationItems, maxSize: this.maxSize, from: this.from, to: this.to, itemsPerPage: this.size, total: resultNumber, list: list, aggregations: aggregations, collection: this.name };
        }
        else {
            this.resultList = { component: StandardResultComponent, viewType: ViewTypeEnum.TABLE, searchRequest: this.searchRequest, paginationItems: this.paginationItems, maxSize: this.maxSize, from: this.from, to: this.to, itemsPerPage: this.size, total: resultNumber, list: list, aggregations: aggregations, collection: this.name };
        }
    }
    refresh() {
        if (this.collectionForm?.formConfig.selectionEnabled) {
            this.userselectionService.storeSearch(this.space, this.name, this.searchRequest);
        }
        this.search((this.searchRequest.page ? ((this.searchRequest.page - 1) * this.size) + 1 : 0), this.searchRequest.q, this.searchRequest.f, this.searchRequest.g);
    }
    static parseSearchRequestSort(searchRequestSort) {
        let sort = [];
        if (searchRequestSort > '') {
            let s = searchRequestSort.split(";");
            for (let i = 0; i < s.length; i++) {
                if (s[i] > "") {
                    sort.push({
                        name: s[i].split(":")[0],
                        order: s[i].split(":")[1]
                    });
                }
            }
        }
        return sort;
    }
    onMapSearch(geoSearch) {
        let index = this.collectionForm?.formConfig.viewConfig.geoSearch?.findIndex(item => item.name === geoSearch.name);
        if (index >= 0) {
            if (!this.searchRequest.g) {
                this.searchRequest.g = {};
            }
            this.searchRequest.g[geoSearch.name] = geoSearch.geometry.coordinates;
        }
        let queryParams = {
            page: this.searchRequest.page,
            q: this.searchRequest.q,
            f: ListDirective.stringifyAdvancedParams(this.configService, this.searchRequest.f, this.configService.env.advancedSearch.multiple.separator),
            o: ListDirective.stringifyAdvancedParams(this.configService, this.searchRequest.o, this.configService.env.advancedSearch.multiple.separator),
            g: ListDirective.stringifyGeospatialParams(this.configService, this.searchRequest.g, this.configService.env.advancedSearch.multiple.separator),
            sort: this.searchRequest.sort
        };
        if (this.currentView) {
            queryParams.view = this.currentView;
        }
        this.router.navigate(['./'], {
            relativeTo: this.route,
            fragment: 'search',
            queryParams: queryParams
        });
    }
    search(from, query, f, g) {
        let statuses;
        if (this.review) {
            statuses = this.configService.env.reviewStatuses || this.statuses.status.map(item => item.name).toString();
        }
        else {
            statuses = this.configService.env.statuses || this.statuses.status.map(item => item.name).toString();
        }
        if (this.virtualCollectionStatuses > "" && !statuses.includes(this.virtualCollectionStatuses)) {
            statuses = statuses + "," + this.virtualCollectionStatuses;
        }
        let searchParameters = [];
        if (query) {
            searchParameters.push(new GeneralSearchParameter(query));
        }
        if (f) {
            let advancedSearchParams = ListDirective.decodeSearch(this.configService, this.configService.env.advancedSearch.termConcatenator, f, this.collectionForm?.formConfig.aliases, this.collectionForm?.formConfig.viewConfig.advancedSearch, this.collectionForm?.formConfig.viewConfig.facets, this.collectionForm?.formConfig.viewConfig.filters, this.configService.env.currentLang);
            searchParameters = this.getAdvancedSearchConditions(this.collectionForm?.formConfig.viewConfig, advancedSearchParams, searchParameters, this.configService.env.advancedSearch.multiple.regexp, this.configService.env.advancedSearch.multiple.condition);
        }
        let geoFilter;
        if (g) {
            geoFilter = this.getGeoSearch(this.collectionForm?.formConfig.viewConfig, g);
        }
        if (this.collectionForm?.formConfig.viewConfig.searchForLang) {
            if (this.searchRequest.lang) {
                searchParameters.push(new SimpleSearchParameter(this.collectionForm?.formConfig.viewConfig.languageField, this.collectionForm?.formConfig.viewConfig.languageParams[this.searchRequest.lang]));
            }
            else {
                searchParameters.push(new SimpleSearchParameter(this.collectionForm?.formConfig.viewConfig.languageField, this.collectionForm?.formConfig.viewConfig.languageParams[this.configService.env.currentLang]));
            }
        }
        searchParameters = this.searchForOptions(this.collectionForm?.formConfig.aliases, searchParameters);
        for (let i = 0; i < this.defaultSearchParameters?.length; i++) {
            searchParameters.push(new GeneralSearchParameter(this.defaultSearchParameters[i]));
        }
        this.loading = true;
        let space;
        let name;
        if (this.collectionForm?.formConfig.virtualCollection) {
            space = this.collectionForm?.formConfig.dataSpace;
            name = this.collectionForm?.formConfig.dataCollections.toString();
        }
        else {
            space = this.space;
            name = this.name;
        }
        this.searchService.searchCollectionItems(space, name, searchParameters, this.size, from, this.searchRequest.sort ? ListDirective.getSort(this.configService, this.collectionForm?.formConfig.aliases, ListDirective.parseSearchRequestSort(this.searchRequest.sort)) : ListDirective.getSort(this.configService, this.collectionForm?.formConfig.aliases, this.collectionForm?.formConfig.viewConfig.sort, this.configService.env), null, ListDirective.getFields(this.configService.env.advancedSearch.termConcatenator, this.collectionForm?.formConfig.aliases, this.collectionForm?.formConfig.viewConfig.fields, this.configService.env.currentLang), null, statuses, geoFilter, this.collectionForm?.formConfig.viewConfig).subscribe(res => {
            this.loading = false;
            this.aggregations = [];
            if (this.collectionForm?.formConfig.viewConfig.facets && this.collectionForm?.formConfig.viewConfig.facets.length > 0) {
                if (res && res.results.aggregations) {
                    for (let i = 0; i < this.collectionForm?.formConfig.viewConfig.facets.length; i++) {
                        this.aggregations.push({
                            type: this.collectionForm?.formConfig.viewConfig.facets[i].name,
                            title: this.dynamicFormControlService.getProperty(null, this.collectionForm?.form, { refPropertiesId: this.collectionForm?.formConfig.viewConfig.facets[i].refPropertiesId, code: this.collectionForm?.formConfig.viewConfig.facets[i].name }, 'label'),
                            parameter: ListDirective.manageField(this.configService.env.advancedSearch.termConcatenator, this.collectionForm?.formConfig.aliases[this.collectionForm?.formConfig.viewConfig.facets[i].path || this.collectionForm?.formConfig.viewConfig.facets[i].name] || this.collectionForm?.formConfig.viewConfig.facets[i].name, this.configService.env),
                            aggregation: res.results.aggregations.find(agg => agg.name === this.collectionForm?.formConfig.viewConfig.facets[i].name)
                        });
                    }
                }
            }
            const resultNumber = res && res.results ? res.results.total : 0;
            let list = [];
            if (res && res.results) {
                if (this.collectionForm?.formConfig.viewConfig.grouping?.groupedDisplay) {
                    list = res.results.aggregations.filter(result => result.name === this.collectionForm?.formConfig.viewConfig.grouping.aggs[0].key)[0]['results'];
                    this.setRenderer(resultNumber, res, list, this.aggregations, true);
                }
                else {
                    list = res.results.values;
                    this.setRenderer(resultNumber, res, list, this.aggregations);
                }
            }
            this.afterSearchAdditionalActions(list, searchParameters, geoFilter);
            this.pageReady = true;
        }, err => {
            this.loading = false;
            this.searchService.manageError(err, 'Error reading collection items from collection ' + this.name);
        });
    }
    beforeSearchAdditionalActions(searchParameters) {
        //console.log(searchParameters);
    }
    afterSearchAdditionalActions(list, searchParameters, geoFilter) {
        //To be defined in the extended class if necessary
    }
    setPagination(res) {
        this.total = res.results.total;
        this.paginationItems = this.total >= this.maxNumberOfElements ? (this.maxNumberOfElements - this.size) : this.total;
        const from = +this.size * (this.searchRequest.page - 1);
        this.from = from + 1; // user friendly pagination starts in 1
        if (this.total) {
            if (this.size < this.total - (this.size * (this.searchRequest.page - 1))) {
                this.to = from + this.size;
            }
            else {
                this.to = from + (this.total - (this.size * (this.searchRequest.page - 1)));
            }
        }
        else {
            this.to = this.from;
        }
    }
    /**
     *
     * @param params the object containing all the possible params that can be provided to the search
     * @returns the search object payload
     *
     * This function transforms the query string in a json object
     *
     */
    static parsePageRequest(advancedSearchConfig, params, routeParams) {
        let searchRequest = new SearchRequest();
        searchRequest.lang = params['lang'];
        searchRequest.page = Number(params['page'] ? params['page'] : 1);
        searchRequest.q = params['q'];
        searchRequest.sort = params['sort'];
        searchRequest.collections = params['collections'];
        searchRequest.tab = params['tab'];
        searchRequest.children = params['children'];
        //----------------------------------------------------------
        searchRequest.o = {};
        if (params['additional'] > '') {
            this.processFilter(advancedSearchConfig, searchRequest, params, 'additional', 'o');
        }
        if (params['options'] > '') {
            this.processFilter(advancedSearchConfig, searchRequest, params, 'options', 'o');
        }
        if (params['o'] > '') {
            this.processFilter(advancedSearchConfig, searchRequest, params, 'o', 'o');
        }
        //----------------------------------------------------------
        searchRequest.f = {};
        if (params['advanced'] > '') {
            this.processFilter(advancedSearchConfig, searchRequest, params, 'advanced', 'f');
        }
        if (params['filter'] > '') {
            this.processFilter(advancedSearchConfig, searchRequest, params, 'filter', 'f');
        }
        if (params['f'] > '') {
            this.processFilter(advancedSearchConfig, searchRequest, params, 'f', 'f');
        }
        if (params['g'] > '') {
            this.processGeofilter(advancedSearchConfig, searchRequest, params);
        }
        //----------------------------------------------------------
        if (params['langs']) {
            if (!params['langs'].endsWith(advancedSearchConfig.suffix)) {
                params['langs'] = params['langs'] + advancedSearchConfig.suffix;
            }
            let inValue = '';
            let languages = params['langs'].split(new RegExp(advancedSearchConfig.regexp));
            for (let i = 0; i < languages.length; i++) {
                if (languages[i] > '') {
                    if (inValue > '') {
                        inValue = inValue + ' OR metadata.lang:' + languages[i];
                    }
                    else {
                        inValue = 'metadata.lang:' + languages[i];
                    }
                }
            }
            if (searchRequest.q !== '*' && searchRequest.q > '' && !searchRequest.q.includes(inValue)) {
                searchRequest.q = searchRequest.q + ' AND (' + inValue + ')';
            }
            else {
                searchRequest.q = '(' + inValue + ')';
            }
        }
        if (routeParams && routeParams.param && routeParams.value) {
            searchRequest.f[routeParams.param] = routeParams.value;
        }
        return searchRequest;
    }
    static processGeofilter(advancedSearchConfig, searchRequest, params) {
        let sep = advancedSearchConfig.separator;
        let geoFilter = params['g'].split(";");
        searchRequest.g = {};
        for (let i = 0; i < geoFilter.length; i++) {
            searchRequest.g[geoFilter[i].split(sep)[0]] = JSON.parse(geoFilter[i].split(sep)[1]);
        }
    }
    static processFilter(advancedSearchConfig, searchRequest, params, name, param) {
        let sep = advancedSearchConfig.separator;
        let p = params[name].includes(advancedSearchConfig.suffix) ? params[name] : params[name] + advancedSearchConfig.suffix;
        const f = decodeURI(p).split(new RegExp(advancedSearchConfig.regexp));
        for (let i = 0; i < f.length; i++) {
            if (f[i] > '') {
                searchRequest[param][f[i].split(sep)[0]] = f[i].split(sep)[1];
            }
        }
    }
    /**
     *
     * @param formItem the json object obtained from the query string
     * @param advancedSearch the array of possible params to use for the advanced search for the current collection, extracted from the collections configuration object
     * @param facets the array of possible params to use for the filter terms for the current collection, extracted from the collections configuration object
     * @returns the object with all the filters to provide to the search, where aliases have been replaced with the corresponding field names
     */
    static decodeSearch(configService, termConcatenator, formItem, aliases, advancedSearch, facets, filters, lang) {
        let item = {};
        for (let key in formItem) {
            if (formItem[key] > '') {
                //The param definition is searched in the advanced search configuration object
                let index = advancedSearch && advancedSearch.length > 0 ? advancedSearch.findIndex(item => item.name === key) : -1;
                if (index >= 0) {
                    ListDirective.decodeAdvancedSearch(advancedSearch, index, formItem, key, item, termConcatenator, aliases, lang, configService);
                }
                else {
                    //The param definition is not defined in the advancedSearch configuration object
                    //The param definition is searched in the facets configuration object
                    index = facets && facets.length > 0 ? facets.findIndex(item => item.name === key) : -1;
                    if (index >= 0) {
                        ListDirective.decodeFacet(facets, index, aliases, lang, item, key, configService, formItem);
                    }
                    else {
                        index = filters && filters.length > 0 ? filters.findIndex(item => item.name === key) : -1;
                        if (index >= 0) {
                            ListDirective.decodeFilters(filters, index, aliases, lang, item, key, configService, formItem);
                        }
                        else {
                            item[ListDirective.manageField(configService.env.advancedSearch.termConcatenator, aliases[key] || (key.startsWith("document.") ? key : "document." + key), lang)] = ListDirective.getTermProperty(configService, configService.env.advancedSearch.termConcatenator, formItem[key], "key");
                        }
                    }
                }
            }
        }
        return item;
    }
    static decodeFilters(filters, index, aliases, lang, item, key, configService, formItem) {
        let p = ListDirective.manageField(configService.env.advancedSearch.termConcatenator, aliases[filters[index].paths[0]] || filters[index].paths[0] || aliases[filters[index].name], lang);
        item[key] = {};
        item[key][p] = ListDirective.getTermProperty(configService, configService.env.advancedSearch.termConcatenator, formItem[key], "key");
    }
    static decodeFacet(facets, index, aliases, lang, item, key, configService, formItem) {
        let p = ListDirective.manageField(facets[index].concatDelimiter, aliases[facets[index].paths[0]] || facets[index].paths[0] || aliases[facets[index].name], lang);
        item[key] = {};
        item[key][p] = ListDirective.getTermProperty(configService, facets[index].concatDelimiter, formItem[key], "key");
    }
    static decodeAdvancedSearch(advancedSearch, index, formItem, key, item, termConcatenator, aliases, lang, configService) {
        if (advancedSearch[index].type === 'range') {
            let range = formItem[key].split(':');
            item[key] = {};
            let p = ListDirective.manageField(termConcatenator, aliases[advancedSearch[index].rangeFromPath] || advancedSearch[index].rangeFromPath, lang);
            item[key][p] = range[0];
            p = ListDirective.manageField(termConcatenator, aliases[advancedSearch[index].rangeToPath] || advancedSearch[index].rangeToPath, lang);
            item[key][p] = range[1];
        }
        else {
            if (advancedSearch[index].paths) {
                item[key] = {};
                for (let i = 0; i < advancedSearch[index].paths.length; i++) {
                    let p = ListDirective.manageField(termConcatenator, aliases[advancedSearch[index].paths[i]] || advancedSearch[index].paths[i], lang);
                    item[key][p] = ListDirective.getTermProperty(configService, termConcatenator, formItem[key], "key");
                }
            }
            else {
                //The param is defined in the configuration
                let p = ListDirective.manageField(termConcatenator, aliases[advancedSearch[index].name] || advancedSearch[index].name, lang);
                item[key] = {};
                item[key][p] = ListDirective.getTermProperty(configService, termConcatenator, formItem[key], "key");
            }
        }
    }
    getGeoSearch(viewConfig, g) {
        let geoFilter;
        for (let key in g) {
            if (g[key]) {
                let index = viewConfig.geoSearch.findIndex(item => item.name === key);
                if (index >= 0) {
                    geoFilter = {
                        geoShape: {
                            field: viewConfig.geoSearch[index].paths[0],
                            type: viewConfig.geoSearch[index].type === "bbox" ? "polygon" : viewConfig.geoSearch[index].type,
                            orientation: "left",
                            coordinates: g[key][0]
                        }
                    };
                }
            }
        }
        return geoFilter;
    }
    /**
     *
     * @param advancedSearchParams
     * @param searchParameters
     * @param regexp
     * @param conditionJoin
     * @returns the object to provide to the search function
     *
     * This function transforms the params object in an array of parameters to be processed by the search function (an array of parameters, as for example GeneralSearchParameter or SimpleSearchParameter)
     */
    getAdvancedSearchConditions(viewConfig, advancedSearchParams, searchParameters, regexp, conditionJoin) {
        for (let key in advancedSearchParams) {
            if (advancedSearchParams[key]) {
                let index = viewConfig.advancedSearch?.findIndex(item => item.name === key);
                if (index >= 0) {
                    //Multiple values
                    if (typeof (advancedSearchParams[key]) === 'object') {
                        let join = conditionJoin;
                        if (viewConfig.advancedSearch[index].type === 'range') {
                            join = ' AND ';
                            let condition = '';
                            let from = advancedSearchParams[key][viewConfig.advancedSearch[index].rangeFromPath];
                            let to = advancedSearchParams[key][viewConfig.advancedSearch[index].rangeToPath];
                            condition = (condition > '' ? condition + join : '') + viewConfig.advancedSearch[index].rangeFromPath + this.configService.env.advancedSearch.paramValueSeparator + '>=' + from;
                            condition = (condition > '' ? condition + join : '') + viewConfig.advancedSearch[index].rangeToPath + this.configService.env.advancedSearch.paramValueSeparator + '<=' + to;
                            condition = '(' + condition + ')';
                            searchParameters.push(new GeneralSearchParameter(condition));
                        }
                        else {
                            let condition = '';
                            for (let param in advancedSearchParams[key]) {
                                let values = advancedSearchParams[key][param].split(new RegExp(regexp));
                                for (let i = 0; i < values.length; i++) {
                                    condition = (condition > '' ? condition + join : '') + param + this.configService.env.advancedSearch.paramValueSeparator + values[i];
                                }
                            }
                            condition = '(' + condition + ')';
                            searchParameters.push(new GeneralSearchParameter(condition));
                        }
                    }
                    //Single value
                    else {
                        searchParameters.push(new SimpleSearchParameter(key, advancedSearchParams[key]));
                    }
                }
                else {
                    index = viewConfig.facets?.findIndex(item => item.name === key);
                    if (index >= 0) {
                        if (typeof (advancedSearchParams[key]) === 'object') {
                            let join = conditionJoin;
                            let condition = '';
                            for (let param in advancedSearchParams[key]) {
                                let values = advancedSearchParams[key][param].split(new RegExp(regexp));
                                for (let i = 0; i < values.length; i++) {
                                    condition = (condition > '' ? condition + join : '') + param + this.configService.env.advancedSearch.paramValueSeparator + values[i];
                                }
                            }
                            condition = '(' + condition + ')';
                            searchParameters.push(new GeneralSearchParameter(condition));
                        }
                        //Single value
                        else {
                            searchParameters.push(new SimpleSearchParameter(key, advancedSearchParams[key]));
                        }
                    }
                    else {
                        index = viewConfig.filters?.findIndex(item => item.name === key);
                        if (index >= 0) {
                            if (typeof (advancedSearchParams[key]) === 'object') {
                                let join = conditionJoin;
                                let condition = '';
                                for (let param in advancedSearchParams[key]) {
                                    let values = advancedSearchParams[key][param].split(new RegExp(regexp));
                                    for (let i = 0; i < values.length; i++) {
                                        condition = (condition > '' ? condition + join : '') + param + this.configService.env.advancedSearch.paramValueSeparator + values[i];
                                    }
                                }
                                condition = '(' + condition + ')';
                                searchParameters.push(new GeneralSearchParameter(condition));
                            }
                            //Single value
                            else {
                                searchParameters.push(new SimpleSearchParameter(key, advancedSearchParams[key]));
                            }
                        }
                        else {
                            searchParameters.push(new SimpleSearchParameter(key, advancedSearchParams[key]));
                        }
                    }
                }
            }
        }
        return searchParameters;
    }
    static getTermProperty(configService, termConcatenator, term, prop) {
        let items = term.split(new RegExp(configService.env.advancedSearch.multiple.regexp));
        let values = [];
        for (let i = 0; i < items.length; i++) {
            let tokens = items[i].split(termConcatenator);
            if (tokens.length > 1) {
                if (prop === "key") {
                    values.push(tokens[0]);
                }
                else {
                    values.push(tokens[1]);
                }
            }
            else {
                values.push(items[i]);
            }
        }
        return values.join(",");
    }
    static stringifyGeospatialParams(configService, item, separator) {
        let advanced = '';
        for (let key in item) {
            advanced = advanced.concat(key + configService.env.advancedSearch.separator + JSON.stringify(item[key]) + configService.env.advancedSearch.suffix);
        }
        if (advanced > '') {
            advanced = advanced.substring(0, advanced.length - 1);
            return advanced;
        }
        else {
            return null;
        }
    }
    /**
     *
     * @param item the json object containing all the decoded filters
     * @param separator the separator to use to join all the conditions
     * @returns a new query string
     */
    static stringifyAdvancedParams(configService, item, separator) {
        let advanced = '';
        for (let key in item) {
            if (typeof (item[key]) === 'object') {
                if (item[key].length > 0) {
                    let value = '';
                    for (let i = 0; i < item[key].length; i++) {
                        if (value.length > 0) {
                            if (typeof (item[key][i]) === 'object') {
                                value = value + separator + (item[key][i].label ? item[key][i].value + configService.env.advancedSearch.termConcatenator + item[key][i].label : item[key][i].value);
                            }
                            else {
                                value = value + separator + item[key][i];
                            }
                        }
                        else {
                            if (typeof (item[key][i]) === 'object') {
                                value = item[key][i].label ? item[key][i].value + configService.env.advancedSearch.termConcatenator + item[key][i].label : item[key][i].value;
                            }
                            else {
                                value = item[key][i];
                            }
                        }
                    }
                    if (value > '') {
                        advanced = advanced.concat(key + configService.env.advancedSearch.separator + value + configService.env.advancedSearch.suffix);
                    }
                }
                else {
                    if (item[key].value) {
                        advanced = advanced.concat(item[key].label + configService.env.advancedSearch.separator + item[key].value + configService.env.advancedSearch.suffix);
                    }
                }
            }
            else if (item[key] > '') {
                advanced = advanced.concat(key + configService.env.advancedSearch.separator + item[key] + configService.env.advancedSearch.suffix);
            }
        }
        if (advanced > '') {
            advanced = advanced.substring(0, advanced.length - 1);
            return advanced;
        }
        else {
            return null;
        }
    }
    /**
     *
     * @param aliases The aliases object for the collection
     * @param sort The sort object to decode
     * @returns The decoded sort object
     *
     * This function takes as input the sort configuration object created using aliases and returns the decoded sort object
     */
    static getSort(configService, aliases, sort, factsheetsSearchConfigurations) {
        if (!configService.env.sort && factsheetsSearchConfigurations) {
            configService.env.sort = factsheetsSearchConfigurations.sort;
        }
        let sorting = {};
        if (!sort || sort.length === 0) {
            return '';
        }
        for (let i = 0; i < sort.length; i++) {
            let alias = ListDirective.manageField(configService.env.advancedSearch.termConcatenator, aliases[sort[i].name] || sort[i].name, configService.env.currentLang);
            sorting[alias] = sort[i].order || 'ASC';
        }
        let sortString = '';
        for (let field in sorting) {
            sortString = (sortString > '' ? sortString + configService.env.sort.separator : sortString) + field + configService.env.sort.paramValueSeparator + sorting[field];
        }
        return sortString;
    }
    /**
     *
     * @param aliases The aliases object for the collection
     * @param grouping The grouping object to decode
     * @returns The decoded grouping object
     *
     * This function takes as input the grouping configuration object created using aliases and returns the decoded grouping object
     */
    static getGrouping(configService, aliases, groupedDisplay, grouping) {
        if (!groupedDisplay) {
            return null;
        }
        let decodedGrouping = {
            aggSetSize: grouping.aggSetSize || 1,
            aggSize: grouping.aggSize || 2000
        };
        if (!(grouping > '')) {
            return '';
        }
        const f = decodeURI(grouping.aggFields).split(configService.env.grouping.separator);
        if (!f.includes('metadata')) {
            f.push('metadata');
        }
        if (!f.includes('status')) {
            f.push('status');
        }
        for (let i = 0; i < f.length; i++) {
            if (f[i] > '') {
                let alias = ListDirective.manageField(configService.env.advancedSearch.termConcatenator, aliases[f[i]], configService.env.currentLang);
                if (!alias) {
                    alias = f[i];
                }
                if (!decodedGrouping.aggFields) {
                    decodedGrouping.aggFields = alias;
                }
                else {
                    decodedGrouping.aggFields = decodedGrouping.aggFields + configService.env.grouping.separator + alias;
                }
            }
        }
        let sort = '';
        for (let i = 0; i < grouping.aggFieldsSort.length; i++) {
            sort = sort + (sort > '' ? ',' : '') + (aliases && aliases[grouping.aggFieldsSort[i].name] ? ListDirective.manageField(configService.env.advancedSearch.termConcatenator, aliases[grouping.aggFieldsSort[i].name], configService.env) : grouping.aggFieldsSort[i].name) + ':' + grouping.aggFieldsSort[i].order;
        }
        decodedGrouping.aggFieldsSort = sort;
        return decodedGrouping;
    }
    /**
     *
     * @param aliases The aliases object for the collection
     * @param fields The fields array to decode
     * @returns The decoded fields array
     *
     * This function takes as input the fields configuration array created using aliases and returns the decoded fields array
     */
    static getFields(termConcatenator, aliases, fields, lang) {
        let items = [];
        if (!fields) {
            return;
        }
        for (let i = 0; i < fields.length; i++) {
            items.push(ListDirective.manageField(termConcatenator, aliases[fields[i]] || fields[i], lang));
        }
        //Enrichment of the fields list with all the fields present in aliases, because they are used for cards view
        for (let key in aliases) {
            let field = aliases[key].replaceAll("%lang%", lang);
            if (!items.includes(field)) {
                items.push(field);
            }
        }
        if (!items.includes('metadata')) {
            items.push('metadata');
        }
        if (!items.includes('id')) {
            items.push('id');
        }
        if (!items.includes('status')) {
            items.push('status');
        }
        return items;
    }
    static manageField(termConcatenator, field, lang) {
        if (!field) {
            return field;
        }
        if (field.includes('%currentlang%')) {
            field = field.replace('%currentlang%', lang);
        }
        if (field.includes('%defaultlang%')) {
            field = field.replace('%defaultlang%', lang);
        }
        if (field.includes('%lang%')) {
            field = field.replace('%lang%', lang);
        }
        if (field.includes(termConcatenator)) {
            let splits = field.split(termConcatenator);
            field = splits[0];
        }
        return field;
    }
    /**
   * @param inputs
   *
   * This function processes the additional attributes of the search-list tag: considered just the ones corresponding to one of the aliases defined in the configuration object
   * For each attribute found that corresponds to an alias, the corresponding filter is added to the f property of the inputs object, following proper rules of concatenation
   */
    processAdditionalAttributes(inputs) {
        if (!inputs) {
            inputs = {};
        }
        for (let i = 0; i < this.elementRef.nativeElement.attributes.length; i++) {
            let p = this.elementRef.nativeElement.attributes[i].nodeName;
            if (ListDirective.manageField(this.configService.env.advancedSearch.termConcatenator, this.collectionForm?.formConfig.aliases[p], this.configService.env.currentLang)) {
                let v = this.elementRef.nativeElement.attributes[i].nodeValue;
                if (inputs.f > '') {
                    inputs.f = inputs.f + (inputs.f.endsWith(this.configService.env.advancedSearch.suffix) ? '' : this.configService.env.advancedSearch.suffix) + p + this.configService.env.advancedSearch.separator + v + this.configService.env.advancedSearch.suffix;
                }
                else {
                    inputs.f = p + this.configService.env.advancedSearch.separator + v + this.configService.env.advancedSearch.suffix;
                }
            }
        }
    }
    static initFormConfig(formConfig) {
        if (!formConfig) {
            formConfig = {};
        }
        if (!formConfig.aliases) {
            formConfig.aliases = {};
        }
        if (!formConfig.detailPageTemplate && formConfig.detailTemplates?.length > 0) {
            formConfig.detailPageTemplate = formConfig.detailTemplates[0];
        }
        return formConfig;
    }
    static initViewConfig(viewConfig, attributes = {}) {
        if (!viewConfig) {
            viewConfig = {};
        }
        if (!viewConfig) {
            viewConfig = {};
        }
        if (viewConfig.itemsPerPage === undefined || viewConfig.itemsPerPage === null) {
            viewConfig.itemsPerPage = 30;
        }
        if (!viewConfig.languageParams) {
            viewConfig.languageParams = {};
        }
        if (!viewConfig.sort) {
            viewConfig.sort = [];
        }
        if (!viewConfig.listResult) {
            viewConfig.listResult = [];
        }
        if (!viewConfig.advancedSearch) {
            viewConfig.advancedSearch = [];
        }
        if (!viewConfig.facets) {
            viewConfig.facets = [];
        }
        if (!viewConfig.fields) {
            viewConfig.fields = [];
        }
        if (!viewConfig.grouping) {
            viewConfig.grouping = {
                groupedDisplay: false,
                aggSetSize: 1,
                aggSize: 2000
            };
        }
        if (!viewConfig.grouping.listResult) {
            viewConfig.grouping.listResult = [
                {
                    "type": "normal"
                },
                {
                    "type": "aggregation"
                }
            ];
        }
        if (!viewConfig.grouping.aggFields) {
            viewConfig.grouping.aggFields = [];
        }
        if (!viewConfig.grouping.aggFieldsSort) {
            viewConfig.grouping.aggFieldsSort = [];
        }
        if (!viewConfig?.viewSwitcher) {
            viewConfig.viewSwitcher = {};
        }
        if (viewConfig?.viewSwitcher.enabled === undefined) {
            viewConfig.viewSwitcher.enabled = false;
        }
        if (!viewConfig?.viewSwitcher.defaultView) {
            viewConfig.viewSwitcher.defaultView = "table";
        }
        if (!viewConfig?.viewSwitcher.views) {
            viewConfig.viewSwitcher.views = [{ type: "table" }, { type: "list", template: 'card-horizontal' }, { type: "grid", template: 'card' }];
        }
        if (attributes.showSearchbar !== undefined) {
            viewConfig.showSearchbar = attributes.showSearchbar;
        }
        if (attributes.showAdvancedSearch !== undefined) {
            viewConfig.showAdvancedSearch = attributes.showAdvancedSearch;
        }
        if (attributes.showFilterTerms !== undefined) {
            viewConfig.showFilterTerms = attributes.showFilterTerms;
        }
        if (attributes.showHeader !== undefined) {
            viewConfig.showHeader = attributes.showHeader;
        }
        return viewConfig;
    }
    static { this.ɵfac = function ListDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ListDirective)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(UserselectionService), i0.ɵɵdirectiveInject(i1.WorkspaceService), i0.ɵɵdirectiveInject(i1.TemplateService), i0.ɵɵdirectiveInject(i1.PropertiesService), i0.ɵɵdirectiveInject(i1.ListConfigService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ListDirective, selectors: [["", "appList", ""]], standalone: false }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListDirective, [{
        type: Directive,
        args: [{
                selector: '[appList]',
                standalone: false
            }]
    }], () => [{ type: i1.SearchService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.UtilsService }, { type: i1.ConfigurationService }, { type: i1.DynamicFormControlService }, { type: i0.ElementRef }, { type: i1.CollectionService }, { type: i3$2.ConfirmationService }, { type: UserselectionService }, { type: i1.WorkspaceService }, { type: i1.TemplateService }, { type: i1.PropertiesService }, { type: i1.ListConfigService }], null); })();

function SliderComponent_swiper_slide_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "swiper-slide");
    i0.ɵɵelement(1, "fi-card", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const entry_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("space", ctx_r1.space)("collection", ctx_r1.collection)("textlimit", ctx_r1.textlimit)("detaillabel", ctx_r1.detaillabel)("detailurl", ctx_r1.detailurl)("data", entry_r1)("view", ctx_r1.view)("cssclass", ctx_r1.cssclass);
} }
register();
class SliderComponent {
    constructor(configService, utilsService, elRef) {
        this.configService = configService;
        this.utilsService = utilsService;
        this.elRef = elRef;
    }
    ngOnInit() {
        const swiperEl = this.elRef.nativeElement.querySelector('swiper-container');
        Object.assign(swiperEl, this.initSwiper());
        swiperEl.initialize();
    }
    initSwiper() {
        let options = {
            direction: 'horizontal',
            loop: false,
            keyboard: true,
            mousewheel: true,
            scrollbar: false,
            pagination: false,
            navigation: true,
            injectStyles: [
                `
          .swiper-button-next,
          .swiper-button-prev {
            background-color: white;
            border-radius: 50%;
            height: 38px;
            width: 38px;
            color: var(--primary-color);
          }
          .swiper-button-next svg, .swiper-button-prev svg {
            width: 15px;
            height: 15px;
          }
      `,
            ]
        };
        if (this.view === this.configService.cardTypes.CARD) {
            options.spaceBetween = 30;
            options.slidesPerView = this.slidesPerView;
        }
        else if (this.view === this.configService.cardTypes.HERO) {
            options.slidesPerView = 1;
        }
        return options;
    }
    static { this.ɵfac = function SliderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SliderComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SliderComponent, selectors: [["slider"]], inputs: { view: "view", sliderId: "sliderId", slidesPerView: "slidesPerView", space: "space", collection: "collection", textlimit: "textlimit", detaillabel: "detaillabel", detailurl: "detailurl", cssclass: "cssclass", items: "items" }, standalone: false, decls: 4, vars: 1, consts: [["init", "false"], [4, "ngFor", "ngForOf"], [1, "fi-slider", "swiper-button-next"], [1, "fi-slider", "swiper-button-prev"], [3, "space", "collection", "textlimit", "detaillabel", "detailurl", "data", "view", "cssclass"]], template: function SliderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "swiper-container", 0);
            i0.ɵɵtemplate(1, SliderComponent_swiper_slide_1_Template, 2, 8, "swiper-slide", 1);
            i0.ɵɵelement(2, "div", 2)(3, "div", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.items);
        } }, dependencies: [i3.NgForOf, CardComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SliderComponent, [{
        type: Component,
        args: [{ selector: 'slider', standalone: false, template: "<swiper-container init=\"false\">\r\n    <swiper-slide *ngFor=\"let entry of items\">\r\n      <fi-card [space]=\"space\" [collection]=\"collection\" [textlimit]=\"textlimit\" [detaillabel]=\"detaillabel\" [detailurl]=\"detailurl\" [data]=\"entry\" [view]=\"view\" [cssclass]=\"cssclass\"></fi-card>\r\n    </swiper-slide>\r\n    <div class=\"fi-slider swiper-button-next\">\r\n\r\n    </div>\r\n    <div class=\"fi-slider swiper-button-prev\">\r\n  \r\n    </div>\r\n</swiper-container>" }]
    }], () => [{ type: i1.ConfigurationService }, { type: i1.UtilsService }, { type: i0.ElementRef }], { view: [{
            type: Input
        }], sliderId: [{
            type: Input
        }], slidesPerView: [{
            type: Input
        }], space: [{
            type: Input
        }], collection: [{
            type: Input
        }], textlimit: [{
            type: Input
        }], detaillabel: [{
            type: Input
        }], detailurl: [{
            type: Input
        }], cssclass: [{
            type: Input
        }], items: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SliderComponent, { className: "SliderComponent", filePath: "src/components/slider/slider.component.ts", lineNumber: 15 }); })();

const _c0$d = a0 => [a0];
function CardsComponent_ng_container_0_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "fi-card", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const entry_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getCardClass());
    i0.ɵɵadvance();
    i0.ɵɵproperty("target", ctx_r1._target)("space", ctx_r1.space)("collection", ctx_r1.collection)("collectionForm", ctx_r1.collectionForm)("textlimit", ctx_r1.textlimit)("detaillabel", ctx_r1.detaillabel)("detailurl", ctx_r1.detailurl)("data", entry_r1)("view", ctx_r1.view)("cssclass", ctx_r1.cssclass)("leftcolclass", ctx_r1.leftcolclass)("rightcolclass", ctx_r1.rightcolclass);
} }
function CardsComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, CardsComponent_ng_container_0_div_1_div_1_Template, 2, 13, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.items);
} }
function CardsComponent_ng_container_0_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "fi-card", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const entry_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getAutocardClass(i_r4));
    i0.ɵɵadvance();
    i0.ɵɵproperty("target", ctx_r1._target)("space", ctx_r1.space)("collection", ctx_r1.collection)("collectionForm", ctx_r1.collectionForm)("textlimit", ctx_r1.textlimit)("detaillabel", ctx_r1.detaillabel)("detailurl", ctx_r1.detailurl)("data", entry_r3)("view", ctx_r1.view)("cssclass", ctx_r1.cssclass)("leftcolclass", ctx_r1.leftcolclass)("rightcolclass", ctx_r1.rightcolclass);
} }
function CardsComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, CardsComponent_ng_container_0_div_2_div_1_Template, 2, 13, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.items);
} }
function CardsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CardsComponent_ng_container_0_div_1_Template, 2, 1, "div", 1)(2, CardsComponent_ng_container_0_div_2_Template, 2, 1, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.items && ctx_r1.view !== ctx_r1.configService.cardTypes.CARDHORIZONTALCAPTION);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.items && ctx_r1.view === ctx_r1.configService.cardTypes.CARDHORIZONTALCAPTION);
} }
function CardsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "slider", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("slidesPerView", ctx_r1.size)("items", ctx_r1.items)("view", ctx_r1.view)("space", ctx_r1.space)("collection", ctx_r1.collection)("textlimit", ctx_r1.textlimit)("detaillabel", ctx_r1.detaillabel)("detailurl", ctx_r1.detailurl)("view", ctx_r1.view)("cssclass", ctx_r1.cssclass);
} }
function CardsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 7)(2, "a", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "span", 9);
    i0.ɵɵtext(5, " chevron_right ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c0$d, ctx_r1.showalllink));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.showalllabel, " ");
} }
class CardsComponent extends ListDirective {
    static { this.itemParams = {
        id: 'id',
        type: 'type',
        title: 'title',
        year: 'year',
        description: 'description',
        image: 'image',
        video: 'video',
        videotype: 'videotype',
        category: 'category',
        link: 'link',
        source: 'source',
        callouttitle: 'callouttitle',
        copyright: 'copyright',
        target: 'target',
        cssclass: 'cssclass',
    }; }
    constructor(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService, formDataService, dialogService, mapService) {
        super(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService);
        this.formDataService = formDataService;
        this.dialogService = dialogService;
        this.mapService = mapService;
        this.view = 'card';
        this.root = '';
        this.mapping = {};
        this.showall = false;
        this.slider = false;
        this.resultsize = 3;
        this.direction = 'vertical';
        this.size = 3;
        this.autolink = 'false';
        this.loading = false;
        this.counter = 0;
        this.items = [];
    }
    ngOnInit() {
        this.setIndexingData = false;
        for (let key in CardsComponent.itemParams) {
            if (this['_' + key]) {
                this.mapping[key] = this.root ? this.root + '.' + this['_' + key] : this['_' + key];
            }
            else {
                this.mapping[key] = this.root ? this.root + '.' + key : key;
            }
        }
        this.name = this.collection;
        if (!this.data) {
            this.route.queryParams.subscribe(params => {
                if (!this.config) {
                    this.config = {
                        listPayload: {
                            itemsPerPage: this.resultsize,
                            searchForLang: false,
                            sort: '',
                            showFilterTerms: false
                        }
                    };
                }
                let inputs = {
                    advanced: this.advanced,
                    filter: this.filter,
                    f: this.f,
                    additional: this.additional,
                    options: this.options,
                    o: this.o,
                    langs: this.langs,
                    q: this.query,
                    sort: this.sort
                };
                for (let key in params) {
                    if (params[key] > '') {
                        inputs[key] = params[key];
                    }
                }
                this.init(true, inputs);
            });
        }
        else {
            let items;
            if (typeof (this.data) === 'string') {
                try {
                    this.data = this.data.trim();
                    items = JSON.parse(this.data);
                    this.afterSearchAdditionalActions();
                }
                catch (err) {
                    console.log(this.data);
                    console.log(err);
                }
            }
            else {
                items = this.data;
                this.afterSearchAdditionalActions();
            }
            this.resultsize = items ? items.length : 0;
            this.items = items || [];
        }
    }
    ngOnDestroy() {
    }
    setRenderer(resultNumber, res, list, aggregations, grouped = false) {
        if (this.view === this.configService.cardTypes.CARDMEETING || this.view === this.configService.cardTypes.CARDPUBLICATIONHORIZONTAL) {
            this.items = list.map((entry) => {
                return entry.document;
            });
        }
        else {
            if (list) {
                this.items = list.map((entry) => this.mapItemEntry(entry));
            }
        }
    }
    mapItemEntry(entry) {
        let item = {};
        for (let key in this.mapping) {
            if (this.mapping[key]) {
                let attrValues = jsonPath.query(entry, '$.' + this.mapping[key]);
                if (attrValues.length > 0) {
                    item[key] = attrValues[0];
                }
                else {
                    let index = this.configService.languages.findIndex(item => this.mapping[key].includes('_' + item.code));
                    if (index >= 0) {
                        //The param contains the language
                        let p = this.mapping[key].replace('_' + this.configService.languages[index].code, '_' + this.configService.env.defaultLang);
                        let attrValues = jsonPath.query(entry, '$.' + p);
                        if (attrValues.length > 0) {
                            item[key] = attrValues[0];
                        }
                    }
                }
            }
        }
        item.image = this.utilsService.processUrl(this.space, item.image);
        if (item.video) {
            item.video = this.utilsService.processUrl(this.space, item.video);
            item.video = this.transform(item.video);
        }
        if (this.collection && (JSON.parse(this.autolink) || !item.link)) {
            let siteUrl = this.configService.env.siteUrl ? this.configService.env.siteUrl : '';
            item.link = siteUrl + '/' + this.collection + '/' + item.id + "/" + this.configService.env.currentLang;
        }
        return item;
    }
    transform(url) {
        return url; //this.sanitizer.bypassSecurityTrustUrl(url);
    }
    getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }
    getCardClass() {
        if (this.direction === 'horizontal') {
            let n = Math.floor(12 / this.size);
            return 'horizontal col-md-' + n;
        }
        else {
            return 'col-md-12';
        }
    }
    getAutocardClass(i) {
        let visibility;
        if (i === this.counter) {
            visibility = "visible";
        }
        else {
            visibility = "hidden";
        }
        if (this.direction === 'horizontal') {
            let n = Math.floor(12 / this.size);
            return visibility + ' horizontal col-md-' + n;
        }
        else {
            return visibility + ' col-md-12';
        }
    }
    afterSearchAdditionalActions() {
        setInterval(() => {
            if (this.counter === this.items?.length - 1) {
                this.counter = 0;
            }
            else {
                this.counter++;
            }
        }, 3000);
    }
    static { this.ɵfac = function CardsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CardsComponent)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(UserselectionService), i0.ɵɵdirectiveInject(i1.WorkspaceService), i0.ɵɵdirectiveInject(i1.TemplateService), i0.ɵɵdirectiveInject(i1.PropertiesService), i0.ɵɵdirectiveInject(i1.ListConfigService), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.MapService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CardsComponent, selectors: [["fi-cards"]], inputs: { space: "space", collection: "collection", advanced: "advanced", query: "query", filter: "filter", f: "f", sort: "sort", additional: "additional", options: "options", o: "o", langs: "langs", view: "view", root: "root", mapping: "mapping", showall: "showall", showalllink: "showalllink", showalllabel: "showalllabel", detailurl: "detailurl", detaillabel: "detaillabel", cssclass: "cssclass", slider: "slider", resultsize: "resultsize", direction: "direction", data: "data", size: "size", autolink: "autolink", textlimit: "textlimit", leftcolclass: "leftcolclass", rightcolclass: "rightcolclass", _id: "_id", _type: "_type", _title: "_title", _description: "_description", _image: "_image", _video: "_video", _videotype: "_videotype", _category: "_category", _link: "_link", _source: "_source", _callouttitle: "_callouttitle", _copyright: "_copyright", _target: "_target", _cssclass: "_cssclass" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [[4, "ngIf"], ["class", "row dynamic-list", 4, "ngIf"], [1, "row", "dynamic-list"], [3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], [3, "target", "space", "collection", "collectionForm", "textlimit", "detaillabel", "detailurl", "data", "view", "cssclass", "leftcolclass", "rightcolclass"], [3, "slidesPerView", "items", "view", "space", "collection", "textlimit", "detaillabel", "detailurl", "cssclass"], [1, "float-right"], ["routerLinkActive", "router-link-active", 1, "title", 3, "routerLink"], [1, "align-middle", "material-icons-outlined"]], template: function CardsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, CardsComponent_ng_container_0_Template, 3, 2, "ng-container", 0)(1, CardsComponent_ng_container_1_Template, 2, 10, "ng-container", 0)(2, CardsComponent_ng_container_2_Template, 6, 4, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.slider);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.slider && ctx.items);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showall);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i2.RouterLink, i2.RouterLinkActive, CardComponent, SliderComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardsComponent, [{
        type: Component,
        args: [{ selector: 'fi-cards', standalone: false, template: "<ng-container *ngIf=\"!slider\">\r\n\r\n  <div class=\"row dynamic-list\" *ngIf=\"items && view !== configService.cardTypes.CARDHORIZONTALCAPTION\">\r\n    <div *ngFor=\"let entry of items\" [ngClass]=\"getCardClass()\">\r\n      <fi-card [target]=\"_target\" [space]=\"space\" [collection]=\"collection\" [collectionForm]=\"collectionForm\" [textlimit]=\"textlimit\" [detaillabel]=\"detaillabel\" [detailurl]=\"detailurl\" [data]=\"entry\" [view]=\"view\" [cssclass]=\"cssclass\" [leftcolclass]=\"leftcolclass\" [rightcolclass]=\"rightcolclass\"></fi-card>\r\n    </div>\r\n  </div>\r\n  \r\n  <div class=\"row dynamic-list\" *ngIf=\"items && view === configService.cardTypes.CARDHORIZONTALCAPTION\">\r\n    <div *ngFor=\"let entry of items; let i = index\" [ngClass]=\"getAutocardClass(i)\">\r\n      <fi-card [target]=\"_target\" [space]=\"space\" [collection]=\"collection\" [collectionForm]=\"collectionForm\" [textlimit]=\"textlimit\" [detaillabel]=\"detaillabel\" [detailurl]=\"detailurl\" [data]=\"entry\" [view]=\"view\" [cssclass]=\"cssclass\" [leftcolclass]=\"leftcolclass\" [rightcolclass]=\"rightcolclass\"></fi-card>\r\n    </div>\r\n  </div>\r\n\r\n</ng-container>\r\n\r\n<ng-container *ngIf=\"slider && items\">\r\n\r\n  <slider [slidesPerView]=\"size\" [items]=\"items\" [view]=\"view\" [space]=\"space\" [collection]=\"collection\" [textlimit]=\"textlimit\" [detaillabel]=\"detaillabel\" [detailurl]=\"detailurl\" [view]=\"view\" [cssclass]=\"cssclass\"></slider>\r\n\r\n</ng-container>\r\n\r\n<ng-container *ngIf=\"showall\">\r\n  <p class=\"float-right\"><a class=\"title\" [routerLink]=\"[showalllink]\" routerLinkActive=\"router-link-active\">{{ showalllabel }} <span class=\"align-middle material-icons-outlined\">\r\n    chevron_right\r\n    </span></a>\r\n  </p>\r\n</ng-container>\r\n" }]
    }], () => [{ type: i1.SearchService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.UtilsService }, { type: i1.ConfigurationService }, { type: i1.DynamicFormControlService }, { type: i0.ElementRef }, { type: i1.CollectionService }, { type: i3$2.ConfirmationService }, { type: UserselectionService }, { type: i1.WorkspaceService }, { type: i1.TemplateService }, { type: i1.PropertiesService }, { type: i1.ListConfigService }, { type: FormDataService }, { type: i1$1.DialogService }, { type: i1.MapService }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], advanced: [{
            type: Input
        }], query: [{
            type: Input
        }], filter: [{
            type: Input
        }], f: [{
            type: Input
        }], sort: [{
            type: Input
        }], additional: [{
            type: Input
        }], options: [{
            type: Input
        }], o: [{
            type: Input
        }], langs: [{
            type: Input
        }], view: [{
            type: Input
        }], root: [{
            type: Input
        }], mapping: [{
            type: Input
        }], showall: [{
            type: Input
        }], showalllink: [{
            type: Input
        }], showalllabel: [{
            type: Input
        }], detailurl: [{
            type: Input
        }], detaillabel: [{
            type: Input
        }], cssclass: [{
            type: Input
        }], slider: [{
            type: Input
        }], resultsize: [{
            type: Input
        }], direction: [{
            type: Input
        }], data: [{
            type: Input
        }], size: [{
            type: Input
        }], autolink: [{
            type: Input
        }], textlimit: [{
            type: Input
        }], leftcolclass: [{
            type: Input
        }], rightcolclass: [{
            type: Input
        }], _id: [{
            type: Input
        }], _type: [{
            type: Input
        }], _title: [{
            type: Input
        }], _description: [{
            type: Input
        }], _image: [{
            type: Input
        }], _video: [{
            type: Input
        }], _videotype: [{
            type: Input
        }], _category: [{
            type: Input
        }], _link: [{
            type: Input
        }], _source: [{
            type: Input
        }], _callouttitle: [{
            type: Input
        }], _copyright: [{
            type: Input
        }], _target: [{
            type: Input
        }], _cssclass: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CardsComponent, { className: "CardsComponent", filePath: "src/components/cards/cards.component.ts", lineNumber: 18 }); })();

function CartButtonsComponent_div_0_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function CartButtonsComponent_div_0_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.userselectionService.addToCart(ctx_r1.space, ctx_r1.collection, ctx_r1.documentId)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r1.disabled)("rounded", true)("text", true);
} }
function CartButtonsComponent_div_0_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function CartButtonsComponent_div_0_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.userselectionService.removeFromCart(ctx_r1.space, ctx_r1.collection, ctx_r1.documentId)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r1.disabled)("rounded", true)("text", true);
} }
function CartButtonsComponent_div_0_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function CartButtonsComponent_div_0_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.userselectionService.saveCart(ctx_r1.space)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r1.disabled)("rounded", true)("text", true);
} }
function CartButtonsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, CartButtonsComponent_div_0_button_2_Template, 1, 3, "button", 3)(3, CartButtonsComponent_div_0_button_3_Template, 1, 3, "button", 4)(4, CartButtonsComponent_div_0_button_4_Template, 1, 3, "button", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.documentId && !ctx_r1.userselectionService.isInCart(ctx_r1.space, ctx_r1.collection, ctx_r1.documentId));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.documentId && ctx_r1.userselectionService.isInCart(ctx_r1.space, ctx_r1.collection, ctx_r1.documentId));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.documentId);
} }
class CartButtonsComponent {
    constructor(userselectionService, configService) {
        this.userselectionService = userselectionService;
        this.configService = configService;
        this.disabled = false;
    }
    ngOnInit() {
        if (!this.configService.isLoggedIn()) {
            this.disabled = true;
        }
    }
    static { this.ɵfac = function CartButtonsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CartButtonsComponent)(i0.ɵɵdirectiveInject(UserselectionService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CartButtonsComponent, selectors: [["cart-buttons"]], inputs: { space: "space", collection: "collection", documentId: "documentId", disabled: "disabled" }, standalone: false, decls: 1, vars: 1, consts: [["class", "row userselection-buttons", 4, "ngIf"], [1, "row", "userselection-buttons"], [1, "col-md-12", "align-right"], ["pButton", "", "pRipple", "", "type", "button", "icon", "bi bi-cart-plus", 3, "disabled", "rounded", "text", "click", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "icon", "bi bi-cart-dash", 3, "disabled", "rounded", "text", "click", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "icon", "bi bi-cart-check", 3, "disabled", "rounded", "text", "click", 4, "ngIf"], ["pButton", "", "pRipple", "", "type", "button", "icon", "bi bi-cart-plus", 3, "click", "disabled", "rounded", "text"], ["pButton", "", "pRipple", "", "type", "button", "icon", "bi bi-cart-dash", 3, "click", "disabled", "rounded", "text"], ["pButton", "", "pRipple", "", "type", "button", "icon", "bi bi-cart-check", 3, "click", "disabled", "rounded", "text"]], template: function CartButtonsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, CartButtonsComponent_div_0_Template, 5, 3, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.configService.isLoggedIn());
        } }, dependencies: [i3.NgIf, i7.ButtonDirective], styles: ["button[_ngcontent-%COMP%]{font-size:1.5em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartButtonsComponent, [{
        type: Component,
        args: [{ selector: 'cart-buttons', standalone: false, template: "<div class=\"row userselection-buttons\" *ngIf=\"configService.isLoggedIn()\">\r\n    <div class=\"col-md-12 align-right\">\r\n        <button *ngIf=\"documentId && !userselectionService.isInCart(space,collection,documentId)\" [disabled]=\"disabled\" pButton pRipple type=\"button\" icon=\"bi bi-cart-plus\" (click)=\"userselectionService.addToCart(space,collection,documentId)\"[rounded]=\"true\" [text]=\"true\"></button>\r\n        <button *ngIf=\"documentId && userselectionService.isInCart(space,collection,documentId)\" [disabled]=\"disabled\" pButton pRipple type=\"button\" icon=\"bi bi-cart-dash\" (click)=\"userselectionService.removeFromCart(space,collection,documentId)\"[rounded]=\"true\" [text]=\"true\"></button>\r\n        <button *ngIf=\"!documentId\" [disabled]=\"disabled\" pButton pRipple type=\"button\" icon=\"bi bi-cart-check\" (click)=\"userselectionService.saveCart(space)\"[rounded]=\"true\" [text]=\"true\"></button>\r\n    </div>\r\n</div>", styles: ["button{font-size:1.5em}\n"] }]
    }], () => [{ type: UserselectionService }, { type: i1.ConfigurationService }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], documentId: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CartButtonsComponent, { className: "CartButtonsComponent", filePath: "src/components/cart-buttons/cart-buttons.component.ts", lineNumber: 11 }); })();

function CartHandlerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 3);
    i0.ɵɵlistener("click", function CartHandlerComponent_div_0_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.processCart()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("[", ctx_r1.userselectionService.countCart(ctx_r1.space), "]");
    i0.ɵɵadvance();
    i0.ɵɵproperty("rounded", true)("text", true);
} }
class CartHandlerComponent {
    constructor(router, configService, userselectionService) {
        this.router = router;
        this.configService = configService;
        this.userselectionService = userselectionService;
    }
    showCart() {
        return this.userselectionService.showCart(this.space);
    }
    processCart() {
        this.router.navigate(['/' + this.url + '/' + this.configService.env.currentLang]);
    }
    static { this.ɵfac = function CartHandlerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CartHandlerComponent)(i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(UserselectionService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CartHandlerComponent, selectors: [["cart-handler"]], inputs: { space: "space", url: "url" }, standalone: false, decls: 1, vars: 1, consts: [["class", "userselection-handler align-right", 4, "ngIf"], [1, "userselection-handler", "align-right"], [1, "text-color-primary"], ["pButton", "", "pRipple", "", "type", "button", "icon", "bi bi-cart", 3, "click", "rounded", "text"]], template: function CartHandlerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, CartHandlerComponent_div_0_Template, 4, 3, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showCart());
        } }, dependencies: [i3.NgIf, i7.ButtonDirective], styles: [".userselection-handler[_ngcontent-%COMP%]{display:flex;align-items:center;margin-left:.5em;margin-right:.5em}.userselection-handler[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-top:8px}.userselection-handler[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{font-size:medium;width:36px!important;height:36px!important}.userselection-handler[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-size:small}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartHandlerComponent, [{
        type: Component,
        args: [{ selector: 'cart-handler', standalone: false, template: "<div class=\"userselection-handler align-right\" *ngIf=\"showCart()\">\r\n    <span class=\"text-color-primary\">[{{userselectionService.countCart(this.space)}}]</span>\r\n    <button pButton pRipple type=\"button\" icon=\"bi bi-cart\" (click)=\"processCart()\"[rounded]=\"true\" [text]=\"true\"></button>\r\n</div>", styles: [".userselection-handler{display:flex;align-items:center;margin-left:.5em;margin-right:.5em}.userselection-handler span{margin-top:8px}.userselection-handler>button{font-size:medium;width:36px!important;height:36px!important}.userselection-handler>span{font-size:small}\n"] }]
    }], () => [{ type: i2.Router }, { type: i1.ConfigurationService }, { type: UserselectionService }], { space: [{
            type: Input
        }], url: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CartHandlerComponent, { className: "CartHandlerComponent", filePath: "src/components/cart/cart-handler/cart-handler.component.ts", lineNumber: 12 }); })();

const _c0$c = a0 => [a0];
function CartComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6)(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("common.loading"));
} }
function CartComponent_div_1_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th")(2, "h6", 13);
    i0.ɵɵtext(3, "Name");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "th")(5, "h6", 13);
    i0.ɵɵtext(6, "Collections");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "th")(8, "h6", 13);
    i0.ɵɵtext(9, "Query");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "th")(11, "h6", 13);
    i0.ɵɵtext(12, "Filters");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "th")(14, "h6", 13);
    i0.ɵɵtext(15, "Options");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(16, "th");
    i0.ɵɵelementEnd();
} }
function CartComponent_div_1_ng_template_7_tr_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "span", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const filter_r3 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", filter_r3.key, ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(filter_r3.value);
} }
function CartComponent_div_1_ng_template_7_tr_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "span", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r4 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", option_r4.key, ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(option_r4.value);
} }
function CartComponent_div_1_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "a", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td")(9, "table", 15);
    i0.ɵɵtemplate(10, CartComponent_div_1_ng_template_7_tr_10_Template, 6, 2, "tr", 16);
    i0.ɵɵpipe(11, "keys");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "td")(13, "table", 15);
    i0.ɵɵtemplate(14, CartComponent_div_1_ng_template_7_tr_14_Template, 6, 2, "tr", 16);
    i0.ɵɵpipe(15, "keys");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "td", 17)(17, "button", 18);
    i0.ɵɵlistener("click", function CartComponent_div_1_ng_template_7_Template_button_click_17_listener() { const request_r5 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.removeRequestFromList(request_r5.name)); });
    i0.ɵɵelement(18, "i", 19);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const request_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(11, _c0$c, ctx_r0.userselectionService.getSearchUrl(ctx_r0.space, request_r5.searchRequest)))("queryParams", ctx_r0.userselectionService.getSearchQueryParams(request_r5.searchRequest));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(request_r5.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", request_r5.searchRequest == null ? null : request_r5.searchRequest.collections == null ? null : request_r5.searchRequest.collections.toString(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", request_r5.searchRequest == null ? null : request_r5.searchRequest.q, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(11, 7, request_r5.searchRequest == null ? null : request_r5.searchRequest.f));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(15, 9, request_r5.searchRequest == null ? null : request_r5.searchRequest.o));
} }
function CartComponent_div_1_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th")(2, "h6", 13);
    i0.ɵɵtext(3, "Collection");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "th")(5, "h6", 13);
    i0.ɵɵtext(6, "Items");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "th");
    i0.ɵɵelementEnd();
} }
function CartComponent_div_1_ng_template_14_p_tag_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-tag", 22)(1, "div", 23)(2, "a", 24);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 25);
    i0.ɵɵlistener("click", function CartComponent_div_1_ng_template_14_p_tag_4_Template_a_click_4_listener() { const i_r8 = i0.ɵɵrestoreView(_r7).index; const id_r9 = i0.ɵɵnextContext().$implicit; const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.removeSelectionFromList("cart", id_r9.collection, i_r8)); });
    i0.ɵɵelement(5, "i", 26);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ids_r10 = ctx.$implicit;
    const id_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c0$c, "/" + ctx_r0.space + "/" + id_r9.collection + "/" + ids_r10 + "/" + ctx_r0.configService.env.currentLang));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ids_r10);
} }
function CartComponent_div_1_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, CartComponent_div_1_ng_template_14_p_tag_4_Template, 6, 4, "p-tag", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 17)(6, "button", 18);
    i0.ɵɵlistener("click", function CartComponent_div_1_ng_template_14_Template_button_click_6_listener() { const id_r9 = i0.ɵɵrestoreView(_r6).$implicit; const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.removeSelectionFromList("cart", id_r9.collection)); });
    i0.ɵɵelement(7, "i", 19);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const id_r9 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(id_r9.collection);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", id_r9.documentIds);
} }
function CartComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "h6");
    i0.ɵɵtext(3, "Your searches");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 9)(5, "p-table", 10);
    i0.ɵɵtemplate(6, CartComponent_div_1_ng_template_6_Template, 17, 0, "ng-template", 11)(7, CartComponent_div_1_ng_template_7_Template, 19, 13, "ng-template", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 9)(9, "h6");
    i0.ɵɵtext(10, "Your selections");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 9)(12, "p-table", 10);
    i0.ɵɵtemplate(13, CartComponent_div_1_ng_template_13_Template, 8, 0, "ng-template", 11)(14, CartComponent_div_1_ng_template_14_Template, 8, 2, "ng-template", 12);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("value", ctx_r0.filterItems("searches"))("paginator", true)("rows", 5);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("value", ctx_r0.filterItems("selectionList"))("paginator", true)("rows", 10);
} }
function CartComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "p-button", 28);
    i0.ɵɵlistener("click", function CartComponent_div_2_Template_p_button_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.cleanupCart()); });
    i0.ɵɵelementEnd()();
} }
class CartComponent {
    constructor(route, searchService, confirmationService, configService, router, loggingService, formDataService, userselectionService) {
        this.route = route;
        this.searchService = searchService;
        this.confirmationService = confirmationService;
        this.configService = configService;
        this.router = router;
        this.loggingService = loggingService;
        this.formDataService = formDataService;
        this.userselectionService = userselectionService;
        this.loading = false;
        this.pageReady = false;
    }
    ngOnInit() {
        this.route.params.subscribe(params => {
            this.space = params['space'] || this.configService.env.space;
            this.userselectionService.initCart(this.space, "cart", () => {
                this.pageReady = true;
            });
        });
    }
    ngOnDestroy() {
    }
    save() {
        this.userselectionService.saveCart(this.space, () => {
            this.confirmationService.confirm({
                message: 'Selections saved correctly',
                key: 'userselection-popup',
                acceptLabel: 'Ok',
                rejectVisible: false
            });
        });
    }
    cleanupCart() {
        this.confirmationService.confirm({
            message: 'Do you want to clean the userselection?',
            key: 'userselection-popup',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            accept: () => {
                this.userselectionService.cleanupCart(this.space);
            }
        });
    }
    getCoordinates(coordinates) {
        if (coordinates) {
            return JSON.stringify(coordinates);
        }
        else {
            return "";
        }
    }
    goToList(name) {
        this.router.navigate([], {
            fragment: name
        });
    }
    removeSelectionFromList(type, collection, index) {
        this.confirmationService.confirm({
            message: 'Do you want to remove the selection from the list?',
            key: 'userselection-popup',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            accept: () => {
                this.userselectionService.removeSelectionFromList(this.space, type, collection, index);
            },
            reject: () => {
            }
        });
    }
    removeRequestFromList(name) {
        this.confirmationService.confirm({
            message: 'Do you want to remove the request ' + name + ' and the corresponding items from the list?',
            key: 'userselection-popup',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            accept: () => {
                this.userselectionService.removeRequestFromList(this.space, name);
            },
            reject: () => {
            }
        });
    }
    filterItems(type) {
        let items = this.userselectionService.getUserselections(this.space).filter(item => item.document?.type === "cart");
        if (items.length > 0) {
            console.log(items[0].document[type]);
            return items[0].document[type];
        }
        else {
            return [];
        }
    }
    static { this.ɵfac = function CartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CartComponent)(i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i1.LoggingService), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(UserselectionService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CartComponent, selectors: [["app-cart"]], standalone: false, decls: 5, vars: 3, consts: [["class", "row spinner", 4, "ngIf"], ["class", "row userselection", 4, "ngIf"], ["class", "buttons-toolbar", 4, "ngIf"], ["header", "Warning", "icon", "pi pi-exclamation-triangle", "key", "userselection-popup"], [1, "row", "spinner"], [1, "col-md-12", "mb-3", "align-center"], ["role", "status", 1, "spinner-border"], [1, "sr-only"], [1, "row", "userselection"], [1, "col-md-12", "mb-3"], [3, "value", "paginator", "rows"], ["pTemplate", "header"], ["pTemplate", "body"], [1, "title-category"], [3, "routerLink", "queryParams"], [1, "filter-table"], [4, "ngFor", "ngForOf"], [1, "align-right"], ["title", "Remove item", "type", "button", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-trash"], [1, "filter-label"], ["class", "selection-item", "severity", "secondary", 4, "ngFor", "ngForOf"], ["severity", "secondary", 1, "selection-item"], [1, "flex-content"], [1, "selection-item-label", 3, "routerLink"], [3, "click"], [1, "bi", "bi-x-lg"], [1, "buttons-toolbar"], ["icon", "bi bi-trash", "severity", "danger", "label", "Empty selections", 3, "click"]], template: function CartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, CartComponent_div_0_Template, 5, 1, "div", 0)(1, CartComponent_div_1_Template, 15, 6, "div", 1)(2, CartComponent_div_2_Template, 2, 0, "div", 2);
            i0.ɵɵelement(3, "p-toast")(4, "p-confirmDialog", 3);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.pageReady);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.pageReady);
        } }, dependencies: [i3.NgForOf, i3.NgIf, i2.RouterLink, i3$2.PrimeTemplate, i5$1.ConfirmDialog, i8.Table, i7.Button, i7$1.Toast, i11.Tag, KeysPipe], styles: [".userselection-list[_ngcontent-%COMP%]{border-top:solid 1px var(--default-border-color);margin-left:0;margin-right:0}.userselection-list-item[_ngcontent-%COMP%]{padding:.65em}a[_ngcontent-%COMP%]{margin-top:.5em;display:block}.filter-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding-right:1em}.filter-table[_ngcontent-%COMP%]   .filter-label[_ngcontent-%COMP%]{font-weight:600;font-variant:all-small-caps}.selection-item[_ngcontent-%COMP%]{margin-right:.5em;margin-bottom:.5em;display:inline-block}.selection-item-label[_ngcontent-%COMP%]{margin-right:.5em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartComponent, [{
        type: Component,
        args: [{ selector: 'app-cart', standalone: false, template: "<div class=\"row spinner\" *ngIf=\"loading\">\r\n    <div class=\"col-md-12 mb-3 align-center\">\r\n      <div class=\"spinner-border\" role=\"status\">\r\n        <span class=\"sr-only\">{{ configService.getTranslation('common.loading')}}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  \r\n  <div class=\"row userselection\" *ngIf=\"pageReady\">\r\n    <div class=\"col-md-12 mb-3\">\r\n      <h6>Your searches</h6>\r\n    </div>\r\n    <div class=\"col-md-12 mb-3\">\r\n\r\n      <p-table\r\n          [value]=\"filterItems('searches')\"\r\n          [paginator]=\"true\"\r\n          [rows]=\"5\"\r\n      >\r\n        <ng-template pTemplate=\"header\">\r\n          <tr>\r\n              <th><h6 class=\"title-category\">Name</h6></th>\r\n              <th><h6 class=\"title-category\">Collections</h6></th>\r\n              <th><h6 class=\"title-category\">Query</h6></th>\r\n              <th><h6 class=\"title-category\">Filters</h6></th>\r\n              <th><h6 class=\"title-category\">Options</h6></th>\r\n              <th></th>\r\n          </tr>\r\n        </ng-template>\r\n          <ng-template pTemplate=\"body\" let-request>\r\n              <tr>\r\n                <td>\r\n                  <a [routerLink]=\"[userselectionService.getSearchUrl(space,request.searchRequest)]\" [queryParams]=\"userselectionService.getSearchQueryParams(request.searchRequest)\">{{request.name}}</a>\r\n                </td>\r\n                <td>\r\n                  {{ request.searchRequest?.collections?.toString() }}\r\n                </td>\r\n                <td>\r\n                  {{ request.searchRequest?.q }}\r\n                </td>\r\n                <td>\r\n                  <table class=\"filter-table\">\r\n                    <tr *ngFor=\"let filter of request.searchRequest?.f | keys\">\r\n                      <td><span class=\"filter-label\">{{ filter.key }}:</span></td><td>{{ filter.value }}</td>\r\n                    </tr>\r\n                  </table>\r\n                </td>\r\n                <td>\r\n                  <table class=\"filter-table\">\r\n                    <tr *ngFor=\"let option of request.searchRequest?.o | keys\">\r\n                      <td><span class=\"filter-label\">{{ option.key }}:</span></td><td>{{ option.value }}</td>\r\n                    </tr>\r\n                  </table>                  \r\n                </td>\r\n                <td class=\"align-right\">\r\n                  <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n                    (click)=\"removeRequestFromList(request.name)\">\r\n                    <i class=\"bi bi-trash\"></i>\r\n                  </button>\r\n                </td>\r\n              </tr>\r\n          </ng-template>\r\n      </p-table>\r\n    </div>\r\n    <div class=\"col-md-12 mb-3\">\r\n      <h6>Your selections</h6>\r\n    </div>\r\n    <div class=\"col-md-12 mb-3\">\r\n      <p-table\r\n              [value]=\"filterItems('selectionList')\"\r\n              [paginator]=\"true\"\r\n              [rows]=\"10\"\r\n      >\r\n        <ng-template pTemplate=\"header\">\r\n          <tr>\r\n              <th><h6 class=\"title-category\">Collection</h6></th>\r\n              <th><h6 class=\"title-category\">Items</h6></th>\r\n              <th></th>\r\n          </tr>\r\n        </ng-template>\r\n          <ng-template pTemplate=\"body\" let-id>\r\n              <tr>\r\n                <td>{{ id.collection }}</td>\r\n                <td>\r\n                  <p-tag *ngFor=\"let ids of id.documentIds; let i = index;\" class=\"selection-item\" severity=\"secondary\">\r\n                    <div class=\"flex-content\">\r\n                      <a class=\"selection-item-label\" [routerLink]=\"['/' + space + '/' + id.collection + '/' + ids + '/' + this.configService.env.currentLang]\">{{ ids }}</a>\r\n                      <a (click)=\"removeSelectionFromList('cart',id.collection,i)\">\r\n                        <i class=\"bi bi-x-lg\"></i>\r\n                      </a>\r\n                    </div>\r\n                  </p-tag>\r\n                </td>\r\n                <td class=\"align-right\">\r\n                  <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n                    (click)=\"removeSelectionFromList('cart',id.collection)\">\r\n                    <i class=\"bi bi-trash\"></i>\r\n                  </button>\r\n                </td>\r\n              </tr>\r\n          </ng-template>\r\n      </p-table>\r\n    </div>\r\n  </div>\r\n  \r\n  <div *ngIf=\"pageReady\" class=\"buttons-toolbar\">\r\n    <p-button icon=\"bi bi-trash\" severity=\"danger\" label=\"Empty selections\" (click)=\"cleanupCart()\"></p-button>\r\n  </div>\r\n  \r\n  <p-toast></p-toast>\r\n  <p-confirmDialog header=\"Warning\" icon=\"pi pi-exclamation-triangle\" key=\"userselection-popup\"></p-confirmDialog>", styles: [".userselection-list{border-top:solid 1px var(--default-border-color);margin-left:0;margin-right:0}.userselection-list-item{padding:.65em}a{margin-top:.5em;display:block}.filter-table td{padding-right:1em}.filter-table .filter-label{font-weight:600;font-variant:all-small-caps}.selection-item{margin-right:.5em;margin-bottom:.5em;display:inline-block}.selection-item-label{margin-right:.5em}\n"] }]
    }], () => [{ type: i2.ActivatedRoute }, { type: i1.SearchService }, { type: i3$2.ConfirmationService }, { type: i1.ConfigurationService }, { type: i2.Router }, { type: i1.LoggingService }, { type: FormDataService }, { type: UserselectionService }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CartComponent, { className: "CartComponent", filePath: "src/components/cart/cart/cart.component.ts", lineNumber: 14 }); })();

function DebugInfoComponent_div_0_p_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 8);
    i0.ɵɵlistener("click", function DebugInfoComponent_div_0_p_button_5_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.debugCollapsed = !ctx_r1.debugCollapsed); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("text", true);
} }
function DebugInfoComponent_div_0_p_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 9);
    i0.ɵɵlistener("click", function DebugInfoComponent_div_0_p_button_6_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.debugCollapsed = !ctx_r1.debugCollapsed); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("text", true);
} }
function DebugInfoComponent_div_0_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 10)(2, "div", 13, 0)(4, "button", 14);
    i0.ɵɵelement(5, "i", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "h6");
    i0.ɵɵtext(7, "Url");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 10)(11, "div", 13, 0)(13, "button", 14);
    i0.ɵɵelement(14, "i", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "h6");
    i0.ɵɵtext(16, "Payload");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div");
    i0.ɵɵelement(18, "ngx-json-viewer", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 17)(20, "div", 13, 0)(22, "button", 14);
    i0.ɵɵelement(23, "i", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "h6");
    i0.ɵɵtext(25, "Response");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div");
    i0.ɵɵelement(27, "ngx-json-viewer", 18);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const container_r5 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("cbContent", ctx_r1.stringify(item_r4.value["url"]))("container", container_r5);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(item_r4.value["url"]);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("cbContent", ctx_r1.stringify(item_r4.value["payload"]))("container", container_r5);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("json", item_r4.value["payload"]);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("cbContent", ctx_r1.stringify(item_r4.value["response"]))("container", container_r5);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("json", item_r4.value["response"])("expanded", false);
} }
function DebugInfoComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, DebugInfoComponent_div_0_div_7_div_1_Template, 28, 10, "div", 11);
    i0.ɵɵpipe(2, "keyvalue");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.debugData));
} }
function DebugInfoComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "h6");
    i0.ɵɵtext(3, "Debug info");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtemplate(5, DebugInfoComponent_div_0_p_button_5_Template, 1, 2, "p-button", 5)(6, DebugInfoComponent_div_0_p_button_6_Template, 1, 2, "p-button", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, DebugInfoComponent_div_0_div_7_Template, 3, 3, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.debugCollapsed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.debugCollapsed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.debugCollapsed);
} }
class DebugInfoComponent {
    constructor(route, configService) {
        this.route = route;
        this.configService = configService;
        this.debugCollapsed = true;
    }
    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            if (params.debug !== undefined) {
                this.configService.env.debug = JSON.parse(params.debug);
            }
        });
    }
    stringify(value) {
        return JSON.stringify(value);
    }
    static { this.ɵfac = function DebugInfoComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DebugInfoComponent)(i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DebugInfoComponent, selectors: [["debug-info"]], inputs: { debugData: "debugData" }, standalone: false, decls: 1, vars: 1, consts: [["container", ""], ["class", "row debug-info", 4, "ngIf"], [1, "row", "debug-info"], [1, "col-md-10"], [1, "col-md-2", "align-right"], ["icon", "pi pi-arrow-down", 3, "rounded", "text", "click", 4, "ngIf"], ["icon", "pi pi-arrow-up", 3, "rounded", "text", "click", 4, "ngIf"], ["class", "col-md-12 mb-3", 4, "ngIf"], ["icon", "pi pi-arrow-down", 3, "click", "rounded", "text"], ["icon", "pi pi-arrow-up", 3, "click", "rounded", "text"], [1, "col-md-12", "mb-3"], ["class", "row", 4, "ngFor", "ngForOf"], [1, "row"], [1, "clipboard-button"], ["type", "button", "ngxClipboard", "", 1, "btn", "btn-link", 3, "cbContent", "container"], [1, "bi", "bi-clipboard"], [3, "json"], [1, "col-md-12"], [3, "json", "expanded"]], template: function DebugInfoComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DebugInfoComponent_div_0_Template, 8, 3, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.configService.env.debug);
        } }, dependencies: [i3.NgForOf, i3.NgIf, i4.NgxJsonViewerComponent, i3$1.ClipboardDirective, i7.Button, i3.KeyValuePipe], styles: [".debug-info[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{align-content:center}.debug-info[_ngcontent-%COMP%]{background-color:var(--secondary-background-color);margin:.1em;border-radius:5px}.debug-info[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{word-wrap:break-word;font-size:.9em}.clipboard-button[_ngcontent-%COMP%]{float:left!important}.clipboard-button[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:25px!important;height:20px!important;padding:0!important;margin:0!important;font-size:.8em!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DebugInfoComponent, [{
        type: Component,
        args: [{ selector: 'debug-info', standalone: false, template: "<div class=\"row debug-info\" *ngIf=\"configService.env.debug\">\r\n    <div class=\"col-md-10\">\r\n        <h6>Debug info</h6>\r\n    </div>\r\n    <div class=\"col-md-2 align-right\">\r\n        <p-button *ngIf=\"debugCollapsed\" icon=\"pi pi-arrow-down\" [rounded]=\"true\" [text]=\"true\" (click)=\"debugCollapsed = !debugCollapsed\"></p-button>\r\n        <p-button *ngIf=\"!debugCollapsed\" icon=\"pi pi-arrow-up\" [rounded]=\"true\" [text]=\"true\" (click)=\"debugCollapsed = !debugCollapsed\"></p-button>\r\n    </div>\r\n    <div class=\"col-md-12 mb-3\" *ngIf=\"!debugCollapsed\">\r\n        <div class=\"row\" *ngFor=\"let item of debugData | keyvalue\">\r\n            <div class=\"col-md-12 mb-3\">\r\n                <div #container class=\"clipboard-button\">\r\n                    <button type=\"button\" class=\"btn btn-link\" ngxClipboard [cbContent]=\"stringify(item.value['url'])\" [container]=\"container\"><i class=\"bi bi-clipboard\"></i></button>\r\n                </div>\r\n                <h6>Url</h6>\r\n                <span>{{ item.value['url'] }}</span>\r\n            </div>\r\n            <div class=\"col-md-12 mb-3\">\r\n                <div #container class=\"clipboard-button\">\r\n                    <button type=\"button\" class=\"btn btn-link\" ngxClipboard [cbContent]=\"stringify(item.value['payload'])\" [container]=\"container\"><i class=\"bi bi-clipboard\"></i></button>\r\n                </div>\r\n                <h6>Payload</h6>\r\n                <div>\r\n                    <ngx-json-viewer [json]=\"item.value['payload']\"></ngx-json-viewer>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-md-12\">\r\n                <div #container class=\"clipboard-button\">\r\n                    <button type=\"button\" class=\"btn btn-link\" ngxClipboard [cbContent]=\"stringify(item.value['response'])\" [container]=\"container\"><i class=\"bi bi-clipboard\"></i></button>\r\n                </div>\r\n                <h6>Response</h6>\r\n                <div>\r\n                    <ngx-json-viewer [json]=\"item.value['response']\" [expanded]=\"false\"></ngx-json-viewer>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>", styles: [".debug-info div{align-content:center}.debug-info{background-color:var(--secondary-background-color);margin:.1em;border-radius:5px}.debug-info span{word-wrap:break-word;font-size:.9em}.clipboard-button{float:left!important}.clipboard-button button{width:25px!important;height:20px!important;padding:0!important;margin:0!important;font-size:.8em!important}\n"] }]
    }], () => [{ type: i2.ActivatedRoute }, { type: i1.ConfigurationService }], { debugData: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DebugInfoComponent, { className: "DebugInfoComponent", filePath: "src/components/debug-info/debug-info.component.ts", lineNumber: 11 }); })();

function ChartComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "div", 8);
    i0.ɵɵelement(3, "span", 9);
    i0.ɵɵelementEnd()()();
} }
HC_exporting(Highcharts);
HC_nodata(Highcharts);
class ChartComponent {
    constructor(searchService, chartService, configService) {
        this.searchService = searchService;
        this.chartService = chartService;
        this.configService = configService;
        this.componentReady = true;
        this.loading = true;
        this.showHelp = false;
        this.debugData = {};
    }
    ngOnInit() {
        this.initChart();
    }
    initChart() {
        this.initOptions();
        if (!this.definition) {
            this.componentReady = false;
            this.loading = false;
            return;
        }
        if (!this.definition.series) {
            this.componentReady = false;
            this.loading = false;
            return;
        }
        if (!this.title && this.definition.titles && (this.definition.titles[this.configService.env.currentLang] || this.definition.titles[this.configService.env.defaultLang])) {
            this.title = this.definition.titles[this.configService.env.currentLang] || this.definition.titles[this.configService.env.defaultLang];
        }
        this.extractData();
    }
    extractData() {
        let requests = [];
        for (let i = 0; i < this.definition.series.length; i++) {
            if (this.code) {
                this.definition.series[i].payload.code = this.code;
            }
            requests.push(this.searchService.post(this.definition.series[i].url, this.definition.series[i].payload));
            this.debugData[i] = {
                url: this.definition.series[i].url,
                payload: this.definition.series[i].payload
            };
        }
        forkJoin$1(requests).subscribe((res) => {
            for (let i = 0; i < res.length; i++) {
                this.debugData[i].response = res[i];
            }
            if (this.definition.transformData) {
                this.options = ChartComponent.transformDataSingleSeriesAggregated(this.options, res, this.definition, this.configService.env.currentLang, this.configService.env.defaultLang);
            }
            else if (this.definition.transformDataCallback) {
                this.options = this.definition.transformDataCallback(this.options, res, this.definition, this.configService.env.currentLang, this.configService.env.defaultLang);
            }
            else {
                this.data = this.data.map(obj => {
                    obj.type = this.options.chart.type;
                    return obj;
                });
                this.options.series = this.data;
                if (!this.definition.titles) {
                    this.options.title = { text: '', style: { fontWeight: 500, fontSize: "1em" } };
                }
            }
            if (!this.definition.titles) {
                this.options.title = { text: '', style: { fontWeight: 500, fontSize: "1em" } };
            }
            else {
                this.options.title = { text: this.definition.titles[this.configService.env.currentLang], style: { fontWeight: 500, fontSize: "1em" } };
            }
            //If results list is not empty, I can show the chart
            if (this.options.series && this.options.series.length > 0) {
                Highcharts.chart(this.code, this.options, function (chart) {
                    if (this.options.series.length === 0) {
                        chart.renderer.text('No Data Available', 140, 120)
                            .css({
                            color: '#4572A7',
                            fontSize: '16px'
                        })
                            .add();
                    }
                });
                this.loading = false;
            }
            else {
                this.componentReady = false;
                this.loading = false;
            }
        }, (err) => {
            this.componentReady = false;
            this.loading = false;
        });
    }
    initOptions() {
        this.options = this.options || this.chartService.getChartOptions();
        if (!this.options.xAxis) {
            this.options.xAxis = {};
        }
        if (!this.options.yAxis) {
            this.options.yAxis = {};
        }
        if (!this.options.xAxis.title) {
            this.options.xAxis.title = {
                text: ""
            };
        }
        if (!this.options.yAxis.title) {
            this.options.yAxis.title = {
                text: ""
            };
        }
        if (!this.options.colors) {
            this.options.colors = this.configService.themes[this.configService.env.theme].palette;
        }
        if (this.definition.xAxis.labels) {
            this.options.xAxis.title.text = this.definition.xAxis.labels[this.configService.env.currentLang] || this.definition.xAxis.labels[this.configService.env.defaultLang];
        }
        else {
            this.options.xAxis.title.text = this.definition.xAxis.field;
        }
        if (this.definition.yAxis.labels) {
            this.options.yAxis.title.text = this.definition.yAxis.labels[this.configService.env.currentLang] || this.definition.yAxis.labels[this.configService.env.defaultLang];
        }
        else {
            this.options.yAxis.title.text = this.definition.yAxis.field;
        }
        this.options.xAxis.categories = [];
        this.options.series = [];
    }
    static transformDataSingleSeriesAggregated(options, results, definition, currentLang, defaultLang) {
        let data = [];
        for (let i = 0; i < results.length; i++) {
            //Verify if results exist, in case they don't exist I initialize the object as empty array
            if (!results[i].results) {
                results[i].results = {};
            }
            if (!results[i]?.results.aggregations) {
                results[i].results.aggregations = [];
            }
            if (results[i].results.aggregations.length > 0) {
                //For the union of query results, each one must be identified by a series
                results[i].results.aggregations[0].results = results[i].results.aggregations[0].results.map((obj) => {
                    //If there isn't a property with the series identifier, I add it to be able to group results
                    obj[definition.seriesField] = obj[definition.seriesField] || definition.series[i].name;
                    return obj;
                });
                results[i].results.aggregations[0].results = results[i].results.aggregations[0].results.sort((e1, e2) => {
                    return (e1[definition.xAxis.field] < e2[definition.xAxis.field] ? -1 : (e1[definition.xAxis.field] > e2[definition.xAxis.field] ? 1 : 0));
                });
                if (definition.mapping && definition.mapping.length > 0) {
                    let items = results[i].results.aggregations[0].results.map(obj => {
                        let item = {};
                        for (let key in obj) {
                            let mps = definition.mapping.filter(m => m.key === obj[key]);
                            if (mps.length > 0) {
                                item[key] = mps[0].label;
                            }
                            else {
                                item[key] = obj[key];
                            }
                        }
                        return item;
                    });
                    data = data.concat(items);
                }
                else {
                    //Conctenation of the series results
                    data = data.concat(results[i].results.aggregations[0].results);
                }
            }
        }
        let series = {};
        for (let i = 0; i < data.length; i++) {
            if (options.xAxis.categories.findIndex(item => item === data[i][definition.xAxis.field]) < 0) {
                options.xAxis.categories.push(data[i][definition.xAxis.field]);
            }
            if (definition.seriesField) {
                if (!series[data[i][definition.seriesField]]) {
                    series[data[i][definition.seriesField]] = {
                        name: data[i][definition.seriesField],
                        data: []
                    };
                }
                if (data[i][definition.yAxis.field]) {
                    series[data[i][definition.seriesField]].data.push(data[i][definition.yAxis.field]);
                }
            }
            else {
                if (!series.default) {
                    series.default = {
                        name: 'default',
                        data: []
                    };
                }
                if (data[i][definition.yAxis.field]) {
                    series.default.data.push(data[i][definition.yAxis.field]);
                }
            }
        }
        if (data.length === 0) {
            series.default = {
                name: 'default',
                data: []
            };
        }
        for (let key in series) {
            options.series.push({
                name: series[key].name,
                data: series[key].data
            });
        }
        if (definition.type == 'column') {
            options.plotOptions.series = {
                stacking: 'normal',
            };
        }
        options.title = {
            text: undefined
        };
        return options;
    }
    static transformDataMultipleSeriesAggregated(options, results, definition, currentLang, defaultLang) {
        let data = [];
        for (let i = 0; i < results.length; i++) {
            if (!results[i].results) {
                results[i].results = {};
            }
            if (!results[i].results.aggregations) {
                results[i].results.aggregations = [];
            }
            results[i].results.aggregations[0].results = results[i].results.aggregations[0].results.map((obj) => {
                for (let x = 0; x < obj.results.length; x++) {
                    obj.results[x][definition.seriesField] = obj.results[x][definition.seriesField] || obj.key;
                }
                obj.results = obj.results.sort((e1, e2) => {
                    return (e1[definition.xAxis.field] < e2[definition.xAxis.field] ? -1 : (e1[definition.xAxis.field] > e2[definition.xAxis.field] ? 1 : 0));
                });
                if (definition.mapping && definition.mapping.length > 0) {
                    let items = obj.results.map(obj => {
                        let item = {};
                        for (let key in obj) {
                            let mps = definition.mapping.filter(m => m.key === obj[key]);
                            if (mps.length > 0) {
                                item[key] = mps[0].label;
                            }
                            else {
                                item[key] = obj[key];
                            }
                        }
                        return item;
                    });
                    data = data.concat(items);
                }
                else {
                    //Conctenation of the series results
                    data = data.concat(obj.results);
                }
                return obj;
            });
        }
        let series = {};
        for (let i = 0; i < data.length; i++) {
            if (options.xAxis.categories.findIndex(item => item === data[i][definition.xAxis.field]) < 0) {
                options.xAxis.categories.push(data[i][definition.xAxis.field]);
            }
            if (definition.seriesField) {
                if (!series[data[i][definition.seriesField]]) {
                    series[data[i][definition.seriesField]] = {
                        name: data[i][definition.seriesField],
                        data: []
                    };
                }
                if (data[i][definition.yAxis.field]) {
                    series[data[i][definition.seriesField]].data.push(data[i][definition.yAxis.field]);
                }
            }
            else {
                if (!series.default) {
                    series.default = {
                        name: 'default',
                        data: []
                    };
                }
                if (data[i][definition.yAxis.field]) {
                    series.default.data.push(data[i][definition.yAxis.field]);
                }
            }
        }
        for (let key in series) {
            options.series.push({
                name: series[key].name,
                data: series[key].data
            });
        }
        if (definition.type == 'column') {
            options.plotOptions.series = {
                stacking: 'normal',
            };
        }
        if (definition.titles) {
            options.title = {
                text: definition.titles[currentLang] || definition.titles[defaultLang]
            };
        }
        return options;
    }
    static { this.ɵfac = function ChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartComponent)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i1.ChartService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChartComponent, selectors: [["chart"]], inputs: { title: "title", code: "code", definition: "definition", options: "options" }, standalone: false, decls: 6, vars: 3, consts: [["class", "row spinner", 4, "ngIf"], [1, "row"], [1, "col-md-12", "mb-3"], [1, "chart-container"], [2, "width", "100%", 3, "id"], [3, "debugData"], [1, "row", "spinner"], [1, "col-md-12", "mb-3", "align-center"], ["role", "status", 1, "spinner-border"], [1, "sr-only"]], template: function ChartComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ChartComponent_div_0_Template, 4, 0, "div", 0);
            i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
            i0.ɵɵelement(4, "div", 4);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(5, "debug-info", 5);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("id", ctx.code);
            i0.ɵɵadvance();
            i0.ɵɵproperty("debugData", ctx.debugData);
        } }, dependencies: [i3.NgIf, DebugInfoComponent], styles: [".mainContainer[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{font-family:Arial;font-size:9pt}.ui-tabs[_ngcontent-%COMP%]   .ui-tabs-panel[_ngcontent-%COMP%]{padding:0!important}.details[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{color:var(--danger-color)}.other[_ngcontent-%COMP%]{display:none}.kChart[_ngcontent-%COMP%]{border:none!important}.highcharts-title[_ngcontent-%COMP%]{font-size:10pt!important}.mainContainer[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:inline-block;vertical-align:top}.tab-content[_ngcontent-%COMP%]{margin-bottom:20px;clear:both}.table-title[_ngcontent-%COMP%]{padding-top:8px;padding-left:10px;margin-bottom:10px;width:530px}.table-title[_ngcontent-%COMP%]   .figis-title[_ngcontent-%COMP%]{font-family:Lucida Grande,Lucida Sans Unicode,Verdana,Arial,Helvetica,sans-serif;font-size:16px;color:var(--default-color);fill:var(--primary-color);display:block;margin-bottom:-6px}.table-title[_ngcontent-%COMP%]   .figis-subtitle[_ngcontent-%COMP%]{white-space:nowrap;font-family:Lucida Grande,Lucida Sans Unicode,Verdana,Arial,Helvetica,sans-serif;font-size:11px;color:var(--secondary-color);margin-left:0;margin-top:10px;margin-bottom:0;display:inline-block}.chart-container[_ngcontent-%COMP%]{padding:10px;width:100%;background-color:var(--default-background-color)}.table-container[_ngcontent-%COMP%]{padding:20px;width:100%;background-color:var(--default-background-color)}.figis-title[_ngcontent-%COMP%]{font-family:Lucida Grande,Lucida Sans Unicode,Verdana,Arial,Helvetica,sans-serif;word-wrap:break-word;white-space:normal;font-size:10pt}.figis-subtitle[_ngcontent-%COMP%]{font-family:Lucida Grande,Lucida Sans Unicode,Verdana,Arial,Helvetica,sans-serif;font-size:8pt;color:var(--secondary-color)}.center[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto;text-align:center}@media screen and (orientation: portrait){.plot[_ngcontent-%COMP%]{width:80vw!important;height:45vh!important}}@media screen and (orientation: landscape){.plot[_ngcontent-%COMP%]{width:80vw!important;height:70vh!important}}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChartComponent, [{
        type: Component,
        args: [{ selector: 'chart', standalone: false, template: "<div class=\"row spinner\" *ngIf=\"loading\">\r\n    <div class=\"col-md-12 mb-3 align-center\">\r\n        <div class=\"spinner-border\" role=\"status\">\r\n            <span class=\"sr-only\"></span>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 mb-3\">\r\n        <div class=\"chart-container\">            \r\n            <div id=\"{{code}}\" style=\"width:100%;\"></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<debug-info [debugData]=\"debugData\"></debug-info>", styles: [".mainContainer *{font-family:Arial;font-size:9pt}.ui-tabs .ui-tabs-panel{padding:0!important}.details h4{color:var(--danger-color)}.other{display:none}.kChart{border:none!important}.highcharts-title{font-size:10pt!important}.mainContainer>div{display:inline-block;vertical-align:top}.tab-content{margin-bottom:20px;clear:both}.table-title{padding-top:8px;padding-left:10px;margin-bottom:10px;width:530px}.table-title .figis-title{font-family:Lucida Grande,Lucida Sans Unicode,Verdana,Arial,Helvetica,sans-serif;font-size:16px;color:var(--default-color);fill:var(--primary-color);display:block;margin-bottom:-6px}.table-title .figis-subtitle{white-space:nowrap;font-family:Lucida Grande,Lucida Sans Unicode,Verdana,Arial,Helvetica,sans-serif;font-size:11px;color:var(--secondary-color);margin-left:0;margin-top:10px;margin-bottom:0;display:inline-block}.chart-container{padding:10px;width:100%;background-color:var(--default-background-color)}.table-container{padding:20px;width:100%;background-color:var(--default-background-color)}.figis-title{font-family:Lucida Grande,Lucida Sans Unicode,Verdana,Arial,Helvetica,sans-serif;word-wrap:break-word;white-space:normal;font-size:10pt}.figis-subtitle{font-family:Lucida Grande,Lucida Sans Unicode,Verdana,Arial,Helvetica,sans-serif;font-size:8pt;color:var(--secondary-color)}.center{margin-left:auto;margin-right:auto;text-align:center}@media screen and (orientation: portrait){.plot{width:80vw!important;height:45vh!important}}@media screen and (orientation: landscape){.plot{width:80vw!important;height:70vh!important}}\n"] }]
    }], () => [{ type: i1.SearchService }, { type: i1.ChartService }, { type: i1.ConfigurationService }], { title: [{
            type: Input
        }], code: [{
            type: Input
        }], definition: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ChartComponent, { className: "ChartComponent", filePath: "src/components/chart/chart.component.ts", lineNumber: 18 }); })();

function CitationComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.corporateAuthor, ".\u00A0");
} }
function CitationComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.corporateCoverTitle, "\u00A0");
} }
function CitationComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r0.coverTitle, "", ctx_r0.reportingYear ? "" : ".", "\u00A0");
} }
function CitationComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.reportingYear, ".\u00A0");
} }
function CitationComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.title, ".\u00A0");
} }
function CitationComponent_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.series, ".\u00A0");
} }
function CitationComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r0.configService.getTranslation("global.citation.textby"), " ", ctx_r0.personalAuthor, ".\u00A0");
} }
function CitationComponent_span_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r0.configService.getTranslation("global.citation.updated"), " ", ctx_r0.updated.modified[ctx_r0.updated.modified.length - 1], "\u00A0");
} }
function CitationComponent_span_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r0.configService.getTranslation("global.citation.updated"), " ", i0.ɵɵpipeBind2(2, 2, ctx_r0.updated, "mediumDate"), "\u00A0");
} }
class CitationComponent {
    constructor(configService) {
        this.configService = configService;
        this.year = new Date().getFullYear();
        this.cited = moment().format('dddd, MMMM Do YYYY');
    }
    ngOnInit() {
        this.url = window.location.href;
        this.updated = this.data.document.dataEntry;
        this.corporateAuthor = this.data.document.objectSource?.corporateCoverPage?.author;
        this.personalAuthor = this.data.document.objectSource && this.data.document.objectSource.coverPage && this.data.document.objectSource.coverPage.creatorPersonal ? this.data.document.objectSource.coverPage.creatorPersonal : '';
        this.corporateCoverTitle = this.data.document.objectSource && this.data.document.objectSource?.corporateCoverPage ? (this.data.document.objectSource?.corporateCoverPage['name_' + this.configService.env.currentLang] || this.data.document.objectSource?.corporateCoverPage['name_' + this.configService.env.defaultLang]) : '';
        this.series = this.data.document.objectSource && this.data.document.objectSource.corporateCoverPage ? (this.data.document.objectSource.corporateCoverPage['series_' + this.configService.env.currentLang] || this.data.document.objectSource.corporateCoverPage['series_' + this.configService.env.defaultLang]) : '';
    }
    isString(value) {
        return typeof (value) === 'string';
    }
    static { this.ɵfac = function CitationComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CitationComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CitationComponent, selectors: [["citation"]], inputs: { title: "title", data: "data", reportingYear: "reportingYear", updated: "updated" }, standalone: false, decls: 27, vars: 18, consts: [[1, "citation"], [1, "bold"], ["id", "corporateAuthor", 4, "ngIf"], ["id", "corporateCoverTitle", 4, "ngIf"], ["id", "coverTitle", 4, "ngIf"], ["id", "reportingYear", 4, "ngIf"], ["id", "title", 4, "ngIf"], ["id", "series", 4, "ngIf"], ["id", "personalAuthor", 4, "ngIf"], [4, "ngIf"], [3, "href"], ["id", "corporateAuthor"], ["id", "corporateCoverTitle"], ["id", "coverTitle"], ["id", "reportingYear"], ["id", "title"], ["id", "series"], ["id", "personalAuthor"]], template: function CitationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "span", 1);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "div")(5, "div")(6, "span");
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, CitationComponent_span_8_Template, 2, 1, "span", 2)(9, CitationComponent_span_9_Template, 2, 1, "span", 3)(10, CitationComponent_span_10_Template, 2, 2, "span", 4)(11, CitationComponent_span_11_Template, 2, 1, "span", 5)(12, CitationComponent_span_12_Template, 2, 1, "span", 6)(13, CitationComponent_span_13_Template, 2, 1, "span", 7)(14, CitationComponent_span_14_Template, 2, 2, "span", 8);
            i0.ɵɵelementStart(15, "span");
            i0.ɵɵtext(16);
            i0.ɵɵelementStart(17, "i");
            i0.ɵɵtext(18);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(19);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(20, CitationComponent_span_20_Template, 2, 2, "span", 9)(21, CitationComponent_span_21_Template, 3, 5, "span", 9);
            i0.ɵɵelementStart(22, "span");
            i0.ɵɵtext(23);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "p")(25, "a", 10);
            i0.ɵɵtext(26);
            i0.ɵɵelementEnd()()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", ctx.configService.getTranslation("global.citation.text"), ": ");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("\u00A9\u00A0FAO. ", ctx.year, ".\u00A0");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.corporateAuthor);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.corporateCoverTitle);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.coverTitle);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.reportingYear);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.series);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.personalAuthor);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", ctx.configService.getTranslation("global.citation.in"), ": ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.configService.getTranslation("global.citation.division"));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" [", ctx.configService.getTranslation("global.citation.online"), "].\u00A0");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.updated && ctx.updated.modified);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.updated && ctx.isString(ctx.updated));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate2("[", ctx.configService.getTranslation("global.citation.cited"), " ", ctx.cited, "].\u00A0");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("href", ctx.url, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.url);
        } }, dependencies: [i3.NgIf, i3.DatePipe], styles: [".citation[_ngcontent-%COMP%]{background-color:var(--bg-primary-light);border-radius:5px;padding:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CitationComponent, [{
        type: Component,
        args: [{ selector: 'citation', standalone: false, template: "<div class=\"citation\">\r\n  <div>\r\n      <span class=\"bold\">{{configService.getTranslation('global.citation.text')}}: </span>\r\n    </div>\r\n  <div>\r\n      <div>\r\n          <span>&copy;&nbsp;FAO. {{year}}.&nbsp;</span>\r\n          <span id=\"corporateAuthor\" *ngIf=\"corporateAuthor\">{{corporateAuthor}}.&nbsp;</span>\r\n          <span id=\"corporateCoverTitle\" *ngIf=\"corporateCoverTitle\">{{corporateCoverTitle}}&nbsp;</span>\r\n          <span id=\"coverTitle\" *ngIf=\"coverTitle\">{{coverTitle}}{{ reportingYear ? \"\" : \".\" }}&nbsp;</span>\r\n          <span id=\"reportingYear\" *ngIf=\"reportingYear\">{{reportingYear}}.&nbsp;</span>\r\n          <span id=\"title\" *ngIf=\"title\">{{title}}.&nbsp;</span>\r\n          <span id=\"series\" *ngIf=\"series\">{{series}}.&nbsp;</span>\r\n          <span id=\"personalAuthor\" *ngIf=\"personalAuthor\">{{configService.getTranslation('global.citation.textby')}} {{personalAuthor}}.&nbsp;</span>\r\n          <span>{{configService.getTranslation('global.citation.in')}}: <i>{{configService.getTranslation('global.citation.division')}}</i> [{{configService.getTranslation('global.citation.online')}}].&nbsp;</span>\r\n          <!-- <span>{{configService.getTranslation('global.citation.rome')}}.&nbsp;</span> -->\r\n          <span *ngIf=\"updated && updated.modified\">{{configService.getTranslation('global.citation.updated')}} {{updated.modified[updated.modified.length-1]}}&nbsp;</span>\r\n          <span *ngIf=\"updated && isString(updated)\">{{configService.getTranslation('global.citation.updated')}} {{ updated | date:'mediumDate'}}&nbsp;</span>\r\n          <span>[{{configService.getTranslation('global.citation.cited')}} {{cited}}].&nbsp;</span>\r\n          <p><a [href]=\"url\">{{url}}</a></p>            \r\n      </div>\r\n  </div>\r\n</div>\r\n", styles: [".citation{background-color:var(--bg-primary-light);border-radius:5px;padding:1em}\n"] }]
    }], () => [{ type: i1.ConfigurationService }], { title: [{
            type: Input
        }], data: [{
            type: Input
        }], reportingYear: [{
            type: Input
        }], updated: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CitationComponent, { className: "CitationComponent", filePath: "src/components/citation/citation.component.ts", lineNumber: 11 }); })();

function CollectionNavigatorComponent_h5_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h5", 5)(1, "a", 6);
    i0.ɵɵlistener("click", function CollectionNavigatorComponent_h5_2_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.location.back()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.title);
} }
class CollectionNavigatorComponent {
    constructor(configService, route, location) {
        this.configService = configService;
        this.route = route;
        this.location = location;
    }
    ngOnInit() {
        if (this.collection.startsWith('news')
            || this.collection.startsWith('meeting')
            || this.collection.startsWith('publication')
            || this.collection.startsWith('countries')
            || this.collection.startsWith('species')
            || this.collection.startsWith('openasfa')
            || this.collection.startsWith('knowledgebase')) {
            if (!this.route.parent) {
                this.link = '/' + this.space + '/' + this.collection + '/' + this.configService.env.currentLang;
            }
            else {
                if (this.parent) {
                    this.link = '../' + this.parent;
                }
                else {
                    this.link = '../';
                }
            }
        }
        else {
            if (!this.route.parent) {
                this.link = '/' + this.space + '/' + this.collection + '/search/' + this.configService.env.currentLang;
            }
            else {
                this.link = '';
                for (let i = 0; i < this.route.pathFromRoot.length; i++) {
                    this.link = this.link + '../';
                }
                this.link = this.link + this.collection + '/search/' + this.configService.env.currentLang;
            }
        }
    }
    static { this.ɵfac = function CollectionNavigatorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CollectionNavigatorComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i3.Location)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CollectionNavigatorComponent, selectors: [["collection-navigator"]], inputs: { space: "space", collection: "collection", version: "version", title: "title", documentId: "documentId", parent: "parent" }, standalone: false, decls: 5, vars: 4, consts: [[1, "row"], [1, "col-md-11"], ["class", "title-link", 4, "ngIf"], [1, "col-md-1"], [3, "space", "collection", "documentId"], [1, "title-link"], ["href", "javascript:void(0)", 3, "click"]], template: function CollectionNavigatorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, CollectionNavigatorComponent_h5_2_Template, 3, 1, "h5", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵelement(4, "cart-buttons", 4);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.link);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("space", ctx.space)("collection", ctx.collection)("documentId", ctx.documentId);
        } }, dependencies: [i3.NgIf, CartButtonsComponent], styles: [".title-highlight[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:inherit!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollectionNavigatorComponent, [{
        type: Component,
        args: [{ selector: 'collection-navigator', standalone: false, template: "<div class=\"row\">\r\n    <div class=\"col-md-11\">\r\n        <h5 class=\"title-link\" *ngIf=\"link\"><a href=\"javascript:void(0)\" (click)=\"location.back()\">{{ title }}</a></h5>\r\n    </div>\r\n    <div class=\"col-md-1\">\r\n        <cart-buttons [space]=\"space\" [collection]=\"collection\" [documentId]=\"documentId\"></cart-buttons>\r\n    </div>\r\n</div>", styles: [".title-highlight a{color:inherit!important}\n"] }]
    }], () => [{ type: i1.ConfigurationService }, { type: i2.ActivatedRoute }, { type: i3.Location }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], version: [{
            type: Input
        }], title: [{
            type: Input
        }], documentId: [{
            type: Input
        }], parent: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CollectionNavigatorComponent, { className: "CollectionNavigatorComponent", filePath: "src/components/collection-navigator/collection-navigator.component.ts", lineNumber: 12 }); })();

const _c0$b = (a0, a1, a2) => ({ total: a0, from: a1, to: a2 });
function DataListComponent_ng_container_0_h6_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("search.results-list.total", i0.ɵɵpureFunction3(1, _c0$b, ctx_r0.total, ctx_r0.from, ctx_r0.to)));
} }
function DataListComponent_ng_container_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
} }
function DataListComponent_ng_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("search.results.noresults"));
} }
function DataListComponent_ng_container_0_div_6_standard_result_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "standard-result", 10);
    i0.ɵɵlistener("onClick", function DataListComponent_ng_container_0_div_6_standard_result_1_Template_standard_result_onClick_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.resultClick($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("enableClick", ctx_r0.enableClick)("dynamicForm", ctx_r0.collectionForm.form)("space", ctx_r0.space)("collection", ctx_r0.name)("parent", ctx_r0.parent)("status", ctx_r0.status)("data", ctx_r0.resultList.list)("config", ctx_r0.collectionForm.formConfig.viewConfig)("collectionForm", ctx_r0.collectionForm);
} }
function DataListComponent_ng_container_0_div_6_grouped_result_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "grouped-result", 11);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("dynamicForm", ctx_r0.collectionForm.form)("space", ctx_r0.space)("collection", ctx_r0.name)("parent", ctx_r0.parent)("status", ctx_r0.status)("data", ctx_r0.resultList.list)("config", ctx_r0.collectionForm.formConfig.viewConfig);
} }
function DataListComponent_ng_container_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, DataListComponent_ng_container_0_div_6_standard_result_1_Template, 1, 9, "standard-result", 8)(2, DataListComponent_ng_container_0_div_6_grouped_result_2_Template, 1, 7, "grouped-result", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.collectionForm.formConfig.viewConfig.grouping == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.grouping.groupedDisplay));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.collectionForm.formConfig.viewConfig.grouping == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.grouping.groupedDisplay);
} }
function DataListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
    i0.ɵɵtemplate(3, DataListComponent_ng_container_0_h6_3_Template, 2, 5, "h6", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, DataListComponent_ng_container_0_div_4_Template, 1, 0, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DataListComponent_ng_container_0_div_5_Template, 3, 1, "div", 0)(6, DataListComponent_ng_container_0_div_6_Template, 3, 2, "div", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.collectionForm.formConfig.selectionEnabled ? "col-md-11" : "col-md-12");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showinfo && ctx_r0.pagination === true && ctx_r0.total > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.collectionForm.formConfig.selectionEnabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.resultList.list && ctx_r0.total === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.total > 0);
} }
function DataListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵtext(2, "No data available");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
class DataListComponent extends ListDirective {
    constructor(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService, formDataService, dialogService, mapService) {
        super(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService);
        this.formDataService = formDataService;
        this.dialogService = dialogService;
        this.mapService = mapService;
        this.showinfo = true;
        this.pagination = true;
        this.enableClick = false;
        this.onClick = new EventEmitter();
        this.dataReady = new EventEmitter();
    }
    ngOnInit() {
        this.setIndexingData = false;
        this.route.queryParams.subscribe(params => {
            this.queryParams = params;
            let inputs = {
                advanced: this.advanced,
                filter: this.filter,
                f: this.f,
                additional: this.additional,
                options: this.options,
                o: this.o,
                langs: this.langs,
                q: this.query,
                sort: this.sort
            };
            this.init(true, inputs);
        });
    }
    openSubformItem(item, id, status) {
        /*     if (this.dynamicFormObject.refFormId)
            {
              if (this.dynamicFormObject.refFormType === 'external')
              { */
        this.formDataService.openSubformItem(null, item, id, status, this.status, this.queryParams, new DynamicForm({
            space: this.space,
            name: this.parent
        }), this.name, this.subpath);
        /*       }
            } */
    }
    getValue(obj, column) {
        if (column.formula) {
            try {
                let value = this.dynamicFormControlService.executeFormula(column.formula, obj, this.collectionForm?.form.acceptedParams, this.collectionForm?.form?.params);
                return value;
            }
            catch (error) {
                return error.code + ' - ' + error.message;
            }
        }
        else {
            let field = (this.collectionForm?.formConfig?.aliases ? ListDirective.manageField(this.configService.env.advancedSearch.termConcatenator, (this.collectionForm?.formConfig?.aliases[column.name] || column.name), this.configService.env.currentLang) : column.name);
            let data = jsonPath.query(obj, '$.' + field);
            if (data.length > 0) {
                //Multiple property means that the jsonpath result of the search of the material (short name) field could be an array of values, this implies to transform the array in a comma separated string
                if (column.multipleProperty) {
                    let items = data[0].map(item => item[column.multipleProperty]);
                    return this.getArrayString(items, ', ');
                }
                else {
                    /* TODO: If a field has a reference to a standard option, extract label */
                    return data[0];
                }
            }
            else {
                if (column.alternativeText) {
                    return column.alternativeText[this.configService.env.currentLang] || column.alternativeText[this.configService.env.defaultLang];
                }
                return '';
            }
        }
    }
    getArrayString(items, separator) {
        let output = '';
        for (let i = 0; i < items.length; i++) {
            if (output > '') {
                output += separator + items[i];
            }
            else {
                output = items[i];
            }
        }
        return output;
    }
    resultClick(event) {
        this.onClick.emit(event);
    }
    afterSearchAdditionalActions(list, searchParameters, geoFilter) {
        this.dataReady.emit(list);
    }
    static { this.ɵfac = function DataListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DataListComponent)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(UserselectionService), i0.ɵɵdirectiveInject(i1.WorkspaceService), i0.ɵɵdirectiveInject(i1.TemplateService), i0.ɵɵdirectiveInject(i1.PropertiesService), i0.ɵɵdirectiveInject(i1.ListConfigService), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.MapService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataListComponent, selectors: [["data-list"]], inputs: { space: "space", name: "name", parent: "parent", size: "size", advanced: "advanced", query: "query", filter: "filter", f: "f", sort: "sort", additional: "additional", options: "options", o: "o", langs: "langs", subpath: "subpath", showinfo: "showinfo", pagination: "pagination", itemsPerPage: "itemsPerPage", enableClick: "enableClick" }, outputs: { onClick: "onClick", dataReady: "dataReady" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "row", "results-header", "mb-2"], [3, "ngClass"], ["class", "title-category", 4, "ngIf"], ["class", "col-md-1 align-right", 4, "ngIf"], [1, "title-category"], [1, "col-md-1", "align-right"], [1, "lead"], ["view", "table", 3, "enableClick", "dynamicForm", "space", "collection", "parent", "status", "data", "config", "collectionForm", "onClick", 4, "ngIf"], [3, "dynamicForm", "space", "collection", "parent", "status", "data", "config", 4, "ngIf"], ["view", "table", 3, "onClick", "enableClick", "dynamicForm", "space", "collection", "parent", "status", "data", "config", "collectionForm"], [3, "dynamicForm", "space", "collection", "parent", "status", "data", "config"], [1, "no-data-found"]], template: function DataListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DataListComponent_ng_container_0_Template, 7, 5, "ng-container", 0)(1, DataListComponent_ng_container_1_Template, 3, 0, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.resultList && ctx.resultList.list && ctx.resultList.list.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.resultList || !ctx.resultList.list || ctx.resultList.list.length === 0);
        } }, dependencies: [i3.NgClass, i3.NgIf, GroupedResultComponent, StandardResultComponent], styles: [".no-data-found[_ngcontent-%COMP%]{font-weight:600}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataListComponent, [{
        type: Component,
        args: [{ selector: 'data-list', standalone: false, template: "<ng-container *ngIf=\"resultList && resultList.list && resultList.list.length > 0\">\r\n    \r\n    <div class=\"row results-header mb-2\">\r\n      <div [ngClass]=\"collectionForm.formConfig.selectionEnabled ? 'col-md-11' : 'col-md-12'\">\r\n          <h6 class=\"title-category\" *ngIf=\"showinfo && pagination === true && total > 0\">{{ configService.getTranslation('search.results-list.total',{ total: total, from: from, to: to }) }}</h6>\r\n      </div>\r\n      <div class=\"col-md-1 align-right\" *ngIf=\"collectionForm.formConfig.selectionEnabled\">\r\n          <!-- <userselection-buttons [space]=\"space\" [collection]=\"collection\" [disabled]=\"noSelections()\"></userselection-buttons> -->\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"resultList.list && total === 0\">\r\n        <p class=\"lead\">{{ configService.getTranslation('search.results.noresults') }}</p>\r\n    </div>\r\n    <div *ngIf=\"total > 0\">\r\n        <standard-result *ngIf=\"!collectionForm.formConfig.viewConfig.grouping?.groupedDisplay\" view=\"table\" [enableClick]=\"enableClick\" (onClick)=\"resultClick($event)\" [dynamicForm]=\"collectionForm.form\" [space]=\"space\" [collection]=\"name\" [parent]=\"parent\" [status]=\"status\" [data]=\"resultList.list\" [config]=\"collectionForm.formConfig.viewConfig\" [collectionForm]=\"collectionForm\"></standard-result>\r\n        <grouped-result *ngIf=\"collectionForm.formConfig.viewConfig.grouping?.groupedDisplay\" [dynamicForm]=\"collectionForm.form\" [space]=\"space\" [collection]=\"name\" [parent]=\"parent\" [status]=\"status\" [data]=\"resultList.list\" [config]=\"collectionForm.formConfig.viewConfig\"></grouped-result>\r\n    </div>\r\n</ng-container>\r\n\r\n<ng-container *ngIf=\"!resultList || !resultList.list || resultList.list.length === 0\">\r\n  <div class=\"no-data-found\" >No data available</div>\r\n</ng-container>\r\n", styles: [".no-data-found{font-weight:600}\n"] }]
    }], () => [{ type: i1.SearchService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.UtilsService }, { type: i1.ConfigurationService }, { type: i1.DynamicFormControlService }, { type: i0.ElementRef }, { type: i1.CollectionService }, { type: i3$2.ConfirmationService }, { type: UserselectionService }, { type: i1.WorkspaceService }, { type: i1.TemplateService }, { type: i1.PropertiesService }, { type: i1.ListConfigService }, { type: FormDataService }, { type: i1$1.DialogService }, { type: i1.MapService }], { space: [{
            type: Input
        }], name: [{
            type: Input
        }], parent: [{
            type: Input
        }], size: [{
            type: Input
        }], advanced: [{
            type: Input
        }], query: [{
            type: Input
        }], filter: [{
            type: Input
        }], f: [{
            type: Input
        }], sort: [{
            type: Input
        }], additional: [{
            type: Input
        }], options: [{
            type: Input
        }], o: [{
            type: Input
        }], langs: [{
            type: Input
        }], subpath: [{
            type: Input
        }], showinfo: [{
            type: Input
        }], pagination: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], enableClick: [{
            type: Input
        }], onClick: [{
            type: Output
        }], dataReady: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DataListComponent, { className: "DataListComponent", filePath: "src/components/data-list/data-list.component.ts", lineNumber: 23 }); })();

const _c0$a = a0 => [a0];
class DatatypeSearchComponent extends ListDirective {
    constructor(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService, formDataService, dialogService, mapService) {
        super(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService);
        this.formDataService = formDataService;
        this.dialogService = dialogService;
        this.mapService = mapService;
        this.version = 'v1';
        this.langs = this.configService.env.currentLang;
    }
    ngOnInit() {
        this.setIndexingData = false;
        this.name = this.collection;
        this.route.queryParams.subscribe(params => {
            let inputs = {
                advanced: this.advanced,
                filter: this.filter,
                f: this.f,
                additional: this.additional,
                options: this.options,
                o: this.o,
                langs: this.langs,
                q: this.query,
                sort: this.sort
            };
            for (let key in params) {
                if (params[key] > '') {
                    inputs[key] = params[key];
                }
            }
            this.initSettings();
            this.processAdditionalAttributes(inputs);
            //this.init(inputs,false);
            this.init(false);
            //-----------------------------------------
            //  Need to transform the search object in a url
            //-----------------------------------------
            if (this.field > '') {
                if (this.collection) {
                    this.link = '/' + this.collection + '/search/' + this.configService.env.currentLang;
                }
                else {
                    this.link = '/search/' + this.configService.env.currentLang;
                }
                if (!this.text) {
                    if (this.collection) {
                        this.text = location.origin + this.configService.env.baseHref + '/' + this.collection + '/' + this.field + '/' + this.configService.env.currentLang;
                    }
                    else {
                        this.text = location.origin + this.configService.env.baseHref + '/' + this.field + '/' + this.configService.env.currentLang;
                    }
                }
                else {
                    this.queryParams = {
                        q: this.field + ':"' + this.text + '"'
                    };
                }
            }
            else {
                if (this.collection) {
                    //FRANCESCA: ripristinare estrazione configurazione
                    //this.config = this.configService.factsheetsSearchConfigurations[this.collection + 'v1'];
                    this.link = this.collection + '/search/' + this.configService.env.currentLang;
                }
                else {
                    this.link = '/search/' + this.configService.env.currentLang;
                }
                this.queryParams = {
                    q: this.query
                };
                if (this.advanced) {
                    let advancedSearchParams = ListDirective.decodeSearch(this.configService, this.configService.env.advancedSearch.termConcatenator, this.advanced, this.aliases, this.config.listPayload.advancedSearchParams, this.config.listPayload.facets, this.config.listPayload.filters, this.configService.env.currentLang);
                    for (let key in advancedSearchParams) {
                        if (!this.queryParams.q) {
                            this.queryParams.q = key + ':' + advancedSearchParams[key];
                        }
                        else {
                            this.queryParams.q = this.queryParams.q + ' AND ' + key + ':' + advancedSearchParams[key];
                        }
                    }
                }
                if (!this.text) {
                    if (this.collection) {
                        this.text = location.origin + this.configService.env.baseHref + '/' + this.collection + '/' + this.configService.env.currentLang;
                    }
                    else {
                        this.text = location.origin + this.configService.env.baseHref + '/' + this.configService.env.currentLang;
                    }
                }
            }
        });
    }
    ngOnDestroy() {
    }
    setClass() {
        if (this.collection === 'species') {
            return 'species';
        }
    }
    static { this.ɵfac = function DatatypeSearchComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DatatypeSearchComponent)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(UserselectionService), i0.ɵɵdirectiveInject(i1.WorkspaceService), i0.ɵɵdirectiveInject(i1.TemplateService), i0.ɵɵdirectiveInject(i1.PropertiesService), i0.ɵɵdirectiveInject(i1.ListConfigService), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.MapService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DatatypeSearchComponent, selectors: [["search"]], inputs: { collection: "collection", version: "version", field: "field", advanced: "advanced", query: "query", filter: "filter", f: "f", sort: "sort", aliases: "aliases", additional: "additional", options: "options", o: "o", langs: "langs", text: "text" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 6, consts: [[1, "ref-link", 3, "ngClass"], [3, "routerLink", "queryParams"], [3, "innerHTML"]], template: function DatatypeSearchComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "span", 0)(1, "a", 1);
            i0.ɵɵelement(2, "span", 2);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.setClass());
            i0.ɵɵadvance();
            i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c0$a, ctx.link))("queryParams", ctx.queryParams);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.text, i0.ɵɵsanitizeHtml);
        } }, dependencies: [i3.NgClass, i2.RouterLink], styles: [".ref-link[_ngcontent-%COMP%]{display:inline-block}.ref-link.species[_ngcontent-%COMP%]{font-style:italic}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatatypeSearchComponent, [{
        type: Component,
        args: [{ selector: 'search', standalone: false, template: "<span class=\"ref-link\" [ngClass]=\"setClass()\">\r\n    <a [routerLink]=\"[link]\" [queryParams]=\"queryParams\"><span [innerHTML]=\"text\"></span></a>\r\n</span>", styles: [".ref-link{display:inline-block}.ref-link.species{font-style:italic}\n"] }]
    }], () => [{ type: i1.SearchService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.UtilsService }, { type: i1.ConfigurationService }, { type: i1.DynamicFormControlService }, { type: i0.ElementRef }, { type: i1.CollectionService }, { type: i3$2.ConfirmationService }, { type: UserselectionService }, { type: i1.WorkspaceService }, { type: i1.TemplateService }, { type: i1.PropertiesService }, { type: i1.ListConfigService }, { type: FormDataService }, { type: i1$1.DialogService }, { type: i1.MapService }], { collection: [{
            type: Input
        }], version: [{
            type: Input
        }], field: [{
            type: Input
        }], advanced: [{
            type: Input
        }], query: [{
            type: Input
        }], filter: [{
            type: Input
        }], f: [{
            type: Input
        }], sort: [{
            type: Input
        }], aliases: [{
            type: Input
        }], additional: [{
            type: Input
        }], options: [{
            type: Input
        }], o: [{
            type: Input
        }], langs: [{
            type: Input
        }], text: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DatatypeSearchComponent, { className: "DatatypeSearchComponent", filePath: "src/components/datatype-search/datatype-search.component.ts", lineNumber: 22 }); })();

function DocumentsListComponent_div_0_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3)(1, "span");
    i0.ɵɵelement(2, "i", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const url_r1 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("href", url_r1, i0.ɵɵsanitizeUrl);
} }
function DocumentsListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 1);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DocumentsListComponent_div_0_a_3_Template, 3, 1, "a", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.configService.getTranslation("global.documents.text"), ": ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.documents);
} }
class DocumentsListComponent {
    constructor(configService) {
        this.configService = configService;
    }
    ngOnInit() {
        if (typeof (this.documents) === 'string') {
            this.documents = [this.documents];
        }
    }
    static { this.ɵfac = function DocumentsListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DocumentsListComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentsListComponent, selectors: [["documents-list"]], inputs: { documents: "documents" }, standalone: false, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "bold"], ["target", "_blank", "title", "View PDF", "routerLinkActive", "router-link-active", 3, "href", 4, "ngFor", "ngForOf"], ["target", "_blank", "title", "View PDF", "routerLinkActive", "router-link-active", 3, "href"], [1, "bi", "bi-file-earmark"]], template: function DocumentsListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DocumentsListComponent_div_0_Template, 4, 2, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.documents);
        } }, dependencies: [i3.NgForOf, i3.NgIf, i2.RouterLinkActive], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentsListComponent, [{
        type: Component,
        args: [{ selector: 'documents-list', standalone: false, template: "<div *ngIf=\"documents\">\r\n    <span class=\"bold\">{{configService.getTranslation('global.documents.text')}}: </span>\r\n    <a *ngFor=\"let url of documents\" target=\"_blank\" title=\"View PDF\" href=\"{{url}}\"\r\n        routerLinkActive=\"router-link-active\">\r\n        <span><i class=\"bi bi-file-earmark\"></i></span>\r\n    </a>\r\n</div>\r\n" }]
    }], () => [{ type: i1.ConfigurationService }], { documents: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DocumentsListComponent, { className: "DocumentsListComponent", filePath: "src/components/documents-list/documents-list.component.ts", lineNumber: 10 }); })();

function DocumentsComponent_ng_container_0_div_1_tr_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r1.docIdentifier, " - ");
} }
function DocumentsComponent_ng_container_0_div_1_tr_4_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r1["docName_" + ctx_r1.configService.env.currentLang] || item_r1["docName_" + ctx_r1.configService.env.defaultLang], " ");
} }
function DocumentsComponent_ng_container_0_div_1_tr_4_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", item_r1["docUrl_" + ctx_r1.configService.env.currentLang] || item_r1["docUrl_" + ctx_r1.configService.env.defaultLang], i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r1["docName_" + ctx_r1.configService.env.currentLang] || item_r1["docName_" + ctx_r1.configService.env.defaultLang], " ");
} }
function DocumentsComponent_ng_container_0_div_1_tr_4_ng_container_5_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, ", ");
    i0.ɵɵelementContainerEnd();
} }
function DocumentsComponent_ng_container_0_div_1_tr_4_ng_container_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DocumentsComponent_ng_container_0_div_1_tr_4_ng_container_5_ng_container_2_ng_container_3_Template, 2, 0, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const url_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const item_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", url_r3.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(url_r3.lang);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r4 < item_r1.urls.length - 1);
} }
function DocumentsComponent_ng_container_0_div_1_tr_4_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " ( ");
    i0.ɵɵtemplate(2, DocumentsComponent_ng_container_0_div_1_tr_4_ng_container_5_ng_container_2_Template, 4, 3, "ng-container", 4);
    i0.ɵɵtext(3, " ) ");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r1.urls);
} }
function DocumentsComponent_ng_container_0_div_1_tr_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtemplate(2, DocumentsComponent_ng_container_0_div_1_tr_4_span_2_Template, 2, 1, "span", 0)(3, DocumentsComponent_ng_container_0_div_1_tr_4_span_3_Template, 2, 1, "span", 0)(4, DocumentsComponent_ng_container_0_div_1_tr_4_a_4_Template, 2, 2, "a", 5)(5, DocumentsComponent_ng_container_0_div_1_tr_4_ng_container_5_Template, 4, 1, "ng-container", 0);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r1.docIdentifier);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r1["docUrl_" + ctx_r1.configService.env.currentLang] && !item_r1["docUrl_" + ctx_r1.configService.env.defaultLang]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1["docUrl_" + ctx_r1.configService.env.currentLang] || item_r1["docUrl_" + ctx_r1.configService.env.defaultLang]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.urls.length > 0);
} }
function DocumentsComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "h6", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "table");
    i0.ɵɵtemplate(4, DocumentsComponent_ng_container_0_div_1_tr_4_Template, 6, 4, "tr", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const doc_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(doc_r5["name_" + ctx_r1.configService.env.currentLang] || doc_r5["name_" + ctx_r1.configService.env.defaultLang]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", doc_r5.documents);
} }
function DocumentsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DocumentsComponent_ng_container_0_div_1_Template, 5, 2, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.documents);
} }
class DocumentsComponent {
    constructor(configService, utilsService) {
        this.configService = configService;
        this.utilsService = utilsService;
        this.items = [];
        this.documents = [];
    }
    ngOnInit() {
        if (!(typeof (this.items) === 'object')) {
            this.items = [];
        }
        for (let i = 0; i < this.items.length; i++) {
            if (!this.documents) {
                this.documents = [];
            }
            this.items[i].urls = [];
            for (let j = 0; j < this.configService.languages.length; j++) {
                if (this.configService.languages[j].code !== this.configService.env.currentLang && this.items[i]['docUrl_' + this.configService.languages[j].code]) {
                    this.items[i].urls.push({
                        lang: this.configService.languages[j].code,
                        url: this.items[i]['docUrl_' + this.configService.languages[j].code]
                    });
                }
            }
            let index = this.documents.findIndex(d => d.id === this.items[i].documentType.id);
            if (index >= 0) {
                this.documents[index].documents.push(this.items[i]);
            }
            else {
                let type = JSON.parse(JSON.stringify(this.items[i].documentType));
                type.documents = [];
                type.documents.push(this.items[i]);
                this.documents.push(type);
            }
        }
        this.documents = this.documents.sort((e1, e2) => {
            if (e1.typeSortOrder < e2.typeSortOrder) {
                return -1;
            }
            else if (e1.typeSortOrder > e2.typeSortOrder) {
                return 1;
            }
            else {
                return 0;
            }
        });
        for (let i = 0; i < this.documents.length; i++) {
            this.documents[i].documents = this.documents[i].documents.sort((e1, e2) => {
                if (e1.sortOrder < e2.sortOrder) {
                    return -1;
                }
                else if (e1.sortOrder > e2.sortOrder) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
        }
    }
    static { this.ɵfac = function DocumentsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DocumentsComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.UtilsService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocumentsComponent, selectors: [["documents"]], inputs: { items: "items" }, standalone: false, decls: 1, vars: 1, consts: [[4, "ngIf"], ["class", "mt-3", 4, "ngFor", "ngForOf"], [1, "mt-3"], [1, "document-type"], [4, "ngFor", "ngForOf"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"], ["target", "_blank", 1, "document-additional-language", 3, "href"]], template: function DocumentsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DocumentsComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.documents);
        } }, dependencies: [i3.NgForOf, i3.NgIf], styles: [".document-type[_ngcontent-%COMP%]{font-weight:700}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentsComponent, [{
        type: Component,
        args: [{ selector: 'documents', standalone: false, template: "<ng-container *ngIf=\"documents\">\r\n    <div class=\"mt-3\" *ngFor=\"let doc of documents\">\r\n        <h6 class=\"document-type\">{{ doc['name_' + configService.env.currentLang] || doc['name_' + configService.env.defaultLang] }}</h6>\r\n        <table>\r\n            <tr *ngFor=\"let item of doc.documents\">\r\n                <td>\r\n                    <span *ngIf=\"item.docIdentifier\">\r\n                        {{ item.docIdentifier }} - \r\n                    </span>\r\n                    <span \r\n                        *ngIf=\"!item['docUrl_' + configService.env.currentLang] && !item['docUrl_' + configService.env.defaultLang]\">\r\n                        {{ item['docName_' + configService.env.currentLang] || item['docName_' + configService.env.defaultLang] }}\r\n                    </span>\r\n                    <a \r\n                        *ngIf=\"item['docUrl_' + configService.env.currentLang] || item['docUrl_' + configService.env.defaultLang]\" \r\n                        [href]=\"item['docUrl_' + configService.env.currentLang] || item['docUrl_' + configService.env.defaultLang]\"\r\n                        target=\"_blank\"\r\n                    >\r\n                        {{ item['docName_' + configService.env.currentLang] || item['docName_' + configService.env.defaultLang] }}\r\n                    </a>\r\n                    <ng-container *ngIf=\"item.urls.length > 0\">\r\n                        (\r\n                            <ng-container *ngFor=\"let url of item.urls; let i = index\">\r\n                                <a class=\"document-additional-language\"                                                  \r\n                                    [href]=\"url.url\" \r\n                                    target=\"_blank\"\r\n                                >{{ url.lang }}</a>\r\n                                <ng-container *ngIf=\"i < item.urls.length-1\">, </ng-container>\r\n                            </ng-container>\r\n                        )\r\n                    </ng-container>\r\n                </td>\r\n            </tr>\r\n        </table>\r\n    </div>\r\n</ng-container>\r\n", styles: [".document-type{font-weight:700}\n"] }]
    }], () => [{ type: i1.ConfigurationService }, { type: i1.UtilsService }], { items: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DocumentsComponent, { className: "DocumentsComponent", filePath: "src/components/documents/documents.component.ts", lineNumber: 10 }); })();

function FactsheetIntroComponent_html_renderer_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "html-renderer", 1);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("template", ctx_r0.intro);
} }
class FactsheetIntroComponent {
    constructor(searchService, configService) {
        this.searchService = searchService;
        this.configService = configService;
    }
    ngOnInit() {
        let searchRequest = new SearchRequest();
        searchRequest.lang = this.configService.env.currentLang;
        this.searchService.searchCollectionItems('collection', 'v1', [new SimpleSearchParameter('document.collection', this.collection), new SimpleSearchParameter('metadata.lang', this.configService.env.currentLang)], 30, 0, null, null, ['document.searchIntroText', 'metadata']).subscribe(res => {
            if (res && res.results.total > 0) {
                this.intro = res.results.values[0].document.searchIntroText;
            }
        }, err => {
            this.searchService.manageError(err, 'Error reading collection items for collection');
        });
    }
    static { this.ɵfac = function FactsheetIntroComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FactsheetIntroComponent)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FactsheetIntroComponent, selectors: [["app-factsheet-intro"]], inputs: { collection: "collection" }, standalone: false, decls: 1, vars: 1, consts: [[3, "template", 4, "ngIf"], [3, "template"]], template: function FactsheetIntroComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FactsheetIntroComponent_html_renderer_0_Template, 1, 1, "html-renderer", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.intro);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FactsheetIntroComponent, [{
        type: Component,
        args: [{ selector: 'app-factsheet-intro', standalone: false, template: "<html-renderer *ngIf=\"intro\" [template]=\"intro\"></html-renderer>" }]
    }], () => [{ type: i1.SearchService }, { type: i1.ConfigurationService }], { collection: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FactsheetIntroComponent, { className: "FactsheetIntroComponent", filePath: "src/components/factsheet-intro/factsheet-intro.component.ts", lineNumber: 11 }); })();

function FiFilterTermsComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 4)(2, "h6", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6)(5, "input", 7);
    i0.ɵɵtwoWayListener("ngModelChange", function FiFilterTermsComponent_div_0_div_3_Template_input_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r1.value, $event) || (ctx_r1.value = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("keyup.enter", function FiFilterTermsComponent_div_0_div_3_Template_input_keyup_enter_5_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onEnter($event, ctx_r1.value)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p-button", 8);
    i0.ɵɵlistener("onClick", function FiFilterTermsComponent_div_0_div_3_Template_p_button_onClick_6_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onEnter($event, ctx_r1.value)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "p-button", 9);
    i0.ɵɵlistener("onClick", function FiFilterTermsComponent_div_0_div_3_Template_p_button_onClick_7_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onEnter($event, null)); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const agg_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(agg_r3.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rounded", true)("text", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rounded", true)("text", true);
} }
function FiFilterTermsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "h5");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, FiFilterTermsComponent_div_0_div_3_Template, 8, 6, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("filterterms.title"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.data.aggregations);
} }
function FiFilterTermsComponent_div_1_div_3_div_1_h6_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const agg_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(agg_r4.title);
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_3_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", item_r6.count, ")");
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "a", 19);
    i0.ɵɵlistener("click", function FiFilterTermsComponent_div_1_div_3_div_1_div_3_div_1_Template_a_click_1_listener() { const item_r6 = i0.ɵɵrestoreView(_r5).$implicit; const agg_r4 = i0.ɵɵnextContext(3).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.searchTerm(agg_r4, item_r6.key)); });
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FiFilterTermsComponent_div_1_div_3_div_1_div_3_div_1_span_3_Template, 2, 1, "span", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ngClass", "facet " + ctx_r1.getTermId(item_r6.key));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.getTermProperty(item_r6.key, "label"), "\u00A0");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r6.count);
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, FiFilterTermsComponent_div_1_div_3_div_1_div_3_div_1_Template, 4, 3, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const agg_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", agg_r4.aggregation.results);
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_1_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", item_r8.count, ")");
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "a", 21);
    i0.ɵɵlistener("click", function FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_1_div_1_Template_a_click_1_listener() { const item_r8 = i0.ɵɵrestoreView(_r7).$implicit; const agg_r4 = i0.ɵɵnextContext(4).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.searchTerm(agg_r4, item_r8.key)); });
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_1_div_1_span_3_Template, 2, 1, "span", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.getTermProperty(item_r8.key, "label"), "\u00A0");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r8.count);
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_1_div_1_Template, 4, 2, "div", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const agg_r4 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.getItems(agg_r4, 0, 5));
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_2_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", item_r10.count, ")");
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "a", 21);
    i0.ɵɵlistener("click", function FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_2_div_1_Template_a_click_1_listener() { const item_r10 = i0.ɵɵrestoreView(_r9).$implicit; const agg_r4 = i0.ɵɵnextContext(4).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.searchTerm(agg_r4, item_r10.key)); });
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_2_div_1_span_3_Template, 2, 1, "span", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.getTermProperty(item_r10.key, "label"), "\u00A0");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r10.count);
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_2_div_1_Template, 4, 2, "div", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const agg_r4 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.getItems(agg_r4, 0));
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_1_Template, 2, 1, "ng-container", 20)(2, FiFilterTermsComponent_div_1_div_3_div_1_div_4_ng_container_2_Template, 2, 1, "ng-container", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.showMore);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showMore);
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_5_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 24);
    i0.ɵɵlistener("click", function FiFilterTermsComponent_div_1_div_3_div_1_div_5_a_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.showMore = !ctx_r1.showMore); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("filterterms.showmore"));
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_5_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 24);
    i0.ɵɵlistener("click", function FiFilterTermsComponent_div_1_div_3_div_1_div_5_a_4_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.showMore = !ctx_r1.showMore); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("filterterms.showless"));
} }
function FiFilterTermsComponent_div_1_div_3_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "p");
    i0.ɵɵtemplate(2, FiFilterTermsComponent_div_1_div_3_div_1_div_5_a_2_Template, 3, 1, "a", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtemplate(4, FiFilterTermsComponent_div_1_div_3_div_1_div_5_a_4_Template, 3, 1, "a", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.showMore);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showMore);
} }
function FiFilterTermsComponent_div_1_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, FiFilterTermsComponent_div_1_div_3_div_1_h6_1_Template, 2, 1, "h6", 12);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵtemplate(3, FiFilterTermsComponent_div_1_div_3_div_1_div_3_Template, 2, 1, "div", 14)(4, FiFilterTermsComponent_div_1_div_3_div_1_div_4_Template, 3, 2, "div", 14)(5, FiFilterTermsComponent_div_1_div_3_div_1_div_5_Template, 5, 2, "div", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const agg_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.search);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", agg_r4.aggregation.results.length <= 5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", agg_r4.aggregation.results.length > 5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", agg_r4.aggregation.results.length > 5);
} }
function FiFilterTermsComponent_div_1_div_3_div_2_h6_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const agg_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(agg_r4.title);
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_2_li_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", item_r14.count, ")");
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_2_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 19);
    i0.ɵɵlistener("click", function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_2_li_2_Template_a_click_1_listener() { const item_r14 = i0.ɵɵrestoreView(_r13).$implicit; const agg_r4 = i0.ɵɵnextContext(3).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.searchTerm(agg_r4, item_r14.key)); });
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_2_li_2_span_3_Template, 2, 1, "span", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ngClass", "facet " + ctx_r1.getTermId(item_r14.key));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.getTermProperty(item_r14.key, "label"), "\u00A0");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r14.count);
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 25);
    i0.ɵɵtemplate(2, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_2_li_2_Template, 4, 3, "li", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const agg_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", agg_r4.aggregation.results);
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_1_li_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", item_r16.count, ")");
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_1_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 19);
    i0.ɵɵlistener("click", function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_1_li_2_Template_a_click_1_listener() { const item_r16 = i0.ɵɵrestoreView(_r15).$implicit; const agg_r4 = i0.ɵɵnextContext(4).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.searchTerm(agg_r4, item_r16.key)); });
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_1_li_2_span_3_Template, 2, 1, "span", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r16 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ngClass", "facet " + ctx_r1.getTermId(item_r16.key));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.getTermProperty(item_r16.key, "label"), "\u00A0");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r16.count);
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 25);
    i0.ɵɵtemplate(2, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_1_li_2_Template, 4, 3, "li", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const agg_r4 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.getItems(agg_r4, 0, 10));
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_2_li_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", item_r18.count, ")");
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_2_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 19);
    i0.ɵɵlistener("click", function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_2_li_2_Template_a_click_1_listener() { const item_r18 = i0.ɵɵrestoreView(_r17).$implicit; const agg_r4 = i0.ɵɵnextContext(4).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.searchTerm(agg_r4, item_r18.key)); });
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_2_li_2_span_3_Template, 2, 1, "span", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r18 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ngClass", "facet " + ctx_r1.getTermId(item_r18.key));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.getTermProperty(item_r18.key, "label"), "\u00A0");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r18.count);
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 25);
    i0.ɵɵtemplate(2, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_2_li_2_Template, 4, 3, "li", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const agg_r4 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.getItems(agg_r4, 0));
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 24);
    i0.ɵɵlistener("click", function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_a_4_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.showMore = !ctx_r1.showMore); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("filterterms.showmore"));
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_a_6_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 24);
    i0.ɵɵlistener("click", function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_a_6_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.showMore = !ctx_r1.showMore); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("filterterms.showless"));
} }
function FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_1_Template, 3, 1, "ng-container", 20)(2, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_ng_container_2_Template, 3, 1, "ng-container", 20);
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtemplate(4, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_a_4_Template, 3, 1, "a", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtemplate(6, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_a_6_Template, 3, 1, "a", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.showMore);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showMore);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.showMore);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showMore);
} }
function FiFilterTermsComponent_div_1_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, FiFilterTermsComponent_div_1_div_3_div_2_h6_1_Template, 2, 1, "h6", 12)(2, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_2_Template, 3, 1, "ng-container", 20)(3, FiFilterTermsComponent_div_1_div_3_div_2_ng_container_3_Template, 7, 4, "ng-container", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const agg_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.search);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", agg_r4.aggregation.results.length <= 10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", agg_r4.aggregation.results.length > 10);
} }
function FiFilterTermsComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FiFilterTermsComponent_div_1_div_3_div_1_Template, 6, 4, "div", 11)(2, FiFilterTermsComponent_div_1_div_3_div_2_Template, 4, 3, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const agg_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", agg_r4.aggregation.results && agg_r4.aggregation.results.length > 0 && ctx_r1.layout === "horizontal");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", agg_r4.aggregation.results && agg_r4.aggregation.results.length > 0 && ctx_r1.layout === "vertical");
} }
function FiFilterTermsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "h5");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, FiFilterTermsComponent_div_1_div_3_Template, 3, 2, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("filterterms.title"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.data.aggregations);
} }
class FiFilterTermsComponent {
    constructor(collectionService, searchService, configService, router, activatedRoute) {
        this.collectionService = collectionService;
        this.searchService = searchService;
        this.configService = configService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.showinfo = true;
        this.pagination = true;
        this.layout = "vertical";
        this.search = false;
        this.pageReady = false;
        this.showMore = false;
    }
    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(queryParams => {
            this.listTemplate = queryParams.listTemplate;
            this.detailTemplate = queryParams.detailTemplate;
            this.listConfig = queryParams.listConfig;
            this.view = queryParams.view;
        });
        if (!this.collectionForm) {
            this.collectionService.getCollection(this.space, this.collection).subscribe(res => {
                this.collectionForm = res;
                this.pageReady = true;
            }, err => {
                this.searchService.manageError(err, 'Error extracting collections from space ' + this.space);
            });
        }
        else {
            this.pageReady = true;
        }
    }
    searchTerm(agg, key) {
        if (isNaN(key)) {
            if (key.includes(this.configService.env.advancedSearch.termConcatenator)) {
                this.searchFilterTerm(agg, key);
            }
            else {
                this.searchFilterTerm(agg, '\"' + key + '\"');
            }
        }
        else {
            this.searchFilterTerm(agg, key);
        }
    }
    getTermId(key) {
        if (key.includes(this.configService.env.advancedSearch.termConcatenator)) {
            return key.split(this.configService.env.advancedSearch.termConcatenator)[0];
        }
        else {
            return key;
        }
    }
    getItems(agg, start, end) {
        let items = [];
        if (!end) {
            end = agg.aggregation.results.length >= 25 ? 25 : agg.aggregation.results.length;
        }
        for (let i = start; i < end; i++) {
            items.push(agg.aggregation.results[i]);
        }
        return items;
    }
    onSearchChange(searchValue) {
        //this.getData(searchValue);
    }
    onEnter(event, searchValue) {
        this.onSearchChange(searchValue);
    }
    onKeyup(event, searchValue) {
        let facets = this;
        setTimeout(function () {
            facets.onSearchChange(searchValue);
        }, 2000);
    }
    searchFilterTerm(agg, key) {
        let facet;
        let index = this.collectionForm?.formConfig.viewConfig.facets.findIndex(item => item.name === agg.aggregation.name);
        if (index >= 0) {
            facet = this.collectionForm?.formConfig.viewConfig.facets[index];
        }
        let duplicate = this.data.searchRequest.f[agg.aggregation.name];
        if (!duplicate || duplicate.value !== key) {
            if (facet.concat && facet.concatDelimiter) {
                this.data.searchRequest.f[agg.aggregation.name] = [{ label: ListDirective.getTermProperty(this.configService, facet.concatDelimiter, key, 'label'), value: ListDirective.getTermProperty(this.configService, this.configService.env.advancedSearch.termConcatenator, key, 'key') }];
            }
            else {
                this.data.searchRequest.f[agg.aggregation.name] = [{ value: key }];
            }
            let queryParams = {
                page: this.data.searchRequest.page,
                q: this.data.searchRequest.q,
                f: ListDirective.stringifyAdvancedParams(this.configService, this.data.searchRequest.f, this.configService.env.advancedSearch.multiple.separator),
                o: ListDirective.stringifyAdvancedParams(this.configService, this.data.searchRequest.o, this.configService.env.advancedSearch.multiple.separator),
                g: ListDirective.stringifyGeospatialParams(this.configService, this.data.searchRequest.g, this.configService.env.advancedSearch.multiple.separator),
                sort: this.data.searchRequest.sort
            };
            if (this.view) {
                queryParams.view = this.view;
            }
            if (this.listTemplate) {
                queryParams.listTemplate = this.listTemplate;
            }
            if (this.detailTemplate) {
                queryParams.detailTemplate = this.detailTemplate;
            }
            if (this.listConfig) {
                queryParams.listConfig = this.listConfig;
            }
            if (this.data.searchRequest.q || this.data.searchRequest.f || this.data.searchRequest.o) {
                this.router.navigate(['./'], {
                    relativeTo: this.activatedRoute,
                    fragment: 'search',
                    queryParams: queryParams
                });
            }
            else {
                this.router.navigate(['./'], {
                    relativeTo: this.activatedRoute,
                    queryParams: queryParams
                });
            }
        }
    }
    getTermProperty(term, prop) {
        return ListDirective.getTermProperty(this.configService, this.configService.env.advancedSearch.termConcatenator, term, prop);
    }
    static { this.ɵfac = function FiFilterTermsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FiFilterTermsComponent)(i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FiFilterTermsComponent, selectors: [["fi-filter-terms"]], inputs: { space: "space", collection: "collection", collectionForm: "collectionForm", data: "data", parent: "parent", status: "status", showinfo: "showinfo", pagination: "pagination", layout: "layout", search: "search" }, standalone: false, decls: 2, vars: 2, consts: [["class", "filter-input mb-3", 4, "ngIf"], ["class", "filter-search", 4, "ngIf"], [1, "filter-input", "mb-3"], [4, "ngFor", "ngForOf"], [1, "filter-item"], [1, "text-muted"], [1, "filter-item-search"], ["type", "text", "placeholder", "- type -", 1, "form-control", "mb-2", "ng-valid", "ng-dirty", "ng-touched", 3, "ngModelChange", "keyup.enter", "ngModel"], ["icon", "pi pi-search", 3, "onClick", "rounded", "text"], ["icon", "pi pi-times", 3, "onClick", "rounded", "text"], [1, "filter-search"], ["class", "filter-item", 4, "ngIf"], ["class", "text-muted", 4, "ngIf"], [1, "mb-3"], ["class", "filter-children-container", 4, "ngIf"], ["class", "more-less", 4, "ngIf"], [1, "filter-children-container"], ["class", "filter-children", 4, "ngFor", "ngForOf"], [1, "filter-children"], ["href", "javascript:", 1, "link-icon", 3, "click", "ngClass"], [4, "ngIf"], ["href", "javascript:", 1, "link-icon", 3, "click"], [1, "more-less"], ["class", "more", "href", "javascript:", 3, "click", 4, "ngIf"], ["href", "javascript:", 1, "more", 3, "click"], [1, "simple-list", "list-unstyled"]], template: function FiFilterTermsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FiFilterTermsComponent_div_0_Template, 4, 2, "div", 0)(1, FiFilterTermsComponent_div_1_Template, 4, 2, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.search && (ctx.collectionForm.formConfig.viewConfig == null ? null : ctx.collectionForm.formConfig.viewConfig.showFilterTerms) && ctx.data.aggregations && ctx.data.aggregations.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.search && (ctx.collectionForm.formConfig.viewConfig == null ? null : ctx.collectionForm.formConfig.viewConfig.showFilterTerms) && ctx.data.aggregations && ctx.data.aggregations.length > 0);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgModel, i7.Button], styles: [".filter-item[_ngcontent-%COMP%]{margin-bottom:1em}.filter-item[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin-bottom:0!important}.filter-item[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-size:.9em}.filter-item[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:4px}.filter-item[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--primary-color)}.filter-item[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{cursor:pointer!important}a.more[_ngcontent-%COMP%]{font-size:.8em;color:var(--secondary-color)!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FiFilterTermsComponent, [{
        type: Component,
        args: [{ selector: 'fi-filter-terms', standalone: false, template: "<div class=\"filter-input mb-3\" *ngIf=\"search && collectionForm.formConfig.viewConfig?.showFilterTerms && data.aggregations && data.aggregations.length > 0\">\r\n\t<h5>{{ configService.getTranslation('filterterms.title') }}</h5>\r\n    <div *ngFor=\"let agg of data.aggregations\">\r\n        <div class=\"filter-item\">\r\n            <h6 class=\"text-muted\">{{agg.title}}</h6>\r\n            <div class=\"filter-item-search\">\r\n                <input type=\"text\" [(ngModel)]=\"value\" class=\"form-control mb-2 ng-valid ng-dirty ng-touched\" placeholder=\"- type -\" (keyup.enter)=\"onEnter($event,value)\">\r\n                <p-button icon=\"pi pi-search\" [rounded]=\"true\" [text]=\"true\" (onClick)=\"onEnter($event,value)\" />\r\n                <p-button icon=\"pi pi-times\" [rounded]=\"true\" [text]=\"true\" (onClick)=\"onEnter($event,null)\" />\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"filter-search\" *ngIf=\"!search && collectionForm.formConfig.viewConfig?.showFilterTerms && data.aggregations && data.aggregations.length > 0\">\r\n    <h5>{{ configService.getTranslation('filterterms.title') }}</h5>\r\n    <div *ngFor=\"let agg of data.aggregations\">\r\n        <div *ngIf=\"agg.aggregation.results && agg.aggregation.results.length > 0 && layout === 'horizontal'\" class=\"filter-item\">\r\n            <h6 *ngIf=\"!search\" class=\"text-muted\">{{agg.title}}</h6>\r\n            \r\n            <div class=\"mb-3\">\r\n                <div class=\"filter-children-container\" *ngIf=\"agg.aggregation.results.length <= 5\">\r\n                    <div class=\"filter-children\" *ngFor=\"let item of agg.aggregation.results\">                    \r\n                        <a class=\"link-icon\" ngClass=\"{{ 'facet ' + getTermId(item.key) }}\" (click)=\"searchTerm(agg,item.key)\" href=\"javascript:\">{{getTermProperty(item.key,'label')}}&nbsp;<span *ngIf=\"item.count\">({{item.count}})</span></a>\r\n                    </div>\r\n                </div>\r\n    \r\n                <div class=\"filter-children-container\" *ngIf=\"agg.aggregation.results.length > 5\">\r\n                    <ng-container *ngIf=\"!showMore\">\r\n                        <div class=\"filter-children\" *ngFor=\"let item of getItems(agg,0,5)\">                    \r\n                            <a class=\"link-icon\" (click)=\"searchTerm(agg,item.key)\" href=\"javascript:\">{{getTermProperty(item.key,'label')}}&nbsp;<span *ngIf=\"item.count\">({{item.count}})</span></a>\r\n                        </div>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"showMore\">\r\n                        <div class=\"filter-children\" *ngFor=\"let item of getItems(agg,0)\">                    \r\n                            <a class=\"link-icon\" (click)=\"searchTerm(agg,item.key)\" href=\"javascript:\">{{getTermProperty(item.key,'label')}}&nbsp;<span *ngIf=\"item.count\">({{item.count}})</span></a>\r\n                        </div>                    \r\n                    </ng-container>                \r\n                </div>\r\n    \r\n                <div class=\"more-less\" *ngIf=\"agg.aggregation.results.length > 5\">\r\n                    <p>\r\n                        <a class=\"more\" href=\"javascript:\" *ngIf=\"!showMore\" (click)=\"showMore=!showMore\"><span>{{ configService.getTranslation('filterterms.showmore') }}</span></a>\r\n                    </p>\r\n                    <p>\r\n                        <a class=\"more\" href=\"javascript:\" *ngIf=\"showMore\" (click)=\"showMore=!showMore\"><span>{{ configService.getTranslation('filterterms.showless') }}</span></a>\r\n                    </p>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div *ngIf=\"agg.aggregation.results && agg.aggregation.results.length > 0 && layout === 'vertical'\" class=\"filter-item\">\r\n            <h6 *ngIf=\"!search\" class=\"text-muted\">{{agg.title}}</h6>\r\n\r\n            <ng-container *ngIf=\"agg.aggregation.results.length <= 10\">\r\n                <ul class=\"simple-list list-unstyled\">\r\n                    <li *ngFor=\"let item of agg.aggregation.results\">\r\n                        <a class=\"link-icon\" ngClass=\"{{ 'facet ' + getTermId(item.key) }}\" (click)=\"searchTerm(agg,item.key)\" href=\"javascript:\">{{getTermProperty(item.key,'label')}}&nbsp;<span *ngIf=\"item.count\">({{item.count}})</span></a>\r\n                    </li>\r\n                </ul>\r\n            </ng-container>\r\n\r\n            <ng-container *ngIf=\"agg.aggregation.results.length > 10\">\r\n                <ng-container *ngIf=\"!showMore\">\r\n                    <ul class=\"simple-list list-unstyled\">\r\n                        <li *ngFor=\"let item of getItems(agg,0,10)\">\r\n                            <a class=\"link-icon\" ngClass=\"{{ 'facet ' + getTermId(item.key) }}\" (click)=\"searchTerm(agg,item.key)\" href=\"javascript:\">{{getTermProperty(item.key,'label')}}&nbsp;<span *ngIf=\"item.count\">({{item.count}})</span></a>\r\n                        </li>\r\n                    </ul>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"showMore\">\r\n                    <ul class=\"simple-list list-unstyled\">\r\n                        <li *ngFor=\"let item of getItems(agg,0)\">\r\n                            <a class=\"link-icon\" ngClass=\"{{ 'facet ' + getTermId(item.key) }}\" (click)=\"searchTerm(agg,item.key)\" href=\"javascript:\">{{getTermProperty(item.key,'label')}}&nbsp;<span *ngIf=\"item.count\">({{item.count}})</span></a>\r\n                        </li>\r\n                    </ul>\r\n                </ng-container>\r\n\r\n                <p>\r\n                    <a class=\"more\" href=\"javascript:\" *ngIf=\"!showMore\" (click)=\"showMore=!showMore\"><span>{{ configService.getTranslation('filterterms.showmore') }}</span></a>\r\n                </p>\r\n                <p>\r\n                    <a class=\"more\" href=\"javascript:\" *ngIf=\"showMore\" (click)=\"showMore=!showMore\"><span>{{ configService.getTranslation('filterterms.showless') }}</span></a>\r\n                </p>\r\n            </ng-container>\r\n        </div>\r\n    </div>\r\n</div>", styles: [".filter-item{margin-bottom:1em}.filter-item ul{margin-bottom:0!important}.filter-item ul li{font-size:.9em}.filter-item p{margin-bottom:4px}.filter-item p a{color:var(--primary-color)}.filter-item p a:hover{cursor:pointer!important}a.more{font-size:.8em;color:var(--secondary-color)!important}\n"] }]
    }], () => [{ type: i1.CollectionService }, { type: i1.SearchService }, { type: i1.ConfigurationService }, { type: i2.Router }, { type: i2.ActivatedRoute }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], collectionForm: [{
            type: Input
        }], data: [{
            type: Input
        }], parent: [{
            type: Input
        }], status: [{
            type: Input
        }], showinfo: [{
            type: Input
        }], pagination: [{
            type: Input
        }], layout: [{
            type: Input
        }], search: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FiFilterTermsComponent, { className: "FiFilterTermsComponent", filePath: "src/components/fi-filter-terms/fi-filter-terms.component.ts", lineNumber: 14 }); })();

const _c0$9 = (a0, a1, a2) => ({ total: a0, from: a1, to: a2 });
const _c1$2 = a0 => ({ total: a0 });
function FiListComponent_ng_container_0_div_1_h6_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("search.results-list.total", i0.ɵɵpureFunction3(1, _c0$9, ctx_r0.data.total, ctx_r0.data.from, ctx_r0.data.to)));
} }
function FiListComponent_ng_container_0_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "p-select", 9);
    i0.ɵɵtwoWayListener("ngModelChange", function FiListComponent_ng_container_0_div_1_div_3_Template_p_select_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.viewSwitcher.defaultView, $event) || ((ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.viewSwitcher).defaultView = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function FiListComponent_ng_container_0_div_1_div_3_Template_p_select_ngModelChange_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.onViewTypeChange()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.viewSwitcher.views);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.viewSwitcher.defaultView);
} }
function FiListComponent_ng_container_0_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
} }
function FiListComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, FiListComponent_ng_container_0_div_1_h6_2_Template, 2, 5, "h6", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, FiListComponent_ng_container_0_div_1_div_3_Template, 2, 2, "div", 5)(4, FiListComponent_ng_container_0_div_1_div_4_Template, 1, 0, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.getTotalsBarClass());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showinfo && ctx_r0.pagination === true && ctx_r0.data.total > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.configService.env.hosted === false && (ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.viewSwitcher == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.viewSwitcher.enabled) || ctx_r0.configService.env.hosted === true && (ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.viewSwitcher == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.viewSwitcher.enabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.collectionForm.formConfig.selectionEnabled);
} }
function FiListComponent_ng_container_0_div_2_h6_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("search.results-list-grouping.total", i0.ɵɵpureFunction1(1, _c1$2, ctx_r0.data.list.length)));
} }
function FiListComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 11);
    i0.ɵɵtemplate(2, FiListComponent_ng_container_0_div_2_h6_2_Template, 2, 3, "h6", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showinfo && ctx_r0.data.list);
} }
function FiListComponent_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("search.results.noresults"));
} }
function FiListComponent_ng_container_0_ng_container_4_div_1_standard_result_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "standard-result", 15);
    i0.ɵɵlistener("onClick", function FiListComponent_ng_container_0_ng_container_4_div_1_standard_result_1_Template_standard_result_onClick_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.resultClick($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("cardType", ctx_r0.cardType)("view", ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.viewSwitcher.defaultView)("enableClick", ctx_r0.enableClick)("dynamicForm", ctx_r0.collectionForm.form)("space", ctx_r0.space)("collection", ctx_r0.collection)("parent", ctx_r0.parent)("status", ctx_r0.status)("data", ctx_r0.data.list)("config", ctx_r0.collectionForm.formConfig.viewConfig)("collectionForm", ctx_r0.collectionForm);
} }
function FiListComponent_ng_container_0_ng_container_4_div_1_grouped_result_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "grouped-result", 16);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("dynamicForm", ctx_r0.collectionForm.form)("space", ctx_r0.space)("collection", ctx_r0.collection)("parent", ctx_r0.parent)("status", ctx_r0.status)("data", ctx_r0.data.list)("config", ctx_r0.collectionForm.formConfig.viewConfig);
} }
function FiListComponent_ng_container_0_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FiListComponent_ng_container_0_ng_container_4_div_1_standard_result_1_Template, 1, 11, "standard-result", 13)(2, FiListComponent_ng_container_0_ng_container_4_div_1_grouped_result_2_Template, 1, 7, "grouped-result", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r0.collectionForm.formConfig.viewConfig.grouping == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.grouping.groupedDisplay));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.collectionForm.formConfig.viewConfig.grouping == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.grouping.groupedDisplay);
} }
function FiListComponent_ng_container_0_ng_container_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "fi-template-renderer", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("template", ctx_r0.listResultTemplate)("space", ctx_r0.space)("collection", ctx_r0.collection)("collectionForm", ctx_r0.collectionForm)("data", ctx_r0.data.list);
} }
function FiListComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiListComponent_ng_container_0_ng_container_4_div_1_Template, 3, 2, "div", 0)(2, FiListComponent_ng_container_0_ng_container_4_div_2_Template, 2, 5, "div", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.listResultTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.listResultTemplate);
} }
function FiListComponent_ng_container_0_ng_container_5_pagination_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "pagination", 19);
    i0.ɵɵtwoWayListener("ngModelChange", function FiListComponent_ng_container_0_ng_container_5_pagination_1_Template_pagination_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r0.data.searchRequest.page, $event) || (ctx_r0.data.searchRequest.page = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("pageChanged", function FiListComponent_ng_container_0_ng_container_5_pagination_1_Template_pagination_pageChanged_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.pageChanged($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.data.searchRequest.page);
    i0.ɵɵproperty("maxSize", ctx_r0.data.maxSize)("boundaryLinks", true)("itemsPerPage", ctx_r0.data.itemsPerPage)("totalItems", ctx_r0.data.paginationItems);
} }
function FiListComponent_ng_container_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiListComponent_ng_container_0_ng_container_5_pagination_1_Template, 1, 5, "pagination", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.paginationItems > ctx_r0.data.itemsPerPage);
} }
function FiListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiListComponent_ng_container_0_div_1_Template, 5, 4, "div", 1)(2, FiListComponent_ng_container_0_div_2_Template, 3, 1, "div", 1)(3, FiListComponent_ng_container_0_div_3_Template, 3, 1, "div", 0)(4, FiListComponent_ng_container_0_ng_container_4_Template, 3, 2, "ng-container", 0)(5, FiListComponent_ng_container_0_ng_container_5_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ((ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.showSearchResults) === undefined || (ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.showSearchResults)) && ctx_r0.pagination === true && !(ctx_r0.collectionForm.formConfig.viewConfig.grouping == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.grouping.groupedDisplay));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.collectionForm.formConfig.viewConfig.grouping == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.grouping.groupedDisplay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.list && ctx_r0.data.total === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.data.total > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.pagination === true && !(ctx_r0.collectionForm.formConfig.viewConfig.grouping == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.grouping.groupedDisplay));
} }
function FiListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵtext(2, "No data available");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
class FiListComponent {
    constructor(collectionService, searchService, router, activatedRoute, configService, templateService) {
        this.collectionService = collectionService;
        this.searchService = searchService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.configService = configService;
        this.templateService = templateService;
        this.showinfo = true;
        this.pagination = true;
        this.enableClick = false;
        this.onClick = new EventEmitter();
        this.pageReady = false;
    }
    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(queryParams => {
            this.listTemplate = queryParams.listTemplate;
            this.detailTemplate = queryParams.detailTemplate;
            this.listConfig = queryParams.listConfig;
            if (!this.collectionForm) {
                this.collectionService.getCollection(this.space, this.collection).subscribe(res => {
                    this.collectionForm = res;
                    this.setQueryParams(queryParams);
                    this.getResultTemplate(() => {
                        this.cardType = this.collectionForm?.formConfig.viewConfig?.viewSwitcher?.views.filter(item => item.type === this.collectionForm?.formConfig.viewConfig?.viewSwitcher?.defaultView)[0].template;
                        this.pageReady = true;
                    });
                }, err => {
                    this.searchService.manageError(err, 'Error extracting collections from space ' + this.space);
                });
            }
            else {
                this.setQueryParams(queryParams);
                this.getResultTemplate(() => {
                    this.pageReady = true;
                });
            }
        });
    }
    setQueryParams(queryParams) {
        if (queryParams.view) {
            this.collectionForm.formConfig.viewConfig.defaultView = queryParams.view;
        }
        this.setCardType();
    }
    getResultTemplate(callback) {
        if (this.listResultTemplateId) {
            this.templateService.getTemplateByIdCompressed(this.space, this.collection, 'result', this.listResultTemplateId).subscribe(res => {
                this.listResultTemplate = res;
                if (callback) {
                    callback();
                }
            });
        }
        else {
            if (callback) {
                callback();
            }
        }
    }
    onViewTypeChange() {
        this.setCardType();
        this.redirect();
    }
    setCardType() {
        this.cardType = this.collectionForm?.formConfig.viewConfig?.viewSwitcher?.views.filter(item => item.type === this.collectionForm?.formConfig.viewConfig?.viewSwitcher?.defaultView)[0].template;
    }
    getTotalsBarClass() {
        let size = 12;
        if (this.collectionForm?.formConfig.selectionEnabled) {
            size = size - 1;
        }
        if ((this.configService.env.hosted === false) || (this.configService.env.hosted === true && this.collectionForm?.formConfig.viewConfig?.viewSwitcher?.enabled)) {
            size = size - 2;
        }
        return "col-md-" + size;
    }
    pageChanged(event) {
        this.data.searchRequest.page = event.page;
        this.redirect();
    }
    redirect() {
        let queryParams = {
            page: this.data.searchRequest.page,
            q: this.data.searchRequest.q,
            f: ListDirective.stringifyAdvancedParams(this.configService, this.data.searchRequest.f, this.configService.env.advancedSearch.multiple.separator),
            o: ListDirective.stringifyAdvancedParams(this.configService, this.data.searchRequest.o, this.configService.env.advancedSearch.multiple.separator),
            g: ListDirective.stringifyGeospatialParams(this.configService, this.data.searchRequest.g, this.configService.env.advancedSearch.multiple.separator),
            sort: this.data.searchRequest.sort,
            collections: this.data.searchRequest.collections,
            lang: this.data.searchRequest.lang,
            view: this.collectionForm?.formConfig.viewConfig?.viewSwitcher.defaultView,
            cardType: this.cardType
        };
        if (this.listTemplate) {
            queryParams.listTemplate = this.listTemplate;
        }
        if (this.detailTemplate) {
            queryParams.detailTemplate = this.detailTemplate;
        }
        if (this.listConfig) {
            queryParams.listConfig = this.listConfig;
        }
        if (!this.activatedRoute.parent) {
            if (this.router.url.includes('?')) {
                this.router.navigate([this.router.url.substring(0, this.router.url.indexOf('?'))], {
                    fragment: 'search',
                    queryParams: queryParams
                });
            }
            else {
                this.router.navigate([this.router.url], {
                    queryParams: queryParams
                });
            }
        }
        else {
            if (this.router.url.includes('?')) {
                this.router.navigate(['./'], {
                    relativeTo: this.activatedRoute,
                    fragment: 'search',
                    queryParams: queryParams
                });
            }
            else {
                this.router.navigate(['./'], {
                    relativeTo: this.activatedRoute,
                    queryParams: queryParams
                });
            }
        }
    }
    resultClick(event) {
        this.onClick.emit(event);
    }
    static { this.ɵfac = function FiListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FiListComponent)(i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.TemplateService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FiListComponent, selectors: [["fi-list"]], inputs: { space: "space", collection: "collection", collectionForm: "collectionForm", listResultTemplateId: "listResultTemplateId", data: "data", parent: "parent", status: "status", showinfo: "showinfo", pagination: "pagination", enableClick: "enableClick" }, outputs: { onClick: "onClick" }, standalone: false, decls: 2, vars: 2, consts: [[4, "ngIf"], ["class", "row results-header mb-2", 4, "ngIf"], [1, "row", "results-header", "mb-2"], [1, "align-vertical-center", 3, "ngClass"], ["class", "title-category", 4, "ngIf"], ["class", "col-md-2", 4, "ngIf"], ["class", "col-md-1 align-right", 4, "ngIf"], [1, "title-category"], [1, "col-md-2"], ["appendTo", "body", "optionValue", "type", "optionLabel", "type", "placeholder", "(none)", 3, "ngModelChange", "options", "ngModel"], [1, "col-md-1", "align-right"], [1, "col-md-12"], [1, "lead"], [3, "cardType", "view", "enableClick", "dynamicForm", "space", "collection", "parent", "status", "data", "config", "collectionForm", "onClick", 4, "ngIf"], [3, "dynamicForm", "space", "collection", "parent", "status", "data", "config", 4, "ngIf"], [3, "onClick", "cardType", "view", "enableClick", "dynamicForm", "space", "collection", "parent", "status", "data", "config", "collectionForm"], [3, "dynamicForm", "space", "collection", "parent", "status", "data", "config"], [3, "template", "space", "collection", "collectionForm", "data"], ["class", "mt-4 justify-content-center", "previousText", "\u2039", "nextText", "\u203A", "firstText", "\u00AB", "lastText", "\u00BB", 3, "ngModel", "maxSize", "boundaryLinks", "itemsPerPage", "totalItems", "ngModelChange", "pageChanged", 4, "ngIf"], ["previousText", "\u2039", "nextText", "\u203A", "firstText", "\u00AB", "lastText", "\u00BB", 1, "mt-4", "justify-content-center", 3, "ngModelChange", "pageChanged", "ngModel", "maxSize", "boundaryLinks", "itemsPerPage", "totalItems"], [1, "no-data-found"]], template: function FiListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FiListComponent_ng_container_0_Template, 6, 5, "ng-container", 0)(1, FiListComponent_ng_container_1_Template, 3, 0, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.pageReady && ctx.data && ctx.data.list && ctx.data.list.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.pageReady && (!ctx.data || !ctx.data.list || ctx.data.list.length === 0));
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FiListComponent, [{
        type: Component,
        args: [{ selector: 'fi-list', standalone: false, template: "<ng-container *ngIf=\"pageReady && data && data.list && data.list.length > 0\">\r\n    <div class=\"row results-header mb-2\" *ngIf=\"(collectionForm.formConfig.viewConfig?.showSearchResults === undefined || collectionForm.formConfig.viewConfig?.showSearchResults) && pagination === true && !collectionForm.formConfig.viewConfig.grouping?.groupedDisplay\">\r\n        <div class=\"align-vertical-center\" [ngClass]=\"getTotalsBarClass()\">\r\n            <h6 class=\"title-category\" *ngIf=\"showinfo && pagination === true && data.total > 0\">{{ configService.getTranslation('search.results-list.total',{ total: data.total, from: data.from, to: data.to }) }}</h6>\r\n        </div>\r\n        <div class=\"col-md-2\" *ngIf=\"(configService.env.hosted === false && collectionForm.formConfig.viewConfig?.viewSwitcher?.enabled) || (configService.env.hosted === true && collectionForm.formConfig.viewConfig?.viewSwitcher?.enabled)\">\r\n            <p-select appendTo=\"body\" [options]=\"collectionForm.formConfig.viewConfig?.viewSwitcher.views\" [(ngModel)]=\"collectionForm.formConfig.viewConfig?.viewSwitcher.defaultView\" optionValue=\"type\" optionLabel=\"type\" (ngModelChange)=\"onViewTypeChange()\" placeholder=\"(none)\"></p-select>\r\n        </div>\r\n        <div class=\"col-md-1 align-right\" *ngIf=\"collectionForm.formConfig.selectionEnabled\">\r\n            <!-- <userselection-buttons [space]=\"space\" [collection]=\"collection\" [disabled]=\"noSelections()\"></userselection-buttons> -->\r\n        </div>\r\n    </div>\r\n    <div class=\"row results-header mb-2\" *ngIf=\"collectionForm.formConfig.viewConfig.grouping?.groupedDisplay\">\r\n        <div class=\"col-md-12\">\r\n            <h6 class=\"title-category\" *ngIf=\"showinfo && data.list\">{{ configService.getTranslation('search.results-list-grouping.total',{ total: data.list.length }) }}</h6>\r\n        </div>        \r\n    </div>\r\n    <div *ngIf=\"data.list && data.total === 0\">\r\n        <p class=\"lead\">{{ configService.getTranslation('search.results.noresults') }}</p>\r\n    </div>\r\n    <ng-container *ngIf=\"data.total > 0\">\r\n        <div *ngIf=\"!listResultTemplate\">\r\n            <standard-result *ngIf=\"!collectionForm.formConfig.viewConfig.grouping?.groupedDisplay\" [cardType]=\"cardType\" [view]=\"collectionForm.formConfig.viewConfig?.viewSwitcher.defaultView\" [enableClick]=\"enableClick\" (onClick)=\"resultClick($event)\" [dynamicForm]=\"collectionForm.form\" [space]=\"space\" [collection]=\"collection\" [parent]=\"parent\" [status]=\"status\" [data]=\"data.list\" [config]=\"collectionForm.formConfig.viewConfig\" [collectionForm]=\"collectionForm\"></standard-result>\r\n            <grouped-result *ngIf=\"collectionForm.formConfig.viewConfig.grouping?.groupedDisplay\" [dynamicForm]=\"collectionForm.form\" [space]=\"space\" [collection]=\"collection\" [parent]=\"parent\" [status]=\"status\" [data]=\"data.list\" [config]=\"collectionForm.formConfig.viewConfig\"></grouped-result>\r\n        </div>\r\n        <div *ngIf=\"listResultTemplate\">\r\n            <fi-template-renderer \r\n                [template]=\"listResultTemplate\" \r\n                [space]=\"space\" \r\n                [collection]=\"collection\" \r\n                [collectionForm]=\"collectionForm\" \r\n                [data]=\"data.list\">\r\n            </fi-template-renderer>\r\n        </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"pagination === true && !collectionForm.formConfig.viewConfig.grouping?.groupedDisplay\">\r\n        <pagination *ngIf=\"data.paginationItems > data.itemsPerPage\" [(ngModel)]=\"data.searchRequest.page\" class=\"mt-4 justify-content-center\"\r\n            [maxSize]=\"data.maxSize\" [boundaryLinks]=\"true\" [itemsPerPage]=\"data.itemsPerPage\" [totalItems]=\"data.paginationItems\"\r\n            (pageChanged)=\"pageChanged($event)\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n            lastText=\"&raquo;\"></pagination>\r\n    </ng-container>\r\n</ng-container>\r\n\r\n<ng-container *ngIf=\"pageReady && (!data || !data.list || data.list.length === 0)\">\r\n  <div class=\"no-data-found\" >No data available</div>\r\n</ng-container>\r\n" }]
    }], () => [{ type: i1.CollectionService }, { type: i1.SearchService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.ConfigurationService }, { type: i1.TemplateService }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], collectionForm: [{
            type: Input
        }], listResultTemplateId: [{
            type: Input
        }], data: [{
            type: Input
        }], parent: [{
            type: Input
        }], status: [{
            type: Input
        }], showinfo: [{
            type: Input
        }], pagination: [{
            type: Input
        }], enableClick: [{
            type: Input
        }], onClick: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FiListComponent, { className: "FiListComponent", filePath: "src/components/fi-list/fi-list.component.ts", lineNumber: 14 }); })();

function FiSearchPillsComponent_div_0_ng_container_2_div_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function FiSearchPillsComponent_div_0_ng_container_2_div_1_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const item_r3 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r3.removeFilter(item_r3)); });
    i0.ɵɵelement(1, "i", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 12);
    i0.ɵɵtext(4, "\u00D7");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.getPillLabel(item_r3.key) + ": " + ctx_r3.getPillValue(item_r3), " ");
} }
function FiSearchPillsComponent_div_0_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FiSearchPillsComponent_div_0_ng_container_2_div_1_button_1_Template, 5, 1, "button", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.key);
} }
function FiSearchPillsComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiSearchPillsComponent_div_0_ng_container_2_div_1_Template, 2, 1, "div", 8);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.items);
} }
function FiSearchPillsComponent_div_0_ng_container_3_div_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function FiSearchPillsComponent_div_0_ng_container_3_div_1_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const geoitem_r6 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r3.removeGeoFilter(geoitem_r6)); });
    i0.ɵɵelement(1, "i", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 13);
    i0.ɵɵtext(4, "\u00A0 ");
    i0.ɵɵelementStart(5, "span", 12);
    i0.ɵɵtext(6, "\u00D7");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const geoitem_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.getGeoPillLabel(geoitem_r6.key) + ": ", " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", geoitem_r6.value);
} }
function FiSearchPillsComponent_div_0_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FiSearchPillsComponent_div_0_ng_container_3_div_1_button_1_Template, 7, 2, "button", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const geoitem_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", geoitem_r6.key);
} }
function FiSearchPillsComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FiSearchPillsComponent_div_0_ng_container_3_div_1_Template, 2, 1, "div", 8);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.geoitems);
} }
function FiSearchPillsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, FiSearchPillsComponent_div_0_ng_container_2_Template, 2, 1, "ng-container", 3)(3, FiSearchPillsComponent_div_0_ng_container_3_Template, 2, 1, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4)(5, "button", 5);
    i0.ɵɵlistener("click", function FiSearchPillsComponent_div_0_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r1); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.clear()); });
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵelement(7, "i", 7);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.items && ctx_r3.items.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.geoitems && ctx_r3.geoitems.length > 0);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("\u00A0", ctx_r3.configService.getTranslation("common.advanced-search.clear-all-button"), "");
} }
class FiSearchPillsComponent {
    constructor(utilsService, router, activatedRoute, configService, dynamicFormControlService, collectionService, searchService, propertiesService, listConfigService) {
        this.utilsService = utilsService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.configService = configService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.collectionService = collectionService;
        this.searchService = searchService;
        this.propertiesService = propertiesService;
        this.listConfigService = listConfigService;
        this.loading = false;
    }
    ngOnInit() {
        if (!this.collectionForm) {
            this.getCollectionInfo(() => {
                this.init();
            });
        }
        else {
            this.init();
        }
    }
    init() {
        this.activatedRoute.params.subscribe(params => {
            this.params = params;
            if (!this.data) {
                this.data = {};
                this.activatedRoute.queryParams.subscribe(queryParams => {
                    this.listTemplate = queryParams.listTemplate;
                    this.detailTemplate = queryParams.detailTemplate;
                    this.listConfig = queryParams.listConfig;
                    this.view = queryParams.view;
                    this.data.searchRequest = ListDirective.parsePageRequest(this.configService.env.advancedSearch, queryParams);
                    this.items = this.setPills(this.data.searchRequest.f);
                    this.geoitems = this.setGeoPills(this.data.searchRequest.g);
                });
            }
            else {
                this.activatedRoute.queryParams.subscribe(queryParams => {
                    this.listTemplate = queryParams.listTemplate;
                    this.detailTemplate = queryParams.detailTemplate;
                    this.listConfig = queryParams.listConfig;
                    this.view = queryParams.view;
                });
                this.items = this.setPills(this.data.searchRequest?.f);
                this.geoitems = this.setGeoPills(this.data.searchRequest?.g);
            }
        });
    }
    getCollectionInfo(callback) {
        forkJoin([
            this.collectionService.getCollection(this.space, this.collection),
            this.collectionService.getCollectionConfig(this.space, this.collection),
            this.propertiesService.getCollectionProperties(this.space, this.collection, this.configService.env.currentLang)
        ]).subscribe((results) => {
            results[0].form = this.configService.enrichGlobalParams(this.space, results[0].roleType, results[0].form, 'edit');
            if (results[1].selectionEnabled && !this.configService.isLoggedIn()) {
                results[1].selectionEnabled = false;
            }
            this.collectionForm = results[0];
            this.collectionForm.formConfig = ListDirective.initFormConfig(results[1]);
            this.propertiesService.getGlobalProperties(this.space, this.configService.env.currentLang).subscribe(globalProperties => {
                this.collectionForm.form.properties = this.propertiesService.merge(globalProperties, results[2]);
                this.configService.enrichProperties(this.collectionForm?.form.properties);
            }, error => {
                this.configService.enrichProperties(this.collectionForm?.form.properties);
            });
            let config = this.collectionForm?.formConfig.resultPages ? this.collectionForm?.formConfig.resultPages[0] : (this.collectionForm?.formConfig.resultsPageConfig?.length > 0 ? this.collectionForm?.formConfig.resultsPageConfig[0] : null);
            this.listConfigService.getListconfigById(this.space, this.collection, config).subscribe(res => {
                this.collectionForm.formConfig.viewConfig = res;
                ListDirective.enrichFilters(this.configService, this.collectionForm?.formConfig.viewConfig);
                callback();
            }, err => {
                this.searchService.manageError(err, 'Error extracting list page configuration ' + config);
            });
        }, (err) => {
            this.loading = false;
            this.searchService.manageError(err, 'Error reading collection info for ' + this.collection);
        });
    }
    getTermProperty(term, prop) {
        return ListDirective.getTermProperty(this.configService, this.configService.env.advancedSearch.termConcatenator, term, prop);
    }
    setPills(f) {
        let items = [];
        for (let key in f) {
            let values = f[key].split(new RegExp(this.configService.env.advancedSearch.multiple.regexp));
            for (let i = 0; i < values.length; i++) {
                items.push({
                    key: key,
                    value: values[i]
                });
            }
        }
        return items;
    }
    setGeoPills(f) {
        let items = [];
        for (let key in f) {
            items.push({
                key: key,
                type: f[key].geoShape?.type,
                value: f[key].geoShape?.coordinates,
                g: f[key]
            });
        }
        return items;
    }
    getPills(items) {
        let filter = {};
        for (let i = 0; i < items.length; i++) {
            if (!filter[items[i].key]) {
                filter[items[i].key] = items[i].value;
            }
            else {
                filter[items[i].key] = filter[items[i].key] + this.configService.env.advancedSearch.multiple.separator + items[i].value;
            }
        }
        return filter;
    }
    getGeoPills(items) {
        let filter = {};
        for (let i = 0; i < items.length; i++) {
            filter[items[i].key] = items[i].g;
        }
        return filter;
    }
    removeFilter(item) {
        let index = this.items.findIndex(f => f.key === item.key && f.value === item.value);
        if (index >= 0) {
            this.items.splice(index, 1);
        }
        this.data.searchRequest.page = 1;
        this.data.searchRequest.f = this.getPills(this.items);
        this.redirect();
    }
    removeGeoFilter(item) {
        let index = this.geoitems.findIndex(f => f.key === item.key && f.value === item.value);
        if (index >= 0) {
            this.geoitems.splice(index, 1);
        }
        this.data.searchRequest.page = 1;
        this.data.searchRequest.g = this.getGeoPills(this.geoitems);
        this.redirect();
    }
    redirect() {
        let queryParams = {
            page: this.data.searchRequest.page,
            q: this.data.searchRequest.q,
            f: ListDirective.stringifyAdvancedParams(this.configService, this.data.searchRequest.f, this.configService.env.advancedSearch.multiple.separator),
            o: ListDirective.stringifyAdvancedParams(this.configService, this.data.searchRequest.o, this.configService.env.advancedSearch.multiple.separator),
            g: ListDirective.stringifyGeospatialParams(this.configService, this.data.searchRequest.g, this.configService.env.advancedSearch.multiple.separator),
            sort: this.data.searchRequest.sort
        };
        if (this.view) {
            queryParams.view = this.view;
        }
        if (this.listTemplate) {
            queryParams.listTemplate = this.listTemplate;
        }
        if (this.detailTemplate) {
            queryParams.detailTemplate = this.detailTemplate;
        }
        if (this.listConfig) {
            queryParams.listConfig = this.listConfig;
        }
        this.router.navigate([(this.params.param && this.params.value) ? '../../search' : './'], {
            relativeTo: this.activatedRoute,
            fragment: 'search',
            queryParams: queryParams
        });
    }
    getGeoPillLabel(term) {
        let index = this.collectionForm?.formConfig?.viewConfig?.geoSearch?.findIndex(item => item.name === term);
        if (index >= 0) {
            return this.dynamicFormControlService.getProperty(null, this.collectionForm?.form, { refPropertiesId: this.collectionForm?.formConfig.viewConfig.geoSearch[index].refPropertiesId, code: this.collectionForm?.formConfig.viewConfig.geoSearch[index].name }, 'label');
        }
        else {
            let index = this.collectionForm?.formConfig?.viewConfig?.filters?.findIndex(item => item.name === term);
            if (index >= 0) {
                return this.dynamicFormControlService.getProperty(null, this.collectionForm?.form, { refPropertiesId: this.collectionForm?.formConfig.viewConfig.filters[index].refPropertiesId, code: this.collectionForm?.formConfig.viewConfig.filters[index].name }, 'label');
            }
            else {
                return this.configService.getTranslation(term) || term;
            }
        }
    }
    getPillLabel(term) {
        let index = this.collectionForm?.formConfig?.viewConfig?.advancedSearch?.findIndex(item => item.name === term);
        if (index >= 0) {
            return this.dynamicFormControlService.getProperty(null, this.collectionForm?.form, { refPropertiesId: this.collectionForm?.formConfig.viewConfig.advancedSearch[index].refPropertiesId, code: this.collectionForm?.formConfig.viewConfig.advancedSearch[index].name }, 'label');
        }
        else {
            index = this.collectionForm?.formConfig?.viewConfig?.facets?.findIndex(item => item.name === term);
            if (index >= 0) {
                return this.dynamicFormControlService.getProperty(null, this.collectionForm?.form, { refPropertiesId: this.collectionForm?.formConfig.viewConfig.facets[index].refPropertiesId, code: this.collectionForm?.formConfig.viewConfig.facets[index].name }, 'label');
            }
            else {
                index = this.collectionForm?.formConfig?.viewConfig?.geoSearch?.findIndex(item => item.name === term);
                if (index >= 0) {
                    return this.dynamicFormControlService.getProperty(null, this.collectionForm?.form, { refPropertiesId: this.collectionForm?.formConfig.viewConfig.geoSearch[index].refPropertiesId, code: this.collectionForm?.formConfig.viewConfig.geoSearch[index].name }, 'label');
                }
                else {
                    index = this.collectionForm?.formConfig?.viewConfig?.filters?.findIndex(item => item.name === term);
                    if (index >= 0) {
                        return this.dynamicFormControlService.getProperty(null, this.collectionForm?.form, { refPropertiesId: this.collectionForm?.formConfig.viewConfig.filters[index].refPropertiesId, code: this.collectionForm?.formConfig.viewConfig.filters[index].name }, 'label');
                    }
                    else {
                        return term;
                    }
                }
            }
        }
    }
    getPillValue(term) {
        return ListDirective.getTermProperty(this.configService, this.configService.env.advancedSearch.termConcatenator, term.value, "label");
    }
    clear() {
        this.data.searchRequest.page = 1;
        this.data.searchRequest.q = undefined;
        this.data.searchRequest.f = undefined;
        this.data.searchRequest.g = undefined;
        this.redirect();
    }
    static { this.ɵfac = function FiSearchPillsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FiSearchPillsComponent)(i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i1.PropertiesService), i0.ɵɵdirectiveInject(i1.ListConfigService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FiSearchPillsComponent, selectors: [["fi-search-pills"]], inputs: { space: "space", collection: "collection", collectionForm: "collectionForm", data: "data", items: "items", geoitems: "geoitems" }, standalone: false, decls: 1, vars: 1, consts: [["class", "pills mt-2", 4, "ngIf"], [1, "pills", "mt-2"], [1, "pills-container"], [4, "ngIf"], [1, "clear-all", "align-right"], ["type", "button", 1, "btn", "btn-light", "btn-clear-all", "btn-sm", 3, "click"], [1, "pills"], [1, "bi", "bi-x-lg"], [4, "ngFor", "ngForOf"], ["class", "filter-pill", 3, "click", 4, "ngIf"], [1, "filter-pill", 3, "click"], [1, "bi", "bi-filter"], [1, "ml-2", "text-muted", "pointer"], [1, "fa-regular", "fa-draw-polygon", "polygon-pill", 3, "title"]], template: function FiSearchPillsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, FiSearchPillsComponent_div_0_Template, 9, 3, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.searchRequest) && ((ctx.data == null ? null : ctx.data.searchRequest.f) && ctx.items && ctx.items.length > 0 || (ctx.data == null ? null : ctx.data.searchRequest.g) && ctx.geoitems && ctx.geoitems.length > 0));
        } }, dependencies: [i3.NgForOf, i3.NgIf], styles: [".pills[_ngcontent-%COMP%]{display:flex;white-space:nowrap}.pills-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;margin-bottom:1em}.polygon-pill[_ngcontent-%COMP%]{color:#0eb064}.search-pill[_ngcontent-%COMP%]{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;font-size:1rem;line-height:1.25;transition:all .15s ease-in-out;border-radius:2rem;padding:.4rem .5rem;color:var(--default-font-color);background-color:var(--hover-background-color);border-color:var(--hover-border-color)}.search-pill[_ngcontent-%COMP%]:hover{background-color:var(--hover-background-color)}.search-pill[_ngcontent-%COMP%]:focus{outline:none}.clear-all[_ngcontent-%COMP%]{flex-grow:1;padding-top:.35em}.filter-pill[_ngcontent-%COMP%]{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;font-size:.9rem;transition:all .15s ease-in-out;border-radius:2rem;margin-right:.5em;padding:.4rem;color:var(--default-font-color);background-color:var(--hover-background-color);border-color:var(--hover-border-color);margin-bottom:.5em}.filter-pill[_ngcontent-%COMP%]:hover{background-color:var(--hover-background-color);border-color:var(--hover-border-color)}.filter-pill[_ngcontent-%COMP%]:focus{outline:none}.btn-clear-all[_ngcontent-%COMP%]{color:var(--default-font-color);background-color:var(--hover-background-color);border-color:var(--hover-border-color)}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FiSearchPillsComponent, [{
        type: Component,
        args: [{ selector: 'fi-search-pills', standalone: false, template: "<div class=\"pills mt-2\" *ngIf=\"data?.searchRequest && ((data?.searchRequest.f && items && items.length > 0) || (data?.searchRequest.g && geoitems && geoitems.length > 0))\">\r\n    <div class=\"pills-container\">\r\n\r\n        <ng-container *ngIf=\"items && items.length > 0\">\r\n            <div *ngFor=\"let item of items\">\r\n                <button class=\"filter-pill\" (click)=\"removeFilter(item)\" *ngIf=\"item.key\">\r\n                    <i class=\"bi bi-filter\"></i>\r\n                    {{ getPillLabel(item.key) + ': ' + getPillValue(item)}}\r\n                    <span class=\"ml-2 text-muted pointer\">\u00D7</span>\r\n                </button>\r\n            </div>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"geoitems && geoitems.length > 0\">\r\n            <div *ngFor=\"let geoitem of geoitems\">\r\n                <button class=\"filter-pill\" (click)=\"removeGeoFilter(geoitem)\" *ngIf=\"geoitem.key\">\r\n                    <i class=\"bi bi-filter\"></i>\r\n                    {{ getGeoPillLabel(geoitem.key) + ': ' }}\r\n                    <i class=\"fa-regular fa-draw-polygon polygon-pill\" title=\"{{geoitem.value}}\"></i>&nbsp;\r\n                    <span class=\"ml-2 text-muted pointer\">\u00D7</span>\r\n                </button>\r\n            </div>\r\n        </ng-container>\r\n\r\n    </div>\r\n    <div class=\"clear-all align-right\">\r\n        <button class=\"btn btn-light btn-clear-all btn-sm\" type=\"button\" (click)=\"clear()\"><div class=\"pills\"><i class=\"bi bi-x-lg\"></i>&nbsp;{{ configService.getTranslation('common.advanced-search.clear-all-button') }}</div></button>\r\n    </div>\r\n</div>", styles: [".pills{display:flex;white-space:nowrap}.pills-container{display:flex;flex-direction:row;flex-wrap:wrap;margin-bottom:1em}.polygon-pill{color:#0eb064}.search-pill{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;font-size:1rem;line-height:1.25;transition:all .15s ease-in-out;border-radius:2rem;padding:.4rem .5rem;color:var(--default-font-color);background-color:var(--hover-background-color);border-color:var(--hover-border-color)}.search-pill:hover{background-color:var(--hover-background-color)}.search-pill:focus{outline:none}.clear-all{flex-grow:1;padding-top:.35em}.filter-pill{display:inline-block;font-weight:400;text-align:center;white-space:nowrap;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid transparent;font-size:.9rem;transition:all .15s ease-in-out;border-radius:2rem;margin-right:.5em;padding:.4rem;color:var(--default-font-color);background-color:var(--hover-background-color);border-color:var(--hover-border-color);margin-bottom:.5em}.filter-pill:hover{background-color:var(--hover-background-color);border-color:var(--hover-border-color)}.filter-pill:focus{outline:none}.btn-clear-all{color:var(--default-font-color);background-color:var(--hover-background-color);border-color:var(--hover-border-color)}\n"] }]
    }], () => [{ type: i1.UtilsService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.ConfigurationService }, { type: i1.DynamicFormControlService }, { type: i1.CollectionService }, { type: i1.SearchService }, { type: i1.PropertiesService }, { type: i1.ListConfigService }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], collectionForm: [{
            type: Input
        }], data: [{
            type: Input
        }], items: [{
            type: Input
        }], geoitems: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FiSearchPillsComponent, { className: "FiSearchPillsComponent", filePath: "src/components/fi-search-pills/fi-search-pills.component.ts", lineNumber: 15 }); })();

class FlagComponent {
    constructor() { }
    ngOnInit() {
        if (this.width > '') {
            this.style = 'width: ' + this.width + 'px;';
        }
        this.value = this.iso3.toLowerCase();
    }
    static { this.ɵfac = function FlagComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FlagComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FlagComponent, selectors: [["flag"]], inputs: { iso3: "iso3", width: "width" }, standalone: false, decls: 1, vars: 4, consts: [["alt", "Flag", 3, "src"]], template: function FlagComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "img", 0);
        } if (rf & 2) {
            i0.ɵɵstyleMap(ctx.style);
            i0.ɵɵpropertyInterpolate1("src", "https://www.fao.org/fileadmin/assets/countries/flags/", ctx.value, ".gif", i0.ɵɵsanitizeUrl);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FlagComponent, [{
        type: Component,
        args: [{ selector: 'flag', standalone: false, template: "<img [style]=\"style\" src=\"https://www.fao.org/fileadmin/assets/countries/flags/{{value}}.gif\" alt=\"Flag\">" }]
    }], () => [], { iso3: [{
            type: Input
        }], width: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FlagComponent, { className: "FlagComponent", filePath: "src/components/flag/flag.component.ts", lineNumber: 9 }); })();

class ImageButtonComponent {
    constructor(utilsService, configService) {
        this.utilsService = utilsService;
        this.configService = configService;
        this.clicked = false;
        this.clickEvent = new EventEmitter();
    }
    ngOnInit() {
        this.url = this.configService.env.storageUrl + '/images/website/gearicons/';
        if (this.id.indexOf('_') > 0) {
            this.url = this.url + this.id.substring(0, this.id.indexOf('_')) + '.gif';
        }
        else {
            this.url = this.url + this.id + '.gif';
        }
    }
    onClick(event) {
        this.clicked = !this.clicked;
        this.clickEvent.emit({
            code: this.code,
            event: event
        });
    }
    static { this.ɵfac = function ImageButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImageButtonComponent)(i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImageButtonComponent, selectors: [["fi-image-button"]], inputs: { id: "id", code: "code", title: "title", clicked: "clicked", showCarousel: "showCarousel" }, outputs: { clickEvent: "clickEvent" }, standalone: false, decls: 2, vars: 2, consts: [[1, "link-container", 3, "ngClass"], [3, "click", "src"]], template: function ImageButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "img", 1);
            i0.ɵɵlistener("click", function ImageButtonComponent_Template_img_click_1_listener($event) { return ctx.onClick($event); });
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.clicked ? "clicked" : "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("src", ctx.utilsService.processUrl(null, ctx.url), i0.ɵɵsanitizeUrl);
        } }, dependencies: [i3.NgClass], styles: [".link-container[_ngcontent-%COMP%]{text-align:center;padding:.5em}.link-container[_ngcontent-%COMP%]:hover{cursor:pointer}.clicked[_ngcontent-%COMP%]{border:solid 1px var(--default-border-color);background-color:var(--default-background-color)}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageButtonComponent, [{
        type: Component,
        args: [{ selector: 'fi-image-button', standalone: false, template: "<div class=\"link-container\" [ngClass]=\"clicked ? 'clicked' : ''\">\r\n    <img [src]=\"utilsService.processUrl(null,url)\" (click)=\"onClick($event)\" />\r\n</div>", styles: [".link-container{text-align:center;padding:.5em}.link-container:hover{cursor:pointer}.clicked{border:solid 1px var(--default-border-color);background-color:var(--default-background-color)}\n"] }]
    }], () => [{ type: i1.UtilsService }, { type: i1.ConfigurationService }], { id: [{
            type: Input
        }], code: [{
            type: Input
        }], title: [{
            type: Input
        }], clicked: [{
            type: Input
        }], showCarousel: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ImageButtonComponent, { className: "ImageButtonComponent", filePath: "src/components/image-button/image-button.component.ts", lineNumber: 11 }); })();

function ImageGalleryModalComponent_div_0_div_2_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "a", 9);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_0_div_2_ng_container_1_div_1_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); const item_r3 = ctx_r1.$implicit; const i_r4 = ctx_r1.index; const ctx_r4 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r4.onThumbClick(item_r3.resource, i_r4)); });
    i0.ɵɵelement(2, "img", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r4.utilsService.processUrl(null, ctx_r4.getThumbnail(item_r3.resource).path), i0.ɵɵsanitizeUrl);
} }
function ImageGalleryModalComponent_div_0_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryModalComponent_div_0_div_2_ng_container_1_div_1_Template, 3, 1, "div", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.getThumbnail(item_r3.resource));
} }
function ImageGalleryModalComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, ImageGalleryModalComponent_div_0_div_2_ng_container_1_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.state.resources.galleryEntry);
} }
function ImageGalleryModalComponent_div_0_ng_container_3_div_3_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "a", 9);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_0_ng_container_3_div_3_ng_container_1_div_1_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r7 = i0.ɵɵnextContext(); const item_r9 = ctx_r7.$implicit; const i_r10 = ctx_r7.index; const ctx_r4 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r4.onThumbClick(item_r9.resource, i_r10)); });
    i0.ɵɵelement(2, "img", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r4.utilsService.processUrl(null, ctx_r4.getThumbnail(item_r9.resource).path), i0.ɵɵsanitizeUrl);
} }
function ImageGalleryModalComponent_div_0_ng_container_3_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryModalComponent_div_0_ng_container_3_div_3_ng_container_1_div_1_Template, 3, 1, "div", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.getThumbnail(item_r9.resource));
} }
function ImageGalleryModalComponent_div_0_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, ImageGalleryModalComponent_div_0_ng_container_3_div_3_ng_container_1_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r11 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("hidden", p_r11 !== ctx_r4.state.currentPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.getResourcesPage(p_r11));
} }
function ImageGalleryModalComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 11)(2, "div", 2);
    i0.ɵɵtemplate(3, ImageGalleryModalComponent_div_0_ng_container_3_div_3_Template, 2, 2, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 13)(5, "a", 14);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_0_ng_container_3_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r6); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.onFirstPage()); });
    i0.ɵɵelementStart(6, "span", 15);
    i0.ɵɵtext(7, "skip_previous");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "a", 16);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_0_ng_container_3_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r6); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.onPrevPage()); });
    i0.ɵɵelementStart(9, "span", 15);
    i0.ɵɵtext(10, "arrow_left");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "a", 16);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_0_ng_container_3_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r6); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.onNextPage()); });
    i0.ɵɵelementStart(12, "span", 15);
    i0.ɵɵtext(13, "arrow_right");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "a", 14);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_0_ng_container_3_Template_a_click_14_listener() { i0.ɵɵrestoreView(_r6); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.onLastPage()); });
    i0.ɵɵelementStart(15, "span", 15);
    i0.ɵɵtext(16, "skip_next");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r4.state.pageNumbers);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r4.prevDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r4.prevDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r4.nextDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r4.nextDisabled());
} }
function ImageGalleryModalComponent_div_0_ng_container_4_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r4.state.credits);
} }
function ImageGalleryModalComponent_div_0_ng_container_4_a_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 26)(1, "span", 15);
    i0.ɵɵtext(2, "file_download");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("title", ctx_r4.configService.getTranslation("image-gallery.download.pdf"));
    i0.ɵɵpropertyInterpolate("href", ctx_r4.utilsService.processUrl(null, item_r12.path), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r12.fileExt);
} }
function ImageGalleryModalComponent_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18)(2, "div", 19)(3, "div", 20);
    i0.ɵɵelement(4, "img", 21);
    i0.ɵɵelementStart(5, "div", 22)(6, "div", 23);
    i0.ɵɵtemplate(7, ImageGalleryModalComponent_div_0_ng_container_4_p_7_Template, 2, 1, "p", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 25)(9, "a", 26)(10, "span", 15);
    i0.ɵɵtext(11, "file_download");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(14, ImageGalleryModalComponent_div_0_ng_container_4_a_14_Template, 5, 3, "a", 27);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r13 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", i_r13 !== ctx_r4.state.selectedResourceIndex);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("src", ctx_r4.utilsService.processUrl(null, ctx_r4.getOriginalResource(i_r13).path), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.state.credits);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", ctx_r4.configService.getTranslation("image-gallery.download.full-size"));
    i0.ɵɵpropertyInterpolate("href", ctx_r4.utilsService.processUrl(null, ctx_r4.getOriginalResource(i_r13, true).path), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.getOriginalResource(i_r13).type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.getOthers(i_r13));
} }
function ImageGalleryModalComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, ImageGalleryModalComponent_div_0_div_2_Template, 2, 1, "div", 3)(3, ImageGalleryModalComponent_div_0_ng_container_3_Template, 17, 5, "ng-container", 4)(4, ImageGalleryModalComponent_div_0_ng_container_4_Template, 15, 7, "ng-container", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.state.resources.galleryEntry.length <= 10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.state.resources.galleryEntry.length > 10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.state.resources.galleryEntry);
} }
function ImageGalleryModalComponent_div_1_div_2_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "a", 9);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_1_div_2_ng_container_1_div_1_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r14 = i0.ɵɵnextContext(); const item_r16 = ctx_r14.$implicit; const i_r17 = ctx_r14.index; const ctx_r4 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r4.onThumbClick(item_r16, i_r17)); });
    i0.ɵɵelement(2, "img", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r4.getImageUrl(item_r16, "s"), i0.ɵɵsanitizeUrl);
} }
function ImageGalleryModalComponent_div_1_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryModalComponent_div_1_div_2_ng_container_1_div_1_Template, 3, 1, "div", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r16 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.getImageUrl(item_r16, "s"));
} }
function ImageGalleryModalComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, ImageGalleryModalComponent_div_1_div_2_ng_container_1_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.state.resources);
} }
function ImageGalleryModalComponent_div_1_ng_container_3_div_3_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "a", 9);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_1_ng_container_3_div_3_ng_container_1_div_1_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r19 = i0.ɵɵnextContext(); const item_r21 = ctx_r19.$implicit; const i_r22 = ctx_r19.index; const ctx_r4 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r4.onThumbClick(item_r21, i_r22)); });
    i0.ɵɵelement(2, "img", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r21 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r4.getImageUrl(item_r21, "s"), i0.ɵɵsanitizeUrl);
} }
function ImageGalleryModalComponent_div_1_ng_container_3_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryModalComponent_div_1_ng_container_3_div_3_ng_container_1_div_1_Template, 3, 1, "div", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r21 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.getImageUrl(item_r21, "s"));
} }
function ImageGalleryModalComponent_div_1_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, ImageGalleryModalComponent_div_1_ng_container_3_div_3_ng_container_1_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r23 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("hidden", p_r23 !== ctx_r4.state.currentPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.getResourcesPage(p_r23));
} }
function ImageGalleryModalComponent_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 11)(2, "div", 2);
    i0.ɵɵtemplate(3, ImageGalleryModalComponent_div_1_ng_container_3_div_3_Template, 2, 2, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 13)(5, "a", 14);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_1_ng_container_3_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r18); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.onFirstPage()); });
    i0.ɵɵelementStart(6, "span", 15);
    i0.ɵɵtext(7, "skip_previous");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "a", 16);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_1_ng_container_3_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r18); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.onPrevPage()); });
    i0.ɵɵelementStart(9, "span", 15);
    i0.ɵɵtext(10, "arrow_left");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "a", 16);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_1_ng_container_3_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r18); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.onNextPage()); });
    i0.ɵɵelementStart(12, "span", 15);
    i0.ɵɵtext(13, "arrow_right");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "a", 14);
    i0.ɵɵlistener("click", function ImageGalleryModalComponent_div_1_ng_container_3_Template_a_click_14_listener() { i0.ɵɵrestoreView(_r18); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.onLastPage()); });
    i0.ɵɵelementStart(15, "span", 15);
    i0.ɵɵtext(16, "skip_next");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r4.state.pageNumbers);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r4.prevDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r4.prevDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r4.nextDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r4.nextDisabled());
} }
function ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33)(1, "h6", 34);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const resource_r24 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(resource_r24.title);
} }
function ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_7_ng_container_5_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r24 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("href", resource_r24.source.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(resource_r24.source.citation);
} }
function ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_7_ng_container_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const resource_r24 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(resource_r24.source.citation);
} }
function ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_7_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_7_ng_container_5_a_1_Template, 2, 2, "a", 35)(2, ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_7_ng_container_5_ng_container_2_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const resource_r24 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", resource_r24.source.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !resource_r24.source.url);
} }
function ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_7_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const resource_r24 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", resource_r24.source, " ");
} }
function ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "p", 28)(2, "b");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵtemplate(5, ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_7_ng_container_5_Template, 3, 2, "ng-container", 4)(6, ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_7_ng_container_6_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const resource_r24 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.configService.getTranslation("common.image.credits"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.isSourceObject(resource_r24.source));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.isSourceObject(resource_r24.source));
} }
function ImageGalleryModalComponent_div_1_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "div", 19)(2, "div", 20)(3, "div", 22)(4, "div", 2);
    i0.ɵɵelement(5, "img", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_6_Template, 3, 1, "div", 31)(7, ImageGalleryModalComponent_div_1_ng_container_4_div_1_div_7_Template, 7, 3, "div", 32);
    i0.ɵɵelementStart(8, "div", 2)(9, "p", 28)(10, "b");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "br");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext();
    const resource_r24 = ctx_r24.$implicit;
    const i_r26 = ctx_r24.index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("src", ctx_r4.utilsService.processUrl(null, ctx_r4.getImageUrl(ctx_r4.getMediumResource(i_r26), "l")), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", resource_r24.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", resource_r24.source);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.configService.getTranslation("common.image.copyright"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.configService.getTranslation("common.image.copyright-text"), " ");
} }
function ImageGalleryModalComponent_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryModalComponent_div_1_ng_container_4_div_1_Template, 14, 5, "div", 29);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r26 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r26 === ctx_r4.state.selectedResourceIndex);
} }
function ImageGalleryModalComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, ImageGalleryModalComponent_div_1_div_2_Template, 2, 1, "div", 3)(3, ImageGalleryModalComponent_div_1_ng_container_3_Template, 17, 5, "ng-container", 4)(4, ImageGalleryModalComponent_div_1_ng_container_4_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.state.resources.length <= 10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.state.resources.length > 10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.state.resources);
} }
class ImageGalleryModalComponent {
    constructor(utilsService, configService) {
        this.utilsService = utilsService;
        this.configService = configService;
    }
    ngOnInit() {
        this.space = this.space || this.configService.env.space;
        if (this.state.type !== 'database') {
            if (this.state.resources.galleryEntry.length > 10) {
                this.state.pages = Math.round(this.state.resources.galleryEntry.length / 10);
            }
        }
        else {
            if (this.state.resources.length > 10) {
                this.state.pages = Math.round(this.state.resources.length / 10);
            }
        }
        this.selectedResourceItem = this.getOriginalResource(this.state.selectedResourceIndex);
    }
    getResourcesPage(page) {
        if (this.state.type !== 'database') {
            let start = (page * 10);
            let end = (page + 1) * 10 < this.state.resources.galleryEntry.length ? (page + 1) * 10 : this.state.resources.galleryEntry.length;
            let items = [];
            for (let i = start; i < end; i++) {
                items.push(this.state.resources.galleryEntry[i]);
            }
            return items;
        }
        else {
            let start = (page * 10);
            let end = (page + 1) * 10 < this.state.resources.length ? (page + 1) * 10 : this.state.resources.length;
            let items = [];
            for (let i = start; i < end; i++) {
                items.push(this.state.resources[i]);
            }
            return items;
        }
    }
    onFirstPage() {
        this.state.currentPage = 0;
    }
    onPrevPage() {
        this.state.currentPage = this.state.currentPage - 1;
    }
    onNextPage() {
        this.state.currentPage = this.state.currentPage + 1;
    }
    onLastPage() {
        this.state.currentPage = this.state.pages - 1;
    }
    prevDisabled() {
        if (this.state.currentPage * 10 > 0) {
            return '';
        }
        else {
            return 'disabled';
        }
    }
    nextDisabled() {
        if (this.state.type !== 'database') {
            if ((this.state.currentPage + 1) * 10 < this.state.resources.galleryEntry.length) {
                return '';
            }
            else {
                return 'disabled';
            }
        }
        else {
            if ((this.state.currentPage + 1) * 10 < this.state.resources.length) {
                return '';
            }
            else {
                return 'disabled';
            }
        }
    }
    getThumbnail(resource) {
        let index = resource.findIndex(image => image.scale === 'thumbnail');
        return resource[index];
    }
    confirm() {
        this.close();
    }
    close() {
        //this.bsModalRef.hide();
    }
    onThumbClick(resource, index) {
        this.state.selectedResourceIndex = index + (this.state.currentPage * 10);
        this.state.selectedResource = resource;
        this.selectedResourceItem = this.getOriginalResource(index + (this.state.currentPage * 10));
    }
    getMediumResource(i) {
        if (this.state.type !== 'database') {
            //Medium - large - original
            if (this.state.resources.galleryEntry.length > 0) {
                if (!i) {
                    i = 0;
                }
                let index = this.state.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'medium');
                if (index >= 0) {
                    return this.state.resources.galleryEntry[i].resource[index];
                }
                else {
                    index = this.state.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'large');
                    if (index >= 0) {
                        return this.state.resources.galleryEntry[i].resource[index];
                    }
                    else {
                        index = this.state.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'original');
                        if (index >= 0) {
                            return this.state.resources.galleryEntry[i].resource[index];
                        }
                    }
                }
            }
        }
        else {
            //Medium - large - original
            if (this.state.resources.length > 0) {
                if (!i) {
                    i = 0;
                }
                return this.state.resources[i];
            }
        }
    }
    getOriginalResource(i, download) {
        if (this.state.type !== 'database') {
            //Large - original - medium
            if (this.state.resources.galleryEntry.length > 0) {
                if (!i) {
                    i = 0;
                }
                if (download) {
                    let index = this.state.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'original');
                    if (index >= 0) {
                        return this.state.resources.galleryEntry[i].resource[index];
                    }
                    else {
                        index = this.state.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'large');
                        if (index >= 0) {
                            return this.state.resources.galleryEntry[i].resource[index];
                        }
                        else {
                            index = this.state.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'medium');
                            if (index >= 0) {
                                return this.state.resources.galleryEntry[i].resource[index];
                            }
                        }
                    }
                }
                else {
                    let index = this.state.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'large');
                    if (index >= 0) {
                        return this.state.resources.galleryEntry[i].resource[index];
                    }
                    else {
                        index = this.state.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'original');
                        if (index >= 0) {
                            return this.state.resources.galleryEntry[i].resource[index];
                        }
                        else {
                            index = this.state.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'medium');
                            if (index >= 0) {
                                return this.state.resources.galleryEntry[i].resource[index];
                            }
                        }
                    }
                }
            }
        }
        else {
            if (this.state.resources.length > 0) {
                if (!i) {
                    i = 0;
                }
                return this.state.resources[i];
            }
        }
    }
    getOthers(i) {
        if (this.state.type !== 'database') {
            if (this.state.resources.galleryEntry.length > 0) {
                return this.state.resources.galleryEntry[i].resource.filter(item => item.type === 'other');
            }
            else {
                return [];
            }
        }
        else {
            if (this.state.resources.length > 0) {
                return this.state.resources[i];
            }
            else {
                return [];
            }
        }
    }
    encode(url) {
        if (url.includes('/')) {
            return url;
        }
        else {
            return encodeURIComponent(url);
        }
    }
    getImageUrl(item, type) {
        return this.configService.env.storageUrl + '/' + this.space + '/images/' + item.domain + '/' + this.encode(item.id) + '?thumbnail=' + type;
    }
    isSourceObject(source) {
        return typeof (source) === 'object';
    }
    onClose() {
        //this.bsModalRef.hide();
    }
    static { this.ɵfac = function ImageGalleryModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImageGalleryModalComponent)(i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImageGalleryModalComponent, selectors: [["image-gallery-modal"]], inputs: { space: "space", state: "state" }, standalone: false, decls: 2, vars: 2, consts: [["class", "gallery row", 4, "ngIf"], [1, "gallery", "row"], [1, "col-md-12"], ["class", "thumbs", 4, "ngIf"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "thumbs"], ["class", "thumb", 4, "ngIf"], [1, "thumb"], ["title", "", "href", "javascript:", 3, "click"], [3, "src"], [1, "row", "thumbs"], ["class", "thumbs", 3, "hidden", 4, "ngFor", "ngForOf"], [1, "col-md-12", "align-center"], ["href", "javascript:", 1, "gallery-button-big", 3, "click", "ngClass"], [1, "material-icons"], ["href", "javascript:", 1, "gallery-button-small", 3, "click", "ngClass"], [1, "thumbs", 3, "hidden"], [1, "selected", "row", 3, "hidden"], [1, "content", "col-md-12"], [1, "content-border"], ["width", "100%", 3, "src"], [1, "row"], [1, "col-md-6", "mt-2"], ["class", "small text-color-gray-medium", 4, "ngIf"], [1, "content", "col-md-6", "align-right"], ["target", "_blank", 3, "title", "href"], ["target", "_blank", 3, "title", "href", 4, "ngFor", "ngForOf"], [1, "small", "text-color-gray-medium"], ["class", "selected row", 4, "ngIf"], [1, "selected", "row"], ["class", "col-md-12 mt-2", 4, "ngIf"], ["class", "col-md-12", 4, "ngIf"], [1, "col-md-12", "mt-2"], [1, "image-title"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"]], template: function ImageGalleryModalComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ImageGalleryModalComponent_div_0_Template, 5, 3, "div", 0)(1, ImageGalleryModalComponent_div_1_Template, 5, 3, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.state.type !== "database");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.state.type === "database");
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf], styles: [".gallery[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px;margin-bottom:20px}h5[_ngcontent-%COMP%]{color:var(--primary-color)}.thumbs[_ngcontent-%COMP%]{width:220px;float:left;display:flex;flex-wrap:wrap}.thumb[_ngcontent-%COMP%]{margin:.5em}.thumb[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border:solid 1px var(--default-border-color);padding:1px}.selected[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:90vw;max-height:90vh}.content[_ngcontent-%COMP%]{margin-top:.5em}.content[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border:solid 1px var(--default-border-color);padding:1px}.content-border[_ngcontent-%COMP%]{float:left}.content[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}a[_ngcontent-%COMP%]{color:var(--primary-color)!important}a.gallery-button-small[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:34px;vertical-align:bottom}.close[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{margin-right:8px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageGalleryModalComponent, [{
        type: Component,
        args: [{ selector: 'image-gallery-modal', standalone: false, template: "<div class=\"gallery row\" *ngIf=\"state.type !== 'database'\">\r\n    <div class=\"col-md-12\">\r\n        <div class=\"thumbs\" *ngIf=\"state.resources.galleryEntry.length <= 10\">\r\n            <ng-container *ngFor=\"let item of state.resources.galleryEntry; let i = index\">\r\n                <div *ngIf=\"getThumbnail(item.resource)\" class=\"thumb\">                    \r\n                    <a title=\"\" href=\"javascript:\" (click)=\"onThumbClick(item.resource,i)\"><img [src]=\"utilsService.processUrl(null,getThumbnail(item.resource).path)\" /></a>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n        <ng-container *ngIf=\"state.resources.galleryEntry.length > 10\">\r\n            <div class=\"row thumbs\">\r\n                <div class=\"col-md-12\">\r\n                    <div *ngFor=\"let p of state.pageNumbers\" class=\"thumbs\" [hidden]=\"p !== state.currentPage\">\r\n                        <ng-container *ngFor=\"let item of getResourcesPage(p); let i = index\">\r\n                            <div *ngIf=\"getThumbnail(item.resource)\" class=\"thumb\">                    \r\n                                <a title=\"\" href=\"javascript:\" (click)=\"onThumbClick(item.resource,i)\"><img [src]=\"utilsService.processUrl(null,getThumbnail(item.resource).path)\" /></a>\r\n                            </div>\r\n                        </ng-container>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-12 align-center\">\r\n                    <a class=\"gallery-button-big\" href=\"javascript:\" [ngClass]=\"prevDisabled()\" (click)=\"onFirstPage()\"><span class=\"material-icons\">skip_previous</span></a>\r\n                    <a class=\"gallery-button-small\" href=\"javascript:\" [ngClass]=\"prevDisabled()\" (click)=\"onPrevPage()\"><span class=\"material-icons\">arrow_left</span></a>\r\n                    <a class=\"gallery-button-small\" href=\"javascript:\" [ngClass]=\"nextDisabled()\" (click)=\"onNextPage()\"><span class=\"material-icons\">arrow_right</span></a>\r\n                    <a class=\"gallery-button-big\" href=\"javascript:\" [ngClass]=\"nextDisabled()\" (click)=\"onLastPage()\"><span class=\"material-icons\">skip_next</span></a>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n        <ng-container *ngFor=\"let resource of state.resources.galleryEntry; let i = index\">\r\n            <div class=\"selected row\" [hidden]=\"i !== state.selectedResourceIndex\">\r\n                <div class=\"content col-md-12\">\r\n                    <div class=\"content-border\">\r\n                        <img [src]=\"utilsService.processUrl(null,getOriginalResource(i).path)\" width=\"100%\" />\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-6 mt-2\">\r\n                                <p *ngIf=\"state.credits\" class=\"small text-color-gray-medium\">{{ state.credits }}</p>\r\n                            </div>\r\n                            <div class=\"content col-md-6 align-right\">\r\n                                <a title=\"{{ configService.getTranslation('image-gallery.download.full-size')}}\" href=\"{{ utilsService.processUrl(null,getOriginalResource(i,true).path) }}\" target=\"_blank\"><span class=\"material-icons\">file_download</span><span>{{ getOriginalResource(i).type }}</span></a>\r\n                                <a title=\"{{ configService.getTranslation('image-gallery.download.pdf')}}\" *ngFor=\"let item of getOthers(i)\" href=\"{{ utilsService.processUrl(null,item.path) }}\" target=\"_blank\"><span class=\"material-icons\">file_download</span><span>{{ item.fileExt }}</span></a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>                \r\n            </div>\r\n        </ng-container>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"gallery row\" *ngIf=\"state.type === 'database'\">\r\n    <div class=\"col-md-12\">\r\n        <div class=\"thumbs\" *ngIf=\"state.resources.length <= 10\">\r\n            <ng-container *ngFor=\"let item of state.resources; let i = index\">\r\n                <div *ngIf=\"getImageUrl(item,'s')\" class=\"thumb\">                    \r\n                    <a title=\"\" href=\"javascript:\" (click)=\"onThumbClick(item,i)\"><img src=\"{{ getImageUrl(item,'s') }}\" /></a>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n        <ng-container *ngIf=\"state.resources.length > 10\">\r\n            <div class=\"row thumbs\">\r\n                <div class=\"col-md-12\">\r\n                    <div *ngFor=\"let p of state.pageNumbers\" class=\"thumbs\" [hidden]=\"p !== state.currentPage\">\r\n                        <ng-container *ngFor=\"let item of getResourcesPage(p); let i = index\">\r\n                            <div *ngIf=\"getImageUrl(item,'s')\" class=\"thumb\">                    \r\n                                <a title=\"\" href=\"javascript:\" (click)=\"onThumbClick(item,i)\"><img src=\"{{ getImageUrl(item,'s') }}\" /></a>\r\n                            </div>\r\n                        </ng-container>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-12 align-center\">\r\n                    <a class=\"gallery-button-big\" href=\"javascript:\" [ngClass]=\"prevDisabled()\" (click)=\"onFirstPage()\"><span class=\"material-icons\">skip_previous</span></a>\r\n                    <a class=\"gallery-button-small\" href=\"javascript:\" [ngClass]=\"prevDisabled()\" (click)=\"onPrevPage()\"><span class=\"material-icons\">arrow_left</span></a>\r\n                    <a class=\"gallery-button-small\" href=\"javascript:\" [ngClass]=\"nextDisabled()\" (click)=\"onNextPage()\"><span class=\"material-icons\">arrow_right</span></a>\r\n                    <a class=\"gallery-button-big\" href=\"javascript:\" [ngClass]=\"nextDisabled()\" (click)=\"onLastPage()\"><span class=\"material-icons\">skip_next</span></a>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n        <ng-container *ngFor=\"let resource of state.resources; let i = index\">\r\n            <div class=\"selected row\" *ngIf=\"i === state.selectedResourceIndex\">\r\n                <div class=\"content col-md-12\">\r\n                    <div class=\"content-border\">\r\n                        <div class=\"row\">                            \r\n                            <div class=\"col-md-12\">\r\n                                <img [src]=\"utilsService.processUrl(null,getImageUrl(getMediumResource(i),'l'))\" width=\"100%\" />\r\n                            </div>\r\n                            <div class=\"col-md-12 mt-2\" *ngIf=\"resource.title\">\r\n                                <h6 class=\"image-title\">{{ resource.title }}</h6>\r\n                            </div>\r\n                            <div class=\"col-md-12\" *ngIf=\"resource.source\">\r\n                                <p class=\"small text-color-gray-medium\">\r\n                                    <b>{{ configService.getTranslation('common.image.credits')}}</b><br />\r\n                                    <ng-container *ngIf=\"isSourceObject(resource.source)\">\r\n                                        <a *ngIf=\"resource.source.url\" [href]=\"resource.source.url\" target=\"_blank\">{{resource.source.citation}}</a>\r\n                                        <ng-container *ngIf=\"!resource.source.url\">{{resource.source.citation}}</ng-container>\r\n                                    </ng-container>\r\n                                    <ng-container *ngIf=\"!isSourceObject(resource.source)\">\r\n                                        {{ resource.source }}\r\n                                    </ng-container>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"col-md-12\">\r\n                                <p class=\"small text-color-gray-medium\">\r\n                                    <b>{{ configService.getTranslation('common.image.copyright')}}</b><br />\r\n                                    {{ configService.getTranslation('common.image.copyright-text')}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>                \r\n            </div>\r\n        </ng-container>\r\n    </div>\r\n</div>", styles: [".gallery{margin-left:5px;margin-right:5px;margin-bottom:20px}h5{color:var(--primary-color)}.thumbs{width:220px;float:left;display:flex;flex-wrap:wrap}.thumb{margin:.5em}.thumb img{border:solid 1px var(--default-border-color);padding:1px}.selected .content img{max-width:90vw;max-height:90vh}.content{margin-top:.5em}.content img{border:solid 1px var(--default-border-color);padding:1px}.content-border{float:left}.content a span{display:inline-block;vertical-align:middle}a{color:var(--primary-color)!important}a.gallery-button-small .material-icons{font-size:34px;vertical-align:bottom}.close a{margin-right:8px}\n"] }]
    }], () => [{ type: i1.UtilsService }, { type: i1.ConfigurationService }], { space: [{
            type: Input
        }], state: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ImageGalleryModalComponent, { className: "ImageGalleryModalComponent", filePath: "src/components/image-gallery/image-gallery-modal/image-gallery-modal.component.ts", lineNumber: 11 }); })();

function ImageGalleryComponent_div_0_div_1_ng_container_1_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17)(1, "span", 18);
    i0.ɵɵtext(2, "file_download");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const r_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.configService.getTranslation("image-gallery.download.all-pdfs"));
    i0.ɵɵpropertyInterpolate("href", ctx_r1.utilsService.processUrl(null, r_r1.path), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("image-gallery.download.all-pdfs"));
} }
function ImageGalleryComponent_div_0_div_1_ng_container_1_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17)(1, "span", 18);
    i0.ɵɵtext(2, "file_download");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const r_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.configService.getTranslation("image-gallery.download.all-images"));
    i0.ɵɵpropertyInterpolate("href", ctx_r1.utilsService.processUrl(null, r_r1.path), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("image-gallery.download.all-images"));
} }
function ImageGalleryComponent_div_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_0_div_1_ng_container_1_a_1_Template, 5, 3, "a", 16)(2, ImageGalleryComponent_div_0_div_1_ng_container_1_a_2_Template, 5, 3, "a", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const r_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", r_r1.title.includes("pdf"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", r_r1.title.includes("image"));
} }
function ImageGalleryComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_0_div_1_ng_container_1_Template, 3, 2, "ng-container", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.resources.resource);
} }
function ImageGalleryComponent_div_0_div_3_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "a", 22);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_0_div_3_ng_container_1_div_1_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(); const item_r5 = ctx_r3.$implicit; const i_r6 = ctx_r3.index; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onThumbClick(item_r5.resource, i_r6)); });
    i0.ɵɵelement(2, "img", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r1.utilsService.processUrl(null, ctx_r1.getThumbnail(item_r5.resource).path), i0.ɵɵsanitizeUrl);
} }
function ImageGalleryComponent_div_0_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_0_div_3_ng_container_1_div_1_Template, 3, 1, "div", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getThumbnail(item_r5.resource));
} }
function ImageGalleryComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_0_div_3_ng_container_1_Template, 2, 1, "ng-container", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.resources.galleryEntry);
} }
function ImageGalleryComponent_div_0_ng_container_4_div_3_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "a", 22);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_0_ng_container_4_div_3_ng_container_1_div_1_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r8 = i0.ɵɵnextContext(); const item_r10 = ctx_r8.$implicit; const i_r11 = ctx_r8.index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.onThumbClick(item_r10.resource, i_r11)); });
    i0.ɵɵelement(2, "img", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r1.utilsService.processUrl(null, ctx_r1.getThumbnail(item_r10.resource).path), i0.ɵɵsanitizeUrl);
} }
function ImageGalleryComponent_div_0_ng_container_4_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_0_ng_container_4_div_3_ng_container_1_div_1_Template, 3, 1, "div", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getThumbnail(item_r10.resource));
} }
function ImageGalleryComponent_div_0_ng_container_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_0_ng_container_4_div_3_ng_container_1_Template, 2, 1, "ng-container", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("hidden", p_r12 !== ctx_r1.currentPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.getResourcesPage(p_r12));
} }
function ImageGalleryComponent_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 24)(2, "div", 11);
    i0.ɵɵtemplate(3, ImageGalleryComponent_div_0_ng_container_4_div_3_Template, 2, 2, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 26)(5, "a", 27);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_0_ng_container_4_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onFirstPage()); });
    i0.ɵɵelementStart(6, "span", 18);
    i0.ɵɵtext(7, "skip_previous");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "a", 28);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_0_ng_container_4_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onPrevPage()); });
    i0.ɵɵelementStart(9, "span", 18);
    i0.ɵɵtext(10, "arrow_left");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "a", 28);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_0_ng_container_4_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onNextPage()); });
    i0.ɵɵelementStart(12, "span", 18);
    i0.ɵɵtext(13, "arrow_right");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "a", 27);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_0_ng_container_4_Template_a_click_14_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onLastPage()); });
    i0.ɵɵelementStart(15, "span", 18);
    i0.ɵɵtext(16, "skip_next");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.pageNumbers);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r1.prevDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.prevDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.nextDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.nextDisabled());
} }
function ImageGalleryComponent_div_0_ng_container_5_ng_container_1_p_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 39);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.credits);
} }
function ImageGalleryComponent_div_0_ng_container_5_ng_container_1_a_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17)(1, "span", 18);
    i0.ɵɵtext(2, "file_download");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.configService.getTranslation("image-gallery.download.pdf"));
    i0.ɵɵproperty("href", ctx_r1.utilsService.processUrl(null, item_r14.path), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r14.fileExt);
} }
function ImageGalleryComponent_div_0_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 30)(2, "div", 9)(3, "div", 31)(4, "div", 32)(5, "a", 33);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_0_ng_container_5_ng_container_1_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r13); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onClick()); });
    i0.ɵɵelement(6, "img", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 9)(8, "div", 35);
    i0.ɵɵtemplate(9, ImageGalleryComponent_div_0_ng_container_5_ng_container_1_p_9_Template, 2, 1, "p", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 37)(11, "a", 17)(12, "span", 18);
    i0.ɵɵtext(13, "file_download");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, ImageGalleryComponent_div_0_ng_container_5_ng_container_1_a_16_Template, 5, 3, "a", 38);
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r15 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", i_r15 !== ctx_r1.selectedResourceIndex);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("src", ctx_r1.utilsService.processUrl(null, ctx_r1.getMediumResource(i_r15).path), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.credits);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.configService.getTranslation("image-gallery.download.full-size"));
    i0.ɵɵproperty("href", ctx_r1.utilsService.processUrl(null, ctx_r1.getOriginalResource(i_r15, true).path), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.getOriginalResource(i_r15).type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.getOthers(i_r15));
} }
function ImageGalleryComponent_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_0_ng_container_5_ng_container_1_Template, 17, 7, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.resources.galleryEntry);
} }
function ImageGalleryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_0_div_1_Template, 2, 1, "div", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵtemplate(3, ImageGalleryComponent_div_0_div_3_Template, 2, 1, "div", 12)(4, ImageGalleryComponent_div_0_ng_container_4_Template, 17, 5, "ng-container", 13)(5, ImageGalleryComponent_div_0_ng_container_5_Template, 2, 1, "ng-container", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.resources && ctx_r1.resources.resource && ctx_r1.resources.resource.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.resources && ctx_r1.resources.galleryEntry && ctx_r1.resources.galleryEntry.length <= 10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.resources && ctx_r1.resources.galleryEntry && ctx_r1.resources.galleryEntry.length > 10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.resources && ctx_r1.resources.galleryEntry);
} }
function ImageGalleryComponent_div_1_div_2_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "a", 22);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_1_div_2_ng_container_1_div_1_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r16); const ctx_r16 = i0.ɵɵnextContext(); const item_r18 = ctx_r16.$implicit; const i_r19 = ctx_r16.index; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onThumbClick(item_r18, i_r19)); });
    i0.ɵɵelement(2, "img", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r18 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r1.getImageUrl(item_r18, "s"), i0.ɵɵsanitizeUrl);
} }
function ImageGalleryComponent_div_1_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_1_div_2_ng_container_1_div_1_Template, 3, 1, "div", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r18 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getImageUrl(item_r18, "s"));
} }
function ImageGalleryComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_1_div_2_ng_container_1_Template, 2, 1, "ng-container", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.resources);
} }
function ImageGalleryComponent_div_1_ng_container_3_div_3_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "a", 22);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_1_ng_container_3_div_3_ng_container_1_div_1_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r21 = i0.ɵɵnextContext(); const item_r23 = ctx_r21.$implicit; const i_r24 = ctx_r21.index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.onThumbClick(item_r23, i_r24)); });
    i0.ɵɵelement(2, "img", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r23 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r1.getImageUrl(item_r23, "s"), i0.ɵɵsanitizeUrl);
} }
function ImageGalleryComponent_div_1_ng_container_3_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_1_ng_container_3_div_3_ng_container_1_div_1_Template, 3, 1, "div", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r23 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getImageUrl(item_r23, "s"));
} }
function ImageGalleryComponent_div_1_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_1_ng_container_3_div_3_ng_container_1_Template, 2, 1, "ng-container", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r25 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("hidden", p_r25 !== ctx_r1.currentPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.getResourcesPage(p_r25));
} }
function ImageGalleryComponent_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 24)(2, "div", 11);
    i0.ɵɵtemplate(3, ImageGalleryComponent_div_1_ng_container_3_div_3_Template, 2, 2, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 26)(5, "a", 27);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_1_ng_container_3_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r20); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onFirstPage()); });
    i0.ɵɵelementStart(6, "span", 18);
    i0.ɵɵtext(7, "skip_previous");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "a", 28);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_1_ng_container_3_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r20); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onPrevPage()); });
    i0.ɵɵelementStart(9, "span", 18);
    i0.ɵɵtext(10, "arrow_left");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "a", 28);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_1_ng_container_3_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r20); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onNextPage()); });
    i0.ɵɵelementStart(12, "span", 18);
    i0.ɵɵtext(13, "arrow_right");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "a", 27);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_1_ng_container_3_Template_a_click_14_listener() { i0.ɵɵrestoreView(_r20); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onLastPage()); });
    i0.ɵɵelementStart(15, "span", 18);
    i0.ɵɵtext(16, "skip_next");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.pageNumbers);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r1.prevDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.prevDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.nextDisabled());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.nextDisabled());
} }
function ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44)(1, "h6", 45);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const resource_r27 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(resource_r27.title);
} }
function ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_9_ng_container_5_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 47);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const resource_r27 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("href", resource_r27.source.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(resource_r27.source.citation);
} }
function ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_9_ng_container_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const resource_r27 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(resource_r27.source.citation);
} }
function ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_9_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_9_ng_container_5_a_1_Template, 2, 2, "a", 46)(2, ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_9_ng_container_5_ng_container_2_Template, 2, 1, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const resource_r27 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", resource_r27.source.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !resource_r27.source.url);
} }
function ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_9_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const resource_r27 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", resource_r27.source, " ");
} }
function ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "p", 39)(2, "b");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵtemplate(5, ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_9_ng_container_5_Template, 3, 2, "ng-container", 13)(6, ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_9_ng_container_6_Template, 2, 1, "ng-container", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const resource_r27 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("common.image.credits"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isSourceObject(resource_r27.source));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isSourceObject(resource_r27.source));
} }
function ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41)(1, "div", 9)(2, "div", 31)(3, "div", 32)(4, "div", 9)(5, "div", 11)(6, "a", 33);
    i0.ɵɵlistener("click", function ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_Template_a_click_6_listener() { i0.ɵɵrestoreView(_r26); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.onClick()); });
    i0.ɵɵelement(7, "img", 34);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_8_Template, 3, 1, "div", 42)(9, ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_div_9_Template, 7, 3, "div", 43);
    i0.ɵɵelementStart(10, "div", 11)(11, "p", 39)(12, "b");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "br");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()()()()()();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext();
    const resource_r27 = ctx_r27.$implicit;
    const i_r29 = ctx_r27.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("src", ctx_r1.utilsService.processUrl(null, ctx_r1.getImageUrl(ctx_r1.getMediumResource(i_r29), "l")), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", resource_r27.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", resource_r27.source);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("common.image.copyright"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.configService.getTranslation("common.image.copyright-text"), " ");
} }
function ImageGalleryComponent_div_1_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_1_ng_container_4_ng_container_1_div_1_Template, 16, 5, "div", 40);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r29 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r29 === ctx_r1.selectedResourceIndex);
} }
function ImageGalleryComponent_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageGalleryComponent_div_1_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.resources);
} }
function ImageGalleryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 11);
    i0.ɵɵtemplate(2, ImageGalleryComponent_div_1_div_2_Template, 2, 1, "div", 12)(3, ImageGalleryComponent_div_1_ng_container_3_Template, 17, 5, "ng-container", 13)(4, ImageGalleryComponent_div_1_ng_container_4_Template, 2, 1, "ng-container", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.resources && ctx_r1.resources.length <= 10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.resources && ctx_r1.resources.length > 10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.resources);
} }
function ImageGalleryComponent_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "h5", 53);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.modalState.title);
} }
function ImageGalleryComponent_div_7_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "h4");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.modalState.subtitle);
} }
function ImageGalleryComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48)(1, "div", 49)(2, "div", 50);
    i0.ɵɵtemplate(3, ImageGalleryComponent_div_7_div_3_Template, 3, 1, "div", 43)(4, ImageGalleryComponent_div_7_div_4_Template, 3, 1, "div", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 51);
    i0.ɵɵelement(6, "button", 52);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.modalState.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.modalState.subtitle);
} }
function ImageGalleryComponent_image_gallery_modal_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "image-gallery-modal", 54);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("state", ctx_r1.modalState)("space", ctx_r1.space);
} }
class ImageGalleryComponent {
    constructor(bsEventsService, utilsService, configService) {
        this.bsEventsService = bsEventsService;
        this.utilsService = utilsService;
        this.configService = configService;
        this.clickEvent = new EventEmitter();
        this.currentPage = 0;
        this.modalOpen = false;
    }
    ngAfterViewInit() {
        this.bsEventsService.onModalShown().subscribe((event) => {
            this.modalOpen = true;
        });
        this.bsEventsService.onModalHidden().subscribe((event) => {
            this.modalOpen = false;
        });
    }
    ngOnInit() {
        this.space = this.space || this.configService.env.space;
        if (!this.resources || !(typeof (this.resources) === 'object')) {
            this.resources = null;
            return;
        }
        if (this.type !== 'database') {
            if (this.resources.galleryEntry.length > 10) {
                this.pages = Math.round(this.resources.galleryEntry.length / 10);
                if (this.pages < this.resources.galleryEntry.length / 10) {
                    this.pages = this.pages + 1;
                }
                this.pageNumbers = [];
                for (let i = 0; i < this.pages; i++) {
                    this.pageNumbers.push(i);
                }
            }
            this.selectedResourceIndex = 0;
            this.selectedResource = this.resources.galleryEntry[0];
            this.selectedResourceItem = this.getOriginalResource(0);
        }
        else {
            if (this.resources.length > 10) {
                this.pages = Math.round(this.resources.length / 10);
                if (this.pages < this.resources.length / 10) {
                    this.pages = this.pages + 1;
                }
                this.pageNumbers = [];
                for (let i = 0; i < this.pages; i++) {
                    this.pageNumbers.push(i);
                }
            }
            this.selectedResourceIndex = 0;
            this.selectedResource = this.resources[0];
            this.selectedResourceItem = this.getOriginalResource(0);
        }
    }
    getResourcesPage(page) {
        if (this.type !== 'database') {
            let start = (page * 10);
            let end = (page + 1) * 10 < this.resources.galleryEntry.length ? (page + 1) * 10 : this.resources.galleryEntry.length;
            let items = [];
            for (let i = start; i < end; i++) {
                items.push(this.resources.galleryEntry[i]);
            }
            return items;
        }
        else {
            let start = (page * 10);
            let end = (page + 1) * 10 < this.resources.length ? (page + 1) * 10 : this.resources.length;
            let items = [];
            for (let i = start; i < end; i++) {
                items.push(this.resources[i]);
            }
            return items;
        }
    }
    onFirstPage() {
        this.currentPage = 0;
    }
    onPrevPage() {
        this.currentPage = this.currentPage - 1;
    }
    onNextPage() {
        this.currentPage = this.currentPage + 1;
    }
    onLastPage() {
        this.currentPage = this.pages - 1;
    }
    prevDisabled() {
        if (this.currentPage * 10 > 0) {
            return '';
        }
        else {
            return 'disabled';
        }
    }
    nextDisabled() {
        if (this.type !== 'database') {
            if ((this.currentPage + 1) * 10 < this.resources.galleryEntry.length) {
                return '';
            }
            else {
                return 'disabled';
            }
        }
        else {
            if ((this.currentPage + 1) * 10 < this.resources.length) {
                return '';
            }
            else {
                return 'disabled';
            }
        }
    }
    getThumbnail(resource) {
        if (this.type !== 'database') {
            let index = resource.findIndex(image => image.scale === 'thumbnail');
            return resource[index];
        }
        else {
            return resource;
        }
    }
    getMediumResource(i) {
        if (this.type !== 'database') {
            //Medium - large - original
            if (this.resources.galleryEntry.length > 0) {
                if (!i) {
                    i = 0;
                }
                let index = this.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'medium');
                if (index >= 0) {
                    return this.resources.galleryEntry[i].resource[index];
                }
                else {
                    index = this.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'large');
                    if (index >= 0) {
                        return this.resources.galleryEntry[i].resource[index];
                    }
                    else {
                        index = this.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'original');
                        if (index >= 0) {
                            return this.resources.galleryEntry[i].resource[index];
                        }
                    }
                }
            }
        }
        else {
            //Medium - large - original
            if (this.resources.length > 0) {
                if (!i) {
                    i = 0;
                }
                return this.resources[i];
            }
        }
    }
    getOriginalResource(i, download) {
        if (this.type !== 'database') {
            //Large - original - medium
            if (this.resources.galleryEntry.length > 0) {
                if (!i) {
                    i = 0;
                }
                if (download) {
                    let index = this.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'original');
                    if (index >= 0) {
                        return this.resources.galleryEntry[i].resource[index];
                    }
                    else {
                        index = this.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'large');
                        if (index >= 0) {
                            return this.resources.galleryEntry[i].resource[index];
                        }
                        else {
                            index = this.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'medium');
                            if (index >= 0) {
                                return this.resources.galleryEntry[i].resource[index];
                            }
                        }
                    }
                }
                else {
                    let index = this.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'large');
                    if (index >= 0) {
                        return this.resources.galleryEntry[i].resource[index];
                    }
                    else {
                        index = this.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'original');
                        if (index >= 0) {
                            return this.resources.galleryEntry[i].resource[index];
                        }
                        else {
                            index = this.resources.galleryEntry[i].resource.findIndex(item => item.scale === 'medium');
                            if (index >= 0) {
                                return this.resources.galleryEntry[i].resource[index];
                            }
                        }
                    }
                }
            }
        }
        else {
            if (this.resources.length > 0) {
                if (!i) {
                    i = 0;
                }
                return this.resources[i];
            }
        }
    }
    getOthers(i) {
        if (this.type !== 'database') {
            if (this.resources.galleryEntry.length > 0) {
                return this.resources.galleryEntry[i].resource.filter(item => item.type === 'other');
            }
            else {
                return [];
            }
        }
        else {
            if (this.resources.length > 0) {
                return this.resources[i];
            }
            else {
                return [];
            }
        }
    }
    onThumbClick(resource, index) {
        this.selectedResourceIndex = index + (this.currentPage * 10);
        this.selectedResource = resource;
        this.selectedResourceItem = this.getOriginalResource(index + (this.currentPage * 10));
    }
    onClick() {
        this.modalState = {
            title: this.title,
            subtitle: this.subtitle,
            type: this.type,
            resources: this.resources,
            selectedResource: this.selectedResource,
            selectedResourceIndex: this.selectedResourceIndex,
            pages: this.pages,
            pageNumbers: this.pageNumbers,
            currentPage: this.currentPage,
            credits: this.credits
        };
        document.getElementById('openModal').click();
    }
    encode(url) {
        if (url.includes('/')) {
            return url;
        }
        else {
            return encodeURIComponent(url);
        }
    }
    getImageUrl(item, type) {
        return this.configService.env.storageUrl + '/' + this.space + '/images/' + item.domain + '/' + this.encode(item.id) + '?thumbnail=' + type;
    }
    isSourceObject(source) {
        return typeof (source) === 'object';
    }
    static { this.ɵfac = function ImageGalleryComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImageGalleryComponent)(i0.ɵɵdirectiveInject(i1.BsEventsService), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImageGalleryComponent, selectors: [["image-gallery"]], inputs: { space: "space", type: "type", title: "title", subtitle: "subtitle", resources: "resources", credits: "credits" }, outputs: { clickEvent: "clickEvent" }, standalone: false, decls: 10, vars: 5, consts: [["class", "row", 4, "ngIf"], ["href", "#", "id", "openModal", "type", "button", "data-bs-toggle", "modal", "data-bs-target", "#imageGalleryModal", 1, "modals-trigger", 3, "hidden"], [1, "bi", "bi-share-fill"], ["id", "imageGalleryModal", "tabindex", "-1", "aria-labelledby", "imageGalleryModalLabel", "aria-hidden", "true", 1, "modal", "modal-share", "fade"], [1, "modal-dialog", "modal-xl", "modal-dialog-centered"], [1, "modal-content"], ["class", "modal-header", 4, "ngIf"], [1, "modal-body"], [3, "state", "space", 4, "ngIf"], [1, "row"], ["class", "download col-md-12", 4, "ngIf"], [1, "col-md-12"], ["class", "thumbs", 4, "ngIf"], [4, "ngIf"], [1, "download", "col-md-12"], [4, "ngFor", "ngForOf"], ["target", "_blank", 3, "title", "href", 4, "ngIf"], ["target", "_blank", 3, "title", "href"], [1, "material-icons"], [1, "thumbs"], ["class", "thumb", 4, "ngIf"], [1, "thumb"], ["title", "", "href", "javascript:", 3, "click"], [3, "src"], [1, "row", "thumbs"], ["class", "thumbs", 3, "hidden", 4, "ngFor", "ngForOf"], [1, "col-md-12", "align-center"], ["href", "javascript:", 1, "gallery-button-big", 3, "click", "ngClass"], ["href", "javascript:", 1, "gallery-button-small", 3, "click", "ngClass"], [1, "thumbs", 3, "hidden"], [1, "selected", 3, "hidden"], [1, "content", "col-md-12"], [1, "content-border"], ["href", "javascript:", 3, "click"], ["width", "100%", 3, "src"], [1, "col-md-6", "mt-2"], ["class", "small text-color-gray-medium", 4, "ngIf"], [1, "content", "col-md-6", "align-right"], ["target", "_blank", 3, "title", "href", 4, "ngFor", "ngForOf"], [1, "small", "text-color-gray-medium"], ["class", "selected", 4, "ngIf"], [1, "selected"], ["class", "col-md-12 mt-2", 4, "ngIf"], ["class", "col-md-12", 4, "ngIf"], [1, "col-md-12", "mt-2"], [1, "image-title"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"], [1, "modal-header"], [1, "row", "gallery-header"], [1, "col-md-10"], [1, "col-md-2", "align-right"], ["type", "button", "data-bs-dismiss", "modal", "aria-label", "Close", 1, "btn-close"], [1, "title-link"], [3, "state", "space"]], template: function ImageGalleryComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ImageGalleryComponent_div_0_Template, 6, 4, "div", 0)(1, ImageGalleryComponent_div_1_Template, 5, 3, "div", 0);
            i0.ɵɵelementStart(2, "a", 1);
            i0.ɵɵelement(3, "i", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "div", 5);
            i0.ɵɵtemplate(7, ImageGalleryComponent_div_7_Template, 7, 2, "div", 6);
            i0.ɵɵelementStart(8, "div", 7);
            i0.ɵɵtemplate(9, ImageGalleryComponent_image_gallery_modal_9_Template, 1, 2, "image-gallery-modal", 8);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.type !== "database" && ctx.resources && ctx.resources.galleryEntry && ctx.resources.galleryEntry.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "database" && ctx.resources && ctx.resources.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", true);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.modalState);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.modalOpen);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, ImageGalleryModalComponent], styles: [".thumbs[_ngcontent-%COMP%]{width:220px;float:left;display:flex;flex-wrap:wrap}.thumb[_ngcontent-%COMP%]{margin:.5em}.thumb[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border:solid 1px var(--default-border-color);padding:1px}h5[_ngcontent-%COMP%]{color:var(--primary-color)}.selected[_ngcontent-%COMP%]{width:100%}.selected[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:auto!important}.content[_ngcontent-%COMP%]{margin-top:.5em}.content[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border:solid 1px var(--default-border-color);max-width:100%;padding:1px}.content-border[_ngcontent-%COMP%]{float:left}.download[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{margin:5px}.content[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .download[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}a.gallery-button-small[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:34px;vertical-align:bottom}.gallery-header[_ngcontent-%COMP%]{width:100%}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageGalleryComponent, [{
        type: Component,
        args: [{ selector: 'image-gallery', standalone: false, template: "<div class=\"row\" *ngIf=\"type !== 'database' && resources && resources.galleryEntry && resources.galleryEntry.length > 0\">    \r\n    <div class=\"download col-md-12\" *ngIf=\"resources && resources.resource && resources.resource.length > 0\">\r\n        <ng-container *ngFor=\"let r of resources.resource\">\r\n            <a *ngIf=\"r.title.includes('pdf')\" title=\"{{ configService.getTranslation('image-gallery.download.all-pdfs')}}\" href=\"{{ utilsService.processUrl(null,r.path) }}\" target=\"_blank\">\r\n                <span class=\"material-icons\">file_download</span><span>{{ configService.getTranslation('image-gallery.download.all-pdfs')}}</span>\r\n            </a>\r\n            <a *ngIf=\"r.title.includes('image')\" title=\"{{ configService.getTranslation('image-gallery.download.all-images')}}\" href=\"{{ utilsService.processUrl(null,r.path) }}\" target=\"_blank\">\r\n                <span class=\"material-icons\">file_download</span><span>{{ configService.getTranslation('image-gallery.download.all-images')}}</span>\r\n            </a>\r\n        </ng-container>\r\n    </div>\r\n    <div class=\"col-md-12\">\r\n        <div class=\"thumbs\" *ngIf=\"resources && resources.galleryEntry && resources.galleryEntry.length <= 10\">\r\n            <ng-container *ngFor=\"let item of resources.galleryEntry; let i = index\">\r\n                <div *ngIf=\"getThumbnail(item.resource)\" class=\"thumb\">                    \r\n                    <a title=\"\" href=\"javascript:\" (click)=\"onThumbClick(item.resource,i)\"><img [src]=\"utilsService.processUrl(null,getThumbnail(item.resource).path)\" /></a>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n        <ng-container *ngIf=\"resources && resources.galleryEntry && resources.galleryEntry.length > 10\">\r\n            <div class=\"row thumbs\">\r\n                <div class=\"col-md-12\">\r\n                    <div *ngFor=\"let p of pageNumbers\" class=\"thumbs\" [hidden]=\"p !== currentPage\">\r\n                        <ng-container *ngFor=\"let item of getResourcesPage(p); let i = index\">\r\n                            <div *ngIf=\"getThumbnail(item.resource)\" class=\"thumb\">                    \r\n                                <a title=\"\" href=\"javascript:\" (click)=\"onThumbClick(item.resource,i)\"><img [src]=\"utilsService.processUrl(null,getThumbnail(item.resource).path)\" /></a>\r\n                            </div>\r\n                        </ng-container>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-12 align-center\">\r\n                    <a class=\"gallery-button-big\" href=\"javascript:\" [ngClass]=\"prevDisabled()\" (click)=\"onFirstPage()\"><span class=\"material-icons\">skip_previous</span></a>\r\n                    <a class=\"gallery-button-small\" href=\"javascript:\" [ngClass]=\"prevDisabled()\" (click)=\"onPrevPage()\"><span class=\"material-icons\">arrow_left</span></a>\r\n                    <a class=\"gallery-button-small\" href=\"javascript:\" [ngClass]=\"nextDisabled()\" (click)=\"onNextPage()\"><span class=\"material-icons\">arrow_right</span></a>\r\n                    <a class=\"gallery-button-big\" href=\"javascript:\" [ngClass]=\"nextDisabled()\" (click)=\"onLastPage()\"><span class=\"material-icons\">skip_next</span></a>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"resources && resources.galleryEntry\">\r\n        <ng-container *ngFor=\"let resource of resources.galleryEntry; let i = index\">\r\n            <div class=\"selected\" [hidden]=\"i !== selectedResourceIndex\">\r\n                <div class=\"row\">\r\n                    <div class=\"content col-md-12\">\r\n                        <div class=\"content-border\">\r\n                            <a href=\"javascript:\" (click)=\"onClick()\"><img [src]=\"utilsService.processUrl(null,getMediumResource(i).path)\" width=\"100%\" /></a>                            \r\n                            <div class=\"row\">\r\n                                <div class=\"col-md-6 mt-2\">\r\n                                    <p *ngIf=\"credits\" class=\"small text-color-gray-medium\">{{ credits }}</p>\r\n                                </div>\r\n                                <div class=\"content col-md-6 align-right\">\r\n                                    <a title=\"{{ configService.getTranslation('image-gallery.download.full-size')}}\" [href]=\"utilsService.processUrl(null,getOriginalResource(i,true).path)\" target=\"_blank\"><span class=\"material-icons\">file_download</span><span>{{ getOriginalResource(i).type }}</span></a>\r\n                                    <a title=\"{{ configService.getTranslation('image-gallery.download.pdf')}}\" *ngFor=\"let item of getOthers(i)\" [href]=\"utilsService.processUrl(null,item.path)\" target=\"_blank\"><span class=\"material-icons\">file_download</span><span>{{ item.fileExt }}</span></a>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>                    \r\n                </div>\r\n            </div>\r\n        </ng-container>     \r\n    </ng-container>   \r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\" *ngIf=\"type === 'database' && resources && resources.length > 0\">\r\n    <div class=\"col-md-12\">\r\n        <div class=\"thumbs\" *ngIf=\"resources && resources.length <= 10\">\r\n            <ng-container *ngFor=\"let item of resources; let i = index\">\r\n                <div *ngIf=\"getImageUrl(item,'s')\" class=\"thumb\">\r\n                    <a title=\"\" href=\"javascript:\" (click)=\"onThumbClick(item,i)\"><img src=\"{{ getImageUrl(item,'s') }}\" /></a>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n        <ng-container *ngIf=\"resources && resources.length > 10\">\r\n            <div class=\"row thumbs\">\r\n                <div class=\"col-md-12\">\r\n                    <div *ngFor=\"let p of pageNumbers\" class=\"thumbs\" [hidden]=\"p !== currentPage\">\r\n                        <ng-container *ngFor=\"let item of getResourcesPage(p); let i = index\">\r\n                            <div *ngIf=\"getImageUrl(item,'s')\" class=\"thumb\">                    \r\n                                <a title=\"\" href=\"javascript:\" (click)=\"onThumbClick(item,i)\"><img src=\"{{ getImageUrl(item,'s') }}\" /></a>\r\n                            </div>\r\n                        </ng-container>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-12 align-center\">\r\n                    <a class=\"gallery-button-big\" href=\"javascript:\" [ngClass]=\"prevDisabled()\" (click)=\"onFirstPage()\"><span class=\"material-icons\">skip_previous</span></a>\r\n                    <a class=\"gallery-button-small\" href=\"javascript:\" [ngClass]=\"prevDisabled()\" (click)=\"onPrevPage()\"><span class=\"material-icons\">arrow_left</span></a>\r\n                    <a class=\"gallery-button-small\" href=\"javascript:\" [ngClass]=\"nextDisabled()\" (click)=\"onNextPage()\"><span class=\"material-icons\">arrow_right</span></a>\r\n                    <a class=\"gallery-button-big\" href=\"javascript:\" [ngClass]=\"nextDisabled()\" (click)=\"onLastPage()\"><span class=\"material-icons\">skip_next</span></a>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"resources\">\r\n            <ng-container *ngFor=\"let resource of resources; let i = index\">\r\n                <div class=\"selected\" *ngIf=\"i === selectedResourceIndex\">\r\n                    <div class=\"row\">\r\n                        <div class=\"content col-md-12\">\r\n                            <div class=\"content-border\">\r\n                                <div class=\"row\">\r\n                                    <div class=\"col-md-12\">\r\n                                        <a href=\"javascript:\" (click)=\"onClick()\"><img [src]=\"utilsService.processUrl(null,getImageUrl(getMediumResource(i),'l'))\" width=\"100%\" /></a>                            \r\n                                    </div>\r\n                                    <div class=\"col-md-12 mt-2\" *ngIf=\"resource.title\">\r\n                                        <h6 class=\"image-title\">{{ resource.title }}</h6>\r\n                                    </div>\r\n                                    <div class=\"col-md-12\" *ngIf=\"resource.source\">\r\n                                        <p class=\"small text-color-gray-medium\">\r\n                                            <b>{{ configService.getTranslation('common.image.credits')}}</b><br />\r\n                                            <ng-container *ngIf=\"isSourceObject(resource.source)\">\r\n                                                <a *ngIf=\"resource.source.url\" [href]=\"resource.source.url\" target=\"_blank\">{{resource.source.citation}}</a>\r\n                                                <ng-container *ngIf=\"!resource.source.url\">{{resource.source.citation}}</ng-container>\r\n                                            </ng-container>\r\n                                            <ng-container *ngIf=\"!isSourceObject(resource.source)\">\r\n                                                {{ resource.source }}\r\n                                            </ng-container>\r\n                                        </p>\r\n                                    </div>\r\n                                    <div class=\"col-md-12\">\r\n                                        <p class=\"small text-color-gray-medium\">\r\n                                            <b>{{ configService.getTranslation('common.image.copyright')}}</b><br />\r\n                                            {{ configService.getTranslation('common.image.copyright-text')}}\r\n                                        </p>\r\n                                    </div>\r\n    \r\n    <!--                                 <div class=\"content col-md-6 align-right\">\r\n                                        <a title=\"{{ configService.getTranslation('image-gallery.download.full-size')}}\" href=\"{{ getImageUrl(getOriginalResource(i,true),'s') }}\" target=\"_blank\"><span class=\"material-icons\">file_download</span><span>{{ getOriginalResource(i).type }}</span></a>\r\n                                        <a title=\"{{ configService.getTranslation('image-gallery.download.pdf')}}\" *ngFor=\"let item of getOthers(i)\" href=\"{{ baseUrl + item.path }}\" target=\"_blank\"><span class=\"material-icons\">file_download</span><span>{{ item.fileExt }}</span></a>\r\n                                    </div> -->\r\n                                </div>\r\n                            </div>\r\n                        </div>                    \r\n                    </div>\r\n                </div>\r\n            </ng-container>  \r\n        </ng-container>              \r\n    </div>\r\n</div>\r\n\r\n<a href=\"#\" class=\"modals-trigger\" [hidden]=\"true\" id=\"openModal\" type=\"button\" data-bs-toggle=\"modal\" data-bs-target=\"#imageGalleryModal\">\r\n    <i class=\"bi bi-share-fill\"></i>\r\n</a>\r\n\r\n<div class=\"modal modal-share fade\" id=\"imageGalleryModal\" tabindex=\"-1\" aria-labelledby=\"imageGalleryModalLabel\" aria-hidden=\"true\">\r\n    <div class=\"modal-dialog modal-xl modal-dialog-centered\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\" *ngIf=\"modalState\">\r\n                <div class=\"row gallery-header\">\r\n                    <div class=\"col-md-10\">\r\n                        <div class=\"col-md-12\" *ngIf=\"modalState.title\">\r\n                            <h5 class=\"title-link\">{{ modalState.title }}</h5>\r\n                        </div>\r\n                        <div class=\"col-md-12\" *ngIf=\"modalState.subtitle\">\r\n                            <h4>{{ modalState.subtitle }}</h4>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-md-2 align-right\">\r\n                        <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"modal-body\">\r\n                <image-gallery-modal *ngIf=\"modalOpen\" [state]=\"modalState\" [space]=\"space\"></image-gallery-modal>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>", styles: [".thumbs{width:220px;float:left;display:flex;flex-wrap:wrap}.thumb{margin:.5em}.thumb img{border:solid 1px var(--default-border-color);padding:1px}h5{color:var(--primary-color)}.selected{width:100%}.selected img{width:auto!important}.content{margin-top:.5em}.content img{border:solid 1px var(--default-border-color);max-width:100%;padding:1px}.content-border{float:left}.download a{margin:5px}.content a span,.download a span{display:inline-block;vertical-align:middle}a.gallery-button-small .material-icons{font-size:34px;vertical-align:bottom}.gallery-header{width:100%}\n"] }]
    }], () => [{ type: i1.BsEventsService }, { type: i1.UtilsService }, { type: i1.ConfigurationService }], { space: [{
            type: Input
        }], type: [{
            type: Input
        }], title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }], resources: [{
            type: Input
        }], credits: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ImageGalleryComponent, { className: "ImageGalleryComponent", filePath: "src/components/image-gallery/image-gallery.component.ts", lineNumber: 12 }); })();

function ImageViewerModalComponent_div_2_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "li", 13);
} if (rf & 2) {
    const i_r1 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i_r1 === ctx_r1.startFromIndex ? "active" : "");
    i0.ɵɵattribute("data-bs-target", "#carousel-" + ctx_r1.parentId)("data-bs-slide-to", i_r1);
} }
function ImageViewerModalComponent_div_2_div_4_h6_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const img_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(img_r3.title);
} }
function ImageViewerModalComponent_div_2_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "p", 25);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const img_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(img_r3.description);
} }
function ImageViewerModalComponent_div_2_div_4_img_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 26);
    i0.ɵɵlistener("load", function ImageViewerModalComponent_div_2_div_4_img_6_Template_img_load_0_listener() { i0.ɵɵrestoreView(_r4); const img_r3 = i0.ɵɵnextContext().$implicit; return i0.ɵɵresetView(img_r3.isCarouselImageLoading = false); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const img_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r1.utilsService.processUrl(null, img_r3.url), i0.ɵɵsanitizeUrl)("alt", img_r3.title);
} }
function ImageViewerModalComponent_div_2_div_4_img_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 27);
} if (rf & 2) {
    const img_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r1.utilsService.processUrl(null, img_r3.imageToShow), i0.ɵɵsanitizeUrl)("alt", img_r3.title);
} }
function ImageViewerModalComponent_div_2_div_4_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "p", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const img_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(img_r3.legend);
} }
function ImageViewerModalComponent_div_2_div_4_div_10_ng_container_5_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const img_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("href", img_r3.source.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(img_r3.source.citation);
} }
function ImageViewerModalComponent_div_2_div_4_div_10_ng_container_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const img_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(img_r3.source.citation);
} }
function ImageViewerModalComponent_div_2_div_4_div_10_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageViewerModalComponent_div_2_div_4_div_10_ng_container_5_a_1_Template, 2, 2, "a", 29)(2, ImageViewerModalComponent_div_2_div_4_div_10_ng_container_5_ng_container_2_Template, 2, 1, "ng-container", 28);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const img_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", img_r3.source.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !img_r3.source.url);
} }
function ImageViewerModalComponent_div_2_div_4_div_10_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const img_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", img_r3.source, " ");
} }
function ImageViewerModalComponent_div_2_div_4_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "p", 23)(2, "b");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵtemplate(5, ImageViewerModalComponent_div_2_div_4_div_10_ng_container_5_Template, 3, 2, "ng-container", 28)(6, ImageViewerModalComponent_div_2_div_4_div_10_ng_container_6_Template, 2, 1, "ng-container", 28);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const img_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("common.image.credits"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isSourceObject(img_r3.source));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isSourceObject(img_r3.source));
} }
function ImageViewerModalComponent_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 0)(2, "div", 15);
    i0.ɵɵtemplate(3, ImageViewerModalComponent_div_2_div_4_h6_3_Template, 2, 1, "h6", 16)(4, ImageViewerModalComponent_div_2_div_4_div_4_Template, 3, 1, "div", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 18);
    i0.ɵɵtemplate(6, ImageViewerModalComponent_div_2_div_4_img_6_Template, 1, 2, "img", 19)(7, ImageViewerModalComponent_div_2_div_4_img_7_Template, 1, 2, "img", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 21);
    i0.ɵɵtemplate(9, ImageViewerModalComponent_div_2_div_4_div_9_Template, 3, 1, "div", 17)(10, ImageViewerModalComponent_div_2_div_4_div_10_Template, 7, 3, "div", 17);
    i0.ɵɵelementStart(11, "div", 22)(12, "p", 23)(13, "b");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "br");
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const img_r3 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i_r5 === ctx_r1.startFromIndex ? "active" : "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", img_r3.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", img_r3.description);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", img_r3.use === undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", img_r3.use !== undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", img_r3.legend);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", img_r3.source);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("common.image.copyright"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.configService.getTranslation("common.image.copyright-text"), " ");
} }
function ImageViewerModalComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "ol", 4);
    i0.ɵɵtemplate(2, ImageViewerModalComponent_div_2_li_2_Template, 1, 3, "li", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵtemplate(4, ImageViewerModalComponent_div_2_div_4_Template, 17, 9, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 8)(6, "span", 9);
    i0.ɵɵelement(7, "i", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "button", 11)(9, "span", 9);
    i0.ɵɵelement(10, "i", 12);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", "carousel-" + ctx_r1.parentId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.carouselImages);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.carouselImages);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-bs-target", "#carousel-" + ctx_r1.parentId);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("data-bs-target", "#carousel-" + ctx_r1.parentId);
} }
class ImageViewerModalComponent {
    constructor(imageService, utilsService, configService) {
        this.imageService = imageService;
        this.utilsService = utilsService;
        this.configService = configService;
        this.startFromIndex = 0;
    }
    ngOnInit() {
        if (this.images) {
            this.extraImages = this.images.filter(item => item.use && item.use.toLowerCase() === 'extra');
            this.normalImages = this.images.filter(item => item.use && item.use.toLowerCase() === 'normal');
            this.thumbImages = this.images.filter(item => item.use && item.use.toLowerCase() === 'thumb');
            this.nonUseImages = this.images;
            if (this.extraImages.length > 0) {
                this.carouselImages = this.extraImages;
            }
            else if (this.normalImages.length > 0) {
                this.carouselImages = this.normalImages;
            }
            else if (this.thumbImages.length > 0) {
                this.carouselImages = this.thumbImages;
            }
            else {
                this.carouselImages = this.nonUseImages;
            }
            for (let i = 0; i < this.carouselImages.length; i++) {
                if (this.type === 'database') {
                    this.carouselImages[i].url = this.carouselImages[i].largeUrl;
                }
                else {
                    if (this.carouselImages[i].use === undefined) {
                        this.carouselImages[i].url = this.carouselImages[i].url;
                    }
                    else {
                        //this.carouselImages[i].url = environment.fileManagerUrl + '/download?filepath=' + encodeURIComponent(this.carouselImages[i].src);
                        this.carouselImages[i].url = this.configService.env.storageUrl + this.encode(this.carouselImages[i].src);
                    }
                    this.getImageFromService(this.carouselImages[i]);
                }
            }
        }
        else {
            this.extraImages = [];
        }
        this.startFromIndex = this.selectedImage;
    }
    encode(url) {
        if (!url) {
            return;
        }
        if (url.includes('/')) {
            return url;
        }
        else {
            return encodeURIComponent(url);
        }
    }
    confirm() {
        this.close();
    }
    close() {
        //this.bsModalRef.hide();
    }
    createImageFromBlob(image, imageItem) {
        let reader = new FileReader();
        reader.addEventListener("load", () => {
            if (imageItem) {
                imageItem.imageToShow = reader.result;
            }
        }, false);
        if (image) {
            reader.readAsDataURL(image);
        }
    }
    getImageFromService(image) {
        if (image) {
            image.isCarouselImageLoading = true;
            this.imageService.getImage(image.url).subscribe(data => {
                this.createImageFromBlob(data, image);
                image.isCarouselImageLoading = false;
            }, error => {
                image.isCarouselImageLoading = false;
            });
        }
    }
    isSourceObject(source) {
        return typeof (source) === 'object';
    }
    static { this.ɵfac = function ImageViewerModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImageViewerModalComponent)(i0.ɵɵdirectiveInject(i1.ImageService), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImageViewerModalComponent, selectors: [["image-viewer-modal"]], inputs: { images: "images", selectedImage: "selectedImage", parentId: "parentId", type: "type" }, standalone: false, decls: 3, vars: 1, consts: [[1, "row"], [1, "col-12"], ["class", "carousel slide", "data-bs-ride", "carousel", 3, "id", 4, "ngIf"], ["data-bs-ride", "carousel", 1, "carousel", "slide", 3, "id"], [1, "carousel-indicators"], [3, "ngClass", 4, "ngFor", "ngForOf"], [1, "carousel-inner"], ["class", "carousel-item image-viewer", 3, "ngClass", 4, "ngFor", "ngForOf"], ["type", "button", "data-bs-slide", "prev", 1, "carousel-control-prev"], ["aria-hidden", "true"], [1, "bi", "bi-chevron-left"], ["type", "button", "data-bs-slide", "next", 1, "carousel-control-next"], [1, "bi", "bi-chevron-right"], [3, "ngClass"], [1, "carousel-item", "image-viewer", 3, "ngClass"], [1, "col-md-12"], ["class", "image-title", 4, "ngIf"], ["class", "image-source-container", 4, "ngIf"], [1, "col-md-12", "image-container"], ["class", "mx-auto", "style", "display: block; max-width: 100%;", 3, "src", "alt", "load", 4, "ngIf"], ["class", "mx-auto", "style", "display: block; max-width: 100%;", 3, "src", "alt", 4, "ngIf"], [1, "col-md-12", "mt-2"], [1, "image-source-container"], [1, "small", "text-color-gray-medium"], [1, "image-title"], [1, "figure-caption"], [1, "mx-auto", 2, "display", "block", "max-width", "100%", 3, "load", "src", "alt"], [1, "mx-auto", 2, "display", "block", "max-width", "100%", 3, "src", "alt"], [4, "ngIf"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"]], template: function ImageViewerModalComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, ImageViewerModalComponent_div_2_Template, 11, 5, "div", 2);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.carouselImages && ctx.carouselImages.length > 0);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf], styles: [".image-source-container[_ngcontent-%COMP%]{text-align:left}.image-source[_ngcontent-%COMP%]{font-size:.8em}.image-title-container[_ngcontent-%COMP%]{text-align:center}.image-title[_ngcontent-%COMP%]{font-style:italic;text-align:center}.carousel-item[_ngcontent-%COMP%]{padding-left:1em;padding-right:1em}.carousel-indicators[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{background-color:var(--primary-color)}.carousel-control-prev[_ngcontent-%COMP%], .carousel-control-next[_ngcontent-%COMP%]{border:none;background-color:inherit;width:5%}.carousel-control-prev[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .carousel-control-next[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--primary-color);font-size:2em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageViewerModalComponent, [{
        type: Component,
        args: [{ selector: 'image-viewer-modal', standalone: false, template: "<div class=\"row\">\r\n    <div class=\"col-12\">\r\n        <div *ngIf=\"carouselImages && carouselImages.length > 0\" [id]=\"'carousel-' + parentId\" class=\"carousel slide\" data-bs-ride=\"carousel\">\r\n            <ol class=\"carousel-indicators\">\r\n              <li [attr.data-bs-target]=\"'#carousel-' + parentId\" [attr.data-bs-slide-to]=\"i\"  [ngClass]=\"i === startFromIndex ? 'active' : ''\" *ngFor=\"let img of carouselImages; let i = index\"></li>\r\n            </ol>\r\n            <div class=\"carousel-inner\">\r\n                <div class=\"carousel-item image-viewer\" [ngClass]=\"i === startFromIndex ? 'active' : ''\" *ngFor=\"let img of carouselImages; let i = index\">\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                            <h6 class=\"image-title\" *ngIf=\"img.title\">{{ img.title }}</h6>\r\n                            <div class=\"image-source-container\" *ngIf=\"img.description\">\r\n                                <p class=\"figure-caption\">{{img.description}}</p>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-md-12 image-container\">\r\n                            <img *ngIf=\"img.use === undefined\" (load)=\"img.isCarouselImageLoading = false;\" [src]=\"utilsService.processUrl(null,img.url)\" [alt]=\"img.title\" class=\"mx-auto\" style=\"display: block; max-width: 100%;\" />\r\n                            <img *ngIf=\"img.use !== undefined\" [src]=\"utilsService.processUrl(null,img.imageToShow)\" [alt]=\"img.title\" class=\"mx-auto\" style=\"display: block; max-width: 100%;\" />\r\n                        </div>\r\n                        <div class=\"col-md-12 mt-2\">                            \r\n                            <div class=\"image-source-container\" *ngIf=\"img.legend\">\r\n                                <p class=\"small text-color-gray-medium\">{{img.legend}}</p>\r\n                            </div>\r\n                            <div class=\"image-source-container\" *ngIf=\"img.source\">\r\n                                <p class=\"small text-color-gray-medium\">\r\n                                    <b>{{ configService.getTranslation('common.image.credits')}}</b><br />\r\n                                    <ng-container *ngIf=\"isSourceObject(img.source)\">\r\n                                        <a *ngIf=\"img.source.url\" [href]=\"img.source.url\" target=\"_blank\">{{img.source.citation}}</a>\r\n                                        <ng-container *ngIf=\"!img.source.url\">{{img.source.citation}}</ng-container>\r\n                                    </ng-container>\r\n                                    <ng-container *ngIf=\"!isSourceObject(img.source)\">\r\n                                        {{ img.source }}\r\n                                    </ng-container>\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"image-source-container\">\r\n                                <p class=\"small text-color-gray-medium\">\r\n                                    <b>{{ configService.getTranslation('common.image.copyright')}}</b><br />\r\n                                    {{ configService.getTranslation('common.image.copyright-text')}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <button class=\"carousel-control-prev\" type=\"button\" [attr.data-bs-target]=\"'#carousel-' + parentId\" data-bs-slide=\"prev\">\r\n              <span aria-hidden=\"true\"><i class=\"bi bi-chevron-left\"></i></span>\r\n            </button>\r\n            <button class=\"carousel-control-next\" type=\"button\" [attr.data-bs-target]=\"'#carousel-' + parentId\" data-bs-slide=\"next\">\r\n              <span aria-hidden=\"true\"><i class=\"bi bi-chevron-right\"></i></span>\r\n            </button>\r\n        </div>          \r\n    </div>\r\n</div>", styles: [".image-source-container{text-align:left}.image-source{font-size:.8em}.image-title-container{text-align:center}.image-title{font-style:italic;text-align:center}.carousel-item{padding-left:1em;padding-right:1em}.carousel-indicators li{background-color:var(--primary-color)}.carousel-control-prev,.carousel-control-next{border:none;background-color:inherit;width:5%}.carousel-control-prev span i,.carousel-control-next span i{color:var(--primary-color);font-size:2em}\n"] }]
    }], () => [{ type: i1.ImageService }, { type: i1.UtilsService }, { type: i1.ConfigurationService }], { images: [{
            type: Input
        }], selectedImage: [{
            type: Input
        }], parentId: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ImageViewerModalComponent, { className: "ImageViewerModalComponent", filePath: "src/components/image-viewer/image-viewer-modal/image-viewer-modal.component.ts", lineNumber: 12 }); })();

function ImageViewerComponent_div_1_div_1_h6_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const thumb_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(thumb_r1.title);
} }
function ImageViewerComponent_div_1_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "p", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const thumb_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(thumb_r1.description);
} }
function ImageViewerComponent_div_1_div_1_img_8_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 24);
    i0.ɵɵlistener("load", function ImageViewerComponent_div_1_div_1_img_8_Template_img_load_0_listener() { i0.ɵɵrestoreView(_r2); const thumb_r1 = i0.ɵɵnextContext().$implicit; return i0.ɵɵresetView(thumb_r1.isImageLoading = false); })("click", function ImageViewerComponent_div_1_div_1_img_8_Template_img_click_0_listener($event) { i0.ɵɵrestoreView(_r2); const i_r3 = i0.ɵɵnextContext().index; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.onClick($event, i_r3)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const thumb_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r3.utilsService.processUrl(null, thumb_r1.thumbUrl), i0.ɵɵsanitizeUrl)("alt", thumb_r1.title || "");
} }
function ImageViewerComponent_div_1_div_1_img_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 25);
    i0.ɵɵlistener("click", function ImageViewerComponent_div_1_div_1_img_9_Template_img_click_0_listener($event) { i0.ɵɵrestoreView(_r5); const i_r3 = i0.ɵɵnextContext().index; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.onClick($event, i_r3)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const thumb_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r3.utilsService.processUrl(null, thumb_r1.imageToShow), i0.ɵɵsanitizeUrl)("alt", thumb_r1.title || "");
} }
function ImageViewerComponent_div_1_div_1_div_10_ng_container_5_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const thumb_r1 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("href", thumb_r1.source.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(thumb_r1.source.citation);
} }
function ImageViewerComponent_div_1_div_1_div_10_ng_container_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const thumb_r1 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(thumb_r1.source.citation);
} }
function ImageViewerComponent_div_1_div_1_div_10_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageViewerComponent_div_1_div_1_div_10_ng_container_5_a_1_Template, 2, 2, "a", 27)(2, ImageViewerComponent_div_1_div_1_div_10_ng_container_5_ng_container_2_Template, 2, 1, "ng-container", 26);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const thumb_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", thumb_r1.source.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !thumb_r1.source.url);
} }
function ImageViewerComponent_div_1_div_1_div_10_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const thumb_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", thumb_r1.source, " ");
} }
function ImageViewerComponent_div_1_div_1_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "p", 20)(2, "b");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵtemplate(5, ImageViewerComponent_div_1_div_1_div_10_ng_container_5_Template, 3, 2, "ng-container", 26)(6, ImageViewerComponent_div_1_div_1_div_10_ng_container_6_Template, 2, 1, "ng-container", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const thumb_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.configService.getTranslation("common.image.credits"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.isSourceObject(thumb_r1.source));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.isSourceObject(thumb_r1.source));
} }
function ImageViewerComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "div", 10)(3, "div", 11)(4, "div", 12);
    i0.ɵɵelement(5, "span", 13);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(6, ImageViewerComponent_div_1_div_1_h6_6_Template, 2, 1, "h6", 14)(7, ImageViewerComponent_div_1_div_1_div_7_Template, 3, 1, "div", 15)(8, ImageViewerComponent_div_1_div_1_img_8_Template, 1, 2, "img", 16)(9, ImageViewerComponent_div_1_div_1_img_9_Template, 1, 2, "img", 17)(10, ImageViewerComponent_div_1_div_1_div_10_Template, 7, 3, "div", 18);
    i0.ɵɵelementStart(11, "div", 19)(12, "p", 20)(13, "b");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "br");
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const thumb_r1 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r3.getCssClass())("hidden", !ctx_r3.showMore && i_r3 >= ctx_r3.size);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("hidden", !thumb_r1.isImageLoading);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", thumb_r1.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", thumb_r1.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", thumb_r1.use === undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", thumb_r1.use !== undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", thumb_r1.source);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r3.configService.getTranslation("common.image.copyright"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.configService.getTranslation("common.image.copyright-text"), " ");
} }
function ImageViewerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, ImageViewerComponent_div_1_div_1_Template, 17, 10, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.thumbnails);
} }
function ImageViewerComponent_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵlistener("click", function ImageViewerComponent_a_4_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.showMore = !ctx_r3.showMore); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.configService.getTranslation("filterterms.showmore"));
} }
function ImageViewerComponent_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵlistener("click", function ImageViewerComponent_a_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.showMore = !ctx_r3.showMore); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.configService.getTranslation("filterterms.showless"));
} }
function ImageViewerComponent_div_8_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41)(1, "h5", 42);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.title);
} }
function ImageViewerComponent_div_8_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41)(1, "h4");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.subtitle);
} }
function ImageViewerComponent_div_8_image_viewer_modal_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "image-viewer-modal", 43);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", ctx_r3.type)("parentId", ctx_r3.id)("images", ctx_r3.selectedImages)("selectedImage", ctx_r3.selectedImage);
} }
function ImageViewerComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "div", 31)(2, "div", 32)(3, "div", 33)(4, "div", 34)(5, "div", 35);
    i0.ɵɵtemplate(6, ImageViewerComponent_div_8_div_6_Template, 3, 1, "div", 36)(7, ImageViewerComponent_div_8_div_7_Template, 3, 1, "div", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 37);
    i0.ɵɵelement(9, "button", 38);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "div", 39);
    i0.ɵɵtemplate(11, ImageViewerComponent_div_8_image_viewer_modal_11_Template, 1, 4, "image-viewer-modal", 40);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r3.id);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r3.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.subtitle);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r3.modalOpen);
} }
class ImageViewerComponent {
    constructor(imageService, bsEventsService, utilsService, configService) {
        this.imageService = imageService;
        this.bsEventsService = bsEventsService;
        this.utilsService = utilsService;
        this.configService = configService;
        this.size = 3;
        this.layout = 'vertical';
        this.clickEvent = new EventEmitter();
        this.showMore = false;
        this.thumbnails = [];
        this.modalOpen = false;
    }
    ngAfterViewInit() {
        this.bsEventsService.onModalShown().subscribe((event) => {
            this.modalOpen = true;
        });
        this.bsEventsService.onModalHidden().subscribe((event) => {
            this.modalOpen = false;
        });
    }
    ngOnInit() {
        this.space = this.space || this.configService.env.space;
        this.id = 'image-viewer-' + this.utilsService.getRandomInt(100);
        if (!(typeof (this.images) === 'object')) {
            this.images = [];
        }
        if (this.images && this.images.length > 0) {
            if (this.type === 'database') {
                this.thumbImages = this.images;
                this.normalImages = this.images;
                this.extraImages = this.images;
            }
            else {
                this.thumbImages = this.images.filter(item => item.use && item.use.toLowerCase() === 'thumb').length > 0;
                this.normalImages = this.images.filter(item => item.use && item.use.toLowerCase() === 'normal').length > 0;
                this.extraImages = this.images.filter(item => item.use && item.use.toLowerCase() === 'extra').length > 0;
            }
            for (let image of this.images) {
                if (this.type === 'database') {
                    if (this.originalsize) {
                        image.thumbUrl = this.configService.env.storageUrl + '/' + this.space + '/images/' + image.domain + '/' + this.encode(image.id);
                        image.largeUrl = this.configService.env.storageUrl + '/' + this.space + '/images/' + image.domain + '/' + this.encode(image.id);
                    }
                    else {
                        image.thumbUrl = this.configService.env.storageUrl + '/' + this.space + '/images/' + image.domain + '/' + this.encode(image.id) + '?thumbnail=m';
                        image.largeUrl = this.configService.env.storageUrl + '/' + this.space + '/images/' + image.domain + '/' + this.encode(image.id) + '?thumbnail=l';
                    }
                    this.thumbnails.push(image);
                }
                else {
                    if (this.use) {
                        if (image.use && image.use.toLowerCase() === this.use.toLowerCase()) {
                            //image.url = environment.fileManagerUrl + '/download?filepath=' + this.encode(image.src);
                            image.url = this.configService.env.storageUrl + this.encode(image.src);
                            this.getImageFromService(image);
                            this.thumbnails.push(image);
                        }
                    }
                    else {
                        if (this.thumbImages) {
                            if (image.use && image.use.toLowerCase() === 'thumb') {
                                //image.url = environment.fileManagerUrl + '/download?filepath=' + this.encode(image.src);
                                image.url = this.configService.env.storageUrl + this.encode(image.src);
                                this.getImageFromService(image);
                                this.thumbnails.push(image);
                            }
                        }
                        else if (!this.thumbImages && this.normalImages) {
                            if (image.use && image.use.toLowerCase() === 'normal') {
                                //image.url = environment.fileManagerUrl + '/download?filepath=' + this.encode(image.src);
                                image.url = this.configService.env.storageUrl + this.encode(image.src);
                                this.getImageFromService(image);
                                this.thumbnails.push(image);
                            }
                        }
                        else if (!this.thumbImages && !this.normalImages && this.extraImages) {
                            if (image.use && image.use.toLowerCase() === 'extra') {
                                //image.url = environment.fileManagerUrl + '/download?filepath=' + this.encode(image.src);
                                image.url = this.configService.env.storageUrl + this.encode(image.src);
                                this.getImageFromService(image);
                                this.thumbnails.push(image);
                            }
                        }
                        else {
                            //all images
                            image.url = this.configService.env.storageUrl + (image.src || image.id);
                            image.isImageLoading = true;
                            image.thumbUrl = image.url + '?thumbnail=m';
                            this.thumbnails.push(image);
                        }
                    }
                }
            }
        }
    }
    getCssClass() {
        if (this.layout === 'vertical') {
            return 'col-md-12 mb-2';
        }
        else {
            return 'col-lg-4 col-md-6 mb-2';
        }
    }
    encode(url) {
        if (!url) {
            return;
        }
        if (url.includes('/')) {
            return url;
        }
        else {
            return encodeURIComponent(url);
        }
    }
    createImageFromBlob(image, imageItem) {
        let reader = new FileReader();
        reader.addEventListener("load", () => {
            if (imageItem) {
                imageItem.imageToShow = reader.result;
            }
            else {
                this.imageToShow = reader.result;
            }
        }, false);
        if (image) {
            reader.readAsDataURL(image);
        }
    }
    getImageFromService(image) {
        if (image) {
            image.isImageLoading = true;
            this.imageService.getImage(image.url).subscribe(data => {
                this.createImageFromBlob(data, image);
                image.isImageLoading = false;
            }, error => {
                image.isImageLoading = false;
            });
        }
        else {
            this.isImageLoading = true;
            this.imageService.getImage(this.url).subscribe(data => {
                this.createImageFromBlob(data);
                this.isImageLoading = false;
            }, error => {
                this.isImageLoading = false;
            });
        }
    }
    showLibraryIcon() {
        return Math.max(this.images.filter(item => item.use && item.use.toLowerCase() === 'extra').length, this.images.filter(item => item.use && item.use.toLowerCase() === 'normal').length, this.images.filter(item => item.use && item.use.toLowerCase() === 'thumb').length, this.images.filter(item => item.use === undefined).length) > 1;
    }
    onClick(event, index) {
        if (this.carousel === 'false') {
            this.clickEvent.emit(event);
        }
        else {
            this.selectedImage = index;
            this.selectedImages = this.images.filter(item => (item.use && item.use.toLowerCase() === 'normal') || (item.use && item.use.toLowerCase() === 'extra') || item.use === undefined);
            document.getElementById('openModal' + this.id).click();
        }
    }
    isSourceObject(source) {
        return typeof (source) === 'object';
    }
    static { this.ɵfac = function ImageViewerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImageViewerComponent)(i0.ɵɵdirectiveInject(i1.ImageService), i0.ɵɵdirectiveInject(i1.BsEventsService), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImageViewerComponent, selectors: [["image-viewer"]], inputs: { space: "space", type: "type", size: "size", title: "title", subtitle: "subtitle", images: "images", use: "use", carousel: "carousel", originalsize: "originalsize", layout: "layout" }, outputs: { clickEvent: "clickEvent" }, standalone: false, decls: 9, vars: 7, consts: [["class", "row", 4, "ngIf"], [1, "row"], [1, "col-md-12", "align-center"], ["class", "more", "href", "javascript:", 3, "click", 4, "ngIf"], ["href", "#", "type", "button", "data-bs-toggle", "modal", 1, "modals-trigger", 3, "hidden", "id"], [1, "bi", "bi-share-fill"], ["class", "modal fade", 3, "id", 4, "ngIf"], [3, "ngClass", "hidden", 4, "ngFor", "ngForOf"], [3, "ngClass", "hidden"], [1, "image-card"], [1, "image", "spinner", 3, "hidden"], [1, "col-md-12", "mb-3", "align-center"], ["role", "status", 1, "spinner-border"], [1, "sr-only"], ["class", "image-title", 4, "ngIf"], ["class", "image-source-container", 4, "ngIf"], ["class", "image-element", 3, "src", "alt", "load", "click", 4, "ngIf"], ["class", "image-element", 3, "src", "alt", "click", 4, "ngIf"], ["class", "source-container mt-2", 4, "ngIf"], [1, "source-container", "mt-2"], [1, "small", "text-color-gray-medium"], [1, "image-title"], [1, "image-source-container"], [1, "figure-caption"], [1, "image-element", 3, "load", "click", "src", "alt"], [1, "image-element", 3, "click", "src", "alt"], [4, "ngIf"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"], ["href", "javascript:", 1, "more", 3, "click"], [1, "modal", "fade", 3, "id"], [1, "modal-dialog", "modal-xl", "modal-dialog-centered"], [1, "modal-content"], [1, "modal-header"], [1, "row", "gallery-header"], [1, "col-md-10"], ["class", "col-md-12", 4, "ngIf"], [1, "col-md-2", "align-right"], ["type", "button", "data-bs-dismiss", "modal", "aria-label", "Close", 1, "btn-close"], [1, "modal-body"], [3, "type", "parentId", "images", "selectedImage", 4, "ngIf"], [1, "col-md-12"], [1, "title-link"], [3, "type", "parentId", "images", "selectedImage"]], template: function ImageViewerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementContainerStart(0);
            i0.ɵɵtemplate(1, ImageViewerComponent_div_1_Template, 2, 1, "div", 0);
            i0.ɵɵelementStart(2, "div", 1)(3, "div", 2);
            i0.ɵɵtemplate(4, ImageViewerComponent_a_4_Template, 3, 1, "a", 3)(5, ImageViewerComponent_a_5_Template, 3, 1, "a", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementStart(6, "a", 4);
            i0.ɵɵelement(7, "i", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, ImageViewerComponent_div_8_Template, 12, 4, "div", 6);
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.images && ctx.images.length > 0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.showMore);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showMore);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", true)("id", "openModal" + ctx.id);
            i0.ɵɵattribute("data-bs-target", "#" + ctx.id);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.id);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, ImageViewerModalComponent], styles: [".title-container[_ngcontent-%COMP%]{display:flex}.title-container[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-right:5px;color:var(--default-border-color)}img[_ngcontent-%COMP%]:hover{box-shadow:0 0 2px 1px #008cba80;cursor:pointer}.image-source[_ngcontent-%COMP%]{font-size:.8em}.image-title[_ngcontent-%COMP%]{font-size:1em;font-style:italic}.source-container[_ngcontent-%COMP%]{margin-bottom:.5em}.image-element[_ngcontent-%COMP%]{width:100%}h5[_ngcontent-%COMP%]{color:var(--primary-color)}a.gallery-button-small[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:34px;vertical-align:bottom}.gallery-header[_ngcontent-%COMP%]{width:100%}.image-component-horizontal[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap}.image-component-horizontal[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{max-width:33%;padding:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageViewerComponent, [{
        type: Component,
        args: [{ selector: 'image-viewer', standalone: false, template: "<ng-container>\r\n    <div class=\"row\" *ngIf=\"images && images.length > 0\">\r\n        <div [ngClass]=\"getCssClass()\" *ngFor=\"let thumb of thumbnails;let i = index\" [hidden]=\"!showMore && i>=size\">\r\n            \r\n            <div class=\"image-card\">\r\n                <div class=\"image spinner\" [hidden]=\"!thumb.isImageLoading\">\r\n                    <div class=\"col-md-12 mb-3 align-center\">\r\n                        <div class=\"spinner-border\" role=\"status\">\r\n                            <span class=\"sr-only\"></span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n        \r\n                <h6 class=\"image-title\" *ngIf=\"thumb.title\">{{thumb.title}}</h6>\r\n                \r\n                <div class=\"image-source-container\" *ngIf=\"thumb.description\">\r\n                    <p class=\"figure-caption\">{{thumb.description}}</p>\r\n                </div>\r\n        \r\n                <img class=\"image-element\" (load)=\"thumb.isImageLoading = false;\" *ngIf=\"thumb.use === undefined\"\r\n                    [src]=\"utilsService.processUrl(null,thumb.thumbUrl)\" [alt]=\"thumb.title || ''\"\r\n                    (click)=\"onClick($event,i)\" />\r\n        \r\n                <img class=\"image-element\" *ngIf=\"thumb.use !== undefined\"\r\n                    [src]=\"utilsService.processUrl(null,thumb.imageToShow)\" [alt]=\"thumb.title || ''\"\r\n                    (click)=\"onClick($event,i)\" />\r\n        \r\n                <div class=\"source-container mt-2\" *ngIf=\"thumb.source\">\r\n                    <p class=\"small text-color-gray-medium\">\r\n                        <b>{{ configService.getTranslation('common.image.credits')}}</b><br />\r\n                        <ng-container *ngIf=\"isSourceObject(thumb.source)\">\r\n                            <a *ngIf=\"thumb.source.url\" [href]=\"thumb.source.url\"\r\n                                target=\"_blank\">{{thumb.source.citation}}</a>\r\n                            <ng-container *ngIf=\"!thumb.source.url\">{{thumb.source.citation}}</ng-container>\r\n                        </ng-container>\r\n                        <ng-container *ngIf=\"!isSourceObject(thumb.source)\">\r\n                            {{ thumb.source }}\r\n                        </ng-container>\r\n                    </p>\r\n                </div>\r\n        \r\n                <div class=\"source-container mt-2\">\r\n                    <p class=\"small text-color-gray-medium\">\r\n                        <b>{{ configService.getTranslation('common.image.copyright')}}</b><br />\r\n                        {{ configService.getTranslation('common.image.copyright-text')}}\r\n                    </p>\r\n                </div>\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 align-center\">\r\n            <a class=\"more\" href=\"javascript:\" *ngIf=\"!showMore\" (click)=\"showMore=!showMore\"><span>{{ configService.getTranslation('filterterms.showmore') }}</span></a>\r\n            <a class=\"more\" href=\"javascript:\" *ngIf=\"showMore\" (click)=\"showMore=!showMore\"><span>{{ configService.getTranslation('filterterms.showless') }}</span></a>\r\n        </div>\r\n    </div>\r\n</ng-container>\r\n\r\n<a href=\"#\" class=\"modals-trigger\" [hidden]=\"true\" [id]=\"'openModal' + id\" type=\"button\" data-bs-toggle=\"modal\"\r\n    [attr.data-bs-target]=\"'#' + id\">\r\n    <i class=\"bi bi-share-fill\"></i>\r\n</a>\r\n\r\n<div class=\"modal fade\" *ngIf=\"id\" [id]=\"id\">\r\n    <div class=\"modal-dialog modal-xl modal-dialog-centered\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <div class=\"row gallery-header\">\r\n                    <div class=\"col-md-10\">\r\n                        <div class=\"col-md-12\" *ngIf=\"title\">\r\n                            <h5 class=\"title-link\">{{ title }}</h5>\r\n                        </div>\r\n                        <div class=\"col-md-12\" *ngIf=\"subtitle\">\r\n                            <h4>{{ subtitle }}</h4>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-md-2 align-right\">\r\n                        <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"modal-body\">\r\n                <image-viewer-modal *ngIf=\"modalOpen\" [type]=\"type\" [parentId]=\"id\" [images]=\"selectedImages\"\r\n                    [selectedImage]=\"selectedImage\"></image-viewer-modal>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>", styles: [".title-container{display:flex}.title-container span{margin-right:5px;color:var(--default-border-color)}img:hover{box-shadow:0 0 2px 1px #008cba80;cursor:pointer}.image-source{font-size:.8em}.image-title{font-size:1em;font-style:italic}.source-container{margin-bottom:.5em}.image-element{width:100%}h5{color:var(--primary-color)}a.gallery-button-small .material-icons{font-size:34px;vertical-align:bottom}.gallery-header{width:100%}.image-component-horizontal{display:flex;flex-direction:row;flex-wrap:wrap}.image-component-horizontal>div{max-width:33%;padding:1em}\n"] }]
    }], () => [{ type: i1.ImageService }, { type: i1.BsEventsService }, { type: i1.UtilsService }, { type: i1.ConfigurationService }], { space: [{
            type: Input
        }], type: [{
            type: Input
        }], size: [{
            type: Input
        }], title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }], images: [{
            type: Input
        }], use: [{
            type: Input
        }], carousel: [{
            type: Input
        }], originalsize: [{
            type: Input
        }], layout: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ImageViewerComponent, { className: "ImageViewerComponent", filePath: "src/components/image-viewer/image-viewer.component.ts", lineNumber: 13 }); })();

function ImageModalComponent_ng_container_2_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "p", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const img_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", img_r1.description, " ");
} }
function ImageModalComponent_ng_container_2_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "p", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const img_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(img_r1.legend);
} }
function ImageModalComponent_ng_container_2_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "p", 12)(2, "b");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const img_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("common.image.credits"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", img_r1.source, " ");
} }
function ImageModalComponent_ng_container_2_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "p", 12)(2, "b");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("common.image.copyright"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.configService.getTranslation("common.image.copyright-text"), " ");
} }
function ImageModalComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6);
    i0.ɵɵtemplate(3, ImageModalComponent_ng_container_2_div_1_div_3_Template, 3, 1, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵelement(5, "img", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵtemplate(7, ImageModalComponent_ng_container_2_div_1_div_7_Template, 3, 1, "div", 7)(8, ImageModalComponent_ng_container_2_div_1_div_8_Template, 6, 2, "div", 7)(9, ImageModalComponent_ng_container_2_div_1_div_9_Template, 6, 2, "div", 7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const img_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", img_r1.description);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap(img_r1.style);
    i0.ɵɵproperty("ngClass", img_r1.class)("alt", img_r1.alt)("src", ctx_r1.utilsService.processUrl(null, img_r1.modalUrl), i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("width", img_r1.width ? img_r1.width : null)("height", img_r1.height ? img_r1.height : null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", img_r1.legend);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", img_r1.source);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", img_r1.copyright && !img_r1.source);
} }
function ImageModalComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ImageModalComponent_ng_container_2_div_1_Template, 10, 11, "div", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.images);
} }
class ImageModalComponent {
    constructor(utilsService, configService) {
        this.utilsService = utilsService;
        this.configService = configService;
    }
    ngOnInit() { }
    confirm() {
        this.close();
    }
    close() {
        //this.bsModalRef.hide();
    }
    static { this.ɵfac = function ImageModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImageModalComponent)(i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImageModalComponent, selectors: [["fi-image-modal"]], inputs: { images: "images", parentId: "parentId" }, standalone: false, decls: 3, vars: 2, consts: [[1, "row", 3, "id"], [1, "col-12"], [4, "ngIf"], ["class", "image-viewer", 4, "ngFor", "ngForOf"], [1, "image-viewer"], [1, "row"], [1, "col-md-12"], ["class", "image-source-container", 4, "ngIf"], [1, "col-md-12", "image-container"], [3, "ngClass", "alt", "src"], [1, "image-source-container"], [1, "small", "text-color-gray-medium", "align-justify"], [1, "small", "text-color-gray-medium"]], template: function ImageModalComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, ImageModalComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("id", "single-image-" + ctx.parentId);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.images && ctx.images.length > 0);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf], styles: [".image-source-container[_ngcontent-%COMP%]{text-align:center}.image-viewer[_ngcontent-%COMP%]{padding-left:1em;padding-right:1em}.image-source[_ngcontent-%COMP%]{font-size:.8em}.image-title-container[_ngcontent-%COMP%]{text-align:center}.image-title[_ngcontent-%COMP%]{font-style:italic;text-align:center}.image-container[_ngcontent-%COMP%]{text-align:center}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageModalComponent, [{
        type: Component,
        args: [{ selector: 'fi-image-modal', standalone: false, template: "<div class=\"row\" [id]=\"'single-image-' + parentId\">\r\n    <div class=\"col-12\">\r\n        <ng-container *ngIf=\"images && images.length > 0\">\r\n\r\n                <div class=\"image-viewer\" *ngFor=\"let img of images; let i = index\">\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-12\">\r\n                            <div class=\"image-source-container\" *ngIf=\"img.description\">\r\n                                <p class=\"small text-color-gray-medium align-justify\">\r\n                                    {{img.description}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"col-md-12 image-container\">\r\n                            \r\n                            <img\r\n                                [ngClass]=\"img.class\" \r\n                                [attr.width]=\"img.width ? img.width : null\" \r\n                                [attr.height]=\"img.height ? img.height : null\" \r\n                                [style]=\"img.style\" \r\n                                [alt]=\"img.alt\" \r\n                                [src]=\"utilsService.processUrl(null,img.modalUrl)\" />\r\n\r\n                        </div>\r\n                        <div class=\"col-md-12\">\r\n                            <div class=\"image-source-container\" *ngIf=\"img.legend\">\r\n                                <p class=\"small text-color-gray-medium\">{{img.legend}}</p>\r\n                            </div>\r\n                            <div class=\"image-source-container\" *ngIf=\"img.source\">\r\n                                <p class=\"small text-color-gray-medium\">\r\n                                    <b>{{ configService.getTranslation('common.image.credits')}}</b><br />\r\n                                    {{ img.source }}\r\n                                </p>\r\n                            </div>\r\n                            <div class=\"image-source-container\" *ngIf=\"img.copyright && !img.source\">\r\n                                <p class=\"small text-color-gray-medium\">\r\n                                    <b>{{ configService.getTranslation('common.image.copyright')}}</b><br />\r\n                                    {{ configService.getTranslation('common.image.copyright-text')}}\r\n                                </p>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n        </ng-container>\r\n    </div>\r\n</div>", styles: [".image-source-container{text-align:center}.image-viewer{padding-left:1em;padding-right:1em}.image-source{font-size:.8em}.image-title-container{text-align:center}.image-title{font-style:italic;text-align:center}.image-container{text-align:center}\n"] }]
    }], () => [{ type: i1.UtilsService }, { type: i1.ConfigurationService }], { images: [{
            type: Input
        }], parentId: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ImageModalComponent, { className: "ImageModalComponent", filePath: "src/components/image/image-modal/image-modal.component.ts", lineNumber: 10 }); })();

function ImageComponent_h6_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.selectedImages[0].title);
} }
function ImageComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "p", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.selectedImages[0].description);
} }
function ImageComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "p", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedImages[0].alt, " ");
} }
function ImageComponent_img_6_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 12);
    i0.ɵɵlistener("click", function ImageComponent_img_6_Template_img_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.onClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r0.selectedImages[0].style);
    i0.ɵɵproperty("ngClass", ctx_r0.selectedImages[0].class)("alt", ctx_r0.selectedImages[0].alt)("src", ctx_r0.utilsService.processUrl(null, ctx_r0.selectedImages[0].url), i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("width", ctx_r0.selectedImages[0].width ? ctx_r0.selectedImages[0].width : null)("height", ctx_r0.selectedImages[0].height ? ctx_r0.selectedImages[0].height : null);
} }
function ImageComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "p", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.selectedImages[0].legend);
} }
function ImageComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "p", 11)(2, "b");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("common.image.credits"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedImages[0].source, " ");
} }
function ImageComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "p", 11)(2, "b");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("common.image.copyright"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.configService.getTranslation("common.image.copyright-text"), " ");
} }
function ImageComponent_a_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", true)("id", "openSingleImageModal" + ctx_r0.id);
    i0.ɵɵattribute("data-bs-target", "#" + ctx_r0.id);
} }
function ImageComponent_div_12_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "h5", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.title);
} }
function ImageComponent_div_12_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "h4");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.subtitle);
} }
function ImageComponent_div_12_fi_image_modal_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-image-modal", 27);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("parentId", ctx_r0.id)("images", ctx_r0.selectedImages);
} }
function ImageComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16)(2, "div", 17)(3, "div", 18)(4, "div", 19)(5, "div", 20)(6, "div", 0);
    i0.ɵɵtemplate(7, ImageComponent_div_12_div_7_Template, 3, 1, "div", 21)(8, ImageComponent_div_12_div_8_Template, 3, 1, "div", 21);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 22);
    i0.ɵɵelement(10, "p-button", 23);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "div", 24);
    i0.ɵɵtemplate(12, ImageComponent_div_12_fi_image_modal_12_Template, 1, 2, "fi-image-modal", 25);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", ctx_r0.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.subtitle);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.modalOpen);
} }
class ImageComponent {
    constructor(bsEventsService, utilsService, configService) {
        this.bsEventsService = bsEventsService;
        this.utilsService = utilsService;
        this.configService = configService;
        this.copyright = true;
        this.clickenabled = "true";
        this.clickEvent = new EventEmitter();
        this.ready = false;
        this.modalOpen = false;
    }
    ngAfterViewInit() {
        this.bsEventsService.onModalShown().subscribe((event) => {
            this.modalOpen = true;
        });
        this.bsEventsService.onModalHidden().subscribe((event) => {
            this.modalOpen = false;
        });
    }
    ngOnInit() {
        this.space = this.space || this.configService.env.space;
        if (this.use) {
            switch (this.use) {
                case "thumbnail":
                    if (!this.thumbnail) {
                        this.thumbnail = 's';
                    }
                    break;
                case "normal":
                    this.thumbnail = null;
                    break;
            }
        }
        this.id = 'image-' + this.utilsService.makeid(6);
        let url = "";
        if (this.domain) {
            url = this.configService.env.storageUrl + '/' + (this.space || this.configService.env.space) + '/images/' + this.domain;
        }
        else if (this.collection) {
            url = this.configService.env.storageUrl + '/' + (this.space || this.configService.env.space) + '/' + this.collection + '/images';
        }
        if (!this.src.startsWith("/")) {
            url = url + "/";
        }
        this.selectedImages = [
            {
                id: this.id,
                url: url + this.src + (this.use && this.thumbnail ? '?thumbnail=' + this.thumbnail : ''),
                modalUrl: url + this.src + '?thumbnail=l',
                title: this.title,
                description: this.description,
                subtitle: this.subtitle,
                source: this.source,
                space: this.space,
                domain: this.collection,
                use: this.use,
                class: this.class,
                src: this.src,
                alt: this.alt,
                width: this.width,
                height: this.height,
                style: this.style,
                copyright: this.copyright
            }
        ];
        this.ready = true;
    }
    onClick() {
        if ((this.clickenabled > "" && JSON.parse(this.clickenabled))) {
            document.getElementById('openSingleImageModal' + this.selectedImages[0].id).click();
        }
    }
    static { this.ɵfac = function ImageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImageComponent)(i0.ɵɵdirectiveInject(i1.BsEventsService), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImageComponent, selectors: [["fi-image"]], inputs: { title: "title", subtitle: "subtitle", description: "description", source: "source", copyright: "copyright", space: "space", domain: "domain", collection: "collection", use: "use", thumbnail: "thumbnail", class: "class", src: "src", alt: "alt", width: "width", height: "height", style: "style", clickenabled: "clickenabled" }, outputs: { clickEvent: "clickEvent" }, standalone: false, decls: 13, vars: 9, consts: [[1, "row"], [1, "col-md-12"], ["class", "image-title", 4, "ngIf"], ["class", "image-source-container", 4, "ngIf"], [1, "col-md-12", "image-container"], [3, "ngClass", "style", "alt", "src", "click", 4, "ngIf"], ["href", "#", "class", "modals-trigger", "type", "button", "data-bs-toggle", "modal", 3, "hidden", "id", 4, "ngIf"], ["class", "modal modal-share fade", "tabindex", "-1", "aria-hidden", "true", 3, "id", 4, "ngIf"], [1, "image-title"], [1, "image-source-container"], [1, "figure-caption", "align-justify"], [1, "small", "text-color-gray-medium"], [3, "click", "ngClass", "alt", "src"], ["href", "#", "type", "button", "data-bs-toggle", "modal", 1, "modals-trigger", 3, "hidden", "id"], [1, "bi", "bi-share-fill"], ["tabindex", "-1", "aria-hidden", "true", 1, "modal", "modal-share", "fade", 3, "id"], [1, "modal-dialog", "modal-dialog-centered"], [1, "modal-content"], [1, "modal-header"], [1, "row", "gallery-header"], [1, "col-md-10"], ["class", "col-md-12", 4, "ngIf"], [1, "col-md-2", "align-right"], ["icon", "pi pi-times", "severity", "secondary", "data-bs-dismiss", "modal", "aria-label", "Close"], [1, "modal-body"], [3, "parentId", "images", 4, "ngIf"], [1, "title-link"], [3, "parentId", "images"]], template: function ImageComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, ImageComponent_h6_2_Template, 2, 1, "h6", 2)(3, ImageComponent_div_3_Template, 3, 1, "div", 3)(4, ImageComponent_div_4_Template, 3, 1, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 4);
            i0.ɵɵtemplate(6, ImageComponent_img_6_Template, 1, 7, "img", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 1);
            i0.ɵɵtemplate(8, ImageComponent_div_8_Template, 3, 1, "div", 3)(9, ImageComponent_div_9_Template, 6, 2, "div", 3)(10, ImageComponent_div_10_Template, 6, 2, "div", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, ImageComponent_a_11_Template, 2, 3, "a", 6)(12, ImageComponent_div_12_Template, 13, 4, "div", 7);
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.selectedImages[0].title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.selectedImages[0].description);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.selectedImages[0].alt);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.ready);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.selectedImages[0].legend);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.selectedImages[0].source);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.copyright && !ctx.selectedImages[0].source);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.id);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.id);
        } }, dependencies: [i3.NgClass, i3.NgIf, i7.Button, ImageModalComponent], styles: [".gallery-header[_ngcontent-%COMP%]{width:100%}.image-source-container[_ngcontent-%COMP%]{text-align:center}.image-viewer[_ngcontent-%COMP%]{padding-left:1em;padding-right:1em}.image-source[_ngcontent-%COMP%]{font-size:.8em}.image-title-container[_ngcontent-%COMP%]{text-align:center}.image-title[_ngcontent-%COMP%]{font-style:italic;text-align:center}.image-container[_ngcontent-%COMP%]{text-align:center}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageComponent, [{
        type: Component,
        args: [{ selector: 'fi-image', standalone: false, template: "<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        <h6 class=\"image-title\" *ngIf=\"selectedImages[0].title\">{{ selectedImages[0].title }}</h6>\r\n\r\n        <div class=\"image-source-container\" *ngIf=\"selectedImages[0].description\">\r\n            <p class=\"figure-caption align-justify\">{{selectedImages[0].description}}</p>\r\n        </div>\r\n\r\n        <div class=\"image-source-container\" *ngIf=\"selectedImages[0].alt\">\r\n            <p class=\"small text-color-gray-medium\">\r\n                {{selectedImages[0].alt}}\r\n            </p>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-12 image-container\">\r\n        \r\n        <img *ngIf=\"ready\" \r\n        [ngClass]=\"selectedImages[0].class\" \r\n        [attr.width]=\"selectedImages[0].width ? selectedImages[0].width : null\" \r\n        [attr.height]=\"selectedImages[0].height ? selectedImages[0].height : null\" \r\n        [style]=\"selectedImages[0].style\" \r\n        [alt]=\"selectedImages[0].alt\" \r\n        [src]=\"utilsService.processUrl(null,selectedImages[0].url)\"\r\n        (click)=\"onClick()\" />\r\n\r\n    </div>\r\n    <div class=\"col-md-12\">\r\n        <div class=\"image-source-container\" *ngIf=\"selectedImages[0].legend\">\r\n            <p class=\"small text-color-gray-medium\">{{selectedImages[0].legend}}</p>\r\n        </div>\r\n        <div class=\"image-source-container\" *ngIf=\"selectedImages[0].source\">\r\n            <p class=\"small text-color-gray-medium\">\r\n                <b>{{ configService.getTranslation('common.image.credits')}}</b><br />\r\n                {{ selectedImages[0].source }}\r\n            </p>\r\n        </div>\r\n        <div class=\"image-source-container\" *ngIf=\"copyright && !selectedImages[0].source\">\r\n            <p class=\"small text-color-gray-medium\">\r\n                <b>{{ configService.getTranslation('common.image.copyright')}}</b><br />\r\n                {{ configService.getTranslation('common.image.copyright-text')}}\r\n            </p>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n<a *ngIf=\"id\" href=\"#\" class=\"modals-trigger\" [hidden]=\"true\" [id]=\"'openSingleImageModal' + id\" type=\"button\" data-bs-toggle=\"modal\" [attr.data-bs-target]=\"'#' + id\">\r\n    <i class=\"bi bi-share-fill\"></i>\r\n</a>\r\n\r\n<div class=\"modal modal-share fade\" *ngIf=\"id\" [id]=\"id\" tabindex=\"-1\" aria-hidden=\"true\">\r\n    <div class=\"modal-dialog modal-dialog-centered\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <div class=\"row gallery-header\">\r\n                    <div class=\"col-md-10\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-12\" *ngIf=\"title\">\r\n                                <h5 class=\"title-link\">{{ title }}</h5>\r\n                            </div>\r\n                            <div class=\"col-md-12\" *ngIf=\"subtitle\">\r\n                                <h4>{{ subtitle }}</h4>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-md-2 align-right\">\r\n                        <p-button icon=\"pi pi-times\" severity=\"secondary\" data-bs-dismiss=\"modal\" aria-label=\"Close\" />\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"modal-body\">\r\n                <fi-image-modal *ngIf=\"modalOpen\" [parentId]=\"id\" [images]=\"selectedImages\"></fi-image-modal>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>", styles: [".gallery-header{width:100%}.image-source-container{text-align:center}.image-viewer{padding-left:1em;padding-right:1em}.image-source{font-size:.8em}.image-title-container{text-align:center}.image-title{font-style:italic;text-align:center}.image-container{text-align:center}\n"] }]
    }], () => [{ type: i1.BsEventsService }, { type: i1.UtilsService }, { type: i1.ConfigurationService }], { title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }], description: [{
            type: Input
        }], source: [{
            type: Input
        }], copyright: [{
            type: Input
        }], space: [{
            type: Input
        }], domain: [{
            type: Input
        }], collection: [{
            type: Input
        }], use: [{
            type: Input
        }], thumbnail: [{
            type: Input
        }], class: [{
            type: Input
        }], src: [{
            type: Input
        }], alt: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], style: [{
            type: Input
        }], clickenabled: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ImageComponent, { className: "ImageComponent", filePath: "src/components/image/image.component.ts", lineNumber: 13 }); })();

function LayersListComponent_ng_container_0_tr_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 9)(1, "th", 10)(2, "h6");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("map.layers-list.title"));
} }
function LayersListComponent_ng_container_0_tr_19_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵelement(2, "span", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td")(4, "p-checkbox", 12);
    i0.ɵɵtwoWayListener("ngModelChange", function LayersListComponent_ng_container_0_tr_19_Template_p_checkbox_ngModelChange_4_listener($event) { const layer_r3 = i0.ɵɵrestoreView(_r2).$implicit; i0.ɵɵtwoWayBindingSet(layer_r3.visible, $event) || (layer_r3.visible = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("onChange", function LayersListComponent_ng_container_0_tr_19_Template_p_checkbox_onChange_4_listener() { const ctx_r3 = i0.ɵɵrestoreView(_r2); const layer_r3 = ctx_r3.$implicit; const i_r5 = ctx_r3.index; const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.changeVisibility(layer_r3, i_r5)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "td")(6, "div")(7, "p-slider", 13);
    i0.ɵɵtwoWayListener("ngModelChange", function LayersListComponent_ng_container_0_tr_19_Template_p_slider_ngModelChange_7_listener($event) { const layer_r3 = i0.ɵɵrestoreView(_r2).$implicit; i0.ɵɵtwoWayBindingSet(layer_r3.opacity, $event) || (layer_r3.opacity = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("onChange", function LayersListComponent_ng_container_0_tr_19_Template_p_slider_onChange_7_listener() { const ctx_r5 = i0.ɵɵrestoreView(_r2); const layer_r3 = ctx_r5.$implicit; const i_r5 = ctx_r5.index; const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.changeOpacity(layer_r3, i_r5)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtext(9, "\u00A0");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const layer_r3 = ctx.$implicit;
    const i_r5 = ctx.index;
    i0.ɵɵadvance();
    i0.ɵɵclassMap(layer_r3.locked ? "locked" : "");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("innerHTML", layer_r3.title || layer_r3.params.LAYERS, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(layer_r3.locked ? "visibility-control locked" : "visibility-control");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "visibility-" + i_r5);
    i0.ɵɵproperty("disabled", layer_r3.locked);
    i0.ɵɵtwoWayProperty("ngModel", layer_r3.visible);
    i0.ɵɵproperty("binary", true);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(layer_r3.locked ? "locked" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", layer_r3.locked);
    i0.ɵɵtwoWayProperty("ngModel", layer_r3.opacity);
    i0.ɵɵproperty("min", 0)("max", 1)("step", 0.1);
} }
function LayersListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "table", 4)(5, "thead");
    i0.ɵɵtemplate(6, LayersListComponent_ng_container_0_tr_6_Template, 4, 1, "tr", 5);
    i0.ɵɵelementStart(7, "tr")(8, "th", 6)(9, "span", 7);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "th", 6)(12, "span", 7);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "th", 6)(15, "span", 7);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(17, "th");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "tbody");
    i0.ɵɵtemplate(19, LayersListComponent_ng_container_0_tr_19_Template, 10, 19, "tr", 8);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", ctx_r0.id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r0.config.layersList == null ? null : ctx_r0.config.layersList.position) === "top-right");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("map.layers-list.layer-name"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("map.layers-list.visibility"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("map.layers-list.opacity"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.layers);
} }
function LayersListComponent_ng_container_1_table_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 15)(1, "thead")(2, "tr", 6)(3, "th", 16)(4, "h6");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.id + "_groups_header");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("map.layers-list.title"));
} }
function LayersListComponent_ng_container_1_ng_container_6_ng_container_1_tr_18_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵelement(2, "span", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td")(4, "p-checkbox", 12);
    i0.ɵɵtwoWayListener("ngModelChange", function LayersListComponent_ng_container_1_ng_container_6_ng_container_1_tr_18_Template_p_checkbox_ngModelChange_4_listener($event) { const layer_r8 = i0.ɵɵrestoreView(_r7).$implicit; i0.ɵɵtwoWayBindingSet(layer_r8.visible, $event) || (layer_r8.visible = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("onChange", function LayersListComponent_ng_container_1_ng_container_6_ng_container_1_tr_18_Template_p_checkbox_onChange_4_listener() { const ctx_r8 = i0.ɵɵrestoreView(_r7); const layer_r8 = ctx_r8.$implicit; const i_r10 = ctx_r8.index; const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.changeVisibility(layer_r8, i_r10)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "td")(6, "div")(7, "p-slider", 13);
    i0.ɵɵtwoWayListener("ngModelChange", function LayersListComponent_ng_container_1_ng_container_6_ng_container_1_tr_18_Template_p_slider_ngModelChange_7_listener($event) { const layer_r8 = i0.ɵɵrestoreView(_r7).$implicit; i0.ɵɵtwoWayBindingSet(layer_r8.opacity, $event) || (layer_r8.opacity = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("onChange", function LayersListComponent_ng_container_1_ng_container_6_ng_container_1_tr_18_Template_p_slider_onChange_7_listener() { const ctx_r10 = i0.ɵɵrestoreView(_r7); const layer_r8 = ctx_r10.$implicit; const i_r10 = ctx_r10.index; const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.changeOpacity(layer_r8, i_r10)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtext(9, "\u00A0");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const layer_r8 = ctx.$implicit;
    const i_r10 = ctx.index;
    i0.ɵɵadvance();
    i0.ɵɵclassMap(layer_r8.locked ? "locked" : "");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("innerHTML", layer_r8.title || layer_r8.params.LAYERS, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(layer_r8.locked ? "visibility-control locked" : "visibility-control");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "visibility-" + i_r10);
    i0.ɵɵproperty("disabled", layer_r8.locked);
    i0.ɵɵtwoWayProperty("ngModel", layer_r8.visible);
    i0.ɵɵproperty("binary", true);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(layer_r8.locked ? "locked" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", layer_r8.locked);
    i0.ɵɵtwoWayProperty("ngModel", layer_r8.opacity);
    i0.ɵɵproperty("min", 0)("max", 1)("step", 0.1);
} }
function LayersListComponent_ng_container_1_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "thead")(2, "tr", 17)(3, "th", 10)(4, "span", 18);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "tr")(7, "th", 6)(8, "span", 7);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "th", 6)(11, "span", 7);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "th", 6)(14, "span", 7);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(16, "th");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "tbody");
    i0.ɵɵtemplate(18, LayersListComponent_ng_container_1_ng_container_6_ng_container_1_tr_18_Template, 10, 19, "tr", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const group_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(group_r12.names[ctx_r0.configService.env.currentLang] || group_r12.names[ctx_r0.configService.env.defaultLang]);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("map.layers-list.layer-name"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("map.layers-list.visibility"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("map.layers-list.opacity"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.getLayersByGroup(group_r12.code));
} }
function LayersListComponent_ng_container_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LayersListComponent_ng_container_1_ng_container_6_ng_container_1_Template, 19, 5, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const group_r12 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.getLayersByGroup(group_r12.code).length > 0);
} }
function LayersListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
    i0.ɵɵtemplate(4, LayersListComponent_ng_container_1_table_4_Template, 6, 2, "table", 14);
    i0.ɵɵelementStart(5, "table", 4);
    i0.ɵɵtemplate(6, LayersListComponent_ng_container_1_ng_container_6_Template, 2, 1, "ng-container", 8);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (ctx_r0.config.layersList == null ? null : ctx_r0.config.layersList.position) === "top-right");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", ctx_r0.id + "_groups_header");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.groups);
} }
class LayersListComponent {
    constructor(configService, mapService) {
        this.configService = configService;
        this.mapService = mapService;
    }
    ngOnInit() {
    }
    changeVisibility(layer, i) {
        let _layers = this.map.getLayers().getArray();
        _layers[i].setVisible(layer.visible);
    }
    changeOpacity(layer, i) {
        let _layers = this.map.getLayers().getArray();
        _layers[i].setOpacity(layer.opacity);
    }
    getLayersByGroup(group) {
        return this.layers.filter(item => item.group === group);
    }
    static { this.ɵfac = function LayersListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LayersListComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.MapService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LayersListComponent, selectors: [["layers-list"]], inputs: { id: "id", map: "map", groups: "groups", layers: "layers", config: "config" }, standalone: false, decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "row", "layers-list"], [1, "col-md-12"], [1, "layers-list-scroll"], [1, "table", 3, "id"], ["scope", "col", "class", "title", 4, "ngIf"], ["scope", "col"], [1, "column-title"], [4, "ngFor", "ngForOf"], ["scope", "col", 1, "title"], ["colspan", "4"], [1, "column-content", 3, "innerHTML"], ["inputId", "binary", 3, "ngModelChange", "onChange", "id", "disabled", "ngModel", "binary"], [1, "w-full", 3, "ngModelChange", "onChange", "disabled", "ngModel", "min", "max", "step"], ["class", "title", 3, "id", 4, "ngIf"], [1, "title", 3, "id"], ["colspan", "3"], ["scope", "col", 1, "group"], [1, "group-name"]], template: function LayersListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LayersListComponent_ng_container_0_Template, 20, 6, "ng-container", 0)(1, LayersListComponent_ng_container_1_Template, 7, 3, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.groups);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.groups);
        } }, dependencies: [i3.NgForOf, i3.NgIf, i5.NgControlStatus, i5.NgModel, i4$1.Checkbox, i5$2.Slider], styles: ["h6[_ngcontent-%COMP%]{color:var(--default-background-color);font-weight:500}.layers-list-container[_ngcontent-%COMP%]   .layers-list-scroll[_ngcontent-%COMP%]{max-height:300px!important;overflow:auto}.layers-list-container[_ngcontent-%COMP%]   .layers-list-table[_ngcontent-%COMP%]{max-width:25vw;border:solid 1px #ccc}.layers-list-container[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .title[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{background-color:var(--primary-color)}.layers-list[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{background-color:var(--default-background-color);margin-bottom:0!important}.layers-list[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{padding-left:1em;padding-right:1em}.layers-list[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:middle}.layers-list[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   .locked[_ngcontent-%COMP%]{opacity:.4}.layers-list[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   .column-title[_ngcontent-%COMP%], .layers-list[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   .column-content[_ngcontent-%COMP%]{font-size:.8em}.layers-list[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   .group[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{background-color:var(--secondary-background-color)}.layers-list[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   .group[_ngcontent-%COMP%]   .group-name[_ngcontent-%COMP%]{font-weight:500;font-size:.9em}.layers-list[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   .visibility-control[_ngcontent-%COMP%]{text-align:center}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LayersListComponent, [{
        type: Component,
        args: [{ selector: 'layers-list', standalone: false, template: "<ng-container *ngIf=\"!groups\">\r\n    <div class=\"row layers-list\">\r\n        <div class=\"col-md-12\">\r\n            <div class=\"layers-list-scroll\">\r\n                <table class=\"table\" [id]=\"id\">\r\n                    <thead>\r\n                        <tr scope=\"col\" class=\"title\" *ngIf=\"config.layersList?.position === 'top-right'\">\r\n                            <th colspan=\"4\"><h6>{{ configService.getTranslation('map.layers-list.title')}}</h6></th>\r\n                        </tr>\r\n                        <tr>\r\n                            <th scope=\"col\"><span class=\"column-title\">{{ configService.getTranslation('map.layers-list.layer-name')}}</span></th>\r\n                            <th scope=\"col\"><span class=\"column-title\">{{ configService.getTranslation('map.layers-list.visibility')}}</span></th>\r\n                            <th scope=\"col\"><span class=\"column-title\">{{ configService.getTranslation('map.layers-list.opacity')}}</span></th>\r\n                            <th></th>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr *ngFor=\"let layer of layers; let i = index\">\r\n                            <td class=\"{{ layer.locked ? 'locked' : '' }}\"><span class=\"column-content\" innerHTML=\"{{ layer.title || layer.params.LAYERS }}\"></span></td>                \r\n                            <td class=\"{{ layer.locked ? 'visibility-control locked' : 'visibility-control' }}\">\r\n                                <p-checkbox id=\"{{ 'visibility-' + i }}\" [disabled]=\"layer.locked\" [(ngModel)]=\"layer.visible\" [binary]=\"true\" inputId=\"binary\" (onChange)=\"changeVisibility(layer,i)\" />\r\n                            </td>\r\n                            <td class=\"{{ layer.locked ? 'locked' : '' }}\">\r\n                                <div><p-slider [disabled]=\"layer.locked\" [(ngModel)]=\"layer.opacity\" class=\"w-full\" [min]=\"0\" [max]=\"1\" [step]=\"0.1\" (onChange)=\"changeOpacity(layer,i)\" /></div>\r\n                            </td>\r\n                            <td>&nbsp;</td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-container>\r\n\r\n<ng-container *ngIf=\"groups\">\r\n    <div class=\"row layers-list\">\r\n        <div class=\"col-md-12\">\r\n            <div class=\"layers-list-scroll\">\r\n                <table class=\"table\" id=\"{{ id + '_groups_header' }}\" class=\"title\" *ngIf=\"config.layersList?.position === 'top-right'\">\r\n                    <thead>\r\n                        <tr scope=\"col\">\r\n                            <th colspan=\"3\"><h6>{{ configService.getTranslation('map.layers-list.title')}}</h6></th>\r\n                        </tr>\r\n                    </thead>\r\n                </table>\r\n                <table class=\"table\" id=\"{{ id + '_groups_header' }}\">\r\n                    <ng-container *ngFor=\"let group of groups\">\r\n                        <ng-container *ngIf=\"getLayersByGroup(group.code).length > 0\">\r\n                            <thead>\r\n                                <tr scope=\"col\" class=\"group\">\r\n                                    <th colspan=\"4\"><span class=\"group-name\">{{ group.names[configService.env.currentLang] || group.names[configService.env.defaultLang] }}</span></th>\r\n                                </tr>\r\n                                <tr>\r\n                                    <th scope=\"col\"><span class=\"column-title\">{{ configService.getTranslation('map.layers-list.layer-name')}}</span></th>\r\n                                    <th scope=\"col\"><span class=\"column-title\">{{ configService.getTranslation('map.layers-list.visibility')}}</span></th>\r\n                                    <th scope=\"col\"><span class=\"column-title\">{{ configService.getTranslation('map.layers-list.opacity')}}</span></th>\r\n                                    <th></th>\r\n                                </tr>\r\n                            </thead>\r\n                            <tbody>\r\n                                <tr *ngFor=\"let layer of getLayersByGroup(group.code); let i = index\">\r\n                                    <td class=\"{{ layer.locked ? 'locked' : '' }}\"><span class=\"column-content\" innerHTML=\"{{ layer.title || layer.params.LAYERS }}\"></span></td>\r\n                                    <td class=\"{{ layer.locked ? 'visibility-control locked' : 'visibility-control' }}\">\r\n                                        <p-checkbox id=\"{{ 'visibility-' + i }}\" [disabled]=\"layer.locked\" [(ngModel)]=\"layer.visible\" [binary]=\"true\" inputId=\"binary\" (onChange)=\"changeVisibility(layer,i)\" />\r\n                                    </td>\r\n                                    <td class=\"{{ layer.locked ? 'locked' : '' }}\">\r\n                                        <div><p-slider [disabled]=\"layer.locked\" [(ngModel)]=\"layer.opacity\" class=\"w-full\" [min]=\"0\" [max]=\"1\" [step]=\"0.1\" (onChange)=\"changeOpacity(layer,i)\" /></div>\r\n                                    </td>\r\n                                    <td>&nbsp;</td>\r\n                                </tr>      \r\n                            </tbody>\r\n                        </ng-container>\r\n                    </ng-container>\r\n                </table>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-container>", styles: ["h6{color:var(--default-background-color);font-weight:500}.layers-list-container .layers-list-scroll{max-height:300px!important;overflow:auto}.layers-list-container .layers-list-table{max-width:25vw;border:solid 1px #ccc}.layers-list-container .title th,.title th{background-color:var(--primary-color)}.layers-list table{background-color:var(--default-background-color);margin-bottom:0!important}.layers-list table tr{padding-left:1em;padding-right:1em}.layers-list table td{vertical-align:middle}.layers-list table .locked{opacity:.4}.layers-list table .column-title,.layers-list table .column-content{font-size:.8em}.layers-list table .group th{background-color:var(--secondary-background-color)}.layers-list table .group .group-name{font-weight:500;font-size:.9em}.layers-list table .visibility-control{text-align:center}\n"] }]
    }], () => [{ type: i1.ConfigurationService }, { type: i1.MapService }], { id: [{
            type: Input
        }], map: [{
            type: Input
        }], groups: [{
            type: Input
        }], layers: [{
            type: Input
        }], config: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LayersListComponent, { className: "LayersListComponent", filePath: "src/components/map/layers-list/layers-list.component.ts", lineNumber: 12 }); })();

function LegendsListComponent_ng_container_2_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵelement(2, "h6", 3)(3, "img", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const layer_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("innerHTML", layer_r1.title || layer_r1.params.LAYERS, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r1.processUrl(layer_r1.legend.url), i0.ɵɵsanitizeUrl);
} }
function LegendsListComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegendsListComponent_ng_container_2_tr_1_Template, 4, 2, "tr", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const layer_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", layer_r1.legend == null ? null : layer_r1.legend.show);
} }
class LegendsListComponent {
    constructor(mapService, configService) {
        this.mapService = mapService;
        this.configService = configService;
    }
    ngOnInit() {
    }
    processUrl(url) {
        if (url) {
            if (url.startsWith('fs://')) {
                url = this.configService.env.servicesUrl + url.replace('fs:/', '');
            }
        }
        return url;
    }
    static { this.ɵfac = function LegendsListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LegendsListComponent)(i0.ɵɵdirectiveInject(i1.MapService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LegendsListComponent, selectors: [["legends-list"]], inputs: { id: "id", map: "map", layers: "layers" }, standalone: false, decls: 3, vars: 1, consts: [["id", "legends-list", 1, "table", "legends-list"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "innerHTML"], [3, "src"]], template: function LegendsListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "table", 0)(1, "tbody");
            i0.ɵɵtemplate(2, LegendsListComponent_ng_container_2_Template, 2, 1, "ng-container", 1);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.layers);
        } }, dependencies: [i3.NgForOf, i3.NgIf], styles: [".title[_ngcontent-%COMP%]{background-color:var(--primary-color)}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LegendsListComponent, [{
        type: Component,
        args: [{ selector: 'legends-list', standalone: false, template: "<table class=\"table legends-list\" id=\"legends-list\">\r\n<!--     <thead>\r\n        <tr scope=\"col\" class=\"title\">\r\n            <th><h6>{{ configService.getTranslation('map.legends-list.title')}}</h6></th>\r\n        </tr>\r\n    </thead> -->\r\n    <tbody>\r\n        <ng-container *ngFor=\"let layer of layers; let i = index\">\r\n            <tr *ngIf=\"layer.legend?.show\">\r\n                <td>\r\n                    <h6 innerHTML=\"{{ layer.title || layer.params.LAYERS }}\"></h6>\r\n                    <img [src]=\"processUrl(layer.legend.url)\" />\r\n                </td>\r\n            </tr>      \r\n        </ng-container>\r\n    </tbody>\r\n</table>", styles: [".title{background-color:var(--primary-color)}\n"] }]
    }], () => [{ type: i1.MapService }, { type: i1.ConfigurationService }], { id: [{
            type: Input
        }], map: [{
            type: Input
        }], layers: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LegendsListComponent, { className: "LegendsListComponent", filePath: "src/components/map/legends-list/legends-list.component.ts", lineNumber: 13 }); })();

class MapTipsComponent {
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = function MapTipsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MapTipsComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MapTipsComponent, selectors: [["map-tips"]], inputs: { id: "id" }, standalone: false, decls: 0, vars: 0, template: function MapTipsComponent_Template(rf, ctx) { }, styles: ["h6[_ngcontent-%COMP%]{color:var(--secondary-font-color);font-weight:500}.title[_ngcontent-%COMP%]{background-color:var(--primary-color)}.source-info[_ngcontent-%COMP%]{font-size:.8em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MapTipsComponent, [{
        type: Component,
        args: [{ selector: 'map-tips', standalone: false, template: "<!-- <table class=\"table tips-list\" id=\"tips-list\">\r\n    <thead>\r\n        <tr scope=\"col\" class=\"title\">\r\n            <th><h6>{{ configService.getTranslation('map.tips.title')}}</h6></th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr>\r\n            <td class=\"source-info\">\r\n                <html-renderer [template]=\"configService.getTranslation('map.tips.text')\"></html-renderer>\r\n            </td>\r\n        </tr>\r\n        <tr>\r\n            <td>\r\n                <span>{{ configService.getTranslation('map.source-info.title')}}</span>\r\n            </td>\r\n        </tr>\r\n        <tr>\r\n            <td class=\"source-info\">\r\n                <html-renderer [template]=\"configService.getTranslation('map.source-info.text')\"></html-renderer>\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</table> -->", styles: ["h6{color:var(--secondary-font-color);font-weight:500}.title{background-color:var(--primary-color)}.source-info{font-size:.8em}\n"] }]
    }], () => [], { id: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MapTipsComponent, { className: "MapTipsComponent", filePath: "src/components/map/map-tips/map-tips.component.ts", lineNumber: 9 }); })();

function MapComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "p-select", 8);
    i0.ɵɵtwoWayListener("ngModelChange", function MapComponent_div_5_Template_p_select_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.featureType, $event) || (ctx_r1.featureType = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function MapComponent_div_5_Template_p_select_ngModelChange_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onFeatureTypeChange()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("filter", true)("options", ctx_r1.featureTypes);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.featureType);
} }
function MapComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵelement(2, "legends-list", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.mapId + "_legendslist");
    i0.ɵɵproperty("map", ctx_r1.map)("layers", ctx_r1.config.layers);
} }
function MapComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 12)(2, "div", 13)(3, "div", 14)(4, "h2", 15)(5, "button", 16);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 17)(8, "div", 18);
    i0.ɵɵelement(9, "layers-list", 19);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("map.layers-list.title"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("config", ctx_r1.config)("map", ctx_r1.map)("groups", ctx_r1.config.groups)("layers", ctx_r1.config.layers);
} }
function MapComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 20)(2, "div", 13)(3, "div", 21)(4, "h2", 15)(5, "button", 22);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 23)(8, "div", 18);
    i0.ɵɵelement(9, "legends-list", 11);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getTranslation("map.legends-list.title"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.mapId + "_legendslist");
    i0.ɵɵproperty("map", ctx_r1.map)("layers", ctx_r1.config.layers);
} }
class MapComponent {
    constructor(configService, http, mapService) {
        this.configService = configService;
        this.http = http;
        this.mapService = mapService;
        this.config = {
            draw: {
                enabled: false,
                featureType: ConfigurationService.olTypes.POLYGON,
                mode: 'multiple',
                zoomToFeature: true
            }
        };
        this.isMapReady = false;
        this.featureTypes = ConfigurationService.featureTypes;
        this.featureType = ConfigurationService.olTypes.POLYGON;
        this.defaultVectorLayerStyle = [
            new Style({
                image: new Circle({
                    fill: new Fill({
                        color: 'rgba(56, 156, 205, 0.2)',
                    }),
                    stroke: new Stroke({
                        color: 'rgba(56, 156, 205)',
                        width: 1.25,
                    }),
                    radius: 5,
                }),
                fill: new Fill({
                    color: 'rgba(56, 156, 205, 0.2)',
                }),
                stroke: new Stroke({
                    color: 'rgba(56, 156, 205)',
                    width: 1.25,
                }),
            }),
        ];
        this.defaultDrawLayerStyle = [
            new Style({
                image: new Circle({
                    fill: new Fill({
                        color: 'rgba(14, 176, 100, 0.2)',
                    }),
                    stroke: new Stroke({
                        color: 'rgba(14, 176, 100)',
                        width: 1.25,
                    }),
                    radius: 5,
                }),
                fill: new Fill({
                    color: 'rgba(14, 176, 100, 0.2)',
                }),
                stroke: new Stroke({
                    color: 'rgba(14, 176, 100)',
                    width: 1.25,
                }),
            }),
        ];
        this.$ = $.noConflict();
        this._layers = [];
        this._defaultProjection = {
            name: 'WGS84',
            srs: 'EPSG:4326',
            extent: [-180, -90, 180, 90],
            def: '+proj=longlat +datum=WGS84 +no_defs'
        };
        /**
        * [lon,lat] in EPSG:4326 projection
        * @default [0,0]
        */
        this.center = [0, 0];
        /**
        * @default 2
        */
        this.zoom = 2;
        this.mapReady = new EventEmitter();
        this.featureDrawn = new EventEmitter();
    }
    ngOnInit() {
        this.mapId = 'map' + Math.random().toString(36).substr(2, 9);
        this.initConfig();
        this.initProjection();
    }
    initConfig() {
        if (!this.config.legend) {
            this.config.legend = {
                position: "bottom"
            };
        }
        if (!this.config.layersList) {
            this.config.layersList = {
                position: "bottom"
            };
        }
    }
    initMap() {
        this._layers = this.createLayersObject();
        this.createLegendsObject();
        this.map = new Map({
            controls: defaults().extend([
                new ScaleLine({
                    units: 'degrees',
                }),
                new FullScreen(),
                new LayersListControl
            ]),
            view: new View({
                projection: this._projection.srs /* ,
                extent: this._projection.extent */
            }),
            layers: this._layers,
            target: this.mapId
        });
        if (this.config.draw?.enabled) {
            this.addDrawLayer();
            this.featureType = this.config.draw.featureType;
        }
        this.emitMapReady();
    }
    initListeners() {
        let component = this;
        //Added listener to clean the features before adding a new one if 'single' mode
        this.draw.on('drawstart', function (evt) {
            if (component.config.draw?.mode === 'single') {
                let features = component.drawVectorSource.getFeatures();
                if (features.length > 0) {
                    let lastFeature = features[features.length - 1];
                    component.drawVectorSource.removeFeature(lastFeature);
                }
            }
        });
        this.draw.on('drawend', function (evt) {
            var geoJsonGeom = new GeoJSON();
            var pp = JSON.parse(geoJsonGeom.writeGeometry(evt.feature.getGeometry()));
            if (component.config.draw?.featureType !== ConfigurationService.olTypes.POINT && component.config.draw?.zoomToFeature) {
                component.map.getView().fit(evt.feature.getGeometry().getExtent());
            }
            component.featureDrawn.emit({
                map: component,
                feature: pp
            });
        });
    }
    addDrawLayer(style) {
        this.drawVectorSource = new VectorSource({ wrapX: false });
        if (this.config.draw?.features) {
            this.drawVectorSource.addFeatures(this.config.draw?.features);
        }
        this.drawVectorLayer = new VectorLayer({
            source: this.drawVectorSource,
            style: style || this.defaultDrawLayerStyle
        });
        this.map.addLayer(this.drawVectorLayer);
        this.addInteraction();
    }
    onFeatureTypeChange() {
        this.config.draw.featureType = this.featureType;
        this.removeInteraction();
        this.addInteraction();
    }
    removeInteraction() {
        if (this.draw) {
            this.map.removeInteraction(this.draw);
        }
    }
    addInteraction() {
        let value = this.config.draw?.featureType;
        if (value) {
            let geometryFunction;
            if (value === ConfigurationService.olTypes.BOX) {
                value = ConfigurationService.olTypes.CIRCLE;
                geometryFunction = createBox();
            }
            this.draw = new Draw({
                source: this.drawVectorSource,
                type: value,
                geometryFunction: geometryFunction,
            });
            this.map.addInteraction(this.draw);
            this.initListeners();
        }
    }
    addVectorLayer(options) {
        let source = new VectorSource({ wrapX: false });
        let vector = new VectorLayer({
            source: source,
            style: options.defaultStyle || this.defaultVectorLayerStyle
        });
        this._layers.push(vector);
        this.map.addLayer(vector);
        return {
            source: source,
            vector: vector
        };
    }
    addFeature(source, feature) {
        source.addFeature(feature);
    }
    addFeatures(source, features) {
        source.addFeatures(features);
    }
    removeFeature(source, index) {
        let features = source.getFeatures();
        if (features.length > 0 && index + 1 <= features.length) {
            let lastFeature = features[index];
            source.removeFeature(lastFeature);
        }
    }
    removeFeatures(source) {
        let features = source.getFeatures();
        for (let i = 0; i < features.length; i++) {
            source.removeFeature(features[i]);
        }
    }
    initProjection() {
        for (let proj in this.mapService.projections) {
            proj4.defs(this.mapService.projections[proj].srs, this.mapService.projections[proj].def);
        }
        register$1(proj4);
        if (!this.config.defaultProjection) {
            if (this.config.projections) {
                let projs = this.config.projections.filter(item => item.default === true);
                if (projs.length > 0) {
                    this._projection = JSON.parse(JSON.stringify(projs[0]));
                    this._defaultProjection = JSON.parse(JSON.stringify(projs[0]));
                }
                else {
                    this._projection = this._defaultProjection;
                }
            }
            else {
                this._projection = this._defaultProjection;
            }
            this.config.extent = this._projection.extent;
        }
        else {
            this._projection = this.config.defaultProjection;
            this._defaultProjection = JSON.parse(JSON.stringify(this.config.defaultProjection));
            this.config.extent = this._projection.extent;
        }
    }
    ngAfterViewInit() {
        this.initMap();
    }
    createLegendsObject() {
        for (let i = 0; i < this.config.layers.length; i++) {
            if (this.config.layers[i].type === 'raster' && this.config.layers[i].sourceType === 'TileWMS') {
                if (!this.config.layers[i].legend) {
                    this.config.layers[i].legend = {
                        show: true
                    };
                }
                this.config.layers[i].legend.url = this.config.layers[i].url + '?'
                    + 'SERVICE=' + this.config.layers[i].params.SERVICE + '&'
                    + 'VERSION=' + this.config.layers[i].params.VERSION + '&'
                    + 'REQUEST=GetLegendGraphic&'
                    + 'FORMAT=image/png&'
                    + 'LAYER=' + this.config.layers[i].params.LAYERS + '&'
                    + (this.config.layers[i].params.STYLES ? 'STYLE=' + this.config.layers[i].params.STYLES + '&' : '')
                    + 'WIDTH=30&'
                    + 'HEIGHT=20&'
                    + 'LEGEND_OPTIONS=forcelabels:on';
            }
        }
    }
    createLayersObject() {
        let layers = [];
        for (let i = 0; i < this.config.layers.length; i++) {
            if (this.config.layers[i].type === 'raster') {
                let layer;
                let source;
                if (!this.config.layers[i].sourceType)
                    this.config.layers[i].sourceType = "TileWMS";
                switch (this.config.layers[i].sourceType) {
                    case "TileWMS":
                        this.config.layers[i].params.SRS = this._projection.srs;
                        source = new TileWMS(this.config.layers[i]);
                        layer = new TileLayer({
                            source: source
                        });
                        break;
                    case "TileArcGISRest":
                        source = new TileArcGISRest({
                            url: this.config.layers[i].url + "/" + this.config.layers[i].layer + "/MapServer",
                            crossOrigin: 'anonymous',
                            wrapX: true
                        });
                        layer = new TileLayer({
                            source: source
                        });
                        break;
                }
                layer.setProperties({
                    index: i
                });
                layer.setZIndex(this.config.layers[i].zindex);
                layer.setVisible(this.config.layers[i].visible !== null ? this.config.layers[i].visible : true);
                layers.push(layer);
            }
            else if (this.config.layers[i].type === 'vector') {
                layers.push(this.config.layers[i].layer);
            }
        }
        return layers;
    }
    emitMapReady() {
        let component = this;
        this.map.once('postrender', function (event) {
            component.map.getView().setConstrainResolution(component.config.constrainResolution);
            if (component.config.extent) {
                component.map.getView().fit(component.config.extent);
            }
            else {
                component.map.getView().fit(component._projection.extent);
            }
            component.mapReady.emit(event);
            component.isMapReady = true;
        });
        this.map.once('change', function (event) {
            //console.log(event);
        });
    }
    onFullscreenChange(event) {
        //console.log(event.isFullscreen);
    }
    changeProjection(projection) {
        this._projection = projection;
        this.setProjection(this._projection.srs, this._projection.name, this._projection.def, this._projection.extent, this._projection.transform);
    }
    /*
        SET PROJECTION
      */
    setProjection(code, name, proj4def, bbox, transform) {
        const newProjCode = code;
        proj4.defs(newProjCode, proj4def);
        register$1(proj4);
        const newProj = get(newProjCode);
        const fromLonLat = getTransform(this._defaultProjection.srs, newProj);
        let worldExtent = [bbox[0], bbox[1], bbox[2], bbox[3]];
        /*     newProj.setWorldExtent(worldExtent);
        
            worldExtent = [bbox[0], bbox[1], bbox[2], bbox[3]]; */
        let extent;
        if (transform) {
            extent = applyTransform(worldExtent, fromLonLat, undefined, 8);
        }
        else {
            extent = worldExtent;
        }
        newProj.setExtent(extent);
        const newView = new View({
            projection: newProj,
            extent: extent
        });
        this.map.setView(newView);
        newView.fit(extent);
        for (let i = 0; i < this.map.getLayers().getArray().length; i++) {
            let layer = this.map.getLayers().getArray()[i];
            let layers = layer.getLayersArray();
            let props = layers[0].getProperties();
            let config = this.config.layers[props.index];
            let projections = config.projections.filter(item => item.srs === newProj.getCode());
            if (config.projections && projections.length === 0) {
                config.visible = false;
                layers[0].setVisible(false);
                config.locked = true;
            }
            else {
                config.visible = true;
                layers[0].setVisible(true);
                config.locked = false;
            }
        }
    }
    getZoom() {
        return this.map.getView().getZoom();
    }
    setZoom(value) {
        this.map.getView().setZoom(value);
    }
    static { this.ɵfac = function MapComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MapComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1$3.HttpClient), i0.ɵɵdirectiveInject(i1.MapService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MapComponent, selectors: [["fi-map"]], viewQuery: function MapComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(LayersListComponent, 5, ElementRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.layersList = _t.first);
        } }, inputs: { config: "config", mapId: "mapId", center: "center", zoom: "zoom" }, outputs: { mapReady: "mapReady", featureDrawn: "featureDrawn" }, standalone: false, decls: 9, vars: 11, consts: [[1, "row", "map-main-container"], [1, "mb-3", 3, "ngClass"], [1, "map-container"], ["id", "layers-list", 1, "layers-list-container", 3, "config", "map", "groups", "layers"], [1, "map", 3, "change"], ["class", "col-md-12", 4, "ngIf"], ["class", "col-lg-5 col-md-12", 4, "ngIf"], [1, "col-md-12"], ["appendTo", "body", "optionLabel", "label", "optionValue", "value", 3, "ngModelChange", "filter", "options", "ngModel"], [1, "col-lg-5", "col-md-12"], [1, "mb-3"], [3, "id", "map", "layers"], ["id", "fiMapLayersListAccordion", 1, "accordion"], [1, "accordion-item"], ["id", "headingfiMapLayersListAccordion1", 1, "accordion-header"], [1, "mb-0"], ["type", "button", "data-bs-toggle", "collapse", "data-bs-target", "#fiMapLayersListaccmultiple1", "aria-expanded", "false", "aria-controls", "collapsefiMapLayersListaccmultiple", 1, "accordion-button"], ["id", "fiMapLayersListaccmultiple1", "aria-labelledby", "headingfiMapLayersListAccordion1", "data-bs-parent", "#fiMapLayersListAccordion", 1, "accordion-collapse", "collapse"], [1, "accordion-body"], [3, "config", "map", "groups", "layers"], ["id", "fiMapLegendAccordion", 1, "accordion"], ["id", "headingfiMapLegendAccordion2", 1, "accordion-header"], ["type", "button", "data-bs-toggle", "collapse", "data-bs-target", "#fiMapLegendaccmultiple2", "aria-expanded", "false", "aria-controls", "collapsefiMapLegendaccmultiple", 1, "accordion-button"], ["id", "fiMapLegendaccmultiple2", "aria-labelledby", "headingfiMapLegendAccordion2", "data-bs-parent", "#fiMapLegendAccordion", 1, "accordion-collapse", "collapse"]], template: function MapComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "layers-list", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵlistener("change", function MapComponent_Template_div_change_4_listener($event) { return ctx.onFullscreenChange($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(5, MapComponent_div_5_Template, 2, 3, "div", 5)(6, MapComponent_div_6_Template, 3, 3, "div", 6)(7, MapComponent_div_7_Template, 10, 5, "div", 5)(8, MapComponent_div_8_Template, 10, 4, "div", 5);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.config.showLegends === true && ctx.config.legend.position === "top-right" ? "col-lg-7 col-md-12" : "col-md-12");
            i0.ɵɵadvance();
            i0.ɵɵattribute("id", ctx.mapId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("config", ctx.config)("map", ctx.map)("groups", ctx.config.groups)("layers", ctx.config.layers);
            i0.ɵɵadvance();
            i0.ɵɵattribute("id", "fullscreen-" + ctx.mapId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isMapReady && (ctx.config.draw == null ? null : ctx.config.draw.showFeatureTypes));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.config.showLegends && ctx.config.legend.position === "top-right");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.config.layersList == null ? null : ctx.config.layersList.position) === "bottom");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.config.showLegends && ctx.config.legend.position === "bottom");
        } }, dependencies: [i3.NgClass, i3.NgIf, i5.NgControlStatus, i5.NgModel, i6.Select, LayersListComponent, LegendsListComponent], styles: [".map-container[_ngcontent-%COMP%]{width:100%;height:100vh;max-height:400px;z-index:1}.disclaimer[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-size:.8em;text-align:justify}.map-container[_ngcontent-%COMP%]   .ol-layers-list[_ngcontent-%COMP%]{right:.5em!important;top:2.5em!important}.form-check[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:flex;flex-direction:column}.ol-layers-list.ol-unselectable.ol-control[_ngcontent-%COMP%]{right:.5em;top:2.5em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MapComponent, [{
        type: Component,
        args: [{ selector: 'fi-map', standalone: false, template: "<div class=\"row map-main-container\">\r\n    <div class=\"mb-3\" [ngClass]=\"config.showLegends === true && config.legend.position === 'top-right' ? 'col-lg-7 col-md-12' : 'col-md-12'\">        \r\n        <div [attr.id]=\"mapId\" class=\"map-container\">\r\n            <layers-list id=\"layers-list\" class=\"layers-list-container\" [config]=\"config\" [map]=\"map\" [groups]=\"config.groups\" [layers]=\"config.layers\"></layers-list>\r\n        </div>\r\n        <!-- <div class=\"disclaimer mt-3 mb-3\">\r\n            <div class=\"title\"><h6>{{ configService.getTranslation('map.disclaimer.title')}}</h6></div>\r\n            <div class=\"text\"><html-renderer [template]=\"configService.getTranslation('map.disclaimer.text')\"></html-renderer></div>\r\n        </div> -->\r\n\r\n        <div [attr.id]=\"'fullscreen-' + mapId\" class=\"map\" (change)=\"onFullscreenChange($event)\"></div>\r\n\r\n        <!-- <div class=\"mb-3\" *ngIf=\"config.allowProjectionSwitch && config.projections && config.projections.length > 1\">\r\n            <projections-list id=\"{{ mapId + '_projectionslist' }}\" [map]=\"map\" [projections]=\"config.projections\" (onProjectionChange)=\"changeProjection($event)\"></projections-list>            \r\n        </div> -->\r\n        <!-- <div class=\"mb-3\">\r\n            <fi-map-tips id=\"{{ mapId + '_maptips' }}\"></fi-map-tips>\r\n        </div> -->\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"isMapReady && config.draw?.showFeatureTypes\">\r\n        <p-select appendTo=\"body\" [filter]=\"true\" [options]=\"featureTypes\" [(ngModel)]=\"featureType\" (ngModelChange)=\"onFeatureTypeChange()\" optionLabel=\"label\" optionValue=\"value\"></p-select>\r\n    </div>\r\n    <div class=\"mb-3\" *ngIf=\"config.showLegends && config.legend.position === 'top-right'\" class=\"col-lg-5 col-md-12\">\r\n        <div class=\"mb-3\">\r\n            <legends-list id=\"{{ mapId + '_legendslist' }}\" [map]=\"map\" [layers]=\"config.layers\"></legends-list>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"config.layersList?.position === 'bottom'\">\r\n        <div class=\"accordion \" id=\"fiMapLayersListAccordion\">\r\n            <div class=\"accordion-item\">\r\n                <div class=\"accordion-header\" id=\"headingfiMapLayersListAccordion1\">\r\n                    <h2 class=\"mb-0\">\r\n                        <button class=\"accordion-button\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#fiMapLayersListaccmultiple1\" aria-expanded=\"false\"\r\n                        aria-controls=\"collapsefiMapLayersListaccmultiple\">{{ configService.getTranslation('map.layers-list.title')}}</button>\r\n                    </h2>\r\n                </div>\r\n                <div id=\"fiMapLayersListaccmultiple1\" class=\"accordion-collapse collapse\" aria-labelledby=\"headingfiMapLayersListAccordion1\" data-bs-parent=\"#fiMapLayersListAccordion\">\r\n                    <div class=\"accordion-body\">\r\n                        <layers-list [config]=\"config\" [map]=\"map\" [groups]=\"config.groups\" [layers]=\"config.layers\"></layers-list>\r\n                    </div>\r\n                </div>\r\n            </div>           \r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"config.showLegends && config.legend.position === 'bottom'\">\r\n        <div class=\"accordion \" id=\"fiMapLegendAccordion\">\t\r\n            <div class=\"accordion-item\">\r\n                <div class=\"accordion-header\" id=\"headingfiMapLegendAccordion2\">\r\n                    <h2 class=\"mb-0\">\r\n                        <button class=\"accordion-button\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#fiMapLegendaccmultiple2\" aria-expanded=\"false\" aria-controls=\"collapsefiMapLegendaccmultiple\">{{ configService.getTranslation('map.legends-list.title')}}</button>\r\n                    </h2>\r\n                </div>\r\n                <div id=\"fiMapLegendaccmultiple2\" class=\"accordion-collapse collapse\" aria-labelledby=\"headingfiMapLegendAccordion2\" data-bs-parent=\"#fiMapLegendAccordion\">\r\n                    <div class=\"accordion-body\">\r\n                        <legends-list id=\"{{ mapId + '_legendslist' }}\" [map]=\"map\" [layers]=\"config.layers\"></legends-list>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>", styles: [".map-container{width:100%;height:100vh;max-height:400px;z-index:1}.disclaimer .text{font-size:.8em;text-align:justify}.map-container .ol-layers-list{right:.5em!important;top:2.5em!important}.form-check>div{display:flex;flex-direction:column}.ol-layers-list.ol-unselectable.ol-control{right:.5em;top:2.5em}\n"] }]
    }], () => [{ type: i1.ConfigurationService }, { type: i1$3.HttpClient }, { type: i1.MapService }], { config: [{
            type: Input
        }], layersList: [{
            type: ViewChild,
            args: [LayersListComponent, { read: ElementRef }]
        }], mapId: [{
            type: Input
        }], center: [{
            type: Input
        }], zoom: [{
            type: Input
        }], mapReady: [{
            type: Output
        }], featureDrawn: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MapComponent, { className: "MapComponent", filePath: "src/components/map/map/map.component.ts", lineNumber: 39 }); })();
class LayersListControl extends Control {
    constructor() {
        const button = document.createElement('button');
        button.innerHTML = '<i class="bi bi-list-ul"></i>';
        const element = document.createElement('div');
        element.className = 'ol-layers-list ol-unselectable ol-control';
        element.appendChild(button);
        super({
            element: element
        });
        button.addEventListener('click', this.showLayersList.bind(this), false);
    }
    showLayersList() {
        /* let popup: Overlay = this.getMap().getOverlayById('layers-list');
        let element: HTMLElement = popup.getElement();
        if (this.isHidden(element)) {
          element.parentElement.setAttribute('style', 'display: block;');
        } else {
          element.parentElement.setAttribute('style', 'display: none;');
        } */
        let ll = document.getElementById("layers-list");
        if (ll.checkVisibility()) {
            ll.setAttribute("style", "display: none;");
        }
        else {
            ll.setAttribute("style", "display: block;");
        }
    }
    isHidden(el) {
        return (el.offsetParent === null);
    }
}

function ProjectionsListComponent_label_11_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 4)(1, "input", 5);
    i0.ɵɵlistener("change", function ProjectionsListComponent_label_11_Template_input_change_1_listener($event) { const projection_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.changeProjection($event, projection_r2)); });
    i0.ɵɵtwoWayListener("ngModelChange", function ProjectionsListComponent_label_11_Template_input_ngModelChange_1_listener($event) { const projection_r2 = i0.ɵɵrestoreView(_r1).$implicit; i0.ɵɵtwoWayBindingSet(projection_r2.default, $event) || (projection_r2.default = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const projection_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", projection_r2.default);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", projection_r2.name, " ");
} }
class ProjectionsListComponent {
    constructor(configService, mapService) {
        this.configService = configService;
        this.mapService = mapService;
        this.onProjectionChange = new EventEmitter();
    }
    ngOnInit() {
    }
    changeProjection(event, projection) {
        this.onProjectionChange.emit(projection);
    }
    static { this.ɵfac = function ProjectionsListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProjectionsListComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.MapService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProjectionsListComponent, selectors: [["projections-list"]], inputs: { id: "id", map: "map", projections: "projections" }, outputs: { onProjectionChange: "onProjectionChange" }, standalone: false, decls: 12, vars: 2, consts: [["id", "projections-list", 1, "table", "projections-list"], ["scope", "col", 1, "title"], [1, "form-check"], ["class", "form-check-label", 4, "ngFor", "ngForOf"], [1, "form-check-label"], ["type", "radio", "name", "projections", 3, "change", "ngModelChange", "ngModel"]], template: function ProjectionsListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "table", 0)(1, "thead")(2, "tr", 1)(3, "th")(4, "h6");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(6, "tbody")(7, "tr")(8, "td")(9, "div", 2)(10, "div");
            i0.ɵɵtemplate(11, ProjectionsListComponent_label_11_Template, 3, 2, "label", 3);
            i0.ɵɵelementEnd()()()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.configService.getTranslation("map.projections.title"));
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngForOf", ctx.projections);
        } }, dependencies: [i3.NgForOf, i5.DefaultValueAccessor, i5.RadioControlValueAccessor, i5.NgControlStatus, i5.NgModel], styles: [".form-check-label[_ngcontent-%COMP%]{display:block}h6[_ngcontent-%COMP%]{color:var(--secondary-font-color);font-weight:500}.title[_ngcontent-%COMP%]{background-color:var(--primary-color)}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProjectionsListComponent, [{
        type: Component,
        args: [{ selector: 'projections-list', standalone: false, template: "<table class=\"table projections-list\" id=\"projections-list\">\r\n    <thead>\r\n        <tr scope=\"col\" class=\"title\">\r\n            <th><h6>{{ configService.getTranslation('map.projections.title')}}</h6></th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr>\r\n            <td>\r\n                <div class=\"form-check\">\r\n                    <div>\r\n                        <label class=\"form-check-label\" *ngFor=\"let projection of projections; let i = index\">\r\n                            <input type=\"radio\" (change)=\"changeProjection($event,projection)\" [(ngModel)]=\"projection.default\" name=\"projections\">{{projection.name}}\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</table>", styles: [".form-check-label{display:block}h6{color:var(--secondary-font-color);font-weight:500}.title{background-color:var(--primary-color)}\n"] }]
    }], () => [{ type: i1.ConfigurationService }, { type: i1.MapService }], { id: [{
            type: Input
        }], map: [{
            type: Input
        }], projections: [{
            type: Input
        }], onProjectionChange: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ProjectionsListComponent, { className: "ProjectionsListComponent", filePath: "src/components/map/projections-list/projections-list.component.ts", lineNumber: 11 }); })();

class ModalService {
    constructor() {
        this.modals = [];
    }
    add(modal) {
        // add modal to array of active modals
        this.modals.push(modal);
    }
    remove(id) {
        // remove modal from array of active modals
        this.modals = this.modals.filter(x => x.id !== id);
    }
    open(id) {
        setTimeout(() => {
            let modal = this.modals.filter(x => x.id === id)[0];
            modal.open();
        }, 500);
    }
    close(id) {
        // close modal specified by id
        let modal = this.modals.filter(x => x.id === id)[0];
        modal.close();
    }
    /*
        Function that detects if there is a popup to display for the current route
    */
    displayPopup(surveyPopups, url) {
        let surveyPopup;
        let popups;
        popups = [];
        for (let i = 0; i < surveyPopups.length; i++) {
            let popup = surveyPopups[i];
            for (let j = 0; j < popup.popup.urls.length; j++) {
                let popupUrl = popup.popup.urls[j];
                if (popupUrl.endsWith('*') || popupUrl.endsWith('/*')) {
                    let newUrl;
                    if (popupUrl.endsWith('/*')) {
                        newUrl = popupUrl.replace('/*', '');
                    }
                    else {
                        newUrl = popupUrl.replace('*', '');
                    }
                    if (url.includes(newUrl)) {
                        popups.push(popup);
                    }
                }
                else {
                    if (url === popupUrl) {
                        popups.push(popup);
                    }
                }
            }
        }
        if (popups.length > 0) {
            let popup = popups[0];
            if (popup.popup.popupPerPage) {
                if (!popup.popup.expired) {
                    popup.popup.expired = {};
                }
                if (popup.enabled && !popup.popup.expired[url]) {
                    popup.popup.expired[url] = true;
                    surveyPopup = popup;
                    this.open(surveyPopup.id);
                }
            }
            else {
                if (popup.enabled && !popup.popup.expired) {
                    popup.popup.expired = true;
                    surveyPopup = popup;
                    this.open(surveyPopup.id);
                }
            }
        }
        else {
            surveyPopup = undefined;
        }
        return surveyPopup;
    }
    static { this.ɵfac = function ModalService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ModalService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ModalService, factory: ModalService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

const _c0$8 = ["*"];
function ModalComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function ModalComponent_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.close()); });
    i0.ɵɵelement(1, "i", 9);
    i0.ɵɵelementEnd();
} }
class ModalComponent {
    constructor(modalService, el) {
        this.modalService = modalService;
        this.el = el;
        this.closebutton = true;
        this.closeonclick = true;
        this.element = el.nativeElement;
    }
    ngOnInit() {
        let modal = this;
        // ensure id attribute exists
        if (!this.id) {
            return;
        }
        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element);
        if (this.closeonclick) {
            // close modal on background click
            this.element.addEventListener('click', function (e) {
                if (e.target.id === this.id) {
                    modal.close();
                }
            });
        }
        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.modalService.add(this);
    }
    // remove self from modal service when directive is destroyed
    ngOnDestroy() {
        this.modalService.remove(this.id);
        this.element.remove();
    }
    // open modal
    open() {
        this.element.style.display = 'block';
        document.body.classList.add('modal-popup-open');
    }
    // close modal
    close() {
        this.element.style.display = 'none';
        document.body.classList.remove('modal-popup-open');
    }
    getClass() {
        return 'modal-popup-' + this.position;
    }
    getBodyClass() {
        return (this.cssclass ? ' ' + this.cssclass : '');
    }
    static { this.ɵfac = function ModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ModalComponent)(i0.ɵɵdirectiveInject(ModalService), i0.ɵɵdirectiveInject(i0.ElementRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ModalComponent, selectors: [["modal-popup"]], inputs: { id: "id", title: "title", position: "position", cssclass: "cssclass", closebutton: "closebutton", closeonclick: "closeonclick" }, standalone: false, ngContentSelectors: _c0$8, decls: 9, vars: 4, consts: [[1, "modal-popup", 3, "ngClass"], [1, "modal-popup-body", 3, "ngClass"], [1, "header"], [1, "title"], [3, "innerHTML"], [1, "buttons"], ["type", "button", "class", "btn btn-link", 3, "click", 4, "ngIf"], [1, "modal-popup-background"], ["type", "button", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-x-lg"]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
            i0.ɵɵelement(4, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵtemplate(6, ModalComponent_button_6_Template, 2, 0, "button", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "div", 7);
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.getClass());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.getBodyClass());
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("innerHTML", ctx.title, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.closebutton);
        } }, dependencies: [i3.NgClass, i3.NgIf], styles: [".modal-popup-body[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%], .modal-popup-body[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{display:flex;flex-grow:1}.modal-popup-body[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]{display:flex;flex-grow:1;flex-direction:row-reverse}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{ selector: 'modal-popup', standalone: false, template: "<div class=\"modal-popup\" [ngClass]=\"getClass()\">\r\n    <div class=\"modal-popup-body\" [ngClass]=\"getBodyClass()\">\r\n        <div class=\"header\">\r\n            <div class=\"title\">\r\n                <span [innerHTML]=\"title\"></span>\r\n            </div>\r\n            <div class=\"buttons\">\r\n                <button *ngIf=\"closebutton\" type=\"button\" class=\"btn btn-link\"(click)=\"close()\"><i class=\"bi bi-x-lg\"></i></button>\r\n            </div>\r\n        </div>\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>\r\n<div class=\"modal-popup-background\"></div>", styles: [".modal-popup-body .header,.modal-popup-body .header .title{display:flex;flex-grow:1}.modal-popup-body .header .buttons{display:flex;flex-grow:1;flex-direction:row-reverse}\n"] }]
    }], () => [{ type: ModalService }, { type: i0.ElementRef }], { id: [{
            type: Input
        }], title: [{
            type: Input
        }], position: [{
            type: Input
        }], cssclass: [{
            type: Input
        }], closebutton: [{
            type: Input
        }], closeonclick: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ModalComponent, { className: "ModalComponent", filePath: "src/components/modal/modal.component.ts", lineNumber: 11 }); })();

function PaginationComponent_li_8_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 5)(1, "a", 4);
    i0.ɵɵlistener("click", function PaginationComponent_li_8_Template_a_click_1_listener() { const p_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onPageChanged(p_r2)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const p_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", p_r2)("ngClass", p_r2 + 1 === ctx_r2.value ? "active" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(p_r2 + 1);
} }
class PaginationComponent {
    set id(value) {
        this._ID = value;
        this.externalId = null;
    }
    get id() {
        return this._ID;
    }
    get value() {
        return this._value;
    }
    set value(val) {
        if (!val) {
            val = 1;
        }
        if (val > this.pages) {
            val = this.pages;
        }
        this._value = val;
        this.onChange(val);
        this.calculateWindow();
        this.onTouched();
    }
    constructor() {
        this.itemsPerPage = 30;
        this.boundaryLinks = true;
        this.maxSize = 12;
        this.firstText = '&laquo;';
        this.nextText = '&rsaquo;';
        this.previousText = '&lsaquo;';
        this.lastText = '&raquo;';
        this.pageChanged = new EventEmitter();
        this.externalId = '';
        this._ID = '';
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    ngOnInit() {
        this.init();
    }
    init() {
        this.pages = this.calculateTotalPages();
        if (this.pages < this.maxSize) {
            this.maxSize = this.pages;
        }
    }
    calculateWindow() {
        this.pagesInterval = {};
        this.pagesInterval.min = this.value - Math.round(this.maxSize / 2);
        this.pagesInterval.max = this.value + Math.round(this.maxSize / 2);
        if (this.pagesInterval.min < 0) {
            this.pagesInterval.min = 0;
            this.pagesInterval.max = this.maxSize - 1;
        }
        if (this.pagesInterval.max >= this.pages) {
            this.pagesInterval.max = this.pages - 1;
            this.pagesInterval.min = this.pages - this.maxSize;
        }
        this.pagesWindow = [];
        for (let i = this.pagesInterval.min; i <= this.pagesInterval.max; i++) {
            this.pagesWindow.push(i);
        }
    }
    switchWindow(step) {
        if (step === undefined) {
            this.value = 0;
        }
        else {
            let currentValue = this.value + step;
            if (currentValue > 0 && currentValue < this.pages) {
                this.value = currentValue;
            }
            else {
                this.value = this.pages;
            }
        }
        this.calculateWindow();
        this.pageChanged.emit({
            page: this.value
        });
    }
    calculateTotalPages() {
        const totalPages = this.itemsPerPage < 1
            ? 1
            : Math.ceil(this.totalItems / this.itemsPerPage);
        return Math.max(totalPages || 0, 1);
    }
    setButtonClass(ref, value, button) {
        if (ref === value) {
            return 'disabled';
        }
        else {
            return '';
        }
    }
    onPageChanged(page) {
        this.value = page;
        this.pageChanged.emit({
            page: page + 1
        });
    }
    setSelection(event) {
        this.value = event;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    static { this.ɵfac = function PaginationComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PaginationComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaginationComponent, selectors: [["pagination"]], hostVars: 1, hostBindings: function PaginationComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵattribute("id", ctx.externalId);
        } }, inputs: { totalItems: "totalItems", itemsPerPage: "itemsPerPage", boundaryLinks: "boundaryLinks", maxSize: "maxSize", firstText: "firstText", nextText: "nextText", previousText: "previousText", lastText: "lastText", _value: [0, "value", "_value"], id: "id" }, outputs: { pageChanged: "pageChanged" }, standalone: false, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => PaginationComponent),
                    multi: true
                },
            ])], decls: 15, vars: 9, consts: [[1, "pagination", "justify-content-center"], [1, "page-item", 3, "ngClass"], ["href", "javascript:", "tabindex", "-1", 1, "page-link", 3, "click"], ["class", "page-item", 3, "id", "ngClass", 4, "ngFor", "ngForOf"], ["href", "javascript:", 1, "page-link", 3, "click"], [1, "page-item", 3, "id", "ngClass"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "nav")(1, "ul", 0)(2, "li", 1)(3, "a", 2);
            i0.ɵɵlistener("click", function PaginationComponent_Template_a_click_3_listener() { return ctx.switchWindow(); });
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "li", 1)(6, "a", 2);
            i0.ɵɵlistener("click", function PaginationComponent_Template_a_click_6_listener() { return ctx.switchWindow(-1); });
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, PaginationComponent_li_8_Template, 3, 3, "li", 3);
            i0.ɵɵelementStart(9, "li", 1)(10, "a", 4);
            i0.ɵɵlistener("click", function PaginationComponent_Template_a_click_10_listener() { return ctx.switchWindow(1); });
            i0.ɵɵtext(11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "li", 1)(13, "a", 4);
            i0.ɵɵlistener("click", function PaginationComponent_Template_a_click_13_listener() { return ctx.switchWindow(ctx.pages); });
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.setButtonClass(ctx.value, 1, ctx.firstText));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.firstText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.setButtonClass(ctx.value, 1, ctx.previousText));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.previousText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.pagesWindow);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.setButtonClass(ctx.value, ctx.pages, ctx.nextText));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.nextText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.setButtonClass(ctx.value, ctx.pages, ctx.lastText));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.lastText);
        } }, dependencies: [i3.NgClass, i3.NgForOf], styles: [".pagination[_ngcontent-%COMP%]   .page-item.active[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--secondary-font-color)!important;background-color:var(--primary-color)!important}.pagination[_ngcontent-%COMP%]   .page-item[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--primary-color)!important;background-color:var(--default-background-color)!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{ selector: 'pagination', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => PaginationComponent),
                        multi: true
                    },
                ], standalone: false, template: "<nav>\r\n    <ul class=\"pagination justify-content-center\">\r\n        <li class=\"page-item\" [ngClass]=\"setButtonClass(value,1,firstText)\"><a href=\"javascript:\" class=\"page-link\" tabindex=\"-1\" (click)=\"switchWindow()\">{{firstText}}</a></li>\r\n        <li class=\"page-item\" [ngClass]=\"setButtonClass(value,1,previousText)\"><a href=\"javascript:\" class=\"page-link\" tabindex=\"-1\" (click)=\"switchWindow(-1)\">{{previousText}}</a></li>\r\n        \r\n        <li class=\"page-item\" [id]=\"p\" [ngClass]=\"(p+1) === value ? 'active' : ''\" *ngFor=\"let p of pagesWindow\"><a href=\"javascript:\" (click)=\"onPageChanged(p)\" class=\"page-link\">{{ p+1 }}</a></li>\r\n\r\n        <li class=\"page-item\" [ngClass]=\"setButtonClass(value,pages,nextText)\"><a href=\"javascript:\" class=\"page-link\" (click)=\"switchWindow(1)\">{{nextText}}</a></li>\r\n        <li class=\"page-item\" [ngClass]=\"setButtonClass(value,pages,lastText)\"><a href=\"javascript:\" class=\"page-link\" (click)=\"switchWindow(pages)\">{{lastText}}</a></li>\r\n    </ul>\r\n</nav>", styles: [".pagination .page-item.active a{color:var(--secondary-font-color)!important;background-color:var(--primary-color)!important}.pagination .page-item a{color:var(--primary-color)!important;background-color:var(--default-background-color)!important}\n"] }]
    }], () => [], { totalItems: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], boundaryLinks: [{
            type: Input
        }], maxSize: [{
            type: Input
        }], firstText: [{
            type: Input
        }], nextText: [{
            type: Input
        }], previousText: [{
            type: Input
        }], lastText: [{
            type: Input
        }], pageChanged: [{
            type: Output
        }], _value: [{
            type: Input,
            args: ['value']
        }], externalId: [{
            type: HostBinding,
            args: ['attr.id']
        }], id: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(PaginationComponent, { className: "PaginationComponent", filePath: "src/components/pagination/pagination.component.ts", lineNumber: 17 }); })();

const _c0$7 = a0 => [a0];
function ReferenceComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵelement(1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c0$7, ctx_r0.intLink));
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.text, i0.ɵɵsanitizeHtml);
} }
function ReferenceComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵelement(1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r0.extLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.text, i0.ɵɵsanitizeHtml);
} }
class ReferenceComponent {
    constructor(configService) {
        this.configService = configService;
    }
    ngOnInit() {
        if (this.id > '') {
            if (this.uri) {
                if (this.type === 'kor' || this.uri.startsWith('http') || this.uri.startsWith('www')) {
                    this.extLink = this.uri;
                }
                else {
                    this.extLink = '/' + this.uri + '/' + this.configService.env.currentLang;
                }
            }
            else {
                if (this.collection === 'publication' || this.type === 'publication') {
                    this.intLink = '/' + (this.collection || this.type) + '/' + this.id + '/' + this.configService.env.currentLang;
                }
                else {
                    this.intLink = '/' + (this.collection || this.type) + '/' + this.id + '/' + this.configService.env.currentLang;
                }
            }
            if (!this.text) {
                this.text = this.configService.env.siteUrl + '/' + (this.collection || this.type) + '/' + this.id + '/' + this.configService.env.currentLang;
            }
        }
        else {
            if (this.uri) {
                if (this.type === 'kor' || this.uri.startsWith('http') || this.uri.startsWith('www')) {
                    this.extLink = this.uri;
                }
                else {
                    this.extLink = '/' + this.uri + '/' + this.configService.env.currentLang;
                }
            }
            else {
                this.intLink = '/' + (this.collection || this.type) + '/' + this.configService.env.currentLang;
            }
            if (!this.text) {
                this.text = this.configService.env.siteUrl + '/' + (this.collection || this.type) + '/' + this.configService.env.currentLang;
            }
        }
    }
    setClass() {
        if (this.collection === 'species') {
            return 'species';
        }
    }
    static { this.ɵfac = function ReferenceComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ReferenceComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReferenceComponent, selectors: [["ref"]], inputs: { collection: "collection", id: "id", uri: "uri", type: "type" }, standalone: false, decls: 3, vars: 3, consts: [[1, "ref-link", 3, "ngClass"], [3, "routerLink", 4, "ngIf"], [3, "href", 4, "ngIf"], [3, "routerLink"], [3, "innerHTML"], [3, "href"]], template: function ReferenceComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "span", 0);
            i0.ɵɵtemplate(1, ReferenceComponent_a_1_Template, 2, 4, "a", 1)(2, ReferenceComponent_a_2_Template, 2, 2, "a", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.setClass());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.intLink);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.extLink);
        } }, dependencies: [i3.NgClass, i3.NgIf, i2.RouterLink], styles: [".ref-link[_ngcontent-%COMP%]{display:inline-block}.ref-link.species[_ngcontent-%COMP%]{font-style:italic}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReferenceComponent, [{
        type: Component,
        args: [{ selector: 'ref', standalone: false, template: "<span class=\"ref-link\" [ngClass]=\"setClass()\">\r\n    <a *ngIf=\"intLink\" [routerLink]=\"[intLink]\"><span [innerHTML]=\"text\"></span></a>\r\n    <a *ngIf=\"extLink\" [href]=\"extLink\"><span [innerHTML]=\"text\"></span></a>\r\n</span>\r\n", styles: [".ref-link{display:inline-block}.ref-link.species{font-style:italic}\n"] }]
    }], () => [{ type: i1.ConfigurationService }], { collection: [{
            type: Input
        }], id: [{
            type: Input
        }], uri: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ReferenceComponent, { className: "ReferenceComponent", filePath: "src/components/reference/reference.component.ts", lineNumber: 10 }); })();

function RelatedLinksComponent_div_0_p_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.title);
} }
function RelatedLinksComponent_div_0_p_1_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("href", item_r1.identifier.type, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.title);
} }
function RelatedLinksComponent_div_0_p_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.freeText);
} }
function RelatedLinksComponent_div_0_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtemplate(1, RelatedLinksComponent_div_0_p_1_span_1_Template, 2, 1, "span", 3)(2, RelatedLinksComponent_div_0_p_1_a_2_Template, 2, 2, "a", 4)(3, RelatedLinksComponent_div_0_p_1_span_3_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r1.identifier || item_r1.identifier.value !== "URI");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.identifier && item_r1.identifier.value === "URI");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.freeText);
} }
function RelatedLinksComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, RelatedLinksComponent_div_0_p_1_Template, 4, 3, "p", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.items.biblioentry);
} }
function RelatedLinksComponent_div_1_p_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r3.title);
} }
function RelatedLinksComponent_div_1_p_1_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("href", item_r3.identifier.type, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r3.title);
} }
function RelatedLinksComponent_div_1_p_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r3.freeText);
} }
function RelatedLinksComponent_div_1_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtemplate(1, RelatedLinksComponent_div_1_p_1_span_1_Template, 2, 1, "span", 3)(2, RelatedLinksComponent_div_1_p_1_a_2_Template, 2, 2, "a", 4)(3, RelatedLinksComponent_div_1_p_1_span_3_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r3.identifier || item_r3.identifier.value !== "URI");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.identifier && item_r3.identifier.value === "URI");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.freeText);
} }
function RelatedLinksComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, RelatedLinksComponent_div_1_p_1_Template, 4, 3, "p", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.items.biblioEntry);
} }
function RelatedLinksComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "span");
    i0.ɵɵtext(2, "Link to FAOLEX: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.faolexUrl + ctx_r1.items.faolex.faolex_id, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.items.faolex.faolex_id);
} }
class RelatedLinksComponent {
    constructor(utilsService, configService) {
        this.utilsService = utilsService;
        this.configService = configService;
        this.faolexUrl = this.configService.env.faolexUrl;
    }
    ngOnInit() {
        if (this.items.biblioentry) {
            if (!this.items.biblioentry || !this.items.biblioentry.length) {
                this.items.biblioentry = [this.items.biblioentry];
            }
        }
        if (this.items.biblioEntry) {
            if (!this.items.biblioEntry || !this.items.biblioEntry.length) {
                this.items.biblioEntry = [this.items.biblioEntry];
            }
        }
    }
    static { this.ɵfac = function RelatedLinksComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RelatedLinksComponent)(i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RelatedLinksComponent, selectors: [["app-related-links"]], inputs: { items: "items" }, standalone: false, decls: 3, vars: 3, consts: [["class", "related-links", 4, "ngIf"], [1, "related-links"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"]], template: function RelatedLinksComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, RelatedLinksComponent_div_0_Template, 2, 1, "div", 0)(1, RelatedLinksComponent_div_1_Template, 2, 1, "div", 0)(2, RelatedLinksComponent_div_2_Template, 5, 2, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.items && ctx.items.biblioentry);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.items && ctx.items.biblioEntry);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.items && ctx.items.faolex && !ctx.utilsService.isObjectEmpty(ctx.items.faolex));
        } }, dependencies: [i3.NgForOf, i3.NgIf], styles: [".related-links[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:.4em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RelatedLinksComponent, [{
        type: Component,
        args: [{ selector: 'app-related-links', standalone: false, template: "<div class=\"related-links\" *ngIf=\"items && items.biblioentry\">\r\n    <p *ngFor=\"let item of items.biblioentry\">\r\n        <span *ngIf=\"!item.identifier || item.identifier.value !== 'URI'\">{{item.title}}</span>\r\n        <a *ngIf=\"item.identifier && item.identifier.value === 'URI'\" href=\"{{item.identifier.type}}\" target=\"_blank\">{{item.title}}</a>\r\n        <span *ngIf=\"item.freeText\">{{item.freeText}}</span>\r\n    </p>\r\n</div>\r\n\r\n<div class=\"related-links\" *ngIf=\"items && items.biblioEntry\">\r\n    <p *ngFor=\"let item of items.biblioEntry\">\r\n        <span *ngIf=\"!item.identifier || item.identifier.value !== 'URI'\">{{item.title}}</span>\r\n        <a *ngIf=\"item.identifier && item.identifier.value === 'URI'\" href=\"{{item.identifier.type}}\" target=\"_blank\">{{item.title}}</a>\r\n        <span *ngIf=\"item.freeText\">{{item.freeText}}</span>\r\n    </p>\r\n</div>\r\n\r\n<div class=\"related-links\" *ngIf=\"items && items.faolex && !utilsService.isObjectEmpty(items.faolex)\">\r\n    <span>Link to FAOLEX: </span>\r\n    <a href=\"{{ faolexUrl + items.faolex.faolex_id}}\" target=\"_blank\">{{items.faolex.faolex_id}}</a>\r\n</div>\r\n\r\n", styles: [".related-links p{margin-bottom:.4em}\n"] }]
    }], () => [{ type: i1.UtilsService }, { type: i1.ConfigurationService }], { items: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(RelatedLinksComponent, { className: "RelatedLinksComponent", filePath: "src/components/related-links/related-links.component.ts", lineNumber: 11 }); })();

function SourcesComponent_dl_0_dd_1_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "truncate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", item_r1.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(2, 2, item_r1.url, 50, false, true));
} }
function SourcesComponent_dl_0_dd_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "dd");
    i0.ɵɵelement(1, "span", 2);
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵtemplate(3, SourcesComponent_dl_0_dd_1_a_3_Template, 3, 7, "a", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", item_r1.citation, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r1.url > "");
} }
function SourcesComponent_dl_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "dl");
    i0.ɵɵtemplate(1, SourcesComponent_dl_0_dd_1_Template, 4, 2, "dd", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.items);
} }
class SourcesComponent {
    constructor() {
        this.items = [];
    }
    ngOnInit() {
        if (!(typeof (this.items) === 'object')) {
            this.items = [];
        }
    }
    static { this.ɵfac = function SourcesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SourcesComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SourcesComponent, selectors: [["sources"]], inputs: { items: "items" }, standalone: false, decls: 1, vars: 1, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "innerHTML"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"]], template: function SourcesComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, SourcesComponent_dl_0_Template, 2, 1, "dl", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.items && ctx.items.length > 0);
        } }, dependencies: [i3.NgForOf, i3.NgIf, TruncatePipe], styles: [".ref-link[_ngcontent-%COMP%]{display:inline-block;margin-right:5px}.ref-link.species[_ngcontent-%COMP%]{font-style:italic}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SourcesComponent, [{
        type: Component,
        args: [{ selector: 'sources', standalone: false, template: "<dl *ngIf=\"items && items.length > 0\">\r\n    <dd *ngFor=\"let item of items\">\r\n        <span [innerHTML]=\"item.citation\"></span>&nbsp;<a target=\"_blank\" *ngIf=\"item.url > ''\" [href]=\"item.url\">{{ item.url | truncate:50:false:true  }}</a>\r\n    </dd>\r\n</dl>", styles: [".ref-link{display:inline-block;margin-right:5px}.ref-link.species{font-style:italic}\n"] }]
    }], () => [], { items: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SourcesComponent, { className: "SourcesComponent", filePath: "src/components/sources/sources.component.ts", lineNumber: 9 }); })();

function TableComponent_th_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(col_r1.label || col_r1.name);
} }
function TableComponent_tr_8_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r2 = ctx.$implicit;
    const row_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r3.getCellStyle(row_r3[col_r2.position]));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.mapCellValue(row_r3[col_r2.position]));
} }
function TableComponent_tr_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, TableComponent_tr_8_td_1_Template, 2, 2, "td", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._header);
} }
class TableComponent {
    constructor(utilsService) {
        this.utilsService = utilsService;
        this.itemsPerPage = 10;
    }
    ngOnInit() {
        if (this.data.length > 0) {
            this.paginationItems = this.data.length;
            if (!this.header) {
                this._header = [];
                for (let key in this.data[0].entry) {
                    this._header.push({
                        name: key,
                        label: this.utilsService.titleCase(key),
                    });
                }
            }
            else {
                this._header = this.header;
            }
        }
    }
    mapCellValue(value) {
        if (typeof (value) === 'object') {
            return value.v;
        }
        else {
            return value;
        }
    }
    getCellStyle(value) {
        if (typeof (value) === 'object') {
            return "align-right";
        }
        else {
            return '';
        }
    }
    static { this.ɵfac = function TableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TableComponent)(i0.ɵɵdirectiveInject(i1.UtilsService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TableComponent, selectors: [["app-table"]], inputs: { data: "data", header: "header", title: "title" }, standalone: false, decls: 9, vars: 3, consts: [[1, "chart-table-container"], [1, "table"], ["scope", "col", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], ["scope", "col"], [3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"]], template: function TableComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h5");
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 0)(3, "table", 1)(4, "thead")(5, "tr");
            i0.ɵɵtemplate(6, TableComponent_th_6_Template, 2, 1, "th", 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "tbody");
            i0.ɵɵtemplate(8, TableComponent_tr_8_Template, 2, 1, "tr", 3);
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngForOf", ctx._header);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.data);
        } }, dependencies: [i3.NgClass, i3.NgForOf], styles: [".chart-table-container[_ngcontent-%COMP%]{max-height:350px;overflow:auto}td.align-right[_ngcontent-%COMP%]{text-align:right;width:100px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableComponent, [{
        type: Component,
        args: [{ selector: 'app-table', standalone: false, template: "<h5>{{ title }}</h5>\r\n<div class=\"chart-table-container\">\r\n    <table class=\"table\">\r\n        <thead>\r\n            <tr>\r\n              <th scope=\"col\" *ngFor=\"let col of _header\">{{ col.label || col.name }}</th>\r\n            </tr>\r\n        </thead>\r\n        <tbody>\r\n        <tr *ngFor=\"let row of data\">\r\n            <td [ngClass]=\"getCellStyle(row[col.position])\" *ngFor=\"let col of _header\">{{ mapCellValue(row[col.position]) }}</td>\r\n        </tr>\r\n        </tbody>\r\n    </table>\r\n</div>\r\n<!-- <pagination *ngIf=\"paginationItems > itemsPerPage\" [(ngModel)]=\"page\" class=\"mt-4 justify-content-center\"\r\n    [maxSize]=\"maxSize\" [boundaryLinks]=\"true\" [itemsPerPage]=\"itemsPerPage\" [totalItems]=\"paginationItems\"\r\n    (pageChanged)=\"pageChanged($event)\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n    lastText=\"&raquo;\"></pagination> -->", styles: [".chart-table-container{max-height:350px;overflow:auto}td.align-right{text-align:right;width:100px}\n"] }]
    }], () => [{ type: i1.UtilsService }], { data: [{
            type: Input
        }], header: [{
            type: Input
        }], title: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TableComponent, { className: "TableComponent", filePath: "src/components/table/table.component.ts", lineNumber: 10 }); })();

const _c0$6 = a0 => ({ document: a0 });
function TocComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function TocComponent_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.isCollapsed = !ctx_r1.isCollapsed); });
    i0.ɵɵelement(1, "i", 6);
    i0.ɵɵelementEnd();
} }
function TocComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function TocComponent_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.isCollapsed = !ctx_r1.isCollapsed); });
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementEnd();
} }
function TocComponent_html_renderer_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "html-renderer", 8);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("template", ctx_r1.tmpl)("data", i0.ɵɵpureFunction1(2, _c0$6, ctx_r1.document));
} }
class TocComponent {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.isCollapsed = true;
    }
    ngOnInit() {
        this.http.get('./assets/templates/' + this.collection + '/' + this.collection + '-toc.fitmpl', { responseType: "text" }).subscribe(post => {
            this.tmpl = post;
        });
    }
    static { this.ɵfac = function TocComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TocComponent)(i0.ɵɵdirectiveInject(i1$3.HttpClient), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TocComponent, selectors: [["toc"]], inputs: { collection: "collection", document: "document" }, standalone: false, decls: 8, vars: 4, consts: [[1, "row"], [1, "col-md-12", "toc-header"], ["type", "button", "class", "btn btn-link toc-button", "data-bs-toggle", "collapse", "data-bs-target", "#tocCollapse", "aria-expanded", "false", "aria-controls", "tocCollapse", 3, "click", 4, "ngIf"], ["id", "tocCollapse", 1, "row", "collapse"], [3, "template", "data", 4, "ngIf"], ["type", "button", "data-bs-toggle", "collapse", "data-bs-target", "#tocCollapse", "aria-expanded", "false", "aria-controls", "tocCollapse", 1, "btn", "btn-link", "toc-button", 3, "click"], [1, "bi", "bi-caret-down-fill"], [1, "bi", "bi-caret-up-fill"], [3, "template", "data"]], template: function TocComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h5");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, TocComponent_button_4_Template, 2, 0, "button", 2)(5, TocComponent_button_5_Template, 2, 0, "button", 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 3);
            i0.ɵɵtemplate(7, TocComponent_html_renderer_7_Template, 1, 4, "html-renderer", 4);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.configService.getTranslation("common.tableOfContents"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isCollapsed);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isCollapsed);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.tmpl);
        } }, styles: [".toc-header[_ngcontent-%COMP%]{display:flex}.toc-button[_ngcontent-%COMP%]{line-height:.5em;color:var(--default-font-color);padding:.2rem .4rem!important}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TocComponent, [{
        type: Component,
        args: [{ selector: 'toc', standalone: false, template: "  <div class=\"row\">\r\n    <div class=\"col-md-12 toc-header\">\r\n      <h5>{{ configService.getTranslation('common.tableOfContents')}}</h5>\r\n      <button type=\"button\" class=\"btn btn-link toc-button\" *ngIf=\"isCollapsed\" (click)=\"isCollapsed = !isCollapsed\" data-bs-toggle=\"collapse\" data-bs-target=\"#tocCollapse\" aria-expanded=\"false\" aria-controls=\"tocCollapse\"><i class=\"bi bi-caret-down-fill\"></i></button>\r\n      <button type=\"button\" class=\"btn btn-link toc-button\" *ngIf=\"!isCollapsed\" (click)=\"isCollapsed = !isCollapsed\" data-bs-toggle=\"collapse\" data-bs-target=\"#tocCollapse\" aria-expanded=\"false\" aria-controls=\"tocCollapse\"><i class=\"bi bi-caret-up-fill\"></i></button>\r\n    </div>\r\n  </div>\r\n  <div class=\"row collapse\" id=\"tocCollapse\">\r\n      <html-renderer *ngIf=\"tmpl\" [template]=\"tmpl\" [data]=\"{ document: document }\"></html-renderer>\r\n  </div>", styles: [".toc-header{display:flex}.toc-button{line-height:.5em;color:var(--default-font-color);padding:.2rem .4rem!important}\n"] }]
    }], () => [{ type: i1$3.HttpClient }, { type: i1.ConfigurationService }], { collection: [{
            type: Input
        }], document: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TocComponent, { className: "TocComponent", filePath: "src/components/toc/toc.component.ts", lineNumber: 11 }); })();

class VideoPlayerComponent {
    constructor() {
        this.apiLoaded = false;
    }
    ngOnInit() {
        if (!this.apiLoaded) {
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            document.body.appendChild(tag);
            this.apiLoaded = true;
        }
    }
    static { this.ɵfac = function VideoPlayerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || VideoPlayerComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VideoPlayerComponent, selectors: [["youtube-video-player"]], inputs: { videoId: "videoId" }, standalone: false, decls: 1, vars: 1, consts: [[3, "videoId"]], template: function VideoPlayerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "youtube-player", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("videoId", ctx.videoId);
        } }, dependencies: [i1$4.YouTubePlayer], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VideoPlayerComponent, [{
        type: Component,
        args: [{ selector: 'youtube-video-player', standalone: false, template: "<youtube-player \r\n    [videoId]=\"videoId\"\r\n>\r\n</youtube-player>" }]
    }], () => [], { videoId: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(VideoPlayerComponent, { className: "VideoPlayerComponent", filePath: "src/components/video-player/video-player.component.ts", lineNumber: 9 }); })();

const _c0$5 = ["dynamicFormPage"];
class DetailDirective {
    constructor(searchService, router, route, utilsService, collectionService, confirmationService, collectionItemService, userselectionService, dialogService, configService, userService, formDataService, workspaceService, loggingService, templateService, propertiesService, listConfigService, dynamicFormControlService, cacheService) {
        this.searchService = searchService;
        this.router = router;
        this.route = route;
        this.utilsService = utilsService;
        this.collectionService = collectionService;
        this.confirmationService = confirmationService;
        this.collectionItemService = collectionItemService;
        this.userselectionService = userselectionService;
        this.dialogService = dialogService;
        this.configService = configService;
        this.userService = userService;
        this.formDataService = formDataService;
        this.workspaceService = workspaceService;
        this.loggingService = loggingService;
        this.templateService = templateService;
        this.propertiesService = propertiesService;
        this.listConfigService = listConfigService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.cacheService = cacheService;
        this.loading = false;
        this.pageReady = false;
        this.editing = false;
        this.readonly = false;
        this.notfound = false;
    }
    init() {
        if (this.router.url.includes('reporting')) {
            this.subpath = 'reporting/';
        }
        else {
            this.subpath = '';
        }
        this.sub = this.route.params.subscribe(params => {
            this.routeParams = params;
            this.subsub = this.route.queryParams.subscribe(async (params) => {
                this.queryParams = params;
                this.manageParams();
                this.manageParentsHierarchy();
                this.getItem();
            });
        });
    }
    newItem() {
        this.collectionItem = {
            parentId: this.parentId,
            parentSpace: this.parentSpace,
            parentCollection: this.parentCollection,
            document: {}
        };
        this.checkBreadcrumb();
        this.manageCollectionItem(() => {
            this.loading = false;
            this.pageReady = true;
        });
    }
    getItem() {
        if (!this.collection || this.collection === 'pages') {
            if (!this.collection) {
                this.collection = 'pages';
            }
            if (this.editing) {
                this.alias = this.extractAlias(this.routeParams);
            }
            else {
                if (!this.routeParams.alias) {
                    this.alias = this.router.url.split("?")[0].substring(1);
                }
                else {
                    this.alias = this.routeParams.alias;
                }
            }
            //If the alias is just the current language, this means that we are in the home page, for which the navigation url is simply the current language
            //and the alias to use to search for the page will be <currentLang>/<currentLang>
            if (this.alias === this.configService.env.currentLang) {
                this.alias = this.alias + "/" + this.configService.env.currentLang;
            }
            //We are in a page, if there is an alias and we are not in the manager (lightforms), this means the we can only be in view
            this.operation = this.alias ? (this.editing ? 'edit' : 'view') : 'new';
            if (this.operation === 'new') {
                this.newItem();
            }
            else {
                this.manageCollectionItem(() => {
                    if (this.routeParams.alias) {
                        this.loadItem(() => {
                            this.loading = false;
                            this.pageReady = true;
                        });
                    }
                    else {
                        this.loadPage(() => {
                            this.loading = false;
                            this.pageReady = true;
                        });
                    }
                });
            }
        }
        else {
            if (!this.alias) {
                this.alias = this.extractAlias(this.routeParams);
            }
            else {
                if (this.alias === "add") {
                    this.alias = null;
                }
            }
            this.operation = this.alias ? (this.editing ? 'edit' : 'view') : 'new';
            if (this.operation === 'new') {
                this.newItem();
            }
            else {
                this.manageCollectionItem(() => {
                    this.loadItem(() => {
                        this.loading = false;
                        this.pageReady = true;
                    });
                });
            }
        }
    }
    loadItem(callback) {
        let space;
        let collection;
        if (this.collectionForm?.formConfig.virtualCollection) {
            space = this.collectionForm?.formConfig.dataSpace;
            collection = this.collectionForm?.formConfig.dataCollections.toString();
        }
        else {
            space = this.space;
            collection = this.collection;
        }
        if (this.virtualCollectionStatuses) {
            this.status = this.virtualCollectionStatuses;
        }
        this.searchService.searchCollectionItemById(space, collection, this.alias, this.lang, this.status, this.statuses).subscribe(res => {
            this.parentId = res.parentId;
            this.parentSpace = res.parentSpace;
            this.parentCollection = res.parentCollection;
            this.collectionItem = res;
            this.checkBreadcrumb();
            this.setCollectionItemIndexingData();
            if (callback) {
                callback();
            }
        }, err => {
            this.alias = this.extractAlias({});
            this.collection = 'pages';
            this.loadPage(callback);
        });
    }
    manageParams() {
        if (!this.space) {
            this.space = this.routeParams['space'] || this.configService.env.space;
        }
        if (!this.collection) {
            this.collection = this.routeParams.collection;
        }
        this.lang = this.routeParams.lang;
        if (this.queryParams.readonly !== undefined) {
            this.readonly = this.queryParams.readonly;
        }
        this.status = this.queryParams.status || this.configService.env.status;
        if (this.queryParams.lang) {
            this.lang = this.queryParams.lang;
        }
    }
    manageParentsHierarchy() {
        if (this.queryParams._p > "") {
            let parents = this.queryParams._p.split(",");
            let parent = parents[parents.length - 1].split("@");
            this.parentSpace = parent[0];
            this.parentCollection = parent[1];
            this.parentId = parent[2];
            this.parentStatus = parent[3];
        }
    }
    manageCollectionItem(callback) {
        //Start collection item management
        this.loading = true;
        if (this.configService.isLoggedIn() || this.configService.user) {
            this.userService.getLoggedUser(this.space, this.configService.user.id).subscribe(usersettings => {
                this.configService.getUserProfile(this.space, usersettings);
                if (this.operation !== 'view') {
                    this.extractReferences(() => {
                        this.extractCollectionInfo(() => {
                            this.loadWorkflow(() => {
                                this.extractTemplatesProperties(() => {
                                    callback();
                                });
                            });
                        });
                    });
                }
                else {
                    this.extractCollectionInfo(() => {
                        this.loadWorkflow(() => {
                            this.extractTemplatesProperties(() => {
                                callback();
                            });
                        });
                    });
                }
            }, err => {
                this.loading = false;
                this.configService.logout(this.router.url, true);
            });
        }
        else {
            if (this.operation !== 'view') {
                this.extractReferences(() => {
                    this.extractCollectionInfo(() => {
                        this.loadWorkflow(() => {
                            this.extractTemplatesProperties(() => {
                                callback();
                            });
                        });
                    });
                });
            }
            else {
                this.extractCollectionInfo(() => {
                    this.loadWorkflow(() => {
                        this.extractTemplatesProperties(() => {
                            callback();
                        });
                    });
                });
            }
        }
    }
    extractReferences(callback) {
        if (!this.configService.references[this.space]) {
            this.collectionService.getCollections(this.space, null, "reference").subscribe(res => {
                this.configService.references[this.space] = res;
                callback();
            });
        }
        else {
            callback();
        }
    }
    extractAlias(params) {
        let alias = params.alias;
        let url = this.router.url.split("?")[0];
        if (this.collection !== 'pages') {
            //Strip out the language at the end
            url = url.substring(0, url.lastIndexOf('/'));
        }
        if (!alias) {
            let paths = url.split(params.collection);
            if (paths.length > 1) {
                if (paths[1].includes('#')) {
                    paths[1] = paths[1].substring(0, paths[1].indexOf('#'));
                }
                alias = paths[1].startsWith('/') ? paths[1].substring(1) : paths[1];
            }
            else {
                //Remove the language from the path and leave just the alias to use to extract collection item
                if (paths.length == 1) {
                    alias = paths[0]; //.substring(1).substring(paths[0].substring(1).indexOf('/') + 1);
                }
            }
        }
        return alias;
    }
    extractCollectionInfo(callback) {
        this.loading = true;
        forkJoin([
            this.collectionService.getCollection(this.space, this.collection),
            this.collectionService.getCollectionConfig(this.space, this.collection)
        ]).subscribe((results) => {
            results[0].form = this.configService.enrichGlobalParams(this.space, results[0].roleType, results[0].form, this.alias ? 'edit' : 'create');
            if (results[1].selectionEnabled && !this.configService.isLoggedIn()) {
                results[1].selectionEnabled = false;
            }
            this.collectionForm = results[0];
            this.collectionForm.formConfig = ListDirective.initFormConfig(results[1]);
            this.collectionForm.form.collection = this.collection;
            //-----Enrichment of the accepted params----------------------------------------
            this.collectionForm.form.params = this.collectionForm?.form.params || [];
            for (let key in this.queryParams) {
                if (key !== 'status' && key !== 'lang') {
                    this.collectionForm?.form.params.push({
                        name: key,
                        value: this.queryParams[key]
                    });
                }
            }
            //------------------------------------------------------------------------------
            if (this.collectionForm?.formConfig.selectionEnabled) {
                this.userselectionService.initCart(this.space, "cart", () => { });
            }
            callback();
        }, (err) => {
            this.loading = false;
            this.searchService.manageError(err, 'Error reading collection and collection config for ' + this.collection);
        });
    }
    loadWorkflow(callback) {
        this.workspaceService.getWorkflow(this.space, this.collectionForm.workflowId || 'default').subscribe(res => {
            this.loading = false;
            this.statuses = res.statuses;
            if (this.collectionForm?.formConfig.virtualCollection) {
                this.collectionService.getCollection(this.collectionForm?.formConfig.dataSpace, this.collectionForm?.formConfig.dataCollections.toString()).subscribe(res => {
                    this.workspaceService.getWorkflow(this.collectionForm?.formConfig.dataSpace, res.workflowId || 'default').subscribe(res => {
                        this.virtualCollectionStatuses = res.statuses.defaultSearchStatus;
                        this.mergeUserActions();
                        callback();
                    }, err => {
                        this.loading = false;
                        this.searchService.manageError(err, 'Error reading workflow');
                    });
                });
            }
            else {
                callback();
            }
        }, err => {
            this.loading = false;
            this.statuses = { status: [] };
            this.searchService.manageError(err, 'Error reading default workflow');
        });
    }
    mergeUserActions() {
        let userActionsIndex = this.configService.globalUserSpaceCollectionActions?.findIndex(item => item.name === this.collection || item.name === "*");
        if (userActionsIndex >= 0) {
            let userActions = this.configService.globalUserSpaceCollectionActions[userActionsIndex].actions;
            if (this.operation === 'edit' && !userActions.edit) {
                this.readonly = true;
            }
            for (let key in userActions) {
                for (let i = 0; i < this.statuses.status.length; i++) {
                    if (this.statuses.status[i].nextStatuses) {
                        this.statuses.status[i].nextStatuses = this.statuses.status[i].nextStatuses.filter(item => userActions[key].includes(item));
                    }
                    else {
                        this.statuses.status[i].nextStatuses = userActions[key];
                    }
                }
            }
        }
        else {
            //To see what to do, I should receive nextStatuses directly in the workflow
            if (this.collectionForm.roleType === 'ADMIN') {
                for (let i = 0; i < this.statuses.status.length; i++) {
                    this.statuses.status[i].nextStatuses = this.statuses.status[i].computedNextStatuses;
                }
            }
        }
    }
    extractProperties(callback) {
        this.propertiesService.getGlobalProperties(this.space, this.configService.env.currentLang).subscribe(globalProps => {
            this.propertiesService.getCollectionProperties(this.space, this.collection, this.configService.env.currentLang).subscribe(collectionProps => {
                this.collectionForm.form.properties = this.propertiesService.merge(globalProps, collectionProps);
                this.configService.enrichProperties(this.collectionForm?.form.properties);
                callback();
            });
        }, error => {
            this.propertiesService.getCollectionProperties(this.space, this.collection, this.configService.env.currentLang).subscribe(collectionProps => {
                this.collectionForm.form.properties = collectionProps;
                this.configService.enrichProperties(this.collectionForm?.form.properties);
                callback();
            });
        });
    }
    extractTemplatesProperties(callback) {
        if (this.operation === 'view' && this.collectionForm?.formConfig.detailPageTemplate) {
            this.templateService.getTemplateByIdCompressed(this.space, this.collection, 'detail', this.collectionForm?.formConfig.detailPageTemplate).subscribe(res => {
                this.detailPageTemplate = res;
                this.extractProperties(callback);
            });
        }
        else {
            this.extractProperties(callback);
        }
    }
    loadPage(callback) {
        if (this.operation === "new" || this.operation === "edit") {
            this.searchService.searchCollectionItemById(this.space, this.collection, this.alias, this.lang, this.status, this.statuses).subscribe(res => {
                this.parentId = res.parentId;
                this.parentSpace = res.parentSpace;
                this.parentCollection = res.parentCollection;
                this.collectionItem = res;
                this.detailPageTemplate = this.collectionItem.document.overview;
                this.setCollectionItemIndexingData();
                this.checkBreadcrumb();
                this.loading = false;
                this.notfound = false;
                if (callback) {
                    callback();
                }
            }, err => {
                this.loading = false;
                this.notfound = true;
                //Add the display of a not found page
                this.searchService.manageError(err, 'Error reading collection item ' + this.alias);
            });
        }
        else {
            this.searchService.searchCollectionItemByAlias(this.space, this.collection, this.alias, this.lang, this.status, this.statuses).subscribe(res => {
                this.parentId = res.parentId;
                this.parentSpace = res.parentSpace;
                this.parentCollection = res.parentCollection;
                this.collectionItem = res;
                this.collectionItem.document.id = this.collectionItem.id;
                this.detailPageTemplate = this.collectionItem.document.overview;
                this.setCollectionItemIndexingData();
                this.checkBreadcrumb();
                this.loading = false;
                this.notfound = false;
                if (callback) {
                    callback();
                }
            }, err => {
                this.loading = false;
                this.notfound = true;
                //Add the display of a not found page
                this.searchService.manageError(err, 'Error reading collection item ' + this.alias);
            });
        }
    }
    setCollectionItemIndexingData() {
        let title;
        if (this.collectionForm?.formConfig.aliases?.title) {
            title = this.utilsService.getPropertyId(this.collectionItem, this.collectionForm?.formConfig.aliases.title);
        }
        else {
            title = !(typeof (this.collectionItem.document.title) === "object") ? this.collectionItem.document.title || "" : "";
        }
        this.utilsService.setIndexingData(title + (title && this.collectionForm?.formConfig?.name ? " - " : "") + (this.collectionForm?.formConfig?.name ? this.collectionForm?.formConfig?.name : ""), this.collectionForm.collection);
    }
    getInitialStatus() {
        if (this.statuses) {
            if (this.statuses.status) {
                if (this.statuses.status.length > 1) {
                    return this.collectionItem.status || this.statuses?.defaultDocumentStatus || this.statuses.status[0].name;
                }
                else {
                    return this.collectionItem.status || this.statuses.status[0].name;
                }
            }
            else {
                return this.collectionItem.status || this.statuses?.defaultDocumentStatus;
            }
        }
        else {
            return this.collectionItem.status;
        }
    }
    checkBreadcrumb() {
        /* if (this.collectionForm?.form.externalFormsRefList && this.collectionForm?.form.externalFormsRefList.length > 0)
        { */
        this.breadcrumb = [];
        if (this.queryParams._p) {
            //Extraction of the breadcrumb steps from the _p query string param
            let parentStrings;
            if (this.queryParams._p.includes(",")) {
                parentStrings = this.queryParams._p.split(",");
            }
            else {
                parentStrings = [this.queryParams._p];
            }
            //Creation of the breadcrumb
            for (let i = 0; i < parentStrings.length; i++) {
                let _p = '';
                if (i > 0) {
                    //Creation of the right _p depending on the breadcrumb level
                    for (let j = 0; j < parentStrings.length - 1; j++) {
                        _p = (_p > '' ? _p + "," : _p) + parentStrings[j];
                    }
                    let parent = parentStrings[i].split("@");
                    this.breadcrumb.push({
                        space: parent[0],
                        collection: parent[1],
                        id: parent[2],
                        status: parent[3],
                        _p: _p
                    });
                }
                else {
                    let parent = parentStrings[i].split("@");
                    this.breadcrumb.push({
                        space: parent[0],
                        collection: parent[1],
                        id: parent[2],
                        status: parent[3]
                    });
                }
            }
            for (let i = 0; i < this.breadcrumb?.length; i++) {
                this.collectionService.getCollectionConfig(this.breadcrumb[i].space, this.breadcrumb[i].collection).subscribe(res => {
                    this.breadcrumb[i].name = res.name || this.breadcrumb[i].collection;
                });
            }
        }
        else {
            if (this.breadcrumb && this.breadcrumb?.length > 0) {
                this.root = this.breadcrumb[0];
            }
        }
        /* } */
    }
    /*
      Extraction of the new breadcrumb depending on the click of the user:
      - if the user clicks on the back button, the b param is not provided and the new breadcrumb array will be the actual one without the last array item
      - if the user clicks on a breadcrumb item, the b param is provided and the new breadcrumb array will be created taking all the array items until the one (excluded) that is equal to the clicked one
    */
    getBreadcrumb(b) {
        let bc;
        if (this.breadcrumb && this.breadcrumb?.length > 0) {
            bc = [];
            for (let i = 0; i < this.breadcrumb?.length; i++) {
                if (b) {
                    if (JSON.stringify(this.breadcrumb[i]) !== JSON.stringify(b)) {
                        bc.push(this.breadcrumb[i]);
                    }
                    else {
                        break;
                    }
                }
                else {
                    if (i === this.breadcrumb?.length - 1) {
                        break;
                    }
                    else {
                        bc.push(this.breadcrumb[i]);
                    }
                }
            }
        }
        return bc;
    }
    deleteAllowed() {
        let userActionsIndex = this.configService.globalUserSpaceCollectionActions?.findIndex(item => item.name === this.collection || item.name === "*");
        if (userActionsIndex >= 0) {
            if (this.configService.globalUserSpaceCollectionActions[userActionsIndex].actions.delete &&
                this.configService.globalUserSpaceCollectionActions[userActionsIndex].actions.delete.includes(this.status)) {
                return true;
            }
        }
        return false;
    }
    goTo(b) {
        let path = '';
        if (this.operation === 'new') {
            path = '../../';
        }
        else {
            path = '../../../';
        }
        let url;
        if (this.routeParams.space) {
            url = this.subpath + '/' + b.space + '/' + b.collection + '/' + b.id + '/' + this.configService.env.currentLang;
        }
        else {
            url = this.subpath + '/' + b.collection + '/' + b.id + '/' + this.configService.env.currentLang;
        }
        this.router.navigate([url], {
            queryParams: {
                status: b.status,
                _p: b._p
            }
        });
    }
    back(root, notfound) {
        if (this.dynamicFormPage?.getForm().dirty) {
            this.confirmationService.confirm({
                message: this.configService.env.i18n[this.configService.env.currentLang]._action_unsaved,
                key: this.dialogsKey,
                acceptLabel: this.configService.env.i18n[this.configService.env.currentLang]._action_unsaved_accept,
                rejectLabel: this.configService.env.i18n[this.configService.env.currentLang]._action_unsaved_reject,
                accept: () => {
                    this.save(true, root);
                },
                reject: (event) => {
                    if (event === 1) {
                        this.formDataService.leaveForm(this.routeParams, this.queryParams, this.subpath, this.collectionItem, this.collectionForm, root);
                    }
                }
            });
        }
        else {
            if (!notfound) {
                this.formDataService.leaveForm(this.routeParams, this.queryParams, this.subpath, this.collectionItem, this.collectionForm, root);
            }
            else {
                this.formDataService.leaveForm(this.routeParams, this.queryParams, this.subpath, {
                    parentSpace: this.parentSpace,
                    parentCollection: this.parentCollection,
                    parentStatus: this.parentStatus,
                    parentId: this.parentId
                }, this.collectionForm, root);
            }
        }
    }
    onStatusChange(event) {
        const ref = this.dialogService.open(StatusNoteComponent, {
            data: {},
            header: 'Status change confirmation',
            width: '50%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
        ref.onClose.subscribe((note) => {
            if (note) {
                this.formDataService.statusChange(this.space, this.collection, this.alias, event.old, event.new, note).subscribe(res => {
                    let url = '/reporting/' + this.space + '/' + this.collection + '/' + this.alias + '/' + this.configService.env.currentLang;
                    this.router.navigate([url], {
                        queryParams: {
                            _p: this.queryParams._p,
                            status: event.new
                        }
                    });
                }, err => {
                    this.loading = false;
                    this.searchService.manageError(err, 'Error changing status for form ' + this.collection);
                });
            }
        });
    }
    save(leave, root) {
        this.collectionItem.document = this.dynamicFormPage.getFormValue();
        /* this.manageJsonComponents(this.collectionForm?.form,this.collectionItem.document); */
        this.dynamicFormPage.form.updateValueAndValidity();
        this.dynamicFormPage.form.markAllAsTouched();
        if (this.dynamicFormPage.form.valid) {
            //If the form is valid I save it
            this.collectionItem.status = this.collectionItem.document.status;
            this.formDataService.storeFormData(this.routeParams, this.queryParams, this.subpath, this.dynamicFormPage, this.collectionForm, this.collectionItem, this.operation, this.alias, this.parentId, this.parentSpace, this.parentCollection, leave, root, this.status, this.statuses);
        }
        else {
            //If the form in not valid, I extract the list of invalid components, I check if they are visible or not, if they are not visible I save anyway
            this.validationErrors = [];
            this.validationErrors = this.extractUnvalidControls(this.validationErrors, this.dynamicFormPage.form, this.collectionForm?.form, this.collectionForm?.form.components);
            let visibleErrors = this.validationErrors.filter(item => item.visible);
            if (visibleErrors.length === 0) {
                this.collectionItem.status = this.collectionItem.document.status;
                this.formDataService.storeFormData(this.routeParams, this.queryParams, this.subpath, this.dynamicFormPage, this.collectionForm, this.collectionItem, this.operation, this.alias, this.parentId, this.parentSpace, this.parentCollection, leave, root, this.status, this.statuses);
            }
        }
    }
    /*   manageJsonComponents(form: any, item: any)
      {
        let dfos: Array<any> = form.components.filter(dfo => dfo.type === "json");
    
        if (dfos.length > 0)
        {
          for(let i=0; i<dfos.length; i++)
          {
            let attrValues = jsonPath.query(item, '$.' + dfos[i].pathId);
            if (attrValues?.length > 0) {
              try {
                attrValues
              }
              catch(error) {}
            }
          }
        }
      }
     */
    getErrorLog() {
        return this.validationErrors?.filter(item => item.visible) || [];
    }
    extractUnvalidControls(errors, form, dynamicForm, components) {
        if (!errors) {
            errors = [];
        }
        if (form.controls) {
            Object.keys(form.controls).forEach((key) => {
                const control = form.get(key);
                let index = components.findIndex(item => item.code === key);
                if (index >= 0) {
                    let component = components[index];
                    if (control.status === "INVALID") {
                        errors.push({
                            name: key,
                            visible: component.visible && this.dynamicFormControlService.processVisibilityConditions(dynamicForm, component, form.getRawValue(), null),
                            label: this.dynamicFormControlService.getProperty(form.getRawValue(), dynamicForm, component, "label", this.configService.env.currentLang),
                            value: control.value,
                            status: control.status,
                            errors: control.errors
                        });
                    }
                    errors = this.extractUnvalidControls(errors, control, dynamicForm, component.components);
                }
                else {
                    console.log("Component " + key + " not found");
                }
            });
        }
        return errors;
    }
    remove() {
        this.confirmationService.confirm({
            message: this.configService.env.i18n[this.configService.env.currentLang]._action_delete,
            key: this.dialogsKey,
            acceptLabel: 'Delete',
            rejectLabel: 'Cancel',
            accept: () => {
                this.loading = true;
                this.formDataService.deleteFormData(this.collectionForm.space, this.collectionForm.collection, this.alias, this.status || this.collectionItem.status).subscribe(res => {
                    this.formDataService.leaveForm(this.routeParams, this.queryParams, this.subpath, this.collectionItem, this.collectionForm, undefined);
                }, err => {
                    this.loading = false;
                    this.searchService.manageError(err, 'Error found while deleting record');
                });
            }
        });
    }
    onNextForm(event) {
        this.formDataService.goToNextForm(this.routeParams, this.queryParams, this.subpath, event.dynamicForm, event.entry, event.status, event.subform, event.parent);
    }
    static { this.ɵfac = function DetailDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DetailDirective)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(UserselectionService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.UsersService), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(i1.WorkspaceService), i0.ɵɵdirectiveInject(i1.LoggingService), i0.ɵɵdirectiveInject(i1.TemplateService), i0.ɵɵdirectiveInject(i1.PropertiesService), i0.ɵɵdirectiveInject(i1.ListConfigService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1.CacheService)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: DetailDirective, selectors: [["", "appDetail", ""]], viewQuery: function DetailDirective_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$5, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dynamicFormPage = _t.first);
        } }, standalone: false }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DetailDirective, [{
        type: Directive,
        args: [{
                selector: '[appDetail]',
                standalone: false
            }]
    }], () => [{ type: i1.SearchService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.UtilsService }, { type: i1.CollectionService }, { type: i3$2.ConfirmationService }, { type: FormDataService }, { type: UserselectionService }, { type: i1$1.DialogService }, { type: i1.ConfigurationService }, { type: i1.UsersService }, { type: FormDataService }, { type: i1.WorkspaceService }, { type: i1.LoggingService }, { type: i1.TemplateService }, { type: i1.PropertiesService }, { type: i1.ListConfigService }, { type: i1.DynamicFormControlService }, { type: i1.CacheService }], { dynamicFormPage: [{
            type: ViewChild,
            args: ['dynamicFormPage']
        }] }); })();

class ResultsDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    static { this.ɵfac = function ResultsDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ResultsDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ResultsDirective, selectors: [["", "appResults", ""]], standalone: false }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResultsDirective, [{
        type: Directive,
        args: [{
                selector: '[appResults]',
                standalone: false
            }]
    }], () => [{ type: i0.ViewContainerRef }], null); })();

function SearchListComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 4);
    i0.ɵɵelement(2, "fi-filter", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("space", ctx_r0.space)("collection", ctx_r0.name)("collectionForm", ctx_r0.collectionForm)("data", ctx_r0.resultList);
} }
function SearchListComponent_div_0_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13)(2, "div", 14)(3, "span", 15);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("common.loading"));
} }
function SearchListComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵelement(2, "fi-search-pills", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵelement(4, "fi-filter-terms", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵtemplate(6, SearchListComponent_div_0_div_2_div_6_Template, 5, 1, "div", 10);
    i0.ɵɵelementStart(7, "fi-list", 11);
    i0.ɵɵlistener("onClick", function SearchListComponent_div_0_div_2_Template_fi_list_onClick_7_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.resultClick($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("space", ctx_r0.space)("collection", ctx_r0.collection)("collectionForm", ctx_r0.collectionForm)("data", ctx_r0.resultList);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("space", ctx_r0.space)("collection", ctx_r0.collection)("collectionForm", ctx_r0.collectionForm)("data", ctx_r0.resultList);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ngClass", ((ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.showFilterTerms) && ctx_r0.aggregations && ctx_r0.aggregations.length > 0 ? "col-md-10" : "col-md-12") + " results");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("enableClick", ctx_r0.enableClick)("space", ctx_r0.space)("collection", ctx_r0.collection)("collectionForm", ctx_r0.collectionForm)("data", ctx_r0.resultList);
} }
function SearchListComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵelement(2, "fi-template-renderer", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("space", ctx_r0.space)("collection", ctx_r0.collection)("collectionForm", ctx_r0.collectionForm)("template", ctx_r0.template)("data", ctx_r0.resultList)("styles", ctx_r0.collectionForm.form.stylesheet);
} }
function SearchListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, SearchListComponent_div_0_div_1_Template, 3, 4, "div", 2)(2, SearchListComponent_div_0_div_2_Template, 8, 15, "div", 3)(3, SearchListComponent_div_0_div_3_Template, 3, 6, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.template);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.template);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.template);
} }
class SearchListComponent extends ListDirective {
    constructor(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService, formDataService, dialogService, mapService) {
        super(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService);
        this.formDataService = formDataService;
        this.dialogService = dialogService;
        this.mapService = mapService;
        this.showsearchbar = false;
        this.showadvancedsearchbar = false;
        this.showfilterterms = false;
        this.resultsonload = true;
        this.allowredirect = false;
        this.target = '_self';
        this.enableClick = false;
        this.onClick = new EventEmitter();
        this.dataReady = new EventEmitter();
        this.resultListReady = new EventEmitter();
    }
    ngOnInit() {
        this.setIndexingData = false;
        if (this.displaycolumns > '') {
            this.columns = this.displaycolumns.split(',');
        }
        if (typeof (this.resultsonload) === 'string') {
            this.resultsonload = JSON.parse(this.resultsonload);
        }
        this.name = this.collection;
        this.sub = this.route.queryParams.subscribe(params => {
            if (!this.config) {
                this.config = {
                    listPayload: {
                        searchForLang: false,
                        sort: '',
                        showFilterTerms: this.showfilterterms
                    }
                };
            }
            let inputs = {
                advanced: this.advanced,
                filter: this.filter,
                f: this.f,
                additional: this.additional,
                options: this.options,
                o: this.o,
                langs: this.langs,
                q: this.q || this.query,
                sort: this.sort
            };
            for (let key in params) {
                if (params[key] > '') {
                    inputs[key] = params[key];
                }
            }
            this.init(this.resultsonload, inputs);
        });
    }
    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
    resultClick(event) {
        this.onClick.emit(event);
    }
    afterSearchAdditionalActions(list, searchParameters, geoFilter) {
        this.dataReady.emit(list);
        this.resultListReady.emit(this.resultList);
    }
    static { this.ɵfac = function SearchListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SearchListComponent)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(UserselectionService), i0.ɵɵdirectiveInject(i1.WorkspaceService), i0.ɵɵdirectiveInject(i1.TemplateService), i0.ɵɵdirectiveInject(i1.PropertiesService), i0.ɵɵdirectiveInject(i1.ListConfigService), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.MapService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SearchListComponent, selectors: [["search-list"]], inputs: { space: "space", collection: "collection", collectionForm: "collectionForm", listTemplate: "listTemplate", listConfig: "listConfig", showsearchbar: "showsearchbar", showadvancedsearchbar: "showadvancedsearchbar", showfilterterms: "showfilterterms", resultsonload: "resultsonload", displaycolumns: "displaycolumns", allowredirect: "allowredirect", size: "size", advanced: "advanced", query: "query", q: "q", filter: "filter", f: "f", sort: "sort", additional: "additional", options: "options", o: "o", target: "target", langs: "langs", enableClick: "enableClick" }, outputs: { onClick: "onClick", dataReady: "dataReady", resultListReady: "resultListReady" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "mt-4", 4, "ngIf"], [1, "mt-4"], ["class", "mb-2", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "mb-2"], [3, "space", "collection", "collectionForm", "data"], [1, "row"], [1, "col-md-12"], [1, "col-md-2"], [3, "ngClass"], ["class", "row spinner", 4, "ngIf"], [3, "onClick", "enableClick", "space", "collection", "collectionForm", "data"], [1, "row", "spinner"], [1, "col-md-12", "mb-3", "align-center"], ["role", "status", 1, "spinner-border"], [1, "sr-only"], [3, "space", "collection", "collectionForm", "template", "data", "styles"]], template: function SearchListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, SearchListComponent_div_0_Template, 4, 3, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.pageReady);
        } }, styles: [".search-list-tabs-bar[_ngcontent-%COMP%]{margin-bottom:1em;display:flex;flex-grow:1;flex-wrap:nowrap;align-items:flex-end}.search-list-tabs-bar[_ngcontent-%COMP%]   .search-tab[_ngcontent-%COMP%]{width:100%}.search-list-tabs-bar[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{background-color:var(--primary-color)!important;border-color:var(--primary-color)!important;color:var(--secondary-font-color)!important;padding:.2rem!important;font-size:1rem!important;border-radius:.25rem!important;width:40px;margin-right:3px!important;margin-left:3px!important;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.search-list-tabs-bar[_ngcontent-%COMP%]   .gsc-search-button-v2[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:var(--secondary-font-color);width:18px;height:25px}.search-list-tabs-bar[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{vertical-align:text-bottom}.global-search-input[_ngcontent-%COMP%]{border:1px solid var(--default-font-color)!important}.search-list-tabs-bar[_ngcontent-%COMP%]   .search-button[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap}.search-list-tabs-bar[_ngcontent-%COMP%]   .tab-children[_ngcontent-%COMP%]{border:1px solid var(--default-font-color);margin-bottom:1em;padding:1em;border-bottom-left-radius:.2rem;border-bottom-right-radius:.2rem;display:flex;flex-direction:column}.child-checkbox[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:baseline}.child-checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-left:.5em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchListComponent, [{
        type: Component,
        args: [{ selector: 'search-list', standalone: false, template: "<div class=\"mt-4\" *ngIf=\"pageReady\">\r\n    <div class=\"mb-2\" *ngIf=\"!template\">\r\n        <div class=\"mb-2\">\r\n          <fi-filter [space]=\"space\" [collection]=\"name\" [collectionForm]=\"collectionForm\" [data]=\"resultList\"></fi-filter>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" *ngIf=\"!template\">  \r\n        <div class=\"col-md-12\">  \r\n          <fi-search-pills [space]=\"space\" [collection]=\"collection\" [collectionForm]=\"collectionForm\" [data]=\"resultList\"></fi-search-pills>\r\n        </div> \r\n        <div class=\"col-md-2\">  \r\n          <fi-filter-terms [space]=\"space\" [collection]=\"collection\" [collectionForm]=\"collectionForm\" [data]=\"resultList\"></fi-filter-terms>  \r\n        </div>  \r\n        <div ngClass=\"{{ (collectionForm.formConfig.viewConfig?.showFilterTerms && aggregations && aggregations.length > 0 ? 'col-md-10' : 'col-md-12') + ' results' }}\">  \r\n          <div class=\"row spinner\" *ngIf=\"loading\">\r\n            <div class=\"col-md-12 mb-3 align-center\">\r\n              <div class=\"spinner-border\" role=\"status\">\r\n                <span class=\"sr-only\">{{ configService.getTranslation('common.loading')}}</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <fi-list [enableClick]=\"enableClick\" (onClick)=\"resultClick($event)\" [space]=\"space\" [collection]=\"collection\" [collectionForm]=\"collectionForm\" [data]=\"resultList\"></fi-list>  \r\n        </div>\r\n    </div>\r\n    <div class=\"row\" *ngIf=\"template\">\r\n      <div class=\"col-md-12\">\r\n        <fi-template-renderer\r\n          [space]=\"space\"\r\n          [collection]=\"collection\"\r\n          [collectionForm]=\"collectionForm\"\r\n          [template]=\"template\" \r\n          [data]=\"resultList\"\r\n          [styles]=\"collectionForm.form.stylesheet\">\r\n        </fi-template-renderer>\r\n      </div>\r\n    </div>\r\n</div>", styles: [".search-list-tabs-bar{margin-bottom:1em;display:flex;flex-grow:1;flex-wrap:nowrap;align-items:flex-end}.search-list-tabs-bar .search-tab{width:100%}.search-list-tabs-bar button{background-color:var(--primary-color)!important;border-color:var(--primary-color)!important;color:var(--secondary-font-color)!important;padding:.2rem!important;font-size:1rem!important;border-radius:.25rem!important;width:40px;margin-right:3px!important;margin-left:3px!important;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.search-list-tabs-bar .gsc-search-button-v2 svg{fill:var(--secondary-font-color);width:18px;height:25px}.search-list-tabs-bar i{vertical-align:text-bottom}.global-search-input{border:1px solid var(--default-font-color)!important}.search-list-tabs-bar .search-button{display:flex;flex-wrap:nowrap}.search-list-tabs-bar .tab-children{border:1px solid var(--default-font-color);margin-bottom:1em;padding:1em;border-bottom-left-radius:.2rem;border-bottom-right-radius:.2rem;display:flex;flex-direction:column}.child-checkbox{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:baseline}.child-checkbox label{margin-left:.5em}\n"] }]
    }], () => [{ type: i1.SearchService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.UtilsService }, { type: i1.ConfigurationService }, { type: i1.DynamicFormControlService }, { type: i0.ElementRef }, { type: i1.CollectionService }, { type: i3$2.ConfirmationService }, { type: UserselectionService }, { type: i1.WorkspaceService }, { type: i1.TemplateService }, { type: i1.PropertiesService }, { type: i1.ListConfigService }, { type: FormDataService }, { type: i1$1.DialogService }, { type: i1.MapService }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], collectionForm: [{
            type: Input
        }], listTemplate: [{
            type: Input
        }], listConfig: [{
            type: Input
        }], showsearchbar: [{
            type: Input
        }], showadvancedsearchbar: [{
            type: Input
        }], showfilterterms: [{
            type: Input
        }], resultsonload: [{
            type: Input
        }], displaycolumns: [{
            type: Input
        }], allowredirect: [{
            type: Input
        }], size: [{
            type: Input
        }], advanced: [{
            type: Input
        }], query: [{
            type: Input
        }], q: [{
            type: Input
        }], filter: [{
            type: Input
        }], f: [{
            type: Input
        }], sort: [{
            type: Input
        }], additional: [{
            type: Input
        }], options: [{
            type: Input
        }], o: [{
            type: Input
        }], target: [{
            type: Input
        }], langs: [{
            type: Input
        }], enableClick: [{
            type: Input
        }], onClick: [{
            type: Output
        }], dataReady: [{
            type: Output
        }], resultListReady: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SearchListComponent, { className: "SearchListComponent", filePath: "src/components/search-list/search-list.component.ts", lineNumber: 18 }); })();

function HtmlEditorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "ngx-monaco-editor", 3);
    i0.ɵɵtwoWayListener("ngModelChange", function HtmlEditorComponent_div_1_Template_ngx_monaco_editor_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.value, $event) || (ctx_r1.value = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r1.editorOptions);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.value);
} }
function HtmlEditorComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
} }
class HtmlEditorComponent {
    set id(value) {
        this._ID = value;
        this.externalId = null;
    }
    get id() {
        return this._ID;
    }
    get value() {
        return this._value;
    }
    set value(val) {
        if (this.mode === "json" && typeof (val) === "object") {
            this._value = val > "" ? JSON.stringify(val) : null;
        }
        else {
            this._value = val;
        }
        this.onChange(val);
        this.onTouched();
    }
    constructor() {
        this.theme = 'material';
        this.readOnly = false;
        this.lineNumbers = true;
        this.mode = 'html';
        this.view = 'detail';
        this.editorOptions = {
            theme: 'vs-dark',
            language: this.mode,
            "semanticHighlighting.enabled": true,
            wordWrap: "on",
            automaticLayout: true,
            mouseWheelZoom: true,
            autoIndent: "full",
            autoClosingBrackets: "always",
            autoClosingComments: "always",
            autoClosingQuotes: "always",
            formatOnPaste: true
        };
        this.externalId = '';
        this._ID = '';
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    ngOnInit() {
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    static { this.ɵfac = function HtmlEditorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HtmlEditorComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HtmlEditorComponent, selectors: [["html-editor"]], hostVars: 1, hostBindings: function HtmlEditorComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵattribute("id", ctx.externalId);
        } }, inputs: { theme: "theme", readOnly: "readOnly", lineNumbers: "lineNumbers", mode: "mode", view: "view", _value: [0, "value", "_value"], id: "id" }, standalone: false, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => HtmlEditorComponent),
                    multi: true,
                }
            ])], decls: 3, vars: 2, consts: [[1, "row"], ["class", "col-md-12", 4, "ngIf"], [1, "col-md-12"], [3, "ngModelChange", "options", "ngModel"]], template: function HtmlEditorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, HtmlEditorComponent_div_1_Template, 2, 2, "div", 1)(2, HtmlEditorComponent_div_2_Template, 1, 0, "div", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.view === "detail");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.view === "list");
        } }, dependencies: [i3.NgIf, i5.NgControlStatus, i5.NgModel, i3$4.EditorComponent], styles: ["textarea[_ngcontent-%COMP%]{width:100%!important;height:500px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HtmlEditorComponent, [{
        type: Component,
        args: [{ selector: 'html-editor', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => HtmlEditorComponent),
                        multi: true,
                    }
                ], standalone: false, template: "<div class=\"row\">\r\n  <div class=\"col-md-12\" *ngIf=\"view === 'detail'\">   \r\n    <ngx-monaco-editor [options]=\"editorOptions\" [(ngModel)]=\"value\"></ngx-monaco-editor>\r\n  </div>\r\n  <div class=\"col-md-12\" *ngIf=\"view === 'list'\">\r\n  </div>\r\n</div>", styles: ["textarea{width:100%!important;height:500px}\n"] }]
    }], () => [], { theme: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], lineNumbers: [{
            type: Input
        }], mode: [{
            type: Input
        }], view: [{
            type: Input
        }], _value: [{
            type: Input,
            args: ['value']
        }], externalId: [{
            type: HostBinding,
            args: ['attr.id']
        }], id: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(HtmlEditorComponent, { className: "HtmlEditorComponent", filePath: "src/components/html-editor/html-editor.component.ts", lineNumber: 17 }); })();

function ErrorLogComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "h6");
    i0.ɵɵtext(2, "Latest error");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5)(4, "label");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.errorHandler.messages[ctx_r0.errorHandler.messages.length - 1]);
} }
function ErrorLogComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "label", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "\u00A0-\u00A0");
    i0.ɵɵelementStart(4, "label");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const msg_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i_r3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(msg_r2);
} }
class ErrorLogComponent {
    constructor(errorHandler) {
        this.errorHandler = errorHandler;
    }
    static { this.ɵfac = function ErrorLogComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ErrorLogComponent)(i0.ɵɵdirectiveInject(i1.ErrorHandlerService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ErrorLogComponent, selectors: [["lightforms-error-log"]], standalone: false, decls: 6, vars: 2, consts: [[1, "row"], ["class", "col-md-12 mb-2", 4, "ngIf"], [1, "col-md-12"], ["class", "message-row", 4, "ngFor", "ngForOf"], [1, "col-md-12", "mb-2"], [1, "message-row", "latest"], [1, "message-row"], [1, "index"]], template: function ErrorLogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ErrorLogComponent_div_1_Template, 6, 1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "h6");
            i0.ɵɵtext(4, "History");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, ErrorLogComponent_div_5_Template, 6, 2, "div", 3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.errorHandler.messages.length > 0);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.errorHandler.messages.slice().reverse());
        } }, dependencies: [i3.NgForOf, i3.NgIf], styles: [".message-row[_ngcontent-%COMP%]{display:flex;border-bottom:solid 1px var(--default-border-color);padding-bottom:1em;margin-bottom:1em}.message-row.latest[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:var(--danger-color)}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorLogComponent, [{
        type: Component,
        args: [{ selector: 'lightforms-error-log', standalone: false, template: "<div class=\"row\">\r\n    <div class=\"col-md-12 mb-2\" *ngIf=\"errorHandler.messages.length > 0\">\r\n        <h6>Latest error</h6>\r\n        <div class=\"message-row latest\">\r\n            <label>{{errorHandler.messages[errorHandler.messages.length-1]}}</label>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-12\">\r\n        <h6>History</h6>\r\n        <div class=\"message-row\" *ngFor=\"let msg of errorHandler.messages.slice().reverse(); let i=index\">\r\n            <label class=\"index\">{{i}}</label>&nbsp;-&nbsp;<label>{{msg}}</label>\r\n        </div>\r\n    </div>\r\n</div>", styles: [".message-row{display:flex;border-bottom:solid 1px var(--default-border-color);padding-bottom:1em;margin-bottom:1em}.message-row.latest label{color:var(--danger-color)}\n"] }]
    }], () => [{ type: i1.ErrorHandlerService }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ErrorLogComponent, { className: "ErrorLogComponent", filePath: "src/components/error-log/error-log.component.ts", lineNumber: 10 }); })();

class ErrorLogIconComponent {
    constructor(errorHandler, dialogService) {
        this.errorHandler = errorHandler;
        this.dialogService = dialogService;
    }
    getErrorsCount() {
        if (this.errorHandler.messages) {
            return this.errorHandler.messages.length.toString();
        }
        else {
            return "0";
        }
    }
    openErrors() {
        this.dialogService.open(ErrorLogComponent, {
            header: 'Errors log',
            width: '70vw',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    static { this.ɵfac = function ErrorLogIconComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ErrorLogIconComponent)(i0.ɵɵdirectiveInject(i1.ErrorHandlerService), i0.ɵɵdirectiveInject(i1$1.DialogService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ErrorLogIconComponent, selectors: [["error-log-icon"]], standalone: false, decls: 1, vars: 2, consts: [["icon", "pi pi-bell", "severity", "info", 3, "onClick", "rounded", "pTooltip"]], template: function ErrorLogIconComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "p-button", 0);
            i0.ɵɵlistener("onClick", function ErrorLogIconComponent_Template_p_button_onClick_0_listener() { return ctx.openErrors(); });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵpropertyInterpolate("pTooltip", ctx.getErrorsCount());
            i0.ɵɵproperty("rounded", true);
        } }, dependencies: [i7.Button, i4$2.Tooltip], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorLogIconComponent, [{
        type: Component,
        args: [{ selector: 'error-log-icon', standalone: false, template: "<p-button icon=\"pi pi-bell\" [rounded]=\"true\" pTooltip=\"{{getErrorsCount()}}\" severity=\"info\" (onClick)=\"openErrors()\"></p-button>" }]
    }], () => [{ type: i1.ErrorHandlerService }, { type: i1$1.DialogService }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ErrorLogIconComponent, { className: "ErrorLogIconComponent", filePath: "src/components/error-log-icon/error-log-icon.component.ts", lineNumber: 12 }); })();

function DynamicFormKeyselectView_p_fieldset_0_ng_template_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵelementEnd();
} }
function DynamicFormKeyselectView_p_fieldset_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormKeyselectView_p_fieldset_0_ng_template_1_span_3_Template, 2, 0, "span", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
} }
function DynamicFormKeyselectView_p_fieldset_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17);
    i0.ɵɵelement(2, "html-renderer", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("template", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp"));
} }
function DynamicFormKeyselectView_p_fieldset_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "debug-details", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("data", ctx_r0.form.getRawValue())("xpath", ctx_r0.xpath);
} }
function DynamicFormKeyselectView_p_fieldset_0_div_5_dynamic_form_switcher_view_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "dynamic-form-switcher-view", 22);
} if (rf & 2) {
    const child_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", child_r2.type === "separator" ? "separator" : "")("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", child_r2)("parentDynamicFormObject", ctx_r0.dynamicFormObject)("form", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code])("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("readonly", ctx_r0.readonly)("hideLabel", ctx_r0.hideLabel)("statuses", ctx_r0.statuses)("status", ctx_r0.status);
} }
function DynamicFormKeyselectView_p_fieldset_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, DynamicFormKeyselectView_p_fieldset_0_div_5_dynamic_form_switcher_view_1_Template, 1, 13, "dynamic-form-switcher-view", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.group || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.dynamicFormService.getComponentChildren(ctx_r0.dynamicFormObject));
} }
function DynamicFormKeyselectView_p_fieldset_0_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", child_r3.type === "separator" ? "separator" : "")("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", child_r3)("parentDynamicFormObject", ctx_r0.dynamicFormObject)("form", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code])("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("readonly", ctx_r0.readonly)("hideLabel", ctx_r0.hideLabel)("statuses", ctx_r0.statuses)("status", ctx_r0.status);
} }
function DynamicFormKeyselectView_p_fieldset_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24);
    i0.ɵɵtemplate(2, DynamicFormKeyselectView_p_fieldset_0_div_6_div_2_Template, 2, 13, "div", 25);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.group || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.dynamicFormService.getComponentChildren(ctx_r0.dynamicFormObject));
} }
function DynamicFormKeyselectView_p_fieldset_0_ng_container_7_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "div", 3)(2, "div", 24)(3, "div", 33)(4, "label", 34);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const child_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", child_r4.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, child_r4, "label"), "");
} }
function DynamicFormKeyselectView_p_fieldset_0_ng_container_7_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormKeyselectView_p_fieldset_0_ng_container_7_ng_container_3_div_1_Template, 6, 2, "div", 31);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getComponentClass(ctx_r0.parentForm || ctx_r0.form, ctx_r0.dynamicForm, child_r4, ctx_r0.xpath, ctx_r0.debug) !== "hidden");
} }
function DynamicFormKeyselectView_p_fieldset_0_ng_container_7_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", child_r5.type === "separator" ? "separator" : "")("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", child_r5)("parentDynamicFormObject", ctx_r0.dynamicFormObject)("form", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code])("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("readonly", ctx_r0.readonly)("hideLabel", true)("statuses", ctx_r0.statuses)("status", ctx_r0.status);
} }
function DynamicFormKeyselectView_p_fieldset_0_ng_container_7_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormKeyselectView_p_fieldset_0_ng_container_7_ng_container_6_div_1_Template, 2, 13, "div", 35);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getComponentClass(ctx_r0.parentForm || ctx_r0.form, ctx_r0.dynamicForm, child_r5, ctx_r0.xpath, ctx_r0.debug) !== "hidden");
} }
function DynamicFormKeyselectView_p_fieldset_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 26);
    i0.ɵɵelementStart(1, "div", 27)(2, "div", 28);
    i0.ɵɵtemplate(3, DynamicFormKeyselectView_p_fieldset_0_ng_container_7_ng_container_3_Template, 2, 1, "ng-container", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 29)(5, "div", 30);
    i0.ɵɵtemplate(6, DynamicFormKeyselectView_p_fieldset_0_ng_container_7_ng_container_6_Template, 2, 1, "ng-container", 25);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.dynamicFormService.getComponentChildren(ctx_r0.dynamicFormObject));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.dynamicFormService.getComponentChildren(ctx_r0.dynamicFormObject));
} }
function DynamicFormKeyselectView_p_fieldset_0_p_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 37);
    i0.ɵɵlistener("click", function DynamicFormKeyselectView_p_fieldset_0_p_button_10_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function DynamicFormKeyselectView_p_fieldset_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-fieldset", 1);
    i0.ɵɵtemplate(1, DynamicFormKeyselectView_p_fieldset_0_ng_template_1_Template, 4, 2, "ng-template", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, DynamicFormKeyselectView_p_fieldset_0_div_3_Template, 3, 1, "div", 4)(4, DynamicFormKeyselectView_p_fieldset_0_div_4_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DynamicFormKeyselectView_p_fieldset_0_div_5_Template, 2, 2, "div", 5)(6, DynamicFormKeyselectView_p_fieldset_0_div_6_Template, 3, 2, "div", 6)(7, DynamicFormKeyselectView_p_fieldset_0_ng_container_7_Template, 7, 2, "ng-container", 7);
    i0.ɵɵelementStart(8, "div", 8)(9, "div", 9);
    i0.ɵɵtemplate(10, DynamicFormKeyselectView_p_fieldset_0_p_button_10_Template, 1, 2, "p-button", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "div", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("collapsed", ctx_r0.dynamicFormObject.collapsed)("toggleable", true)("formGroup", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code])("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.group || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp") > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.debug);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.format === "float");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.dynamicFormObject.format || ctx_r0.dynamicFormObject.format === "vertical");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.format === "horizontal");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_template_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵelementEnd();
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormKeyselectView_p_fieldset_1_ng_template_1_span_3_Template, 2, 0, "span", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
} }
function DynamicFormKeyselectView_p_fieldset_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17);
    i0.ɵɵelement(2, "html-renderer", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("template", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp"));
} }
function DynamicFormKeyselectView_p_fieldset_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "debug-details", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("data", ctx_r0.form.getRawValue())("xpath", ctx_r0.xpath);
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_5_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44)(1, "button", 45);
    i0.ɵɵlistener("click", function DynamicFormKeyselectView_p_fieldset_1_ng_container_5_div_1_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r7); const arrayGroupElementIndex_r8 = i0.ɵɵnextContext().index; const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.removeFormArrayElement(arrayGroupElementIndex_r8)); });
    i0.ɵɵelement(2, "i", 46);
    i0.ɵɵelementEnd()();
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_5_div_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const arrayGroupElementIndex_r8 = i0.ɵɵnextContext().index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getHeader(ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, ctx_r0.form.controls[ctx_r0.dynamicFormObject.code]["controls"][arrayGroupElementIndex_r8].value, null));
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_5_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r9 = ctx.$implicit;
    const arrayGroupElement_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", child_r9.type === "separator" ? "separator" : "")("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", child_r9)("parentDynamicFormObject", ctx_r0.dynamicFormObject)("form", arrayGroupElement_r10)("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("readonly", ctx_r0.readonly)("hideLabel", ctx_r0.hideLabel)("statuses", ctx_r0.statuses)("status", ctx_r0.status);
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_5_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "form-errors-manager", 48);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const arrayGroupElement_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("errors", arrayGroupElement_r10.errors)("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject);
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, DynamicFormKeyselectView_p_fieldset_1_ng_container_5_div_1_div_1_Template, 3, 0, "div", 41);
    i0.ɵɵelementStart(2, "div", 42)(3, "p-panel", 43);
    i0.ɵɵtemplate(4, DynamicFormKeyselectView_p_fieldset_1_ng_container_5_div_1_ng_template_4_Template, 3, 1, "ng-template", 2)(5, DynamicFormKeyselectView_p_fieldset_1_ng_container_5_div_1_div_5_Template, 2, 13, "div", 25)(6, DynamicFormKeyselectView_p_fieldset_1_ng_container_5_div_1_div_6_Template, 2, 3, "div", 38);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const arrayGroupElement_r10 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly || ctx_r0.operation === "edit" && !ctx_r0.dynamicFormObject.editBlocked);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("toggleable", true)("collapsed", ctx_r0.dynamicFormObject.collapsed);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.dynamicFormService.getComponentChildren(ctx_r0.dynamicFormObject));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", arrayGroupElement_r10.errors);
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormKeyselectView_p_fieldset_1_ng_container_5_div_1_Template, 7, 5, "div", 40);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code]["controls"]);
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 32);
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "div", 3)(2, "div", 24)(3, "div", 33)(4, "label", 34);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const child_r11 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", child_r11.pathId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, child_r11, "label"), "");
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 54)(1, "button", 45);
    i0.ɵɵlistener("click", function DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_6_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r12); const arrayGroupElementIndex_r13 = i0.ɵɵnextContext().index; const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.removeFormArrayElement(arrayGroupElementIndex_r13)); });
    i0.ɵɵelement(2, "i", 46);
    i0.ɵɵelementEnd()();
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "dynamic-form-switcher-view", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r14 = ctx.$implicit;
    const arrayGroupElement_r15 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", child_r14.type === "separator" ? "separator" : "")("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", child_r14)("parentDynamicFormObject", ctx_r0.dynamicFormObject)("form", arrayGroupElement_r15)("parentForm", ctx_r0.parentForm)("operation", ctx_r0.operation)("debug", ctx_r0.debug)("xpath", ctx_r0.xpath)("readonly", ctx_r0.readonly)("hideLabel", true)("statuses", ctx_r0.statuses)("status", ctx_r0.status);
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_6_div_1_Template, 3, 0, "div", 52)(2, DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_6_div_2_Template, 2, 13, "div", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly || ctx_r0.operation === "edit" && !ctx_r0.dynamicFormObject.editBlocked);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.dynamicFormService.getComponentChildren(ctx_r0.dynamicFormObject));
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵtext(1, " No data found ");
    i0.ɵɵelementEnd();
} }
function DynamicFormKeyselectView_p_fieldset_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 26);
    i0.ɵɵelementStart(1, "div", 27)(2, "div", 28);
    i0.ɵɵtemplate(3, DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_3_Template, 1, 0, "div", 31)(4, DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_4_Template, 6, 2, "div", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 29);
    i0.ɵɵtemplate(6, DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_6_Template, 3, 2, "div", 50);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, DynamicFormKeyselectView_p_fieldset_1_ng_container_6_div_7_Template, 2, 0, "div", 51);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly || ctx_r0.operation === "edit" && !ctx_r0.dynamicFormObject.editBlocked);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.dynamicFormService.getComponentChildren(ctx_r0.dynamicFormObject));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code]["controls"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code]["controls"].length === 0);
} }
function DynamicFormKeyselectView_p_fieldset_1_p_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 37);
    i0.ɵɵlistener("click", function DynamicFormKeyselectView_p_fieldset_1_p_button_9_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function DynamicFormKeyselectView_p_fieldset_1_p_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 56);
    i0.ɵɵlistener("click", function DynamicFormKeyselectView_p_fieldset_1_p_button_11_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.addFormArrayElement()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true);
} }
function DynamicFormKeyselectView_p_fieldset_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-fieldset", 1);
    i0.ɵɵtemplate(1, DynamicFormKeyselectView_p_fieldset_1_ng_template_1_Template, 4, 2, "ng-template", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, DynamicFormKeyselectView_p_fieldset_1_div_3_Template, 3, 1, "div", 4)(4, DynamicFormKeyselectView_p_fieldset_1_div_4_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DynamicFormKeyselectView_p_fieldset_1_ng_container_5_Template, 2, 1, "ng-container", 38)(6, DynamicFormKeyselectView_p_fieldset_1_ng_container_6_Template, 8, 4, "ng-container", 7);
    i0.ɵɵelementStart(7, "div", 8)(8, "div", 9);
    i0.ɵɵtemplate(9, DynamicFormKeyselectView_p_fieldset_1_p_button_9_Template, 1, 2, "p-button", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 11);
    i0.ɵɵtemplate(11, DynamicFormKeyselectView_p_fieldset_1_p_button_11_Template, 1, 1, "p-button", 39);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("collapsed", ctx_r0.dynamicFormObject.collapsed)("toggleable", true)("formGroup", ctx_r0.form)("ngClass", ctx_r0.dynamicForm.cssClass && ctx_r0.dynamicForm.cssClass.group || ctx_r0.dynamicFormObject.cssClass);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp") > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.debug);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.dynamicFormObject.format || ctx_r0.dynamicFormObject.format === "vertical" || ctx_r0.dynamicFormObject.format === "float");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.format === "horizontal");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly || ctx_r0.operation === "edit" && !ctx_r0.dynamicFormObject.editBlocked);
} }
class DynamicFormKeyselectView {
    constructor(dynamicFormService, dynamicFormControlService, dialogService, router, formDataService, confirmationService, route) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.dialogService = dialogService;
        this.router = router;
        this.formDataService = formDataService;
        this.confirmationService = confirmationService;
        this.route = route;
        this.debug = false;
        this.readonly = false;
        this.nextForm = new EventEmitter();
    }
    ngOnInit() {
        this.xpath = this.dynamicFormControlService.getXpath(this.dynamicFormObject, this.xpath);
        this.dynamicFormObject.components = this.dynamicFormControlService.getKeyselectComponents(this.xpath);
        this.subpath = this.router.url.substring(this.router.url.indexOf('/admin') + 7);
        this.subpath = this.subpath.substring(0, this.subpath.indexOf('/'));
        this.route.queryParams.subscribe(params => {
            this.queryParams = params;
        });
    }
    ngAfterViewInit() {
        if (this.operation === 'new' && !this.dynamicFormObject.collapsed) {
            this.addFormArrayElement();
        }
    }
    showHelp(description) {
        const ref = this.dialogService.open(HelpComponent, {
            data: {
                description: description
            },
            header: 'Help',
            width: '50%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    addFormArrayElement(keyboard) {
        if (!keyboard || (keyboard && keyboard.keyCode === 9)) {
            let fa = this.form.controls[this.dynamicFormObject.code];
            if (!isNaN(fa.value.length)) {
                fa.push(this.dynamicFormControlService.formObjectsToFormGroup(this.dynamicForm, this.operation, this.dynamicFormService.getComponentChildren(this.dynamicFormObject), null, this.xpath));
            }
        }
    }
    removeFormArrayElement(i) {
        let fa = this.form.controls[this.dynamicFormObject.code];
        fa.removeAt(i);
    }
    static { this.ɵfac = function DynamicFormKeyselectView_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormKeyselectView)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(i2.ActivatedRoute)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormKeyselectView, selectors: [["dynamic-form-keyselect-view"]], inputs: { group: "group", statuses: "statuses", status: "status", dynamicForm: "dynamicForm", parentDynamicForm: "parentDynamicForm", dynamicFormObject: "dynamicFormObject", parentDynamicFormObject: "parentDynamicFormObject", form: "form", parentForm: "parentForm", debug: "debug", readonly: "readonly", operation: "operation", xpath: "xpath", hideLabel: "hideLabel" }, outputs: { nextForm: "nextForm" }, standalone: false, decls: 2, vars: 2, consts: [[3, "collapsed", "toggleable", "formGroup", "ngClass", 4, "ngIf"], [3, "collapsed", "toggleable", "formGroup", "ngClass"], ["pTemplate", "header"], [1, "row"], ["class", "col-md-12 mt-2 mb-2", 4, "ngIf"], ["class", "float form-group-children", 3, "ngClass", 4, "ngIf"], ["class", "row form-group-children", 3, "ngClass", 4, "ngIf"], ["class", "form-array-item", 4, "ngIf"], [1, "row", "mt-3"], [1, "col-md-6"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "rounded", "outlined", "click", 4, "ngIf"], [1, "col-md-6", "align-right"], [1, "flex", "align-items-center"], ["class", "mandatory", 4, "ngIf"], [1, "mandatory"], [1, "bi", "bi-asterisk"], [1, "col-md-12", "mt-2", "mb-2"], [1, "form-control-footer", "text-color-gray-medium"], [3, "template"], [3, "dynamicForm", "dynamicFormObject", "data", "xpath"], [1, "float", "form-group-children", 3, "ngClass"], [3, "ngClass", "dynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "debug", "xpath", "readonly", "hideLabel", "statuses", "status", 4, "ngFor", "ngForOf"], [3, "ngClass", "dynamicForm", "dynamicFormObject", "parentDynamicFormObject", "form", "parentForm", "operation", "debug", "xpath", "readonly", "hideLabel", "statuses", "status"], [1, "row", "form-group-children", 3, "ngClass"], [1, "col-md-12"], [4, "ngFor", "ngForOf"], [1, "form-array-item"], [1, "layout-table"], [1, "layout-table-header"], [1, "layout-table-body"], [1, "layout-table-row"], ["class", "layout-table-header-item", 4, "ngIf"], [1, "layout-table-header-item"], [1, "component-header"], [1, "component-label", "text-color-gray-medium", "horizontal", 3, "id"], ["class", "layout-table-cell", 4, "ngIf"], [1, "layout-table-cell"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "click", "rounded", "outlined"], [4, "ngIf"], ["icon", "pi pi-plus", 3, "rounded", "click", 4, "ngIf"], ["class", "form-array-item", 4, "ngFor", "ngForOf"], ["class", "form-array-item-actions", 4, "ngIf"], [1, "form-array-item-content"], [3, "toggleable", "collapsed"], [1, "form-array-item-actions"], ["title", "Remove item", "type", "button", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-trash"], [1, "form-array-item-header"], [3, "errors", "dynamicForm", "dynamicFormObject"], ["class", "layout-table-header-item", 4, "ngFor", "ngForOf"], ["class", "layout-table-row", 4, "ngFor", "ngForOf"], ["class", "no-data-found", 4, "ngIf"], ["class", "layout-table-cell buttons", 4, "ngIf"], ["class", "layout-table-cell", 4, "ngFor", "ngForOf"], [1, "layout-table-cell", "buttons"], [1, "no-data-found"], ["icon", "pi pi-plus", 3, "click", "rounded"]], template: function DynamicFormKeyselectView_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicFormKeyselectView_p_fieldset_0_Template, 12, 10, "p-fieldset", 0)(1, DynamicFormKeyselectView_p_fieldset_1_Template, 12, 10, "p-fieldset", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.dynamicFormObject.multipleValues);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dynamicFormObject.multipleValues);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormKeyselectView, [{
        type: Component,
        args: [{ selector: 'dynamic-form-keyselect-view', standalone: false, template: "<!-- Multiple values = false -->\r\n<p-fieldset [collapsed]=\"dynamicFormObject.collapsed\" [toggleable]=\"true\" *ngIf=\"!dynamicFormObject.multipleValues\" [formGroup]=\"$any(form.controls[dynamicFormObject.code])\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n\r\n    <ng-template pTemplate=\"header\">\r\n      <div class=\"flex align-items-center\">\r\n        <label>{{dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label')}}</label>\r\n        <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n      </div>\r\n    </ng-template>\r\n  \r\n    <div class=\"row\">\r\n      <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n        <div class=\"form-control-footer text-color-gray-medium\">\r\n          <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n        <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\" [xpath]=\"xpath\"></debug-details>\r\n      </div>\r\n    </div>\r\n  \r\n      <!-- Float layout -->\r\n      <div *ngIf=\"dynamicFormObject.format === 'float'\" class=\"float form-group-children\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n        <dynamic-form-switcher-view \r\n          *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\"\r\n          [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n          [dynamicForm]=\"dynamicForm\" \r\n          [dynamicFormObject]=\"child\" \r\n          [parentDynamicFormObject]=\"dynamicFormObject\" \r\n          [form]=\"$any(form.controls[dynamicFormObject.code])\" \r\n          [parentForm]=\"parentForm\"\r\n          [operation]=\"operation\"\r\n          [debug]=\"debug\"\r\n          [xpath]=\"xpath\"\r\n          [readonly]=\"readonly\"\r\n          [hideLabel]=\"hideLabel\"\r\n          [statuses]=\"statuses\"\r\n          [status]=\"status\">\r\n        </dynamic-form-switcher-view>\r\n      </div>\r\n  \r\n    <!-- Vertical layout -->\r\n    <div *ngIf=\"(!dynamicFormObject.format) || dynamicFormObject.format === 'vertical'\" class=\"row form-group-children\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n      <div class=\"col-md-12\">\r\n        <div *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n          <dynamic-form-switcher-view \r\n            [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n            [dynamicForm]=\"dynamicForm\" \r\n            [dynamicFormObject]=\"child\" \r\n            [parentDynamicFormObject]=\"dynamicFormObject\" \r\n            [form]=\"$any(form.controls[dynamicFormObject.code])\" \r\n            [parentForm]=\"parentForm\"\r\n            [operation]=\"operation\"\r\n            [debug]=\"debug\"\r\n            [xpath]=\"xpath\"\r\n            [readonly]=\"readonly\"\r\n            [hideLabel]=\"hideLabel\"\r\n            [statuses]=\"statuses\"\r\n            [status]=\"status\">\r\n          </dynamic-form-switcher-view>                \r\n        </div>     \r\n      </div>\r\n    </div>\r\n  \r\n    <!-- Horizontal layout -->\r\n    <ng-container *ngIf=\"dynamicFormObject.format === 'horizontal'\" class=\"form-array-item\">\r\n      <div class=\"layout-table\">\r\n        <div class=\"layout-table-header\">\r\n          <ng-container *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n            <div class=\"layout-table-header-item\" *ngIf=\"dynamicFormControlService.getComponentClass(parentForm || form, dynamicForm, child, xpath, debug) !== 'hidden'\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"component-header\">\r\n                    <label class=\"component-label text-color-gray-medium horizontal\" [id]=\"child.pathId\"> {{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, child, 'label') }}</label>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n        <div class=\"layout-table-body\">\r\n          <div class=\"layout-table-row\">\r\n            <ng-container *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n              <div class=\"layout-table-cell\" *ngIf=\"dynamicFormControlService.getComponentClass(parentForm || form, dynamicForm, child, xpath, debug) !== 'hidden'\">\r\n                <dynamic-form-switcher-view \r\n                  [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n                  [dynamicForm]=\"dynamicForm\" \r\n                  [dynamicFormObject]=\"child\" \r\n                  [parentDynamicFormObject]=\"dynamicFormObject\" \r\n                  [form]=\"$any(form.controls[dynamicFormObject.code])\" \r\n                  [parentForm]=\"parentForm\"\r\n                  [operation]=\"operation\"\r\n                  [debug]=\"debug\"\r\n                  [xpath]=\"xpath\"\r\n                  [readonly]=\"readonly\"\r\n                  [hideLabel]=\"true\"\r\n                  [statuses]=\"statuses\"\r\n                  [status]=\"status\">\r\n                </dynamic-form-switcher-view>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  \r\n    <div class=\"row mt-3\">\r\n      <div class=\"col-md-6\">\r\n        <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\" title=\"Help\"\r\n          (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\"></p-button>\r\n      </div>\r\n      <div class=\"col-md-6 align-right\">\r\n  \r\n      </div>\r\n    </div>\r\n  </p-fieldset>\r\n  \r\n  <!-- Multiple values = true -->\r\n  <p-fieldset [collapsed]=\"dynamicFormObject.collapsed\" [toggleable]=\"true\" *ngIf=\"dynamicFormObject.multipleValues\" [formGroup]=\"form\" [ngClass]=\"(dynamicForm.cssClass && dynamicForm.cssClass.group) || dynamicFormObject.cssClass\">\r\n  \r\n    <ng-template pTemplate=\"header\">\r\n      <div class=\"flex align-items-center\">\r\n        <label>{{dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label')}}</label>\r\n        <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n      </div>\r\n    </ng-template>\r\n  \r\n    <div class=\"row\">\r\n      <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n        <div class=\"form-control-footer text-color-gray-medium\">\r\n          <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n        <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\" [xpath]=\"xpath\"></debug-details>\r\n      </div>\r\n    </div>\r\n      \r\n    <!-- Vertical layout -->\r\n    <ng-container *ngIf=\"(!dynamicFormObject.format) || dynamicFormObject.format === 'vertical' || dynamicFormObject.format === 'float'\">\r\n  \r\n      <div class=\"form-array-item\" *ngFor=\"let arrayGroupElement of form.controls[dynamicFormObject.code]['controls']; let arrayGroupElementIndex=index\">\r\n        <div class=\"form-array-item-actions\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n          <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n            (click)=\"removeFormArrayElement(arrayGroupElementIndex)\">\r\n            <i class=\"bi bi-trash\"></i>\r\n          </button>\r\n        </div>\r\n        <div class=\"form-array-item-content\">\r\n  \r\n          <p-panel [toggleable]=\"true\" [collapsed]=\"dynamicFormObject.collapsed\">\r\n            <ng-template pTemplate=\"header\">\r\n              <!-- <span>[{{ arrayGroupElementIndex }}]&nbsp;</span> -->\r\n              <div class=\"form-array-item-header\"><label>{{ dynamicFormControlService.getHeader(dynamicForm, dynamicFormObject, form.controls[dynamicFormObject.code]['controls'][arrayGroupElementIndex].value,null) }}</label></div>\r\n            </ng-template>\r\n      \r\n            <div *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n              <dynamic-form-switcher-view \r\n                [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n                [dynamicForm]=\"dynamicForm\" \r\n                [dynamicFormObject]=\"child\" \r\n                [parentDynamicFormObject]=\"dynamicFormObject\" \r\n                [form]=\"arrayGroupElement\" \r\n                [parentForm]=\"parentForm\"\r\n                [operation]=\"operation\"\r\n                [debug]=\"debug\"\r\n                [xpath]=\"xpath\"\r\n                [readonly]=\"readonly\"\r\n                [hideLabel]=\"hideLabel\"\r\n                [statuses]=\"statuses\"\r\n                [status]=\"status\">\r\n              </dynamic-form-switcher-view>                \r\n            </div>\r\n  \r\n            <div *ngIf=\"arrayGroupElement.errors\">\r\n              <form-errors-manager [errors]=\"arrayGroupElement.errors\" [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\"></form-errors-manager>\r\n            </div>\r\n  \r\n          </p-panel>\r\n  \r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  \r\n    <!-- Horizontal layout -->\r\n    <ng-container *ngIf=\"dynamicFormObject.format === 'horizontal'\" class=\"form-array-item\">\r\n      <div class=\"layout-table\">\r\n        <div class=\"layout-table-header\">\r\n          <div class=\"layout-table-header-item\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n  \r\n          </div>\r\n          <div class=\"layout-table-header-item\"  *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"component-header\">\r\n                  <label class=\"component-label text-color-gray-medium horizontal\" [id]=\"child.pathId\"> {{ dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, child, 'label') }}</label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"layout-table-body\">        \r\n          <div class=\"layout-table-row\" *ngFor=\"let arrayGroupElement of form.controls[dynamicFormObject.code]['controls']; let arrayGroupElementIndex=index\">\r\n            <div class=\"layout-table-cell buttons\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n              <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n                (click)=\"removeFormArrayElement(arrayGroupElementIndex)\">\r\n                <i class=\"bi bi-trash\"></i>\r\n              </button>\r\n            </div>\r\n            <div class=\"layout-table-cell\" *ngFor=\"let child of (dynamicFormService.getComponentChildren(dynamicFormObject))\">\r\n              <dynamic-form-switcher-view \r\n                [ngClass]=\"child.type==='separator' ? 'separator' : ''\"\r\n                [dynamicForm]=\"dynamicForm\" \r\n                [dynamicFormObject]=\"child\" \r\n                [parentDynamicFormObject]=\"dynamicFormObject\" \r\n                [form]=\"arrayGroupElement\" \r\n                [parentForm]=\"parentForm\"\r\n                [operation]=\"operation\"\r\n                [debug]=\"debug\"\r\n                [xpath]=\"xpath\"\r\n                [readonly]=\"readonly\"\r\n                [hideLabel]=\"true\"\r\n                [statuses]=\"statuses\"\r\n                [status]=\"status\">\r\n              </dynamic-form-switcher-view>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n  \r\n      <div class=\"no-data-found\" *ngIf=\"form.controls[dynamicFormObject.code]['controls'].length === 0\">\r\n        No data found\r\n      </div>\r\n    </ng-container>\r\n  \r\n    <div class=\"row mt-3\">\r\n      <div class=\"col-md-6\">\r\n        <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\" title=\"Help\"\r\n          (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\"></p-button>\r\n      </div>\r\n      <div class=\"col-md-6 align-right\">\r\n        <p-button *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\" icon=\"pi pi-plus\" [rounded]=\"true\" (click)=\"addFormArrayElement()\"></p-button>\r\n      </div>\r\n    </div>\r\n  \r\n  </p-fieldset>" }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i1$1.DialogService }, { type: i2.Router }, { type: FormDataService }, { type: i3$2.ConfirmationService }, { type: i2.ActivatedRoute }], { group: [{
            type: Input
        }], statuses: [{
            type: Input
        }], status: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], parentDynamicForm: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], parentDynamicFormObject: [{
            type: Input
        }], form: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], debug: [{
            type: Input
        }], readonly: [{
            type: Input
        }], operation: [{
            type: Input
        }], xpath: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], nextForm: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormKeyselectView, { className: "DynamicFormKeyselectView", filePath: "src/dynamic-form/dynamic-form-keyselect/dynamic-form-keyselect.component.ts", lineNumber: 18 }); })();

class FullscreenDirective {
    set fullscreen(element) {
        if (element instanceof ElementRef) {
            this.element = element.nativeElement;
        }
        else if (element instanceof HTMLElement) {
            this.element = element;
        }
        else if (element === '') {
            this.element = this.doc.documentElement;
        }
        else {
            throw new Error(`Only type HTMLElement or string allowed, got "${typeof element}".`);
        }
    }
    get fullscreen() {
        return this.element;
    }
    get isFullscreen() {
        return this.isFullscreenEnabled();
    }
    onTransition() {
        const isFullscreen = this.isFullscreen;
        const element = this.element;
        this.change.emit({ isFullscreen, element });
    }
    constructor(doc) {
        this.doc = doc;
        this.change = new EventEmitter();
    }
    async enter() {
        if (this.fullscreen) {
            await this.enterElementFullscreen(this.fullscreen);
        }
        else {
            await this.enterDocumentFullscreen();
        }
    }
    async exit() {
        if (this.fullscreen) {
            await this.exitElementFullscreen();
        }
        else {
            await this.exitDocumentFullscreen();
        }
    }
    toggle() {
        if (this.isFullscreen) {
            this.exit();
        }
        else {
            this.enter();
        }
    }
    async enterDocumentFullscreen() {
        const elem = this.doc.documentElement;
        await this.enterFullscreen(elem);
    }
    async exitDocumentFullscreen() {
        await this.exitFullscreen();
    }
    async enterElementFullscreen(elem) {
        await this.enterFullscreen(elem);
    }
    async exitElementFullscreen() {
        await this.exitFullscreen();
    }
    async enterFullscreen(elem) {
        await (elem.requestFullscreen?.() ||
            elem.webkitRequestFullscreen?.() ||
            elem.mozRequestFullScreen?.() ||
            elem.msRequestFullscreen?.());
    }
    async exitFullscreen() {
        await (this.doc.exitFullscreen?.() ||
            this.doc.webkitExitFullscreen?.() ||
            this.doc.mozCancelFullScreen?.() ||
            this.doc.msExitFullscreen?.());
    }
    isFullscreenEnabled() {
        return !!(this.doc.fullscreenElement ||
            this.doc.webkitFullscreenElement ||
            this.doc.mozFullScreenElement ||
            this.doc.msFullscreenElement);
    }
    static { this.ɵfac = function FullscreenDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FullscreenDirective)(i0.ɵɵdirectiveInject(DOCUMENT)); }; }
    static { this.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FullscreenDirective, selectors: [["", "fullscreen", ""]], hostVars: 2, hostBindings: function FullscreenDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("fullscreenchange", function FullscreenDirective_fullscreenchange_HostBindingHandler() { return ctx.onTransition(); }, false, i0.ɵɵresolveDocument);
        } if (rf & 2) {
            i0.ɵɵclassProp("fullscreen", ctx.isFullscreen);
        } }, inputs: { fullscreen: "fullscreen" }, outputs: { change: "change" }, exportAs: ["fullscreen"], standalone: false }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FullscreenDirective, [{
        type: Directive,
        args: [{
                selector: '[fullscreen]',
                exportAs: 'fullscreen',
                standalone: false
            }]
    }], () => [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }], { fullscreen: [{
            type: Input
        }], isFullscreen: [{
            type: HostBinding,
            args: ['class.fullscreen']
        }], onTransition: [{
            type: HostListener,
            args: ['document:fullscreenchange']
        }], change: [{
            type: Output
        }] }); })();

function LevelComponent_ng_container_0_ng_container_1_ng_container_3_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 7);
} }
function LevelComponent_ng_container_0_ng_container_1_ng_container_3_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 8);
} }
function LevelComponent_ng_container_0_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LevelComponent_ng_container_0_ng_container_1_ng_container_3_i_1_Template, 1, 0, "i", 5)(2, LevelComponent_ng_container_0_ng_container_1_ng_container_3_i_2_Template, 1, 0, "i", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.expanded[ctx_r2.getProperty(item_r2, ctx_r2.config.tree.id)]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.expanded[ctx_r2.getProperty(item_r2, ctx_r2.config.tree.id)]);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r2.getLeafLabel(item_r2), " ");
} }
function LevelComponent_ng_container_0_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.getLeafLabel(item_r2));
} }
function LevelComponent_ng_container_0_ng_container_1_level_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "level", 10);
    i0.ɵɵlistener("onLoaded", function LevelComponent_ng_container_0_ng_container_1_level_5_Template_level_onLoaded_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onLevelLoaded($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("config", ctx_r2.config)("parentId", ctx_r2.getProperty(item_r2, ctx_r2.config.tree.id))("level", ctx_r2.level)("expanded", ctx_r2.expanded)("selectedItem", ctx_r2.selectedItem);
} }
function LevelComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "a", 3);
    i0.ɵɵlistener("click", function LevelComponent_ng_container_0_ng_container_1_Template_a_click_2_listener() { const item_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.loadLevel(item_r2)); });
    i0.ɵɵtemplate(3, LevelComponent_ng_container_0_ng_container_1_ng_container_3_Template, 4, 3, "ng-container", 0)(4, LevelComponent_ng_container_0_ng_container_1_ng_container_4_Template, 3, 1, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LevelComponent_ng_container_0_ng_container_1_level_5_Template, 1, 5, "level", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "level_" + ctx_r2.level);
    i0.ɵɵproperty("ngClass", ctx_r2.level > 0 ? "level-container" : "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", item_r2.id)("ngClass", (ctx_r2.selectedItem == null ? null : ctx_r2.selectedItem.id) === item_r2.id ? "level-highlight" + " " + item_r2.status : item_r2.status);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.hasChildren(item_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.hasChildren(item_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.expanded[ctx_r2.getProperty(item_r2, ctx_r2.config.tree.id)]);
} }
function LevelComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LevelComponent_ng_container_0_ng_container_1_Template, 6, 7, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.levels);
} }
class LevelComponent {
    get selectedItem() {
        return this._selectedItem;
    }
    set selectedItem(value) {
        this._selectedItem = value;
    }
    constructor(route, searchService, configService) {
        this.route = route;
        this.searchService = searchService;
        this.configService = configService;
        this.expanded = {};
        this.onClick = new EventEmitter();
        this.onLoaded = new EventEmitter();
        this.review = false;
        this._selectedItem = false;
    }
    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.review = JSON.parse(params.review || "false");
        });
        if (this.level == undefined) {
            this.level = 0;
        }
        else {
            this.level = this.level + 1;
        }
        this.extractLevels();
    }
    extractLevels() {
        let payload = {
            "q": "*",
            "from": 0,
            "size": this.config.tree.size
        };
        this.injectAdditionalFields();
        if (this.config.tree.sort) {
            payload.sort = this.config.tree.sort;
        }
        let statuses;
        if (this.review) {
            statuses = this.configService.env.reviewStatuses || this.configService.env.statuses;
        }
        else {
            statuses = this.configService.env.statuses;
        }
        payload.status = statuses;
        payload.fields = this.config.tree.fields.toString();
        payload.q = this.config.tree.parentId + ":" + (this.parentId || this.config.tree.startParentId);
        if (this.config.tree.defaultFilter) {
            payload.q = "(" + this.config.tree.defaultFilter + ") AND " + payload.q;
        }
        this.searchService.post((this.config.tree.url || this.configService.env.servicesUrl) + '/collection/' + this.config.tree.space + '/' + this.config.tree.collection + '/search', payload).subscribe(res => {
            this.levels = res.results?.values || [];
        }, (error) => {
            this.searchService.manageError(error, "Error extracting hierarchy levels");
        });
    }
    injectAdditionalFields() {
        if (!this.config.tree.fields) {
            this.config.tree.fields = [];
        }
        if (!this.config.tree.fields.includes(this.config.tree.id)) {
            this.config.tree.fields.push(this.config.tree.id);
        }
        if (!this.config.tree.fields.includes(this.config.tree.parentId)) {
            this.config.tree.fields.push(this.config.tree.parentId);
        }
        for (let i = 0; i < this.config.tree.labelFields?.length; i++) {
            if (!this.config.tree.fields.includes(this.config.tree.labelFields[i])) {
                this.config.tree.fields.push(this.config.tree.labelFields[i]);
            }
        }
    }
    hasChildren(item) {
        return item.document.children === undefined || item.document.children;
    }
    getProperty(item, property) {
        let values = jsonPath.query(item, '$.' + property);
        if (values.length > 0) {
            return values[0];
        }
        else {
            return null;
        }
    }
    getLeafLabel(item) {
        let values = {};
        for (let i = 0; i < this.config.tree.labelFields.length; i++) {
            values[this.config.tree.labelFields[i]] = this.getProperty(item, this.config.tree.labelFields[i]);
        }
        let template = this.config.tree.labelTemplate;
        for (let key in values) {
            template = template.replace("${" + key + "}", values[key]);
        }
        return template;
    }
    loadLevel(item) {
        this.expanded[this.getProperty(item, this.config.tree.id)] = !this.expanded[this.getProperty(item, this.config.tree.id)];
        if (this.expanded[this.getProperty(item, this.config.tree.id)]) {
            if (!this.config.tree.multiple) {
                for (let i = 0; i < this.levels.length; i++) {
                    if (this.getProperty(item, this.config.tree.id) !== this.levels[i].id) {
                        this.expanded[this.levels[i].id] = false;
                    }
                }
            }
            this.onLoaded.emit({
                item: item,
                leafs: item.items?.filter(item => item.type === "leaf")
            });
        }
        else {
            this.onLoaded.emit();
        }
    }
    onLevelLoaded(event) {
        this.onLoaded.emit(event);
    }
    static { this.ɵfac = function LevelComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LevelComponent)(i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LevelComponent, selectors: [["level"]], inputs: { parentId: "parentId", config: "config", items: "items", expanded: "expanded", level: "level", selectedItem: "selectedItem" }, outputs: { onClick: "onClick", onLoaded: "onLoaded" }, standalone: false, decls: 1, vars: 1, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "id", "ngClass"], ["href", "javascript:void(0)", 1, "level", 3, "click", "title", "ngClass"], [3, "config", "parentId", "level", "expanded", "selectedItem", "onLoaded", 4, "ngIf"], ["class", "fa-solid fa-folder", 4, "ngIf"], ["class", "fa-regular fa-folder-open", 4, "ngIf"], [1, "fa-solid", "fa-folder"], [1, "fa-regular", "fa-folder-open"], [1, "no-children"], [3, "onLoaded", "config", "parentId", "level", "expanded", "selectedItem"]], template: function LevelComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LevelComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.levels == null ? null : ctx.levels.length) > 0);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, LevelComponent], styles: ["ul[_ngcontent-%COMP%]{padding-left:.4rem!important}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none}.level[_ngcontent-%COMP%]{width:100%;display:block;padding:.5em 1em}.level[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-right:.5em}.level-container[_ngcontent-%COMP%]{border-left:dashed 1px var(--link);padding-left:1em;margin-left:1em}.level-highlight[_ngcontent-%COMP%]{background-color:var(--secondary-background-color)}.no-children[_ngcontent-%COMP%]{margin-left:1.5em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LevelComponent, [{
        type: Component,
        args: [{ selector: 'level', standalone: false, template: "<ng-container *ngIf=\"levels?.length > 0\">\r\n    <ng-container *ngFor=\"let item of levels\">\r\n        <div id=\"{{'level_' + level}}\" [ngClass]=\"level > 0 ? 'level-container' : ''\">\r\n            <a class=\"level\" [title]=\"item.id\" [ngClass]=\"(selectedItem?.id === item.id ? 'level-highlight' +  ' ' + item.status : item.status)\" href=\"javascript:void(0)\" (click)=\"loadLevel(item)\">\r\n                <ng-container *ngIf=\"hasChildren(item)\">\r\n                    <i class=\"fa-solid fa-folder\" *ngIf=\"!expanded[getProperty(item,config.tree.id)]\"></i>\r\n                    <i class=\"fa-regular fa-folder-open\" *ngIf=\"expanded[getProperty(item,config.tree.id)]\"></i>{{getLeafLabel(item)}}\r\n                </ng-container>\r\n                <ng-container *ngIf=\"!hasChildren(item)\">\r\n                    <span class=\"no-children\">{{getLeafLabel(item)}}</span>\r\n                </ng-container>\r\n            </a>\r\n            <level \r\n                *ngIf=\"expanded[getProperty(item,config.tree.id)]\" \r\n                [config]=\"config\" \r\n                [parentId]=\"getProperty(item,config.tree.id)\" \r\n                [level]=\"level\" \r\n                [expanded]=\"expanded\"\r\n                [selectedItem]=\"selectedItem\" \r\n                (onLoaded)=\"onLevelLoaded($event)\">\r\n            </level>\r\n        </div>\r\n    </ng-container>\r\n</ng-container>", styles: ["ul{padding-left:.4rem!important}ul li{list-style-type:none}.level{width:100%;display:block;padding:.5em 1em}.level i{margin-right:.5em}.level-container{border-left:dashed 1px var(--link);padding-left:1em;margin-left:1em}.level-highlight{background-color:var(--secondary-background-color)}.no-children{margin-left:1.5em}\n"] }]
    }], () => [{ type: i2.ActivatedRoute }, { type: i1.SearchService }, { type: i1.ConfigurationService }], { parentId: [{
            type: Input
        }], config: [{
            type: Input
        }], items: [{
            type: Input
        }], expanded: [{
            type: Input
        }], level: [{
            type: Input
        }], onClick: [{
            type: Output
        }], onLoaded: [{
            type: Output
        }], selectedItem: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LevelComponent, { className: "LevelComponent", filePath: "src/components/hierarchy/level/level.component.ts", lineNumber: 12 }); })();

const _c0$4 = a0 => [a0];
const _c1$1 = a0 => ({ status: a0 });
function HierarchyComponent_div_3_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "a", 17);
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", item_r3.status)("title", item_r3.id)("routerLink", i0.ɵɵpureFunction1(5, _c0$4, "/" + ctx_r1.config.leafs.collection + "/" + item_r3.id + "/" + ctx_r1.configService.env.currentLang))("queryParams", i0.ɵɵpureFunction1(7, _c1$1, item_r3.status));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.getLeafLabel(item_r3));
} }
function HierarchyComponent_div_3_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, HierarchyComponent_div_3_div_11_div_1_Template, 4, 9, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.leafs);
} }
function HierarchyComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6)(3, "div", 7)(4, "h6", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(6, "div", 9)(7, "p-inputGroup")(8, "input", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function HierarchyComponent_div_3_Template_input_ngModelChange_8_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.searchText, $event) || (ctx_r1.searchText = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("keydown", function HierarchyComponent_div_3_Template_input_keydown_8_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.search($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 11);
    i0.ɵɵlistener("click", function HierarchyComponent_div_3_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.search()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 12);
    i0.ɵɵlistener("click", function HierarchyComponent_div_3_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.reset()); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(11, HierarchyComponent_div_3_div_11_Template, 2, 1, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2("", ctx_r1.configService.getTranslation("hierarchy.total-results"), " ", ctx_r1.leafs == null ? null : ctx_r1.leafs.length, "");
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.searchText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r1.leafs == null ? null : ctx_r1.leafs.length) > 0);
} }
class HierarchyComponent {
    constructor(route, searchService, configService) {
        this.route = route;
        this.searchService = searchService;
        this.configService = configService;
        this.dynamic = true;
        this.showLeafs = false;
        this.review = false;
        this.defaultConfig = {
            tree: {
                url: this.configService.env.servicesUrl,
                space: null,
                collection: null,
                fields: ["metadata,id,status"],
                id: "document.id",
                parentId: "document.parentId",
                searchField: "document.pathId",
                searchSuffix: "*",
                startParentId: "_root",
                labelFields: [],
                labelTemplate: null,
                size: 30,
                multiple: true,
            },
            leafs: {
                url: this.configService.env.servicesUrl,
                space: null,
                collection: null,
                fields: ["metadata,id,status"],
                searchField: "document.pathId",
                searchSuffix: "*",
                id: "document.id",
                labelFields: [],
                labelTemplate: null,
                size: 30,
                inline: false,
                disabled: false
            }
        };
    }
    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.review = JSON.parse(params.review || "false");
        });
        this.config.tree = Object.assign({}, this.defaultConfig.tree, this.config.tree);
        this.config.leafs = Object.assign({}, this.defaultConfig.leafs, this.config.leafs);
    }
    onLevelLoaded(event) {
        this.leafs = event?.leafs;
        this.selectedItem = event?.item;
        this.searchText = null;
        if (this.selectedItem) {
            this.extractLeafs(this.getProperty(this.selectedItem, this.config.leafs.dataField || this.config.leafs.searchField));
        }
    }
    extractLeafs(searchValue, searchText) {
        let payload = {
            "q": "*",
            "from": 0,
            "size": this.config.leafs.size
        };
        if (searchText > "") {
            payload.q = searchText;
        }
        if (this.config.leafs.sort) {
            payload.sort = this.config.leafs.sort;
        }
        let statuses;
        if (this.review) {
            statuses = this.configService.env.reviewStatuses || this.configService.env.statuses;
        }
        else {
            statuses = this.configService.env.statuses;
        }
        this.injectAdditionalFields();
        payload.status = statuses;
        payload.fields = this.config.leafs.fields.toString() + "," + (this.config.leafs.dataField || this.config.leafs.searchField);
        payload.q = this.getSearch(searchValue) + (payload.q !== "*" ? " AND (" + payload.q + ")" : "");
        if (payload.q > "" && payload.q !== "*") {
            if (this.config.leafs.defaultFilter) {
                payload.q = payload.q + " AND (" + this.config.leafs.defaultFilter + ")";
            }
            this.searchService.post((this.config.leafs.url || this.configService.env.servicesUrl) + '/collection/' + this.config.leafs.space + '/' + this.config.leafs.collection + '/search', payload).subscribe(res => {
                this.leafs = res.results?.values || [];
                //if (this.leafs?.length > 0) {
                this.showLeafs = true;
                //} else {
                //this.showLeafs = false;
                //}
            }, (error) => {
                this.searchService.manageError(error, "Error extracting hierarchy levels");
            });
        }
        else {
            this.leafs = [];
        }
    }
    getSearch(searchValue) {
        let conditions = "";
        if (this.config.leafs.searchField && searchValue) {
            for (let i = 0; i < searchValue?.length; i++) {
                conditions = (conditions > "" ? " OR " : "") + this.config.leafs.searchField + ":(" + searchValue[i] + (this.config.leafs.searchSuffix || "") + " OR " + searchValue[i] + ")";
            }
        }
        return (conditions > "" ? "(" + conditions + ") " : "");
    }
    injectAdditionalFields() {
        if (!this.config.leafs.fields) {
            this.config.leafs.fields = [];
        }
        if (!this.config.leafs.fields.includes(this.config.leafs.id) && this.config.leafs.id) {
            this.config.leafs.fields.push(this.config.leafs.id);
        }
        if (!this.config.leafs.fields.includes(this.config.leafs.parentId) && this.config.leafs.parentId) {
            this.config.leafs.fields.push(this.config.leafs.parentId);
        }
        for (let i = 0; i < this.config.leafs.labelFields?.length; i++) {
            if (!this.config.leafs.fields.includes(this.config.leafs.labelFields[i])) {
                this.config.leafs.fields.push(this.config.leafs.labelFields[i]);
            }
        }
    }
    getProperty(item, property) {
        let values = jsonPath.query(item, '$.' + property);
        if (values.length > 0) {
            return values[0];
        }
        else {
            return null;
        }
    }
    getLeafLabel(item) {
        let values = {};
        for (let i = 0; i < this.config.leafs.labelFields.length; i++) {
            values[this.config.leafs.labelFields[i]] = this.getProperty(item, this.config.leafs.labelFields[i]);
        }
        let template = this.config.leafs.labelTemplate;
        for (let key in values) {
            template = template.replace("${" + key + "}", values[key]);
        }
        return template;
    }
    search(keyboard) {
        if (!keyboard || (keyboard && keyboard.keyCode === 13)) {
            if (this.selectedItem) {
                this.extractLeafs(this.getProperty(this.selectedItem, this.config.leafs.dataField || this.config.leafs.searchField), this.searchText);
            }
        }
    }
    reset() {
        this.searchText = null;
        if (this.selectedItem) {
            this.extractLeafs(this.getProperty(this.selectedItem, this.config.leafs.dataField || this.config.leafs.searchField), this.searchText);
        }
    }
    static { this.ɵfac = function HierarchyComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HierarchyComponent)(i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HierarchyComponent, selectors: [["hierarchy"]], inputs: { config: "config", parentId: "parentId", dynamic: "dynamic", items: "items" }, standalone: false, decls: 4, vars: 4, consts: [[1, "row"], [1, "col-md-8", "sticky"], [3, "onLoaded", "config", "level", "selectedItem"], ["class", "col-md-4 level-highlight", 4, "ngIf"], [1, "col-md-4", "level-highlight"], [1, "leaf-results", "mt-2"], [1, "row", "results-header", "mb-2"], [1, "align-vertical-center"], [1, "title-category"], [1, "leaf-search"], ["type", "text", "pInputText", "", "placeholder", "Search within the list", 3, "ngModelChange", "keydown", "ngModel"], ["type", "button", "pButton", "", "icon", "pi pi-search", 3, "click"], ["type", "button", "pButton", "", "icon", "pi pi-times", 3, "click"], ["class", "leafs", 4, "ngIf"], [1, "leafs"], ["class", "leaf", 4, "ngFor", "ngForOf"], [1, "leaf"], [1, "level", 3, "ngClass", "title", "routerLink", "queryParams"], [1, "bi", "bi-file-earmark-text"]], template: function HierarchyComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "level", 2);
            i0.ɵɵlistener("onLoaded", function HierarchyComponent_Template_level_onLoaded_2_listener($event) { return ctx.onLevelLoaded($event); });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(3, HierarchyComponent_div_3_Template, 12, 4, "div", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("config", ctx.config)("level", ctx.level)("selectedItem", ctx.selectedItem);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showLeafs && ctx.leafs);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i2.RouterLink, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgModel, i7.ButtonDirective, i6$1.InputText, i7$2.InputGroup, LevelComponent], styles: ["ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none}.level[_ngcontent-%COMP%]{width:100%;display:block;padding:.5em 1em}.level[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-right:.5em}.leaf-search[_ngcontent-%COMP%], .leaf-results[_ngcontent-%COMP%]{margin:1em}.level-highlight[_ngcontent-%COMP%]{background-color:var(--secondary-background-color)}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HierarchyComponent, [{
        type: Component,
        args: [{ selector: 'hierarchy', standalone: false, template: "<div class=\"row\">\r\n    <div class=\"col-md-8 sticky\">\r\n        <level [config]=\"config\" [level]=\"level\" [selectedItem]=\"selectedItem\" (onLoaded)=\"onLevelLoaded($event)\"></level>\r\n    </div>\r\n    <div class=\"col-md-4 level-highlight\" *ngIf=\"showLeafs && leafs\">\r\n        <div class=\"leaf-results mt-2\">\r\n            <div class=\"row results-header mb-2\">\r\n                <div class=\"align-vertical-center\">\r\n                    <h6 class=\"title-category\">{{ configService.getTranslation('hierarchy.total-results') }} {{ leafs?.length }}</h6>\r\n                </div>                \r\n            </div>\r\n        </div>\r\n        <div class=\"leaf-search\">\r\n            <p-inputGroup>\r\n                <input type=\"text\" pInputText placeholder=\"Search within the list\" [(ngModel)]=\"searchText\" (keydown)=\"search($event)\" />\r\n                <button type=\"button\" pButton icon=\"pi pi-search\" (click)=\"search()\"></button>\r\n                <button type=\"button\" pButton icon=\"pi pi-times\" (click)=\"reset()\"></button>\r\n            </p-inputGroup>\r\n        </div>\r\n        <div class=\"leafs\" *ngIf=\"leafs?.length > 0\">\r\n            <div class=\"leaf\" *ngFor=\"let item of leafs\">\r\n                <a class=\"level\" [ngClass]=\"item.status\" [title]=\"item.id\" [routerLink]=\"['/' + config.leafs.collection + '/' + item.id + '/' + configService.env.currentLang]\" [queryParams]=\"{ status: item.status }\"><i class=\"bi bi-file-earmark-text\"></i>{{getLeafLabel(item)}}</a>\r\n            </div>\r\n        </div>\r\n<!--         <div class=\"leafs\" *ngIf=\"!leafs || leafs?.length === 0\">\r\n            <div class=\"no-data-found\">No data available</div>\r\n        </div> -->\r\n    </div>\r\n</div>", styles: ["ul li{list-style-type:none}.level{width:100%;display:block;padding:.5em 1em}.level i{margin-right:.5em}.leaf-search,.leaf-results{margin:1em}.level-highlight{background-color:var(--secondary-background-color)}\n"] }]
    }], () => [{ type: i2.ActivatedRoute }, { type: i1.SearchService }, { type: i1.ConfigurationService }], { config: [{
            type: Input
        }], parentId: [{
            type: Input
        }], dynamic: [{
            type: Input
        }], items: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(HierarchyComponent, { className: "HierarchyComponent", filePath: "src/components/hierarchy/hierarchy.component.ts", lineNumber: 12 }); })();

class QrcodeComponent {
    constructor(configService) {
        this.configService = configService;
        this.watermark = 'fao'; //allowed values are fao and fish
        this.width = 'auto';
        this.height = 'auto';
    }
    ngOnInit() {
        this.src = this.configService.env.storageUrl + '/qrcode?text=' + encodeURIComponent(this.text) + '&watermark=' + this.watermark;
    }
    static { this.ɵfac = function QrcodeComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || QrcodeComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QrcodeComponent, selectors: [["fi-qrcode"]], inputs: { text: "text", watermark: "watermark", width: "width", height: "height" }, standalone: false, decls: 1, vars: 3, consts: [[3, "src"]], template: function QrcodeComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelement(0, "img", 0);
        } if (rf & 2) {
            i0.ɵɵstyleMap("width: " + ctx.width + "; height: " + ctx.height + ";");
            i0.ɵɵproperty("src", ctx.src, i0.ɵɵsanitizeUrl);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QrcodeComponent, [{
        type: Component,
        args: [{ selector: 'fi-qrcode', standalone: false, template: "<img [style]=\"'width: ' + width + '; height: ' + height + ';'\" [src]=\"src\" />" }]
    }], () => [{ type: i1.ConfigurationService }], { text: [{
            type: Input
        }], watermark: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(QrcodeComponent, { className: "QrcodeComponent", filePath: "src/components/qrcode/qrcode.component.ts", lineNumber: 10 }); })();

function DynamicDialogComponent_html_renderer_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "html-renderer", 1);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("template", ctx_r0.template);
} }
class DynamicDialogComponent {
    constructor(ref, config) {
        this.ref = ref;
        this.config = config;
    }
    ngOnInit() {
        if (this.config && this.config.data) {
            this.template = this.config.data.template;
        }
    }
    static { this.ɵfac = function DynamicDialogComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicDialogComponent)(i0.ɵɵdirectiveInject(i1$1.DynamicDialogRef), i0.ɵɵdirectiveInject(i1$1.DynamicDialogConfig)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicDialogComponent, selectors: [["dynamic-dialog"]], standalone: false, decls: 1, vars: 1, consts: [[3, "template", 4, "ngIf"], [3, "template"]], template: function DynamicDialogComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicDialogComponent_html_renderer_0_Template, 1, 1, "html-renderer", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.template);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicDialogComponent, [{
        type: Component,
        args: [{ selector: 'dynamic-dialog', standalone: false, template: "<html-renderer *ngIf=\"template\" [template]=\"template\"></html-renderer>" }]
    }], () => [{ type: i1$1.DynamicDialogRef }, { type: i1$1.DynamicDialogConfig }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicDialogComponent, { className: "DynamicDialogComponent", filePath: "src/components/dynamic-dialog/dynamic-dialog.component.ts", lineNumber: 10 }); })();

const _c0$3 = (a0, a1) => ({ refPropertiesId: a0, code: a1 });
function FiFilterComponent_div_1_ng_container_4_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "input", 17);
    i0.ɵɵlistener("change", function FiFilterComponent_div_1_ng_container_4_div_5_Template_input_change_1_listener() { const filter_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onAdditionalFilterChange(filter_r4.name)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const filter_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.searchRequest.o[filter_r4.name] === "true");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", filter_r4.title, " ");
} }
function FiFilterComponent_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 11);
    i0.ɵɵelement(2, "i", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13)(4, "div", 14);
    i0.ɵɵtemplate(5, FiFilterComponent_div_1_ng_container_4_div_5_Template, 4, 2, "div", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r1.options);
} }
function FiFilterComponent_div_1_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function FiFilterComponent_div_1_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.advancedSearch()); });
    i0.ɵɵelement(1, "i", 19);
    i0.ɵɵelementEnd();
} }
function FiFilterComponent_div_1_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function FiFilterComponent_div_1_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.advancedSearch()); });
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵelementEnd();
} }
function FiFilterComponent_div_1_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function FiFilterComponent_div_1_button_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.clear()); });
    i0.ɵɵelement(1, "i", 21);
    i0.ɵɵelementEnd();
} }
function FiFilterComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5)(3, "input", 6);
    i0.ɵɵlistener("keyup.enter", function FiFilterComponent_div_1_Template_input_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.search()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FiFilterComponent_div_1_ng_container_4_Template, 6, 1, "ng-container", 7);
    i0.ɵɵelementStart(5, "button", 8);
    i0.ɵɵlistener("click", function FiFilterComponent_div_1_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.search()); });
    i0.ɵɵelement(6, "i", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, FiFilterComponent_div_1_button_7_Template, 2, 0, "button", 10)(8, FiFilterComponent_div_1_button_8_Template, 2, 0, "button", 10)(9, FiFilterComponent_div_1_button_9_Template, 2, 0, "button", 10);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.searchService.advancedSearchVisible ? "" : "mb-2");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r1.configService.getTranslation("search.placeholder"));
    i0.ɵɵproperty("formControl", ctx_r1.query);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.options && ctx_r1.options.length > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r1.collectionForm.formConfig.viewConfig == null ? null : ctx_r1.collectionForm.formConfig.viewConfig.showAdvancedSearch) && !ctx_r1.searchService.advancedSearchVisible);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.collectionForm.formConfig.viewConfig == null ? null : ctx_r1.collectionForm.formConfig.viewConfig.showAdvancedSearch) && ctx_r1.searchService.advancedSearchVisible);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.collectionForm.formConfig.viewConfig == null ? null : ctx_r1.collectionForm.formConfig.viewConfig.showAdvancedSearch) && ctx_r1.searchService.advancedSearchVisible);
} }
function FiFilterComponent_div_2_div_2_div_1_p_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 33);
    i0.ɵɵlistener("click", function FiFilterComponent_div_2_div_2_div_1_p_button_4_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const param_r9 = i0.ɵɵnextContext().$implicit; return i0.ɵɵresetView(param_r9.showQuickHelp = !param_r9.showQuickHelp); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function FiFilterComponent_div_2_div_2_div_1_label_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const param_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(param_r9.quickhelp);
} }
function FiFilterComponent_div_2_div_2_div_1_div_6_p_autocomplete_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-autocomplete", 37);
    i0.ɵɵtwoWayListener("ngModelChange", function FiFilterComponent_div_2_div_2_div_1_div_6_p_autocomplete_1_Template_p_autocomplete_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r10); const param_r9 = i0.ɵɵnextContext(2).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r1.form[param_r9.name], $event) || (ctx_r1.form[param_r9.name] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("completeMethod", function FiFilterComponent_div_2_div_2_div_1_div_6_p_autocomplete_1_Template_p_autocomplete_completeMethod_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.onChipAdded($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const param_r9 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.configService.getTranslation("advanced-search.chips.tooltip"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form[param_r9.name]);
    i0.ɵɵproperty("multiple", true)("typeahead", false);
} }
function FiFilterComponent_div_2_div_2_div_1_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35)(1, "p-multiSelect", 38);
    i0.ɵɵtwoWayListener("ngModelChange", function FiFilterComponent_div_2_div_2_div_1_div_6_div_2_Template_p_multiSelect_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r11); const param_r9 = i0.ɵɵnextContext(2).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r1.form[param_r9.name], $event) || (ctx_r1.form[param_r9.name] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const param_r9 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", ctx_r1.configService.getTranslation("advanced-search.select.tooltip"));
    i0.ɵɵproperty("filter", true)("options", param_r9.items);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form[param_r9.name]);
    i0.ɵɵproperty("showClear", true);
} }
function FiFilterComponent_div_2_div_2_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, FiFilterComponent_div_2_div_2_div_1_div_6_p_autocomplete_1_Template, 1, 4, "p-autocomplete", 36)(2, FiFilterComponent_div_2_div_2_div_1_div_6_div_2_Template, 2, 5, "div", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const param_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !param_r9.refOptionsId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", param_r9.refOptionsId);
} }
function FiFilterComponent_div_2_div_2_div_1_div_7_div_1_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 44);
    i0.ɵɵlistener("keyup.enter", function FiFilterComponent_div_2_div_2_div_1_div_7_div_1_input_3_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.search()); });
    i0.ɵɵtwoWayListener("ngModelChange", function FiFilterComponent_div_2_div_2_div_1_div_7_div_1_input_3_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const param_r9 = i0.ɵɵnextContext(3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r1.form[param_r9.name].from, $event) || (ctx_r1.form[param_r9.name].from = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const param_r9 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("pTooltip", ctx_r1.configService.getTranslation("advanced-search.chips.tooltip"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form[param_r9.name].from);
} }
function FiFilterComponent_div_2_div_2_div_1_div_7_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45)(1, "p-select", 46);
    i0.ɵɵtwoWayListener("ngModelChange", function FiFilterComponent_div_2_div_2_div_1_div_7_div_1_div_4_Template_p_select_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r13); const param_r9 = i0.ɵɵnextContext(3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r1.form[param_r9.name].from, $event) || (ctx_r1.form[param_r9.name].from = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const param_r9 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", param_r9.name + "-from");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", ctx_r1.configService.getTranslation("advanced-search.select.tooltip"));
    i0.ɵɵproperty("filter", true)("options", param_r9.items);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form[param_r9.name].from);
    i0.ɵɵproperty("showClear", true);
} }
function FiFilterComponent_div_2_div_2_div_1_div_7_div_1_input_7_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 47);
    i0.ɵɵlistener("keyup.enter", function FiFilterComponent_div_2_div_2_div_1_div_7_div_1_input_7_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r1 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r1.search()); });
    i0.ɵɵtwoWayListener("ngModelChange", function FiFilterComponent_div_2_div_2_div_1_div_7_div_1_input_7_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r14); const param_r9 = i0.ɵɵnextContext(3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r1.form[param_r9.name].to, $event) || (ctx_r1.form[param_r9.name].to = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const param_r9 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.configService.getTranslation("advanced-search.chips.tooltip"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form[param_r9.name].to);
} }
function FiFilterComponent_div_2_div_2_div_1_div_7_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45)(1, "p-select", 46);
    i0.ɵɵtwoWayListener("ngModelChange", function FiFilterComponent_div_2_div_2_div_1_div_7_div_1_div_8_Template_p_select_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r15); const param_r9 = i0.ɵɵnextContext(3).$implicit; const ctx_r1 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r1.form[param_r9.name].to, $event) || (ctx_r1.form[param_r9.name].to = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const param_r9 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", param_r9.name + "-to");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", ctx_r1.configService.getTranslation("advanced-search.select.tooltip"));
    i0.ɵɵproperty("filter", true)("options", param_r9.items);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.form[param_r9.name].to);
    i0.ɵɵproperty("showClear", true);
} }
function FiFilterComponent_div_2_div_2_div_1_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 40)(2, "div", 35);
    i0.ɵɵtemplate(3, FiFilterComponent_div_2_div_2_div_1_div_7_div_1_input_3_Template, 1, 2, "input", 41)(4, FiFilterComponent_div_2_div_2_div_1_div_7_div_1_div_4_Template, 2, 6, "div", 42);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 40)(6, "div", 35);
    i0.ɵɵtemplate(7, FiFilterComponent_div_2_div_2_div_1_div_7_div_1_input_7_Template, 1, 2, "input", 43)(8, FiFilterComponent_div_2_div_2_div_1_div_7_div_1_div_8_Template, 2, 6, "div", 42);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const param_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !param_r9.refOptionsId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", param_r9.refOptionsId);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !param_r9.refOptionsId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", param_r9.refOptionsId);
} }
function FiFilterComponent_div_2_div_2_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵtemplate(1, FiFilterComponent_div_2_div_2_div_1_div_7_div_1_Template, 9, 4, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const param_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.form[param_r9.name]);
} }
function FiFilterComponent_div_2_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "div")(2, "label", 28);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FiFilterComponent_div_2_div_2_div_1_p_button_4_Template, 1, 2, "p-button", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, FiFilterComponent_div_2_div_2_div_1_label_5_Template, 2, 1, "label", 30)(6, FiFilterComponent_div_2_div_2_div_1_div_6_Template, 3, 2, "div", 31)(7, FiFilterComponent_div_2_div_2_div_1_div_7_Template, 2, 1, "div", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const param_r9 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", param_r9.cssClass ? param_r9.cssClass : "col-md-6");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.dynamicFormControlService.getProperty(null, ctx_r1.collectionForm.form, i0.ɵɵpureFunction2(6, _c0$3, param_r9.refPropertiesId, param_r9.name), "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", param_r9.quickhelp);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", param_r9.showQuickHelp);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", param_r9.type !== "range");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", param_r9.type === "range");
} }
function FiFilterComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, FiFilterComponent_div_2_div_2_div_1_Template, 8, 9, "div", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.collectionForm.formConfig.viewConfig.advancedSearch);
} }
function FiFilterComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23);
    i0.ɵɵtemplate(2, FiFilterComponent_div_2_div_2_Template, 2, 1, "div", 24);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !ctx_r1.searchService.advancedSearchVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.form);
} }
class FiFilterComponent {
    set initialValue(value) {
        if (value) {
            this.query.setValue(value);
        }
    }
    constructor(collectionService, route, configService, searchService, _vps, router, dynamicFormControlService, optionsService) {
        this.collectionService = collectionService;
        this.route = route;
        this.configService = configService;
        this.searchService = searchService;
        this._vps = _vps;
        this.router = router;
        this.dynamicFormControlService = dynamicFormControlService;
        this.optionsService = optionsService;
        this.showAdvancedSearch = false;
        this.pageReady = false;
    }
    ngOnInit() {
        this.route.params.subscribe(params => {
            this.params = params;
            this.route.queryParams.subscribe(queryParams => {
                this.listTemplate = queryParams.listTemplate;
                this.detailTemplate = queryParams.detailTemplate;
                this.listConfig = queryParams.listConfig;
                this.view = queryParams.view;
                this.searchRequest = ListDirective.parsePageRequest(this.configService.env.advancedSearch, queryParams, this.params);
                this.query = new FormControl(queryParams.q);
                this.options = this.collectionForm?.formConfig?.viewConfig && this.collectionForm?.formConfig?.viewConfig.options ? this.collectionForm?.formConfig?.viewConfig?.options.filter(item => item.type !== 'hidden') : [];
                if (!this.collectionForm) {
                    this.collectionService.getCollection(this.space, this.collection).subscribe(res => {
                        this.collectionForm = res;
                        this.initForm(this.searchRequest.f);
                        this.pageReady = true;
                    }, err => {
                        this.searchService.manageError(err, 'Error extracting collections from space ' + this.space);
                    });
                }
                else {
                    this.initForm(this.searchRequest.f);
                    this.pageReady = true;
                }
            });
        });
        this.route.fragment.subscribe(fragment => {
            this.fragment = fragment;
            this._vps.scrollToAnchor(this.fragment);
        });
    }
    ngOnDestroy() {
    }
    ngAfterViewInit() {
        this._vps.scrollToAnchor(this.fragment);
    }
    initForm(advanced) {
        this.form = {};
        for (let i = 0; i < this.collectionForm?.formConfig?.viewConfig?.advancedSearch?.length; i++) {
            if (this.collectionForm?.formConfig?.viewConfig?.advancedSearch[i].type === 'range') {
                this.getTermOptions(this.collectionForm?.formConfig?.viewConfig.advancedSearch[i]);
                if (advanced && advanced[this.collectionForm?.formConfig?.viewConfig.advancedSearch[i].name]) {
                    let interval = advanced[this.collectionForm?.formConfig?.viewConfig.advancedSearch[i].name].split(':');
                    this.form[this.collectionForm?.formConfig?.viewConfig?.advancedSearch[i].name] = {
                        from: {
                            label: interval[0],
                            value: interval[0]
                        },
                        to: {
                            label: interval[1],
                            value: interval[1]
                        }
                    };
                }
                else {
                    this.form[this.collectionForm?.formConfig?.viewConfig?.advancedSearch[i].name] = {
                        from: null,
                        to: null
                    };
                }
            }
            else {
                this.getTermOptions(this.collectionForm?.formConfig?.viewConfig?.advancedSearch[i]);
                let value;
                if (advanced && advanced[this.collectionForm?.formConfig?.viewConfig?.advancedSearch[i].name]) {
                    value = [];
                    let values = advanced[this.collectionForm?.formConfig?.viewConfig?.advancedSearch[i].name].split(new RegExp(this.configService.env.advancedSearch.multiple.regexp));
                    for (let i = 0; i < values.length; i++) {
                        let termLabel = ListDirective.getTermProperty(this.configService, this.configService.env.advancedSearch.termConcatenator, values[i], "label");
                        let termValue = ListDirective.getTermProperty(this.configService, this.configService.env.advancedSearch.termConcatenator, values[i], "key");
                        value.push({
                            label: termLabel,
                            value: termValue
                        });
                    }
                }
                this.form[this.collectionForm?.formConfig.viewConfig.advancedSearch[i].name] = value;
            }
        }
    }
    onChipAdded(event) {
        if (isNaN(event.value)) {
            if (event.value.includes(' ')) {
                event.label = '\"' + event.label + '\"';
                event.value = '\"' + event.value + '\"';
            }
        }
    }
    getTermOptions(term) {
        if (term.refOptionsId) {
            let index = this.collectionForm?.form.options?.findIndex(item => item.id === term.refOptionsId);
            if (index >= 0) {
                if (this.collectionForm?.form.options[index].type === 'reference' || this.collectionForm?.form.options[index].type === 'standard' || this.collectionForm?.form.options[index].type === 'external') {
                    this.optionsService.getRemoteItems({}, this.dynamicFormControlService, this.collectionForm, {
                        componentConfig: {
                            size: 200
                        }
                    }, {}, this.collectionForm?.form.options[index], null).subscribe(res => {
                        term.items = this.optionsService.mapRemoteItems(this.collectionForm?.form.options[index], res, { label: term.optionLabel || "label", value: term.optionValue || "key" });
                    }, err => {
                        this.searchService.manageError(err, 'Error reading ' + this.collectionForm?.form.options[index].type + ' items');
                    });
                }
                else {
                    term.items = this.collectionForm?.form.options[index].items;
                }
            }
        }
    }
    formToSearchRequest(form) {
        let output = [];
        for (let i = 0; i < form.length; i++) {
            if (typeof (form[i]) === "object") {
                if (form[i].value === form[i].label) {
                    output.push('"' + form[i].value + '"');
                }
                else {
                    output.push('"' + form[i].value + '|' + form[i].label + '"');
                }
            }
            else {
                output.push('"' + form[i] + '"');
            }
        }
        return output;
    }
    search() {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.searchRequest.page = 1;
        this.searchRequest.q = this.query.value;
        for (let i = 0; i < this.collectionForm?.formConfig.viewConfig?.advancedSearch?.length; i++) {
            let term = this.collectionForm?.formConfig.viewConfig.advancedSearch[i];
            if (this.collectionForm?.formConfig.viewConfig.advancedSearch[i].type !== 'range') {
                if (this.form[term.name]) {
                    this.searchRequest.f[term.name] = this.formToSearchRequest(this.form[term.name]);
                }
            }
            else {
                if (this.form[term.name] && this.form[term.name].from && this.form[term.name].to) {
                    this.searchRequest.f[term.name] = {
                        path: this.collectionForm?.formConfig.viewConfig.advancedSearch[i].rangeFromPath + ':' + this.collectionForm?.formConfig.viewConfig.advancedSearch[i].rangeToPath,
                        label: term.name,
                        value: this.form[term.name].from.value + ':' + this.form[term.name].to.value
                    };
                }
            }
        }
        let queryParams = {
            page: this.searchRequest.page,
            q: this.searchRequest.q,
            f: ListDirective.stringifyAdvancedParams(this.configService, this.searchRequest.f, this.configService.env.advancedSearch.multiple.separator),
            o: ListDirective.stringifyAdvancedParams(this.configService, this.searchRequest.o, this.configService.env.advancedSearch.multiple.separator),
            g: ListDirective.stringifyGeospatialParams(this.configService, this.searchRequest.g, this.configService.env.advancedSearch.multiple.separator),
            sort: this.searchRequest.sort
        };
        if (this.view) {
            queryParams.view = this.view;
        }
        if (this.listTemplate) {
            queryParams.listTemplate = this.listTemplate;
        }
        if (this.detailTemplate) {
            queryParams.detailTemplate = this.detailTemplate;
        }
        if (this.listConfig) {
            queryParams.listConfig = this.listConfig;
        }
        this.router.navigate(['./'], {
            relativeTo: this.route,
            fragment: 'search',
            queryParams: queryParams
        });
    }
    clear() {
        this.searchRequest.page = 1;
        this.searchRequest.q = undefined;
        for (let i = 0; i < this.collectionForm?.formConfig.viewConfig.advancedSearch.length; i++) {
            if (this.searchRequest.f.hasOwnProperty(this.collectionForm?.formConfig.viewConfig.advancedSearch[i].name)) {
                delete this.searchRequest.f[this.collectionForm?.formConfig.viewConfig.advancedSearch[i].name];
            }
        }
        let queryParams = {
            page: this.searchRequest.page,
            q: this.searchRequest.q,
            f: ListDirective.stringifyAdvancedParams(this.configService, this.searchRequest.f, this.configService.env.advancedSearch.multiple.separator),
            o: ListDirective.stringifyAdvancedParams(this.configService, this.searchRequest.o, this.configService.env.advancedSearch.multiple.separator),
            g: ListDirective.stringifyGeospatialParams(this.configService, this.searchRequest.g, this.configService.env.advancedSearch.multiple.separator),
            sort: this.searchRequest.sort
        };
        if (this.view) {
            queryParams.view = this.view;
        }
        if (this.listTemplate) {
            queryParams.listTemplate = this.listTemplate;
        }
        if (this.detailTemplate) {
            queryParams.detailTemplate = this.detailTemplate;
        }
        if (this.listConfig) {
            queryParams.listConfig = this.listConfig;
        }
        this.router.navigate(['./'], {
            relativeTo: this.route,
            fragment: 'search',
            queryParams: queryParams
        });
    }
    onAdditionalFilterChange(filterName) {
        this.searchRequest.o[filterName] = !this.searchRequest.o[filterName];
        this.search();
    }
    advancedSearch() {
        this.searchService.advancedSearchVisible = !this.searchService.advancedSearchVisible;
    }
    static { this.ɵfac = function FiFilterComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FiFilterComponent)(i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i3.ViewportScroller), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1.OptionsService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FiFilterComponent, selectors: [["fi-filter"]], inputs: { initialValue: "initialValue", space: "space", collection: "collection", collectionForm: "collectionForm", data: "data" }, standalone: false, decls: 3, vars: 3, consts: [[1, "filter", 3, "ngClass"], ["class", "row", 3, "ngClass", 4, "ngIf"], ["class", "row", 3, "hidden", 4, "ngIf"], [1, "row", 3, "ngClass"], [1, "col-md-12", "mb-2"], ["dir", "ltr", "id", "search-bar", 1, "input-group"], ["type", "text", "aria-label", "Search", 1, "form-control", "form-control-sm", 3, "keyup.enter", "formControl", "placeholder"], [4, "ngIf"], ["type", "button", 1, "btn", "btn-primary", "btn-sm", 3, "click"], [1, "bi", "bi-search"], ["class", "btn btn-primary btn-sm", "type", "button", 3, "click", 4, "ngIf"], ["type", "button", "id", "additionalFilter", "data-bs-toggle", "dropdown", "aria-expanded", "false", 1, "btn", "btn-primary", "btn-sm", "dropdown-toggle"], [1, "bi", "bi-funnel"], ["aria-labelledby", "additionalFilter", 1, "dropdown-menu"], [1, "form-group"], ["class", "form-check", 4, "ngFor", "ngForOf"], [1, "form-check"], ["type", "checkbox", 1, "form-check-input", 3, "change", "checked"], [1, "form-check-label"], [1, "bi", "bi-zoom-in"], [1, "bi", "bi-zoom-out"], [1, "bi", "bi-x-lg"], [1, "row", 3, "hidden"], [1, "col-md-12"], ["class", "row", 4, "ngIf"], [1, "row"], [3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], [1, "field-label"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "rounded", "outlined", "click", 4, "ngIf"], ["class", "quickhelp", 4, "ngIf"], ["class", "field-control", 4, "ngIf"], ["class", "field-control-group", 4, "ngIf"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "click", "rounded", "outlined"], [1, "quickhelp"], [1, "field-control"], [3, "title", "ngModel", "multiple", "typeahead", "ngModelChange", "completeMethod", 4, "ngIf"], [3, "ngModelChange", "completeMethod", "title", "ngModel", "multiple", "typeahead"], ["appendTo", "body", "optionLabel", "label", "dataKey", "value", "placeholder", "(none)", 3, "ngModelChange", "filter", "title", "options", "ngModel", "showClear"], [1, "field-control-group"], [1, "col-md-6"], ["type", "text", "class", "form-control form-control-sm", 3, "pTooltip", "ngModel", "keyup.enter", "ngModelChange", 4, "ngIf"], ["class", "field-control mb-2", 3, "id", 4, "ngIf"], ["type", "text", "class", "form-control form-control-sm", 3, "title", "ngModel", "keyup.enter", "ngModelChange", 4, "ngIf"], ["type", "text", 1, "form-control", "form-control-sm", 3, "keyup.enter", "ngModelChange", "pTooltip", "ngModel"], [1, "field-control", "mb-2", 3, "id"], ["appendTo", "body", "optionLabel", "label", "placeholder", "(none)", "dataKey", "value", 3, "ngModelChange", "filter", "title", "options", "ngModel", "showClear"], ["type", "text", 1, "form-control", "form-control-sm", 3, "keyup.enter", "ngModelChange", "title", "ngModel"]], template: function FiFilterComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, FiFilterComponent_div_1_Template, 10, 7, "div", 1)(2, FiFilterComponent_div_2_Template, 3, 2, "div", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.searchService.advancedSearchVisible ? "bordered" : "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.collectionForm.formConfig.viewConfig == null ? null : ctx.collectionForm.formConfig.viewConfig.showSearchbar);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.collectionForm.formConfig.viewConfig == null ? null : ctx.collectionForm.formConfig.viewConfig.showAdvancedSearch);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgModel, i5.FormControlDirective, i7.Button, i6.Select, i7$3.MultiSelect, i8$1.AutoComplete, i4$2.Tooltip], styles: [".filter.bordered[_ngcontent-%COMP%]{border:1px solid var(--hover-border-color);padding:1em;border-radius:5px;margin-bottom:1em}.field-control[_ngcontent-%COMP%]{margin-bottom:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FiFilterComponent, [{
        type: Component,
        args: [{ selector: 'fi-filter', standalone: false, template: "<div class=\"filter\" [ngClass]=\"searchService.advancedSearchVisible ? 'bordered' : ''\">\r\n  <div *ngIf=\"collectionForm.formConfig.viewConfig?.showSearchbar\" class=\"row\" [ngClass]=\"searchService.advancedSearchVisible ? '' : 'mb-2'\">\r\n    <div class=\"col-md-12 mb-2\">\r\n        <div dir=\"ltr\" id=\"search-bar\" class=\"input-group\">\r\n          <input\r\n            type=\"text\"\r\n            [formControl]=\"query\"\r\n            class=\"form-control form-control-sm\"\r\n            placeholder=\"{{ configService.getTranslation('search.placeholder') }}\"\r\n            aria-label=\"Search\"  \r\n            (keyup.enter)=\"search()\"    \r\n          />\r\n          <ng-container *ngIf=\"options && options.length > 0\">\r\n            <button class=\"btn btn-primary btn-sm dropdown-toggle\" type=\"button\" id=\"additionalFilter\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\">\r\n              <i class=\"bi bi-funnel\"></i>\r\n            </button>\r\n            <div class=\"dropdown-menu\" aria-labelledby=\"additionalFilter\">\r\n              <div class=\"form-group\">\r\n                <div class=\"form-check\" *ngFor=\"let filter of options\">\r\n                  <input class=\"form-check-input\" type=\"checkbox\" [checked]=\"searchRequest.o[filter.name] === 'true'\" (change)=\"onAdditionalFilterChange(filter.name)\">\r\n                  <label class=\"form-check-label\">\r\n                    {{ filter.title}}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </ng-container>\r\n          <button class=\"btn btn-primary btn-sm\" type=\"button\" (click)=\"search()\">\r\n            <i class=\"bi bi-search\"></i>\r\n          </button>    \r\n          <button *ngIf=\"collectionForm.formConfig.viewConfig?.showAdvancedSearch && !searchService.advancedSearchVisible\" class=\"btn btn-primary btn-sm\" type=\"button\" (click)=\"advancedSearch()\"><i class=\"bi bi-zoom-in\"></i></button>\r\n          <button *ngIf=\"collectionForm.formConfig.viewConfig?.showAdvancedSearch && searchService.advancedSearchVisible\" class=\"btn btn-primary btn-sm\" type=\"button\" (click)=\"advancedSearch()\"><i class=\"bi bi-zoom-out\"></i></button>\r\n          <button *ngIf=\"collectionForm.formConfig.viewConfig?.showAdvancedSearch && searchService.advancedSearchVisible\" class=\"btn btn-primary btn-sm\" type=\"button\" (click)=\"clear()\"><i class=\"bi bi-x-lg\"></i></button>\r\n        </div>        \r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\" *ngIf=\"collectionForm.formConfig.viewConfig?.showAdvancedSearch\" [hidden]=\"!searchService.advancedSearchVisible\">\r\n    <div class=\"col-md-12\">\r\n  \r\n      <div class=\"row\" *ngIf=\"form\">\r\n        <div [ngClass]=\"param.cssClass ? param.cssClass : 'col-md-6'\" *ngFor=\"let param of collectionForm.formConfig.viewConfig.advancedSearch\">\r\n          <div>\r\n            <label class=\"field-label\">{{ dynamicFormControlService.getProperty(null, collectionForm.form,{ refPropertiesId: param.refPropertiesId, code: param.name },'label') }}</label>\r\n            <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\" *ngIf=\"param.quickhelp\" title=\"Help\"\r\n              (click)=\"param.showQuickHelp=!param.showQuickHelp\"></p-button>\r\n          </div>\r\n          <label class=\"quickhelp\" *ngIf=\"param.showQuickHelp\">{{ param.quickhelp }}</label>\r\n  \r\n          <div *ngIf=\"param.type !== 'range'\" class=\"field-control\">             \r\n            <p-autocomplete *ngIf=\"!param.refOptionsId\" title=\"{{ configService.getTranslation('advanced-search.chips.tooltip') }}\" [(ngModel)]=\"form[param.name]\" [multiple]=\"true\" [typeahead]=\"false\" (completeMethod)=\"onChipAdded($event)\" />\r\n  \r\n            <div *ngIf=\"param.refOptionsId\" class=\"field-control\">\r\n              <p-multiSelect appendTo=\"body\" [filter]=\"true\" title=\"{{ configService.getTranslation('advanced-search.select.tooltip') }}\"\r\n                [options]=\"param.items\" [(ngModel)]=\"form[param.name]\"\r\n                optionLabel=\"label\" dataKey=\"value\" [showClear]=\"true\" placeholder=\"(none)\">\r\n              </p-multiSelect>\r\n            </div>\r\n          </div>\r\n  \r\n          <div *ngIf=\"param.type === 'range'\" class=\"field-control-group\">\r\n          \r\n            <div class=\"row\" *ngIf=\"form[param.name]\">\r\n              <div class=\"col-md-6\">              \r\n                <div class=\"field-control\">\r\n                  <input\r\n                    *ngIf=\"!param.refOptionsId\"\r\n                    (keyup.enter)=\"search()\"\r\n                    pTooltip=\"{{ configService.getTranslation('advanced-search.chips.tooltip') }}\"\r\n                    type=\"text\"              \r\n                    class=\"form-control\"\r\n                    [(ngModel)]=\"form[param.name].from\"\r\n                    class=\"form-control form-control-sm\" />\r\n      \r\n                  <div *ngIf=\"param.refOptionsId\" class=\"field-control mb-2\" id=\"{{ param.name + '-from' }}\">\r\n                    <p-select appendTo=\"body\" [filter]=\"true\" title=\"{{ configService.getTranslation('advanced-search.select.tooltip') }}\"\r\n                      [options]=\"param.items\" [(ngModel)]=\"form[param.name].from\"\r\n                      optionLabel=\"label\" [showClear]=\"true\" placeholder=\"(none)\" dataKey=\"value\">\r\n                    </p-select>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-md-6\">\r\n                <div class=\"field-control\">\r\n                  <input title=\"{{ configService.getTranslation('advanced-search.chips.tooltip') }}\"\r\n                    *ngIf=\"!param.refOptionsId\"\r\n                    (keyup.enter)=\"search()\"                    \r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    [(ngModel)]=\"form[param.name].to\"\r\n                    class=\"form-control form-control-sm\" />\r\n      \r\n                  <div *ngIf=\"param.refOptionsId\" class=\"field-control mb-2\" id=\"{{ param.name + '-to' }}\">\r\n                    <p-select appendTo=\"body\" [filter]=\"true\" title=\"{{ configService.getTranslation('advanced-search.select.tooltip') }}\"\r\n                      [options]=\"param.items\" [(ngModel)]=\"form[param.name].to\"\r\n                      optionLabel=\"label\" [showClear]=\"true\" placeholder=\"(none)\" dataKey=\"value\">\r\n                    </p-select>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n  \r\n          </div>\r\n        </div>\r\n      </div>\r\n  \r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n", styles: [".filter.bordered{border:1px solid var(--hover-border-color);padding:1em;border-radius:5px;margin-bottom:1em}.field-control{margin-bottom:1em}\n"] }]
    }], () => [{ type: i1.CollectionService }, { type: i2.ActivatedRoute }, { type: i1.ConfigurationService }, { type: i1.SearchService }, { type: i3.ViewportScroller }, { type: i2.Router }, { type: i1.DynamicFormControlService }, { type: i1.OptionsService }], { initialValue: [{
            type: Input
        }], space: [{
            type: Input
        }], collection: [{
            type: Input
        }], collectionForm: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(FiFilterComponent, { className: "FiFilterComponent", filePath: "src/components/fi-filter/fi-filter.component.ts", lineNumber: 15 }); })();

function GeosearchComponent_fi_map_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fi-map", 4);
    i0.ɵɵlistener("mapReady", function GeosearchComponent_fi_map_2_Template_fi_map_mapReady_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onMapReady($event)); })("featureDrawn", function GeosearchComponent_fi_map_2_Template_fi_map_featureDrawn_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onFeatureDrawn($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("config", ctx_r1.config);
} }
function GeosearchComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 5);
    i0.ɵɵtext(2, " The displayed bounding boxes are just the ones related to the results listed in the page ");
    i0.ɵɵelementEnd()();
} }
class GeosearchComponent {
    constructor(route, mapService, searchService, configService) {
        this.route = route;
        this.mapService = mapService;
        this.searchService = searchService;
        this.configService = configService;
        this.draw = false;
        this.showPolygons = "true";
        this.showPoints = "true";
        this.showExtent = "true";
        this.onMapSearch = new EventEmitter();
        this.pageReady = false;
        this.polygons = [];
        this.points = [];
        this.defaultExtent = [-180, -90, 180, 90];
    }
    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.searchRequest = ListDirective.parsePageRequest(this.configService.env.advancedSearch, params);
        });
        if (this.item) {
            if (this.item.type === 'activity') {
                this.activityInit();
            }
            else if (this.item.type === 'survey') {
                this.surveyInit();
            }
        }
        else {
            this.listInit();
        }
    }
    listInit() {
        this.polygons = [];
        for (let i = 0; i < this.items?.length; i++) {
            if (this.items[i].document?.extent?.bbox_geom_geojson) {
                this.polygons.push(this.mapService.createPolygonFeature(this.items[i].document.extent.bbox_geom_geojson.coordinates));
            }
        }
        this.init();
    }
    surveyInit() {
        if (this.item.extent?.bbox) {
            this.extent = [this.item.extent.bbox.westLongitude, this.item.extent.bbox.southLatitude, this.item.extent.bbox.eastLongitude, this.item.extent.bbox.northLatitude];
        }
        let payload = {
            "q": "document.id:" + this.item.id,
            "from": 0,
            "size": 25,
            "fields": "id,document",
            "aggType": "flat",
            "aggSize": 0,
            "aggSetSize": 0
        };
        this.searchService.post(this.configService.env.servicesUrl + '/collection/eafnansen/surveygeodata/search', payload).subscribe((res) => {
            this.polygons = [];
            //This resultset is always composed by 1 item
            for (let i = 0; i < res?.results?.values?.length; i++) {
                let geodata = res.results.values[i].document;
                if (geodata?.polygon_geom_geojson) {
                    this.polygons.push(this.mapService.createPolygonFeature(geodata.polygon_geom_geojson.coordinates));
                }
                if (geodata.bbox_geom_geojson) {
                    this.polygons.push(this.mapService.createPolygonFeature(geodata.bbox_geom_geojson.coordinates));
                }
                //this.extent = [Number(geodata.min_lon || 0),Number(geodata.min_lat || 0),Number(geodata.max_lon || 0),Number(geodata.max_lat || 0)];
            }
            this.init();
        });
    }
    activityInit() {
        if (this.item.extent?.bbox) {
            this.extent = [this.item.extent.bbox.westLongitude, this.item.extent.bbox.southLatitude, this.item.extent.bbox.eastLongitude, this.item.extent.bbox.northLatitude];
        }
        let payload = {
            "q": "document.activity_code:" + this.item.id,
            "from": 0,
            "size": 25,
            "fields": "id,document",
            "aggType": "flat",
            "aggSize": 0,
            "aggSetSize": 0
        };
        this.searchService.post(this.configService.env.servicesUrl + '/collection/eafnansen/activitygeodata/search', payload).subscribe((res) => {
            this.polygons = [];
            this.points = [];
            for (let i = 0; i < res?.results?.values?.length; i++) {
                let geodata = res.results.values[i].document;
                if (geodata?.point_geom_geojson) {
                    this.points.push(this.mapService.createPointFeature(geodata.point_geom_geojson.coordinates));
                }
                if (geodata?.bbox_geom_geojson) {
                    this.polygons.push(this.mapService.createPolygonFeature(geodata.bbox_geom_geojson.coordinates));
                }
            }
            this.init();
        });
    }
    init() {
        this.config =
            {
                layers: [
                    {
                        type: 'raster',
                        name: 'un_continent2',
                        group: 'base',
                        zindex: 0,
                        url: this.configService.env.geoUrl + 'gwc/service/wms',
                        title: {
                            en: "UN Continents"
                        },
                        params: {
                            SERVICE: "WMS",
                            VERSION: "1.1.1",
                            REQUEST: "GetMap",
                            FORMAT: "image/png",
                            TRANSPARENT: "true",
                            LAYERS: "fifao:UN_CONTINENT2",
                            TILED: "true"
                        },
                        visible: true,
                        opacity: 1
                    },
                    {
                        type: 'raster',
                        name: 'limit_200nm',
                        group: 'base',
                        zindex: 6,
                        url: this.configService.env.geoUrl + 'gwc/service/wms',
                        title: {
                            en: "200 nautical miles arcs"
                        },
                        params: {
                            SERVICE: "WMS",
                            VERSION: "1.1.1",
                            REQUEST: "GetMap",
                            FORMAT: "image/png",
                            TRANSPARENT: "true",
                            LAYERS: "fifao:limit_200nm",
                            TILED: "true"
                        },
                        visible: true,
                        opacity: 1
                    },
                    {
                        type: 'raster',
                        name: 'fao_major_areas',
                        group: 'base',
                        zindex: 3,
                        url: this.configService.env.geoUrl + 'gwc/service/wms',
                        title: {
                            en: "FAO fishing areas"
                        },
                        params: {
                            SERVICE: "WMS",
                            VERSION: "1.1.1",
                            REQUEST: "GetMap",
                            FORMAT: "image/png",
                            TRANSPARENT: "true",
                            LAYERS: "fifao:FAO_MAJOR",
                            TILED: "true"
                        },
                        visible: true,
                        opacity: 1
                    }
                ],
                showLegends: false,
                extent: this.extent || this.defaultExtent,
                draw: {
                    featureType: 'Box',
                    mode: 'single',
                    zoomToFeature: true
                },
                constrainResolution: (this.items ? false : true),
                layersList: {
                    position: "top-right"
                }
            };
        this.pageReady = true;
    }
    onMapReady(event) {
        if (this.item) {
            this.polygonLayer = this.map.addVectorLayer({});
            if (this.item.extent?.bbox) {
                if (this.showExtent === 'true') {
                    this.map.addFeature(this.polygonLayer.source, this.mapService.bboxToPolygon([this.item.extent.bbox.westLongitude, this.item.extent.bbox.southLatitude, this.item.extent.bbox.eastLongitude, this.item.extent.bbox.northLatitude]));
                }
            }
            if (this.showPolygons === 'true') {
                for (let i = 0; i < this.polygons.length; i++) {
                    this.map.addFeature(this.polygonLayer.source, this.polygons[i]);
                }
            }
            if (this.showPoints === 'true') {
                this.pointLayer = this.map.addVectorLayer({});
                for (let i = 0; i < this.points.length; i++) {
                    this.map.addFeature(this.pointLayer.source, this.points[i]);
                }
            }
        }
        if (this.items) {
            if (this.showPolygons === 'true') {
                this.polygonLayer = this.map.addVectorLayer({});
                for (let i = 0; i < this.polygons.length; i++) {
                    this.map.addFeature(this.polygonLayer.source, this.polygons[i]);
                }
            }
        }
        if (this.map.getZoom() > 5) {
            this.map.setZoom(5);
        }
        if (this.searchRequest.g) {
            this.selectionLayer = this.map.addVectorLayer({});
            for (let key in this.searchRequest.g) {
                let feature = this.mapService.createPolygonFeature(this.searchRequest.g[key], [
                    new Style({
                        stroke: new Stroke({
                            color: 'rgba(14, 176, 100)',
                            width: 2,
                        }),
                        fill: new Fill({
                            color: 'rgba(14, 176, 100, 0.2)',
                        }),
                    })
                ]);
                this.map.addFeature(this.selectionLayer.source, feature);
            }
        }
        if (this.draw) {
            this.map.addDrawLayer();
            this.drawLayer = this.map.addVectorLayer({
                defaultStyle: {
                    'fill-color': 'rgba(14, 176, 100, 0.2)',
                    'stroke-color': 'rgba(14, 176, 100)'
                }
            });
            if (this.extent && (JSON.stringify(this.extent) !== JSON.stringify(this.defaultExtent)) && this.showExtent === 'true') {
                this.map.addFeature(this.drawLayer.source, this.mapService.bboxToPolygon(this.extent));
            }
        }
    }
    onFeatureDrawn(event) {
        this.onMapSearch.emit({
            name: "bbox",
            geometry: event.feature
        });
    }
    static { this.ɵfac = function GeosearchComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GeosearchComponent)(i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.MapService), i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GeosearchComponent, selectors: [["geosearch"]], viewQuery: function GeosearchComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MapComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.map = _t.first);
        } }, inputs: { items: "items", item: "item", extent: "extent", draw: "draw", showPolygons: "showPolygons", showPoints: "showPoints", showExtent: "showExtent" }, outputs: { onMapSearch: "onMapSearch" }, standalone: false, decls: 4, vars: 2, consts: [[1, "row"], [1, "col-md-12"], [3, "config", "mapReady", "featureDrawn", 4, "ngIf"], ["class", "col-md-12", 4, "ngIf"], [3, "mapReady", "featureDrawn", "config"], ["role", "alert", 1, "alert", "alert-warning"]], template: function GeosearchComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, GeosearchComponent_fi_map_2_Template, 1, 1, "fi-map", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, GeosearchComponent_div_3_Template, 3, 0, "div", 3);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.pageReady);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.items);
        } }, dependencies: [i3.NgIf, MapComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GeosearchComponent, [{
        type: Component,
        args: [{ selector: 'geosearch', standalone: false, template: "<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        <fi-map *ngIf=\"pageReady\" [config]=\"config\" (mapReady)=\"onMapReady($event)\" (featureDrawn)=\"onFeatureDrawn($event)\"></fi-map>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"items\">\r\n        <div class=\"alert alert-warning\" role=\"alert\">\r\n            The displayed bounding boxes are just the ones related to the results listed in the page\r\n          </div>\r\n    </div>\r\n</div>" }]
    }], () => [{ type: i2.ActivatedRoute }, { type: i1.MapService }, { type: i1.SearchService }, { type: i1.ConfigurationService }], { items: [{
            type: Input
        }], item: [{
            type: Input
        }], extent: [{
            type: Input
        }], draw: [{
            type: Input
        }], showPolygons: [{
            type: Input
        }], showPoints: [{
            type: Input
        }], showExtent: [{
            type: Input
        }], onMapSearch: [{
            type: Output
        }], map: [{
            type: ViewChild,
            args: [MapComponent]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(GeosearchComponent, { className: "GeosearchComponent", filePath: "src/components/geosearch/geosearch.component.ts", lineNumber: 17 }); })();

class ShareModalComponent {
    constructor(titleService) {
        this.titleService = titleService;
    }
    getUrl() {
        return window.location.href;
    }
    getTitle() {
        return this.titleService.getTitle();
    }
    static { this.ɵfac = function ShareModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ShareModalComponent)(i0.ɵɵdirectiveInject(i1$2.Title)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ShareModalComponent, selectors: [["fi-share-modal"]], standalone: false, decls: 27, vars: 13, consts: [["id", "shareModal", "tabindex", "-1", "aria-labelledby", "shareModalLabel", "aria-modal", "true", "role", "dialog", 1, "modal", "modal-share", "fade"], [1, "modal-dialog", "modal-dialog-centered"], [1, "modal-content"], [1, "modal-header"], ["id", "shareModalLabel", 1, "modal-title"], ["type", "button", "data-bs-dismiss", "modal", "aria-label", "Close", 1, "btn-close"], [1, "modal-body"], [1, "list-inline", "social-icons"], [1, "list-inline-item"], ["alt", "facebook", "title", "facebook", "target", "_blank", 3, "href"], ["src", "https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-facebook.svg", "alt", "facebook"], ["alt", "linkedin", "title", "linkedin", "target", "_blank", 3, "href"], ["src", "https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-linkedin.svg", "alt", "linkedin"], ["alt", "pinterest", "title", "pinterest", "target", "_blank", 3, "href"], ["src", "https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-pinterest.svg", "alt", "pinterest"], ["alt", "twitter X", "title", "twitter X", "target", "_blank", 3, "href"], ["src", "https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-twitter-x.svg", "alt", "twitter"], ["alt", "weibo", "title", "weibo", "target", "_blank", 3, "href"], ["src", "https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-weibo.svg", "alt", "weibo"], [1, "modal-footer"], ["type", "button", "data-bs-dismiss", "modal", 1, "btn", "btn-primary"]], template: function ShareModalComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "h5", 4);
            i0.ɵɵtext(5, " Share ");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(6, "button", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 6)(8, "ul", 7)(9, "li", 8)(10, "a", 9);
            i0.ɵɵelement(11, "img", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "li", 8)(13, "a", 11);
            i0.ɵɵelement(14, "img", 12);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "li", 8)(16, "a", 13);
            i0.ɵɵelement(17, "img", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(18, "li", 8)(19, "a", 15);
            i0.ɵɵelement(20, "img", 16);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(21, "li", 8)(22, "a", 17);
            i0.ɵɵelement(23, "img", 18);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(24, "div", 19)(25, "button", 20);
            i0.ɵɵtext(26, "Close");
            i0.ɵɵelementEnd()()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(10);
            i0.ɵɵpropertyInterpolate1("href", "https://www.facebook.com/sharer/sharer.php?u=", ctx.getUrl(), "", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate2("href", "https://www.linkedin.com/shareArticle?mini=true&title=", ctx.getTitle(), "&url=", ctx.getUrl(), "", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate2("href", "https://pinterest.com/pin/create/button/?url=", ctx.getUrl(), "&description=", ctx.getTitle(), "", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate1("href", "https://twitter.com/intent/tweet?text=", ctx.getUrl(), "", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate2("href", "https://service.weibo.com/share/share.php?title=", ctx.getTitle(), "&url=", ctx.getUrl(), "", i0.ɵɵsanitizeUrl);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShareModalComponent, [{
        type: Component,
        args: [{ selector: 'fi-share-modal', standalone: false, template: "<div class=\"modal modal-share fade\" id=\"shareModal\" tabindex=\"-1\" aria-labelledby=\"shareModalLabel\" aria-modal=\"true\" role=\"dialog\">\r\n    <div class=\"modal-dialog modal-dialog-centered\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <h5 class=\"modal-title\" id=\"shareModalLabel\">\r\n                    Share\r\n                </h5>\r\n                <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\r\n            </div>\r\n            <div class=\"modal-body\">\r\n                <ul class=\"list-inline social-icons\">\r\n                        <li class=\"list-inline-item\">\r\n                            <a href=\"https://www.facebook.com/sharer/sharer.php?u={{getUrl()}}\" alt=\"facebook\" title=\"facebook\" target=\"_blank\">\r\n                                <img src=\"https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-facebook.svg\" alt=\"facebook\">\r\n                            </a>\r\n                        </li>\r\n                                            <li class=\"list-inline-item\">\r\n                            <a href=\"https://www.linkedin.com/shareArticle?mini=true&amp;title={{getTitle()}}&amp;url={{getUrl()}}\" alt=\"linkedin\" title=\"linkedin\" target=\"_blank\">\r\n                                <img src=\"https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-linkedin.svg\" alt=\"linkedin\">\r\n                            </a>\r\n                        </li>\r\n                                            <li class=\"list-inline-item\">\r\n                            <a href=\"https://pinterest.com/pin/create/button/?url={{getUrl()}}&amp;description={{getTitle()}}\" alt=\"pinterest\" title=\"pinterest\" target=\"_blank\">\r\n                                <img src=\"https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-pinterest.svg\" alt=\"pinterest\">\r\n                            </a>\r\n                        </li>\r\n                                            <li class=\"list-inline-item\">\r\n                            <a href=\"https://twitter.com/intent/tweet?text={{getUrl()}}\" alt=\"twitter X\" title=\"twitter X\" target=\"_blank\">\r\n                                <img src=\"https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-twitter-x.svg\" alt=\"twitter\">\r\n                            </a>\r\n                        </li>\r\n                                            <li class=\"list-inline-item\">\r\n                            <a href=\"https://service.weibo.com/share/share.php?title={{getTitle()}}&amp;url={{getUrl()}}\" alt=\"weibo\" title=\"weibo\" target=\"_blank\">\r\n                                <img src=\"https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-weibo.svg\" alt=\"weibo\">\r\n                            </a>\r\n                        </li>\r\n                </ul>\r\n            </div>\r\n            <div class=\"modal-footer\">\r\n                <button type=\"button\" class=\"btn btn-primary\" data-bs-dismiss=\"modal\">Close</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n  </div>" }]
    }], () => [{ type: i1$2.Title }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ShareModalComponent, { className: "ShareModalComponent", filePath: "src/components/share-modal/share-modal.component.ts", lineNumber: 10 }); })();

function LoginButtonComponent_ng_container_0_p_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 2);
    i0.ɵɵlistener("click", function LoginButtonComponent_ng_container_0_p_button_1_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.configService.login()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("label", ctx_r1.configService.getTranslation("header.login"));
    i0.ɵɵproperty("icon", ctx_r1.icon);
} }
function LoginButtonComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoginButtonComponent_ng_container_0_p_button_1_Template, 1, 2, "p-button", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.configService.isLoggedIn());
} }
function LoginButtonComponent_ng_container_1_p_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 4);
    i0.ɵɵlistener("click", function LoginButtonComponent_ng_container_1_p_button_1_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.configService.login()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("label", ctx_r1.configService.getTranslation("header.login"));
    i0.ɵɵproperty("icon", ctx_r1.icon);
} }
function LoginButtonComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoginButtonComponent_ng_container_1_p_button_1_Template, 1, 2, "p-button", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.configService.isLoggedIn());
} }
class LoginButtonComponent {
    constructor(configService) {
        this.configService = configService;
        this.icon = "bi bi-pencil-square me-2";
    }
    static { this.ɵfac = function LoginButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoginButtonComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoginButtonComponent, selectors: [["fi-login-button"]], inputs: { variant: "variant", icon: "icon" }, standalone: false, decls: 2, vars: 2, consts: [[4, "ngIf"], ["variant", "text", "severity", "secondary", 3, "icon", "label", "click", 4, "ngIf"], ["variant", "text", "severity", "secondary", 3, "click", "icon", "label"], [3, "icon", "label", "click", 4, "ngIf"], [3, "click", "icon", "label"]], template: function LoginButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LoginButtonComponent_ng_container_0_Template, 2, 1, "ng-container", 0)(1, LoginButtonComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.variant && ctx.variant === "text");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.variant);
        } }, dependencies: [i3.NgIf, i7.Button], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginButtonComponent, [{
        type: Component,
        args: [{ selector: 'fi-login-button', standalone: false, template: "<ng-container *ngIf=\"variant && variant === 'text'\">\r\n    <p-button *ngIf=\"!configService.isLoggedIn()\"    \r\n        (click)=\"configService.login()\"\r\n        variant=\"text\"\r\n        severity=\"secondary\"\r\n        [icon]=\"icon\"\r\n        label=\"{{configService.getTranslation('header.login')}}\">\r\n    </p-button>\r\n</ng-container>\r\n\r\n<ng-container *ngIf=\"!variant\">\r\n    <p-button *ngIf=\"!configService.isLoggedIn()\"    \r\n        (click)=\"configService.login()\"\r\n        [icon]=\"icon\"\r\n        label=\"{{configService.getTranslation('header.login')}}\">\r\n    </p-button>\r\n</ng-container>" }]
    }], () => [{ type: i1.ConfigurationService }], { variant: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LoginButtonComponent, { className: "LoginButtonComponent", filePath: "src/components/login-button/login-button.component.ts", lineNumber: 10 }); })();

class RegisterButtonComponent {
    constructor(dialogService, configService) {
        this.dialogService = dialogService;
        this.configService = configService;
        this.cssClass = "btn btn-link btn-icon btn-icon-s btn-sm text-decoration-none text-color-gray-dark";
        this.icon = "bi bi-person-circle me-2";
    }
    register() {
        const ref = this.dialogService.open(UserRegisterComponent, {
            header: 'Registration',
            width: '50%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    static { this.ɵfac = function RegisterButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RegisterButtonComponent)(i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RegisterButtonComponent, selectors: [["fi-register-button"]], inputs: { cssClass: "cssClass", icon: "icon" }, standalone: false, decls: 4, vars: 4, consts: [[3, "click", "ngClass"]], template: function RegisterButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function RegisterButtonComponent_Template_button_click_0_listener() { return ctx.register(); });
            i0.ɵɵelement(1, "i");
            i0.ɵɵelementStart(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.cssClass);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.icon);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.configService.getTranslation("header.signup"));
        } }, dependencies: [i3.NgClass], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RegisterButtonComponent, [{
        type: Component,
        args: [{ selector: 'fi-register-button', standalone: false, template: "<button\r\n    [ngClass]=\"cssClass\" (click)=\"register()\">\r\n    <i [class]=\"icon\"></i><span>{{configService.getTranslation('header.signup')}}</span></button>" }]
    }], () => [{ type: i1$1.DialogService }, { type: i1.ConfigurationService }], { cssClass: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(RegisterButtonComponent, { className: "RegisterButtonComponent", filePath: "src/components/register-button/register-button.component.ts", lineNumber: 12 }); })();

function LogoutButtonComponent_ng_container_0_p_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 3);
    i0.ɵɵlistener("click", function LogoutButtonComponent_ng_container_0_p_button_3_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.configService.logout(ctx_r1.redirectUrl)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("label", ctx_r1.configService.getTranslation("header.logout"));
} }
function LogoutButtonComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 1);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LogoutButtonComponent_ng_container_0_p_button_3_Template, 1, 1, "p-button", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.configService.getUser().email);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.configService.isLoggedIn());
} }
function LogoutButtonComponent_ng_container_1_p_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 5);
    i0.ɵɵlistener("click", function LogoutButtonComponent_ng_container_1_p_button_1_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.configService.logout(ctx_r1.redirectUrl)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("label", ctx_r1.configService.getTranslation("header.logout"));
} }
function LogoutButtonComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LogoutButtonComponent_ng_container_1_p_button_1_Template, 1, 1, "p-button", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.configService.isLoggedIn());
} }
class LogoutButtonComponent {
    constructor(configService) {
        this.configService = configService;
        this.header = false;
        this.cssClass = "btn btn-link btn-icon text-decoration-none text-color-gray-dark";
    }
    static { this.ɵfac = function LogoutButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LogoutButtonComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LogoutButtonComponent, selectors: [["fi-logout-button"]], inputs: { header: "header", redirectUrl: "redirectUrl", cssClass: "cssClass" }, standalone: false, decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "text-color-gray-medium"], ["variant", "text", "severity", "secondary", "icon", "bi bi-x-lg", 3, "label", "click", 4, "ngIf"], ["variant", "text", "severity", "secondary", "icon", "bi bi-x-lg", 3, "click", "label"], ["icon", "bi bi-x-lg", 3, "label", "click", 4, "ngIf"], ["icon", "bi bi-x-lg", 3, "click", "label"]], template: function LogoutButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LogoutButtonComponent_ng_container_0_Template, 4, 2, "ng-container", 0)(1, LogoutButtonComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.header);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.header);
        } }, dependencies: [i3.NgIf, i7.Button], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogoutButtonComponent, [{
        type: Component,
        args: [{ selector: 'fi-logout-button', standalone: false, template: "<!-- <button \r\n    type=\"button\" class=\"btn-close\" *ngIf=\"configService.isLoggedIn()\"\r\n    data-bs-dismiss=\"offcanvas\" aria-label=\"Close\" data-bs-target=\"#bdNavbar\" (click)=\"configService.logout()\"></button> -->\r\n\r\n<ng-container *ngIf=\"header\">\r\n    <span class=\"text-color-gray-medium\">{{ configService.getUser().email }}</span>\r\n    <p-button *ngIf=\"configService.isLoggedIn()\"\r\n        (click)=\"configService.logout(redirectUrl)\"\r\n        variant=\"text\"\r\n        severity=\"secondary\"\r\n        icon=\"bi bi-x-lg\" label=\"{{configService.getTranslation('header.logout')}}\">\r\n    </p-button>\r\n</ng-container>\r\n\r\n<ng-container *ngIf=\"!header\">\r\n    <p-button *ngIf=\"configService.isLoggedIn()\"\r\n    (click)=\"configService.logout(redirectUrl)\"\r\n    icon=\"bi bi-x-lg\" label=\"{{configService.getTranslation('header.logout')}}\">\r\n</p-button>\r\n</ng-container>" }]
    }], () => [{ type: i1.ConfigurationService }], { header: [{
            type: Input
        }], redirectUrl: [{
            type: Input
        }], cssClass: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LogoutButtonComponent, { className: "LogoutButtonComponent", filePath: "src/components/logout-button/logout-button.component.ts", lineNumber: 10 }); })();

function DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_ng_template_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementEnd();
} }
function DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_ng_template_1_span_3_Template, 2, 0, "span", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
} }
function DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_p_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 18);
    i0.ɵɵlistener("click", function DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_p_button_6_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-fieldset", 9);
    i0.ɵɵtemplate(1, DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_ng_template_1_Template, 4, 2, "ng-template", 10)(2, DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_ng_container_2_Template, 1, 0, "ng-container", 11)(3, DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_ng_container_3_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementStart(4, "div", 12)(5, "div", 7);
    i0.ɵɵtemplate(6, DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_p_button_6_Template, 1, 2, "p-button", 13);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    const quickhelp_r3 = i0.ɵɵreference(2);
    const single_r4 = i0.ɵɵreference(4);
    i0.ɵɵproperty("collapsed", ctx_r0.dynamicFormObject.collapsed)("toggleable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", single_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", quickhelp_r3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
} }
function DynamicFormGeometryComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, DynamicFormGeometryComponent_div_0_div_1_p_fieldset_1_Template, 7, 5, "p-fieldset", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.hideLabel === false);
} }
function DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_ng_template_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementEnd();
} }
function DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_ng_template_1_span_3_Template, 2, 0, "span", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "label"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.required);
} }
function DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_p_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 18);
    i0.ɵɵlistener("click", function DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_p_button_6_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.showHelp(ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help"))); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true)("outlined", true);
} }
function DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_p_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 23);
    i0.ɵɵlistener("click", function DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_p_button_8_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.addFormArrayElement()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("rounded", true);
} }
function DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-fieldset", 9);
    i0.ɵɵtemplate(1, DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_ng_template_1_Template, 4, 2, "ng-template", 10)(2, DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_ng_container_2_Template, 1, 0, "ng-container", 11)(3, DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_ng_container_3_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementStart(4, "div", 12)(5, "div", 20);
    i0.ɵɵtemplate(6, DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_p_button_6_Template, 1, 2, "p-button", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 21);
    i0.ɵɵtemplate(8, DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_p_button_8_Template, 1, 1, "p-button", 22);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    const quickhelp_r3 = i0.ɵɵreference(2);
    const multiple_r7 = i0.ɵɵreference(6);
    i0.ɵɵproperty("collapsed", ctx_r0.dynamicFormObject.collapsed)("toggleable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", quickhelp_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", multiple_r7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "help") > "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly || ctx_r0.operation === "edit" && !ctx_r0.dynamicFormObject.editBlocked);
} }
function DynamicFormGeometryComponent_div_0_div_2_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormGeometryComponent_div_0_div_2_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DynamicFormGeometryComponent_div_0_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormGeometryComponent_div_0_div_2_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 11)(2, DynamicFormGeometryComponent_div_0_div_2_ng_container_2_ng_container_2_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(3);
    const quickhelp_r3 = i0.ɵɵreference(2);
    const multiple_r7 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", quickhelp_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", multiple_r7);
} }
function DynamicFormGeometryComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, DynamicFormGeometryComponent_div_0_div_2_p_fieldset_1_Template, 9, 6, "p-fieldset", 8)(2, DynamicFormGeometryComponent_div_0_div_2_ng_container_2_Template, 3, 2, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.hideLabel === false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.hideLabel === true);
} }
function DynamicFormGeometryComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "debug-details", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("data", ctx_r0.form.getRawValue())("xpath", ctx_r0.xpath);
} }
function DynamicFormGeometryComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "form-errors-manager", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("errors", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code].errors)("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject);
} }
function DynamicFormGeometryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, DynamicFormGeometryComponent_div_0_div_1_Template, 2, 1, "div", 5)(2, DynamicFormGeometryComponent_div_0_div_2_Template, 3, 2, "div", 5)(3, DynamicFormGeometryComponent_div_0_div_3_Template, 2, 4, "div", 6)(4, DynamicFormGeometryComponent_div_0_div_4_Template, 2, 3, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.dynamicFormObject.multipleValues);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.multipleValues);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.debug);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.form && ctx_r0.form.controls && ctx_r0.form.controls[ctx_r0.dynamicFormObject.code] && !ctx_r0.form.controls[ctx_r0.dynamicFormObject.code].valid && ctx_r0.form.controls[ctx_r0.dynamicFormObject.code].touched);
} }
function DynamicFormGeometryComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "html-renderer", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("template", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp"));
} }
function DynamicFormGeometryComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicFormGeometryComponent_ng_template_1_div_0_Template, 2, 1, "div", 27);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormControlService.getProperty(ctx_r0.parentForm.getRawValue(), ctx_r0.dynamicForm, ctx_r0.dynamicFormObject, "quickhelp") > "");
} }
function DynamicFormGeometryComponent_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4)(2, "div", 7);
    i0.ɵɵelement(3, "fi-map", 30);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("config", ctx_r0.config);
} }
function DynamicFormGeometryComponent_ng_template_3_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "dynamic-form-geometry-item", 31);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", ctx_r0.form)("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("config", ctx_r0.config)("readonly", ctx_r0.readonly)("operation", ctx_r0.operation);
} }
function DynamicFormGeometryComponent_ng_template_3_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4)(2, "div", 7);
    i0.ɵɵelement(3, "dynamic-form-geometry-item", 31);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("form", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code])("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("config", ctx_r0.config)("readonly", ctx_r0.readonly)("operation", ctx_r0.operation);
} }
function DynamicFormGeometryComponent_ng_template_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormGeometryComponent_ng_template_3_ng_container_1_ng_container_1_Template, 2, 6, "ng-container", 19)(2, DynamicFormGeometryComponent_ng_template_3_ng_container_1_ng_container_2_Template, 4, 6, "ng-container", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type !== "geogeometry");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "geogeometry");
} }
function DynamicFormGeometryComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicFormGeometryComponent_ng_template_3_ng_container_0_Template, 4, 1, "ng-container", 19)(1, DynamicFormGeometryComponent_ng_template_3_ng_container_1_Template, 3, 2, "ng-container", 19);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.operation === "view");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.operation !== "view");
} }
function DynamicFormGeometryComponent_ng_template_5_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40)(1, "button", 41);
    i0.ɵɵlistener("click", function DynamicFormGeometryComponent_ng_template_5_div_3_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r8); const arrayGroupElementIndex_r9 = i0.ɵɵnextContext().index; const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.removeFormArrayElement(arrayGroupElementIndex_r9)); });
    i0.ɵɵelement(2, "i", 42);
    i0.ɵɵelementEnd()();
} }
function DynamicFormGeometryComponent_ng_template_5_div_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4)(2, "div", 7);
    i0.ɵɵelement(3, "fi-map", 30);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("config", ctx_r0.config);
} }
function DynamicFormGeometryComponent_ng_template_5_div_3_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "dynamic-form-geometry-item", 31);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const arrayGroupElement_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("form", arrayGroupElement_r10)("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("config", ctx_r0.config)("readonly", ctx_r0.readonly)("operation", ctx_r0.operation);
} }
function DynamicFormGeometryComponent_ng_template_5_div_3_ng_container_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4)(2, "div", 7);
    i0.ɵɵelement(3, "dynamic-form-geometry-item", 31);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const arrayGroupElement_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("form", arrayGroupElement_r10)("dynamicForm", ctx_r0.dynamicForm)("dynamicFormObject", ctx_r0.dynamicFormObject)("config", ctx_r0.config)("readonly", ctx_r0.readonly)("operation", ctx_r0.operation);
} }
function DynamicFormGeometryComponent_ng_template_5_div_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormGeometryComponent_ng_template_5_div_3_ng_container_5_ng_container_1_Template, 2, 6, "ng-container", 19)(2, DynamicFormGeometryComponent_ng_template_5_div_3_ng_container_5_ng_container_2_Template, 4, 6, "ng-container", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type !== "geogeometry");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.dynamicFormObject.type === "geogeometry");
} }
function DynamicFormGeometryComponent_ng_template_5_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtemplate(1, DynamicFormGeometryComponent_ng_template_5_div_3_div_1_Template, 3, 0, "div", 37);
    i0.ɵɵelementStart(2, "div", 38)(3, "div", 39);
    i0.ɵɵtemplate(4, DynamicFormGeometryComponent_ng_template_5_div_3_ng_container_4_Template, 4, 1, "ng-container", 19)(5, DynamicFormGeometryComponent_ng_template_5_div_3_ng_container_5_Template, 3, 2, "ng-container", 19);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.readonly || ctx_r0.operation === "edit" && !ctx_r0.dynamicFormObject.editBlocked);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.operation === "view");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.operation !== "view");
} }
function DynamicFormGeometryComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 32);
    i0.ɵɵelementStart(1, "div", 33)(2, "div", 34);
    i0.ɵɵtemplate(3, DynamicFormGeometryComponent_ng_template_5_div_3_Template, 6, 3, "div", 35);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formArrayName", ctx_r0.dynamicFormObject.code);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.form.controls[ctx_r0.dynamicFormObject.code]["controls"]);
} }
class DynamicFormGeometryComponent {
    constructor(dynamicFormService, dynamicFormControlService, configService, dialogService, optionsService, mapService, fb) {
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.configService = configService;
        this.dialogService = dialogService;
        this.optionsService = optionsService;
        this.mapService = mapService;
        this.fb = fb;
        this.debug = false;
        this.readonly = false;
        this.pageReady = false;
        this.defaultExtent = [-180, -90, 180, 90];
        this.initializing = false;
    }
    async ngOnInit() {
        this.xpath = this.dynamicFormControlService.getXpath(this.dynamicFormObject, this.xpath);
        this.init();
    }
    showHelp(description) {
        const ref = this.dialogService.open(HelpComponent, {
            data: {
                description: description
            },
            header: 'Help',
            width: '50%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    addFormArrayElement(keyboard) {
        if (!keyboard || (keyboard && keyboard.keyCode === 9)) {
            let fa = this.form.controls[this.dynamicFormObject.code];
            if (!isNaN(fa.value.length)) {
                if (this.dynamicFormObject.type === "geogeometry") {
                    fa.push(new FormGroup({
                        type: new FormControl("GeometryCollection"),
                        geometries: new FormArray([])
                    }));
                }
                else {
                    fa.push(this.dynamicFormControlService.createFormControl(this.dynamicForm, this.dynamicFormObject, null));
                }
            }
        }
    }
    removeFormArrayElement(i) {
        let fa = this.form.controls[this.dynamicFormObject.code];
        fa.removeAt(i);
    }
    init() {
        let layers = [];
        for (let name in this.configService.env.mapConfig?.layers) {
            layers.push(this.mapService.getLayer(this.configService.env.mapConfig, null, this.dynamicForm, name));
        }
        let featureType;
        if (this.dynamicFormObject.type === "geopoint") {
            featureType = "Point";
        }
        else if (this.dynamicFormObject.type === "geoline") {
            featureType = "LineString";
        }
        else if (this.dynamicFormObject.type === "geopolygon") {
            featureType = "Polygon";
        }
        else {
            //Geogeometry
            featureType = "Polygon";
        }
        this.config =
            {
                layers: layers,
                showLegends: false,
                extent: this.extent || this.defaultExtent,
                draw: {
                    enabled: true,
                    featureType: featureType,
                    mode: this.dynamicFormObject.type === 'geogeometry' ? 'multiple' : 'single',
                    zoomToFeature: true,
                    showFeatureTypes: (this.dynamicFormObject.type === "geogeometry")
                },
                constrainResolution: true,
                layersList: {
                    position: "top-right"
                }
            };
        this.pageReady = true;
    }
    static { this.ɵfac = function DynamicFormGeometryComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormGeometryComponent)(i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.OptionsService), i0.ɵɵdirectiveInject(i1.MapService), i0.ɵɵdirectiveInject(i5.FormBuilder)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormGeometryComponent, selectors: [["dynamic-form-geometry-view"]], viewQuery: function DynamicFormGeometryComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MapComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.map = _t.first);
        } }, inputs: { group: "group", dynamicForm: "dynamicForm", parentDynamicForm: "parentDynamicForm", dynamicFormObject: "dynamicFormObject", parentDynamicFormObject: "parentDynamicFormObject", form: "form", parentForm: "parentForm", debug: "debug", statuses: "statuses", readonly: "readonly", operation: "operation", xpath: "xpath", hideLabel: "hideLabel" }, standalone: false, decls: 7, vars: 1, consts: [["quickhelp", ""], ["single", ""], ["multiple", ""], ["class", "row", 4, "ngIf"], [1, "row"], ["class", "col-md-12", 4, "ngIf"], ["class", "col-md-12 mt-2 mb-2", 4, "ngIf"], [1, "col-md-12"], [3, "collapsed", "toggleable", 4, "ngIf"], [3, "collapsed", "toggleable"], ["pTemplate", "header"], [4, "ngTemplateOutlet"], [1, "row", "mt-3"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "rounded", "outlined", "click", 4, "ngIf"], [1, "flex", "align-items-center"], ["class", "mandatory", 4, "ngIf"], [1, "mandatory"], [1, "bi", "bi-asterisk"], ["icon", "pi pi-info-circle", "severity", "warn", "title", "Help", 3, "click", "rounded", "outlined"], [4, "ngIf"], [1, "col-md-6"], [1, "col-md-6", "align-right"], ["icon", "pi pi-plus", 3, "rounded", "click", 4, "ngIf"], ["icon", "pi pi-plus", 3, "click", "rounded"], [1, "col-md-12", "mt-2", "mb-2"], [3, "dynamicForm", "dynamicFormObject", "data", "xpath"], [3, "errors", "dynamicForm", "dynamicFormObject"], ["class", "form-control-footer text-color-gray-medium", 4, "ngIf"], [1, "form-control-footer", "text-color-gray-medium"], [3, "template"], [3, "config"], [3, "form", "dynamicForm", "dynamicFormObject", "config", "readonly", "operation"], [3, "formGroup"], [1, "row", 3, "formArrayName"], [1, "col-md-12", "mt-2"], ["class", "multiple-values-item", 4, "ngFor", "ngForOf"], [1, "multiple-values-item"], ["class", "multiple-values-item-actions", 4, "ngIf"], [1, "multiple-values-item-content"], [1, "multiple-values-item-body"], [1, "multiple-values-item-actions"], ["title", "Remove item", "type", "button", "tabindex", "-1", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-trash"]], template: function DynamicFormGeometryComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicFormGeometryComponent_div_0_Template, 5, 4, "div", 3)(1, DynamicFormGeometryComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, DynamicFormGeometryComponent_ng_template_3_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, DynamicFormGeometryComponent_ng_template_5_Template, 4, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form && ctx.pageReady);
        } }, styles: [".effect[_ngcontent-%COMP%]{opacity:1;animation:_ngcontent-%COMP%_fade 5s linear}@keyframes _ngcontent-%COMP%_fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator[_ngcontent-%COMP%]{width:100%}.form-check-label[_ngcontent-%COMP%]{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items[_ngcontent-%COMP%]{list-style:none;font-size:.9rem}.help-button[_ngcontent-%COMP%]{margin:5px}.help-button[_ngcontent-%COMP%]:hover{cursor:pointer}.component-header[_ngcontent-%COMP%]{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{margin-left:10px}.form-control-footer[_ngcontent-%COMP%]{font-size:.8em}.mandatory[_ngcontent-%COMP%]{font-size:50%;vertical-align:top;color:red}.app-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}.header-title[_ngcontent-%COMP%]:hover{cursor:pointer}.status-label[_ngcontent-%COMP%]{font-size:1em;font-weight:700}.component-label[_ngcontent-%COMP%]{font-size:1em}.component-label.horizontal[_ngcontent-%COMP%], label.title-category[_ngcontent-%COMP%]{font-size:.9em}.float[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.panel-body[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading[_ngcontent-%COMP%]{min-height:45px;display:flex}.panel-heading[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-height:40px}.multiple-values-item[_ngcontent-%COMP%]{display:flex;flex-grow:1}.multiple-values-item-content[_ngcontent-%COMP%]{width:95%}.multiple-values-item-body[_ngcontent-%COMP%]{width:95%;margin-bottom:5px}.array-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:.9em}.header-title[_ngcontent-%COMP%]{vertical-align:middle}.card[_ngcontent-%COMP%]{margin-bottom:.5em}.refresh-button[_ngcontent-%COMP%]{margin:.5em}.refresh-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ref-form[_ngcontent-%COMP%]{display:flex;align-items:baseline}img[_ngcontent-%COMP%]{max-width:100%;height:auto}.collapse[_ngcontent-%COMP%]{display:none!important}.collapse.in[_ngcontent-%COMP%]{display:block!important}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form[_ngcontent-%COMP%]   .p-fieldset[_ngcontent-%COMP%]   .p-fieldset-legend[_ngcontent-%COMP%]{font-size:.8em!important}.dynamic-form-summary-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%]{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{margin-left:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%], .dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-icon[_ngcontent-%COMP%]{font-size:20px!important}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.control-cell.content[_ngcontent-%COMP%]{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu[_ngcontent-%COMP%]{width:55px}.form-group[_ngcontent-%COMP%]{border:solid 1px rgba(0,0,0,.125);margin:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormGeometryComponent, [{
        type: Component,
        args: [{ selector: 'dynamic-form-geometry-view', standalone: false, template: "<div class=\"row\" *ngIf=\"form && pageReady\">\r\n\r\n    <!-- SINGLE VALUE -->\r\n    <div class=\"col-md-12\" *ngIf=\"!dynamicFormObject.multipleValues\">\r\n\r\n        <p-fieldset [collapsed]=\"dynamicFormObject.collapsed\" [toggleable]=\"true\" *ngIf=\"hideLabel === false\">\r\n            <ng-template pTemplate=\"header\">\r\n                <div class=\"flex align-items-center\">\r\n                    <label>{{dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'label')}}</label>\r\n                    <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n                </div>\r\n            </ng-template>\r\n            \r\n            <ng-container *ngTemplateOutlet=\"single\"></ng-container>\r\n            <ng-container *ngTemplateOutlet=\"quickhelp\"></ng-container>\r\n\r\n            <div class=\"row mt-3\">\r\n                <div class=\"col-md-12\">\r\n                    <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\"\r\n                        *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\"\r\n                        title=\"Help\"\r\n                        (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\"></p-button>\r\n                </div>\r\n            </div>\r\n        </p-fieldset>\r\n        \r\n    </div>\r\n    <!-- --------------- -->\r\n\r\n    <!-- MULTIPLE VALUES -->\r\n    <div class=\"col-md-12\" *ngIf=\"dynamicFormObject.multipleValues\">\r\n\r\n        <p-fieldset [collapsed]=\"dynamicFormObject.collapsed\" [toggleable]=\"true\" *ngIf=\"hideLabel === false\">\r\n            <ng-template pTemplate=\"header\">\r\n                <div class=\"flex align-items-center\">\r\n                    <label>{{dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm,\r\n                        dynamicFormObject, 'label')}}</label>\r\n                    <span class=\"mandatory\" *ngIf=\"dynamicFormObject.required\"><i class=\"bi bi-asterisk\"></i></span>\r\n                </div>\r\n            </ng-template>\r\n\r\n            <ng-container *ngTemplateOutlet=\"quickhelp\"></ng-container>\r\n            <ng-container *ngTemplateOutlet=\"multiple\"></ng-container>\r\n\r\n            <div class=\"row mt-3\">\r\n                <div class=\"col-md-6\">\r\n                    <p-button icon=\"pi pi-info-circle\" [rounded]=\"true\" severity=\"warn\" [outlined]=\"true\"\r\n                        *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help') > ''\"\r\n                        title=\"Help\"\r\n                        (click)=\"showHelp(dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'help'))\"></p-button>\r\n                </div>\r\n                <div class=\"col-md-6 align-right\">\r\n                    <p-button *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\" icon=\"pi pi-plus\" [rounded]=\"true\" (click)=\"addFormArrayElement()\"></p-button>\r\n                </div>\r\n            </div>\r\n        </p-fieldset>\r\n\r\n        <ng-container *ngIf=\"hideLabel === true\">\r\n            <ng-container *ngTemplateOutlet=\"quickhelp\"></ng-container>\r\n            <ng-container *ngTemplateOutlet=\"multiple\"></ng-container>\r\n        </ng-container>\r\n\r\n    </div>\r\n    <!-- --------------- -->\r\n\r\n    <!-- FOOTER -->\r\n    <div class=\"col-md-12 mt-2 mb-2\" *ngIf=\"debug\">\r\n        <debug-details [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [data]=\"form.getRawValue()\"\r\n            [xpath]=\"xpath\"></debug-details>\r\n    </div>\r\n\r\n    <div class=\"col-md-12\"\r\n        *ngIf=\"form && form.controls && form.controls[dynamicFormObject.code] && !form.controls[dynamicFormObject.code].valid && form.controls[dynamicFormObject.code].touched\">\r\n        <form-errors-manager [errors]=\"form.controls[dynamicFormObject.code].errors\" [dynamicForm]=\"dynamicForm\"\r\n            [dynamicFormObject]=\"dynamicFormObject\"></form-errors-manager>\r\n    </div>\r\n</div>\r\n\r\n<!-- --------- -->\r\n<!-- TEMPLATES -->\r\n<!-- --------- -->\r\n\r\n<!-- QUICK HELP -->\r\n<ng-template #quickhelp>\r\n    <div class=\"form-control-footer text-color-gray-medium\" *ngIf=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp') > ''\">\r\n        <html-renderer [template]=\"dynamicFormControlService.getProperty(parentForm.getRawValue(), dynamicForm, dynamicFormObject, 'quickhelp')\"></html-renderer>\r\n    </div>\r\n</ng-template>\r\n\r\n<!-- SINGLE CONTENT -->\r\n<ng-template #single>\r\n\r\n    <!-- Display -->\r\n    <ng-container *ngIf=\"operation === 'view'\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <fi-map [config]=\"config\"></fi-map>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n\r\n    <!-- Editing -->\r\n    <ng-container *ngIf=\"operation !== 'view'\">\r\n        \r\n        <!-- Single feature not geogeometry -->\r\n        <ng-container *ngIf=\"dynamicFormObject.type !== 'geogeometry'\">\r\n            <dynamic-form-geometry-item [form]=\"form\" [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [config]=\"config\" [readonly]=\"readonly\" [operation]=\"operation\"></dynamic-form-geometry-item>\r\n        </ng-container>\r\n\r\n        <!-- Single feature geogeometry -->\r\n        <ng-container *ngIf=\"dynamicFormObject.type === 'geogeometry'\">\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                    <dynamic-form-geometry-item [form]=\"form.controls[dynamicFormObject.code]\" [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [config]=\"config\" [readonly]=\"readonly\" [operation]=\"operation\"></dynamic-form-geometry-item>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n\r\n    </ng-container>    \r\n\r\n</ng-template>\r\n\r\n<!-- MULTIPLE CONTENT -->\r\n<ng-template #multiple>\r\n\r\n    <ng-container [formGroup]=\"form\">\r\n        <div class=\"row\" [formArrayName]=\"dynamicFormObject.code\">\r\n          <div class=\"col-md-12 mt-2\">\r\n            <div class=\"multiple-values-item\" *ngFor=\"let arrayGroupElement of form.controls[dynamicFormObject.code]['controls']; let arrayGroupElementIndex=index\">\r\n              <div class=\"multiple-values-item-actions\" *ngIf=\"!readonly || (operation === 'edit' && !dynamicFormObject.editBlocked)\">\r\n                <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n                  (click)=\"removeFormArrayElement(arrayGroupElementIndex)\" tabindex=\"-1\">\r\n                  <i class=\"bi bi-trash\"></i>\r\n                </button>\r\n              </div>\r\n              \r\n              <div class=\"multiple-values-item-content\">\r\n                <div class=\"multiple-values-item-body\">\r\n      \r\n                    <!-- Display -->\r\n                    <ng-container *ngIf=\"operation === 'view'\">\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-12\">\r\n                                <fi-map [config]=\"config\"></fi-map>\r\n                            </div>\r\n                        </div>\r\n                    </ng-container>\r\n\r\n                    <!-- Editing -->\r\n                    <ng-container *ngIf=\"operation !== 'view'\">\r\n                        \r\n                        <!-- Multiple feature not geogeometry -->\r\n                        <ng-container *ngIf=\"dynamicFormObject.type !== 'geogeometry'\">\r\n                            <dynamic-form-geometry-item [form]=\"arrayGroupElement\" [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [config]=\"config\" [readonly]=\"readonly\" [operation]=\"operation\"></dynamic-form-geometry-item>\r\n                        </ng-container>\r\n\r\n                        <!-- Multiple feature geogeometry -->\r\n                        <ng-container *ngIf=\"dynamicFormObject.type === 'geogeometry'\">\r\n                            <div class=\"row\">\r\n                                <div class=\"col-md-12\">\r\n                                    <dynamic-form-geometry-item [form]=\"arrayGroupElement\" [dynamicForm]=\"dynamicForm\" [dynamicFormObject]=\"dynamicFormObject\" [config]=\"config\" [readonly]=\"readonly\" [operation]=\"operation\"></dynamic-form-geometry-item>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                    </ng-container>  \r\n      \r\n                </div>\r\n              </div>\r\n            </div>\r\n      \r\n          </div>\r\n        </div>\r\n    </ng-container>\r\n\r\n</ng-template>", styles: [".effect{opacity:1;animation:fade 5s linear}@keyframes fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator{width:100%}.form-check-label{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items{list-style:none;font-size:.9rem}.help-button{margin:5px}.help-button:hover{cursor:pointer}.component-header{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header .header-title{margin-left:10px}.form-control-footer{font-size:.8em}.mandatory{font-size:50%;vertical-align:top;color:red}.app-menu-disabled{pointer-events:none;opacity:.6}.header-title:hover{cursor:pointer}.status-label{font-size:1em;font-weight:700}.component-label{font-size:1em}.component-label.horizontal,label.title-category{font-size:.9em}.float{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float>*{margin-left:5px;margin-right:5px}.panel-body{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading{min-height:45px;display:flex}.panel-heading .header-title{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading button{max-height:40px}.multiple-values-item{display:flex;flex-grow:1}.multiple-values-item-content{width:95%}.multiple-values-item-body{width:95%;margin-bottom:5px}.array-items button{font-size:.9em}.header-title{vertical-align:middle}.card{margin-bottom:.5em}.refresh-button{margin:.5em}.refresh-button:hover{cursor:pointer}.ref-form{display:flex;align-items:baseline}img{max-width:100%;height:auto}.collapse{display:none!important}.collapse.in{display:block!important}.collapsing{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form .p-fieldset .p-fieldset-legend{font-size:.8em!important}.dynamic-form-summary-view{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view .form-tree{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view .form-questions{margin-left:5px}.dynamic-form-summary-view .form-tree,.dynamic-form-summary-view .form-questions{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form{width:100%}form .item-icon{font-size:20px!important}form .item-switcher{width:100%}form .item-switcher>div{width:100%}.control-cell.content{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu{width:55px}.form-group{border:solid 1px rgba(0,0,0,.125);margin:1em}\n"] }]
    }], () => [{ type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i1.ConfigurationService }, { type: i1$1.DialogService }, { type: i1.OptionsService }, { type: i1.MapService }, { type: i5.FormBuilder }], { group: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], parentDynamicForm: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], parentDynamicFormObject: [{
            type: Input
        }], form: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], debug: [{
            type: Input
        }], statuses: [{
            type: Input
        }], readonly: [{
            type: Input
        }], operation: [{
            type: Input
        }], xpath: [{
            type: Input
        }], hideLabel: [{
            type: Input
        }], map: [{
            type: ViewChild,
            args: [MapComponent]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormGeometryComponent, { className: "DynamicFormGeometryComponent", filePath: "src/dynamic-form/dynamic-form-geometry/dynamic-form-geometry.component.ts", lineNumber: 15 }); })();

function JsonViewerComponent_div_1_ngx_json_viewer_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ngx-json-viewer", 5);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("json", ctx_r0.value)("expanded", false);
} }
function JsonViewerComponent_div_1_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1, "(empty)");
    i0.ɵɵelementEnd();
} }
function JsonViewerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, JsonViewerComponent_div_1_ngx_json_viewer_1_Template, 1, 2, "ngx-json-viewer", 3)(2, JsonViewerComponent_div_1_label_2_Template, 2, 0, "label", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.utilsService.isObjectEmpty(ctx_r0.value));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.utilsService.isObjectEmpty(ctx_r0.value));
} }
function JsonViewerComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
} }
class JsonViewerComponent {
    set id(value) {
        this._ID = value;
        this.externalId = null;
    }
    get id() {
        return this._ID;
    }
    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val || {};
        this.onChange(val);
        this.onTouched();
    }
    constructor(utilsService) {
        this.utilsService = utilsService;
        this.view = 'detail';
        this.externalId = '';
        this._ID = '';
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    ngOnInit() {
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    writeValue(value) {
        this.value = value || {};
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    static { this.ɵfac = function JsonViewerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || JsonViewerComponent)(i0.ɵɵdirectiveInject(i1.UtilsService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: JsonViewerComponent, selectors: [["json-viewer"]], hostVars: 1, hostBindings: function JsonViewerComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵattribute("id", ctx.externalId);
        } }, inputs: { view: "view", _value: [0, "value", "_value"], id: "id" }, standalone: false, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => JsonViewerComponent),
                    multi: true,
                }
            ])], decls: 3, vars: 2, consts: [[1, "row"], ["class", "col-md-12", 4, "ngIf"], [1, "col-md-12"], [3, "json", "expanded", 4, "ngIf"], [4, "ngIf"], [3, "json", "expanded"]], template: function JsonViewerComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, JsonViewerComponent_div_1_Template, 3, 2, "div", 1)(2, JsonViewerComponent_div_2_Template, 1, 0, "div", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.view === "detail");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.view === "list");
        } }, dependencies: [i3.NgIf, i4.NgxJsonViewerComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonViewerComponent, [{
        type: Component,
        args: [{ selector: 'json-viewer', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => JsonViewerComponent),
                        multi: true,
                    }
                ], standalone: false, template: "<div class=\"row\">\r\n    <div class=\"col-md-12\" *ngIf=\"view === 'detail'\">\r\n        <ngx-json-viewer *ngIf=\"!utilsService.isObjectEmpty(value)\" [json]=\"value\" [expanded]=\"false\"></ngx-json-viewer>\r\n        <label *ngIf=\"utilsService.isObjectEmpty(value)\">(empty)</label>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"view === 'list'\">\r\n      \r\n    </div>\r\n  </div>" }]
    }], () => [{ type: i1.UtilsService }], { view: [{
            type: Input
        }], _value: [{
            type: Input,
            args: ['value']
        }], externalId: [{
            type: HostBinding,
            args: ['attr.id']
        }], id: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(JsonViewerComponent, { className: "JsonViewerComponent", filePath: "src/components/json-viewer/json-viewer.component.ts", lineNumber: 18 }); })();

function GeometryEditorComponent_p_panel_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4);
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "input", 5);
    i0.ɵɵtwoWayListener("ngModelChange", function GeometryEditorComponent_p_panel_0_ng_container_1_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r1.value.coordinates[0], $event) || (ctx_r1.value.coordinates[0] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function GeometryEditorComponent_p_panel_0_ng_container_1_Template_input_ngModelChange_4_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onGeometryChange()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(5);
    i0.ɵɵelementStart(6, "input", 6);
    i0.ɵɵtwoWayListener("ngModelChange", function GeometryEditorComponent_p_panel_0_ng_container_1_Template_input_ngModelChange_6_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r1.value.coordinates[1], $event) || (ctx_r1.value.coordinates[1] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function GeometryEditorComponent_p_panel_0_ng_container_1_Template_input_ngModelChange_6_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onGeometryChange()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.value.coordinates[0]);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.value.coordinates[1]);
} }
function GeometryEditorComponent_p_panel_0_ng_container_2_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function GeometryEditorComponent_p_panel_0_ng_container_2_div_1_ng_container_4_Template_input_ngModelChange_1_listener($event) { const j_r4 = i0.ɵɵrestoreView(_r3).index; const coords_r5 = i0.ɵɵnextContext().$implicit; i0.ɵɵtwoWayBindingSet(coords_r5[j_r4], $event) || (coords_r5[j_r4] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function GeometryEditorComponent_p_panel_0_ng_container_2_div_1_ng_container_4_Template_input_ngModelChange_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.onGeometryChange()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r4 = ctx.index;
    const coords_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", j_r4 === coords_r5.length - 1 ? "last" : "");
    i0.ɵɵtwoWayProperty("ngModel", coords_r5[j_r4]);
} }
function GeometryEditorComponent_p_panel_0_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "label", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GeometryEditorComponent_p_panel_0_ng_container_2_div_1_ng_container_4_Template, 2, 2, "ng-container", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const coords_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", coords_r5);
} }
function GeometryEditorComponent_p_panel_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GeometryEditorComponent_p_panel_0_ng_container_2_div_1_Template, 5, 2, "div", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.value.coordinates);
} }
function GeometryEditorComponent_p_panel_0_ng_container_3_div_1_div_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function GeometryEditorComponent_p_panel_0_ng_container_3_div_1_div_2_ng_container_4_Template_input_ngModelChange_1_listener($event) { const j_r8 = i0.ɵɵrestoreView(_r7).index; const subcoords_r9 = i0.ɵɵnextContext().$implicit; i0.ɵɵtwoWayBindingSet(subcoords_r9[j_r8], $event) || (subcoords_r9[j_r8] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function GeometryEditorComponent_p_panel_0_ng_container_3_div_1_div_2_ng_container_4_Template_input_ngModelChange_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.onGeometryChange()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r8 = ctx.index;
    const subcoords_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", j_r8 === subcoords_r9.length - 1 ? "last" : "");
    i0.ɵɵtwoWayProperty("ngModel", subcoords_r9[j_r8]);
} }
function GeometryEditorComponent_p_panel_0_ng_container_3_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "label", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GeometryEditorComponent_p_panel_0_ng_container_3_div_1_div_2_ng_container_4_Template, 2, 2, "ng-container", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const subcoords_r9 = ctx.$implicit;
    const x_r10 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(x_r10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", subcoords_r9);
} }
function GeometryEditorComponent_p_panel_0_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 11);
    i0.ɵɵtemplate(2, GeometryEditorComponent_p_panel_0_ng_container_3_div_1_div_2_Template, 5, 2, "div", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const coords_r11 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", coords_r11);
} }
function GeometryEditorComponent_p_panel_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GeometryEditorComponent_p_panel_0_ng_container_3_div_1_Template, 3, 1, "div", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.value.coordinates);
} }
function GeometryEditorComponent_p_panel_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-panel", 1);
    i0.ɵɵtemplate(1, GeometryEditorComponent_p_panel_0_ng_container_1_Template, 7, 2, "ng-container", 2)(2, GeometryEditorComponent_p_panel_0_ng_container_2_Template, 2, 1, "ng-container", 2)(3, GeometryEditorComponent_p_panel_0_ng_container_3_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("header", ctx_r1.value.type);
    i0.ɵɵproperty("toggleable", true)("collapsed", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.value.type === "Point");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.value.type === "LineString");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.value.type === "Polygon");
} }
class GeometryEditorComponent {
    set id(value) {
        this._ID = value;
        this.externalId = null;
    }
    get id() {
        return this._ID;
    }
    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val || {};
        this.onChange(val);
        this.onTouched();
    }
    constructor() {
        this.readOnly = false;
        this.geometryChange = new EventEmitter();
        this.externalId = '';
        this._ID = '';
        this.onChange = () => { };
        this.onTouched = () => { };
        this.featureTypes = ConfigurationService.featureTypes;
    }
    ngOnInit() {
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    writeValue(value) {
        this.value = value || {};
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    onGeometryChange() {
        this.geometryChange.emit(this.value);
    }
    static { this.ɵfac = function GeometryEditorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GeometryEditorComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GeometryEditorComponent, selectors: [["geometry-editor"]], hostVars: 1, hostBindings: function GeometryEditorComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵattribute("id", ctx.externalId);
        } }, inputs: { readOnly: "readOnly", _value: [0, "value", "_value"], id: "id" }, outputs: { geometryChange: "geometryChange" }, standalone: false, features: [i0.ɵɵProvidersFeature([
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(() => GeometryEditorComponent),
                    multi: true,
                }
            ])], decls: 1, vars: 1, consts: [[3, "header", "toggleable", "collapsed", 4, "ngIf"], [3, "header", "toggleable", "collapsed"], [4, "ngIf"], [1, "col-md-12", "mb-2"], [1, "flex-content", "align-vertical-center"], ["type", "number", 1, "form-control", 3, "ngModelChange", "ngModel"], ["type", "number", 1, "form-control", "last", 3, "ngModelChange", "ngModel"], ["class", "col-md-12 mb-2", 4, "ngFor", "ngForOf"], [1, "first"], [4, "ngFor", "ngForOf"], ["type", "number", 1, "form-control", 3, "ngModelChange", "ngClass", "ngModel"], [1, "row"]], template: function GeometryEditorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, GeometryEditorComponent_p_panel_0_Template, 4, 6, "p-panel", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.value.type);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i5.DefaultValueAccessor, i5.NumberValueAccessor, i5.NgControlStatus, i5.NgModel, i13.Panel], styles: [".last[_ngcontent-%COMP%]{margin-left:.5em}.first[_ngcontent-%COMP%]{margin-right:.5em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GeometryEditorComponent, [{
        type: Component,
        args: [{ selector: 'geometry-editor', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => GeometryEditorComponent),
                        multi: true,
                    }
                ], standalone: false, template: "<p-panel *ngIf=\"value.type\" header=\"{{value.type}}\" [toggleable]=\"true\" [collapsed]=\"true\">\r\n    <ng-container *ngIf=\"value.type === 'Point'\">\r\n        <div class=\"col-md-12 mb-2\">\r\n            <div class=\"flex-content align-vertical-center\">\r\n                <ng-container>\r\n                    <input class=\"form-control\" type=\"number\" [(ngModel)]=\"value.coordinates[0]\" (ngModelChange)=\"onGeometryChange()\" />\r\n                </ng-container>\r\n                <ng-container>\r\n                    <input class=\"form-control last\" type=\"number\" [(ngModel)]=\"value.coordinates[1]\" (ngModelChange)=\"onGeometryChange()\" />\r\n                </ng-container>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"value.type === 'LineString'\">\r\n        <div class=\"col-md-12 mb-2\" *ngFor=\"let coords of value.coordinates; let i = index\">\r\n            <div class=\"flex-content align-vertical-center\">\r\n                <label class=\"first\">{{i}}</label>\r\n                <ng-container *ngFor=\"let subcoords of coords; let j = index\">\r\n                    <input class=\"form-control\" [ngClass]=\"j === coords.length - 1 ? 'last' : ''\" type=\"number\" [(ngModel)]=\"coords[j]\" (ngModelChange)=\"onGeometryChange()\" />\r\n                </ng-container>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"value.type === 'Polygon'\">\r\n        <div class=\"col-md-12 mb-2\" *ngFor=\"let coords of value.coordinates; let i = index\">\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12 mb-2\" *ngFor=\"let subcoords of coords; let x = index\">\r\n                    <div class=\"flex-content align-vertical-center\">\r\n                        <label class=\"first\">{{x}}</label>\r\n                        <ng-container *ngFor=\"let subsubcoords of subcoords; let j = index\">\r\n                            <input class=\"form-control\" [ngClass]=\"j === subcoords.length - 1 ? 'last' : ''\" type=\"number\" [(ngModel)]=\"subcoords[j]\" (ngModelChange)=\"onGeometryChange()\" />\r\n                        </ng-container>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>        \r\n    </ng-container>\r\n</p-panel>", styles: [".last{margin-left:.5em}.first{margin-right:.5em}\n"] }]
    }], () => [], { readOnly: [{
            type: Input
        }], _value: [{
            type: Input,
            args: ['value']
        }], geometryChange: [{
            type: Output
        }], externalId: [{
            type: HostBinding,
            args: ['attr.id']
        }], id: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(GeometryEditorComponent, { className: "GeometryEditorComponent", filePath: "src/components/geometry-editor/geometry-editor.component.ts", lineNumber: 18 }); })();

function DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "div", 5)(4, "fi-map", 6);
    i0.ɵɵlistener("featureDrawn", function DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_div_1_Template_fi_map_featureDrawn_4_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onFeatureDrawn($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 5)(6, "geometry-editor", 7);
    i0.ɵɵlistener("geometryChange", function DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_div_1_Template_geometry_editor_geometryChange_6_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onGeometryChange($event)); });
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("config", ctx_r1.config);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControlName", ctx_r1.dynamicFormObject.code);
} }
function DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_div_2_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10)(2, "button", 11);
    i0.ɵɵlistener("click", function DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_div_2_ng_container_6_Template_button_click_2_listener() { const arrayGroupElementIndex_r5 = i0.ɵɵrestoreView(_r4).index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.removeFormArrayElement(arrayGroupElementIndex_r5)); });
    i0.ɵɵelement(3, "i", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "geometry-editor", 13);
    i0.ɵɵlistener("geometryChange", function DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_div_2_ng_container_6_Template_geometry_editor_geometryChange_4_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.onGeometryChange($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const arrayGroupElement_r6 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("formControl", arrayGroupElement_r6);
} }
function DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "div", 5)(4, "fi-map", 6);
    i0.ɵɵlistener("featureDrawn", function DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_div_2_Template_fi_map_featureDrawn_4_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onFeatureDrawn($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 8);
    i0.ɵɵtemplate(6, DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_div_2_ng_container_6_Template, 5, 1, "ng-container", 9);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("config", ctx_r1.config);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.form.controls["geometries"].controls);
} }
function DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_div_1_Template, 7, 3, "div", 1)(2, DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_div_2_Template, 7, 3, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.type !== "geogeometry");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.type === "geogeometry");
} }
function DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 2)(3, "div", 5)(4, "fi-map", 6);
    i0.ɵɵlistener("featureDrawn", function DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_div_1_Template_fi_map_featureDrawn_4_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onFeatureDrawn($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 5)(6, "geometry-editor", 13);
    i0.ɵɵlistener("geometryChange", function DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_div_1_Template_geometry_editor_geometryChange_6_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onGeometryChange($event)); });
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("config", ctx_r1.config);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r1.form);
} }
function DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_div_2_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10)(2, "button", 11);
    i0.ɵɵlistener("click", function DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_div_2_ng_container_6_Template_button_click_2_listener() { const arrayGroupElementIndex_r10 = i0.ɵɵrestoreView(_r9).index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.removeFormArrayElement(arrayGroupElementIndex_r10)); });
    i0.ɵɵelement(3, "i", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "geometry-editor", 13);
    i0.ɵɵlistener("geometryChange", function DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_div_2_ng_container_6_Template_geometry_editor_geometryChange_4_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.onGeometryChange($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const arrayGroupElement_r11 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("formControl", arrayGroupElement_r11);
} }
function DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "div", 5)(4, "fi-map", 6);
    i0.ɵɵlistener("featureDrawn", function DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_div_2_Template_fi_map_featureDrawn_4_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.onFeatureDrawn($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 8);
    i0.ɵɵtemplate(6, DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_div_2_ng_container_6_Template, 5, 1, "ng-container", 9);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("config", ctx_r1.config);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.form.controls["geometries"].controls);
} }
function DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_div_1_Template, 7, 2, "div", 1)(2, DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_div_2_Template, 7, 3, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.type !== "geogeometry");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.type === "geogeometry");
} }
function DynamicFormGeometryItemComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFormGeometryItemComponent_ng_container_0_ng_container_1_Template, 3, 2, "ng-container", 0)(2, DynamicFormGeometryItemComponent_ng_container_0_ng_container_2_Template, 3, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.dynamicFormObject.multipleValues);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dynamicFormObject.multipleValues);
} }
class DynamicFormGeometryItemComponent {
    constructor(dynamicFormControlService, mapService) {
        this.dynamicFormControlService = dynamicFormControlService;
        this.mapService = mapService;
        this.pageReady = false;
    }
    ngOnInit() {
        this.config.draw.features = this.initFeatures();
        this.pageReady = true;
    }
    removeFormArrayElement(i) {
        this.map.removeFeature(this.map.drawVectorSource, i);
        let fa = this.form.controls["geometries"];
        fa.removeAt(i);
    }
    onFeatureDrawn(event, index) {
        if (this.dynamicFormObject.multipleValues) {
            if (this.dynamicFormObject.type !== 'geogeometry') {
                //If there is already a geometry (in an already saved collection item), I remove it
                if (this.form.value) {
                    event.map.removeFeature(event.map.drawVectorSource, 0);
                }
                this.form.setValue(event.feature);
            }
            else {
                let fa = this.form.controls["geometries"];
                if (!isNaN(fa.value.length)) {
                    let fc = this.dynamicFormControlService.createFormControl(this.dynamicForm, this.dynamicFormObject, null);
                    fc.setValue(event.feature);
                    fa.push(fc);
                }
            }
        }
        else {
            //Single feature not geogeometry
            if (this.dynamicFormObject.type !== 'geogeometry') {
                //If there is already a geometry (in an already saved collection item), I remove it
                if (this.form.controls[this.dynamicFormObject.code].value) {
                    event.map.removeFeature(event.map.drawVectorSource, 0);
                }
                this.form.controls[this.dynamicFormObject.code].setValue(event.feature);
            }
            else {
                let fa = this.form.controls["geometries"];
                if (!isNaN(fa.value.length)) {
                    let fc = this.dynamicFormControlService.createFormControl(this.dynamicForm, this.dynamicFormObject, null);
                    fc.setValue(event.feature);
                    fa.push(fc);
                }
            }
        }
    }
    onGeometryChange(value) {
        this.map.removeFeatures(this.map.drawVectorSource);
        this.map.addFeatures(this.map.drawVectorSource, this.initFeatures());
    }
    initFeatures() {
        let features = [];
        //Multiple values
        if (this.dynamicFormObject.multipleValues) {
            if (this.dynamicFormObject.type !== 'geogeometry') {
                if (this.form.value) {
                    features.push(this.mapService.featureFromGeom(this.dynamicFormObject.type, this.form.value));
                }
            }
            else {
                if (this.form.value) {
                    let value = this.form.value;
                    for (let i = 0; i < value?.geometries?.length; i++) {
                        features.push(this.mapService.featureFromGeom(this.dynamicFormObject.type, value.geometries[i]));
                    }
                }
            }
        }
        //Single value
        else {
            //Single feature not geogeometry
            if (this.dynamicFormObject.type !== 'geogeometry') {
                if (this.form.controls[this.dynamicFormObject.code].value) {
                    features.push(this.mapService.featureFromGeom(this.dynamicFormObject.type, this.form.controls[this.dynamicFormObject.code].value));
                }
            }
            //Single feature geogeometry
            else {
                let values = this.form.controls["geometries"].value;
                for (let i = 0; i < values?.length; i++) {
                    features.push(this.mapService.featureFromGeom(this.dynamicFormObject.type, values[i]));
                }
            }
        }
        return features;
    }
    static { this.ɵfac = function DynamicFormGeometryItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DynamicFormGeometryItemComponent)(i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1.MapService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFormGeometryItemComponent, selectors: [["dynamic-form-geometry-item"]], viewQuery: function DynamicFormGeometryItemComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MapComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.map = _t.first);
        } }, inputs: { config: "config", operation: "operation", form: "form", dynamicForm: "dynamicForm", dynamicFormObject: "dynamicFormObject", readonly: "readonly", index: "index" }, standalone: false, decls: 1, vars: 1, consts: [[4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "row"], [1, "col-md-12"], [1, "row", 3, "formGroup"], [1, "col-md-6"], [3, "featureDrawn", "config"], [3, "geometryChange", "formControlName"], ["formArrayName", "geometries", 1, "col-md-6"], [4, "ngFor", "ngForOf"], [1, "flex-content", "align-vertical-top", "mb-2"], ["title", "Remove item", "type", "button", "tabindex", "-1", 1, "btn", "btn-link", 3, "click"], [1, "bi", "bi-trash"], [3, "geometryChange", "formControl"]], template: function DynamicFormGeometryItemComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DynamicFormGeometryItemComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.pageReady);
        } }, dependencies: [i3.NgForOf, i3.NgIf, i5.NgControlStatus, i5.NgControlStatusGroup, i5.FormControlDirective, i5.FormGroupDirective, i5.FormControlName, i5.FormArrayName, MapComponent, GeometryEditorComponent], styles: [".effect[_ngcontent-%COMP%]{opacity:1;animation:_ngcontent-%COMP%_fade 5s linear}@keyframes _ngcontent-%COMP%_fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator[_ngcontent-%COMP%]{width:100%}.form-check-label[_ngcontent-%COMP%]{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items[_ngcontent-%COMP%]{list-style:none;font-size:.9rem}.help-button[_ngcontent-%COMP%]{margin:5px}.help-button[_ngcontent-%COMP%]:hover{cursor:pointer}.component-header[_ngcontent-%COMP%]{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{margin-left:10px}.form-control-footer[_ngcontent-%COMP%]{font-size:.8em}.mandatory[_ngcontent-%COMP%]{font-size:50%;vertical-align:top;color:red}.app-menu-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.6}.header-title[_ngcontent-%COMP%]:hover{cursor:pointer}.status-label[_ngcontent-%COMP%]{font-size:1em;font-weight:700}.component-label[_ngcontent-%COMP%]{font-size:1em}.component-label.horizontal[_ngcontent-%COMP%], label.title-category[_ngcontent-%COMP%]{font-size:.9em}.float[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:5px;margin-right:5px}.panel-body[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading[_ngcontent-%COMP%]{min-height:45px;display:flex}.panel-heading[_ngcontent-%COMP%]   .header-title[_ngcontent-%COMP%]{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{max-height:40px}.multiple-values-item[_ngcontent-%COMP%]{display:flex;flex-grow:1}.multiple-values-item-content[_ngcontent-%COMP%]{width:95%}.multiple-values-item-body[_ngcontent-%COMP%]{width:95%;margin-bottom:5px}.array-items[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:.9em}.header-title[_ngcontent-%COMP%]{vertical-align:middle}.card[_ngcontent-%COMP%]{margin-bottom:.5em}.refresh-button[_ngcontent-%COMP%]{margin:.5em}.refresh-button[_ngcontent-%COMP%]:hover{cursor:pointer}.ref-form[_ngcontent-%COMP%]{display:flex;align-items:baseline}img[_ngcontent-%COMP%]{max-width:100%;height:auto}.collapse[_ngcontent-%COMP%]{display:none!important}.collapse.in[_ngcontent-%COMP%]{display:block!important}.collapsing[_ngcontent-%COMP%]{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form[_ngcontent-%COMP%]   .p-fieldset[_ngcontent-%COMP%]   .p-fieldset-legend[_ngcontent-%COMP%]{font-size:.8em!important}.dynamic-form-summary-view[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%]{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{margin-left:5px}.dynamic-form-summary-view[_ngcontent-%COMP%]   .form-tree[_ngcontent-%COMP%], .dynamic-form-summary-view[_ngcontent-%COMP%]   .form-questions[_ngcontent-%COMP%]{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-icon[_ngcontent-%COMP%]{font-size:20px!important}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%]{width:100%}form[_ngcontent-%COMP%]   .item-switcher[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.control-cell.content[_ngcontent-%COMP%]{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu[_ngcontent-%COMP%]{width:55px}.form-group[_ngcontent-%COMP%]{border:solid 1px rgba(0,0,0,.125);margin:1em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFormGeometryItemComponent, [{
        type: Component,
        args: [{ selector: 'dynamic-form-geometry-item', standalone: false, template: "<ng-container *ngIf=\"pageReady\">\r\n\r\n    <ng-container *ngIf=\"!dynamicFormObject.multipleValues\">\r\n\r\n        <div class=\"row\" *ngIf=\"dynamicFormObject.type !== 'geogeometry'\">\r\n\r\n            <div class=\"col-md-12\">\r\n                <div class=\"row\" [formGroup]=\"form\">\r\n                    <div class=\"col-md-6\">\r\n                        <fi-map [config]=\"config\" (featureDrawn)=\"onFeatureDrawn($event)\"></fi-map>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <geometry-editor [formControlName]=\"dynamicFormObject.code\" (geometryChange)=\"onGeometryChange($event)\"></geometry-editor>\r\n                    </div>                                \r\n                </div>\r\n            </div>\r\n    \r\n        </div>\r\n\r\n        <div class=\"row\" *ngIf=\"dynamicFormObject.type === 'geogeometry'\">\r\n\r\n            <div class=\"col-md-12\">\r\n                <div class=\"row\" [formGroup]=\"form\">\r\n                    <div class=\"col-md-6\">\r\n                        <fi-map [config]=\"config\" (featureDrawn)=\"onFeatureDrawn($event)\"></fi-map>\r\n                    </div>\r\n                    <div class=\"col-md-6\" formArrayName=\"geometries\">\r\n                        <ng-container *ngFor=\"let arrayGroupElement of form.controls['geometries'].controls; let arrayGroupElementIndex=index\">\r\n                            <div class=\"flex-content align-vertical-top mb-2\">\r\n                                <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n                                    (click)=\"removeFormArrayElement(arrayGroupElementIndex)\" tabindex=\"-1\">\r\n                                    <i class=\"bi bi-trash\"></i>\r\n                                </button>\r\n                                <geometry-editor [formControl]=\"arrayGroupElement\" (geometryChange)=\"onGeometryChange($event)\"></geometry-editor>\r\n                            </div>\r\n                        </ng-container>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n    \r\n        </div>\r\n\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"dynamicFormObject.multipleValues\">\r\n\r\n        <div class=\"row\" *ngIf=\"dynamicFormObject.type !== 'geogeometry'\">\r\n\r\n            <div class=\"col-md-12\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                        <fi-map [config]=\"config\" (featureDrawn)=\"onFeatureDrawn($event)\"></fi-map>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <geometry-editor [formControl]=\"form\" (geometryChange)=\"onGeometryChange($event)\"></geometry-editor>\r\n                    </div>                                \r\n                </div>\r\n            </div>\r\n    \r\n        </div>\r\n\r\n        <div class=\"row\" *ngIf=\"dynamicFormObject.type === 'geogeometry'\">\r\n\r\n            <div class=\"col-md-12\">\r\n                <div class=\"row\" [formGroup]=\"form\">\r\n                    <div class=\"col-md-6\">\r\n                        <fi-map [config]=\"config\" (featureDrawn)=\"onFeatureDrawn($event)\"></fi-map>\r\n                    </div>\r\n                    <div class=\"col-md-6\" formArrayName=\"geometries\">\r\n                        <ng-container *ngFor=\"let arrayGroupElement of form.controls['geometries'].controls; let arrayGroupElementIndex=index\">\r\n                            <div class=\"flex-content align-vertical-top mb-2\">\r\n                                <button title=\"Remove item\" type=\"button\" class=\"btn btn-link\"\r\n                                    (click)=\"removeFormArrayElement(arrayGroupElementIndex)\" tabindex=\"-1\">\r\n                                    <i class=\"bi bi-trash\"></i>\r\n                                </button>\r\n                                <geometry-editor [formControl]=\"arrayGroupElement\" (geometryChange)=\"onGeometryChange($event)\"></geometry-editor>\r\n                            </div>\r\n                        </ng-container>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n    \r\n        </div>\r\n\r\n    </ng-container>\r\n</ng-container>", styles: [".effect{opacity:1;animation:fade 5s linear}@keyframes fade{0%{background-color:var(--default-background-color);border-radius:0}50%{background-color:var(--hover-background-color);border-radius:10px}to{background-color:var(--default-background-color);border-radius:0}}.separator{width:100%}.form-check-label{margin-right:.8em;margin-top:.8em;margin-bottom:.8em;font-size:.9em}.array-items{list-style:none;font-size:.9rem}.help-button{margin:5px}.help-button:hover{cursor:pointer}.component-header{display:flex;flex-grow:1;align-items:center;min-height:25px}.form-control-header .header-title{margin-left:10px}.form-control-footer{font-size:.8em}.mandatory{font-size:50%;vertical-align:top;color:red}.app-menu-disabled{pointer-events:none;opacity:.6}.header-title:hover{cursor:pointer}.status-label{font-size:1em;font-weight:700}.component-label{font-size:1em}.component-label.horizontal,label.title-category{font-size:.9em}.float{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.float>*{margin-left:5px;margin-right:5px}.panel-body{border-left:solid 1px rgba(0,0,0,.125);padding-left:1em}.panel-heading{min-height:45px;display:flex}.panel-heading .header-title{vertical-align:middle;margin-left:10px;display:inline-block}.panel-heading button{max-height:40px}.multiple-values-item{display:flex;flex-grow:1}.multiple-values-item-content{width:95%}.multiple-values-item-body{width:95%;margin-bottom:5px}.array-items button{font-size:.9em}.header-title{vertical-align:middle}.card{margin-bottom:.5em}.refresh-button{margin:.5em}.refresh-button:hover{cursor:pointer}.ref-form{display:flex;align-items:baseline}img{max-width:100%;height:auto}.collapse{display:none!important}.collapse.in{display:block!important}.collapsing{position:relative;height:0;overflow:hidden;transition:height,visibility .35s ease}.dynamic-form .p-fieldset .p-fieldset-legend{font-size:.8em!important}.dynamic-form-summary-view{display:flex;flex-direction:row;flex-grow:1;overflow:hidden}.dynamic-form-summary-view .form-tree{border-radius:3px;border:1px solid var(--hover-background-color);padding:10px;margin-right:5px}.dynamic-form-summary-view .form-questions{margin-left:5px}.dynamic-form-summary-view .form-tree,.dynamic-form-summary-view .form-questions{width:50%;display:flex;flex-direction:column;flex-grow:1;overflow-y:auto}form{width:100%}form .item-icon{font-size:20px!important}form .item-switcher{width:100%}form .item-switcher>div{width:100%}.control-cell.content{width:100%;min-width:200px;vertical-align:top;border:solid 1px var(--default-border-color);padding:.5em;margin-bottom:1em;border-radius:5px}.control-cell.app-menu{width:55px}.form-group{border:solid 1px rgba(0,0,0,.125);margin:1em}\n"] }]
    }], () => [{ type: i1.DynamicFormControlService }, { type: i1.MapService }], { config: [{
            type: Input
        }], operation: [{
            type: Input
        }], form: [{
            type: Input
        }], dynamicForm: [{
            type: Input
        }], dynamicFormObject: [{
            type: Input
        }], readonly: [{
            type: Input
        }], index: [{
            type: Input
        }], map: [{
            type: ViewChild,
            args: [MapComponent]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DynamicFormGeometryItemComponent, { className: "DynamicFormGeometryItemComponent", filePath: "src/dynamic-form/dynamic-form-geometry/dynamic-form-geometry-item/dynamic-form-geometry-item.component.ts", lineNumber: 12 }); })();

const _c0$2 = a0 => ({ name: a0 });
const _c1 = a0 => [a0];
function CollectionListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5)(3, "span", 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.configService.getTranslation("common.loading"));
} }
function CollectionListComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "h5");
    i0.ɵɵelement(3, "span", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 8)(5, "p-button", 10);
    i0.ɵɵlistener("click", function CollectionListComponent_ng_container_1_div_1_Template_p_button_click_5_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.requestCollectionAccess()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r0.configService.getTranslation("list.request-access", i0.ɵɵpureFunction1(2, _c0$2, ctx_r0.name)), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("raised", true);
} }
function CollectionListComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "h5");
    i0.ɵɵelement(3, "span", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵelement(5, "fi-logout-button");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("innerHTML", ctx_r0.configService.getTranslation("list.access-requested", i0.ɵɵpureFunction1(1, _c0$2, ctx_r0.name)), i0.ɵɵsanitizeHtml);
} }
function CollectionListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CollectionListComponent_ng_container_1_div_1_Template, 6, 4, "div", 2)(2, CollectionListComponent_ng_container_1_div_2_Template, 6, 3, "div", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.accessRequested);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.accessRequested);
} }
function CollectionListComponent_div_2_div_1_fi_template_renderer_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 16);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("space", ctx_r0.space)("collection", ctx_r0.name)("collectionForm", ctx_r0.collectionForm)("data", ctx_r0.resultList)("template", ctx_r0.template);
} }
function CollectionListComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 7)(2, "div", 14);
    i0.ɵɵtemplate(3, CollectionListComponent_div_2_div_1_fi_template_renderer_3_Template, 1, 5, "fi-template-renderer", 15);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.resultList);
} }
function CollectionListComponent_div_2_div_2_div_1_div_1_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 28);
    i0.ɵɵelement(1, "i", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(1, _c1, "/reporting/" + ctx_r0.space + "/" + ctx_r0.configService.env.currentLang));
} }
function CollectionListComponent_div_2_div_2_div_1_div_1_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 28);
    i0.ɵɵelement(1, "i", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(1, _c1, "/admin/collections/" + ctx_r0.space + "/" + ctx_r0.configService.env.currentLang));
} }
function CollectionListComponent_div_2_div_2_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 26);
    i0.ɵɵtemplate(2, CollectionListComponent_div_2_div_2_div_1_div_1_a_2_Template, 2, 3, "a", 27)(3, CollectionListComponent_div_2_div_2_div_1_div_1_a_3_Template, 2, 3, "a", 27);
    i0.ɵɵelementStart(4, "h5");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.reporting);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.reporting);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r0.collectionForm == null ? null : ctx_r0.collectionForm.formConfig == null ? null : ctx_r0.collectionForm.formConfig.name) || (ctx_r0.collectionForm == null ? null : ctx_r0.collectionForm.form == null ? null : ctx_r0.collectionForm.form.name));
} }
function CollectionListComponent_div_2_div_2_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 26)(2, "a", 30);
    i0.ɵɵlistener("click", function CollectionListComponent_div_2_div_2_div_1_div_2_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.configService.goTo(null, false)); });
    i0.ɵɵelement(3, "i", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "h4", 31);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.collectionForm == null ? null : ctx_r0.collectionForm.formConfig == null ? null : ctx_r0.collectionForm.formConfig.name) || (ctx_r0.collectionForm == null ? null : ctx_r0.collectionForm.form == null ? null : ctx_r0.collectionForm.form.name));
} }
function CollectionListComponent_div_2_div_2_div_1_p_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 32);
    i0.ɵɵlistener("click", function CollectionListComponent_div_2_div_2_div_1_p_button_4_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.newCollectionItem()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("disabled", ctx_r0.collectionForm.form.closed)("rounded", true);
} }
function CollectionListComponent_div_2_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, CollectionListComponent_div_2_div_2_div_1_div_1_Template, 6, 3, "div", 22)(2, CollectionListComponent_div_2_div_2_div_1_div_2_Template, 6, 1, "div", 22);
    i0.ɵɵelementStart(3, "div", 23);
    i0.ɵɵtemplate(4, CollectionListComponent_div_2_div_2_div_1_p_button_4_Template, 1, 2, "p-button", 24);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.configService.env.hosted === false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.configService.env.hosted === true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.collectionForm.roleType === "ADMIN" || ctx_r0.collectionForm.roleType === "MANAGER" || ctx_r0.collectionForm.roleType === "EDITOR");
} }
function CollectionListComponent_div_2_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelement(1, "fi-filter", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("space", ctx_r0.space)("collection", ctx_r0.name)("collectionForm", ctx_r0.collectionForm)("data", ctx_r0.resultList);
} }
function CollectionListComponent_div_2_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35)(1, "div", 7)(2, "div", 14);
    i0.ɵɵelement(3, "fi-search-pills", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 36)(5, "fi-list", 37);
    i0.ɵɵlistener("onClick", function CollectionListComponent_div_2_div_2_div_4_Template_fi_list_onClick_5_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r0.onCollectionItemClick($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 38);
    i0.ɵɵelement(7, "fi-filter-terms", 34);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("space", ctx_r0.space)("collection", ctx_r0.name)("collectionForm", ctx_r0.collectionForm)("data", ctx_r0.resultList);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("ngClass", ((ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.showFilterTerms) && ctx_r0.aggregations && ctx_r0.aggregations.length > 0 ? "col-md-10" : "col-md-12") + " results");
    i0.ɵɵadvance();
    i0.ɵɵproperty("space", ctx_r0.space)("collection", ctx_r0.name)("collectionForm", ctx_r0.collectionForm)("data", ctx_r0.resultList);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("space", ctx_r0.space)("collection", ctx_r0.name)("collectionForm", ctx_r0.collectionForm)("data", ctx_r0.resultList);
} }
function CollectionListComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, CollectionListComponent_div_2_div_2_div_1_Template, 5, 3, "div", 18);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵtemplate(3, CollectionListComponent_div_2_div_2_div_3_Template, 2, 4, "div", 19)(4, CollectionListComponent_div_2_div_2_div_4_Template, 8, 13, "div", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.showHeader) || (ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.showHeader) === undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.showSearchbar) || (ctx_r0.collectionForm.formConfig.viewConfig == null ? null : ctx_r0.collectionForm.formConfig.viewConfig.showSearchbar) === undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.collectionForm.formConfig.selectionEnabled && ctx_r0.userselectionService.getUserselections(ctx_r0.space) && ctx_r0.resultList || !ctx_r0.collectionForm.formConfig.selectionEnabled && ctx_r0.resultList);
} }
function CollectionListComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, CollectionListComponent_div_2_div_1_Template, 4, 1, "div", 11)(2, CollectionListComponent_div_2_div_2_Template, 5, 3, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.template);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.template);
} }
class CollectionListComponent extends ListDirective {
    constructor(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, messageService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService, formDataService, dialogService, mapService) {
        super(searchService, router, route, utilsService, configService, dynamicFormControlService, elementRef, collectionService, confirmationService, userselectionService, workspaceService, templateService, propertiesService, listConfigService);
        this.messageService = messageService;
        this.formDataService = formDataService;
        this.dialogService = dialogService;
        this.mapService = mapService;
        this.reporting = false;
    }
    ngOnInit() {
        if (this.router.url.includes('reporting')) {
            this.reporting = true;
        }
        this.init();
    }
    ngOnDestroy() {
    }
    onAdvancedSearchEvent(event) {
        if (!this.collectionForm.formConfig.viewConfig) {
            this.collectionForm.formConfig.viewConfig = {};
        }
        this.collectionForm.formConfig.viewConfig.showAdvancedSearch = event;
    }
    onMapSearch(geofilter) {
        this.searchRequest.g = geofilter;
        let queryParams = {
            page: this.searchRequest.page,
            q: this.searchRequest.q,
            f: ListDirective.stringifyAdvancedParams(this.configService, this.searchRequest.f, this.configService.env.advancedSearch.multiple.separator),
            o: ListDirective.stringifyAdvancedParams(this.configService, this.searchRequest.o, this.configService.env.advancedSearch.multiple.separator),
            g: JSON.stringify(this.searchRequest.g?.geoShape?.coordinates),
            sort: this.searchRequest.sort
        };
        if (this.currentView) {
            queryParams.view = this.currentView;
        }
        this.router.navigate(['./'], {
            relativeTo: this.route,
            fragment: 'search',
            queryParams: queryParams
        });
    }
    afterSearchAdditionalActions(searchParameters, geoFilter) {
        if (geoFilter && geoFilter.geoShape) {
            if (geoFilter.geoShape.type === 'polygon') {
                this.extent = this.mapService.polygonToBbox([geoFilter.geoShape.coordinates]);
            }
            else {
                this.extent = this.mapService.polygonToBbox(geoFilter.geoShape.coordinates);
            }
        }
    }
    newCollectionItem() {
        if (this.collectionForm?.formConfig.route) {
            this.router.navigate(['/' + this.collectionForm?.formConfig.route + '/add/' + this.configService.env.currentLang]);
        }
        else {
            this.router.navigate(['/reporting/' + this.space + '/' + this.name + '/' + this.configService.env.currentLang]);
        }
    }
    onCollectionItemClick(event) {
        console.log(event);
    }
    static { this.ɵfac = function CollectionListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CollectionListComponent)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i3$2.MessageService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(UserselectionService), i0.ɵɵdirectiveInject(i1.WorkspaceService), i0.ɵɵdirectiveInject(i1.TemplateService), i0.ɵɵdirectiveInject(i1.PropertiesService), i0.ɵɵdirectiveInject(i1.ListConfigService), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.MapService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CollectionListComponent, selectors: [["collection-list"]], inputs: { space: "space", name: "name", defaultSearchParameters: "defaultSearchParameters", listTemplate: "listTemplate", listConfig: "listConfig", showHeader: "showHeader", showSearchbar: "showSearchbar", showFilterTerms: "showFilterTerms", showAdvancedSearch: "showAdvancedSearch", setIndexingData: "setIndexingData" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [["class", "row spinner", 4, "ngIf"], [4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "row", "spinner"], [1, "col-md-12", "mb-3", "align-center"], ["role", "status", 1, "spinner-border"], [1, "sr-only"], [1, "row"], [1, "col-md-12", "align-center"], [3, "innerHTML"], ["severity", "primary", "label", "Request access", 3, "click", "raised"], ["class", "col-md-12 template", 4, "ngIf"], ["class", "col-md-12 no-template", 4, "ngIf"], [1, "col-md-12", "template"], [1, "col-md-12"], [3, "space", "collection", "collectionForm", "data", "template", 4, "ngIf"], [3, "space", "collection", "collectionForm", "data", "template"], [1, "col-md-12", "no-template"], ["class", "row header", 4, "ngIf"], ["class", "col-md-12 mt-3", 4, "ngIf"], ["id", "search", "class", "col-md-12", 4, "ngIf"], [1, "row", "header"], ["class", "col-md-10", 4, "ngIf"], [1, "col-md-2", "align-right"], ["icon", "bi bi-plus-lg", 3, "disabled", "rounded", "click", 4, "ngIf"], [1, "col-md-10"], [1, "flex-content"], ["class", "text-color-orange home", "role", "button", 3, "routerLink", 4, "ngIf"], ["role", "button", 1, "text-color-orange", "home", 3, "routerLink"], [1, "bi", "bi-house-fill"], ["role", "button", 1, "text-color-orange", "home", 3, "click"], [1, "title-highlight"], ["icon", "bi bi-plus-lg", 3, "click", "disabled", "rounded"], [1, "col-md-12", "mt-3"], [3, "space", "collection", "collectionForm", "data"], ["id", "search", 1, "col-md-12"], [3, "ngClass"], [3, "onClick", "space", "collection", "collectionForm", "data"], [1, "col-md-2"]], template: function CollectionListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, CollectionListComponent_div_0_Template, 5, 1, "div", 0)(1, CollectionListComponent_ng_container_1_Template, 3, 2, "ng-container", 1)(2, CollectionListComponent_div_2_Template, 3, 2, "div", 2);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.loading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.requestAccess);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.loading && ctx.collectionForm && ctx.space && !ctx.requestAccess);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollectionListComponent, [{
        type: Component,
        args: [{ selector: 'collection-list', standalone: false, template: "<div class=\"row spinner\" *ngIf=\"loading\">\r\n  <div class=\"col-md-12 mb-3 align-center\">\r\n    <div class=\"spinner-border\" role=\"status\">\r\n      <span class=\"sr-only\">{{ configService.getTranslation('common.loading')}}</span>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<ng-container *ngIf=\"requestAccess\">\r\n  <div class=\"row\" *ngIf=\"!accessRequested\">\r\n    <div class=\"col-md-12 align-center\">\r\n      <h5><span innerHTML=\"{{ configService.getTranslation('list.request-access',{ name: name }) }}\"></span></h5>\r\n    </div>\r\n    <div class=\"col-md-12 align-center\">\r\n      <p-button [raised]=\"true\" severity=\"primary\" label=\"Request access\" (click)=\"requestCollectionAccess()\"></p-button>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\" *ngIf=\"accessRequested\">\r\n    <div class=\"col-md-12 align-center\">\r\n      <h5><span innerHTML=\"{{ configService.getTranslation('list.access-requested',{ name: name }) }}\"></span></h5>\r\n    </div>\r\n    <div class=\"col-md-12 align-center\">\r\n      <fi-logout-button></fi-logout-button>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n\r\n<div class=\"row\" *ngIf=\"!loading && collectionForm && space && !requestAccess\">\r\n\r\n    <!-- CUSTOM LIST PAGE TEMPLATE -->\r\n    <div class=\"col-md-12 template\" *ngIf=\"template\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <fi-template-renderer *ngIf=\"resultList\" [space]=\"space\" [collection]=\"name\" [collectionForm]=\"collectionForm\" [data]=\"resultList\" [template]=\"template\"></fi-template-renderer>\r\n        </div>\r\n      </div>\r\n    </div>    \r\n\r\n    <!-- DEFAULT LIST PAGE -->\r\n    <div class=\"col-md-12 no-template\" *ngIf=\"!template\">      \r\n      <div class=\"row header\" *ngIf=\"collectionForm.formConfig.viewConfig?.showHeader || collectionForm.formConfig.viewConfig?.showHeader === undefined\">\r\n        <div class=\"col-md-10\" *ngIf=\"configService.env.hosted === false\">\r\n          <div class=\"flex-content\">\r\n            <a *ngIf=\"reporting\" class=\"text-color-orange home\" role=\"button\"\r\n              [routerLink]=\"['/reporting/' + space + '/' + configService.env.currentLang]\"><i class=\"bi bi-house-fill\"></i></a>\r\n            <a *ngIf=\"!reporting\" class=\"text-color-orange home\" role=\"button\"\r\n              [routerLink]=\"['/admin/collections/' + space + '/' + configService.env.currentLang]\"><i class=\"bi bi-house-fill\"></i></a>\r\n            <h5>{{ collectionForm?.formConfig?.name || collectionForm?.form?.name }}</h5>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-10\" *ngIf=\"configService.env.hosted === true\">\r\n          <div class=\"flex-content\">\r\n            <a class=\"text-color-orange home\" role=\"button\" (click)=\"configService.goTo(null,false)\"><i class=\"bi bi-house-fill\"></i></a>\r\n            <h4 class=\"title-highlight\">{{ collectionForm?.formConfig?.name || collectionForm?.form?.name }}</h4>\r\n          </div>        \r\n        </div>\r\n        <div class=\"col-md-2 align-right\">\r\n          <p-button *ngIf=\"(collectionForm.roleType === 'ADMIN' || collectionForm.roleType === 'MANAGER' || collectionForm.roleType === 'EDITOR')\"\r\n            [disabled]=\"collectionForm.form.closed\" icon=\"bi bi-plus-lg\" [rounded]=\"true\" (click)=\"newCollectionItem()\"></p-button>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12 mt-3\" *ngIf=\"(collectionForm.formConfig.viewConfig?.showSearchbar || collectionForm.formConfig.viewConfig?.showSearchbar === undefined)\">\r\n          <fi-filter [space]=\"space\" [collection]=\"name\" [collectionForm]=\"collectionForm\" [data]=\"resultList\"></fi-filter>\r\n        </div>\r\n        <div id=\"search\" class=\"col-md-12\" *ngIf=\"(collectionForm.formConfig.selectionEnabled && userselectionService.getUserselections(space) && resultList) || (!collectionForm.formConfig.selectionEnabled && resultList)\">\r\n      \r\n          <div class=\"row\">  \r\n            <div class=\"col-md-12\">  \r\n              <fi-search-pills [space]=\"space\" [collection]=\"name\" [collectionForm]=\"collectionForm\" [data]=\"resultList\"></fi-search-pills>\r\n            </div> \r\n            <div ngClass=\"{{ (collectionForm.formConfig.viewConfig?.showFilterTerms && aggregations && aggregations.length > 0 ? 'col-md-10' : 'col-md-12') + ' results' }}\">  \r\n              <fi-list [space]=\"space\" [collection]=\"name\" [collectionForm]=\"collectionForm\" [data]=\"resultList\" (onClick)=\"onCollectionItemClick($event)\"></fi-list>  \r\n            </div>  \r\n            <div class=\"col-md-2\">  \r\n              <fi-filter-terms [space]=\"space\" [collection]=\"name\" [collectionForm]=\"collectionForm\" [data]=\"resultList\"></fi-filter-terms>  \r\n            </div>  \r\n          </div>\r\n          \r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n</div>" }]
    }], () => [{ type: i1.SearchService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.UtilsService }, { type: i1.ConfigurationService }, { type: i1.DynamicFormControlService }, { type: i0.ElementRef }, { type: i1.CollectionService }, { type: i3$2.MessageService }, { type: i3$2.ConfirmationService }, { type: UserselectionService }, { type: i1.WorkspaceService }, { type: i1.TemplateService }, { type: i1.PropertiesService }, { type: i1.ListConfigService }, { type: FormDataService }, { type: i1$1.DialogService }, { type: i1.MapService }], { space: [{
            type: Input
        }], name: [{
            type: Input
        }], defaultSearchParameters: [{
            type: Input
        }], listTemplate: [{
            type: Input
        }], listConfig: [{
            type: Input
        }], showHeader: [{
            type: Input
        }], showSearchbar: [{
            type: Input
        }], showFilterTerms: [{
            type: Input
        }], showAdvancedSearch: [{
            type: Input
        }], setIndexingData: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CollectionListComponent, { className: "CollectionListComponent", filePath: "src/components/collection-list/collection-list.component.ts", lineNumber: 17 }); })();

function CollectionItemComponent_div_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CollectionItemComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, CollectionItemComponent_div_0_div_1_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const breadcrumbComponent_r1 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", breadcrumbComponent_r1);
} }
function CollectionItemComponent_div_0_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "label", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const log_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(log_r2.code);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(log_r2.message);
} }
function CollectionItemComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11);
    i0.ɵɵtemplate(2, CollectionItemComponent_div_0_div_2_div_2_Template, 5, 2, "div", 12);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.loggingService.log);
} }
function CollectionItemComponent_div_0_div_3_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementStart(2, "label");
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "label", 13);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const error_r4 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(error_r4.label + ": ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(!error_r4.value ? "<empty>" : error_r4.value);
} }
function CollectionItemComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "ul", 15);
    i0.ɵɵtemplate(2, CollectionItemComponent_div_0_div_3_li_2_Template, 6, 2, "li", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.getErrorLog());
} }
function CollectionItemComponent_div_0_div_4_dynamic_form_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dynamic-form", 21, 1);
    i0.ɵɵlistener("nextForm", function CollectionItemComponent_div_0_div_4_dynamic_form_2_Template_dynamic_form_nextForm_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onNextForm($event)); })("statusChange", function CollectionItemComponent_div_0_div_4_dynamic_form_2_Template_dynamic_form_statusChange_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.onStatusChange($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("status", ctx_r2.getInitialStatus())("statuses", ctx_r2.statuses)("readonly", ctx_r2.readonly)("operation", ctx_r2.operation)("space", ctx_r2.space)("formData", ctx_r2.collectionItem.document)("dynamicForm", ctx_r2.collectionForm.form)("params", ctx_r2.collectionForm.form.params);
} }
function CollectionItemComponent_div_0_div_4_div_3_p_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 26);
    i0.ɵɵlistener("click", function CollectionItemComponent_div_0_div_4_div_3_p_button_2_Template_p_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.remove()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("raised", true);
} }
function CollectionItemComponent_div_0_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "p-button", 23);
    i0.ɵɵlistener("click", function CollectionItemComponent_div_0_div_4_div_3_Template_p_button_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.save(false, undefined)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, CollectionItemComponent_div_0_div_4_div_3_p_button_2_Template, 1, 1, "p-button", 24);
    i0.ɵɵelementStart(3, "p-button", 25);
    i0.ɵɵlistener("click", function CollectionItemComponent_div_0_div_4_div_3_Template_p_button_click_3_listener() { i0.ɵɵrestoreView(_r6); const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.back()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("raised", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.alias && !ctx_r2.readonly && ctx_r2.deleteAllowed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("raised", true);
} }
function CollectionItemComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 18);
    i0.ɵɵtemplate(2, CollectionItemComponent_div_0_div_4_dynamic_form_2_Template, 2, 8, "dynamic-form", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CollectionItemComponent_div_0_div_4_div_3_Template, 4, 3, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.collectionForm && ctx_r2.collectionForm.formConfig && ctx_r2.collectionForm.form && ctx_r2.statuses);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.configService.env.hosted === true);
} }
function CollectionItemComponent_div_0_div_5_fi_template_renderer_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fi-template-renderer", 29);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("space", ctx_r2.space)("collection", ctx_r2.collection)("collectionForm", ctx_r2.collectionForm)("styles", ctx_r2.collectionForm.form.stylesheet)("template", ctx_r2.detailPageTemplate)("data", ctx_r2.collectionItem)("alias", ctx_r2.collection === "pages" ? ctx_r2.alias : undefined);
} }
function CollectionItemComponent_div_0_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "h6");
    i0.ɵɵtext(2, "No custom template defined");
    i0.ɵɵelementEnd()();
} }
function CollectionItemComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 18);
    i0.ɵɵtemplate(2, CollectionItemComponent_div_0_div_5_fi_template_renderer_2_Template, 1, 7, "fi-template-renderer", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CollectionItemComponent_div_0_div_5_div_3_Template, 3, 0, "div", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.detailPageTemplate > "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.detailPageTemplate);
} }
function CollectionItemComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, CollectionItemComponent_div_0_div_1_Template, 2, 1, "div", 6)(2, CollectionItemComponent_div_0_div_2_Template, 3, 1, "div", 7)(3, CollectionItemComponent_div_0_div_3_Template, 3, 1, "div", 6)(4, CollectionItemComponent_div_0_div_4_Template, 4, 2, "div", 6)(5, CollectionItemComponent_div_0_div_5_Template, 4, 2, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    let tmp_4_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.collection !== "pages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.loggingService.log);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ((tmp_4_0 = ctx_r2.getErrorLog()) == null ? null : tmp_4_0.length) > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.editing);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.editing);
} }
function CollectionItemComponent_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CollectionItemComponent_div_1_h6_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h6", 34);
    i0.ɵɵtext(1, " Click ");
    i0.ɵɵelementStart(2, "a", 35);
    i0.ɵɵlistener("click", function CollectionItemComponent_div_1_h6_7_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.back(ctx_r2.root)); });
    i0.ɵɵtext(3, "here");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " to go back to the search page ");
    i0.ɵɵelementEnd();
} }
function CollectionItemComponent_div_1_h6_8_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h6", 34);
    i0.ɵɵtext(1, " Click ");
    i0.ɵɵelementStart(2, "a", 35);
    i0.ɵɵlistener("click", function CollectionItemComponent_div_1_h6_8_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.back(null, true)); });
    i0.ɵɵtext(3, "here");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " to go back to the parent ");
    i0.ɵɵelementEnd();
} }
function CollectionItemComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 30);
    i0.ɵɵtemplate(2, CollectionItemComponent_div_1_ng_container_2_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8)(4, "div", 11)(5, "div", 31)(6, "div", 32);
    i0.ɵɵtemplate(7, CollectionItemComponent_div_1_h6_7_Template, 5, 0, "h6", 33)(8, CollectionItemComponent_div_1_h6_8_Template, 5, 0, "h6", 33);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵelement(10, "app-not-found");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const breadcrumbComponent_r1 = i0.ɵɵreference(5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", breadcrumbComponent_r1);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", !ctx_r2.queryParams._p);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.queryParams._p);
} }
function CollectionItemComponent_ng_template_4_ng_container_1_div_1_h6_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵelement(1, "i", 40);
    i0.ɵɵelementEnd();
} }
function CollectionItemComponent_ng_template_4_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38)(1, "a", 39);
    i0.ɵɵlistener("click", function CollectionItemComponent_ng_template_4_ng_container_1_div_1_Template_a_click_1_listener() { const b_r11 = i0.ɵɵrestoreView(_r10).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.goTo(b_r11)); });
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, CollectionItemComponent_ng_template_4_ng_container_1_div_1_h6_4_Template, 2, 0, "h6", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const b_r11 = ctx.$implicit;
    const i_r12 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(b_r11.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r12 < (ctx_r2.breadcrumb == null ? null : ctx_r2.breadcrumb.length));
} }
function CollectionItemComponent_ng_template_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CollectionItemComponent_ng_template_4_ng_container_1_div_1_Template, 5, 2, "div", 37);
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.breadcrumb);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.collectionForm.name || ctx_r2.collectionForm.formConfig.name || ctx_r2.collectionForm.collection);
} }
function CollectionItemComponent_ng_template_4_ng_container_2_h4_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.collectionForm.name || ctx_r2.collectionForm.formConfig.name || ctx_r2.collectionForm.collection);
} }
function CollectionItemComponent_ng_template_4_ng_container_2_h5_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.collectionForm.name || ctx_r2.collectionForm.formConfig.name || ctx_r2.collectionForm.collection);
} }
function CollectionItemComponent_ng_template_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 41);
    i0.ɵɵlistener("click", function CollectionItemComponent_ng_template_4_ng_container_2_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r13); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.back(null, true)); });
    i0.ɵɵtemplate(2, CollectionItemComponent_ng_template_4_ng_container_2_h4_2_Template, 2, 1, "h4", 42)(3, CollectionItemComponent_ng_template_4_ng_container_2_h5_3_Template, 2, 1, "h5", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.configService.env.hosted === true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.configService.env.hosted === false);
} }
function CollectionItemComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtemplate(1, CollectionItemComponent_ng_template_4_ng_container_1_Template, 4, 2, "ng-container", 4)(2, CollectionItemComponent_ng_template_4_ng_container_2_Template, 4, 2, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.collectionForm.collection);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r2.breadcrumb == null ? null : ctx_r2.breadcrumb.length) >= 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r2.breadcrumb == null ? null : ctx_r2.breadcrumb.length) < 1);
} }
function CollectionItemComponent_fi_buttons_bar_6_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44)(1, "p-button", 50);
    i0.ɵɵlistener("click", function CollectionItemComponent_fi_buttons_bar_6_div_4_Template_p_button_click_1_listener() { i0.ɵɵrestoreView(_r15); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.remove()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "p-button", 51);
    i0.ɵɵlistener("click", function CollectionItemComponent_fi_buttons_bar_6_div_4_Template_p_button_click_2_listener() { i0.ɵɵrestoreView(_r15); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.remove()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("rounded", true);
} }
function CollectionItemComponent_fi_buttons_bar_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fi-buttons-bar")(1, "div", 44)(2, "p-button", 45);
    i0.ɵɵlistener("click", function CollectionItemComponent_fi_buttons_bar_6_Template_p_button_click_2_listener() { i0.ɵɵrestoreView(_r14); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.save(false, undefined)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-button", 46);
    i0.ɵɵlistener("click", function CollectionItemComponent_fi_buttons_bar_6_Template_p_button_click_3_listener() { i0.ɵɵrestoreView(_r14); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.save(false, undefined)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, CollectionItemComponent_fi_buttons_bar_6_div_4_Template, 3, 1, "div", 47);
    i0.ɵɵelementStart(5, "div", 44);
    i0.ɵɵelement(6, "error-log-icon");
    i0.ɵɵelementStart(7, "p-button", 48);
    i0.ɵɵlistener("click", function CollectionItemComponent_fi_buttons_bar_6_Template_p_button_click_7_listener() { i0.ɵɵrestoreView(_r14); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.openErrors()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(8, "p-divider");
    i0.ɵɵelementStart(9, "div", 44)(10, "p-button", 49);
    i0.ɵɵlistener("click", function CollectionItemComponent_fi_buttons_bar_6_Template_p_button_click_10_listener() { i0.ɵɵrestoreView(_r14); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.back()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("rounded", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.alias && !ctx_r2.readonly && ctx_r2.deleteAllowed);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("rounded", true);
} }
class CollectionItemComponent extends DetailDirective {
    constructor(searchService, router, route, utilsService, collectionService, confirmationService, collectionItemService, userselectionService, dialogService, configService, userService, formDataService, workspaceService, loggingService, templateService, propertiesService, listConfigService, dynamicFormControlService, cacheService, errorHandler) {
        super(searchService, router, route, utilsService, collectionService, confirmationService, collectionItemService, userselectionService, dialogService, configService, userService, formDataService, workspaceService, loggingService, templateService, propertiesService, listConfigService, dynamicFormControlService, cacheService);
        this.errorHandler = errorHandler;
        this.editing = false;
        this.visible = true;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }
    ngOnInit() {
        this.errorHandler.notify = true;
        this.dialogsKey = 'data-editor';
        this.init();
    }
    ngOnDestroy() {
        this.errorHandler.notify = false;
        this.loggingService.log = [];
    }
    openErrors() {
        this.dialogService.open(ErrorLogComponent, {
            header: 'Errors log',
            width: '70vw',
            focusOnShow: false,
            modal: true,
            closable: true
        });
    }
    static { this.ɵfac = function CollectionItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CollectionItemComponent)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.CollectionService), i0.ɵɵdirectiveInject(i3$2.ConfirmationService), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(UserselectionService), i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.UsersService), i0.ɵɵdirectiveInject(FormDataService), i0.ɵɵdirectiveInject(i1.WorkspaceService), i0.ɵɵdirectiveInject(i1.LoggingService), i0.ɵɵdirectiveInject(i1.TemplateService), i0.ɵɵdirectiveInject(i1.PropertiesService), i0.ɵɵdirectiveInject(i1.ListConfigService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(i1.CacheService), i0.ɵɵdirectiveInject(i1.ErrorHandlerService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CollectionItemComponent, selectors: [["collection-item"]], inputs: { space: "space", collection: "collection", alias: "alias", editing: "editing", restricted: "restricted" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 3, consts: [["breadcrumbComponent", ""], ["dynamicFormPage", ""], ["class", "row data-editor", 4, "ngIf"], ["header", "Warning", "icon", "pi pi-exclamation-triangle", "key", "data-editor"], [4, "ngIf"], [1, "row", "data-editor"], ["class", "col-md-12", 4, "ngIf"], ["class", "col-md-12 errors-log", 4, "ngIf"], [1, "col-md-12"], [4, "ngTemplateOutlet"], [1, "col-md-12", "errors-log"], [1, "row"], ["class", "col-md-12", 4, "ngFor", "ngForOf"], [1, "error-code"], [1, "error-message"], [1, "simple-list", "list-unstyled", "errors-log"], [4, "ngFor", "ngForOf"], [1, "bi", "bi-chevron-right"], [1, "form-container"], [3, "status", "statuses", "readonly", "operation", "space", "formData", "dynamicForm", "params", "nextForm", "statusChange", 4, "ngIf"], ["class", "form-buttons align-center", 4, "ngIf"], [3, "nextForm", "statusChange", "status", "statuses", "readonly", "operation", "space", "formData", "dynamicForm", "params"], [1, "form-buttons", "align-center"], ["icon", "pi pi-save", "severity", "success", "label", "Submit", 3, "click", "raised"], ["icon", "bi bi-trash", "severity", "danger", "label", "Delete", 3, "raised", "click", 4, "ngIf"], ["icon", "bi bi-arrow-return-left", "severity", "warn", "label", "Back", 3, "click", "raised"], ["icon", "bi bi-trash", "severity", "danger", "label", "Delete", 3, "click", "raised"], [3, "space", "collection", "collectionForm", "styles", "template", "data", "alias", 4, "ngIf"], ["class", "form-container", 4, "ngIf"], [3, "space", "collection", "collectionForm", "styles", "template", "data", "alias"], [1, "col-md-12", "mb-3"], [1, "sf_colsIn", "col-md-12"], [1, "sf_colsIn", "container"], ["class", "text-color-gray-medium", 4, "ngIf"], [1, "text-color-gray-medium"], ["role", "button", 1, "text-color-primary", 3, "click"], [1, "lightforms-breadcrumb", 3, "ngClass"], ["class", "lightforms-breadcrumb-item", 4, "ngFor", "ngForOf"], [1, "lightforms-breadcrumb-item"], ["role", "button", 1, "nav-link", "text-color-primary", 3, "click"], [1, "pi", "pi-chevron-right"], ["role", "button", 1, "nav-link", 3, "click"], ["class", "title-highlight", 4, "ngIf"], [1, "title-highlight"], [1, "fluid-button-container"], ["icon", "pi pi-save", "severity", "success", "title", "Save", 3, "click", "rounded"], ["label", "Save", "variant", "text", "severity", "secondary", 1, "label-button", 3, "click"], ["class", "fluid-button-container", 4, "ngIf"], ["label", "Errors", "variant", "text", "severity", "secondary", 1, "label-button", 3, "click"], ["icon", "bi bi-arrow-return-left", "severity", "warn", "title", "Back", 3, "click", "rounded"], ["icon", "bi bi-trash", "severity", "danger", "title", "Delete", 3, "click", "rounded"], ["label", "Delete", "variant", "text", "severity", "secondary", 1, "label-button", 3, "click"]], template: function CollectionItemComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, CollectionItemComponent_div_0_Template, 6, 5, "div", 2)(1, CollectionItemComponent_div_1_Template, 11, 3, "div", 2);
            i0.ɵɵelement(2, "p-toast")(3, "p-confirmDialog", 3);
            i0.ɵɵtemplate(4, CollectionItemComponent_ng_template_4_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(6, CollectionItemComponent_fi_buttons_bar_6_Template, 11, 3, "fi-buttons-bar", 4);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.pageReady);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.notfound);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.pageReady && ctx.editing && ctx.configService.env.hosted === false);
        } }, styles: [".errors-log[_ngcontent-%COMP%]{color:var(--danger-color)}.error-code[_ngcontent-%COMP%]{font-weight:700;margin-right:.5em}.simple-list[_ngcontent-%COMP%]{margin-bottom:0!important}.collection-item-edit[_ngcontent-%COMP%]{margin-left:.5em;margin-top:.2em}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollectionItemComponent, [{
        type: Component,
        args: [{ selector: 'collection-item', standalone: false, template: "  <!-- PAGE -------------------->\r\n  <div class=\"row data-editor\" *ngIf=\"pageReady\">\r\n  \r\n    <!-- ADDITIONAL INFO -->\r\n    <div class=\"col-md-12\" *ngIf=\"collection !== 'pages'\">\r\n      <ng-container *ngTemplateOutlet=\"breadcrumbComponent\"></ng-container>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12 errors-log\" *ngIf=\"loggingService.log\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\" *ngFor=\"let log of loggingService.log\">\r\n          <label class=\"error-code\">{{ log.code  }}</label>\r\n          <label class=\"error-message\">{{ log.message }}</label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\" *ngIf=\"getErrorLog()?.length > 0\">\r\n      <ul class=\"simple-list list-unstyled errors-log\">\r\n        <li *ngFor=\"let error of getErrorLog()\"><i class=\"bi bi-chevron-right\"></i><label>{{ error.label + \": \" }}<label class=\"error-code\">{{ (!error.value ? \"&lt;empty&gt;\" : error.value) }}</label></label></li>\r\n      </ul>\r\n    </div>\r\n    <!--------------------->\r\n  \r\n    <div class=\"col-md-12\" *ngIf=\"editing\">\r\n      <div class=\"form-container\">\r\n        <dynamic-form *ngIf=\"collectionForm && collectionForm.formConfig && collectionForm.form && statuses\" #dynamicFormPage [status]=\"getInitialStatus()\" [statuses]=\"statuses\" [readonly]=\"readonly\" [operation]=\"operation\" [space]=\"space\" [formData]=\"collectionItem.document\" [dynamicForm]=\"collectionForm.form\" [params]=\"collectionForm.form.params\" (nextForm)=\"onNextForm($event)\" (statusChange)=\"onStatusChange($event)\"></dynamic-form>    \r\n      </div>\r\n      <div class=\"form-buttons align-center\" *ngIf=\"configService.env.hosted === true\">\r\n        <p-button icon=\"pi pi-save\" [raised]=\"true\" severity=\"success\" label=\"Submit\" (click)=\"save(false,undefined)\"></p-button>\r\n        <p-button icon=\"bi bi-trash\" *ngIf=\"alias && !readonly && deleteAllowed\" [raised]=\"true\" severity=\"danger\" label=\"Delete\" (click)=\"remove()\"></p-button>\r\n        <p-button icon=\"bi bi-arrow-return-left\" [raised]=\"true\" severity=\"warn\" label=\"Back\" (click)=\"back()\"></p-button>\r\n      </div>\r\n    </div>\r\n  \r\n    <div class=\"col-md-12\" *ngIf=\"!editing\">\r\n      <div class=\"form-container\">\r\n        <fi-template-renderer\r\n          *ngIf=\"detailPageTemplate > ''\" \r\n          [space]=\"space\"\r\n          [collection]=\"collection\"\r\n          [collectionForm]=\"collectionForm\"\r\n          [styles]=\"collectionForm.form.stylesheet\"\r\n          [template]=\"detailPageTemplate\" \r\n          [data]=\"collectionItem\"\r\n          [alias]=\"collection === 'pages' ? alias : undefined\">\r\n        </fi-template-renderer>\r\n      </div>\r\n      <div class=\"form-container\" *ngIf=\"!detailPageTemplate\">\r\n        <h6>No custom template defined</h6>\r\n      </div>\r\n    </div>\r\n  \r\n  </div>\r\n  <!---------------------------->\r\n  \r\n  <!-- NOT FOUND --------------->\r\n  <div class=\"row data-editor\" *ngIf=\"notfound\">\r\n    <div class=\"col-md-12 mb-3\">\r\n      <ng-container *ngTemplateOutlet=\"breadcrumbComponent\"></ng-container>\r\n    </div>\r\n    \r\n    <div class=\"col-md-12\">\r\n      <div class=\"row\">\r\n        <div class=\"sf_colsIn col-md-12\">\r\n          <div class=\"sf_colsIn container\">\r\n            <h6 class=\"text-color-gray-medium\" *ngIf=\"!queryParams._p\">\r\n              Click <a class=\"text-color-primary\" role=\"button\" (click)=\"back(root)\">here</a> to go back to the search page\r\n            </h6>\r\n            <h6 class=\"text-color-gray-medium\" *ngIf=\"queryParams._p\">\r\n              Click <a class=\"text-color-primary\" role=\"button\" (click)=\"back(null,true)\">here</a> to go back to the parent\r\n            </h6>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-md-12\">\r\n      <app-not-found></app-not-found>\r\n    </div>\r\n  </div>\r\n  <!----------------------------->\r\n   \r\n  <p-toast></p-toast>\r\n  <p-confirmDialog header=\"Warning\" icon=\"pi pi-exclamation-triangle\" key=\"data-editor\"></p-confirmDialog>\r\n  \r\n  <ng-template #breadcrumbComponent>\r\n    <div class=\"lightforms-breadcrumb\" [ngClass]=\"collectionForm.collection\">\r\n      <ng-container *ngIf=\"breadcrumb?.length >= 1\">\r\n        <div class=\"lightforms-breadcrumb-item\" *ngFor=\"let b of breadcrumb; let i = index\">\r\n          <a class=\"nav-link text-color-primary\" role=\"button\" (click)=\"goTo(b)\"><h5>{{b.name}}</h5></a>          \r\n          <h6 *ngIf=\"i < breadcrumb?.length\"><i class=\"pi pi-chevron-right\"></i></h6>\r\n        </div>\r\n        <h5>{{collectionForm.name || collectionForm.formConfig.name || collectionForm.collection }}</h5>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"breadcrumb?.length < 1\">\r\n        <a class=\"nav-link\" role=\"button\" (click)=\"back(null,true)\">\r\n          <h4 *ngIf=\"configService.env.hosted === true\" class=\"title-highlight\">{{collectionForm.name || collectionForm.formConfig.name || collectionForm.collection}}</h4>\r\n          <h5 *ngIf=\"configService.env.hosted === false\">{{collectionForm.name || collectionForm.formConfig.name || collectionForm.collection}}</h5>\r\n        </a>\r\n      </ng-container>\r\n    </div>  \r\n  </ng-template>\r\n\r\n  <fi-buttons-bar *ngIf=\"pageReady && editing && configService.env.hosted === false\">\r\n    <div class=\"fluid-button-container\">\r\n      <p-button icon=\"pi pi-save\" [rounded]=\"true\" severity=\"success\" title=\"Save\" (click)=\"save(false,undefined)\"></p-button>\r\n      <p-button class=\"label-button\" label=\"Save\" variant=\"text\" severity=\"secondary\" (click)=\"save(false,undefined)\" />\r\n    </div>\r\n    <div class=\"fluid-button-container\" *ngIf=\"alias && !readonly && deleteAllowed\">\r\n      <p-button icon=\"bi bi-trash\" [rounded]=\"true\" severity=\"danger\" title=\"Delete\" (click)=\"remove()\"></p-button>\r\n      <p-button class=\"label-button\" label=\"Delete\" variant=\"text\" severity=\"secondary\" (click)=\"remove()\" />\r\n    </div>\r\n    <div class=\"fluid-button-container\">\r\n      <error-log-icon></error-log-icon>\r\n      <p-button class=\"label-button\" label=\"Errors\" variant=\"text\" severity=\"secondary\" (click)=\"openErrors()\" />\r\n    </div>\r\n    <p-divider />\r\n    <div class=\"fluid-button-container\">\r\n      <p-button icon=\"bi bi-arrow-return-left\" [rounded]=\"true\" severity=\"warn\" title=\"Back\" (click)=\"back()\"></p-button>\r\n    </div>\r\n  </fi-buttons-bar>", styles: [".errors-log{color:var(--danger-color)}.error-code{font-weight:700;margin-right:.5em}.simple-list{margin-bottom:0!important}.collection-item-edit{margin-left:.5em;margin-top:.2em}\n"] }]
    }], () => [{ type: i1.SearchService }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i1.UtilsService }, { type: i1.CollectionService }, { type: i3$2.ConfirmationService }, { type: FormDataService }, { type: UserselectionService }, { type: i1$1.DialogService }, { type: i1.ConfigurationService }, { type: i1.UsersService }, { type: FormDataService }, { type: i1.WorkspaceService }, { type: i1.LoggingService }, { type: i1.TemplateService }, { type: i1.PropertiesService }, { type: i1.ListConfigService }, { type: i1.DynamicFormControlService }, { type: i1.CacheService }, { type: i1.ErrorHandlerService }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], alias: [{
            type: Input
        }], editing: [{
            type: Input
        }], restricted: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CollectionItemComponent, { className: "CollectionItemComponent", filePath: "src/components/collection-item/collection-item.component.ts", lineNumber: 17 }); })();

class FileSizePipe {
    constructor() {
        this.units = ['B', 'KB', 'MB', 'GB', 'TB'];
    }
    transform(size, decimals = 2, useBase10 = true) {
        if (size === 0)
            return '0 B';
        if (!size || size < 0)
            return 'N/A';
        // use base10 to be compliant with filesystem size otherwise use Base 2 ( 1024 per KB)
        const base = useBase10 ? 1000 : 1024;
        const i = Math.floor(Math.log(size) / Math.log(base));
        const formattedSize = (size / Math.pow(base, i)).toFixed(decimals);
        return `${formattedSize.replace(/\.00$/, '')} ${this.units[i]}`;
    }
    static { this.ɵfac = function FileSizePipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FileSizePipe)(); }; }
    static { this.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "fileSize", type: FileSizePipe, pure: true, standalone: false }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileSizePipe, [{
        type: Pipe,
        args: [{
                name: 'fileSize',
                standalone: false
            }]
    }], null, null); })();

class RendererService {
    constructor(configService, dynamicFormService, dynamicFormControlService, dialogService, propertiesService) {
        this.configService = configService;
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.dialogService = dialogService;
        this.propertiesService = propertiesService;
        this.window = window;
        this.document = document;
    }
    translateKey(key, params) {
        return this.configService.getTranslation(key, params);
    }
    getProperty(collectionForm, data, id, type, subform, lang, properties) {
        /*     if (!collectionForm)
            {
              let props = this.propertiesService.spaceProperties.filter(item => item.id === id);
              if (props.length > 0) {
                let property = props[0][type];
                if (properties) {
                  for(let key in properties) {
                    property = property.replace("${" + key + "}",properties[key]);
                  }
                  return property;
                }
              }
              else {
                return id;
              }
            }
            else
            { */
        if (!properties) {
            return this.dynamicFormControlService.getProperty(data, collectionForm?.form, {
                refPropertiesId: id,
                code: id
            }, type, lang, subform);
        }
        else {
            let property = this.dynamicFormControlService.getProperty(data, collectionForm?.form, {
                refPropertiesId: id,
                code: id
            }, type, lang, subform);
            for (let key in properties) {
                property = property.replace("${" + key + "}", properties[key]);
            }
            return property;
        }
        /* } */
    }
    getFieldProperty(collectionForm, data, fieldId, type, subform, lang) {
        if (!subform) {
            let components = jsonPath__default.query(collectionForm?.form.components, '$..[?(@.pathId==\'' + (fieldId || '') + '\')]');
            if (components.length > 0) {
                return this.dynamicFormControlService.getProperty(data, collectionForm?.form, components[0], type, lang, subform);
            }
            else {
                return fieldId;
            }
        }
        else {
            let subformComponents = this.dynamicFormService.getNestedFormChildren(collectionForm?.form, subform);
            let components = jsonPath__default.query(subformComponents, '$..[?(@.pathId==\'' + (fieldId.replace(subform + ".", "") || '') + '\')]');
            if (components.length > 0) {
                return this.dynamicFormControlService.getProperty(data, collectionForm?.form, components[0], type, lang, subform);
            }
            else {
                return fieldId;
            }
        }
    }
    checkVisibility(collectionForm, data, code, subform) {
        let xpath = '';
        if (code.includes('.')) {
            xpath = code.substring(0, code.lastIndexOf('.'));
        }
        if (!subform) {
            let components = jsonPath__default.query(collectionForm?.form.components, '$..[?(@.pathId==\'' + (code || '') + '\')]');
            if (components.length > 0) {
                return this.dynamicFormControlService.processVisibilityConditions(collectionForm?.form, components[0], data.document, xpath);
            }
            else {
                return true;
            }
        }
        else {
            let subformForm = this.dynamicFormService.getForm(collectionForm?.form, subform);
            let subformComponents = this.dynamicFormService.getNestedFormChildren(collectionForm?.form, subform);
            let components = jsonPath__default.query(subformComponents, '$..[?(@.pathId==\'' + (code.replace(subform + ".", "") || '') + '\')]');
            if (components.length > 0) {
                return this.dynamicFormControlService.processVisibilityConditions(subformForm, components[0], data.document, xpath);
            }
            else {
                return true;
            }
        }
    }
    isArrayEmpty(items, conditions) {
        if (!conditions) {
            conditions = {};
        }
        let filteredItems = items.filter(item => {
            let matches = true;
            for (let key in conditions) {
                if (item[key] !== conditions[key]) {
                    matches = false;
                }
            }
            return matches;
        });
        return filteredItems.length === 0;
    }
    showHidePopup(id, state) {
        var popup = document.getElementById(id);
        let title = popup.getElementsByClassName("forTable");
        if (title.length > 0) {
            title[0].setAttribute("style", "display: none;");
        }
        const ref = this.dialogService.open(DynamicDialogComponent$1, {
            header: title.length > 0 ? title[0].innerHTML : "",
            data: {
                template: popup.outerHTML.replace('class="hidden"', "")
            },
            width: '80%',
            focusOnShow: false,
            modal: true,
            closable: true
        });
        ref.onClose.subscribe((definition) => {
        });
        /*
            if (state) {
              popup.setAttribute("class","visible");
            } else {
              popup.setAttribute("class","hidden");
            } */
    }
    static { this.ɵfac = function RendererService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RendererService)(i0.ɵɵinject(i1.ConfigurationService), i0.ɵɵinject(i1.DynamicFormService), i0.ɵɵinject(i1.DynamicFormControlService), i0.ɵɵinject(i1$1.DialogService), i0.ɵɵinject(i1.PropertiesService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RendererService, factory: RendererService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RendererService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.ConfigurationService }, { type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: i1$1.DialogService }, { type: i1.PropertiesService }], null); })();

const _c0$1 = ["dynamicComponentContainer"];
function TemplateRendererComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.cssclass)("innerHTML", i0.ɵɵpipeBind2(1, 2, ctx_r0.template, "html"), i0.ɵɵsanitizeHtml);
} }
class TemplateRendererComponent {
    constructor(configService, cacheService, utilsService, dynamicFormService, dynamicFormControlService, rendererService, templateService, modulesService, injector, cdr) {
        this.configService = configService;
        this.cacheService = cacheService;
        this.utilsService = utilsService;
        this.dynamicFormService = dynamicFormService;
        this.dynamicFormControlService = dynamicFormControlService;
        this.rendererService = rendererService;
        this.templateService = templateService;
        this.modulesService = modulesService;
        this.injector = injector;
        this.cdr = cdr;
        this.config = {};
        this.data = {};
        this.template = '';
        this.templateType = "detail";
        this.styles = '';
        this.loading = true;
        this.window = window;
        this.document = document;
        this.dynamic = false;
    }
    async ngAfterViewInit() {
        //console.log("------TEMPLATE RENDERER------");
        if (!this.templateSpace) {
            this.templateSpace = this.space;
        }
        if (!this.templateCollection) {
            this.templateCollection = this.collection;
        }
        if (this.templateId) {
            let ident = (this.templateSpace || this.space) + "_" + (this.templateCollection || this.collection) + "_" + this.templateType + "_" + this.templateId;
            if (!this.cacheService.isTemplateCached(ident)) {
                this.template = await this.templateService.asyncGetTemplateByIdCompressed(this.templateSpace || this.space, this.templateCollection || this.collection, this.templateType, this.templateId);
                this.cacheService.cacheTemplate(ident, this.template);
                this.instantiateComponent();
            }
            else {
                this.template = this.cacheService.getTemplate(ident);
                this.instantiateComponent();
            }
        }
        else if (this.templateUrl) {
            this.template = await this.configService.loadFile(this.templateUrl, "text");
            this.template = this.template.substring(this.template.indexOf("<svg"));
            this.instantiateComponent();
        }
        else {
            this.instantiateComponent();
        }
    }
    instantiateComponent() {
        if (this.template > "") {
            this.template = this.template.replaceAll("@", "&#64;");
        }
        else {
            return;
        }
        //console.log(this.template);
        try {
            //console.log("getAngularRegex - " + this.modulesService.getAngularRegex().test(this.template));
            //console.log("getAngularDirectivesRegexp - " + this.modulesService.getAngularDirectivesRegexp().test(this.template));
            //To fix the regexp to text angular directives because if in the text there are brackets, round or square, it is considered as dynamic
            if (this.modulesService.getAngularRegex().test(this.template) || this.modulesService.getAngularDirectivesRegexp().test(this.template)) {
                this.dynamic = true;
                this.createComponent();
            }
            else {
                this.dynamic = false;
            }
            //console.log(this.dynamic);
        }
        catch (error) {
            console.log("-----ERROR-----");
            console.log(error);
            console.log(this.template);
        }
        this.loading = false;
        this.cdr.detectChanges();
    }
    createComponent() {
        let component;
        let ident = this.modulesService.getTemplateId(this.templateSpace || this.space || this.configService.env.space, this.templateCollection || this.collection, this.template, this.alias);
        if (ident) {
            if (!this.cacheService.isDynamicComponentCached(ident)) {
                component = Component({ template: this.template, standalone: true,
                    imports: this.modulesService.getDynamicModules(),
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    styles: [
                        this.styles || ''
                    ] })(class {
                });
                this.cacheService.cacheDynamicComponent(ident, component);
            }
            else {
                component = this.cacheService.getDynamicComponent(ident);
            }
        }
        else {
            component = Component({ template: this.template, standalone: true,
                imports: this.modulesService.getDynamicModules(),
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                styles: [
                    this.styles || ''
                ] })(class {
            });
        }
        this.container.clear();
        this.componentRef = this.container.createComponent(component, { injector: this.injector });
        if (component) {
            this.componentRef.instance['window'] = window;
            this.componentRef.instance['document'] = document;
            this.componentRef.instance['siteUrl'] = this.configService.env.siteUrl;
            this.componentRef.instance['baseUrl'] = this.configService.env.baseHref + this.configService.env.currentLang;
            this.componentRef.instance['defaultLang'] = this.configService.env.defaultLang;
            this.componentRef.instance['currentLang'] = this.configService.env.currentLang || this.configService.env.defaultLang;
            this.componentRef.instance['currentYear'] = new Date().getFullYear();
            this.componentRef.instance['config'] = this.config;
            this.componentRef.instance['data'] = this.data;
            this.componentRef.instance['space'] = this.space || this.configService.env.space;
            this.componentRef.instance['collection'] = this.collection;
            this.componentRef.instance['collectionForm'] = this.collectionForm;
            this.componentRef.instance['configService'] = this.configService;
            this.componentRef.instance['utilsService'] = this.utilsService;
            this.componentRef.instance['dynamicFormService'] = this.dynamicFormService;
            this.componentRef.instance['dynamicFormControlService'] = this.dynamicFormControlService;
            this.componentRef.instance['rendererService'] = this.rendererService;
        }
        this.cdr.detectChanges();
    }
    static { this.ɵfac = function TemplateRendererComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TemplateRendererComponent)(i0.ɵɵdirectiveInject(i1.ConfigurationService), i0.ɵɵdirectiveInject(i1.CacheService), i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i1.DynamicFormService), i0.ɵɵdirectiveInject(i1.DynamicFormControlService), i0.ɵɵdirectiveInject(RendererService), i0.ɵɵdirectiveInject(i1.TemplateService), i0.ɵɵdirectiveInject(ModulesService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TemplateRendererComponent, selectors: [["fi-template-renderer"]], viewQuery: function TemplateRendererComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1, 5, ViewContainerRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
        } }, inputs: { space: "space", collection: "collection", collectionForm: "collectionForm", config: "config", data: "data", template: "template", templateSpace: "templateSpace", templateCollection: "templateCollection", templateId: "templateId", templateType: "templateType", templateUrl: "templateUrl", cssclass: "cssclass", styles: "styles", alias: "alias" }, standalone: false, decls: 3, vars: 1, consts: [["dynamicComponentContainer", ""], ["class", "html-renderer", 3, "ngClass", "innerHTML", 4, "ngIf"], [1, "html-renderer", 3, "ngClass", "innerHTML"]], template: function TemplateRendererComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementContainer(0, null, 0);
            i0.ɵɵtemplate(2, TemplateRendererComponent_span_2_Template, 2, 5, "span", 1);
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.dynamic);
        } }, dependencies: [i3.NgClass, i3.NgIf, SafePipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplateRendererComponent, [{
        type: Component,
        args: [{ selector: 'fi-template-renderer', standalone: false, template: "<!-- <div class=\"row spinner\" *ngIf=\"loading\">\r\n    <div class=\"col-md-12 mb-3 align-center\">\r\n      <div class=\"spinner-border\" role=\"status\">\r\n        <span class=\"sr-only\">{{ rendererService.translateKey('common.loading') }}</span>\r\n      </div>\r\n    </div>\r\n</div> -->\r\n\r\n<ng-container #dynamicComponentContainer></ng-container>\r\n\r\n<span *ngIf=\"!dynamic\" class=\"html-renderer\" [ngClass]=\"cssclass\" [innerHTML]=\"template | safe: 'html'\"></span>" }]
    }], () => [{ type: i1.ConfigurationService }, { type: i1.CacheService }, { type: i1.UtilsService }, { type: i1.DynamicFormService }, { type: i1.DynamicFormControlService }, { type: RendererService }, { type: i1.TemplateService }, { type: ModulesService }, { type: i0.Injector }, { type: i0.ChangeDetectorRef }], { space: [{
            type: Input
        }], collection: [{
            type: Input
        }], collectionForm: [{
            type: Input
        }], config: [{
            type: Input
        }], data: [{
            type: Input
        }], template: [{
            type: Input
        }], templateSpace: [{
            type: Input
        }], templateCollection: [{
            type: Input
        }], templateId: [{
            type: Input
        }], templateType: [{
            type: Input
        }], templateUrl: [{
            type: Input
        }], cssclass: [{
            type: Input
        }], styles: [{
            type: Input
        }], alias: [{
            type: Input
        }], container: [{
            type: ViewChild,
            args: ['dynamicComponentContainer', { read: ViewContainerRef }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TemplateRendererComponent, { className: "TemplateRendererComponent", filePath: "src/components/template-renderer/template-renderer.component.ts", lineNumber: 11 }); })();

const _c0 = ["*"];
class ButtonsBarComponent {
    constructor() {
        this.mini = true;
    }
    toggleSidebar(value) {
        this.mini = value || !this.mini;
        if (this.mini) {
            document.getElementById("mySidebar").style.width = "210px";
        }
        else {
            document.getElementById("mySidebar").style.width = "65px";
        }
    }
    expandSidebar() {
        this.mini = false;
        document.getElementById("mySidebar").style.width = "210px";
    }
    collapseSidebar() {
        this.mini = true;
        document.getElementById("mySidebar").style.width = "65px";
    }
    static { this.ɵfac = function ButtonsBarComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ButtonsBarComponent)(); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ButtonsBarComponent, selectors: [["fi-buttons-bar"]], standalone: false, ngContentSelectors: _c0, decls: 3, vars: 0, consts: [["id", "mySidebar", 1, "sidebar", 3, "mouseover", "mouseout", "click"]], template: function ButtonsBarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("mouseover", function ButtonsBarComponent_Template_div_mouseover_0_listener() { return ctx.expandSidebar(); })("mouseout", function ButtonsBarComponent_Template_div_mouseout_0_listener() { return ctx.collapseSidebar(); })("click", function ButtonsBarComponent_Template_div_click_0_listener() { return ctx.toggleSidebar(ctx.mini); });
            i0.ɵɵelementContainerStart(1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonsBarComponent, [{
        type: Component,
        args: [{ selector: 'fi-buttons-bar', standalone: false, template: "<div id=\"mySidebar\" class=\"sidebar\" (mouseover)=\"expandSidebar()\" (mouseout)=\"collapseSidebar()\" (click)=\"toggleSidebar(mini)\">\r\n  <ng-container>\r\n    <ng-content></ng-content> <!-- This will render projected content -->\r\n  </ng-container>\r\n</div>" }]
    }], () => [], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ButtonsBarComponent, { className: "ButtonsBarComponent", filePath: "src/components/buttons-bar/buttons-bar.component.ts", lineNumber: 9 }); })();

function DocComponent_markdown_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "markdown", 1);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r0.content);
} }
class DocComponent {
    constructor(http, searchService) {
        this.http = http;
        this.searchService = searchService;
    }
    ngOnInit() {
        if (!this.content) {
            this.http.get("./assets/docs/" + this.code + (this.section ? "/" + this.section : "") + (this.subsection ? "/" + this.subsection : "") + (this.subsubsection ? "/" + this.subsubsection : "") + ".md", {
                responseType: "text"
            }).subscribe((res) => {
                this.content = res;
            }, error => {
                this.searchService.manageError(error, 'Error extracting ' + this.code + ' document');
            });
        }
    }
    static { this.ɵfac = function DocComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DocComponent)(i0.ɵɵdirectiveInject(i1$3.HttpClient), i0.ɵɵdirectiveInject(i1.SearchService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DocComponent, selectors: [["fi-doc"]], inputs: { code: "code", section: "section", subsection: "subsection", subsubsection: "subsubsection", content: "content" }, standalone: false, decls: 1, vars: 1, consts: [["lineHighlight", "", "class", "variable-binding", 3, "data", 4, "ngIf"], ["lineHighlight", "", 1, "variable-binding", 3, "data"]], template: function DocComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DocComponent_markdown_0_Template, 1, 1, "markdown", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.content);
        } }, dependencies: [i3.NgIf, i4$3.MarkdownComponent], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocComponent, [{
        type: Component,
        args: [{ selector: 'fi-doc', standalone: false, template: "<markdown \r\n    lineHighlight\r\n    *ngIf=\"content\" \r\n    class=\"variable-binding\" \r\n    [data]=\"content\">\r\n</markdown>" }]
    }], () => [{ type: i1$3.HttpClient }, { type: i1.SearchService }], { code: [{
            type: Input
        }], section: [{
            type: Input
        }], subsection: [{
            type: Input
        }], subsubsection: [{
            type: Input
        }], content: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DocComponent, { className: "DocComponent", filePath: "src/components/doc/doc.component.ts", lineNumber: 11 }); })();

const components = [
    HtmlRendererComponent,
    ObjectListComponent,
    AnchorComponent,
    BibliographyComponent,
    CalendarComponent,
    CardComponent,
    CardsComponent,
    CartComponent,
    CartHandlerComponent,
    CartButtonsComponent,
    ChartComponent,
    CitationComponent,
    CollectionNavigatorComponent,
    DataListComponent,
    DatatypeSearchComponent,
    DocumentsComponent,
    DocumentsListComponent,
    FactsheetIntroComponent,
    FiFilterTermsComponent,
    FiListComponent,
    FiSearchPillsComponent,
    FlagComponent,
    GroupedResultComponent,
    ImageComponent,
    ImageModalComponent,
    ImageButtonComponent,
    ImageGalleryComponent,
    ImageGalleryModalComponent,
    ImageViewerComponent,
    ImageViewerModalComponent,
    MapComponent,
    MapTipsComponent,
    LayersListComponent,
    LegendsListComponent,
    ProjectionsListComponent,
    ModalComponent,
    PaginationComponent,
    ReferenceComponent,
    RelatedLinksComponent,
    StandardResultComponent,
    SourcesComponent,
    TableComponent,
    TabsComponent,
    TocComponent,
    VideoPlayerComponent,
    StatusNoteComponent,
    ButtonComponent,
    FormErrorsManagerComponent,
    FormulaEditorComponent,
    GlobalParametersComponent,
    LoadingComponent,
    NotFoundComponent,
    UserRegisterComponent,
    SearchListComponent,
    HtmlEditorComponent,
    ErrorLogComponent,
    ErrorLogIconComponent,
    DebugInfoComponent,
    SliderComponent,
    HierarchyComponent,
    LevelComponent,
    QrcodeComponent,
    FiFilterComponent,
    GeosearchComponent,
    LoginButtonComponent,
    RegisterButtonComponent,
    LogoutButtonComponent,
    JsonViewerComponent,
    DynamicDialogComponent,
    GeometryEditorComponent,
    CollectionListComponent,
    CollectionItemComponent,
    TemplateRendererComponent,
    ButtonsBarComponent,
    DocComponent
];
const dynamic_form_components = [
    DebugDetailsComponent,
    DynamicFormPage,
    DynamicFormArrayView,
    DynamicFormCheckboxlistView,
    DynamicFormControlView,
    DynamicFormGroupView,
    DynamicFormGroupLatLongView,
    DynamicFormGroupselectView,
    DynamicFormNestedFormView,
    DynamicFormSwitcherView,
    DynamicFormKeyselectView,
    DynamicFormGeometryComponent,
    DynamicFormGeometryItemComponent,
    HelpComponent,
    ShareModalComponent
];
const primeng_components = [
    AccordionModule,
    TimelineModule,
    ConfirmDialogModule,
    MenuModule,
    DynamicDialogModule,
    TableModule,
    ButtonModule,
    DialogModule,
    ToastModule,
    SelectModule,
    TabsModule,
    FileUploadModule,
    MultiSelectModule,
    RadioButtonModule,
    TextareaModule,
    InputTextModule,
    InputNumberModule,
    CheckboxModule,
    ListboxModule,
    FieldsetModule,
    PanelModule,
    TreeModule,
    ContextMenuModule,
    ConfirmPopupModule,
    ChipModule,
    AutoCompleteModule,
    ToggleButtonModule,
    BadgeModule,
    InputGroupModule,
    InputGroupAddonModule,
    SliderModule,
    TooltipModule,
    TagModule,
    SidebarModule,
    DividerModule,
    ProgressBarModule,
    ScrollPanelModule
];
const primeng_providers = [
    ConfirmationService,
    DialogService,
    DynamicDialogRef,
    DynamicDialogConfig,
    MessageService
];
class LightformsComponentsModule {
    static { this.ɵfac = function LightformsComponentsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LightformsComponentsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LightformsComponentsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            FormDataService,
            UserselectionService,
            ModulesService,
            RendererService,
            DecimalPipe,
            primeng_providers
        ], imports: [CommonModule,
            RouterModule,
            FormsModule,
            ReactiveFormsModule,
            YouTubePlayerModule,
            NgxJsonViewerModule,
            ClipboardModule,
            LightformsServicesModule,
            primeng_components,
            MonacoEditorModule.forRoot(),
            MarkdownModule.forRoot(), CommonModule,
            RouterModule,
            FormsModule,
            ReactiveFormsModule, AccordionModule,
            TimelineModule,
            ConfirmDialogModule,
            MenuModule,
            DynamicDialogModule,
            TableModule,
            ButtonModule,
            DialogModule,
            ToastModule,
            SelectModule,
            TabsModule,
            FileUploadModule,
            MultiSelectModule,
            RadioButtonModule,
            TextareaModule,
            InputTextModule,
            InputNumberModule,
            CheckboxModule,
            ListboxModule,
            FieldsetModule,
            PanelModule,
            TreeModule,
            ContextMenuModule,
            ConfirmPopupModule,
            ChipModule,
            AutoCompleteModule,
            ToggleButtonModule,
            BadgeModule,
            InputGroupModule,
            InputGroupAddonModule,
            SliderModule,
            TooltipModule,
            TagModule,
            SidebarModule,
            DividerModule,
            ProgressBarModule,
            ScrollPanelModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LightformsComponentsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    components,
                    dynamic_form_components,
                    KeysPipe,
                    OrderByPipe,
                    SafePipe,
                    FileSizePipe,
                    TruncatePipe,
                    ListDirective,
                    DetailDirective,
                    ResultsDirective,
                    FullscreenDirective,
                    DynamicHostDirective
                ],
                imports: [
                    CommonModule,
                    RouterModule,
                    FormsModule,
                    ReactiveFormsModule,
                    YouTubePlayerModule,
                    NgxJsonViewerModule,
                    ClipboardModule,
                    LightformsServicesModule,
                    primeng_components,
                    MonacoEditorModule.forRoot(),
                    MarkdownModule.forRoot()
                ],
                exports: [
                    CommonModule,
                    RouterModule,
                    FormsModule,
                    ReactiveFormsModule,
                    ListDirective,
                    DetailDirective,
                    ResultsDirective,
                    FullscreenDirective,
                    DynamicHostDirective,
                    components,
                    dynamic_form_components,
                    primeng_components,
                    FileSizePipe
                ],
                providers: [
                    FormDataService,
                    UserselectionService,
                    ModulesService,
                    RendererService,
                    DecimalPipe,
                    primeng_providers
                ],
                schemas: [
                    CUSTOM_ELEMENTS_SCHEMA
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LightformsComponentsModule, { declarations: [HtmlRendererComponent,
        ObjectListComponent,
        AnchorComponent,
        BibliographyComponent,
        CalendarComponent,
        CardComponent,
        CardsComponent,
        CartComponent,
        CartHandlerComponent,
        CartButtonsComponent,
        ChartComponent,
        CitationComponent,
        CollectionNavigatorComponent,
        DataListComponent,
        DatatypeSearchComponent,
        DocumentsComponent,
        DocumentsListComponent,
        FactsheetIntroComponent,
        FiFilterTermsComponent,
        FiListComponent,
        FiSearchPillsComponent,
        FlagComponent,
        GroupedResultComponent,
        ImageComponent,
        ImageModalComponent,
        ImageButtonComponent,
        ImageGalleryComponent,
        ImageGalleryModalComponent,
        ImageViewerComponent,
        ImageViewerModalComponent,
        MapComponent,
        MapTipsComponent,
        LayersListComponent,
        LegendsListComponent,
        ProjectionsListComponent,
        ModalComponent,
        PaginationComponent,
        ReferenceComponent,
        RelatedLinksComponent,
        StandardResultComponent,
        SourcesComponent,
        TableComponent,
        TabsComponent,
        TocComponent,
        VideoPlayerComponent,
        StatusNoteComponent,
        ButtonComponent,
        FormErrorsManagerComponent,
        FormulaEditorComponent,
        GlobalParametersComponent,
        LoadingComponent,
        NotFoundComponent,
        UserRegisterComponent,
        SearchListComponent,
        HtmlEditorComponent,
        ErrorLogComponent,
        ErrorLogIconComponent,
        DebugInfoComponent,
        SliderComponent,
        HierarchyComponent,
        LevelComponent,
        QrcodeComponent,
        FiFilterComponent,
        GeosearchComponent,
        LoginButtonComponent,
        RegisterButtonComponent,
        LogoutButtonComponent,
        JsonViewerComponent,
        DynamicDialogComponent,
        GeometryEditorComponent,
        CollectionListComponent,
        CollectionItemComponent,
        TemplateRendererComponent,
        ButtonsBarComponent,
        DocComponent, DebugDetailsComponent,
        DynamicFormPage,
        DynamicFormArrayView,
        DynamicFormCheckboxlistView,
        DynamicFormControlView,
        DynamicFormGroupView,
        DynamicFormGroupLatLongView,
        DynamicFormGroupselectView,
        DynamicFormNestedFormView,
        DynamicFormSwitcherView,
        DynamicFormKeyselectView,
        DynamicFormGeometryComponent,
        DynamicFormGeometryItemComponent,
        HelpComponent,
        ShareModalComponent, KeysPipe,
        OrderByPipe,
        SafePipe,
        FileSizePipe,
        TruncatePipe,
        ListDirective,
        DetailDirective,
        ResultsDirective,
        FullscreenDirective,
        DynamicHostDirective], imports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        YouTubePlayerModule,
        NgxJsonViewerModule,
        ClipboardModule,
        LightformsServicesModule, AccordionModule,
        TimelineModule,
        ConfirmDialogModule,
        MenuModule,
        DynamicDialogModule,
        TableModule,
        ButtonModule,
        DialogModule,
        ToastModule,
        SelectModule,
        TabsModule,
        FileUploadModule,
        MultiSelectModule,
        RadioButtonModule,
        TextareaModule,
        InputTextModule,
        InputNumberModule,
        CheckboxModule,
        ListboxModule,
        FieldsetModule,
        PanelModule,
        TreeModule,
        ContextMenuModule,
        ConfirmPopupModule,
        ChipModule,
        AutoCompleteModule,
        ToggleButtonModule,
        BadgeModule,
        InputGroupModule,
        InputGroupAddonModule,
        SliderModule,
        TooltipModule,
        TagModule,
        SidebarModule,
        DividerModule,
        ProgressBarModule,
        ScrollPanelModule, i3$4.MonacoEditorModule, i4$3.MarkdownModule], exports: [CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ListDirective,
        DetailDirective,
        ResultsDirective,
        FullscreenDirective,
        DynamicHostDirective, HtmlRendererComponent,
        ObjectListComponent,
        AnchorComponent,
        BibliographyComponent,
        CalendarComponent,
        CardComponent,
        CardsComponent,
        CartComponent,
        CartHandlerComponent,
        CartButtonsComponent,
        ChartComponent,
        CitationComponent,
        CollectionNavigatorComponent,
        DataListComponent,
        DatatypeSearchComponent,
        DocumentsComponent,
        DocumentsListComponent,
        FactsheetIntroComponent,
        FiFilterTermsComponent,
        FiListComponent,
        FiSearchPillsComponent,
        FlagComponent,
        GroupedResultComponent,
        ImageComponent,
        ImageModalComponent,
        ImageButtonComponent,
        ImageGalleryComponent,
        ImageGalleryModalComponent,
        ImageViewerComponent,
        ImageViewerModalComponent,
        MapComponent,
        MapTipsComponent,
        LayersListComponent,
        LegendsListComponent,
        ProjectionsListComponent,
        ModalComponent,
        PaginationComponent,
        ReferenceComponent,
        RelatedLinksComponent,
        StandardResultComponent,
        SourcesComponent,
        TableComponent,
        TabsComponent,
        TocComponent,
        VideoPlayerComponent,
        StatusNoteComponent,
        ButtonComponent,
        FormErrorsManagerComponent,
        FormulaEditorComponent,
        GlobalParametersComponent,
        LoadingComponent,
        NotFoundComponent,
        UserRegisterComponent,
        SearchListComponent,
        HtmlEditorComponent,
        ErrorLogComponent,
        ErrorLogIconComponent,
        DebugInfoComponent,
        SliderComponent,
        HierarchyComponent,
        LevelComponent,
        QrcodeComponent,
        FiFilterComponent,
        GeosearchComponent,
        LoginButtonComponent,
        RegisterButtonComponent,
        LogoutButtonComponent,
        JsonViewerComponent,
        DynamicDialogComponent,
        GeometryEditorComponent,
        CollectionListComponent,
        CollectionItemComponent,
        TemplateRendererComponent,
        ButtonsBarComponent,
        DocComponent, DebugDetailsComponent,
        DynamicFormPage,
        DynamicFormArrayView,
        DynamicFormCheckboxlistView,
        DynamicFormControlView,
        DynamicFormGroupView,
        DynamicFormGroupLatLongView,
        DynamicFormGroupselectView,
        DynamicFormNestedFormView,
        DynamicFormSwitcherView,
        DynamicFormKeyselectView,
        DynamicFormGeometryComponent,
        DynamicFormGeometryItemComponent,
        HelpComponent,
        ShareModalComponent, AccordionModule,
        TimelineModule,
        ConfirmDialogModule,
        MenuModule,
        DynamicDialogModule,
        TableModule,
        ButtonModule,
        DialogModule,
        ToastModule,
        SelectModule,
        TabsModule,
        FileUploadModule,
        MultiSelectModule,
        RadioButtonModule,
        TextareaModule,
        InputTextModule,
        InputNumberModule,
        CheckboxModule,
        ListboxModule,
        FieldsetModule,
        PanelModule,
        TreeModule,
        ContextMenuModule,
        ConfirmPopupModule,
        ChipModule,
        AutoCompleteModule,
        ToggleButtonModule,
        BadgeModule,
        InputGroupModule,
        InputGroupAddonModule,
        SliderModule,
        TooltipModule,
        TagModule,
        SidebarModule,
        DividerModule,
        ProgressBarModule,
        ScrollPanelModule, FileSizePipe] }); })();
i0.ɵɵsetComponentScope(CardComponent, function () { return [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgStyle, i2.RouterLink, VideoPlayerComponent,
    TemplateRendererComponent]; }, function () { return [i3.DatePipe, TruncatePipe]; });
i0.ɵɵsetComponentScope(FactsheetIntroComponent, function () { return [i3.NgIf, HtmlRendererComponent]; }, []);
i0.ɵɵsetComponentScope(FiListComponent, function () { return [i3.NgClass, i3.NgIf, i5.NgControlStatus, i5.NgModel, i6.Select, GroupedResultComponent,
    PaginationComponent,
    StandardResultComponent,
    TemplateRendererComponent]; }, []);
i0.ɵɵsetComponentScope(TocComponent, function () { return [i3.NgIf, HtmlRendererComponent]; }, []);
i0.ɵɵsetComponentScope(SearchListComponent, function () { return [i3.NgClass, i3.NgIf, FiFilterTermsComponent,
    FiListComponent,
    FiSearchPillsComponent,
    FiFilterComponent,
    TemplateRendererComponent]; }, []);
i0.ɵɵsetComponentScope(DynamicDialogComponent, function () { return [i3.NgIf, HtmlRendererComponent]; }, []);
i0.ɵɵsetComponentScope(CollectionListComponent, function () { return [i3.NgClass, i3.NgIf, i2.RouterLink, i7.Button, FiFilterTermsComponent,
    FiListComponent,
    FiSearchPillsComponent,
    FiFilterComponent,
    LogoutButtonComponent,
    TemplateRendererComponent]; }, []);
i0.ɵɵsetComponentScope(CollectionItemComponent, function () { return [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i5$1.ConfirmDialog, i7.Button, i7$1.Toast, i10.Divider, NotFoundComponent,
    ErrorLogIconComponent,
    TemplateRendererComponent,
    ButtonsBarComponent, DynamicFormPage]; }, []);
i0.ɵɵsetComponentScope(DynamicFormArrayView, function () { return [i3.NgClass, i3.NgForOf, i3.NgIf, i5.NgControlStatusGroup, i5.FormGroupDirective, i3$2.PrimeTemplate, i7.Button, i12.Fieldset, i13.Panel, HtmlRendererComponent,
    FormErrorsManagerComponent, DebugDetailsComponent,
    DynamicFormSwitcherView]; }, []);
i0.ɵɵsetComponentScope(DynamicFormCheckboxlistView, function () { return [i3.NgClass, i3.NgForOf, i3.NgIf, i5.NgControlStatusGroup, i5.FormGroupDirective, HtmlRendererComponent, DebugDetailsComponent]; }, []);
i0.ɵɵsetComponentScope(DynamicFormControlView, function () { return [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i5.DefaultValueAccessor, i5.NumberValueAccessor, i5.CheckboxControlValueAccessor, i5.NgControlStatus, i5.NgControlStatusGroup, i5.FormControlDirective, i5.FormGroupDirective, i5.FormControlName, i5.FormArrayName, i3$2.PrimeTemplate, i7.Button, i6.Select, i14.Tabs, i14.TabPanels, i14.TabPanel, i14.TabList, i14.Tab, i7$3.MultiSelect, i12.Fieldset, i16.ToggleButton, HtmlRendererComponent,
    FormErrorsManagerComponent,
    HtmlEditorComponent,
    TemplateRendererComponent, DebugDetailsComponent]; }, []);
i0.ɵɵsetComponentScope(DynamicFormGroupView, function () { return [i3.NgClass, i3.NgForOf, i3.NgIf, i5.NgControlStatusGroup, i5.FormGroupDirective, i3$2.PrimeTemplate, i7.Button, i12.Fieldset, i13.Panel, HtmlRendererComponent,
    FormErrorsManagerComponent, DebugDetailsComponent,
    DynamicFormSwitcherView]; }, []);
i0.ɵɵsetComponentScope(DynamicFormGroupLatLongView, function () { return [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgSwitch, i3.NgSwitchCase, i5.DefaultValueAccessor, i5.NumberValueAccessor, i5.CheckboxControlValueAccessor, i5.NgControlStatus, i5.FormControlDirective, HtmlRendererComponent, DebugDetailsComponent]; }, []);
i0.ɵɵsetComponentScope(DynamicFormGroupselectView, function () { return [i3.NgClass, i3.NgForOf, i3.NgIf, i5.NgControlStatusGroup, i5.FormGroupDirective, i7.Button, HtmlRendererComponent, DebugDetailsComponent,
    DynamicFormSwitcherView]; }, []);
i0.ɵɵsetComponentScope(DynamicFormNestedFormView, function () { return [i3.NgClass, i3.NgForOf, i3.NgIf, i5.NgControlStatusGroup, i5.FormGroupDirective, i3$2.PrimeTemplate, i7.Button, i12.Fieldset, i13.Panel, HtmlRendererComponent,
    FormErrorsManagerComponent, DebugDetailsComponent,
    DynamicFormPage]; }, []);
i0.ɵɵsetComponentScope(DynamicFormSwitcherView, function () { return [i3.NgClass, i3.NgIf, i5.NgControlStatusGroup, i5.FormGroupDirective, DynamicFormArrayView,
    DynamicFormCheckboxlistView,
    DynamicFormControlView,
    DynamicFormGroupView,
    DynamicFormGroupLatLongView,
    DynamicFormGroupselectView,
    DynamicFormNestedFormView,
    DynamicFormKeyselectView,
    DynamicFormGeometryComponent]; }, []);
i0.ɵɵsetComponentScope(DynamicFormKeyselectView, function () { return [i3.NgClass, i3.NgForOf, i3.NgIf, i5.NgControlStatusGroup, i5.FormGroupDirective, i3$2.PrimeTemplate, i7.Button, i12.Fieldset, i13.Panel, HtmlRendererComponent,
    FormErrorsManagerComponent, DebugDetailsComponent,
    DynamicFormSwitcherView]; }, []);
i0.ɵɵsetComponentScope(DynamicFormGeometryComponent, function () { return [i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i5.NgControlStatusGroup, i5.FormGroupDirective, i5.FormArrayName, i3$2.PrimeTemplate, i7.Button, i12.Fieldset, HtmlRendererComponent,
    MapComponent,
    FormErrorsManagerComponent, DebugDetailsComponent,
    DynamicFormGeometryItemComponent]; }, []);
i0.ɵɵsetComponentScope(HelpComponent, function () { return [TemplateRendererComponent]; }, []);

/**
 * Generated bundle index. Do not edit.
 */

export { AnchorComponent, BibliographyComponent, ButtonComponent, ButtonsBarComponent, CalendarComponent, CardComponent, CardsComponent, CartButtonsComponent, CartComponent, CartHandlerComponent, ChartComponent, CitationComponent, CollectionItemComponent, CollectionListComponent, CollectionNavigatorComponent, DataListComponent, DatatypeSearchComponent, DebugDetailsComponent, DebugInfoComponent, DetailDirective, DocComponent, DocumentsComponent, DocumentsListComponent, DynamicDialogComponent, DynamicFormArrayView, DynamicFormCheckboxlistView, DynamicFormControlView, DynamicFormGeometryComponent, DynamicFormGeometryItemComponent, DynamicFormGroupLatLongView, DynamicFormGroupView, DynamicFormGroupselectView, DynamicFormKeyselectView, DynamicFormNestedFormView, DynamicFormPage, DynamicFormSwitcherView, DynamicHostDirective, ErrorLogComponent, ErrorLogIconComponent, FactsheetIntroComponent, FiFilterComponent, FiFilterTermsComponent, FiListComponent, FiSearchPillsComponent, FileSizePipe, FlagComponent, FormDataService, FormErrorsManagerComponent, FormulaEditorComponent, FullscreenDirective, GeometryEditorComponent, GeosearchComponent, GlobalParametersComponent, GroupedResultComponent, HelpComponent, HierarchyComponent, HtmlEditorComponent, HtmlRendererComponent, ImageButtonComponent, ImageComponent, ImageGalleryComponent, ImageGalleryModalComponent, ImageModalComponent, ImageViewerComponent, ImageViewerModalComponent, JsonViewerComponent, KeysPipe, LayersListComponent, LayersListControl, LegendsListComponent, LevelComponent, LightformsComponentsModule, ListDirective, LoadingComponent, LoginButtonComponent, LogoutButtonComponent, MapComponent, MapTipsComponent, ModalComponent, ModalService, ModulesService, NotFoundComponent, ObjectListComponent, OrderByPipe, PaginationComponent, ProjectionsListComponent, QrcodeComponent, ReferenceComponent, RegisterButtonComponent, RelatedLinksComponent, RendererService, ResultsDirective, SafePipe, SearchListComponent, ShareModalComponent, SliderComponent, SourcesComponent, StandardResultComponent, StatusNoteComponent, TableComponent, TabsComponent, TemplateRendererComponent, TocComponent, TruncatePipe, UserRegisterComponent, UserselectionService, VideoPlayerComponent };
